(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bvJM2", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("8UnLC", function(module, exports) {
/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://iframe-resizer.com
 * Author: David J. Bradshaw - info@iframe-resizer.com
 *
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var autoResize = true, base = 10, bodyBackground = '', bodyMargin = 0, bodyMarginStr = '', bodyObserver = null, bodyPadding = '', calculateWidth = false, doubleEventList = {
        resize: 1,
        click: 1
    }, eventCancelTimer = 128, firstRun = true, height = 1, heightCalcModeDefault = 'bodyOffset', heightCalcMode = heightCalcModeDefault, initLock = true, initMsg = '', inPageLinks = {}, interval = 32, intervalTimer = null, logging = false, mouseEvents = false, msgID = '[iFrameSizer]', msgIdLen = msgID.length, myID = '', resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, resizeFrom = 'child', sendPermit = true, target = window.parent, targetOriginDefault = '*', tolerance = 0, triggerLocked = false, triggerLockedTimer = null, throttledTimer = 16, width = 1, widthCalcModeDefault = 'scroll', widthCalcMode = widthCalcModeDefault, win = window, onMessage = function() {
        warn('onMessage function not defined');
    }, onReady = function() {}, onPageInfo = function() {}, customCalcMethods = {
        height: function() {
            warn('Custom height calculation function not defined');
            return document.documentElement.offsetHeight;
        },
        width: function() {
            warn('Custom width calculation function not defined');
            return document.body.scrollWidth;
        }
    }, eventHandlersByName = {}, passiveSupported = false;
    function noop() {}
    try {
        var options = Object.create({}, {
            passive: {
                // eslint-disable-next-line getter-return
                get: function() {
                    passiveSupported = true;
                }
            }
        });
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop, options);
    } catch (error) {
    /* */ }
    function addEventListener(el, evt, func, options) {
        el.addEventListener(evt, func, passiveSupported ? options || {} : false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    // Based on underscore.js
    function throttle(func) {
        var context, args, result, timeout = null, previous = 0, later = function() {
            previous = Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) // eslint-disable-next-line no-multi-assign
            context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous) previous = now;
            var remaining = throttledTimer - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > throttledTimer) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) // eslint-disable-next-line no-multi-assign
                context = args = null;
            } else if (!timeout) timeout = setTimeout(later, remaining);
            return result;
        };
    }
    function formatLogMsg(msg) {
        return msgID + '[' + myID + '] ' + msg;
    }
    function log(msg) {
        if (logging && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console.log(formatLogMsg(msg));
    }
    function warn(msg) {
        if ('object' === typeof window.console) // eslint-disable-next-line no-console
        console.warn(formatLogMsg(msg));
    }
    function init() {
        readDataFromParent();
        log('Initialising iFrame (' + window.location.href + ')');
        readDataFromPage();
        setMargin();
        setBodyStyle('background', bodyBackground);
        setBodyStyle('padding', bodyPadding);
        injectClearFixIntoBodyElement();
        checkHeightMode();
        checkWidthMode();
        stopInfiniteResizingOfIFrame();
        setupPublicMethods();
        setupMouseEvents();
        startEventListeners();
        inPageLinks = setupInPageLinks();
        sendSize('init', 'Init message from host page');
        onReady();
    }
    function readDataFromParent() {
        function strBool(str) {
            return 'true' === str;
        }
        var data = initMsg.slice(msgIdLen).split(':');
        myID = data[0];
        bodyMargin = undefined === data[1] ? bodyMargin : Number(data[1]) // For V1 compatibility
        ;
        calculateWidth = undefined === data[2] ? calculateWidth : strBool(data[2]);
        logging = undefined === data[3] ? logging : strBool(data[3]);
        interval = undefined === data[4] ? interval : Number(data[4]);
        autoResize = undefined === data[6] ? autoResize : strBool(data[6]);
        bodyMarginStr = data[7];
        heightCalcMode = undefined === data[8] ? heightCalcMode : data[8];
        bodyBackground = data[9];
        bodyPadding = data[10];
        tolerance = undefined === data[11] ? tolerance : Number(data[11]);
        inPageLinks.enable = undefined === data[12] ? false : strBool(data[12]);
        resizeFrom = undefined === data[13] ? resizeFrom : data[13];
        widthCalcMode = undefined === data[14] ? widthCalcMode : data[14];
        mouseEvents = undefined === data[15] ? mouseEvents : strBool(data[15]);
    }
    function depricate(key) {
        var splitName = key.split('Callback');
        if (splitName.length === 2) {
            var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
            this[name] = this[key];
            delete this[key];
            warn("Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
        }
    }
    function readDataFromPage() {
        function readData() {
            var data = window.iFrameResizer;
            log('Reading data from page: ' + JSON.stringify(data));
            Object.keys(data).forEach(depricate, data);
            onMessage = 'onMessage' in data ? data.onMessage : onMessage;
            onReady = 'onReady' in data ? data.onReady : onReady;
            targetOriginDefault = 'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
            heightCalcMode = 'heightCalculationMethod' in data ? data.heightCalculationMethod : heightCalcMode;
            widthCalcMode = 'widthCalculationMethod' in data ? data.widthCalculationMethod : widthCalcMode;
        }
        function setupCustomCalcMethods(calcMode, calcFunc) {
            if ('function' === typeof calcMode) {
                log('Setup custom ' + calcFunc + 'CalcMethod');
                customCalcMethods[calcFunc] = calcMode;
                calcMode = 'custom';
            }
            return calcMode;
        }
        if ('iFrameResizer' in window && Object === window.iFrameResizer.constructor) {
            readData();
            heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
            widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
        }
        log('TargetOrigin for parent set to: ' + targetOriginDefault);
    }
    function chkCSS(attr, value) {
        if (-1 !== value.indexOf('-')) {
            warn('Negative CSS value ignored for ' + attr);
            value = '';
        }
        return value;
    }
    function setBodyStyle(attr, value) {
        if (undefined !== value && '' !== value && 'null' !== value) {
            document.body.style[attr] = value;
            log('Body ' + attr + ' set to "' + value + '"');
        }
    }
    function setMargin() {
        // If called via V1 script, convert bodyMargin from int to str
        if (undefined === bodyMarginStr) bodyMarginStr = bodyMargin + 'px';
        setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
    }
    function stopInfiniteResizingOfIFrame() {
        document.documentElement.style.height = '';
        document.body.style.height = '';
        log('HTML & body height set to "auto"');
    }
    function manageTriggerEvent(options) {
        var listener = {
            add: function(eventName) {
                function handleEvent() {
                    sendSize(options.eventName, options.eventType);
                }
                eventHandlersByName[eventName] = handleEvent;
                addEventListener(window, eventName, handleEvent, {
                    passive: true
                });
            },
            remove: function(eventName) {
                var handleEvent = eventHandlersByName[eventName];
                delete eventHandlersByName[eventName];
                removeEventListener(window, eventName, handleEvent);
            }
        };
        if (options.eventNames && Array.prototype.map) {
            options.eventName = options.eventNames[0];
            options.eventNames.map(listener[options.method]);
        } else listener[options.method](options.eventName);
        log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
    }
    function manageEventListeners(method) {
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Start',
            eventNames: [
                'animationstart',
                'webkitAnimationStart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Iteration',
            eventNames: [
                'animationiteration',
                'webkitAnimationIteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation End',
            eventNames: [
                'animationend',
                'webkitAnimationEnd'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Input',
            eventName: 'input'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Up',
            eventName: 'mouseup'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Down',
            eventName: 'mousedown'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Orientation Change',
            eventName: 'orientationchange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Print',
            eventNames: [
                'afterprint',
                'beforeprint'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Ready State Change',
            eventName: 'readystatechange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Start',
            eventName: 'touchstart'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch End',
            eventName: 'touchend'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Cancel',
            eventName: 'touchcancel'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Start',
            eventNames: [
                'transitionstart',
                'webkitTransitionStart',
                'MSTransitionStart',
                'oTransitionStart',
                'otransitionstart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Iteration',
            eventNames: [
                'transitioniteration',
                'webkitTransitionIteration',
                'MSTransitionIteration',
                'oTransitionIteration',
                'otransitioniteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition End',
            eventNames: [
                'transitionend',
                'webkitTransitionEnd',
                'MSTransitionEnd',
                'oTransitionEnd',
                'otransitionend'
            ]
        });
        if ('child' === resizeFrom) manageTriggerEvent({
            method: method,
            eventType: 'IFrame Resized',
            eventName: 'resize'
        });
    }
    function checkCalcMode(calcMode, calcModeDefault, modes, type) {
        if (calcModeDefault !== calcMode) {
            if (!(calcMode in modes)) {
                warn(calcMode + ' is not a valid option for ' + type + 'CalculationMethod.');
                calcMode = calcModeDefault;
            }
            log(type + ' calculation method set to "' + calcMode + '"');
        }
        return calcMode;
    }
    function checkHeightMode() {
        heightCalcMode = checkCalcMode(heightCalcMode, heightCalcModeDefault, getHeight, 'height');
    }
    function checkWidthMode() {
        widthCalcMode = checkCalcMode(widthCalcMode, widthCalcModeDefault, getWidth, 'width');
    }
    function startEventListeners() {
        if (true === autoResize) {
            manageEventListeners('add');
            setupMutationObserver();
        } else log('Auto Resize disabled');
    }
    //   function stopMsgsToParent() {
    //     log('Disable outgoing messages')
    //     sendPermit = false
    //   }
    //   function removeMsgListener() {
    //     log('Remove event listener: Message')
    //     removeEventListener(window, 'message', receiver)
    //   }
    function disconnectMutationObserver() {
        if (null !== bodyObserver) /* istanbul ignore next */ // Not testable in PhantonJS
        bodyObserver.disconnect();
    }
    function stopEventListeners() {
        manageEventListeners('remove');
        disconnectMutationObserver();
        clearInterval(intervalTimer);
    }
    //   function teardown() {
    //     stopMsgsToParent()
    //     removeMsgListener()
    //     if (true === autoResize) stopEventListeners()
    //   }
    function injectClearFixIntoBodyElement() {
        var clearFix = document.createElement('div');
        clearFix.style.clear = 'both';
        // Guard against the following having been globally redefined in CSS.
        clearFix.style.display = 'block';
        clearFix.style.height = '0';
        document.body.appendChild(clearFix);
    }
    function setupInPageLinks() {
        function getPagePosition() {
            return {
                x: window.pageXOffset === undefined ? document.documentElement.scrollLeft : window.pageXOffset,
                y: window.pageYOffset === undefined ? document.documentElement.scrollTop : window.pageYOffset
            };
        }
        function getElementPosition(el) {
            var elPosition = el.getBoundingClientRect(), pagePosition = getPagePosition();
            return {
                x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
                y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
            };
        }
        function findTarget(location) {
            function jumpToTarget(target) {
                var jumpPosition = getElementPosition(target);
                log('Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
                ;
            }
            var hash = location.split('#')[1] || location, hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (undefined === target) {
                log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
                sendMsg(0, 0, 'inPageLink', '#' + hash);
            } else jumpToTarget(target);
        }
        function checkLocationHash() {
            var hash = window.location.hash;
            var href = window.location.href;
            if ('' !== hash && '#' !== hash) findTarget(href);
        }
        function bindAnchors() {
            function setupLink(el) {
                function linkClicked(e) {
                    e.preventDefault();
                    /* jshint validthis:true */ findTarget(this.getAttribute('href'));
                }
                if ('#' !== el.getAttribute('href')) addEventListener(el, 'click', linkClicked);
            }
            Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), setupLink);
        }
        function bindLocationHash() {
            addEventListener(window, 'hashchange', checkLocationHash);
        }
        function initCheck() {
            // Check if page loaded with location hash after init resize
            setTimeout(checkLocationHash, eventCancelTimer);
        }
        function enableInPageLinks() {
            /* istanbul ignore else */ // Not testable in phantonJS
            if (Array.prototype.forEach && document.querySelectorAll) {
                log('Setting up location.hash handlers');
                bindAnchors();
                bindLocationHash();
                initCheck();
            } else warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
        }
        if (inPageLinks.enable) enableInPageLinks();
        else log('In page linking not enabled');
        return {
            findTarget: findTarget
        };
    }
    function setupMouseEvents() {
        if (mouseEvents !== true) return;
        function sendMouse(e) {
            sendMsg(0, 0, e.type, e.screenY + ':' + e.screenX);
        }
        function addMouseListener(evt, name) {
            log('Add event listener: ' + name);
            addEventListener(window.document, evt, sendMouse);
        }
        addMouseListener('mouseenter', 'Mouse Enter');
        addMouseListener('mouseleave', 'Mouse Leave');
    }
    function setupPublicMethods() {
        log('Enable public methods');
        win.parentIFrame = {
            autoResize: function autoResizeF(resize) {
                if (true === resize && false === autoResize) {
                    autoResize = true;
                    startEventListeners();
                } else if (false === resize && true === autoResize) {
                    autoResize = false;
                    stopEventListeners();
                }
                sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize));
                return autoResize;
            },
            close: function closeF() {
                sendMsg(0, 0, 'close');
            // teardown()
            },
            getId: function getIdF() {
                return myID;
            },
            getPageInfo: function getPageInfoF(callback) {
                if ('function' === typeof callback) {
                    onPageInfo = callback;
                    sendMsg(0, 0, 'pageInfo');
                } else {
                    onPageInfo = function() {};
                    sendMsg(0, 0, 'pageInfoStop');
                }
            },
            moveToAnchor: function moveToAnchorF(hash) {
                inPageLinks.findTarget(hash);
            },
            reset: function resetF() {
                resetIFrame('parentIFrame.reset');
            },
            scrollTo: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollTo') // X&Y reversed at sendMsg uses height/width
                ;
            },
            scrollToOffset: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollToOffset') // X&Y reversed at sendMsg uses height/width
                ;
            },
            sendMessage: function sendMessageF(msg, targetOrigin) {
                sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
            },
            setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
                heightCalcMode = heightCalculationMethod;
                checkHeightMode();
            },
            setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
                widthCalcMode = widthCalculationMethod;
                checkWidthMode();
            },
            setTargetOrigin: function setTargetOriginF(targetOrigin) {
                log('Set targetOrigin: ' + targetOrigin);
                targetOriginDefault = targetOrigin;
            },
            size: function sizeF(customHeight, customWidth) {
                var valString = '' + (customHeight || '') + (customWidth ? ',' + customWidth : '');
                sendSize('size', 'parentIFrame.size(' + valString + ')', customHeight, customWidth);
            }
        };
    }
    function initInterval() {
        if (0 !== interval) {
            log('setInterval: ' + interval + 'ms');
            intervalTimer = setInterval(function() {
                sendSize('interval', 'setInterval: ' + interval);
            }, Math.abs(interval));
        }
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function setupBodyMutationObserver() {
        function addImageLoadListners(mutation) {
            function addImageLoadListener(element) {
                if (false === element.complete) {
                    log('Attach listeners to ' + element.src);
                    element.addEventListener('load', imageLoaded, false);
                    element.addEventListener('error', imageError, false);
                    elements.push(element);
                }
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') addImageLoadListener(mutation.target);
            else if (mutation.type === 'childList') Array.prototype.forEach.call(mutation.target.querySelectorAll('img'), addImageLoadListener);
        }
        function removeFromArray(element) {
            elements.splice(elements.indexOf(element), 1);
        }
        function removeImageLoadListener(element) {
            log('Remove listeners from ' + element.src);
            element.removeEventListener('load', imageLoaded, false);
            element.removeEventListener('error', imageError, false);
            removeFromArray(element);
        }
        function imageEventTriggered(event, type, typeDesc) {
            removeImageLoadListener(event.target);
            sendSize(type, typeDesc + ': ' + event.target.src);
        }
        function imageLoaded(event) {
            imageEventTriggered(event, 'imageLoad', 'Image loaded');
        }
        function imageError(event) {
            imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
        }
        function mutationObserved(mutations) {
            sendSize('mutationObserver', 'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
            // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
            mutations.forEach(addImageLoadListners);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            };
            observer = new MutationObserver(mutationObserved);
            log('Create body MutationObserver');
            observer.observe(target, config);
            return observer;
        }
        var elements = [], MutationObserver = window.MutationObserver || window.WebKitMutationObserver, observer = createMutationObserver();
        return {
            disconnect: function() {
                if ('disconnect' in observer) {
                    log('Disconnect body MutationObserver');
                    observer.disconnect();
                    elements.forEach(removeImageLoadListener);
                }
            }
        };
    }
    function setupMutationObserver() {
        var forceIntervalTimer = 0 > interval;
        // Not testable in PhantomJS
        /* istanbul ignore if */ if (window.MutationObserver || window.WebKitMutationObserver) {
            if (forceIntervalTimer) initInterval();
            else bodyObserver = setupBodyMutationObserver();
        } else {
            log('MutationObserver not supported in this browser!');
            initInterval();
        }
    }
    // document.documentElement.offsetHeight is not reliable, so
    // we have to jump through hoops to get a better value.
    function getComputedStyle(prop, el) {
        var retVal = 0;
        el = el || document.body // Not testable in phantonJS
        ;
        retVal = document.defaultView.getComputedStyle(el, null);
        retVal = null === retVal ? 0 : retVal[prop];
        return parseInt(retVal, base);
    }
    function chkEventThottle(timer) {
        if (timer > throttledTimer / 2) {
            throttledTimer = 2 * timer;
            log('Event throttle increased to ' + throttledTimer + 'ms');
        }
    }
    // Idea from https://github.com/guardian/iframe-messenger
    function getMaxElement(side, elements) {
        var elementsLength = elements.length, elVal = 0, maxVal = 0, Side = capitalizeFirstLetter(side), timer = Date.now();
        for(var i = 0; i < elementsLength; i++){
            elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin' + Side, elements[i]);
            if (elVal > maxVal) maxVal = elVal;
        }
        timer = Date.now() - timer;
        log('Parsed ' + elementsLength + ' HTML elements');
        log('Element position calculated in ' + timer + 'ms');
        chkEventThottle(timer);
        return maxVal;
    }
    function getAllMeasurements(dimensions) {
        return [
            dimensions.bodyOffset(),
            dimensions.bodyScroll(),
            dimensions.documentElementOffset(),
            dimensions.documentElementScroll()
        ];
    }
    function getTaggedElements(side, tag) {
        function noTaggedElementsFound() {
            warn('No tagged elements (' + tag + ') found on page');
            return document.querySelectorAll('body *');
        }
        var elements = document.querySelectorAll('[' + tag + ']');
        if (elements.length === 0) noTaggedElementsFound();
        return getMaxElement(side, elements);
    }
    function getAllElements() {
        return document.querySelectorAll('body *');
    }
    var getHeight = {
        bodyOffset: function getBodyOffsetHeight() {
            return document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
        },
        offset: function() {
            return getHeight.bodyOffset() // Backwards compatibility
            ;
        },
        bodyScroll: function getBodyScrollHeight() {
            return document.body.scrollHeight;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.height();
        },
        documentElementOffset: function getDEOffsetHeight() {
            return document.documentElement.offsetHeight;
        },
        documentElementScroll: function getDEScrollHeight() {
            return document.documentElement.scrollHeight;
        },
        max: function getMaxHeight() {
            return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function getMinHeight() {
            return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function growHeight() {
            return getHeight.max() // Run max without the forced downsizing
            ;
        },
        lowestElement: function getBestHeight() {
            return Math.max(getHeight.bodyOffset() || getHeight.documentElementOffset(), getMaxElement('bottom', getAllElements()));
        },
        taggedElement: function getTaggedElementsHeight() {
            return getTaggedElements('bottom', 'data-iframe-height');
        }
    }, getWidth = {
        bodyScroll: function getBodyScrollWidth() {
            return document.body.scrollWidth;
        },
        bodyOffset: function getBodyOffsetWidth() {
            return document.body.offsetWidth;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.width();
        },
        documentElementScroll: function getDEScrollWidth() {
            return document.documentElement.scrollWidth;
        },
        documentElementOffset: function getDEOffsetWidth() {
            return document.documentElement.offsetWidth;
        },
        scroll: function getMaxWidth() {
            return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
        },
        max: function getMaxWidth() {
            return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function getMinWidth() {
            return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function rightMostElement() {
            return getMaxElement('right', getAllElements());
        },
        taggedElement: function getTaggedElementsWidth() {
            return getTaggedElements('right', 'data-iframe-width');
        }
    };
    function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function resizeIFrame() {
            height = currentHeight;
            width = currentWidth;
            sendMsg(height, width, triggerEvent);
        }
        function isSizeChangeDetected() {
            function checkTolarance(a, b) {
                var retVal = Math.abs(a - b) <= tolerance;
                return !retVal;
            }
            currentHeight = undefined === customHeight ? getHeight[heightCalcMode]() : customHeight;
            currentWidth = undefined === customWidth ? getWidth[widthCalcMode]() : customWidth;
            return checkTolarance(height, currentHeight) || calculateWidth && checkTolarance(width, currentWidth);
        }
        function isForceResizableEvent() {
            return !(triggerEvent in {
                init: 1,
                interval: 1,
                size: 1
            });
        }
        function isForceResizableCalcMode() {
            return heightCalcMode in resetRequiredMethods || calculateWidth && widthCalcMode in resetRequiredMethods;
        }
        function logIgnored() {
            log('No change in size detected');
        }
        function checkDownSizing() {
            if (isForceResizableEvent() && isForceResizableCalcMode()) resetIFrame(triggerEventDesc);
            else if (!(triggerEvent in {
                interval: 1
            })) logIgnored();
        }
        var currentHeight, currentWidth;
        if (isSizeChangeDetected() || 'init' === triggerEvent) {
            lockTrigger();
            resizeIFrame();
        } else checkDownSizing();
    }
    var sizeIFrameThrottled = throttle(sizeIFrame);
    function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function recordTrigger() {
            if (!(triggerEvent in {
                reset: 1,
                resetPage: 1,
                init: 1
            })) log('Trigger event: ' + triggerEventDesc);
        }
        function isDoubleFiredEvent() {
            return triggerLocked && triggerEvent in doubleEventList;
        }
        if (isDoubleFiredEvent()) log('Trigger event cancelled: ' + triggerEvent);
        else {
            recordTrigger();
            if (triggerEvent === 'init') sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
            else sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
        }
    }
    function lockTrigger() {
        if (!triggerLocked) {
            triggerLocked = true;
            log('Trigger event lock on');
        }
        clearTimeout(triggerLockedTimer);
        triggerLockedTimer = setTimeout(function() {
            triggerLocked = false;
            log('Trigger event lock off');
            log('--');
        }, eventCancelTimer);
    }
    function triggerReset(triggerEvent) {
        height = getHeight[heightCalcMode]();
        width = getWidth[widthCalcMode]();
        sendMsg(height, width, triggerEvent);
    }
    function resetIFrame(triggerEventDesc) {
        var hcm = heightCalcMode;
        heightCalcMode = heightCalcModeDefault;
        log('Reset trigger event: ' + triggerEventDesc);
        lockTrigger();
        triggerReset('reset');
        heightCalcMode = hcm;
    }
    function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
        function setTargetOrigin() {
            if (undefined === targetOrigin) targetOrigin = targetOriginDefault;
            else log('Message targetOrigin: ' + targetOrigin);
        }
        function sendToParent() {
            var size = height + ':' + width, message = myID + ':' + size + ':' + triggerEvent + (undefined === msg ? '' : ':' + msg);
            log('Sending message to host page (' + message + ')');
            target.postMessage(msgID + message, targetOrigin);
        }
        if (true === sendPermit) {
            setTargetOrigin();
            sendToParent();
        }
    }
    function receiver(event) {
        var processRequestFromParent = {
            init: function initFromParent() {
                initMsg = event.data;
                target = event.source;
                init();
                firstRun = false;
                setTimeout(function() {
                    initLock = false;
                }, eventCancelTimer);
            },
            reset: function resetFromParent() {
                if (initLock) log('Page reset ignored by init');
                else {
                    log('Page size reset by host page');
                    triggerReset('resetPage');
                }
            },
            resize: function resizeFromParent() {
                sendSize('resizeParent', 'Parent window requested size check');
            },
            moveToAnchor: function moveToAnchorF() {
                inPageLinks.findTarget(getData());
            },
            inPageLink: function inPageLinkF() {
                this.moveToAnchor();
            },
            pageInfo: function pageInfoFromParent() {
                var msgBody = getData();
                log('PageInfoFromParent called from parent: ' + msgBody);
                onPageInfo(JSON.parse(msgBody));
                log(' --');
            },
            message: function messageFromParent() {
                var msgBody = getData();
                log('onMessage called from parent: ' + msgBody);
                // eslint-disable-next-line sonarjs/no-extra-arguments
                onMessage(JSON.parse(msgBody));
                log(' --');
            }
        };
        function isMessageForUs() {
            return msgID === ('' + event.data).slice(0, msgIdLen) // ''+ Protects against non-string messages
            ;
        }
        function getMessageType() {
            return event.data.split(']')[1].split(':')[0];
        }
        function getData() {
            return event.data.slice(event.data.indexOf(':') + 1);
        }
        function isMiddleTier() {
            return !(0, module.exports) && 'iFrameResize' in window || window.jQuery !== undefined && 'iFrameResize' in window.jQuery.prototype;
        }
        function isInitMsg() {
            // Test if this message is from a child below us. This is an ugly test, however, updating
            // the message format would break backwards compatibility.
            return event.data.split(':')[2] in {
                true: 1,
                false: 1
            };
        }
        function callFromParent() {
            var messageType = getMessageType();
            if (messageType in processRequestFromParent) processRequestFromParent[messageType]();
            else if (!isMiddleTier() && !isInitMsg()) warn('Unexpected message (' + event.data + ')');
        }
        function processMessage() {
            if (false === firstRun) callFromParent();
            else if (isInitMsg()) processRequestFromParent.init();
            else log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
        }
        if (isMessageForUs()) processMessage();
    }
    // Normally the parent kicks things off when it detects the iFrame has loaded.
    // If this script is async-loaded, then tell parent page to retry init.
    function chkLateLoaded() {
        if ('loading' !== document.readyState) window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
    // Setup if not already running
    if (!('iframeResizer' in window)) {
        window.iframeChildListener = function(data) {
            receiver({
                data: data,
                sameDomian: true
            });
        };
        addEventListener(window, 'message', receiver);
        addEventListener(window, 'readystatechange', chkLateLoaded);
        chkLateLoaded();
    }
})();

});

parcelRegister("kMGLj", function(module, exports) {
/* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v1.13.3/LICENSE.txt */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);';
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== 'undefined') mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        "use strict";
        function e1(t1, e1) {
            return t1(e1 = {
                exports: {}
            }, e1.exports), e1.exports;
        }
        var r = n;
        function n(t1, e1, r, n) {
            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = n, this.p2x = r, this.p2y = n;
        }
        n.prototype.sampleCurveX = function(t1) {
            return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
        }, n.prototype.sampleCurveY = function(t1) {
            return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
        }, n.prototype.sampleCurveDerivativeX = function(t1) {
            return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
        }, n.prototype.solveCurveX = function(t1, e1) {
            var r, n, i, a, o;
            for(void 0 === e1 && (e1 = 1e-6), i = t1, o = 0; o < 8; o++){
                if (a = this.sampleCurveX(i) - t1, Math.abs(a) < e1) return i;
                var s = this.sampleCurveDerivativeX(i);
                if (Math.abs(s) < 1e-6) break;
                i -= a / s;
            }
            if ((i = t1) < (r = 0)) return r;
            if (i > (n = 1)) return n;
            for(; r < n;){
                if (a = this.sampleCurveX(i), Math.abs(a - t1) < e1) return i;
                t1 > a ? r = i : n = i, i = .5 * (n - r) + r;
            }
            return i;
        }, n.prototype.solve = function(t1, e1) {
            return this.sampleCurveY(this.solveCurveX(t1, e1));
        };
        var i = a;
        function a(t1, e1) {
            this.x = t1, this.y = e1;
        }
        a.prototype = {
            clone: function() {
                return new a(this.x, this.y);
            },
            add: function(t1) {
                return this.clone()._add(t1);
            },
            sub: function(t1) {
                return this.clone()._sub(t1);
            },
            multByPoint: function(t1) {
                return this.clone()._multByPoint(t1);
            },
            divByPoint: function(t1) {
                return this.clone()._divByPoint(t1);
            },
            mult: function(t1) {
                return this.clone()._mult(t1);
            },
            div: function(t1) {
                return this.clone()._div(t1);
            },
            rotate: function(t1) {
                return this.clone()._rotate(t1);
            },
            rotateAround: function(t1, e1) {
                return this.clone()._rotateAround(t1, e1);
            },
            matMult: function(t1) {
                return this.clone()._matMult(t1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t1) {
                return this.x === t1.x && this.y === t1.y;
            },
            dist: function(t1) {
                return Math.sqrt(this.distSqr(t1));
            },
            distSqr: function(t1) {
                var e1 = t1.x - this.x, r = t1.y - this.y;
                return e1 * e1 + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t1) {
                return Math.atan2(this.y - t1.y, this.x - t1.x);
            },
            angleWith: function(t1) {
                return this.angleWithSep(t1.x, t1.y);
            },
            angleWithSep: function(t1, e1) {
                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
            },
            _matMult: function(t1) {
                var e1 = t1[2] * this.x + t1[3] * this.y;
                return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e1, this;
            },
            _add: function(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            },
            _sub: function(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            },
            _mult: function(t1) {
                return this.x *= t1, this.y *= t1, this;
            },
            _div: function(t1) {
                return this.x /= t1, this.y /= t1, this;
            },
            _multByPoint: function(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            },
            _divByPoint: function(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t1 = this.y;
                return this.y = this.x, this.x = -t1, this;
            },
            _rotate: function(t1) {
                var e1 = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e1 * this.y;
                return this.x = e1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t1, e1) {
                var r = Math.cos(t1), n = Math.sin(t1), i = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                return this.x = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, a.convert = function(t1) {
            return t1 instanceof a ? t1 : Array.isArray(t1) ? new a(t1[0], t1[1]) : t1;
        };
        var o = "undefined" != typeof self ? self : {}, s = Math.pow(2, 53) - 1;
        function u(t1, e1, n, i) {
            var a = new r(t1, e1, n, i);
            return function(t1) {
                return a.solve(t1);
            };
        }
        var l = u(.25, .1, .25, 1);
        function p(t1, e1, r) {
            return Math.min(r, Math.max(e1, t1));
        }
        function c(t1, e1, r) {
            var n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
            return i === e1 ? r : i;
        }
        function h(t1) {
            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
            for(var n = 0, i = e1; n < i.length; n += 1){
                var a = i[n];
                for(var o in a)t1[o] = a[o];
            }
            return t1;
        }
        var f = 1;
        function y() {
            return f++;
        }
        function d() {
            return function t1(e1) {
                return e1 ? (e1 ^ 16 * Math.random() >> e1 / 4).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
            }();
        }
        function m(t1) {
            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
        }
        function v(t1, e1) {
            t1.forEach(function(t1) {
                e1[t1] && (e1[t1] = e1[t1].bind(e1));
            });
        }
        function g(t1, e1) {
            return -1 !== t1.indexOf(e1, t1.length - e1.length);
        }
        function x(t1, e1, r) {
            var n = {};
            for(var i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
            return n;
        }
        function b(t1, e1, r) {
            var n = {};
            for(var i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
            return n;
        }
        function w(t1) {
            return Array.isArray(t1) ? t1.map(w) : "object" == typeof t1 && t1 ? x(t1, w) : t1;
        }
        var _ = {};
        function A(t1) {
            _[t1] || ("undefined" != typeof console && console.warn(t1), _[t1] = !0);
        }
        function S(t1, e1, r) {
            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
        }
        function k(t1) {
            for(var e1 = 0, r = 0, n = t1.length, i = n - 1, a = void 0, o = void 0; r < n; i = r++)e1 += ((o = t1[i]).x - (a = t1[r]).x) * (a.y + o.y);
            return e1;
        }
        function I() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function z(t1) {
            var e1 = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function(t1, r, n, i) {
                var a = n || i;
                return e1[r] = !a || a.toLowerCase(), "";
            }), e1["max-age"]) {
                var r = parseInt(e1["max-age"], 10);
                isNaN(r) ? delete e1["max-age"] : e1["max-age"] = r;
            }
            return e1;
        }
        var C = null;
        function E(t1) {
            if (null == C) {
                var e1 = t1.navigator ? t1.navigator.userAgent : null;
                C = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
            }
            return C;
        }
        function P(t1) {
            try {
                var e1 = o[t1];
                return e1.setItem("_mapbox_test_", 1), e1.removeItem("_mapbox_test_"), !0;
            } catch (t1) {
                return !1;
            }
        }
        var M, B, T, V, F = o.performance && o.performance.now ? o.performance.now.bind(o.performance) : Date.now.bind(Date), D = o.requestAnimationFrame || o.mozRequestAnimationFrame || o.webkitRequestAnimationFrame || o.msRequestAnimationFrame, L = o.cancelAnimationFrame || o.mozCancelAnimationFrame || o.webkitCancelAnimationFrame || o.msCancelAnimationFrame, O = {
            now: F,
            frame: function(t1) {
                var e1 = D(t1);
                return {
                    cancel: function() {
                        return L(e1);
                    }
                };
            },
            getImageData: function(t1, e1) {
                void 0 === e1 && (e1 = 0);
                var r = o.document.createElement("canvas"), n = r.getContext("2d");
                if (!n) throw new Error("failed to create canvas 2d context");
                return r.width = t1.width, r.height = t1.height, n.drawImage(t1, 0, 0, t1.width, t1.height), n.getImageData(-e1, -e1, t1.width + 2 * e1, t1.height + 2 * e1);
            },
            resolveURL: function(t1) {
                return M || (M = o.document.createElement("a")), M.href = t1, M.href;
            },
            hardwareConcurrency: o.navigator && o.navigator.hardwareConcurrency || 4,
            get devicePixelRatio () {
                return o.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!o.matchMedia && (null == B && (B = o.matchMedia("(prefers-reduced-motion: reduce)")), B.matches);
            }
        }, R = {
            API_URL: "https://api.mapbox.com",
            get EVENTS_URL () {
                return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null;
            },
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            MAX_PARALLEL_IMAGE_REQUESTS: 16
        }, U = {
            supported: !1,
            testSupport: function(t1) {
                !j && V && (q ? N(t1) : T = t1);
            }
        }, j = !1, q = !1;
        function N(t1) {
            var e1 = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e1);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, V), t1.isContextLost()) return;
                U.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e1), j = !0;
        }
        o.document && ((V = o.document.createElement("img")).onload = function() {
            T && N(T), T = null, q = !0;
        }, V.onerror = function() {
            j = !0, T = null;
        }, V.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        var K = "01", G = function(t1, e1) {
            this._transformRequestFn = t1, this._customAccessToken = e1, this._createSkuToken();
        };
        function Z(t1) {
            return 0 === t1.indexOf("mapbox:");
        }
        G.prototype._createSkuToken = function() {
            var t1 = function() {
                for(var t1 = "", e1 = 0; e1 < 10; e1++)t1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                return {
                    token: [
                        "1",
                        K,
                        t1
                    ].join(""),
                    tokenExpiresAt: Date.now() + 432e5
                };
            }();
            this._skuToken = t1.token, this._skuTokenExpiresAt = t1.tokenExpiresAt;
        }, G.prototype._isSkuTokenExpired = function() {
            return Date.now() > this._skuTokenExpiresAt;
        }, G.prototype.transformRequest = function(t1, e1) {
            return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                url: t1
            };
        }, G.prototype.normalizeStyleURL = function(t1, e1) {
            if (!Z(t1)) return t1;
            var r = Y(t1);
            return r.path = "/styles/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
        }, G.prototype.normalizeGlyphsURL = function(t1, e1) {
            if (!Z(t1)) return t1;
            var r = Y(t1);
            return r.path = "/fonts/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
        }, G.prototype.normalizeSourceURL = function(t1, e1) {
            if (!Z(t1)) return t1;
            var r = Y(t1);
            return r.path = "/v4/" + r.authority + ".json", r.params.push("secure"), this._makeAPIURL(r, this._customAccessToken || e1);
        }, G.prototype.normalizeSpriteURL = function(t1, e1, r, n) {
            var i = Y(t1);
            return Z(t1) ? (i.path = "/styles/v1" + i.path + "/sprite" + e1 + r, this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += "" + e1 + r, $(i));
        }, G.prototype.normalizeTileURL = function(t1, e1) {
            if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !Z(t1)) return t1;
            var r = Y(t1);
            r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, (O.devicePixelRatio >= 2 || 512 === e1 ? "@2x" : "") + (U.supported ? ".webp" : "$1")), r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = "/v4" + r.path;
            var n = this._customAccessToken || function(t1) {
                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                    var n = r[e1].match(/^access_token=(.*)$/);
                    if (n) return n[1];
                }
                return null;
            }(r.params) || R.ACCESS_TOKEN;
            return R.REQUIRE_ACCESS_TOKEN && n && this._skuToken && r.params.push("sku=" + this._skuToken), this._makeAPIURL(r, n);
        }, G.prototype.canonicalizeTileURL = function(t1, e1) {
            var r = Y(t1);
            if (!r.path.match(/(^\/v4\/)/) || !r.path.match(/\.[\w]+$/)) return t1;
            var n = "mapbox://tiles/";
            n += r.path.replace("/v4/", "");
            var i = r.params;
            return e1 && (i = i.filter(function(t1) {
                return !t1.match(/^access_token=/);
            })), i.length && (n += "?" + i.join("&")), n;
        }, G.prototype.canonicalizeTileset = function(t1, e1) {
            for(var r = !!e1 && Z(e1), n = [], i = 0, a = t1.tiles || []; i < a.length; i += 1){
                var o = a[i];
                J(o) ? n.push(this.canonicalizeTileURL(o, r)) : n.push(o);
            }
            return n;
        }, G.prototype._makeAPIURL = function(t1, e1) {
            var r = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes", n = Y(R.API_URL);
            if (t1.protocol = n.protocol, t1.authority = n.authority, "http" === t1.protocol) {
                var i = t1.params.indexOf("secure");
                i >= 0 && t1.params.splice(i, 1);
            }
            if ("/" !== n.path && (t1.path = "" + n.path + t1.path), !R.REQUIRE_ACCESS_TOKEN) return $(t1);
            if (!(e1 = e1 || R.ACCESS_TOKEN)) throw new Error("An API access token is required to use Mapbox GL. " + r);
            if ("s" === e1[0]) throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + r);
            return t1.params = t1.params.filter(function(t1) {
                return -1 === t1.indexOf("access_token");
            }), t1.params.push("access_token=" + e1), $(t1);
        };
        var X = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
        function J(t1) {
            return X.test(t1);
        }
        var H = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function Y(t1) {
            var e1 = t1.match(H);
            if (!e1) throw new Error("Unable to parse URL object");
            return {
                protocol: e1[1],
                authority: e1[2],
                path: e1[3] || "/",
                params: e1[4] ? e1[4].split("&") : []
            };
        }
        function $(t1) {
            var e1 = t1.params.length ? "?" + t1.params.join("&") : "";
            return t1.protocol + "://" + t1.authority + t1.path + e1;
        }
        function W(t1) {
            if (!t1) return null;
            var e1 = t1.split(".");
            if (!e1 || 3 !== e1.length) return null;
            try {
                return JSON.parse(decodeURIComponent(o.atob(e1[1]).split("").map(function(t1) {
                    return "%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2);
                }).join("")));
            } catch (t1) {
                return null;
            }
        }
        var Q = function(t1) {
            this.type = t1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
        };
        Q.prototype.getStorageKey = function(t1) {
            var e1, r = W(R.ACCESS_TOKEN);
            return e1 = r && r.u ? o.btoa(encodeURIComponent(r.u).replace(/%([0-9A-F]{2})/g, function(t1, e1) {
                return String.fromCharCode(Number("0x" + e1));
            })) : R.ACCESS_TOKEN || "", t1 ? "mapbox.eventData." + t1 + ":" + e1 : "mapbox.eventData:" + e1;
        }, Q.prototype.fetchEventData = function() {
            var t1 = P("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
            if (t1) try {
                var n = o.localStorage.getItem(e1);
                n && (this.eventData = JSON.parse(n));
                var i = o.localStorage.getItem(r);
                i && (this.anonId = i);
            } catch (t1) {
                A("Unable to read from LocalStorage");
            }
        }, Q.prototype.saveEventData = function() {
            var t1 = P("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
            if (t1) try {
                o.localStorage.setItem(r, this.anonId), Object.keys(this.eventData).length >= 1 && o.localStorage.setItem(e1, JSON.stringify(this.eventData));
            } catch (t1) {
                A("Unable to write to LocalStorage");
            }
        }, Q.prototype.processRequests = function(t1) {}, Q.prototype.postEvent = function(t1, e1, r, n) {
            var i = this;
            if (R.EVENTS_URL) {
                var a = Y(R.EVENTS_URL);
                a.params.push("access_token=" + (n || R.ACCESS_TOKEN || ""));
                var o = {
                    event: this.type,
                    created: new Date(t1).toISOString(),
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: "1.13.3",
                    skuId: K,
                    userId: this.anonId
                }, s = e1 ? h(o, e1) : o, u = {
                    url: $(a),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        s
                    ])
                };
                this.pendingRequest = wt(u, function(t1) {
                    i.pendingRequest = null, r(t1), i.saveEventData(), i.processRequests(n);
                });
            }
        }, Q.prototype.queueRequest = function(t1, e1) {
            this.queue.push(t1), this.processRequests(e1);
        };
        var tt, et, rt = function(t1) {
            function e1() {
                t1.call(this, "map.load"), this.success = {}, this.skuToken = "";
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.postMapLoadEvent = function(t1, e1, r, n) {
                this.skuToken = r;
                var i = !(!n && !R.ACCESS_TOKEN), a = Array.isArray(t1) && t1.some(function(t1) {
                    return Z(t1) || J(t1);
                });
                R.EVENTS_URL && i && a && this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, n);
            }, e1.prototype.processRequests = function(t1) {
                var e1 = this;
                if (!this.pendingRequest && 0 !== this.queue.length) {
                    var r = this.queue.shift(), n = r.id, i = r.timestamp;
                    n && this.success[n] || (this.anonId || this.fetchEventData(), m(this.anonId) || (this.anonId = d()), this.postEvent(i, {
                        skuToken: this.skuToken
                    }, function(t1) {
                        t1 || n && (e1.success[n] = !0);
                    }, t1));
                }
            }, e1;
        }(Q), nt = new (function(t1) {
            function e1(e1) {
                t1.call(this, "appUserTurnstile"), this._customAccessToken = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.postTurnstileEvent = function(t1, e1) {
                R.EVENTS_URL && R.ACCESS_TOKEN && Array.isArray(t1) && t1.some(function(t1) {
                    return Z(t1) || J(t1);
                }) && this.queueRequest(Date.now(), e1);
            }, e1.prototype.processRequests = function(t1) {
                var e1 = this;
                if (!this.pendingRequest && 0 !== this.queue.length) {
                    this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                    var r = W(R.ACCESS_TOKEN), n = r ? r.u : R.ACCESS_TOKEN, i = n !== this.eventData.tokenU;
                    m(this.anonId) || (this.anonId = d(), i = !0);
                    var a = this.queue.shift();
                    if (this.eventData.lastSuccess) {
                        var o = new Date(this.eventData.lastSuccess), s = new Date(a), u = (a - this.eventData.lastSuccess) / 864e5;
                        i = i || u >= 1 || u < -1 || o.getDate() !== s.getDate();
                    } else i = !0;
                    if (!i) return this.processRequests();
                    this.postEvent(a, {
                        "enabled.telemetry": !1
                    }, function(t1) {
                        t1 || (e1.eventData.lastSuccess = a, e1.eventData.tokenU = n);
                    }, t1);
                }
            }, e1;
        }(Q)), it = nt.postTurnstileEvent.bind(nt), at = new rt, ot = at.postMapLoadEvent.bind(at), st = 500, ut = 50;
        function lt() {
            o.caches && !tt && (tt = o.caches.open("mapbox-tiles"));
        }
        function pt(t1) {
            var e1 = t1.indexOf("?");
            return e1 < 0 ? t1 : t1.slice(0, e1);
        }
        var ct, ht = 1 / 0;
        function ft() {
            return null == ct && (ct = o.OffscreenCanvas && new o.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof o.createImageBitmap), ct;
        }
        var yt = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image"
        };
        "function" == typeof Object.freeze && Object.freeze(yt);
        var dt = function(t1) {
            function e1(e1, r, n) {
                401 === r && J(n) && (e1 += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), t1.call(this, e1), this.status = r, this.url = n, this.name = this.constructor.name, this.message = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.toString = function() {
                return this.name + ": " + this.message + " (" + this.status + "): " + this.url;
            }, e1;
        }(Error), mt = I() ? function() {
            return self.worker && self.worker.referrer;
        } : function() {
            return ("blob:" === o.location.protocol ? o.parent : o).location.href;
        };
        var vt, gt, xt = function(t1, e1) {
            if (!(/^file:/.test(r = t1.url) || /^file:/.test(mt()) && !/^\w+:/.test(r))) {
                if (o.fetch && o.Request && o.AbortController && o.Request.prototype.hasOwnProperty("signal")) return function(t1, e1) {
                    var r, n = new o.AbortController, i = new o.Request(t1.url, {
                        method: t1.method || "GET",
                        body: t1.body,
                        credentials: t1.credentials,
                        headers: t1.headers,
                        referrer: mt(),
                        signal: n.signal
                    }), a = !1, s = !1, u = (r = i.url).indexOf("sku=") > 0 && J(r);
                    "json" === t1.type && i.headers.set("Accept", "application/json");
                    var l = function(r, n, a) {
                        if (!s) {
                            if (r && "SecurityError" !== r.message && A(r), n && a) return p(n);
                            var l = Date.now();
                            o.fetch(i).then(function(r) {
                                if (r.ok) {
                                    var n = u ? r.clone() : null;
                                    return p(r, n, l);
                                }
                                return e1(new dt(r.statusText, r.status, t1.url));
                            }).catch(function(t1) {
                                20 !== t1.code && e1(new Error(t1.message));
                            });
                        }
                    }, p = function(r, n, u) {
                        ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then(function(t1) {
                            s || (n && u && function(t1, e1, r) {
                                if (lt(), tt) {
                                    var n = {
                                        status: e1.status,
                                        statusText: e1.statusText,
                                        headers: new o.Headers
                                    };
                                    e1.headers.forEach(function(t1, e1) {
                                        return n.headers.set(e1, t1);
                                    });
                                    var i = z(e1.headers.get("Cache-Control") || "");
                                    i["no-store"] || (i["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * i["max-age"]).toUTCString()), new Date(n.headers.get("Expires")).getTime() - r < 42e4 || function(t1, e1) {
                                        if (void 0 === et) try {
                                            new Response(new ReadableStream), et = !0;
                                        } catch (t1) {
                                            et = !1;
                                        }
                                        et ? e1(t1.body) : t1.blob().then(e1);
                                    }(e1, function(e1) {
                                        var r = new o.Response(e1, n);
                                        lt(), tt && tt.then(function(e1) {
                                            return e1.put(pt(t1.url), r);
                                        }).catch(function(t1) {
                                            return A(t1.message);
                                        });
                                    }));
                                }
                            }(i, n, u), a = !0, e1(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch(function(t1) {
                            s || e1(new Error(t1.message));
                        });
                    };
                    return u ? function(t1, e1) {
                        if (lt(), !tt) return e1(null);
                        var r = pt(t1.url);
                        tt.then(function(t1) {
                            t1.match(r).then(function(n) {
                                var i = function(t1) {
                                    if (!t1) return !1;
                                    var e1 = new Date(t1.headers.get("Expires") || 0), r = z(t1.headers.get("Cache-Control") || "");
                                    return e1 > Date.now() && !r["no-cache"];
                                }(n);
                                t1.delete(r), i && t1.put(r, n.clone()), e1(null, n, i);
                            }).catch(e1);
                        }).catch(e1);
                    }(i, l) : l(null, null), {
                        cancel: function() {
                            s = !0, a || n.abort();
                        }
                    };
                }(t1, e1);
                if (I() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1, void 0, !0);
            }
            var r;
            return function(t1, e1) {
                var r = new o.XMLHttpRequest;
                for(var n in r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer"), t1.headers)r.setRequestHeader(n, t1.headers[n]);
                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = function() {
                    e1(new Error(r.statusText));
                }, r.onload = function() {
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        var n = r.response;
                        if ("json" === t1.type) try {
                            n = JSON.parse(r.response);
                        } catch (t1) {
                            return e1(t1);
                        }
                        e1(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else e1(new dt(r.statusText, r.status, t1.url));
                }, r.send(t1.body), {
                    cancel: function() {
                        return r.abort();
                    }
                };
            }(t1, e1);
        }, bt = function(t1, e1) {
            return xt(h(t1, {
                type: "arrayBuffer"
            }), e1);
        }, wt = function(t1, e1) {
            return xt(h(t1, {
                method: "POST"
            }), e1);
        }, _t = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        vt = [], gt = 0;
        var At = function(t1, e1) {
            if (U.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), gt >= R.MAX_PARALLEL_IMAGE_REQUESTS) {
                var r = {
                    requestParameters: t1,
                    callback: e1,
                    cancelled: !1,
                    cancel: function() {
                        this.cancelled = !0;
                    }
                };
                return vt.push(r), r;
            }
            gt++;
            var n = !1, i = function() {
                if (!n) for(n = !0, gt--; vt.length && gt < R.MAX_PARALLEL_IMAGE_REQUESTS;){
                    var t1 = vt.shift();
                    t1.cancelled || (t1.cancel = At(t1.requestParameters, t1.callback).cancel);
                }
            }, a = bt(t1, function(t1, r, n, a) {
                i(), t1 ? e1(t1) : r && (ft() ? function(t1, e1) {
                    var r = new o.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    o.createImageBitmap(r).then(function(t1) {
                        e1(null, t1);
                    }).catch(function(t1) {
                        e1(new Error("Could not load image because of " + t1.message + ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    });
                }(r, e1) : function(t1, e1, r, n) {
                    var i = new o.Image, a = o.URL;
                    i.onload = function() {
                        e1(null, i), a.revokeObjectURL(i.src), i.onload = null, o.requestAnimationFrame(function() {
                            i.src = _t;
                        });
                    }, i.onerror = function() {
                        return e1(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    };
                    var s = new o.Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    i.cacheControl = r, i.expires = n, i.src = t1.byteLength ? a.createObjectURL(s) : _t;
                }(r, e1, n, a));
            });
            return {
                cancel: function() {
                    a.cancel(), i();
                }
            };
        };
        function St(t1, e1, r) {
            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
        }
        function kt(t1, e1, r) {
            if (r && r[t1]) {
                var n = r[t1].indexOf(e1);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        var It = function(t1, e1) {
            void 0 === e1 && (e1 = {}), h(this, e1), this.type = t1;
        }, zt = function(t1) {
            function e1(e1, r) {
                void 0 === r && (r = {}), t1.call(this, "error", h({
                    error: e1
                }, r));
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(It), Ct = function() {};
        Ct.prototype.on = function(t1, e1) {
            return this._listeners = this._listeners || {}, St(t1, e1, this._listeners), this;
        }, Ct.prototype.off = function(t1, e1) {
            return kt(t1, e1, this._listeners), kt(t1, e1, this._oneTimeListeners), this;
        }, Ct.prototype.once = function(t1, e1) {
            return this._oneTimeListeners = this._oneTimeListeners || {}, St(t1, e1, this._oneTimeListeners), this;
        }, Ct.prototype.fire = function(t1, e1) {
            "string" == typeof t1 && (t1 = new It(t1, e1 || {}));
            var r = t1.type;
            if (this.listens(r)) {
                t1.target = this;
                for(var n = 0, i = this._listeners && this._listeners[r] ? this._listeners[r].slice() : []; n < i.length; n += 1)i[n].call(this, t1);
                for(var a = 0, o = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : []; a < o.length; a += 1){
                    var s = o[a];
                    kt(r, s, this._oneTimeListeners), s.call(this, t1);
                }
                var u = this._eventedParent;
                u && (h(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), u.fire(t1));
            } else t1 instanceof zt && console.error(t1.error);
            return this;
        }, Ct.prototype.listens = function(t1) {
            return this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1);
        }, Ct.prototype.setEventedParent = function(t1, e1) {
            return this._eventedParent = t1, this._eventedParentData = e1, this;
        };
        var Et = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "string"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {}
                    },
                    default: "mapbox"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {},
                    within: {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        }, Pt = function(t1, e1, r, n) {
            this.message = (t1 ? t1 + ": " : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
        };
        function Mt(t1) {
            var e1 = t1.value;
            return e1 ? [
                new Pt(t1.key, e1, "constants have been deprecated as of v8")
            ] : [];
        }
        function Bt(t1) {
            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
            for(var n = 0, i = e1; n < i.length; n += 1){
                var a = i[n];
                for(var o in a)t1[o] = a[o];
            }
            return t1;
        }
        function Tt(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Vt(t1) {
            if (Array.isArray(t1)) return t1.map(Vt);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                var e1 = {};
                for(var r in t1)e1[r] = Vt(t1[r]);
                return e1;
            }
            return Tt(t1);
        }
        var Ft = function(t1) {
            function e1(e1, r) {
                t1.call(this, r), this.message = r, this.key = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(Error), Dt = function(t1, e1) {
            void 0 === e1 && (e1 = []), this.parent = t1, this.bindings = {};
            for(var r = 0, n = e1; r < n.length; r += 1){
                var i = n[r];
                this.bindings[i[0]] = i[1];
            }
        };
        Dt.prototype.concat = function(t1) {
            return new Dt(this, t1);
        }, Dt.prototype.get = function(t1) {
            if (this.bindings[t1]) return this.bindings[t1];
            if (this.parent) return this.parent.get(t1);
            throw new Error(t1 + " not found in scope.");
        }, Dt.prototype.has = function(t1) {
            return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
        };
        var Lt = {
            kind: "null"
        }, Ot = {
            kind: "number"
        }, Rt = {
            kind: "string"
        }, Ut = {
            kind: "boolean"
        }, jt = {
            kind: "color"
        }, qt = {
            kind: "object"
        }, Nt = {
            kind: "value"
        }, Kt = {
            kind: "collator"
        }, Gt = {
            kind: "formatted"
        }, Zt = {
            kind: "resolvedImage"
        };
        function Xt(t1, e1) {
            return {
                kind: "array",
                itemType: t1,
                N: e1
            };
        }
        function Jt(t1) {
            if ("array" === t1.kind) {
                var e1 = Jt(t1.itemType);
                return "number" == typeof t1.N ? "array<" + e1 + ", " + t1.N + ">" : "value" === t1.itemType.kind ? "array" : "array<" + e1 + ">";
            }
            return t1.kind;
        }
        var Ht = [
            Lt,
            Ot,
            Rt,
            Ut,
            jt,
            Gt,
            qt,
            Xt(Nt),
            Zt
        ];
        function Yt(t1, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !Yt(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
            } else {
                if (t1.kind === e1.kind) return null;
                if ("value" === t1.kind) {
                    for(var r = 0, n = Ht; r < n.length; r += 1)if (!Yt(n[r], e1)) return null;
                }
            }
            return "Expected " + Jt(t1) + " but found " + Jt(e1) + " instead.";
        }
        function $t(t1, e1) {
            return e1.some(function(e1) {
                return e1.kind === t1.kind;
            });
        }
        function Wt(t1, e1) {
            return e1.some(function(e1) {
                return "null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1;
            });
        }
        var Qt = e1(function(t1, e1) {
            var r = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function n(t1) {
                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
            }
            function i(t1) {
                return n("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
            }
            function a(t1) {
                var e1;
                return (e1 = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e1 > 1 ? 1 : e1;
            }
            function o(t1, e1, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e1 - t1) * r * 6 : 2 * r < 1 ? e1 : 3 * r < 2 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
            }
            try {
                e1.parseCSSColor = function(t1) {
                    var e1, s = t1.replace(/ /g, "").toLowerCase();
                    if (s in r) return r[s].slice();
                    if ("#" === s[0]) return 4 === s.length ? (e1 = parseInt(s.substr(1), 16)) >= 0 && e1 <= 4095 ? [
                        (3840 & e1) >> 4 | (3840 & e1) >> 8,
                        240 & e1 | (240 & e1) >> 4,
                        15 & e1 | (15 & e1) << 4,
                        1
                    ] : null : 7 === s.length && (e1 = parseInt(s.substr(1), 16)) >= 0 && e1 <= 16777215 ? [
                        (16711680 & e1) >> 16,
                        (65280 & e1) >> 8,
                        255 & e1,
                        1
                    ] : null;
                    var u = s.indexOf("("), l = s.indexOf(")");
                    if (-1 !== u && l + 1 === s.length) {
                        var p = s.substr(0, u), c = s.substr(u + 1, l - (u + 1)).split(","), h = 1;
                        switch(p){
                            case "rgba":
                                if (4 !== c.length) return null;
                                h = a(c.pop());
                            case "rgb":
                                return 3 !== c.length ? null : [
                                    i(c[0]),
                                    i(c[1]),
                                    i(c[2]),
                                    h
                                ];
                            case "hsla":
                                if (4 !== c.length) return null;
                                h = a(c.pop());
                            case "hsl":
                                if (3 !== c.length) return null;
                                var f = (parseFloat(c[0]) % 360 + 360) % 360 / 360, y = a(c[1]), d = a(c[2]), m = d <= .5 ? d * (y + 1) : d + y - d * y, v = 2 * d - m;
                                return [
                                    n(255 * o(v, m, f + 1 / 3)),
                                    n(255 * o(v, m, f)),
                                    n(255 * o(v, m, f - 1 / 3)),
                                    h
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (t1) {}
        }).parseCSSColor, te = function(t1, e1, r, n) {
            void 0 === n && (n = 1), this.r = t1, this.g = e1, this.b = r, this.a = n;
        };
        te.parse = function(t1) {
            if (t1) {
                if (t1 instanceof te) return t1;
                if ("string" == typeof t1) {
                    var e1 = Qt(t1);
                    if (e1) return new te(e1[0] / 255 * e1[3], e1[1] / 255 * e1[3], e1[2] / 255 * e1[3], e1[3]);
                }
            }
        }, te.prototype.toString = function() {
            var t1 = this.toArray(), e1 = t1[1], r = t1[2], n = t1[3];
            return "rgba(" + Math.round(t1[0]) + "," + Math.round(e1) + "," + Math.round(r) + "," + n + ")";
        }, te.prototype.toArray = function() {
            var t1 = this.a;
            return 0 === t1 ? [
                0,
                0,
                0,
                0
            ] : [
                255 * this.r / t1,
                255 * this.g / t1,
                255 * this.b / t1,
                t1
            ];
        }, te.black = new te(0, 0, 0, 1), te.white = new te(1, 1, 1, 1), te.transparent = new te(0, 0, 0, 0), te.red = new te(1, 0, 0, 1);
        var ee = function(t1, e1, r) {
            this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                sensitivity: this.sensitivity,
                usage: "search"
            });
        };
        ee.prototype.compare = function(t1, e1) {
            return this.collator.compare(t1, e1);
        }, ee.prototype.resolvedLocale = function() {
            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        };
        var re = function(t1, e1, r, n, i) {
            this.text = t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
        }, ne = function(t1) {
            this.sections = t1;
        };
        ne.fromString = function(t1) {
            return new ne([
                new re(t1, null, null, null, null)
            ]);
        }, ne.prototype.isEmpty = function() {
            return 0 === this.sections.length || !this.sections.some(function(t1) {
                return 0 !== t1.text.length || t1.image && 0 !== t1.image.name.length;
            });
        }, ne.factory = function(t1) {
            return t1 instanceof ne ? t1 : ne.fromString(t1);
        }, ne.prototype.toString = function() {
            return 0 === this.sections.length ? "" : this.sections.map(function(t1) {
                return t1.text;
            }).join("");
        }, ne.prototype.serialize = function() {
            for(var t1 = [
                "format"
            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                var n = r[e1];
                if (n.image) t1.push([
                    "image",
                    n.image.name
                ]);
                else {
                    t1.push(n.text);
                    var i = {};
                    n.fontStack && (i["text-font"] = [
                        "literal",
                        n.fontStack.split(",")
                    ]), n.scale && (i["font-scale"] = n.scale), n.textColor && (i["text-color"] = [
                        "rgba"
                    ].concat(n.textColor.toArray())), t1.push(i);
                }
            }
            return t1;
        };
        var ie = function(t1) {
            this.name = t1.name, this.available = t1.available;
        };
        function ae(t1, e1, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [" + [
                t1,
                e1,
                r,
                n
            ].join(", ") + "]: 'a' must be between 0 and 1." : "Invalid rgba value [" + ("number" == typeof n ? [
                t1,
                e1,
                r,
                n
            ] : [
                t1,
                e1,
                r
            ]).join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255.";
        }
        function oe(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof te) return !0;
            if (t1 instanceof ee) return !0;
            if (t1 instanceof ne) return !0;
            if (t1 instanceof ie) return !0;
            if (Array.isArray(t1)) {
                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (!oe(r[e1])) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(var n in t1)if (!oe(t1[n])) return !1;
                return !0;
            }
            return !1;
        }
        function se(t1) {
            if (null === t1) return Lt;
            if ("string" == typeof t1) return Rt;
            if ("boolean" == typeof t1) return Ut;
            if ("number" == typeof t1) return Ot;
            if (t1 instanceof te) return jt;
            if (t1 instanceof ee) return Kt;
            if (t1 instanceof ne) return Gt;
            if (t1 instanceof ie) return Zt;
            if (Array.isArray(t1)) {
                for(var e1, r = t1.length, n = 0, i = t1; n < i.length; n += 1){
                    var a = se(i[n]);
                    if (e1) {
                        if (e1 === a) continue;
                        e1 = Nt;
                        break;
                    }
                    e1 = a;
                }
                return Xt(e1 || Nt, r);
            }
            return qt;
        }
        function ue(t1) {
            var e1 = typeof t1;
            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof te || t1 instanceof ne || t1 instanceof ie ? t1.toString() : JSON.stringify(t1);
        }
        ie.prototype.toString = function() {
            return this.name;
        }, ie.fromString = function(t1) {
            return t1 ? new ie({
                name: t1,
                available: !1
            }) : null;
        }, ie.prototype.serialize = function() {
            return [
                "image",
                this.name
            ];
        };
        var le = function(t1, e1) {
            this.type = t1, this.value = e1;
        };
        le.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("'literal' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
            if (!oe(t1[1])) return e1.error("invalid value");
            var r = t1[1], n = se(r), i = e1.expectedType;
            return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new le(n, r);
        }, le.prototype.evaluate = function() {
            return this.value;
        }, le.prototype.eachChild = function() {}, le.prototype.outputDefined = function() {
            return !0;
        }, le.prototype.serialize = function() {
            return "array" === this.type.kind || "object" === this.type.kind ? [
                "literal",
                this.value
            ] : this.value instanceof te ? [
                "rgba"
            ].concat(this.value.toArray()) : this.value instanceof ne ? this.value.serialize() : this.value;
        };
        var pe = function(t1) {
            this.name = "ExpressionEvaluationError", this.message = t1;
        };
        pe.prototype.toJSON = function() {
            return this.message;
        };
        var ce = {
            string: Rt,
            number: Ot,
            boolean: Ut,
            object: qt
        }, he = function(t1, e1) {
            this.type = t1, this.args = e1;
        };
        he.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expected at least one argument.");
            var r, n = 1, i = t1[0];
            if ("array" === i) {
                var a, o;
                if (t1.length > 2) {
                    var s = t1[1];
                    if ("string" != typeof s || !(s in ce) || "object" === s) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                    a = ce[s], n++;
                } else a = Nt;
                if (t1.length > 3) {
                    if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                    o = t1[2], n++;
                }
                r = Xt(a, o);
            } else r = ce[i];
            for(var u = []; n < t1.length; n++){
                var l = e1.parse(t1[n], n, Nt);
                if (!l) return null;
                u.push(l);
            }
            return new he(r, u);
        }, he.prototype.evaluate = function(t1) {
            for(var e1 = 0; e1 < this.args.length; e1++){
                var r = this.args[e1].evaluate(t1);
                if (!Yt(this.type, se(r))) return r;
                if (e1 === this.args.length - 1) throw new pe("Expected value to be of type " + Jt(this.type) + ", but found " + Jt(se(r)) + " instead.");
            }
            return null;
        }, he.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, he.prototype.outputDefined = function() {
            return this.args.every(function(t1) {
                return t1.outputDefined();
            });
        }, he.prototype.serialize = function() {
            var t1 = this.type, e1 = [
                t1.kind
            ];
            if ("array" === t1.kind) {
                var r = t1.itemType;
                if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                    e1.push(r.kind);
                    var n = t1.N;
                    ("number" == typeof n || this.args.length > 1) && e1.push(n);
                }
            }
            return e1.concat(this.args.map(function(t1) {
                return t1.serialize();
            }));
        };
        var fe = function(t1) {
            this.type = Gt, this.sections = t1;
        };
        fe.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expected at least one argument.");
            var r = t1[1];
            if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
            for(var n = [], i = !1, a = 1; a <= t1.length - 1; ++a){
                var o = t1[a];
                if (i && "object" == typeof o && !Array.isArray(o)) {
                    i = !1;
                    var s = null;
                    if (o["font-scale"] && !(s = e1.parse(o["font-scale"], 1, Ot))) return null;
                    var u = null;
                    if (o["text-font"] && !(u = e1.parse(o["text-font"], 1, Xt(Rt)))) return null;
                    var l = null;
                    if (o["text-color"] && !(l = e1.parse(o["text-color"], 1, jt))) return null;
                    var p = n[n.length - 1];
                    p.scale = s, p.font = u, p.textColor = l;
                } else {
                    var c = e1.parse(t1[a], 1, Nt);
                    if (!c) return null;
                    var h = c.type.kind;
                    if ("string" !== h && "value" !== h && "null" !== h && "resolvedImage" !== h) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                    i = !0, n.push({
                        content: c,
                        scale: null,
                        font: null,
                        textColor: null
                    });
                }
            }
            return new fe(n);
        }, fe.prototype.evaluate = function(t1) {
            return new ne(this.sections.map(function(e1) {
                var r = e1.content.evaluate(t1);
                return se(r) === Zt ? new re("", r, null, null, null) : new re(ue(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
            }));
        }, fe.prototype.eachChild = function(t1) {
            for(var e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                var n = r[e1];
                t1(n.content), n.scale && t1(n.scale), n.font && t1(n.font), n.textColor && t1(n.textColor);
            }
        }, fe.prototype.outputDefined = function() {
            return !1;
        }, fe.prototype.serialize = function() {
            for(var t1 = [
                "format"
            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                var n = r[e1];
                t1.push(n.content.serialize());
                var i = {};
                n.scale && (i["font-scale"] = n.scale.serialize()), n.font && (i["text-font"] = n.font.serialize()), n.textColor && (i["text-color"] = n.textColor.serialize()), t1.push(i);
            }
            return t1;
        };
        var ye = function(t1) {
            this.type = Zt, this.input = t1;
        };
        ye.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("Expected two arguments.");
            var r = e1.parse(t1[1], 1, Rt);
            return r ? new ye(r) : e1.error("No image name provided.");
        }, ye.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1), r = ie.fromString(e1);
            return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
        }, ye.prototype.eachChild = function(t1) {
            t1(this.input);
        }, ye.prototype.outputDefined = function() {
            return !1;
        }, ye.prototype.serialize = function() {
            return [
                "image",
                this.input.serialize()
            ];
        };
        var de = {
            "to-boolean": Ut,
            "to-color": jt,
            "to-number": Ot,
            "to-string": Rt
        }, me = function(t1, e1) {
            this.type = t1, this.args = e1;
        };
        me.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expected at least one argument.");
            var r = t1[0];
            if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
            for(var n = de[r], i = [], a = 1; a < t1.length; a++){
                var o = e1.parse(t1[a], a, Nt);
                if (!o) return null;
                i.push(o);
            }
            return new me(n, i);
        }, me.prototype.evaluate = function(t1) {
            if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
            if ("color" === this.type.kind) {
                for(var e1, r, n = 0, i = this.args; n < i.length; n += 1){
                    if (r = null, (e1 = i[n].evaluate(t1)) instanceof te) return e1;
                    if ("string" == typeof e1) {
                        var a = t1.parseColor(e1);
                        if (a) return a;
                    } else if (Array.isArray(e1) && !(r = e1.length < 3 || e1.length > 4 ? "Invalid rbga value " + JSON.stringify(e1) + ": expected an array containing either three or four numeric values." : ae(e1[0], e1[1], e1[2], e1[3]))) return new te(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                }
                throw new pe(r || "Could not parse color from value '" + ("string" == typeof e1 ? e1 : String(JSON.stringify(e1))) + "'");
            }
            if ("number" === this.type.kind) {
                for(var o = null, s = 0, u = this.args; s < u.length; s += 1){
                    if (null === (o = u[s].evaluate(t1))) return 0;
                    var l = Number(o);
                    if (!isNaN(l)) return l;
                }
                throw new pe("Could not convert " + JSON.stringify(o) + " to number.");
            }
            return "formatted" === this.type.kind ? ne.fromString(ue(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? ie.fromString(ue(this.args[0].evaluate(t1))) : ue(this.args[0].evaluate(t1));
        }, me.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, me.prototype.outputDefined = function() {
            return this.args.every(function(t1) {
                return t1.outputDefined();
            });
        }, me.prototype.serialize = function() {
            if ("formatted" === this.type.kind) return new fe([
                {
                    content: this.args[0],
                    scale: null,
                    font: null,
                    textColor: null
                }
            ]).serialize();
            if ("resolvedImage" === this.type.kind) return new ye(this.args[0]).serialize();
            var t1 = [
                "to-" + this.type.kind
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var ve = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], ge = function() {
            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
        };
        ge.prototype.id = function() {
            return this.feature && "id" in this.feature ? this.feature.id : null;
        }, ge.prototype.geometryType = function() {
            return this.feature ? "number" == typeof this.feature.type ? ve[this.feature.type] : this.feature.type : null;
        }, ge.prototype.geometry = function() {
            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }, ge.prototype.canonicalID = function() {
            return this.canonical;
        }, ge.prototype.properties = function() {
            return this.feature && this.feature.properties || {};
        }, ge.prototype.parseColor = function(t1) {
            var e1 = this._parseColorCache[t1];
            return e1 || (e1 = this._parseColorCache[t1] = te.parse(t1)), e1;
        };
        var xe = function(t1, e1, r, n) {
            this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
        };
        xe.prototype.evaluate = function(t1) {
            return this._evaluate(t1, this.args);
        }, xe.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, xe.prototype.outputDefined = function() {
            return !1;
        }, xe.prototype.serialize = function() {
            return [
                this.name
            ].concat(this.args.map(function(t1) {
                return t1.serialize();
            }));
        }, xe.parse = function(t1, e1) {
            var r, n = t1[0], i = xe.definitions[n];
            if (!i) return e1.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
            for(var a = Array.isArray(i) ? i[0] : i.type, o = Array.isArray(i) ? [
                [
                    i[1],
                    i[2]
                ]
            ] : i.overloads, s = o.filter(function(e1) {
                var r = e1[0];
                return !Array.isArray(r) || r.length === t1.length - 1;
            }), u = null, l = 0, p = s; l < p.length; l += 1){
                var c = p[l], h = c[0], f = c[1];
                u = new je(e1.registry, e1.path, null, e1.scope);
                for(var y = [], d = !1, m = 1; m < t1.length; m++){
                    var v = t1[m], g = Array.isArray(h) ? h[m - 1] : h.type, x = u.parse(v, 1 + y.length, g);
                    if (!x) {
                        d = !0;
                        break;
                    }
                    y.push(x);
                }
                if (!d) {
                    if (Array.isArray(h) && h.length !== y.length) u.error("Expected " + h.length + " arguments, but found " + y.length + " instead.");
                    else {
                        for(var b = 0; b < y.length; b++){
                            var w = Array.isArray(h) ? h[b] : h.type, _ = y[b];
                            u.concat(b + 1).checkSubtype(w, _.type);
                        }
                        if (0 === u.errors.length) return new xe(n, a, f, y);
                    }
                }
            }
            if (1 === s.length) (r = e1.errors).push.apply(r, u.errors);
            else {
                for(var A = (s.length ? s : o).map(function(t1) {
                    var e1;
                    return e1 = t1[0], Array.isArray(e1) ? "(" + e1.map(Jt).join(", ") + ")" : "(" + Jt(e1.type) + "...)";
                }).join(" | "), S = [], k = 1; k < t1.length; k++){
                    var I = e1.parse(t1[k], 1 + S.length);
                    if (!I) return null;
                    S.push(Jt(I.type));
                }
                e1.error("Expected arguments of type " + A + ", but found (" + S.join(", ") + ") instead.");
            }
            return null;
        }, xe.register = function(t1, e1) {
            for(var r in xe.definitions = e1, e1)t1[r] = xe;
        };
        var be = function(t1, e1, r) {
            this.type = Kt, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
        };
        function we(t1, e1) {
            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
        }
        function _e(t1, e1) {
            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
        }
        function Ae(t1, e1) {
            var r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(r * i * 8192),
                Math.round(n * i * 8192)
            ];
        }
        function Se(t1, e1, r) {
            return e1[1] > t1[1] != r[1] > t1[1] && t1[0] < (r[0] - e1[0]) * (t1[1] - e1[1]) / (r[1] - e1[1]) + e1[0];
        }
        function ke(t1, e1) {
            for(var r, n, i, a, o, s, u, l = !1, p = 0, c = e1.length; p < c; p++)for(var h = e1[p], f = 0, y = h.length; f < y - 1; f++){
                if ((a = (r = t1)[0] - (n = h[f])[0]) * (u = r[1] - (i = h[f + 1])[1]) - (s = r[0] - i[0]) * (o = r[1] - n[1]) == 0 && a * s <= 0 && o * u <= 0) return !1;
                Se(t1, h[f], h[f + 1]) && (l = !l);
            }
            return l;
        }
        function Ie(t1, e1) {
            for(var r = 0; r < e1.length; r++)if (ke(t1, e1[r])) return !0;
            return !1;
        }
        function ze(t1, e1, r, n) {
            var i = n[0] - r[0], a = n[1] - r[1], o = (t1[0] - r[0]) * a - i * (t1[1] - r[1]), s = (e1[0] - r[0]) * a - i * (e1[1] - r[1]);
            return o > 0 && s < 0 || o < 0 && s > 0;
        }
        function Ce(t1, e1, r) {
            for(var n = 0, i = r; n < i.length; n += 1)for(var a = i[n], o = 0; o < a.length - 1; ++o)if (0 != (c = [
                (p = a[o + 1])[0] - (l = a[o])[0],
                p[1] - l[1]
            ])[0] * (h = [
                (u = e1)[0] - (s = t1)[0],
                u[1] - s[1]
            ])[1] - c[1] * h[0] && ze(s, u, l, p) && ze(l, p, s, u)) return !0;
            var s, u, l, p, c, h;
            return !1;
        }
        function Ee(t1, e1) {
            for(var r = 0; r < t1.length; ++r)if (!ke(t1[r], e1)) return !1;
            for(var n = 0; n < t1.length - 1; ++n)if (Ce(t1[n], t1[n + 1], e1)) return !1;
            return !0;
        }
        function Pe(t1, e1) {
            for(var r = 0; r < e1.length; r++)if (Ee(t1, e1[r])) return !0;
            return !1;
        }
        function Me(t1, e1, r) {
            for(var n = [], i = 0; i < t1.length; i++){
                for(var a = [], o = 0; o < t1[i].length; o++){
                    var s = Ae(t1[i][o], r);
                    we(e1, s), a.push(s);
                }
                n.push(a);
            }
            return n;
        }
        function Be(t1, e1, r) {
            for(var n = [], i = 0; i < t1.length; i++){
                var a = Me(t1[i], e1, r);
                n.push(a);
            }
            return n;
        }
        function Te(t1, e1, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                var i = .5 * n, a = t1[0] - r[0] > i ? -n : r[0] - t1[0] > i ? n : 0;
                0 === a && (a = t1[0] - r[2] > i ? -n : r[2] - t1[0] > i ? n : 0), t1[0] += a;
            }
            we(e1, t1);
        }
        function Ve(t1, e1, r, n) {
            for(var i = 8192 * Math.pow(2, n.z), a = [
                8192 * n.x,
                8192 * n.y
            ], o = [], s = 0, u = t1; s < u.length; s += 1)for(var l = 0, p = u[s]; l < p.length; l += 1){
                var c = p[l], h = [
                    c.x + a[0],
                    c.y + a[1]
                ];
                Te(h, e1, r, i), o.push(h);
            }
            return o;
        }
        function Fe(t1, e1, r, n) {
            for(var i, a = 8192 * Math.pow(2, n.z), o = [
                8192 * n.x,
                8192 * n.y
            ], s = [], u = 0, l = t1; u < l.length; u += 1){
                for(var p = [], c = 0, h = l[u]; c < h.length; c += 1){
                    var f = h[c], y = [
                        f.x + o[0],
                        f.y + o[1]
                    ];
                    we(e1, y), p.push(y);
                }
                s.push(p);
            }
            if (e1[2] - e1[0] <= a / 2) {
                (i = e1)[0] = i[1] = 1 / 0, i[2] = i[3] = -1 / 0;
                for(var d = 0, m = s; d < m.length; d += 1)for(var v = 0, g = m[d]; v < g.length; v += 1)Te(g[v], e1, r, a);
            }
            return s;
        }
        be.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("Expected one argument.");
            var r = t1[1];
            if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
            var n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, Ut);
            if (!n) return null;
            var i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, Ut);
            if (!i) return null;
            var a = null;
            return r.locale && !(a = e1.parse(r.locale, 1, Rt)) ? null : new be(n, i, a);
        }, be.prototype.evaluate = function(t1) {
            return new ee(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
        }, be.prototype.eachChild = function(t1) {
            t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
        }, be.prototype.outputDefined = function() {
            return !1;
        }, be.prototype.serialize = function() {
            var t1 = {};
            return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                "collator",
                t1
            ];
        };
        var De = function(t1, e1) {
            this.type = Ut, this.geojson = t1, this.geometries = e1;
        };
        function Le(t1) {
            if (t1 instanceof xe) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof De) return !1;
            var e1 = !0;
            return t1.eachChild(function(t1) {
                e1 && !Le(t1) && (e1 = !1);
            }), e1;
        }
        function Oe(t1) {
            if (t1 instanceof xe && "feature-state" === t1.name) return !1;
            var e1 = !0;
            return t1.eachChild(function(t1) {
                e1 && !Oe(t1) && (e1 = !1);
            }), e1;
        }
        function Re(t1, e1) {
            if (t1 instanceof xe && e1.indexOf(t1.name) >= 0) return !1;
            var r = !0;
            return t1.eachChild(function(t1) {
                r && !Re(t1, e1) && (r = !1);
            }), r;
        }
        De.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("'within' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
            if (oe(t1[1])) {
                var r = t1[1];
                if ("FeatureCollection" === r.type) for(var n = 0; n < r.features.length; ++n){
                    var i = r.features[n].geometry.type;
                    if ("Polygon" === i || "MultiPolygon" === i) return new De(r, r.features[n].geometry);
                }
                else if ("Feature" === r.type) {
                    var a = r.geometry.type;
                    if ("Polygon" === a || "MultiPolygon" === a) return new De(r, r.geometry);
                } else if ("Polygon" === r.type || "MultiPolygon" === r.type) return new De(r, r);
            }
            return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }, De.prototype.evaluate = function(t1) {
            if (null != t1.geometry() && null != t1.canonicalID()) {
                if ("Point" === t1.geometryType()) return function(t1, e1) {
                    var r = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], i = t1.canonicalID();
                    if ("Polygon" === e1.type) {
                        var a = Me(e1.coordinates, n, i), o = Ve(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var s = 0, u = o; s < u.length; s += 1)if (!ke(u[s], a)) return !1;
                    }
                    if ("MultiPolygon" === e1.type) {
                        var l = Be(e1.coordinates, n, i), p = Ve(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var c = 0, h = p; c < h.length; c += 1)if (!Ie(h[c], l)) return !1;
                    }
                    return !0;
                }(t1, this.geometries);
                if ("LineString" === t1.geometryType()) return function(t1, e1) {
                    var r = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], i = t1.canonicalID();
                    if ("Polygon" === e1.type) {
                        var a = Me(e1.coordinates, n, i), o = Fe(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var s = 0, u = o; s < u.length; s += 1)if (!Ee(u[s], a)) return !1;
                    }
                    if ("MultiPolygon" === e1.type) {
                        var l = Be(e1.coordinates, n, i), p = Fe(t1.geometry(), r, n, i);
                        if (!_e(r, n)) return !1;
                        for(var c = 0, h = p; c < h.length; c += 1)if (!Pe(h[c], l)) return !1;
                    }
                    return !0;
                }(t1, this.geometries);
            }
            return !1;
        }, De.prototype.eachChild = function() {}, De.prototype.outputDefined = function() {
            return !0;
        }, De.prototype.serialize = function() {
            return [
                "within",
                this.geojson
            ];
        };
        var Ue = function(t1, e1) {
            this.type = e1.type, this.name = t1, this.boundExpression = e1;
        };
        Ue.parse = function(t1, e1) {
            if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
            var r = t1[1];
            return e1.scope.has(r) ? new Ue(r, e1.scope.get(r)) : e1.error('Unknown variable "' + r + '". Make sure "' + r + '" has been bound in an enclosing "let" expression before using it.', 1);
        }, Ue.prototype.evaluate = function(t1) {
            return this.boundExpression.evaluate(t1);
        }, Ue.prototype.eachChild = function() {}, Ue.prototype.outputDefined = function() {
            return !1;
        }, Ue.prototype.serialize = function() {
            return [
                "var",
                this.name
            ];
        };
        var je = function(t1, e1, r, n, i) {
            void 0 === e1 && (e1 = []), void 0 === n && (n = new Dt), void 0 === i && (i = []), this.registry = t1, this.path = e1, this.key = e1.map(function(t1) {
                return "[" + t1 + "]";
            }).join(""), this.scope = n, this.errors = i, this.expectedType = r;
        };
        function qe(t1, e1) {
            for(var r, n = t1.length - 1, i = 0, a = n, o = 0; i <= a;)if ((r = t1[o = Math.floor((i + a) / 2)]) <= e1) {
                if (o === n || e1 < t1[o + 1]) return o;
                i = o + 1;
            } else {
                if (!(r > e1)) throw new pe("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        je.prototype.parse = function(t1, e1, r, n, i) {
            return void 0 === i && (i = {}), e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
        }, je.prototype._parse = function(t1, e1) {
            function r(t1, e1, r) {
                return "assert" === r ? new he(e1, [
                    t1
                ]) : "coerce" === r ? new me(e1, [
                    t1
                ]) : t1;
            }
            if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                "literal",
                t1
            ]), Array.isArray(t1)) {
                if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                var n = t1[0];
                if ("string" != typeof n) return this.error("Expression name must be a string, but found " + typeof n + ' instead. If you wanted a literal array, use ["literal", [...]].', 0), null;
                var i = this.registry[n];
                if (i) {
                    var a = i.parse(t1, this);
                    if (!a) return null;
                    if (this.expectedType) {
                        var o = this.expectedType, s = a.type;
                        if ("string" !== o.kind && "number" !== o.kind && "boolean" !== o.kind && "object" !== o.kind && "array" !== o.kind || "value" !== s.kind) {
                            if ("color" !== o.kind && "formatted" !== o.kind && "resolvedImage" !== o.kind || "value" !== s.kind && "string" !== s.kind) {
                                if (this.checkSubtype(o, s)) return null;
                            } else a = r(a, o, e1.typeAnnotation || "coerce");
                        } else a = r(a, o, e1.typeAnnotation || "assert");
                    }
                    if (!(a instanceof le) && "resolvedImage" !== a.type.kind && function t1(e1) {
                        if (e1 instanceof Ue) return t1(e1.boundExpression);
                        if (e1 instanceof xe && "error" === e1.name) return !1;
                        if (e1 instanceof be) return !1;
                        if (e1 instanceof De) return !1;
                        var r = e1 instanceof me || e1 instanceof he, n = !0;
                        return e1.eachChild(function(e1) {
                            n = r ? n && t1(e1) : n && e1 instanceof le;
                        }), !!n && Le(e1) && Re(e1, [
                            "zoom",
                            "heatmap-density",
                            "line-progress",
                            "accumulated",
                            "is-supported-script"
                        ]);
                    }(a)) {
                        var u = new ge;
                        try {
                            a = new le(a.type, a.evaluate(u));
                        } catch (t1) {
                            return this.error(t1.message), null;
                        }
                    }
                    return a;
                }
                return this.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
            }
            return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : "Expected an array, but found " + typeof t1 + " instead.");
        }, je.prototype.concat = function(t1, e1, r) {
            var n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
            return new je(this.registry, n, e1 || null, i, this.errors);
        }, je.prototype.error = function(t1) {
            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
            var n = "" + this.key + e1.map(function(t1) {
                return "[" + t1 + "]";
            }).join("");
            this.errors.push(new Ft(n, t1));
        }, je.prototype.checkSubtype = function(t1, e1) {
            var r = Yt(t1, e1);
            return r && this.error(r), r;
        };
        var Ne = function(t1, e1, r) {
            this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
            for(var n = 0, i = r; n < i.length; n += 1){
                var a = i[n], o = a[1];
                this.labels.push(a[0]), this.outputs.push(o);
            }
        };
        function Ke(t1, e1, r) {
            return t1 * (1 - r) + e1 * r;
        }
        Ne.parse = function(t1, e1) {
            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
            var r = e1.parse(t1[1], 1, Ot);
            if (!r) return null;
            var n = [], i = null;
            e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
            for(var a = 1; a < t1.length; a += 2){
                var o = 1 === a ? -1 / 0 : t1[a], s = t1[a + 1], u = a, l = a + 1;
                if ("number" != typeof o) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', u);
                if (n.length && n[n.length - 1][0] >= o) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', u);
                var p = e1.parse(s, l, i);
                if (!p) return null;
                i = i || p.type, n.push([
                    o,
                    p
                ]);
            }
            return new Ne(i, r, n);
        }, Ne.prototype.evaluate = function(t1) {
            var e1 = this.labels, r = this.outputs;
            if (1 === e1.length) return r[0].evaluate(t1);
            var n = this.input.evaluate(t1);
            if (n <= e1[0]) return r[0].evaluate(t1);
            var i = e1.length;
            return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[qe(e1, n)].evaluate(t1);
        }, Ne.prototype.eachChild = function(t1) {
            t1(this.input);
            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
        }, Ne.prototype.outputDefined = function() {
            return this.outputs.every(function(t1) {
                return t1.outputDefined();
            });
        }, Ne.prototype.serialize = function() {
            for(var t1 = [
                "step",
                this.input.serialize()
            ], e1 = 0; e1 < this.labels.length; e1++)e1 > 0 && t1.push(this.labels[e1]), t1.push(this.outputs[e1].serialize());
            return t1;
        };
        var Ge = Object.freeze({
            __proto__: null,
            number: Ke,
            color: function(t1, e1, r) {
                return new te(Ke(t1.r, e1.r, r), Ke(t1.g, e1.g, r), Ke(t1.b, e1.b, r), Ke(t1.a, e1.a, r));
            },
            array: function(t1, e1, r) {
                return t1.map(function(t1, n) {
                    return Ke(t1, e1[n], r);
                });
            }
        }), Ze = 6 / 29 * 3 * (6 / 29), Xe = Math.PI / 180, Je = 180 / Math.PI;
        function He(t1) {
            return t1 > .008856451679035631 ? Math.pow(t1, 1 / 3) : t1 / Ze + 4 / 29;
        }
        function Ye(t1) {
            return t1 > 6 / 29 ? t1 * t1 * t1 : Ze * (t1 - 4 / 29);
        }
        function $e(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function We(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Qe(t1) {
            var e1 = We(t1.r), r = We(t1.g), n = We(t1.b), i = He((.4124564 * e1 + .3575761 * r + .1804375 * n) / .95047), a = He((.2126729 * e1 + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * a - 16,
                a: 500 * (i - a),
                b: 200 * (a - He((.0193339 * e1 + .119192 * r + .9503041 * n) / 1.08883)),
                alpha: t1.a
            };
        }
        function tr(t1) {
            var e1 = (t1.l + 16) / 116, r = isNaN(t1.a) ? e1 : e1 + t1.a / 500, n = isNaN(t1.b) ? e1 : e1 - t1.b / 200;
            return e1 = 1 * Ye(e1), r = .95047 * Ye(r), n = 1.08883 * Ye(n), new te($e(3.2404542 * r - 1.5371385 * e1 - .4985314 * n), $e(-0.969266 * r + 1.8760108 * e1 + .041556 * n), $e(.0556434 * r - .2040259 * e1 + 1.0572252 * n), t1.alpha);
        }
        function er(t1, e1, r) {
            var n = e1 - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        var rr = {
            forward: Qe,
            reverse: tr,
            interpolate: function(t1, e1, r) {
                return {
                    l: Ke(t1.l, e1.l, r),
                    a: Ke(t1.a, e1.a, r),
                    b: Ke(t1.b, e1.b, r),
                    alpha: Ke(t1.alpha, e1.alpha, r)
                };
            }
        }, nr = {
            forward: function(t1) {
                var e1 = Qe(t1), r = e1.l, n = e1.a, i = e1.b, a = Math.atan2(i, n) * Je;
                return {
                    h: a < 0 ? a + 360 : a,
                    c: Math.sqrt(n * n + i * i),
                    l: r,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                var e1 = t1.h * Xe, r = t1.c;
                return tr({
                    l: t1.l,
                    a: Math.cos(e1) * r,
                    b: Math.sin(e1) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e1, r) {
                return {
                    h: er(t1.h, e1.h, r),
                    c: Ke(t1.c, e1.c, r),
                    l: Ke(t1.l, e1.l, r),
                    alpha: Ke(t1.alpha, e1.alpha, r)
                };
            }
        }, ir = Object.freeze({
            __proto__: null,
            lab: rr,
            hcl: nr
        }), ar = function(t1, e1, r, n, i) {
            this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
            for(var a = 0, o = i; a < o.length; a += 1){
                var s = o[a], u = s[1];
                this.labels.push(s[0]), this.outputs.push(u);
            }
        };
        function or(t1, e1, r, n) {
            var i = n - r, a = t1 - r;
            return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
        }
        ar.interpolationFactor = function(t1, e1, n, i) {
            var a = 0;
            if ("exponential" === t1.name) a = or(e1, t1.base, n, i);
            else if ("linear" === t1.name) a = or(e1, 1, n, i);
            else if ("cubic-bezier" === t1.name) {
                var o = t1.controlPoints;
                a = new r(o[0], o[1], o[2], o[3]).solve(or(e1, 1, n, i));
            }
            return a;
        }, ar.parse = function(t1, e1) {
            var r = t1[0], n = t1[1], i = t1[2], a = t1.slice(3);
            if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
            if ("linear" === n[0]) n = {
                name: "linear"
            };
            else if ("exponential" === n[0]) {
                var o = n[1];
                if ("number" != typeof o) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                n = {
                    name: "exponential",
                    base: o
                };
            } else {
                if ("cubic-bezier" !== n[0]) return e1.error("Unknown interpolation type " + String(n[0]), 1, 0);
                var s = n.slice(1);
                if (4 !== s.length || s.some(function(t1) {
                    return "number" != typeof t1 || t1 < 0 || t1 > 1;
                })) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                n = {
                    name: "cubic-bezier",
                    controlPoints: s
                };
            }
            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
            if (!(i = e1.parse(i, 2, Ot))) return null;
            var u = [], l = null;
            "interpolate-hcl" === r || "interpolate-lab" === r ? l = jt : e1.expectedType && "value" !== e1.expectedType.kind && (l = e1.expectedType);
            for(var p = 0; p < a.length; p += 2){
                var c = a[p], h = a[p + 1], f = p + 3, y = p + 4;
                if ("number" != typeof c) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', f);
                if (u.length && u[u.length - 1][0] >= c) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', f);
                var d = e1.parse(h, y, l);
                if (!d) return null;
                l = l || d.type, u.push([
                    c,
                    d
                ]);
            }
            return "number" === l.kind || "color" === l.kind || "array" === l.kind && "number" === l.itemType.kind && "number" == typeof l.N ? new ar(l, r, n, i, u) : e1.error("Type " + Jt(l) + " is not interpolatable.");
        }, ar.prototype.evaluate = function(t1) {
            var e1 = this.labels, r = this.outputs;
            if (1 === e1.length) return r[0].evaluate(t1);
            var n = this.input.evaluate(t1);
            if (n <= e1[0]) return r[0].evaluate(t1);
            var i = e1.length;
            if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
            var a = qe(e1, n), o = ar.interpolationFactor(this.interpolation, n, e1[a], e1[a + 1]), s = r[a].evaluate(t1), u = r[a + 1].evaluate(t1);
            return "interpolate" === this.operator ? Ge[this.type.kind.toLowerCase()](s, u, o) : "interpolate-hcl" === this.operator ? nr.reverse(nr.interpolate(nr.forward(s), nr.forward(u), o)) : rr.reverse(rr.interpolate(rr.forward(s), rr.forward(u), o));
        }, ar.prototype.eachChild = function(t1) {
            t1(this.input);
            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
        }, ar.prototype.outputDefined = function() {
            return this.outputs.every(function(t1) {
                return t1.outputDefined();
            });
        }, ar.prototype.serialize = function() {
            var t1;
            t1 = "linear" === this.interpolation.name ? [
                "linear"
            ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                "linear"
            ] : [
                "exponential",
                this.interpolation.base
            ] : [
                "cubic-bezier"
            ].concat(this.interpolation.controlPoints);
            for(var e1 = [
                this.operator,
                t1,
                this.input.serialize()
            ], r = 0; r < this.labels.length; r++)e1.push(this.labels[r], this.outputs[r].serialize());
            return e1;
        };
        var sr = function(t1, e1) {
            this.type = t1, this.args = e1;
        };
        sr.parse = function(t1, e1) {
            if (t1.length < 2) return e1.error("Expectected at least one argument.");
            var r = null, n = e1.expectedType;
            n && "value" !== n.kind && (r = n);
            for(var i = [], a = 0, o = t1.slice(1); a < o.length; a += 1){
                var s = e1.parse(o[a], 1 + i.length, r, void 0, {
                    typeAnnotation: "omit"
                });
                if (!s) return null;
                r = r || s.type, i.push(s);
            }
            var u = n && i.some(function(t1) {
                return Yt(n, t1.type);
            });
            return new sr(u ? Nt : r, i);
        }, sr.prototype.evaluate = function(t1) {
            for(var e1, r = null, n = 0, i = 0, a = this.args; i < a.length && (n++, (r = a[i].evaluate(t1)) && r instanceof ie && !r.available && (e1 || (e1 = r.name), r = null, n === this.args.length && (r = e1)), null === r); i += 1);
            return r;
        }, sr.prototype.eachChild = function(t1) {
            this.args.forEach(t1);
        }, sr.prototype.outputDefined = function() {
            return this.args.every(function(t1) {
                return t1.outputDefined();
            });
        }, sr.prototype.serialize = function() {
            var t1 = [
                "coalesce"
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var ur = function(t1, e1) {
            this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
        };
        ur.prototype.evaluate = function(t1) {
            return this.result.evaluate(t1);
        }, ur.prototype.eachChild = function(t1) {
            for(var e1 = 0, r = this.bindings; e1 < r.length; e1 += 1)t1(r[e1][1]);
            t1(this.result);
        }, ur.parse = function(t1, e1) {
            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found " + (t1.length - 1) + " instead.");
            for(var r = [], n = 1; n < t1.length - 1; n += 2){
                var i = t1[n];
                if ("string" != typeof i) return e1.error("Expected string, but found " + typeof i + " instead.", n);
                if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                var a = e1.parse(t1[n + 1], n + 1);
                if (!a) return null;
                r.push([
                    i,
                    a
                ]);
            }
            var o = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
            return o ? new ur(r, o) : null;
        }, ur.prototype.outputDefined = function() {
            return this.result.outputDefined();
        }, ur.prototype.serialize = function() {
            for(var t1 = [
                "let"
            ], e1 = 0, r = this.bindings; e1 < r.length; e1 += 1){
                var n = r[e1];
                t1.push(n[0], n[1].serialize());
            }
            return t1.push(this.result.serialize()), t1;
        };
        var lr = function(t1, e1, r) {
            this.type = t1, this.index = e1, this.input = r;
        };
        lr.parse = function(t1, e1) {
            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Ot), n = e1.parse(t1[2], 2, Xt(e1.expectedType || Nt));
            return r && n ? new lr(n.type.itemType, r, n) : null;
        }, lr.prototype.evaluate = function(t1) {
            var e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
            if (e1 < 0) throw new pe("Array index out of bounds: " + e1 + " < 0.");
            if (e1 >= r.length) throw new pe("Array index out of bounds: " + e1 + " > " + (r.length - 1) + ".");
            if (e1 !== Math.floor(e1)) throw new pe("Array index must be an integer, but found " + e1 + " instead.");
            return r[e1];
        }, lr.prototype.eachChild = function(t1) {
            t1(this.index), t1(this.input);
        }, lr.prototype.outputDefined = function() {
            return !1;
        }, lr.prototype.serialize = function() {
            return [
                "at",
                this.index.serialize(),
                this.input.serialize()
            ];
        };
        var pr = function(t1, e1) {
            this.type = Ut, this.needle = t1, this.haystack = e1;
        };
        pr.parse = function(t1, e1) {
            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Nt), n = e1.parse(t1[2], 2, Nt);
            return r && n ? $t(r.type, [
                Ut,
                Rt,
                Ot,
                Lt,
                Nt
            ]) ? new pr(r, n) : e1.error("Expected first argument to be of type boolean, string, number or null, but found " + Jt(r.type) + " instead") : null;
        }, pr.prototype.evaluate = function(t1) {
            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
            if (!r) return !1;
            if (!Wt(e1, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new pe("Expected first argument to be of type boolean, string, number or null, but found " + Jt(se(e1)) + " instead.");
            if (!Wt(r, [
                "string",
                "array"
            ])) throw new pe("Expected second argument to be of type array or string, but found " + Jt(se(r)) + " instead.");
            return r.indexOf(e1) >= 0;
        }, pr.prototype.eachChild = function(t1) {
            t1(this.needle), t1(this.haystack);
        }, pr.prototype.outputDefined = function() {
            return !0;
        }, pr.prototype.serialize = function() {
            return [
                "in",
                this.needle.serialize(),
                this.haystack.serialize()
            ];
        };
        var cr = function(t1, e1, r) {
            this.type = Ot, this.needle = t1, this.haystack = e1, this.fromIndex = r;
        };
        cr.parse = function(t1, e1) {
            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Nt), n = e1.parse(t1[2], 2, Nt);
            if (!r || !n) return null;
            if (!$t(r.type, [
                Ut,
                Rt,
                Ot,
                Lt,
                Nt
            ])) return e1.error("Expected first argument to be of type boolean, string, number or null, but found " + Jt(r.type) + " instead");
            if (4 === t1.length) {
                var i = e1.parse(t1[3], 3, Ot);
                return i ? new cr(r, n, i) : null;
            }
            return new cr(r, n);
        }, cr.prototype.evaluate = function(t1) {
            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
            if (!Wt(e1, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new pe("Expected first argument to be of type boolean, string, number or null, but found " + Jt(se(e1)) + " instead.");
            if (!Wt(r, [
                "string",
                "array"
            ])) throw new pe("Expected second argument to be of type array or string, but found " + Jt(se(r)) + " instead.");
            if (this.fromIndex) {
                var n = this.fromIndex.evaluate(t1);
                return r.indexOf(e1, n);
            }
            return r.indexOf(e1);
        }, cr.prototype.eachChild = function(t1) {
            t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
        }, cr.prototype.outputDefined = function() {
            return !1;
        }, cr.prototype.serialize = function() {
            if (null != this.fromIndex && void 0 !== this.fromIndex) {
                var t1 = this.fromIndex.serialize();
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize(),
                    t1
                ];
            }
            return [
                "index-of",
                this.needle.serialize(),
                this.haystack.serialize()
            ];
        };
        var hr = function(t1, e1, r, n, i, a) {
            this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
        };
        hr.parse = function(t1, e1) {
            if (t1.length < 5) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
            if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
            var r, n;
            e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
            for(var i = {}, a = [], o = 2; o < t1.length - 1; o += 2){
                var s = t1[o], u = t1[o + 1];
                Array.isArray(s) || (s = [
                    s
                ]);
                var l = e1.concat(o);
                if (0 === s.length) return l.error("Expected at least one branch label.");
                for(var p = 0, c = s; p < c.length; p += 1){
                    var h = c[p];
                    if ("number" != typeof h && "string" != typeof h) return l.error("Branch labels must be numbers or strings.");
                    if ("number" == typeof h && Math.abs(h) > Number.MAX_SAFE_INTEGER) return l.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
                    if ("number" == typeof h && Math.floor(h) !== h) return l.error("Numeric branch labels must be integer values.");
                    if (r) {
                        if (l.checkSubtype(r, se(h))) return null;
                    } else r = se(h);
                    if (void 0 !== i[String(h)]) return l.error("Branch labels must be unique.");
                    i[String(h)] = a.length;
                }
                var f = e1.parse(u, o, n);
                if (!f) return null;
                n = n || f.type, a.push(f);
            }
            var y = e1.parse(t1[1], 1, Nt);
            if (!y) return null;
            var d = e1.parse(t1[t1.length - 1], t1.length - 1, n);
            return d ? "value" !== y.type.kind && e1.concat(1).checkSubtype(r, y.type) ? null : new hr(r, n, y, i, a, d) : null;
        }, hr.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1);
            return (se(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
        }, hr.prototype.eachChild = function(t1) {
            t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
        }, hr.prototype.outputDefined = function() {
            return this.outputs.every(function(t1) {
                return t1.outputDefined();
            }) && this.otherwise.outputDefined();
        }, hr.prototype.serialize = function() {
            for(var t1 = this, e1 = [
                "match",
                this.input.serialize()
            ], r = [], n = {}, i = 0, a = Object.keys(this.cases).sort(); i < a.length; i += 1){
                var o = a[i];
                void 0 === (c = n[this.cases[o]]) ? (n[this.cases[o]] = r.length, r.push([
                    this.cases[o],
                    [
                        o
                    ]
                ])) : r[c][1].push(o);
            }
            for(var s = function(e1) {
                return "number" === t1.inputType.kind ? Number(e1) : e1;
            }, u = 0, l = r; u < l.length; u += 1){
                var p = l[u], c = p[0], h = p[1];
                e1.push(1 === h.length ? s(h[0]) : h.map(s)), e1.push(this.outputs[outputIndex$1].serialize());
            }
            return e1.push(this.otherwise.serialize()), e1;
        };
        var fr = function(t1, e1, r) {
            this.type = t1, this.branches = e1, this.otherwise = r;
        };
        fr.parse = function(t1, e1) {
            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found only " + (t1.length - 1) + ".");
            if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
            var r;
            e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
            for(var n = [], i = 1; i < t1.length - 1; i += 2){
                var a = e1.parse(t1[i], i, Ut);
                if (!a) return null;
                var o = e1.parse(t1[i + 1], i + 1, r);
                if (!o) return null;
                n.push([
                    a,
                    o
                ]), r = r || o.type;
            }
            var s = e1.parse(t1[t1.length - 1], t1.length - 1, r);
            return s ? new fr(r, n, s) : null;
        }, fr.prototype.evaluate = function(t1) {
            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                var n = r[e1], i = n[1];
                if (n[0].evaluate(t1)) return i.evaluate(t1);
            }
            return this.otherwise.evaluate(t1);
        }, fr.prototype.eachChild = function(t1) {
            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                var n = r[e1], i = n[1];
                t1(n[0]), t1(i);
            }
            t1(this.otherwise);
        }, fr.prototype.outputDefined = function() {
            return this.branches.every(function(t1) {
                return t1[1].outputDefined();
            }) && this.otherwise.outputDefined();
        }, fr.prototype.serialize = function() {
            var t1 = [
                "case"
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var yr = function(t1, e1, r, n) {
            this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
        };
        function dr(t1, e1) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function mr(t1, e1, r, n) {
            return 0 === n.compare(e1, r);
        }
        function vr(t1, e1, r) {
            var n = "==" !== t1 && "!=" !== t1;
            return function() {
                function i(t1, e1, r) {
                    this.type = Ut, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                }
                return i.parse = function(t1, e1) {
                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                    var r = t1[0], a = e1.parse(t1[1], 1, Nt);
                    if (!a) return null;
                    if (!dr(r, a.type)) return e1.concat(1).error('"' + r + "\" comparisons are not supported for type '" + Jt(a.type) + "'.");
                    var o = e1.parse(t1[2], 2, Nt);
                    if (!o) return null;
                    if (!dr(r, o.type)) return e1.concat(2).error('"' + r + "\" comparisons are not supported for type '" + Jt(o.type) + "'.");
                    if (a.type.kind !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot compare types '" + Jt(a.type) + "' and '" + Jt(o.type) + "'.");
                    n && ("value" === a.type.kind && "value" !== o.type.kind ? a = new he(o.type, [
                        a
                    ]) : "value" !== a.type.kind && "value" === o.type.kind && (o = new he(a.type, [
                        o
                    ])));
                    var s = null;
                    if (4 === t1.length) {
                        if ("string" !== a.type.kind && "string" !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                        if (!(s = e1.parse(t1[3], 3, Kt))) return null;
                    }
                    return new i(a, o, s);
                }, i.prototype.evaluate = function(i) {
                    var a = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        var s = se(a), u = se(o);
                        if (s.kind !== u.kind || "string" !== s.kind && "number" !== s.kind) throw new pe('Expected arguments for "' + t1 + '" to be (string, string) or (number, number), but found (' + s.kind + ", " + u.kind + ") instead.");
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        var l = se(a), p = se(o);
                        if ("string" !== l.kind || "string" !== p.kind) return e1(i, a, o);
                    }
                    return this.collator ? r(i, a, o, this.collator.evaluate(i)) : e1(i, a, o);
                }, i.prototype.eachChild = function(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }, i.prototype.outputDefined = function() {
                    return !0;
                }, i.prototype.serialize = function() {
                    var e1 = [
                        t1
                    ];
                    return this.eachChild(function(t1) {
                        e1.push(t1.serialize());
                    }), e1;
                }, i;
            }();
        }
        yr.parse = function(t1, e1) {
            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1, Nt), n = e1.parse(t1[2], 2, Ot);
            if (!r || !n) return null;
            if (!$t(r.type, [
                Xt(Nt),
                Rt,
                Nt
            ])) return e1.error("Expected first argument to be of type array or string, but found " + Jt(r.type) + " instead");
            if (4 === t1.length) {
                var i = e1.parse(t1[3], 3, Ot);
                return i ? new yr(r.type, r, n, i) : null;
            }
            return new yr(r.type, r, n);
        }, yr.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
            if (!Wt(e1, [
                "string",
                "array"
            ])) throw new pe("Expected first argument to be of type array or string, but found " + Jt(se(e1)) + " instead.");
            if (this.endIndex) {
                var n = this.endIndex.evaluate(t1);
                return e1.slice(r, n);
            }
            return e1.slice(r);
        }, yr.prototype.eachChild = function(t1) {
            t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
        }, yr.prototype.outputDefined = function() {
            return !1;
        }, yr.prototype.serialize = function() {
            if (null != this.endIndex && void 0 !== this.endIndex) {
                var t1 = this.endIndex.serialize();
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize(),
                    t1
                ];
            }
            return [
                "slice",
                this.input.serialize(),
                this.beginIndex.serialize()
            ];
        };
        var gr = vr("==", function(t1, e1, r) {
            return e1 === r;
        }, mr), xr = vr("!=", function(t1, e1, r) {
            return e1 !== r;
        }, function(t1, e1, r, n) {
            return !mr(0, e1, r, n);
        }), br = vr("<", function(t1, e1, r) {
            return e1 < r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) < 0;
        }), wr = vr(">", function(t1, e1, r) {
            return e1 > r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) > 0;
        }), _r = vr("<=", function(t1, e1, r) {
            return e1 <= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) <= 0;
        }), Ar = vr(">=", function(t1, e1, r) {
            return e1 >= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) >= 0;
        }), Sr = function(t1, e1, r, n, i) {
            this.type = Rt, this.number = t1, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
        };
        Sr.parse = function(t1, e1) {
            if (3 !== t1.length) return e1.error("Expected two arguments.");
            var r = e1.parse(t1[1], 1, Ot);
            if (!r) return null;
            var n = t1[2];
            if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
            var i = null;
            if (n.locale && !(i = e1.parse(n.locale, 1, Rt))) return null;
            var a = null;
            if (n.currency && !(a = e1.parse(n.currency, 1, Rt))) return null;
            var o = null;
            if (n["min-fraction-digits"] && !(o = e1.parse(n["min-fraction-digits"], 1, Ot))) return null;
            var s = null;
            return n["max-fraction-digits"] && !(s = e1.parse(n["max-fraction-digits"], 1, Ot)) ? null : new Sr(r, i, a, o, s);
        }, Sr.prototype.evaluate = function(t1) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                style: this.currency ? "currency" : "decimal",
                currency: this.currency ? this.currency.evaluate(t1) : void 0,
                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
            }).format(this.number.evaluate(t1));
        }, Sr.prototype.eachChild = function(t1) {
            t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
        }, Sr.prototype.outputDefined = function() {
            return !1;
        }, Sr.prototype.serialize = function() {
            var t1 = {};
            return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                "number-format",
                this.number.serialize(),
                t1
            ];
        };
        var kr = function(t1) {
            this.type = Ot, this.input = t1;
        };
        kr.parse = function(t1, e1) {
            if (2 !== t1.length) return e1.error("Expected 1 argument, but found " + (t1.length - 1) + " instead.");
            var r = e1.parse(t1[1], 1);
            return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error("Expected argument of type string or array, but found " + Jt(r.type) + " instead.") : new kr(r) : null;
        }, kr.prototype.evaluate = function(t1) {
            var e1 = this.input.evaluate(t1);
            if ("string" == typeof e1) return e1.length;
            if (Array.isArray(e1)) return e1.length;
            throw new pe("Expected value to be of type string or array, but found " + Jt(se(e1)) + " instead.");
        }, kr.prototype.eachChild = function(t1) {
            t1(this.input);
        }, kr.prototype.outputDefined = function() {
            return !1;
        }, kr.prototype.serialize = function() {
            var t1 = [
                "length"
            ];
            return this.eachChild(function(e1) {
                t1.push(e1.serialize());
            }), t1;
        };
        var Ir = {
            "==": gr,
            "!=": xr,
            ">": wr,
            "<": br,
            ">=": Ar,
            "<=": _r,
            array: he,
            at: lr,
            boolean: he,
            case: fr,
            coalesce: sr,
            collator: be,
            format: fe,
            image: ye,
            in: pr,
            "index-of": cr,
            interpolate: ar,
            "interpolate-hcl": ar,
            "interpolate-lab": ar,
            length: kr,
            let: ur,
            literal: le,
            match: hr,
            number: he,
            "number-format": Sr,
            object: he,
            slice: yr,
            step: Ne,
            string: he,
            "to-boolean": me,
            "to-color": me,
            "to-number": me,
            "to-string": me,
            var: Ue,
            within: De
        };
        function zr(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = e1[3];
            r = r.evaluate(t1), n = n.evaluate(t1), i = i.evaluate(t1);
            var o = a ? a.evaluate(t1) : 1, s = ae(r, n, i, o);
            if (s) throw new pe(s);
            return new te(r / 255 * o, n / 255 * o, i / 255 * o, o);
        }
        function Cr(t1, e1) {
            return t1 in e1;
        }
        function Er(t1, e1) {
            var r = e1[t1];
            return void 0 === r ? null : r;
        }
        function Pr(t1) {
            return {
                type: t1
            };
        }
        function Mr(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function Br(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function Tr(t1) {
            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
        }
        function Vr(t1) {
            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
        }
        function Fr(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function Dr(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        function Lr(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function Or(t1) {
            return t1;
        }
        function Rr(t1, e1, r) {
            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
        }
        function Ur(t1, e1, r, n, i) {
            return Rr(typeof r === i ? n[r] : void 0, t1.default, e1.default);
        }
        function jr(t1, e1, r) {
            if ("number" !== Dr(r)) return Rr(t1.default, e1.default);
            var n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            var i = qe(t1.stops.map(function(t1) {
                return t1[0];
            }), r);
            return t1.stops[i][1];
        }
        function qr(t1, e1, r) {
            var n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== Dr(r)) return Rr(t1.default, e1.default);
            var i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            var a = qe(t1.stops.map(function(t1) {
                return t1[0];
            }), r), o = function(t1, e1, r, n) {
                var i = n - r, a = t1 - r;
                return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), s = t1.stops[a][1], u = t1.stops[a + 1][1], l = Ge[e1.type] || Or;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                var p = ir[t1.colorSpace];
                l = function(t1, e1) {
                    return p.reverse(p.interpolate(p.forward(t1), p.forward(e1), o));
                };
            }
            return "function" == typeof s.evaluate ? {
                evaluate: function() {
                    for(var t1 = [], e1 = arguments.length; e1--;)t1[e1] = arguments[e1];
                    var r = s.evaluate.apply(void 0, t1), n = u.evaluate.apply(void 0, t1);
                    if (void 0 !== r && void 0 !== n) return l(r, n, o);
                }
            } : l(s, u, o);
        }
        function Nr(t1, e1, r) {
            return "color" === e1.type ? r = te.parse(r) : "formatted" === e1.type ? r = ne.fromString(r.toString()) : "resolvedImage" === e1.type ? r = ie.fromString(r.toString()) : Dr(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0), Rr(r, t1.default, e1.default);
        }
        xe.register(Ir, {
            error: [
                {
                    kind: "error"
                },
                [
                    Rt
                ],
                function(t1, e1) {
                    throw new pe(e1[0].evaluate(t1));
                }
            ],
            typeof: [
                Rt,
                [
                    Nt
                ],
                function(t1, e1) {
                    return Jt(se(e1[0].evaluate(t1)));
                }
            ],
            "to-rgba": [
                Xt(Ot, 4),
                [
                    jt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).toArray();
                }
            ],
            rgb: [
                jt,
                [
                    Ot,
                    Ot,
                    Ot
                ],
                zr
            ],
            rgba: [
                jt,
                [
                    Ot,
                    Ot,
                    Ot,
                    Ot
                ],
                zr
            ],
            has: {
                type: Ut,
                overloads: [
                    [
                        [
                            Rt
                        ],
                        function(t1, e1) {
                            return Cr(e1[0].evaluate(t1), t1.properties());
                        }
                    ],
                    [
                        [
                            Rt,
                            qt
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return Cr(e1[0].evaluate(t1), r.evaluate(t1));
                        }
                    ]
                ]
            },
            get: {
                type: Nt,
                overloads: [
                    [
                        [
                            Rt
                        ],
                        function(t1, e1) {
                            return Er(e1[0].evaluate(t1), t1.properties());
                        }
                    ],
                    [
                        [
                            Rt,
                            qt
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return Er(e1[0].evaluate(t1), r.evaluate(t1));
                        }
                    ]
                ]
            },
            "feature-state": [
                Nt,
                [
                    Rt
                ],
                function(t1, e1) {
                    return Er(e1[0].evaluate(t1), t1.featureState || {});
                }
            ],
            properties: [
                qt,
                [],
                function(t1) {
                    return t1.properties();
                }
            ],
            "geometry-type": [
                Rt,
                [],
                function(t1) {
                    return t1.geometryType();
                }
            ],
            id: [
                Nt,
                [],
                function(t1) {
                    return t1.id();
                }
            ],
            zoom: [
                Ot,
                [],
                function(t1) {
                    return t1.globals.zoom;
                }
            ],
            "heatmap-density": [
                Ot,
                [],
                function(t1) {
                    return t1.globals.heatmapDensity || 0;
                }
            ],
            "line-progress": [
                Ot,
                [],
                function(t1) {
                    return t1.globals.lineProgress || 0;
                }
            ],
            accumulated: [
                Nt,
                [],
                function(t1) {
                    return void 0 === t1.globals.accumulated ? null : t1.globals.accumulated;
                }
            ],
            "+": [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    for(var r = 0, n = 0, i = e1; n < i.length; n += 1)r += i[n].evaluate(t1);
                    return r;
                }
            ],
            "*": [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    for(var r = 1, n = 0, i = e1; n < i.length; n += 1)r *= i[n].evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: Ot,
                overloads: [
                    [
                        [
                            Ot,
                            Ot
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return e1[0].evaluate(t1) - r.evaluate(t1);
                        }
                    ],
                    [
                        [
                            Ot
                        ],
                        function(t1, e1) {
                            return -e1[0].evaluate(t1);
                        }
                    ]
                ]
            },
            "/": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[1];
                    return e1[0].evaluate(t1) / r.evaluate(t1);
                }
            ],
            "%": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[1];
                    return e1[0].evaluate(t1) % r.evaluate(t1);
                }
            ],
            ln2: [
                Ot,
                [],
                function() {
                    return Math.LN2;
                }
            ],
            pi: [
                Ot,
                [],
                function() {
                    return Math.PI;
                }
            ],
            e: [
                Ot,
                [],
                function() {
                    return Math.E;
                }
            ],
            "^": [
                Ot,
                [
                    Ot,
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[1];
                    return Math.pow(e1[0].evaluate(t1), r.evaluate(t1));
                }
            ],
            sqrt: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.sqrt(e1[0].evaluate(t1));
                }
            ],
            log10: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.log(e1[0].evaluate(t1)) / Math.LN10;
                }
            ],
            ln: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.log(e1[0].evaluate(t1));
                }
            ],
            log2: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.log(e1[0].evaluate(t1)) / Math.LN2;
                }
            ],
            sin: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.sin(e1[0].evaluate(t1));
                }
            ],
            cos: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.cos(e1[0].evaluate(t1));
                }
            ],
            tan: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.tan(e1[0].evaluate(t1));
                }
            ],
            asin: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.asin(e1[0].evaluate(t1));
                }
            ],
            acos: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.acos(e1[0].evaluate(t1));
                }
            ],
            atan: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.atan(e1[0].evaluate(t1));
                }
            ],
            min: [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    return Math.min.apply(Math, e1.map(function(e1) {
                        return e1.evaluate(t1);
                    }));
                }
            ],
            max: [
                Ot,
                Pr(Ot),
                function(t1, e1) {
                    return Math.max.apply(Math, e1.map(function(e1) {
                        return e1.evaluate(t1);
                    }));
                }
            ],
            abs: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.abs(e1[0].evaluate(t1));
                }
            ],
            round: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    var r = e1[0].evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.floor(e1[0].evaluate(t1));
                }
            ],
            ceil: [
                Ot,
                [
                    Ot
                ],
                function(t1, e1) {
                    return Math.ceil(e1[0].evaluate(t1));
                }
            ],
            "filter-==": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1];
                    return t1.properties()[r.value] === n.value;
                }
            ],
            "filter-id-==": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0];
                    return t1.id() === r.value;
                }
            ],
            "filter-type-==": [
                Ut,
                [
                    Rt
                ],
                function(t1, e1) {
                    var r = e1[0];
                    return t1.geometryType() === r.value;
                }
            ],
            "filter-<": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i < a;
                }
            ],
            "filter-id-<": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter->": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i > a;
                }
            ],
            "filter-id->": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-<=": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i <= a;
                }
            ],
            "filter-id-<=": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter->=": [
                Ut,
                [
                    Rt,
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                    return typeof i == typeof a && i >= a;
                }
            ],
            "filter-id->=": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    var r = e1[0], n = t1.id(), i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-has": [
                Ut,
                [
                    Nt
                ],
                function(t1, e1) {
                    return e1[0].value in t1.properties();
                }
            ],
            "filter-has-id": [
                Ut,
                [],
                function(t1) {
                    return null !== t1.id() && void 0 !== t1.id();
                }
            ],
            "filter-type-in": [
                Ut,
                [
                    Xt(Rt)
                ],
                function(t1, e1) {
                    return e1[0].value.indexOf(t1.geometryType()) >= 0;
                }
            ],
            "filter-id-in": [
                Ut,
                [
                    Xt(Nt)
                ],
                function(t1, e1) {
                    return e1[0].value.indexOf(t1.id()) >= 0;
                }
            ],
            "filter-in-small": [
                Ut,
                [
                    Rt,
                    Xt(Nt)
                ],
                function(t1, e1) {
                    var r = e1[0];
                    return e1[1].value.indexOf(t1.properties()[r.value]) >= 0;
                }
            ],
            "filter-in-large": [
                Ut,
                [
                    Rt,
                    Xt(Nt)
                ],
                function(t1, e1) {
                    var r = e1[0], n = e1[1];
                    return function(t1, e1, r, n) {
                        for(; r <= n;){
                            var i = r + n >> 1;
                            if (e1[i] === t1) return !0;
                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    }(t1.properties()[r.value], n.value, 0, n.value.length - 1);
                }
            ],
            all: {
                type: Ut,
                overloads: [
                    [
                        [
                            Ut,
                            Ut
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return e1[0].evaluate(t1) && r.evaluate(t1);
                        }
                    ],
                    [
                        Pr(Ut),
                        function(t1, e1) {
                            for(var r = 0, n = e1; r < n.length; r += 1)if (!n[r].evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Ut,
                overloads: [
                    [
                        [
                            Ut,
                            Ut
                        ],
                        function(t1, e1) {
                            var r = e1[1];
                            return e1[0].evaluate(t1) || r.evaluate(t1);
                        }
                    ],
                    [
                        Pr(Ut),
                        function(t1, e1) {
                            for(var r = 0, n = e1; r < n.length; r += 1)if (n[r].evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Ut,
                [
                    Ut
                ],
                function(t1, e1) {
                    return !e1[0].evaluate(t1);
                }
            ],
            "is-supported-script": [
                Ut,
                [
                    Rt
                ],
                function(t1, e1) {
                    var r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e1[0].evaluate(t1));
                }
            ],
            upcase: [
                Rt,
                [
                    Rt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).toUpperCase();
                }
            ],
            downcase: [
                Rt,
                [
                    Rt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).toLowerCase();
                }
            ],
            concat: [
                Rt,
                Pr(Nt),
                function(t1, e1) {
                    return e1.map(function(e1) {
                        return ue(e1.evaluate(t1));
                    }).join("");
                }
            ],
            "resolved-locale": [
                Rt,
                [
                    Kt
                ],
                function(t1, e1) {
                    return e1[0].evaluate(t1).resolvedLocale();
                }
            ]
        });
        var Kr = function(t1, e1) {
            this.expression = t1, this._warningHistory = {}, this._evaluator = new ge, this._defaultValue = e1 ? function(t1) {
                return "color" === t1.type && Lr(t1.default) ? new te(0, 0, 0, 0) : "color" === t1.type ? te.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
            }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
        };
        function Gr(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in Ir;
        }
        function Zr(t1, e1) {
            var r = new je(Ir, [], e1 ? function(t1) {
                var e1 = {
                    color: jt,
                    string: Rt,
                    number: Ot,
                    enum: Rt,
                    boolean: Ut,
                    formatted: Gt,
                    resolvedImage: Zt
                };
                return "array" === t1.type ? Xt(e1[t1.value] || Nt, t1.length) : e1[t1.type];
            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? Mr(new Kr(n, e1)) : Br(r.errors);
        }
        Kr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
            return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
        }, Kr.prototype.evaluate = function(t1, e1, r, n, i, a) {
            this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
            try {
                var o = this.expression.evaluate(this._evaluator);
                if (null == o || "number" == typeof o && o != o) return this._defaultValue;
                if (this._enumValues && !(o in this._enumValues)) throw new pe("Expected value to be one of " + Object.keys(this._enumValues).map(function(t1) {
                    return JSON.stringify(t1);
                }).join(", ") + ", but found " + JSON.stringify(o) + " instead.");
                return o;
            } catch (t1) {
                return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
            }
        };
        var Xr = function(t1, e1) {
            this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !Oe(e1.expression);
        };
        Xr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
        }, Xr.prototype.evaluate = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
        };
        var Jr = function(t1, e1, r, n) {
            this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !Oe(e1.expression), this.interpolationType = n;
        };
        function Hr(t1, e1) {
            if ("error" === (t1 = Zr(t1, e1)).result) return t1;
            var r = t1.value.expression, n = Le(r);
            if (!n && !Tr(e1)) return Br([
                new Ft("", "data expressions not supported")
            ]);
            var i = Re(r, [
                "zoom"
            ]);
            if (!i && !Vr(e1)) return Br([
                new Ft("", "zoom expressions not supported")
            ]);
            var a = function t1(e1) {
                var r = null;
                if (e1 instanceof ur) r = t1(e1.result);
                else if (e1 instanceof sr) for(var n = 0, i = e1.args; n < i.length && !(r = t1(i[n])); n += 1);
                else (e1 instanceof Ne || e1 instanceof ar) && e1.input instanceof xe && "zoom" === e1.input.name && (r = e1);
                return r instanceof Ft || e1.eachChild(function(e1) {
                    var n = t1(e1);
                    n instanceof Ft ? r = n : !r && n ? r = new Ft("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : r && n && r !== n && (r = new Ft("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                }), r;
            }(r);
            return a || i ? a instanceof Ft ? Br([
                a
            ]) : a instanceof ar && !Fr(e1) ? Br([
                new Ft("", '"interpolate" expressions cannot be used with this property')
            ]) : Mr(a ? new Jr(n ? "camera" : "composite", t1.value, a.labels, a instanceof ar ? a.interpolation : void 0) : new Xr(n ? "constant" : "source", t1.value)) : Br([
                new Ft("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        Jr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
        }, Jr.prototype.evaluate = function(t1, e1, r, n, i, a) {
            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
        }, Jr.prototype.interpolationFactor = function(t1, e1, r) {
            return this.interpolationType ? ar.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
        };
        var Yr = function(t1, e1) {
            this._parameters = t1, this._specification = e1, Bt(this, function t1(e1, r) {
                var n, i, a, o = "color" === r.type, s = e1.stops && "object" == typeof e1.stops[0][0], u = s || !(s || void 0 !== e1.property), l = e1.type || (Fr(r) ? "exponential" : "interval");
                if (o && ((e1 = Bt({}, e1)).stops && (e1.stops = e1.stops.map(function(t1) {
                    return [
                        t1[0],
                        te.parse(t1[1])
                    ];
                })), e1.default = te.parse(e1.default ? e1.default : r.default)), e1.colorSpace && "rgb" !== e1.colorSpace && !ir[e1.colorSpace]) throw new Error("Unknown color space: " + e1.colorSpace);
                if ("exponential" === l) n = qr;
                else if ("interval" === l) n = jr;
                else if ("categorical" === l) {
                    n = Ur, i = Object.create(null);
                    for(var p = 0, c = e1.stops; p < c.length; p += 1){
                        var h = c[p];
                        i[h[0]] = h[1];
                    }
                    a = typeof e1.stops[0][0];
                } else {
                    if ("identity" !== l) throw new Error('Unknown function type "' + l + '"');
                    n = Nr;
                }
                if (s) {
                    for(var f = {}, y = [], d = 0; d < e1.stops.length; d++){
                        var m = e1.stops[d], v = m[0].zoom;
                        void 0 === f[v] && (f[v] = {
                            zoom: v,
                            type: e1.type,
                            property: e1.property,
                            default: e1.default,
                            stops: []
                        }, y.push(v)), f[v].stops.push([
                            m[0].value,
                            m[1]
                        ]);
                    }
                    for(var g = [], x = 0, b = y; x < b.length; x += 1){
                        var w = b[x];
                        g.push([
                            f[w].zoom,
                            t1(f[w], r)
                        ]);
                    }
                    var _ = {
                        name: "linear"
                    };
                    return {
                        kind: "composite",
                        interpolationType: _,
                        interpolationFactor: ar.interpolationFactor.bind(void 0, _),
                        zoomStops: g.map(function(t1) {
                            return t1[0];
                        }),
                        evaluate: function(t1, n) {
                            var i = t1.zoom;
                            return qr({
                                stops: g,
                                base: e1.base
                            }, r, i).evaluate(i, n);
                        }
                    };
                }
                if (u) {
                    var A = "exponential" === l ? {
                        name: "exponential",
                        base: void 0 !== e1.base ? e1.base : 1
                    } : null;
                    return {
                        kind: "camera",
                        interpolationType: A,
                        interpolationFactor: ar.interpolationFactor.bind(void 0, A),
                        zoomStops: e1.stops.map(function(t1) {
                            return t1[0];
                        }),
                        evaluate: function(t1) {
                            return n(e1, r, t1.zoom, i, a);
                        }
                    };
                }
                return {
                    kind: "source",
                    evaluate: function(t1, o) {
                        var s = o && o.properties ? o.properties[e1.property] : void 0;
                        return void 0 === s ? Rr(e1.default, r.default) : n(e1, r, s, i, a);
                    }
                };
            }(this._parameters, this._specification));
        };
        function $r(t1) {
            var e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, a = t1.style, o = t1.styleSpec, s = [], u = Dr(r);
            if ("object" !== u) return [
                new Pt(e1, r, "object expected, " + u + " found")
            ];
            for(var l in r){
                var p = l.split(".")[0], c = n[p] || n["*"], h = void 0;
                if (i[p]) h = i[p];
                else if (n[p]) h = An;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        s.push(new Pt(e1, r[l], 'unknown property "' + l + '"'));
                        continue;
                    }
                    h = An;
                }
                s = s.concat(h({
                    key: (e1 ? e1 + "." : e1) + l,
                    value: r[l],
                    valueSpec: c,
                    style: a,
                    styleSpec: o,
                    object: r,
                    objectKey: l
                }, r));
            }
            for(var f in n)i[f] || n[f].required && void 0 === n[f].default && void 0 === r[f] && s.push(new Pt(e1, r, 'missing required property "' + f + '"'));
            return s;
        }
        function Wr(t1) {
            var e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, a = t1.key, o = t1.arrayElementValidator || An;
            if ("array" !== Dr(e1)) return [
                new Pt(a, e1, "array expected, " + Dr(e1) + " found")
            ];
            if (r.length && e1.length !== r.length) return [
                new Pt(a, e1, "array length " + r.length + " expected, length " + e1.length + " found")
            ];
            if (r["min-length"] && e1.length < r["min-length"]) return [
                new Pt(a, e1, "array length at least " + r["min-length"] + " expected, length " + e1.length + " found")
            ];
            var s = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (s.function = r.function), "object" === Dr(r.value) && (s = r.value);
            for(var u = [], l = 0; l < e1.length; l++)u = u.concat(o({
                array: e1,
                arrayIndex: l,
                value: e1[l],
                valueSpec: s,
                style: n,
                styleSpec: i,
                key: a + "[" + l + "]"
            }));
            return u;
        }
        function Qr(t1) {
            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = Dr(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new Pt(e1, r, "number expected, " + i + " found")
            ] : "minimum" in n && r < n.minimum ? [
                new Pt(e1, r, r + " is less than the minimum value " + n.minimum)
            ] : "maximum" in n && r > n.maximum ? [
                new Pt(e1, r, r + " is greater than the maximum value " + n.maximum)
            ] : [];
        }
        function tn(t1) {
            var e1, r, n, i = t1.valueSpec, a = Tt(t1.value.type), o = {}, s = "categorical" !== a && void 0 === t1.value.property, u = !s, l = "array" === Dr(t1.value.stops) && "array" === Dr(t1.value.stops[0]) && "object" === Dr(t1.value.stops[0][0]), p = $r({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === a) return [
                            new Pt(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        var e1 = [], r = t1.value;
                        return e1 = e1.concat(Wr({
                            key: t1.key,
                            value: r,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: c
                        })), "array" === Dr(r) && 0 === r.length && e1.push(new Pt(t1.key, r, "array must have at least one stop")), e1;
                    },
                    default: function(t1) {
                        return An({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: i,
                            style: t1.style,
                            styleSpec: t1.styleSpec
                        });
                    }
                }
            });
            return "identity" === a && s && p.push(new Pt(t1.key, t1.value, 'missing required property "property"')), "identity" === a || t1.value.stops || p.push(new Pt(t1.key, t1.value, 'missing required property "stops"')), "exponential" === a && t1.valueSpec.expression && !Fr(t1.valueSpec) && p.push(new Pt(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (u && !Tr(t1.valueSpec) ? p.push(new Pt(t1.key, t1.value, "property functions not supported")) : s && !Vr(t1.valueSpec) && p.push(new Pt(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== a && !l || void 0 !== t1.value.property || p.push(new Pt(t1.key, t1.value, '"property" property is required')), p;
            function c(t1) {
                var e1 = [], a = t1.value, s = t1.key;
                if ("array" !== Dr(a)) return [
                    new Pt(s, a, "array expected, " + Dr(a) + " found")
                ];
                if (2 !== a.length) return [
                    new Pt(s, a, "array length 2 expected, length " + a.length + " found")
                ];
                if (l) {
                    if ("object" !== Dr(a[0])) return [
                        new Pt(s, a, "object expected, " + Dr(a[0]) + " found")
                    ];
                    if (void 0 === a[0].zoom) return [
                        new Pt(s, a, "object stop key must have zoom")
                    ];
                    if (void 0 === a[0].value) return [
                        new Pt(s, a, "object stop key must have value")
                    ];
                    if (n && n > Tt(a[0].zoom)) return [
                        new Pt(s, a[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    Tt(a[0].zoom) !== n && (n = Tt(a[0].zoom), r = void 0, o = {}), e1 = e1.concat($r({
                        key: s + "[0]",
                        value: a[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: Qr,
                            value: h
                        }
                    }));
                } else e1 = e1.concat(h({
                    key: s + "[0]",
                    value: a[0],
                    valueSpec: {},
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, a));
                return Gr(Vt(a[1])) ? e1.concat([
                    new Pt(s + "[1]", a[1], "expressions are not allowed in function stops.")
                ]) : e1.concat(An({
                    key: s + "[1]",
                    value: a[1],
                    valueSpec: i,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function h(t1, n) {
                var s = Dr(t1.value), u = Tt(t1.value), l = null !== t1.value ? t1.value : n;
                if (e1) {
                    if (s !== e1) return [
                        new Pt(t1.key, l, s + " stop domain type must match previous stop domain type " + e1)
                    ];
                } else e1 = s;
                if ("number" !== s && "string" !== s && "boolean" !== s) return [
                    new Pt(t1.key, l, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== s && "categorical" !== a) {
                    var p = "number expected, " + s + " found";
                    return Tr(i) && void 0 === a && (p += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Pt(t1.key, l, p)
                    ];
                }
                return "categorical" !== a || "number" !== s || isFinite(u) && Math.floor(u) === u ? "categorical" !== a && "number" === s && void 0 !== r && u < r ? [
                    new Pt(t1.key, l, "stop domain values must appear in ascending order")
                ] : (r = u, "categorical" === a && u in o ? [
                    new Pt(t1.key, l, "stop domain values must be unique")
                ] : (o[u] = !0, [])) : [
                    new Pt(t1.key, l, "integer expected, found " + u)
                ];
            }
        }
        function en(t1) {
            var e1 = ("property" === t1.expressionContext ? Hr : Zr)(Vt(t1.value), t1.valueSpec);
            if ("error" === e1.result) return e1.value.map(function(e1) {
                return new Pt("" + t1.key + e1.key, t1.value, e1.message);
            });
            var r = e1.value.expression || e1.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                new Pt(t1.key, t1.value, 'Invalid data expression for "' + t1.propertyKey + '". Output values must be contained as literals within the expression.')
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !Oe(r)) return [
                new Pt(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext && !Oe(r)) return [
                new Pt(t1.key, t1.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!Re(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Pt(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !Le(r)) return [
                    new Pt(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function rn(t1) {
            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(Tt(r)) && i.push(new Pt(e1, r, "expected one of [" + n.values.join(", ") + "], " + JSON.stringify(r) + " found")) : -1 === Object.keys(n.values).indexOf(Tt(r)) && i.push(new Pt(e1, r, "expected one of [" + Object.keys(n.values).join(", ") + "], " + JSON.stringify(r) + " found")), i;
        }
        function nn(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for(var e1 = 0, r = t1.slice(1); e1 < r.length; e1 += 1){
                        var n = r[e1];
                        if (!nn(n) && "boolean" != typeof n) return !1;
                    }
                    return !0;
                default:
                    return !0;
            }
        }
        Yr.deserialize = function(t1) {
            return new Yr(t1._parameters, t1._specification);
        }, Yr.serialize = function(t1) {
            return {
                _parameters: t1._parameters,
                _specification: t1._specification
            };
        };
        var an = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function on(t1) {
            if (null == t1) return {
                filter: function() {
                    return !0;
                },
                needGeometry: !1
            };
            nn(t1) || (t1 = un(t1));
            var e1 = Zr(t1, an);
            if ("error" === e1.result) throw new Error(e1.value.map(function(t1) {
                return t1.key + ": " + t1.message;
            }).join(", "));
            return {
                filter: function(t1, r, n) {
                    return e1.value.evaluate(t1, r, {}, n);
                },
                needGeometry: function t1(e1) {
                    if (!Array.isArray(e1)) return !1;
                    if ("within" === e1[0]) return !0;
                    for(var r = 1; r < e1.length; r++)if (t1(e1[r])) return !0;
                    return !1;
                }(t1)
            };
        }
        function sn(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function un(t1) {
            if (!t1) return !0;
            var e1, r = t1[0];
            return t1.length <= 1 ? "any" !== r : "==" === r ? ln(t1[1], t1[2], "==") : "!=" === r ? hn(ln(t1[1], t1[2], "==")) : "<" === r || ">" === r || "<=" === r || ">=" === r ? ln(t1[1], t1[2], r) : "any" === r ? (e1 = t1.slice(1), [
                "any"
            ].concat(e1.map(un))) : "all" === r ? [
                "all"
            ].concat(t1.slice(1).map(un)) : "none" === r ? [
                "all"
            ].concat(t1.slice(1).map(un).map(hn)) : "in" === r ? pn(t1[1], t1.slice(2)) : "!in" === r ? hn(pn(t1[1], t1.slice(2))) : "has" === r ? cn(t1[1]) : "!has" === r ? hn(cn(t1[1])) : "within" !== r || t1;
        }
        function ln(t1, e1, r) {
            switch(t1){
                case "$type":
                    return [
                        "filter-type-" + r,
                        e1
                    ];
                case "$id":
                    return [
                        "filter-id-" + r,
                        e1
                    ];
                default:
                    return [
                        "filter-" + r,
                        t1,
                        e1
                    ];
            }
        }
        function pn(t1, e1) {
            if (0 === e1.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some(function(t1) {
                        return typeof t1 != typeof e1[0];
                    }) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e1.sort(sn)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function cn(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function hn(t1) {
            return [
                "!",
                t1
            ];
        }
        function fn(t1) {
            return nn(Vt(t1.value)) ? en(Bt({}, t1, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : function t1(e1) {
                var r = e1.value, n = e1.key;
                if ("array" !== Dr(r)) return [
                    new Pt(n, r, "array expected, " + Dr(r) + " found")
                ];
                var i, a = e1.styleSpec, o = [];
                if (r.length < 1) return [
                    new Pt(n, r, "filter array must have at least 1 element")
                ];
                switch(o = o.concat(rn({
                    key: n + "[0]",
                    value: r[0],
                    valueSpec: a.filter_operator,
                    style: e1.style,
                    styleSpec: e1.styleSpec
                })), Tt(r[0])){
                    case "<":
                    case "<=":
                    case ">":
                    case ">=":
                        r.length >= 2 && "$type" === Tt(r[1]) && o.push(new Pt(n, r, '"$type" cannot be use with operator "' + r[0] + '"'));
                    case "==":
                    case "!=":
                        3 !== r.length && o.push(new Pt(n, r, 'filter array for operator "' + r[0] + '" must have 3 elements'));
                    case "in":
                    case "!in":
                        r.length >= 2 && "string" !== (i = Dr(r[1])) && o.push(new Pt(n + "[1]", r[1], "string expected, " + i + " found"));
                        for(var s = 2; s < r.length; s++)i = Dr(r[s]), "$type" === Tt(r[1]) ? o = o.concat(rn({
                            key: n + "[" + s + "]",
                            value: r[s],
                            valueSpec: a.geometry_type,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        })) : "string" !== i && "number" !== i && "boolean" !== i && o.push(new Pt(n + "[" + s + "]", r[s], "string, number, or boolean expected, " + i + " found"));
                        break;
                    case "any":
                    case "all":
                    case "none":
                        for(var u = 1; u < r.length; u++)o = o.concat(t1({
                            key: n + "[" + u + "]",
                            value: r[u],
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        }));
                        break;
                    case "has":
                    case "!has":
                        i = Dr(r[1]), 2 !== r.length ? o.push(new Pt(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "string" !== i && o.push(new Pt(n + "[1]", r[1], "string expected, " + i + " found"));
                        break;
                    case "within":
                        i = Dr(r[1]), 2 !== r.length ? o.push(new Pt(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "object" !== i && o.push(new Pt(n + "[1]", r[1], "object expected, " + i + " found"));
                }
                return o;
            }(t1);
        }
        function yn(t1, e1) {
            var r = t1.key, n = t1.style, i = t1.styleSpec, a = t1.value, o = t1.objectKey, s = i[e1 + "_" + t1.layerType];
            if (!s) return [];
            var u = o.match(/^(.*)-transition$/);
            if ("paint" === e1 && u && s[u[1]] && s[u[1]].transition) return An({
                key: r,
                value: a,
                valueSpec: i.transition,
                style: n,
                styleSpec: i
            });
            var l, p = t1.valueSpec || s[o];
            if (!p) return [
                new Pt(r, a, 'unknown property "' + o + '"')
            ];
            if ("string" === Dr(a) && Tr(p) && !p.tokens && (l = /^{([^}]+)}$/.exec(a))) return [
                new Pt(r, a, '"' + o + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(l[1]) + " }`.")
            ];
            var c = [];
            return "symbol" === t1.layerType && ("text-field" === o && n && !n.glyphs && c.push(new Pt(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && Lr(Vt(a)) && "identity" === Tt(a.type) && c.push(new Pt(r, a, '"text-font" does not support identity functions'))), c.concat(An({
                key: t1.key,
                value: a,
                valueSpec: p,
                style: n,
                styleSpec: i,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: o
            }));
        }
        function dn(t1) {
            return yn(t1, "paint");
        }
        function mn(t1) {
            return yn(t1, "layout");
        }
        function vn(t1) {
            var e1 = [], r = t1.value, n = t1.key, i = t1.style, a = t1.styleSpec;
            r.type || r.ref || e1.push(new Pt(n, r, 'either "type" or "ref" is required'));
            var o, s = Tt(r.type), u = Tt(r.ref);
            if (r.id) for(var l = Tt(r.id), p = 0; p < t1.arrayIndex; p++){
                var c = i.layers[p];
                Tt(c.id) === l && e1.push(new Pt(n, r.id, 'duplicate layer id "' + r.id + '", previously used at line ' + c.id.__line__));
            }
            if ("ref" in r) [
                "type",
                "source",
                "source-layer",
                "filter",
                "layout"
            ].forEach(function(t1) {
                t1 in r && e1.push(new Pt(n, r[t1], '"' + t1 + '" is prohibited for ref layers'));
            }), i.layers.forEach(function(t1) {
                Tt(t1.id) === u && (o = t1);
            }), o ? o.ref ? e1.push(new Pt(n, r.ref, "ref cannot reference another ref layer")) : s = Tt(o.type) : e1.push(new Pt(n, r.ref, 'ref layer "' + u + '" not found'));
            else if ("background" !== s) {
                if (r.source) {
                    var h = i.sources && i.sources[r.source], f = h && Tt(h.type);
                    h ? "vector" === f && "raster" === s ? e1.push(new Pt(n, r.source, 'layer "' + r.id + '" requires a raster source')) : "raster" === f && "raster" !== s ? e1.push(new Pt(n, r.source, 'layer "' + r.id + '" requires a vector source')) : "vector" !== f || r["source-layer"] ? "raster-dem" === f && "hillshade" !== s ? e1.push(new Pt(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === f && h.lineMetrics || e1.push(new Pt(n, r, 'layer "' + r.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')) : e1.push(new Pt(n, r, 'layer "' + r.id + '" must specify a "source-layer"')) : e1.push(new Pt(n, r.source, 'source "' + r.source + '" not found'));
                } else e1.push(new Pt(n, r, 'missing required property "source"'));
            }
            return e1 = e1.concat($r({
                key: n,
                value: r,
                valueSpec: a.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": function() {
                        return [];
                    },
                    type: function() {
                        return An({
                            key: n + ".type",
                            value: r.type,
                            valueSpec: a.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: r,
                            objectKey: "type"
                        });
                    },
                    filter: fn,
                    layout: function(t1) {
                        return $r({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": function(t1) {
                                    return mn(Bt({
                                        layerType: s
                                    }, t1));
                                }
                            }
                        });
                    },
                    paint: function(t1) {
                        return $r({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": function(t1) {
                                    return dn(Bt({
                                        layerType: s
                                    }, t1));
                                }
                            }
                        });
                    }
                }
            }));
        }
        function gn(t1) {
            var e1 = t1.value, r = t1.key, n = Dr(e1);
            return "string" !== n ? [
                new Pt(r, e1, "string expected, " + n + " found")
            ] : [];
        }
        var xn = {
            promoteId: function(t1) {
                var e1 = t1.key, r = t1.value;
                if ("string" === Dr(r)) return gn({
                    key: e1,
                    value: r
                });
                var n = [];
                for(var i in r)n.push.apply(n, gn({
                    key: e1 + "." + i,
                    value: r[i]
                }));
                return n;
            }
        };
        function bn(t1) {
            var e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style;
            if (!e1.type) return [
                new Pt(r, e1, '"type" is required')
            ];
            var a, o = Tt(e1.type);
            switch(o){
                case "vector":
                case "raster":
                case "raster-dem":
                    return $r({
                        key: r,
                        value: e1,
                        valueSpec: n["source_" + o.replace("-", "_")],
                        style: t1.style,
                        styleSpec: n,
                        objectElementValidators: xn
                    });
                case "geojson":
                    if (a = $r({
                        key: r,
                        value: e1,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        objectElementValidators: xn
                    }), e1.cluster) for(var s in e1.clusterProperties){
                        var u = e1.clusterProperties[s], l = u[0], p = "string" == typeof l ? [
                            l,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                s
                            ]
                        ] : l;
                        a.push.apply(a, en({
                            key: r + "." + s + ".map",
                            value: u[1],
                            expressionContext: "cluster-map"
                        })), a.push.apply(a, en({
                            key: r + "." + s + ".reduce",
                            value: p,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return a;
                case "video":
                    return $r({
                        key: r,
                        value: e1,
                        valueSpec: n.source_video,
                        style: i,
                        styleSpec: n
                    });
                case "image":
                    return $r({
                        key: r,
                        value: e1,
                        valueSpec: n.source_image,
                        style: i,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new Pt(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return rn({
                        key: r + ".type",
                        value: e1.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        styleSpec: n
                    });
            }
        }
        function wn(t1) {
            var e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style, a = [], o = Dr(e1);
            if (void 0 === e1) return a;
            if ("object" !== o) return a.concat([
                new Pt("light", e1, "object expected, " + o + " found")
            ]);
            for(var s in e1){
                var u = s.match(/^(.*)-transition$/);
                a = a.concat(u && n[u[1]] && n[u[1]].transition ? An({
                    key: s,
                    value: e1[s],
                    valueSpec: r.transition,
                    style: i,
                    styleSpec: r
                }) : n[s] ? An({
                    key: s,
                    value: e1[s],
                    valueSpec: n[s],
                    style: i,
                    styleSpec: r
                }) : [
                    new Pt(s, e1[s], 'unknown property "' + s + '"')
                ]);
            }
            return a;
        }
        var _n = {
            "*": function() {
                return [];
            },
            array: Wr,
            boolean: function(t1) {
                var e1 = t1.value, r = t1.key, n = Dr(e1);
                return "boolean" !== n ? [
                    new Pt(r, e1, "boolean expected, " + n + " found")
                ] : [];
            },
            number: Qr,
            color: function(t1) {
                var e1 = t1.key, r = t1.value, n = Dr(r);
                return "string" !== n ? [
                    new Pt(e1, r, "color expected, " + n + " found")
                ] : null === Qt(r) ? [
                    new Pt(e1, r, 'color expected, "' + r + '" found')
                ] : [];
            },
            constants: Mt,
            enum: rn,
            filter: fn,
            function: tn,
            layer: vn,
            object: $r,
            source: bn,
            light: wn,
            string: gn,
            formatted: function(t1) {
                return 0 === gn(t1).length ? [] : en(t1);
            },
            resolvedImage: function(t1) {
                return 0 === gn(t1).length ? [] : en(t1);
            }
        };
        function An(t1) {
            var e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
            return r.expression && Lr(Tt(e1)) ? tn(t1) : r.expression && Gr(Vt(e1)) ? en(t1) : r.type && _n[r.type] ? _n[r.type](t1) : $r(Bt({}, t1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Sn(t1) {
            var e1 = t1.value, r = t1.key, n = gn(t1);
            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new Pt(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new Pt(r, e1, '"glyphs" url must include a "{range}" token'))), n;
        }
        function kn(t1, e1) {
            void 0 === e1 && (e1 = Et);
            var r = [];
            return r = r.concat(An({
                key: "",
                value: t1,
                valueSpec: e1.$root,
                styleSpec: e1,
                style: t1,
                objectElementValidators: {
                    glyphs: Sn,
                    "*": function() {
                        return [];
                    }
                }
            })), t1.constants && (r = r.concat(Mt({
                key: "constants",
                value: t1.constants,
                style: t1,
                styleSpec: e1
            }))), In(r);
        }
        function In(t1) {
            return [].concat(t1).sort(function(t1, e1) {
                return t1.line - e1.line;
            });
        }
        function zn(t1) {
            return function() {
                for(var e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                return In(t1.apply(this, e1));
            };
        }
        kn.source = zn(bn), kn.light = zn(wn), kn.layer = zn(vn), kn.filter = zn(fn), kn.paintProperty = zn(dn), kn.layoutProperty = zn(mn);
        var Cn = kn, En = Cn.light, Pn = Cn.paintProperty, Mn = Cn.layoutProperty;
        function Bn(t1, e1) {
            var r = !1;
            if (e1 && e1.length) for(var n = 0, i = e1; n < i.length; n += 1)t1.fire(new zt(new Error(i[n].message))), r = !0;
            return r;
        }
        var Tn = Vn;
        function Vn(t1, e1, r) {
            var n = this.cells = [];
            if (t1 instanceof ArrayBuffer) {
                this.arrayBuffer = t1;
                var i = new Int32Array(this.arrayBuffer);
                t1 = i[0], this.d = (e1 = i[1]) + 2 * (r = i[2]);
                for(var a = 0; a < this.d * this.d; a++){
                    var o = i[3 + a], s = i[3 + a + 1];
                    n.push(o === s ? null : i.subarray(o, s));
                }
                var u = i[3 + n.length + 1];
                this.keys = i.subarray(i[3 + n.length], u), this.bboxes = i.subarray(u), this.insert = this._insertReadonly;
            } else {
                this.d = e1 + 2 * r;
                for(var l = 0; l < this.d * this.d; l++)n.push([]);
                this.keys = [], this.bboxes = [];
            }
            this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
            var p = r / e1 * t1;
            this.min = -p, this.max = t1 + p;
        }
        Vn.prototype.insert = function(t1, e1, r, n, i) {
            this._forEachCell(e1, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
        }, Vn.prototype._insertReadonly = function() {
            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, Vn.prototype._insertCell = function(t1, e1, r, n, i, a) {
            this.cells[i].push(a);
        }, Vn.prototype.query = function(t1, e1, r, n, i) {
            var a = this.min, o = this.max;
            if (t1 <= a && e1 <= a && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
            var s = [];
            return this._forEachCell(t1, e1, r, n, this._queryCell, s, {}, i), s;
        }, Vn.prototype._queryCell = function(t1, e1, r, n, i, a, o, s) {
            var u = this.cells[i];
            if (null !== u) for(var l = this.keys, p = this.bboxes, c = 0; c < u.length; c++){
                var h = u[c];
                if (void 0 === o[h]) {
                    var f = 4 * h;
                    (s ? s(p[f + 0], p[f + 1], p[f + 2], p[f + 3]) : t1 <= p[f + 2] && e1 <= p[f + 3] && r >= p[f + 0] && n >= p[f + 1]) ? (o[h] = !0, a.push(l[h])) : o[h] = !1;
                }
            }
        }, Vn.prototype._forEachCell = function(t1, e1, r, n, i, a, o, s) {
            for(var u = this._convertToCellCoord(t1), l = this._convertToCellCoord(e1), p = this._convertToCellCoord(r), c = this._convertToCellCoord(n), h = u; h <= p; h++)for(var f = l; f <= c; f++){
                var y = this.d * f + h;
                if ((!s || s(this._convertFromCellCoord(h), this._convertFromCellCoord(f), this._convertFromCellCoord(h + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t1, e1, r, n, y, a, o, s)) return;
            }
        }, Vn.prototype._convertFromCellCoord = function(t1) {
            return (t1 - this.padding) / this.scale;
        }, Vn.prototype._convertToCellCoord = function(t1) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
        }, Vn.prototype.toArrayBuffer = function() {
            if (this.arrayBuffer) return this.arrayBuffer;
            for(var t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++)r += this.cells[n].length;
            var i = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
            i[0] = this.extent, i[1] = this.n, i[2] = this.padding;
            for(var a = e1, o = 0; o < t1.length; o++){
                var s = t1[o];
                i[3 + o] = a, i.set(s, a), a += s.length;
            }
            return i[3 + t1.length] = a, i.set(this.keys, a), i[3 + t1.length + 1] = a += this.keys.length, i.set(this.bboxes, a), a += this.bboxes.length, i.buffer;
        };
        var Fn = o.ImageData, Dn = o.ImageBitmap, Ln = {};
        function On(t1, e1, r) {
            void 0 === r && (r = {}), Object.defineProperty(e1, "_classRegistryKey", {
                value: t1,
                writeable: !1
            }), Ln[t1] = {
                klass: e1,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        for(var Rn in On("Object", Object), Tn.serialize = function(t1, e1) {
            var r = t1.toArrayBuffer();
            return e1 && e1.push(r), {
                buffer: r
            };
        }, Tn.deserialize = function(t1) {
            return new Tn(t1.buffer);
        }, On("Grid", Tn), On("Color", te), On("Error", Error), On("ResolvedImage", ie), On("StylePropertyFunction", Yr), On("StyleExpression", Kr, {
            omit: [
                "_evaluator"
            ]
        }), On("ZoomDependentExpression", Jr), On("ZoomConstantExpression", Xr), On("CompoundExpression", xe, {
            omit: [
                "_evaluate"
            ]
        }), Ir)Ir[Rn]._classRegistryKey || On("Expression_" + Rn, Ir[Rn]);
        function Un(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function jn(t1) {
            return Dn && t1 instanceof Dn;
        }
        function qn(t1, e1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
            if (Un(t1) || jn(t1)) return e1 && e1.push(t1), t1;
            if (ArrayBuffer.isView(t1)) {
                var r = t1;
                return e1 && e1.push(r.buffer), r;
            }
            if (t1 instanceof Fn) return e1 && e1.push(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                for(var n = [], i = 0, a = t1; i < a.length; i += 1)n.push(qn(a[i], e1));
                return n;
            }
            if ("object" == typeof t1) {
                var o = t1.constructor, s = o._classRegistryKey;
                if (!s) throw new Error("can't serialize object of unregistered class");
                var u = o.serialize ? o.serialize(t1, e1) : {};
                if (!o.serialize) {
                    for(var l in t1)if (t1.hasOwnProperty(l) && !(Ln[s].omit.indexOf(l) >= 0)) {
                        var p = t1[l];
                        u[l] = Ln[s].shallow.indexOf(l) >= 0 ? p : qn(p, e1);
                    }
                    t1 instanceof Error && (u.message = t1.message);
                }
                if (u.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== s && (u.$name = s), u;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function Nn(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || Un(t1) || jn(t1) || ArrayBuffer.isView(t1) || t1 instanceof Fn) return t1;
            if (Array.isArray(t1)) return t1.map(Nn);
            if ("object" == typeof t1) {
                var e1 = t1.$name || "Object", r = Ln[e1].klass;
                if (!r) throw new Error("can't deserialize unregistered class " + e1);
                if (r.deserialize) return r.deserialize(t1);
                for(var n = Object.create(r.prototype), i = 0, a = Object.keys(t1); i < a.length; i += 1){
                    var o = a[i];
                    if ("$name" !== o) {
                        var s = t1[o];
                        n[o] = Ln[e1].shallow.indexOf(o) >= 0 ? s : Nn(s);
                    }
                }
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        var Kn = function() {
            this.first = !0;
        };
        Kn.prototype.update = function(t1, e1) {
            var r = Math.floor(t1);
            return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
        };
        var Gn = {
            "Latin-1 Supplement": function(t1) {
                return t1 >= 128 && t1 <= 255;
            },
            Arabic: function(t1) {
                return t1 >= 1536 && t1 <= 1791;
            },
            "Arabic Supplement": function(t1) {
                return t1 >= 1872 && t1 <= 1919;
            },
            "Arabic Extended-A": function(t1) {
                return t1 >= 2208 && t1 <= 2303;
            },
            "Hangul Jamo": function(t1) {
                return t1 >= 4352 && t1 <= 4607;
            },
            "Unified Canadian Aboriginal Syllabics": function(t1) {
                return t1 >= 5120 && t1 <= 5759;
            },
            Khmer: function(t1) {
                return t1 >= 6016 && t1 <= 6143;
            },
            "Unified Canadian Aboriginal Syllabics Extended": function(t1) {
                return t1 >= 6320 && t1 <= 6399;
            },
            "General Punctuation": function(t1) {
                return t1 >= 8192 && t1 <= 8303;
            },
            "Letterlike Symbols": function(t1) {
                return t1 >= 8448 && t1 <= 8527;
            },
            "Number Forms": function(t1) {
                return t1 >= 8528 && t1 <= 8591;
            },
            "Miscellaneous Technical": function(t1) {
                return t1 >= 8960 && t1 <= 9215;
            },
            "Control Pictures": function(t1) {
                return t1 >= 9216 && t1 <= 9279;
            },
            "Optical Character Recognition": function(t1) {
                return t1 >= 9280 && t1 <= 9311;
            },
            "Enclosed Alphanumerics": function(t1) {
                return t1 >= 9312 && t1 <= 9471;
            },
            "Geometric Shapes": function(t1) {
                return t1 >= 9632 && t1 <= 9727;
            },
            "Miscellaneous Symbols": function(t1) {
                return t1 >= 9728 && t1 <= 9983;
            },
            "Miscellaneous Symbols and Arrows": function(t1) {
                return t1 >= 11008 && t1 <= 11263;
            },
            "CJK Radicals Supplement": function(t1) {
                return t1 >= 11904 && t1 <= 12031;
            },
            "Kangxi Radicals": function(t1) {
                return t1 >= 12032 && t1 <= 12255;
            },
            "Ideographic Description Characters": function(t1) {
                return t1 >= 12272 && t1 <= 12287;
            },
            "CJK Symbols and Punctuation": function(t1) {
                return t1 >= 12288 && t1 <= 12351;
            },
            Hiragana: function(t1) {
                return t1 >= 12352 && t1 <= 12447;
            },
            Katakana: function(t1) {
                return t1 >= 12448 && t1 <= 12543;
            },
            Bopomofo: function(t1) {
                return t1 >= 12544 && t1 <= 12591;
            },
            "Hangul Compatibility Jamo": function(t1) {
                return t1 >= 12592 && t1 <= 12687;
            },
            Kanbun: function(t1) {
                return t1 >= 12688 && t1 <= 12703;
            },
            "Bopomofo Extended": function(t1) {
                return t1 >= 12704 && t1 <= 12735;
            },
            "CJK Strokes": function(t1) {
                return t1 >= 12736 && t1 <= 12783;
            },
            "Katakana Phonetic Extensions": function(t1) {
                return t1 >= 12784 && t1 <= 12799;
            },
            "Enclosed CJK Letters and Months": function(t1) {
                return t1 >= 12800 && t1 <= 13055;
            },
            "CJK Compatibility": function(t1) {
                return t1 >= 13056 && t1 <= 13311;
            },
            "CJK Unified Ideographs Extension A": function(t1) {
                return t1 >= 13312 && t1 <= 19903;
            },
            "Yijing Hexagram Symbols": function(t1) {
                return t1 >= 19904 && t1 <= 19967;
            },
            "CJK Unified Ideographs": function(t1) {
                return t1 >= 19968 && t1 <= 40959;
            },
            "Yi Syllables": function(t1) {
                return t1 >= 40960 && t1 <= 42127;
            },
            "Yi Radicals": function(t1) {
                return t1 >= 42128 && t1 <= 42191;
            },
            "Hangul Jamo Extended-A": function(t1) {
                return t1 >= 43360 && t1 <= 43391;
            },
            "Hangul Syllables": function(t1) {
                return t1 >= 44032 && t1 <= 55215;
            },
            "Hangul Jamo Extended-B": function(t1) {
                return t1 >= 55216 && t1 <= 55295;
            },
            "Private Use Area": function(t1) {
                return t1 >= 57344 && t1 <= 63743;
            },
            "CJK Compatibility Ideographs": function(t1) {
                return t1 >= 63744 && t1 <= 64255;
            },
            "Arabic Presentation Forms-A": function(t1) {
                return t1 >= 64336 && t1 <= 65023;
            },
            "Vertical Forms": function(t1) {
                return t1 >= 65040 && t1 <= 65055;
            },
            "CJK Compatibility Forms": function(t1) {
                return t1 >= 65072 && t1 <= 65103;
            },
            "Small Form Variants": function(t1) {
                return t1 >= 65104 && t1 <= 65135;
            },
            "Arabic Presentation Forms-B": function(t1) {
                return t1 >= 65136 && t1 <= 65279;
            },
            "Halfwidth and Fullwidth Forms": function(t1) {
                return t1 >= 65280 && t1 <= 65519;
            }
        };
        function Zn(t1) {
            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (Xn(r[e1].charCodeAt(0))) return !0;
            return !1;
        }
        function Xn(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(Gn["Bopomofo Extended"](t1) || Gn.Bopomofo(t1) || Gn["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || Gn["CJK Compatibility Ideographs"](t1) || Gn["CJK Compatibility"](t1) || Gn["CJK Radicals Supplement"](t1) || Gn["CJK Strokes"](t1) || !(!Gn["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || Gn["CJK Unified Ideographs Extension A"](t1) || Gn["CJK Unified Ideographs"](t1) || Gn["Enclosed CJK Letters and Months"](t1) || Gn["Hangul Compatibility Jamo"](t1) || Gn["Hangul Jamo Extended-A"](t1) || Gn["Hangul Jamo Extended-B"](t1) || Gn["Hangul Jamo"](t1) || Gn["Hangul Syllables"](t1) || Gn.Hiragana(t1) || Gn["Ideographic Description Characters"](t1) || Gn.Kanbun(t1) || Gn["Kangxi Radicals"](t1) || Gn["Katakana Phonetic Extensions"](t1) || Gn.Katakana(t1) && 12540 !== t1 || !(!Gn["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!Gn["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || Gn["Unified Canadian Aboriginal Syllabics"](t1) || Gn["Unified Canadian Aboriginal Syllabics Extended"](t1) || Gn["Vertical Forms"](t1) || Gn["Yijing Hexagram Symbols"](t1) || Gn["Yi Syllables"](t1) || Gn["Yi Radicals"](t1))));
        }
        function Jn(t1) {
            return !(Xn(t1) || function(t1) {
                return !!(Gn["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || Gn["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || Gn["Letterlike Symbols"](t1) || Gn["Number Forms"](t1) || Gn["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || Gn["Control Pictures"](t1) && 9251 !== t1 || Gn["Optical Character Recognition"](t1) || Gn["Enclosed Alphanumerics"](t1) || Gn["Geometric Shapes"](t1) || Gn["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || Gn["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || Gn["CJK Symbols and Punctuation"](t1) || Gn.Katakana(t1) || Gn["Private Use Area"](t1) || Gn["CJK Compatibility Forms"](t1) || Gn["Small Form Variants"](t1) || Gn["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function Hn(t1) {
            return t1 >= 1424 && t1 <= 2303 || Gn["Arabic Presentation Forms-A"](t1) || Gn["Arabic Presentation Forms-B"](t1);
        }
        function Yn(t1, e1) {
            return !(!e1 && Hn(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || Gn.Khmer(t1));
        }
        function $n(t1) {
            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (Hn(r[e1].charCodeAt(0))) return !0;
            return !1;
        }
        var Wn = null, Qn = "unavailable", ti = null, ei = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Qn = "error"), Wn && Wn(t1);
        };
        function ri() {
            ni.fire(new It("pluginStateChange", {
                pluginStatus: Qn,
                pluginURL: ti
            }));
        }
        var ni = new Ct, ii = function() {
            return Qn;
        }, ai = function() {
            if ("deferred" !== Qn || !ti) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Qn = "loading", ri(), ti && bt({
                url: ti
            }, function(t1) {
                t1 ? ei(t1) : (Qn = "loaded", ri());
            });
        }, oi = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: function() {
                return "loaded" === Qn || null != oi.applyArabicShaping;
            },
            isLoading: function() {
                return "loading" === Qn;
            },
            setState: function(t1) {
                Qn = t1.pluginStatus, ti = t1.pluginURL;
            },
            isParsed: function() {
                return null != oi.applyArabicShaping && null != oi.processBidirectionalText && null != oi.processStyledBidirectionalText;
            },
            getPluginURL: function() {
                return ti;
            }
        }, si = function(t1, e1) {
            this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Kn, this.transition = {});
        };
        si.prototype.isSupportedScript = function(t1) {
            return function(t1, e1) {
                for(var r = 0, n = t1; r < n.length; r += 1)if (!Yn(n[r].charCodeAt(0), e1)) return !1;
                return !0;
            }(t1, oi.isLoaded());
        }, si.prototype.crossFadingFactor = function() {
            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
        }, si.prototype.getCrossfadeParameters = function() {
            var t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
            return t1 > this.zoomHistory.lastIntegerZoom ? {
                fromScale: 2,
                toScale: 1,
                t: e1 + (1 - e1) * r
            } : {
                fromScale: .5,
                toScale: 1,
                t: 1 - (1 - r) * e1
            };
        };
        var ui = function(t1, e1) {
            this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                if (Lr(t1)) return new Yr(t1, e1);
                if (Gr(t1)) {
                    var r = Hr(t1, e1);
                    if ("error" === r.result) throw new Error(r.value.map(function(t1) {
                        return t1.key + ": " + t1.message;
                    }).join(", "));
                    return r.value;
                }
                var n = t1;
                return "string" == typeof t1 && "color" === e1.type && (n = te.parse(t1)), {
                    kind: "constant",
                    evaluate: function() {
                        return n;
                    }
                };
            }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
        };
        ui.prototype.isDataDriven = function() {
            return "source" === this.expression.kind || "composite" === this.expression.kind;
        }, ui.prototype.possiblyEvaluate = function(t1, e1, r) {
            return this.property.possiblyEvaluate(this, t1, e1, r);
        };
        var li = function(t1) {
            this.property = t1, this.value = new ui(t1, void 0);
        };
        li.prototype.transitioned = function(t1, e1) {
            return new ci(this.property, this.value, e1, h({}, t1.transition, this.transition), t1.now);
        }, li.prototype.untransitioned = function() {
            return new ci(this.property, this.value, null, {}, 0);
        };
        var pi = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
        };
        pi.prototype.getValue = function(t1) {
            return w(this._values[t1].value.value);
        }, pi.prototype.setValue = function(t1, e1) {
            this._values.hasOwnProperty(t1) || (this._values[t1] = new li(this._values[t1].property)), this._values[t1].value = new ui(this._values[t1].property, null === e1 ? void 0 : w(e1));
        }, pi.prototype.getTransition = function(t1) {
            return w(this._values[t1].transition);
        }, pi.prototype.setTransition = function(t1, e1) {
            this._values.hasOwnProperty(t1) || (this._values[t1] = new li(this._values[t1].property)), this._values[t1].transition = w(e1) || void 0;
        }, pi.prototype.serialize = function() {
            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                var n = r[e1], i = this.getValue(n);
                void 0 !== i && (t1[n] = i);
                var a = this.getTransition(n);
                void 0 !== a && (t1[n + "-transition"] = a);
            }
            return t1;
        }, pi.prototype.transitioned = function(t1, e1) {
            for(var r = new hi(this._properties), n = 0, i = Object.keys(this._values); n < i.length; n += 1){
                var a = i[n];
                r._values[a] = this._values[a].transitioned(t1, e1._values[a]);
            }
            return r;
        }, pi.prototype.untransitioned = function() {
            for(var t1 = new hi(this._properties), e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                var n = r[e1];
                t1._values[n] = this._values[n].untransitioned();
            }
            return t1;
        };
        var ci = function(t1, e1, r, n, i) {
            this.property = t1, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
        };
        ci.prototype.possiblyEvaluate = function(t1, e1, r) {
            var n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), a = this.prior;
            if (a) {
                if (n > this.end) return this.prior = null, i;
                if (this.value.isDataDriven()) return this.prior = null, i;
                if (n < this.begin) return a.possiblyEvaluate(t1, e1, r);
                var o = (n - this.begin) / (this.end - this.begin);
                return this.property.interpolate(a.possiblyEvaluate(t1, e1, r), i, function(t1) {
                    if (t1 <= 0) return 0;
                    if (t1 >= 1) return 1;
                    var e1 = t1 * t1, r = e1 * t1;
                    return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                }(o));
            }
            return i;
        };
        var hi = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
        };
        hi.prototype.possiblyEvaluate = function(t1, e1, r) {
            for(var n = new di(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                var o = a[i];
                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
            }
            return n;
        }, hi.prototype.hasTransition = function() {
            for(var t1 = 0, e1 = Object.keys(this._values); t1 < e1.length; t1 += 1)if (this._values[e1[t1]].prior) return !0;
            return !1;
        };
        var fi = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
        };
        fi.prototype.getValue = function(t1) {
            return w(this._values[t1].value);
        }, fi.prototype.setValue = function(t1, e1) {
            this._values[t1] = new ui(this._values[t1].property, null === e1 ? void 0 : w(e1));
        }, fi.prototype.serialize = function() {
            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                var n = r[e1], i = this.getValue(n);
                void 0 !== i && (t1[n] = i);
            }
            return t1;
        }, fi.prototype.possiblyEvaluate = function(t1, e1, r) {
            for(var n = new di(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                var o = a[i];
                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
            }
            return n;
        };
        var yi = function(t1, e1, r) {
            this.property = t1, this.value = e1, this.parameters = r;
        };
        yi.prototype.isConstant = function() {
            return "constant" === this.value.kind;
        }, yi.prototype.constantOr = function(t1) {
            return "constant" === this.value.kind ? this.value.value : t1;
        }, yi.prototype.evaluate = function(t1, e1, r, n) {
            return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
        };
        var di = function(t1) {
            this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
        };
        di.prototype.get = function(t1) {
            return this._values[t1];
        };
        var mi = function(t1) {
            this.specification = t1;
        };
        mi.prototype.possiblyEvaluate = function(t1, e1) {
            return t1.expression.evaluate(e1);
        }, mi.prototype.interpolate = function(t1, e1, r) {
            var n = Ge[this.specification.type];
            return n ? n(t1, e1, r) : t1;
        };
        var vi = function(t1, e1) {
            this.specification = t1, this.overrides = e1;
        };
        vi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
            return new yi(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                kind: "constant",
                value: t1.expression.evaluate(e1, null, {}, r, n)
            } : t1.expression, e1);
        }, vi.prototype.interpolate = function(t1, e1, r) {
            if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
            if (void 0 === t1.value.value || void 0 === e1.value.value) return new yi(this, {
                kind: "constant",
                value: void 0
            }, t1.parameters);
            var n = Ge[this.specification.type];
            return n ? new yi(this, {
                kind: "constant",
                value: n(t1.value.value, e1.value.value, r)
            }, t1.parameters) : t1;
        }, vi.prototype.evaluate = function(t1, e1, r, n, i, a) {
            return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, a);
        };
        var gi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                if (void 0 === t1.value) return new yi(this, {
                    kind: "constant",
                    value: void 0
                }, e1);
                if ("constant" === t1.expression.kind) {
                    var i = t1.expression.evaluate(e1, null, {}, r, n), a = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, o = this._calculate(a, a, a, e1);
                    return new yi(this, {
                        kind: "constant",
                        value: o
                    }, e1);
                }
                if ("camera" === t1.expression.kind) {
                    var s = this._calculate(t1.expression.evaluate({
                        zoom: e1.zoom - 1
                    }), t1.expression.evaluate({
                        zoom: e1.zoom
                    }), t1.expression.evaluate({
                        zoom: e1.zoom + 1
                    }), e1);
                    return new yi(this, {
                        kind: "constant",
                        value: s
                    }, e1);
                }
                return new yi(this, t1.expression, e1);
            }, e1.prototype.evaluate = function(t1, e1, r, n, i, a) {
                if ("source" === t1.kind) {
                    var o = t1.evaluate(e1, r, n, i, a);
                    return this._calculate(o, o, o, e1);
                }
                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                    zoom: Math.floor(e1.zoom) - 1
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom)
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom) + 1
                }, r, n), e1) : t1.value;
            }, e1.prototype._calculate = function(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1
                } : {
                    from: r,
                    to: e1
                };
            }, e1.prototype.interpolate = function(t1) {
                return t1;
            }, e1;
        }(vi), xi = function(t1) {
            this.specification = t1;
        };
        xi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
            if (void 0 !== t1.value) {
                if ("constant" === t1.expression.kind) {
                    var i = t1.expression.evaluate(e1, null, {}, r, n);
                    return this._calculate(i, i, i, e1);
                }
                return this._calculate(t1.expression.evaluate(new si(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new si(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new si(Math.floor(e1.zoom + 1), e1)), e1);
            }
        }, xi.prototype._calculate = function(t1, e1, r, n) {
            return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                from: t1,
                to: e1
            } : {
                from: r,
                to: e1
            };
        }, xi.prototype.interpolate = function(t1) {
            return t1;
        };
        var bi = function(t1) {
            this.specification = t1;
        };
        bi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
            return !!t1.expression.evaluate(e1, null, {}, r, n);
        }, bi.prototype.interpolate = function() {
            return !1;
        };
        var wi = function(t1) {
            for(var e1 in this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [], t1){
                var r = t1[e1];
                r.specification.overridable && this.overridableProperties.push(e1);
                var n = this.defaultPropertyValues[e1] = new ui(r, void 0), i = this.defaultTransitionablePropertyValues[e1] = new li(r);
                this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = n.possiblyEvaluate({});
            }
        };
        On("DataDrivenProperty", vi), On("DataConstantProperty", mi), On("CrossFadedDataDrivenProperty", gi), On("CrossFadedProperty", xi), On("ColorRampProperty", bi);
        var _i = function(t1) {
            function e1(e1, r) {
                if (t1.call(this), this.id = e1.id, this.type = e1.type, this._featureFilter = {
                    filter: function() {
                        return !0;
                    },
                    needGeometry: !1
                }, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter), r.layout && (this._unevaluatedLayout = new fi(r.layout)), r.paint)) {
                    for(var n in this._transitionablePaint = new pi(r.paint), e1.paint)this.setPaintProperty(n, e1.paint[n], {
                        validate: !1
                    });
                    for(var i in e1.layout)this.setLayoutProperty(i, e1.layout[i], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new di(r.paint);
                }
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getCrossfadeParameters = function() {
                return this._crossfadeParameters;
            }, e1.prototype.getLayoutProperty = function(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }, e1.prototype.setLayoutProperty = function(t1, e1, r) {
                void 0 === r && (r = {}), null != e1 && this._validate(Mn, "layers." + this.id + ".layout." + t1, t1, e1, r) || ("visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1);
            }, e1.prototype.getPaintProperty = function(t1) {
                return g(t1, "-transition") ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
            }, e1.prototype.setPaintProperty = function(t1, e1, r) {
                if (void 0 === r && (r = {}), null != e1 && this._validate(Pn, "layers." + this.id + ".paint." + t1, t1, e1, r)) return !1;
                if (g(t1, "-transition")) return this._transitionablePaint.setTransition(t1.slice(0, -11), e1 || void 0), !1;
                var n = this._transitionablePaint._values[t1], i = "cross-faded-data-driven" === n.property.specification["property-type"], a = n.value.isDataDriven(), o = n.value;
                this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                var s = this._transitionablePaint._values[t1].value;
                return s.isDataDriven() || a || i || this._handleOverridablePaintPropertyUpdate(t1, o, s);
            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {}, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, e1, r) {
                return !1;
            }, e1.prototype.isHidden = function(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }, e1.prototype.updateTransitions = function(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }, e1.prototype.hasTransition = function() {
                return this._transitioningPaint.hasTransition();
            }, e1.prototype.recalculate = function(t1, e1) {
                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
            }, e1.prototype.serialize = function() {
                var t1 = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), b(t1, function(t1, e1) {
                    return !(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length);
                });
            }, e1.prototype._validate = function(t1, e1, r, n, i) {
                return void 0 === i && (i = {}), (!i || !1 !== i.validate) && Bn(this, t1.call(Cn, {
                    key: e1,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: Et,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }, e1.prototype.is3D = function() {
                return !1;
            }, e1.prototype.isTileClipped = function() {
                return !1;
            }, e1.prototype.hasOffscreenPass = function() {
                return !1;
            }, e1.prototype.resize = function() {}, e1.prototype.isStateDependent = function() {
                for(var t1 in this.paint._values){
                    var e1 = this.paint.get(t1);
                    if (e1 instanceof yi && Tr(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                }
                return !1;
            }, e1;
        }(Ct), Ai = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        }, Si = function(t1, e1) {
            this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
        }, ki = function() {
            this.isTransferred = !1, this.capacity = -1, this.resize(0);
        };
        function Ii(t1, e1) {
            void 0 === e1 && (e1 = 1);
            var r = 0, n = 0;
            return {
                members: t1.map(function(t1) {
                    var i = Ai[t1.type].BYTES_PER_ELEMENT, a = r = zi(r, Math.max(e1, i)), o = t1.components || 1;
                    return n = Math.max(n, i), r += i * o, {
                        name: t1.name,
                        type: t1.type,
                        components: o,
                        offset: a
                    };
                }),
                size: zi(r, Math.max(n, e1)),
                alignment: e1
            };
        }
        function zi(t1, e1) {
            return Math.ceil(t1 / e1) * e1;
        }
        ki.serialize = function(t1, e1) {
            return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                length: t1.length,
                arrayBuffer: t1.arrayBuffer
            };
        }, ki.deserialize = function(t1) {
            var e1 = Object.create(this.prototype);
            return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
        }, ki.prototype._trim = function() {
            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
        }, ki.prototype.clear = function() {
            this.length = 0;
        }, ki.prototype.resize = function(t1) {
            this.reserve(t1), this.length = t1;
        }, ki.prototype.reserve = function(t1) {
            if (t1 > this.capacity) {
                this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                var e1 = this.uint8;
                this._refreshViews(), e1 && this.uint8.set(e1);
            }
        }, ki.prototype._refreshViews = function() {
            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
        };
        var Ci = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1) {
                var r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }, e1.prototype.emplace = function(t1, e1, r) {
                var n = 2 * t1;
                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
            }, e1;
        }(ki);
        Ci.prototype.bytesPerElement = 4, On("StructArrayLayout2i4", Ci);
        var Ei = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                var i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                var a = 4 * t1;
                return this.int16[a + 0] = e1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
            }, e1;
        }(ki);
        Ei.prototype.bytesPerElement = 8, On("StructArrayLayout4i8", Ei);
        var Pi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                var o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                var s = 6 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
            }, e1;
        }(ki);
        Pi.prototype.bytesPerElement = 12, On("StructArrayLayout2i4i12", Pi);
        var Mi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                var o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                var s = 4 * t1, u = 8 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = a, this.uint8[u + 7] = o, t1;
            }, e1;
        }(ki);
        Mi.prototype.bytesPerElement = 8, On("StructArrayLayout2i4ub8", Mi);
        var Bi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1) {
                var r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }, e1.prototype.emplace = function(t1, e1, r) {
                var n = 2 * t1;
                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
            }, e1;
        }(ki);
        Bi.prototype.bytesPerElement = 8, On("StructArrayLayout2f8", Bi);
        var Ti = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l) {
                var p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e1, r, n, i, a, o, s, u, l);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p) {
                var c = 10 * t1;
                return this.uint16[c + 0] = e1, this.uint16[c + 1] = r, this.uint16[c + 2] = n, this.uint16[c + 3] = i, this.uint16[c + 4] = a, this.uint16[c + 5] = o, this.uint16[c + 6] = s, this.uint16[c + 7] = u, this.uint16[c + 8] = l, this.uint16[c + 9] = p, t1;
            }, e1;
        }(ki);
        Ti.prototype.bytesPerElement = 20, On("StructArrayLayout10ui20", Ti);
        var Vi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l, p, c) {
                var h = this.length;
                return this.resize(h + 1), this.emplace(h, t1, e1, r, n, i, a, o, s, u, l, p, c);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h) {
                var f = 12 * t1;
                return this.int16[f + 0] = e1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = o, this.uint16[f + 6] = s, this.uint16[f + 7] = u, this.int16[f + 8] = l, this.int16[f + 9] = p, this.int16[f + 10] = c, this.int16[f + 11] = h, t1;
            }, e1;
        }(ki);
        Vi.prototype.bytesPerElement = 24, On("StructArrayLayout4i4ui4i24", Vi);
        var Fi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 3 * t1;
                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }, e1;
        }(ki);
        Fi.prototype.bytesPerElement = 12, On("StructArrayLayout3f12", Fi);
        var Di = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1) {
                var e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }, e1.prototype.emplace = function(t1, e1) {
                return this.uint32[1 * t1 + 0] = e1, t1;
            }, e1;
        }(ki);
        Di.prototype.bytesPerElement = 4, On("StructArrayLayout1ul4", Di);
        var Li = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u) {
                var l = this.length;
                return this.resize(l + 1), this.emplace(l, t1, e1, r, n, i, a, o, s, u);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l) {
                var p = 10 * t1, c = 5 * t1;
                return this.int16[p + 0] = e1, this.int16[p + 1] = r, this.int16[p + 2] = n, this.int16[p + 3] = i, this.int16[p + 4] = a, this.int16[p + 5] = o, this.uint32[c + 3] = s, this.uint16[p + 8] = u, this.uint16[p + 9] = l, t1;
            }, e1;
        }(ki);
        Li.prototype.bytesPerElement = 20, On("StructArrayLayout6i1ul2ui20", Li);
        var Oi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                var o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                var s = 6 * t1;
                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
            }, e1;
        }(ki);
        Oi.prototype.bytesPerElement = 12, On("StructArrayLayout2i2i2i12", Oi);
        var Ri = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i) {
                var a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a) {
                var o = 4 * t1, s = 8 * t1;
                return this.float32[o + 0] = e1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[s + 6] = i, this.int16[s + 7] = a, t1;
            }, e1;
        }(ki);
        Ri.prototype.bytesPerElement = 16, On("StructArrayLayout2f1f2i16", Ri);
        var Ui = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                var i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                var a = 12 * t1, o = 3 * t1;
                return this.uint8[a + 0] = e1, this.uint8[a + 1] = r, this.float32[o + 1] = n, this.float32[o + 2] = i, t1;
            }, e1;
        }(ki);
        Ui.prototype.bytesPerElement = 12, On("StructArrayLayout2ub2f12", Ui);
        var ji = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 3 * t1;
                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }, e1;
        }(ki);
        ji.prototype.bytesPerElement = 6, On("StructArrayLayout3ui6", ji);
        var qi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m) {
                var v = this.length;
                return this.resize(v + 1), this.emplace(v, t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v) {
                var g = 24 * t1, x = 12 * t1, b = 48 * t1;
                return this.int16[g + 0] = e1, this.int16[g + 1] = r, this.uint16[g + 2] = n, this.uint16[g + 3] = i, this.uint32[x + 2] = a, this.uint32[x + 3] = o, this.uint32[x + 4] = s, this.uint16[g + 10] = u, this.uint16[g + 11] = l, this.uint16[g + 12] = p, this.float32[x + 7] = c, this.float32[x + 8] = h, this.uint8[b + 36] = f, this.uint8[b + 37] = y, this.uint8[b + 38] = d, this.uint32[x + 10] = m, this.int16[g + 22] = v, t1;
            }, e1;
        }(ki);
        qi.prototype.bytesPerElement = 48, On("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", qi);
        var Ni = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, A, S, k, I, z) {
                var C = this.length;
                return this.resize(C + 1), this.emplace(C, t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, A, S, k, I, z);
            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, A, S, k, I, z, C) {
                var E = 34 * t1, P = 17 * t1;
                return this.int16[E + 0] = e1, this.int16[E + 1] = r, this.int16[E + 2] = n, this.int16[E + 3] = i, this.int16[E + 4] = a, this.int16[E + 5] = o, this.int16[E + 6] = s, this.int16[E + 7] = u, this.uint16[E + 8] = l, this.uint16[E + 9] = p, this.uint16[E + 10] = c, this.uint16[E + 11] = h, this.uint16[E + 12] = f, this.uint16[E + 13] = y, this.uint16[E + 14] = d, this.uint16[E + 15] = m, this.uint16[E + 16] = v, this.uint16[E + 17] = g, this.uint16[E + 18] = x, this.uint16[E + 19] = b, this.uint16[E + 20] = w, this.uint16[E + 21] = _, this.uint16[E + 22] = A, this.uint32[P + 12] = S, this.float32[P + 13] = k, this.float32[P + 14] = I, this.float32[P + 15] = z, this.float32[P + 16] = C, t1;
            }, e1;
        }(ki);
        Ni.prototype.bytesPerElement = 68, On("StructArrayLayout8i15ui1ul4f68", Ni);
        var Ki = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1) {
                var e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }, e1.prototype.emplace = function(t1, e1) {
                return this.float32[1 * t1 + 0] = e1, t1;
            }, e1;
        }(ki);
        Ki.prototype.bytesPerElement = 4, On("StructArrayLayout1f4", Ki);
        var Gi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 3 * t1;
                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }, e1;
        }(ki);
        Gi.prototype.bytesPerElement = 6, On("StructArrayLayout3i6", Gi);
        var Zi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                var n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }, e1.prototype.emplace = function(t1, e1, r, n) {
                var i = 4 * t1;
                return this.uint32[2 * t1 + 0] = e1, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t1;
            }, e1;
        }(ki);
        Zi.prototype.bytesPerElement = 8, On("StructArrayLayout1ul2ui8", Zi);
        var Xi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1) {
                var r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }, e1.prototype.emplace = function(t1, e1, r) {
                var n = 2 * t1;
                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
            }, e1;
        }(ki);
        Xi.prototype.bytesPerElement = 4, On("StructArrayLayout2ui4", Xi);
        var Ji = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1) {
                var e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }, e1.prototype.emplace = function(t1, e1) {
                return this.uint16[1 * t1 + 0] = e1, t1;
            }, e1;
        }(ki);
        Ji.prototype.bytesPerElement = 2, On("StructArrayLayout1ui2", Ji);
        var Hi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._refreshViews = function() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                var i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                var a = 4 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
            }, e1;
        }(ki);
        Hi.prototype.bytesPerElement = 16, On("StructArrayLayout4f16", Hi);
        var Yi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                anchorPointX: {
                    configurable: !0
                },
                anchorPointY: {
                    configurable: !0
                },
                x1: {
                    configurable: !0
                },
                y1: {
                    configurable: !0
                },
                x2: {
                    configurable: !0
                },
                y2: {
                    configurable: !0
                },
                featureIndex: {
                    configurable: !0
                },
                sourceLayerIndex: {
                    configurable: !0
                },
                bucketIndex: {
                    configurable: !0
                },
                anchorPoint: {
                    configurable: !0
                }
            };
            return r.anchorPointX.get = function() {
                return this._structArray.int16[this._pos2 + 0];
            }, r.anchorPointY.get = function() {
                return this._structArray.int16[this._pos2 + 1];
            }, r.x1.get = function() {
                return this._structArray.int16[this._pos2 + 2];
            }, r.y1.get = function() {
                return this._structArray.int16[this._pos2 + 3];
            }, r.x2.get = function() {
                return this._structArray.int16[this._pos2 + 4];
            }, r.y2.get = function() {
                return this._structArray.int16[this._pos2 + 5];
            }, r.featureIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 3];
            }, r.sourceLayerIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 8];
            }, r.bucketIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 9];
            }, r.anchorPoint.get = function() {
                return new i(this.anchorPointX, this.anchorPointY);
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        Yi.prototype.size = 20;
        var $i = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new Yi(this, t1);
            }, e1;
        }(Li);
        On("CollisionBoxArray", $i);
        var Wi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                anchorX: {
                    configurable: !0
                },
                anchorY: {
                    configurable: !0
                },
                glyphStartIndex: {
                    configurable: !0
                },
                numGlyphs: {
                    configurable: !0
                },
                vertexStartIndex: {
                    configurable: !0
                },
                lineStartIndex: {
                    configurable: !0
                },
                lineLength: {
                    configurable: !0
                },
                segment: {
                    configurable: !0
                },
                lowerSize: {
                    configurable: !0
                },
                upperSize: {
                    configurable: !0
                },
                lineOffsetX: {
                    configurable: !0
                },
                lineOffsetY: {
                    configurable: !0
                },
                writingMode: {
                    configurable: !0
                },
                placedOrientation: {
                    configurable: !0
                },
                hidden: {
                    configurable: !0
                },
                crossTileID: {
                    configurable: !0
                },
                associatedIconIndex: {
                    configurable: !0
                }
            };
            return r.anchorX.get = function() {
                return this._structArray.int16[this._pos2 + 0];
            }, r.anchorY.get = function() {
                return this._structArray.int16[this._pos2 + 1];
            }, r.glyphStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 2];
            }, r.numGlyphs.get = function() {
                return this._structArray.uint16[this._pos2 + 3];
            }, r.vertexStartIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 2];
            }, r.lineStartIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 3];
            }, r.lineLength.get = function() {
                return this._structArray.uint32[this._pos4 + 4];
            }, r.segment.get = function() {
                return this._structArray.uint16[this._pos2 + 10];
            }, r.lowerSize.get = function() {
                return this._structArray.uint16[this._pos2 + 11];
            }, r.upperSize.get = function() {
                return this._structArray.uint16[this._pos2 + 12];
            }, r.lineOffsetX.get = function() {
                return this._structArray.float32[this._pos4 + 7];
            }, r.lineOffsetY.get = function() {
                return this._structArray.float32[this._pos4 + 8];
            }, r.writingMode.get = function() {
                return this._structArray.uint8[this._pos1 + 36];
            }, r.placedOrientation.get = function() {
                return this._structArray.uint8[this._pos1 + 37];
            }, r.placedOrientation.set = function(t1) {
                this._structArray.uint8[this._pos1 + 37] = t1;
            }, r.hidden.get = function() {
                return this._structArray.uint8[this._pos1 + 38];
            }, r.hidden.set = function(t1) {
                this._structArray.uint8[this._pos1 + 38] = t1;
            }, r.crossTileID.get = function() {
                return this._structArray.uint32[this._pos4 + 10];
            }, r.crossTileID.set = function(t1) {
                this._structArray.uint32[this._pos4 + 10] = t1;
            }, r.associatedIconIndex.get = function() {
                return this._structArray.int16[this._pos2 + 22];
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        Wi.prototype.size = 48;
        var Qi = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new Wi(this, t1);
            }, e1;
        }(qi);
        On("PlacedSymbolArray", Qi);
        var ta = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                anchorX: {
                    configurable: !0
                },
                anchorY: {
                    configurable: !0
                },
                rightJustifiedTextSymbolIndex: {
                    configurable: !0
                },
                centerJustifiedTextSymbolIndex: {
                    configurable: !0
                },
                leftJustifiedTextSymbolIndex: {
                    configurable: !0
                },
                verticalPlacedTextSymbolIndex: {
                    configurable: !0
                },
                placedIconSymbolIndex: {
                    configurable: !0
                },
                verticalPlacedIconSymbolIndex: {
                    configurable: !0
                },
                key: {
                    configurable: !0
                },
                textBoxStartIndex: {
                    configurable: !0
                },
                textBoxEndIndex: {
                    configurable: !0
                },
                verticalTextBoxStartIndex: {
                    configurable: !0
                },
                verticalTextBoxEndIndex: {
                    configurable: !0
                },
                iconBoxStartIndex: {
                    configurable: !0
                },
                iconBoxEndIndex: {
                    configurable: !0
                },
                verticalIconBoxStartIndex: {
                    configurable: !0
                },
                verticalIconBoxEndIndex: {
                    configurable: !0
                },
                featureIndex: {
                    configurable: !0
                },
                numHorizontalGlyphVertices: {
                    configurable: !0
                },
                numVerticalGlyphVertices: {
                    configurable: !0
                },
                numIconVertices: {
                    configurable: !0
                },
                numVerticalIconVertices: {
                    configurable: !0
                },
                useRuntimeCollisionCircles: {
                    configurable: !0
                },
                crossTileID: {
                    configurable: !0
                },
                textBoxScale: {
                    configurable: !0
                },
                textOffset0: {
                    configurable: !0
                },
                textOffset1: {
                    configurable: !0
                },
                collisionCircleDiameter: {
                    configurable: !0
                }
            };
            return r.anchorX.get = function() {
                return this._structArray.int16[this._pos2 + 0];
            }, r.anchorY.get = function() {
                return this._structArray.int16[this._pos2 + 1];
            }, r.rightJustifiedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 2];
            }, r.centerJustifiedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 3];
            }, r.leftJustifiedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 4];
            }, r.verticalPlacedTextSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 5];
            }, r.placedIconSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 6];
            }, r.verticalPlacedIconSymbolIndex.get = function() {
                return this._structArray.int16[this._pos2 + 7];
            }, r.key.get = function() {
                return this._structArray.uint16[this._pos2 + 8];
            }, r.textBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 9];
            }, r.textBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 10];
            }, r.verticalTextBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 11];
            }, r.verticalTextBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 12];
            }, r.iconBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 13];
            }, r.iconBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 14];
            }, r.verticalIconBoxStartIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 15];
            }, r.verticalIconBoxEndIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 16];
            }, r.featureIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 17];
            }, r.numHorizontalGlyphVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 18];
            }, r.numVerticalGlyphVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 19];
            }, r.numIconVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 20];
            }, r.numVerticalIconVertices.get = function() {
                return this._structArray.uint16[this._pos2 + 21];
            }, r.useRuntimeCollisionCircles.get = function() {
                return this._structArray.uint16[this._pos2 + 22];
            }, r.crossTileID.get = function() {
                return this._structArray.uint32[this._pos4 + 12];
            }, r.crossTileID.set = function(t1) {
                this._structArray.uint32[this._pos4 + 12] = t1;
            }, r.textBoxScale.get = function() {
                return this._structArray.float32[this._pos4 + 13];
            }, r.textOffset0.get = function() {
                return this._structArray.float32[this._pos4 + 14];
            }, r.textOffset1.get = function() {
                return this._structArray.float32[this._pos4 + 15];
            }, r.collisionCircleDiameter.get = function() {
                return this._structArray.float32[this._pos4 + 16];
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        ta.prototype.size = 68;
        var ea = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new ta(this, t1);
            }, e1;
        }(Ni);
        On("SymbolInstanceArray", ea);
        var ra = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getoffsetX = function(t1) {
                return this.float32[1 * t1 + 0];
            }, e1;
        }(Ki);
        On("GlyphOffsetArray", ra);
        var na = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getx = function(t1) {
                return this.int16[3 * t1 + 0];
            }, e1.prototype.gety = function(t1) {
                return this.int16[3 * t1 + 1];
            }, e1.prototype.gettileUnitDistanceFromAnchor = function(t1) {
                return this.int16[3 * t1 + 2];
            }, e1;
        }(Gi);
        On("SymbolLineVertexArray", na);
        var ia = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var r = {
                featureIndex: {
                    configurable: !0
                },
                sourceLayerIndex: {
                    configurable: !0
                },
                bucketIndex: {
                    configurable: !0
                }
            };
            return r.featureIndex.get = function() {
                return this._structArray.uint32[this._pos4 + 0];
            }, r.sourceLayerIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 2];
            }, r.bucketIndex.get = function() {
                return this._structArray.uint16[this._pos2 + 3];
            }, Object.defineProperties(e1.prototype, r), e1;
        }(Si);
        ia.prototype.size = 8;
        var aa = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.get = function(t1) {
                return new ia(this, t1);
            }, e1;
        }(Zi);
        On("FeatureIndexArray", aa);
        var oa = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4).members, sa = function(t1) {
            void 0 === t1 && (t1 = []), this.segments = t1;
        };
        function ua(t1, e1) {
            return 256 * (t1 = p(Math.floor(t1), 0, 255)) + p(Math.floor(e1), 0, 255);
        }
        sa.prototype.prepareSegment = function(t1, e1, r, n) {
            var i = this.segments[this.segments.length - 1];
            return t1 > sa.MAX_VERTEX_ARRAY_LENGTH && A("Max vertices per segment is " + sa.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + t1), (!i || i.vertexLength + t1 > sa.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                vertexOffset: e1.length,
                primitiveOffset: r.length,
                vertexLength: 0,
                primitiveLength: 0
            }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
        }, sa.prototype.get = function() {
            return this.segments;
        }, sa.prototype.destroy = function() {
            for(var t1 = 0, e1 = this.segments; t1 < e1.length; t1 += 1){
                var r = e1[t1];
                for(var n in r.vaos)r.vaos[n].destroy();
            }
        }, sa.simpleSegment = function(t1, e1, r, n) {
            return new sa([
                {
                    vertexOffset: t1,
                    primitiveOffset: e1,
                    vertexLength: r,
                    primitiveLength: n,
                    vaos: {},
                    sortKey: 0
                }
            ]);
        }, sa.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, On("SegmentVector", sa);
        var la = Ii([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]), pa = e1(function(t1) {
            t1.exports = function(t1, e1) {
                var r, n, i, a, o, s, u, l;
                for(n = t1.length - (r = 3 & t1.length), i = e1, o = 3432918353, s = 461845907, l = 0; l < n;)u = 255 & t1.charCodeAt(l) | (255 & t1.charCodeAt(++l)) << 8 | (255 & t1.charCodeAt(++l)) << 16 | (255 & t1.charCodeAt(++l)) << 24, ++l, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= u = (65535 & (u = (u = (65535 & u) * o + (((u >>> 16) * o & 65535) << 16) & 4294967295) << 15 | u >>> 17)) * s + (((u >>> 16) * s & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
                switch(u = 0, r){
                    case 3:
                        u ^= (255 & t1.charCodeAt(l + 2)) << 16;
                    case 2:
                        u ^= (255 & t1.charCodeAt(l + 1)) << 8;
                    case 1:
                        i ^= u = (65535 & (u = (u = (65535 & (u ^= 255 & t1.charCodeAt(l))) * o + (((u >>> 16) * o & 65535) << 16) & 4294967295) << 15 | u >>> 17)) * s + (((u >>> 16) * s & 65535) << 16) & 4294967295;
                }
                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            };
        }), ca = e1(function(t1) {
            t1.exports = function(t1, e1) {
                for(var r, n = t1.length, i = e1 ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
                switch(n){
                    case 3:
                        i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                    case 2:
                        i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            };
        }), ha = pa, fa = ca;
        ha.murmur3 = pa, ha.murmur2 = fa;
        var ya = function() {
            this.ids = [], this.positions = [], this.indexed = !1;
        };
        ya.prototype.add = function(t1, e1, r, n) {
            this.ids.push(ma(t1)), this.positions.push(e1, r, n);
        }, ya.prototype.getPositions = function(t1) {
            for(var e1 = ma(t1), r = 0, n = this.ids.length - 1; r < n;){
                var i = r + n >> 1;
                this.ids[i] >= e1 ? n = i : r = i + 1;
            }
            for(var a = []; this.ids[r] === e1;)a.push({
                index: this.positions[3 * r],
                start: this.positions[3 * r + 1],
                end: this.positions[3 * r + 2]
            }), r++;
            return a;
        }, ya.serialize = function(t1, e1) {
            var r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
            return function t1(e1, r, n, i) {
                for(; n < i;){
                    for(var a = e1[n + i >> 1], o = n - 1, s = i + 1;;){
                        do o++;
                        while (e1[o] < a);
                        do s--;
                        while (e1[s] > a);
                        if (o >= s) break;
                        va(e1, o, s), va(r, 3 * o, 3 * s), va(r, 3 * o + 1, 3 * s + 1), va(r, 3 * o + 2, 3 * s + 2);
                    }
                    s - n < i - s ? (t1(e1, r, n, s), n = s + 1) : (t1(e1, r, s + 1, i), i = s);
                }
            }(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                ids: r,
                positions: n
            };
        }, ya.deserialize = function(t1) {
            var e1 = new ya;
            return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
        };
        var da = Math.pow(2, 53) - 1;
        function ma(t1) {
            var e1 = +t1;
            return !isNaN(e1) && e1 <= da ? e1 : ha(String(t1));
        }
        function va(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        On("FeaturePositionMap", ya);
        var ga = function(t1, e1) {
            this.gl = t1.gl, this.location = e1;
        }, xa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = 0;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1i(this.location, t1));
            }, e1;
        }(ga), ba = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = 0;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1f(this.location, t1));
            }, e1;
        }(ga), wa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = [
                    0,
                    0
                ];
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] || (this.current = t1, this.gl.uniform2f(this.location, t1[0], t1[1]));
            }, e1;
        }(ga), _a = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = [
                    0,
                    0,
                    0
                ];
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] || (this.current = t1, this.gl.uniform3f(this.location, t1[0], t1[1], t1[2]));
            }, e1;
        }(ga), Aa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] && t1[3] === this.current[3] || (this.current = t1, this.gl.uniform4f(this.location, t1[0], t1[1], t1[2], t1[3]));
            }, e1;
        }(ga), Sa = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = te.transparent;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                t1.r === this.current.r && t1.g === this.current.g && t1.b === this.current.b && t1.a === this.current.a || (this.current = t1, this.gl.uniform4f(this.location, t1.r, t1.g, t1.b, t1.a));
            }, e1;
        }(ga), ka = new Float32Array(16), Ia = function(t1) {
            function e1(e1, r) {
                t1.call(this, e1, r), this.current = ka;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                if (t1[12] !== this.current[12] || t1[0] !== this.current[0]) return this.current = t1, void this.gl.uniformMatrix4fv(this.location, !1, t1);
                for(var e1 = 1; e1 < 16; e1++)if (t1[e1] !== this.current[e1]) {
                    this.current = t1, this.gl.uniformMatrix4fv(this.location, !1, t1);
                    break;
                }
            }, e1;
        }(ga);
        function za(t1) {
            return [
                ua(255 * t1.r, 255 * t1.g),
                ua(255 * t1.b, 255 * t1.a)
            ];
        }
        var Ca = function(t1, e1, r) {
            this.value = t1, this.uniformNames = e1.map(function(t1) {
                return "u_" + t1;
            }), this.type = r;
        };
        Ca.prototype.setUniform = function(t1, e1, r) {
            t1.set(r.constantOr(this.value));
        }, Ca.prototype.getBinding = function(t1, e1, r) {
            return "color" === this.type ? new Sa(t1, e1) : new ba(t1, e1);
        };
        var Ea = function(t1, e1) {
            this.uniformNames = e1.map(function(t1) {
                return "u_" + t1;
            }), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
        };
        Ea.prototype.setConstantPatternPositions = function(t1, e1) {
            this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t1.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t1.tlbr;
        }, Ea.prototype.setUniform = function(t1, e1, r, n) {
            var i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
            i && t1.set(i);
        }, Ea.prototype.getBinding = function(t1, e1, r) {
            return "u_pattern" === r.substr(0, 9) ? new Aa(t1, e1) : new ba(t1, e1);
        };
        var Pa = function(t1, e1, r, n) {
            this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                return {
                    name: "a_" + t1,
                    type: "Float32",
                    components: "color" === r ? 2 : 1,
                    offset: 0
                };
            }), this.paintVertexArray = new n;
        };
        Pa.prototype.populatePaintArray = function(t1, e1, r, n, i) {
            var a = this.paintVertexArray.length, o = this.expression.evaluate(new si(0), e1, {}, n, [], i);
            this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, o);
        }, Pa.prototype.updatePaintArray = function(t1, e1, r, n) {
            var i = this.expression.evaluate({
                zoom: 0
            }, r, n);
            this._setPaintValue(t1, e1, i);
        }, Pa.prototype._setPaintValue = function(t1, e1, r) {
            if ("color" === this.type) for(var n = za(r), i = t1; i < e1; i++)this.paintVertexArray.emplace(i, n[0], n[1]);
            else {
                for(var a = t1; a < e1; a++)this.paintVertexArray.emplace(a, r);
                this.maxValue = Math.max(this.maxValue, Math.abs(r));
            }
        }, Pa.prototype.upload = function(t1) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }, Pa.prototype.destroy = function() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        };
        var Ma = function(t1, e1, r, n, i, a) {
            this.expression = t1, this.uniformNames = e1.map(function(t1) {
                return "u_" + t1 + "_t";
            }), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                return {
                    name: "a_" + t1,
                    type: "Float32",
                    components: "color" === r ? 4 : 2,
                    offset: 0
                };
            }), this.paintVertexArray = new a;
        };
        Ma.prototype.populatePaintArray = function(t1, e1, r, n, i) {
            var a = this.expression.evaluate(new si(this.zoom), e1, {}, n, [], i), o = this.expression.evaluate(new si(this.zoom + 1), e1, {}, n, [], i), s = this.paintVertexArray.length;
            this.paintVertexArray.resize(t1), this._setPaintValue(s, t1, a, o);
        }, Ma.prototype.updatePaintArray = function(t1, e1, r, n) {
            var i = this.expression.evaluate({
                zoom: this.zoom
            }, r, n), a = this.expression.evaluate({
                zoom: this.zoom + 1
            }, r, n);
            this._setPaintValue(t1, e1, i, a);
        }, Ma.prototype._setPaintValue = function(t1, e1, r, n) {
            if ("color" === this.type) for(var i = za(r), a = za(n), o = t1; o < e1; o++)this.paintVertexArray.emplace(o, i[0], i[1], a[0], a[1]);
            else {
                for(var s = t1; s < e1; s++)this.paintVertexArray.emplace(s, r, n);
                this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
            }
        }, Ma.prototype.upload = function(t1) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }, Ma.prototype.destroy = function() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }, Ma.prototype.setUniform = function(t1, e1) {
            var r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, n = p(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
            t1.set(n);
        }, Ma.prototype.getBinding = function(t1, e1, r) {
            return new ba(t1, e1);
        };
        var Ba = function(t1, e1, r, n, i, a) {
            this.expression = t1, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
        };
        Ba.prototype.populatePaintArray = function(t1, e1, r) {
            var n = this.zoomInPaintVertexArray.length;
            this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
        }, Ba.prototype.updatePaintArray = function(t1, e1, r, n, i) {
            this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], i);
        }, Ba.prototype._setPaintValues = function(t1, e1, r, n) {
            if (n && r) {
                var i = n[r.min], a = n[r.mid], o = n[r.max];
                if (i && a && o) for(var s = t1; s < e1; s++)this.zoomInPaintVertexArray.emplace(s, a.tl[0], a.tl[1], a.br[0], a.br[1], i.tl[0], i.tl[1], i.br[0], i.br[1], a.pixelRatio, i.pixelRatio), this.zoomOutPaintVertexArray.emplace(s, a.tl[0], a.tl[1], a.br[0], a.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], a.pixelRatio, o.pixelRatio);
            }
        }, Ba.prototype.upload = function(t1) {
            this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, la.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, la.members, this.expression.isStateDependent));
        }, Ba.prototype.destroy = function() {
            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
        };
        var Ta = function(t1, e1, r) {
            this.binders = {}, this._buffers = [];
            var n = [];
            for(var i in t1.paint._values)if (r(i)) {
                var a = t1.paint.get(i);
                if (a instanceof yi && Tr(a.property.specification)) {
                    var o = Fa(i, t1.type), s = a.value, u = a.property.specification.type, l = a.property.useIntegerZoom, p = a.property.specification["property-type"], c = "cross-faded" === p || "cross-faded-data-driven" === p;
                    if ("constant" === s.kind) this.binders[i] = c ? new Ea(s.value, o) : new Ca(s.value, o, u), n.push("/u_" + i);
                    else if ("source" === s.kind || c) {
                        var h = Da(i, u, "source");
                        this.binders[i] = c ? new Ba(s, u, l, e1, h, t1.id) : new Pa(s, o, u, h), n.push("/a_" + i);
                    } else {
                        var f = Da(i, u, "composite");
                        this.binders[i] = new Ma(s, o, u, l, e1, f), n.push("/z_" + i);
                    }
                }
            }
            this.cacheKey = n.sort().join("");
        };
        Ta.prototype.getMaxValue = function(t1) {
            var e1 = this.binders[t1];
            return e1 instanceof Pa || e1 instanceof Ma ? e1.maxValue : 0;
        }, Ta.prototype.populatePaintArrays = function(t1, e1, r, n, i) {
            for(var a in this.binders){
                var o = this.binders[a];
                (o instanceof Pa || o instanceof Ma || o instanceof Ba) && o.populatePaintArray(t1, e1, r, n, i);
            }
        }, Ta.prototype.setConstantPatternPositions = function(t1, e1) {
            for(var r in this.binders){
                var n = this.binders[r];
                n instanceof Ea && n.setConstantPatternPositions(t1, e1);
            }
        }, Ta.prototype.updatePaintArrays = function(t1, e1, r, n, i) {
            var a = !1;
            for(var o in t1)for(var s = 0, u = e1.getPositions(o); s < u.length; s += 1){
                var l = u[s], p = r.feature(l.index);
                for(var c in this.binders){
                    var h = this.binders[c];
                    if ((h instanceof Pa || h instanceof Ma || h instanceof Ba) && !0 === h.expression.isStateDependent) {
                        var f = n.paint.get(c);
                        h.expression = f.value, h.updatePaintArray(l.start, l.end, p, t1[o], i), a = !0;
                    }
                }
            }
            return a;
        }, Ta.prototype.defines = function() {
            var t1 = [];
            for(var e1 in this.binders){
                var r = this.binders[e1];
                (r instanceof Ca || r instanceof Ea) && t1.push.apply(t1, r.uniformNames.map(function(t1) {
                    return "#define HAS_UNIFORM_" + t1;
                }));
            }
            return t1;
        }, Ta.prototype.getBinderAttributes = function() {
            var t1 = [];
            for(var e1 in this.binders){
                var r = this.binders[e1];
                if (r instanceof Pa || r instanceof Ma) for(var n = 0; n < r.paintVertexAttributes.length; n++)t1.push(r.paintVertexAttributes[n].name);
                else if (r instanceof Ba) for(var i = 0; i < la.members.length; i++)t1.push(la.members[i].name);
            }
            return t1;
        }, Ta.prototype.getBinderUniforms = function() {
            var t1 = [];
            for(var e1 in this.binders){
                var r = this.binders[e1];
                if (r instanceof Ca || r instanceof Ea || r instanceof Ma) for(var n = 0, i = r.uniformNames; n < i.length; n += 1)t1.push(i[n]);
            }
            return t1;
        }, Ta.prototype.getPaintVertexBuffers = function() {
            return this._buffers;
        }, Ta.prototype.getUniforms = function(t1, e1) {
            var r = [];
            for(var n in this.binders){
                var i = this.binders[n];
                if (i instanceof Ca || i instanceof Ea || i instanceof Ma) for(var a = 0, o = i.uniformNames; a < o.length; a += 1){
                    var s = o[a];
                    if (e1[s]) {
                        var u = i.getBinding(t1, e1[s], s);
                        r.push({
                            name: s,
                            property: n,
                            binding: u
                        });
                    }
                }
            }
            return r;
        }, Ta.prototype.setUniforms = function(t1, e1, r, n) {
            for(var i = 0, a = e1; i < a.length; i += 1){
                var o = a[i], s = o.name, u = o.property;
                this.binders[u].setUniform(o.binding, n, r.get(u), s);
            }
        }, Ta.prototype.updatePaintBuffers = function(t1) {
            for(var e1 in this._buffers = [], this.binders){
                var r = this.binders[e1];
                if (t1 && r instanceof Ba) {
                    var n = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                    n && this._buffers.push(n);
                } else (r instanceof Pa || r instanceof Ma) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
            }
        }, Ta.prototype.upload = function(t1) {
            for(var e1 in this.binders){
                var r = this.binders[e1];
                (r instanceof Pa || r instanceof Ma || r instanceof Ba) && r.upload(t1);
            }
            this.updatePaintBuffers();
        }, Ta.prototype.destroy = function() {
            for(var t1 in this.binders){
                var e1 = this.binders[t1];
                (e1 instanceof Pa || e1 instanceof Ma || e1 instanceof Ba) && e1.destroy();
            }
        };
        var Va = function(t1, e1, r) {
            void 0 === r && (r = function() {
                return !0;
            }), this.programConfigurations = {};
            for(var n = 0, i = t1; n < i.length; n += 1){
                var a = i[n];
                this.programConfigurations[a.id] = new Ta(a, e1, r);
            }
            this.needsUpload = !1, this._featureMap = new ya, this._bufferOffset = 0;
        };
        function Fa(t1, e1) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t1] || [
                t1.replace(e1 + "-", "").replace(/-/g, "_")
            ];
        }
        function Da(t1, e1, r) {
            var n = {
                color: {
                    source: Bi,
                    composite: Hi
                },
                number: {
                    source: Ki,
                    composite: Bi
                }
            }, i = function(t1) {
                return ({
                    "line-pattern": {
                        source: Ti,
                        composite: Ti
                    },
                    "fill-pattern": {
                        source: Ti,
                        composite: Ti
                    },
                    "fill-extrusion-pattern": {
                        source: Ti,
                        composite: Ti
                    }
                })[t1];
            }(t1);
            return i && i[r] || n[e1][r];
        }
        Va.prototype.populatePaintArrays = function(t1, e1, r, n, i, a) {
            for(var o in this.programConfigurations)this.programConfigurations[o].populatePaintArrays(t1, e1, n, i, a);
            void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
        }, Va.prototype.updatePaintArrays = function(t1, e1, r, n) {
            for(var i = 0, a = r; i < a.length; i += 1){
                var o = a[i];
                this.needsUpload = this.programConfigurations[o.id].updatePaintArrays(t1, this._featureMap, e1, o, n) || this.needsUpload;
            }
        }, Va.prototype.get = function(t1) {
            return this.programConfigurations[t1];
        }, Va.prototype.upload = function(t1) {
            if (this.needsUpload) {
                for(var e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                this.needsUpload = !1;
            }
        }, Va.prototype.destroy = function() {
            for(var t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
        }, On("ConstantBinder", Ca), On("CrossFadedConstantBinder", Ea), On("SourceExpressionBinder", Pa), On("CrossFadedCompositeBinder", Ba), On("CompositeExpressionBinder", Ma), On("ProgramConfiguration", Ta, {
            omit: [
                "_buffers"
            ]
        }), On("ProgramConfigurationSet", Va);
        var La = Math.pow(2, 14) - 1, Oa = -La - 1;
        function Ra(t1) {
            for(var e1 = 8192 / t1.extent, r = t1.loadGeometry(), n = 0; n < r.length; n++)for(var i = r[n], a = 0; a < i.length; a++){
                var o = i[a], s = Math.round(o.x * e1), u = Math.round(o.y * e1);
                o.x = p(s, Oa, La), o.y = p(u, Oa, La), (s < o.x || s > o.x + 1 || u < o.y || u > o.y + 1) && A("Geometry exceeds allowed extent, reduce your vector tile buffer size");
            }
            return r;
        }
        function Ua(t1, e1) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e1 ? Ra(t1) : []
            };
        }
        function ja(t1, e1, r, n, i) {
            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        var qa = function(t1) {
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new Ci, this.indexArray = new ji, this.segments = new sa, this.programConfigurations = new Va(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        function Na(t1, e1) {
            for(var r = 0; r < t1.length; r++)if (Wa(e1, t1[r])) return !0;
            for(var n = 0; n < e1.length; n++)if (Wa(t1, e1[n])) return !0;
            return !!Xa(t1, e1);
        }
        function Ka(t1, e1, r) {
            return !!Wa(t1, e1) || !!Ha(e1, t1, r);
        }
        function Ga(t1, e1) {
            if (1 === t1.length) return $a(e1, t1[0]);
            for(var r = 0; r < e1.length; r++)for(var n = e1[r], i = 0; i < n.length; i++)if (Wa(t1, n[i])) return !0;
            for(var a = 0; a < t1.length; a++)if ($a(e1, t1[a])) return !0;
            for(var o = 0; o < e1.length; o++)if (Xa(t1, e1[o])) return !0;
            return !1;
        }
        function Za(t1, e1, r) {
            if (t1.length > 1) {
                if (Xa(t1, e1)) return !0;
                for(var n = 0; n < e1.length; n++)if (Ha(e1[n], t1, r)) return !0;
            }
            for(var i = 0; i < t1.length; i++)if (Ha(t1[i], e1, r)) return !0;
            return !1;
        }
        function Xa(t1, e1) {
            if (0 === t1.length || 0 === e1.length) return !1;
            for(var r = 0; r < t1.length - 1; r++)for(var n = t1[r], i = t1[r + 1], a = 0; a < e1.length - 1; a++)if (Ja(n, i, e1[a], e1[a + 1])) return !0;
            return !1;
        }
        function Ja(t1, e1, r, n) {
            return S(t1, r, n) !== S(e1, r, n) && S(t1, e1, r) !== S(t1, e1, n);
        }
        function Ha(t1, e1, r) {
            var n = r * r;
            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
            for(var i = 1; i < e1.length; i++)if (Ya(t1, e1[i - 1], e1[i]) < n) return !0;
            return !1;
        }
        function Ya(t1, e1, r) {
            var n = e1.distSqr(r);
            if (0 === n) return t1.distSqr(e1);
            var i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
            return t1.distSqr(i < 0 ? e1 : i > 1 ? r : r.sub(e1)._mult(i)._add(e1));
        }
        function $a(t1, e1) {
            for(var r, n, i, a = !1, o = 0; o < t1.length; o++)for(var s = 0, u = (r = t1[o]).length - 1; s < r.length; u = s++)(n = r[s]).y > e1.y != (i = r[u]).y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (a = !a);
            return a;
        }
        function Wa(t1, e1) {
            for(var r = !1, n = 0, i = t1.length - 1; n < t1.length; i = n++){
                var a = t1[n], o = t1[i];
                a.y > e1.y != o.y > e1.y && e1.x < (o.x - a.x) * (e1.y - a.y) / (o.y - a.y) + a.x && (r = !r);
            }
            return r;
        }
        function Qa(t1, e1, r) {
            var n = r[0], i = r[2];
            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
            var a = S(t1, e1, r[0]);
            return a !== S(t1, e1, r[1]) || a !== S(t1, e1, r[2]) || a !== S(t1, e1, r[3]);
        }
        function to(t1, e1, r) {
            var n = e1.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
        }
        function eo(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function ro(t1, e1, r, n, a) {
            if (!e1[0] && !e1[1]) return t1;
            var o = i.convert(e1)._mult(a);
            "viewport" === r && o._rotate(-n);
            for(var s = [], u = 0; u < t1.length; u++)s.push(t1[u].sub(o));
            return s;
        }
        qa.prototype.populate = function(t1, e1, r) {
            var n = this.layers[0], i = [], a = null;
            "circle" === n.type && (a = n.layout.get("circle-sort-key"));
            for(var o = 0, s = t1; o < s.length; o += 1){
                var u = s[o], l = u.feature, p = u.id, c = u.index, h = u.sourceLayerIndex, f = this.layers[0]._featureFilter.needGeometry, y = Ua(l, f);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), y, r)) {
                    var d = a ? a.evaluate(y, {}, r) : void 0, m = {
                        id: p,
                        properties: l.properties,
                        type: l.type,
                        sourceLayerIndex: h,
                        index: c,
                        geometry: f ? y.geometry : Ra(l),
                        patterns: {},
                        sortKey: d
                    };
                    i.push(m);
                }
            }
            a && i.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var v = 0, g = i; v < g.length; v += 1){
                var x = g[v], b = x.geometry, w = x.index, _ = x.sourceLayerIndex, A = t1[w].feature;
                this.addFeature(x, b, w, r), e1.featureIndex.insert(A, b, w, _, this.index);
            }
        }, qa.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, qa.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, qa.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, qa.prototype.upload = function(t1) {
            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, oa), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, qa.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }, qa.prototype.addFeature = function(t1, e1, r, n) {
            for(var i = 0, a = e1; i < a.length; i += 1)for(var o = 0, s = a[i]; o < s.length; o += 1){
                var u = s[o], l = u.x, p = u.y;
                if (!(l < 0 || l >= 8192 || p < 0 || p >= 8192)) {
                    var c = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), h = c.vertexLength;
                    ja(this.layoutVertexArray, l, p, -1, -1), ja(this.layoutVertexArray, l, p, 1, -1), ja(this.layoutVertexArray, l, p, 1, 1), ja(this.layoutVertexArray, l, p, -1, 1), this.indexArray.emplaceBack(h, h + 1, h + 2), this.indexArray.emplaceBack(h, h + 3, h + 2), c.vertexLength += 4, c.primitiveLength += 2;
                }
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n);
        }, On("CircleBucket", qa, {
            omit: [
                "layers"
            ]
        });
        var no = new wi({
            "circle-sort-key": new vi(Et.layout_circle["circle-sort-key"])
        }), io = {
            paint: new wi({
                "circle-radius": new vi(Et.paint_circle["circle-radius"]),
                "circle-color": new vi(Et.paint_circle["circle-color"]),
                "circle-blur": new vi(Et.paint_circle["circle-blur"]),
                "circle-opacity": new vi(Et.paint_circle["circle-opacity"]),
                "circle-translate": new mi(Et.paint_circle["circle-translate"]),
                "circle-translate-anchor": new mi(Et.paint_circle["circle-translate-anchor"]),
                "circle-pitch-scale": new mi(Et.paint_circle["circle-pitch-scale"]),
                "circle-pitch-alignment": new mi(Et.paint_circle["circle-pitch-alignment"]),
                "circle-stroke-width": new vi(Et.paint_circle["circle-stroke-width"]),
                "circle-stroke-color": new vi(Et.paint_circle["circle-stroke-color"]),
                "circle-stroke-opacity": new vi(Et.paint_circle["circle-stroke-opacity"])
            }),
            layout: no
        }, ao = "undefined" != typeof Float32Array ? Float32Array : Array;
        function oo(t1) {
            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function so(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], u = e1[5], l = e1[6], p = e1[7], c = e1[8], h = e1[9], f = e1[10], y = e1[11], d = e1[12], m = e1[13], v = e1[14], g = e1[15], x = r[0], b = r[1], w = r[2], _ = r[3];
            return t1[0] = x * n + b * s + w * c + _ * d, t1[1] = x * i + b * u + w * h + _ * m, t1[2] = x * a + b * l + w * f + _ * v, t1[3] = x * o + b * p + w * y + _ * g, t1[4] = (x = r[4]) * n + (b = r[5]) * s + (w = r[6]) * c + (_ = r[7]) * d, t1[5] = x * i + b * u + w * h + _ * m, t1[6] = x * a + b * l + w * f + _ * v, t1[7] = x * o + b * p + w * y + _ * g, t1[8] = (x = r[8]) * n + (b = r[9]) * s + (w = r[10]) * c + (_ = r[11]) * d, t1[9] = x * i + b * u + w * h + _ * m, t1[10] = x * a + b * l + w * f + _ * v, t1[11] = x * o + b * p + w * y + _ * g, t1[12] = (x = r[12]) * n + (b = r[13]) * s + (w = r[14]) * c + (_ = r[15]) * d, t1[13] = x * i + b * u + w * h + _ * m, t1[14] = x * a + b * l + w * f + _ * v, t1[15] = x * o + b * p + w * y + _ * g, t1;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t1 = arguments, e1 = 0, r = arguments.length; r--;)e1 += t1[r] * t1[r];
            return Math.sqrt(e1);
        });
        var uo, lo = so;
        function po(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = e1[3];
            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t1;
        }
        uo = new ao(3), ao != Float32Array && (uo[0] = 0, uo[1] = 0, uo[2] = 0), function() {
            var t1 = new ao(4);
            ao != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0);
        }();
        var co = (function() {
            var t1 = new ao(2);
            ao != Float32Array && (t1[0] = 0, t1[1] = 0);
        }(), function(t1) {
            function e1(e1) {
                t1.call(this, e1, io);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.createBucket = function(t1) {
                return new qa(t1);
            }, e1.prototype.queryRadius = function(t1) {
                var e1 = t1;
                return to("circle-radius", this, e1) + to("circle-stroke-width", this, e1) + eo(this.paint.get("circle-translate"));
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o, s) {
                for(var u = ro(t1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, o), l = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r), p = "map" === this.paint.get("circle-pitch-alignment"), c = p ? u : function(t1, e1) {
                    return t1.map(function(t1) {
                        return ho(t1, e1);
                    });
                }(u, s), h = p ? l * o : l, f = 0, y = n; f < y.length; f += 1)for(var d = 0, m = y[f]; d < m.length; d += 1){
                    var v = m[d], g = p ? v : ho(v, s), x = h, b = po([], [
                        v.x,
                        v.y,
                        0,
                        1
                    ], s);
                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? x *= b[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (x *= a.cameraToCenterDistance / b[3]), Ka(c, g, x)) return !0;
                }
                return !1;
            }, e1;
        }(_i));
        function ho(t1, e1) {
            var r = po([], [
                t1.x,
                t1.y,
                0,
                1
            ], e1);
            return new i(r[0] / r[3], r[1] / r[3]);
        }
        var fo = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(qa);
        function yo(t1, e1, r, n) {
            var i = e1.width, a = e1.height;
            if (n) {
                if (n instanceof Uint8ClampedArray) n = new Uint8Array(n.buffer);
                else if (n.length !== i * a * r) throw new RangeError("mismatched image size");
            } else n = new Uint8Array(i * a * r);
            return t1.width = i, t1.height = a, t1.data = n, t1;
        }
        function mo(t1, e1, r) {
            var n = e1.width, i = e1.height;
            if (n !== t1.width || i !== t1.height) {
                var a = yo({}, {
                    width: n,
                    height: i
                }, r);
                vo(t1, a, {
                    x: 0,
                    y: 0
                }, {
                    x: 0,
                    y: 0
                }, {
                    width: Math.min(t1.width, n),
                    height: Math.min(t1.height, i)
                }, r), t1.width = n, t1.height = i, t1.data = a.data;
            }
        }
        function vo(t1, e1, r, n, i, a) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            for(var o = t1.data, s = e1.data, u = 0; u < i.height; u++)for(var l = ((r.y + u) * t1.width + r.x) * a, p = ((n.y + u) * e1.width + n.x) * a, c = 0; c < i.width * a; c++)s[p + c] = o[l + c];
            return e1;
        }
        On("HeatmapBucket", fo, {
            omit: [
                "layers"
            ]
        });
        var go = function(t1, e1) {
            yo(this, t1, 1, e1);
        };
        go.prototype.resize = function(t1) {
            mo(this, t1, 1);
        }, go.prototype.clone = function() {
            return new go({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }, go.copy = function(t1, e1, r, n, i) {
            vo(t1, e1, r, n, i, 1);
        };
        var xo = function(t1, e1) {
            yo(this, t1, 4, e1);
        };
        xo.prototype.resize = function(t1) {
            mo(this, t1, 4);
        }, xo.prototype.replace = function(t1, e1) {
            e1 ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
        }, xo.prototype.clone = function() {
            return new xo({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }, xo.copy = function(t1, e1, r, n, i) {
            vo(t1, e1, r, n, i, 4);
        }, On("AlphaImage", go), On("RGBAImage", xo);
        var bo = {
            paint: new wi({
                "heatmap-radius": new vi(Et.paint_heatmap["heatmap-radius"]),
                "heatmap-weight": new vi(Et.paint_heatmap["heatmap-weight"]),
                "heatmap-intensity": new mi(Et.paint_heatmap["heatmap-intensity"]),
                "heatmap-color": new bi(Et.paint_heatmap["heatmap-color"]),
                "heatmap-opacity": new mi(Et.paint_heatmap["heatmap-opacity"])
            })
        };
        function wo(t1) {
            var e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new xo({
                width: r,
                height: n
            }), a = function(r, n, a) {
                e1[t1.evaluationKey] = a;
                var o = t1.expression.evaluate(e1);
                i.data[r + n + 0] = Math.floor(255 * o.r / o.a), i.data[r + n + 1] = Math.floor(255 * o.g / o.a), i.data[r + n + 2] = Math.floor(255 * o.b / o.a), i.data[r + n + 3] = Math.floor(255 * o.a);
            };
            if (t1.clips) for(var o = 0, s = 0; o < n; ++o, s += 4 * r)for(var u = 0, l = 0; u < r; u++, l += 4){
                var p = u / (r - 1), c = t1.clips[o];
                a(s, l, c.start * (1 - p) + c.end * p);
            }
            else for(var h = 0, f = 0; h < r; h++, f += 4)a(0, f, h / (r - 1));
            return i;
        }
        var _o = function(t1) {
            function e1(e1) {
                t1.call(this, e1, bo), this._updateColorRamp();
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.createBucket = function(t1) {
                return new fo(t1);
            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                "heatmap-color" === t1 && this._updateColorRamp();
            }, e1.prototype._updateColorRamp = function() {
                this.colorRamp = wo({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }, e1.prototype.resize = function() {
                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
            }, e1.prototype.queryRadius = function() {
                return 0;
            }, e1.prototype.queryIntersectsFeature = function() {
                return !1;
            }, e1.prototype.hasOffscreenPass = function() {
                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }, e1;
        }(_i), Ao = {
            paint: new wi({
                "hillshade-illumination-direction": new mi(Et.paint_hillshade["hillshade-illumination-direction"]),
                "hillshade-illumination-anchor": new mi(Et.paint_hillshade["hillshade-illumination-anchor"]),
                "hillshade-exaggeration": new mi(Et.paint_hillshade["hillshade-exaggeration"]),
                "hillshade-shadow-color": new mi(Et.paint_hillshade["hillshade-shadow-color"]),
                "hillshade-highlight-color": new mi(Et.paint_hillshade["hillshade-highlight-color"]),
                "hillshade-accent-color": new mi(Et.paint_hillshade["hillshade-accent-color"])
            })
        }, So = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Ao);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.hasOffscreenPass = function() {
                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }, e1;
        }(_i), ko = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4).members, Io = Co, zo = Co;
        function Co(t1, e1, r) {
            r = r || 2;
            var n, i, a, o, s, u, l, p = e1 && e1.length, c = p ? e1[0] * r : t1.length, h = Eo(t1, 0, c, r, !0), f = [];
            if (!h || h.next === h.prev) return f;
            if (p && (h = function(t1, e1, r, n) {
                var i, a, o, s = [];
                for(i = 0, a = e1.length; i < a; i++)(o = Eo(t1, e1[i] * n, i < a - 1 ? e1[i + 1] * n : t1.length, n, !1)) === o.next && (o.steiner = !0), s.push(Uo(o));
                for(s.sort(Do), i = 0; i < s.length; i++)Lo(s[i], r), r = Po(r, r.next);
                return r;
            }(t1, e1, h, r)), t1.length > 80 * r) {
                n = a = t1[0], i = o = t1[1];
                for(var y = r; y < c; y += r)(s = t1[y]) < n && (n = s), (u = t1[y + 1]) < i && (i = u), s > a && (a = s), u > o && (o = u);
                l = 0 !== (l = Math.max(a - n, o - i)) ? 1 / l : 0;
            }
            return Mo(h, f, r, n, i, l), f;
        }
        function Eo(t1, e1, r, n, i) {
            var a, o;
            if (i === Qo(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)o = Yo(a, t1[a], t1[a + 1], o);
            else for(a = r - n; a >= e1; a -= n)o = Yo(a, t1[a], t1[a + 1], o);
            return o && Ko(o, o.next) && ($o(o), o = o.next), o;
        }
        function Po(t1, e1) {
            if (!t1) return t1;
            e1 || (e1 = t1);
            var r, n = t1;
            do if (r = !1, n.steiner || !Ko(n, n.next) && 0 !== No(n.prev, n, n.next)) n = n.next;
            else {
                if ($o(n), (n = e1 = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e1);
            return e1;
        }
        function Mo(t1, e1, r, n, i, a, o) {
            if (t1) {
                !o && a && function(t1, e1, r, n) {
                    var i = t1;
                    do null === i.z && (i.z = Ro(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t1);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                        var e1, r, n, i, a, o, s, u, l = 1;
                        do {
                            for(r = t1, t1 = null, a = null, o = 0; r;){
                                for(o++, n = r, s = 0, e1 = 0; e1 < l && (s++, n = n.nextZ); e1++);
                                for(u = l; s > 0 || u > 0 && n;)0 !== s && (0 === u || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, u--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                r = n;
                            }
                            a.nextZ = null, l *= 2;
                        }while (o > 1);
                    }(i);
                }(t1, n, i, a);
                for(var s, u, l = t1; t1.prev !== t1.next;)if (s = t1.prev, u = t1.next, a ? To(t1, n, i, a) : Bo(t1)) e1.push(s.i / r), e1.push(t1.i / r), e1.push(u.i / r), $o(t1), t1 = u.next, l = u.next;
                else if ((t1 = u) === l) {
                    o ? 1 === o ? Mo(t1 = Vo(Po(t1), e1, r), e1, r, n, i, a, 2) : 2 === o && Fo(t1, e1, r, n, i, a) : Mo(Po(t1), e1, r, n, i, a, 1);
                    break;
                }
            }
        }
        function Bo(t1) {
            var e1 = t1.prev, r = t1, n = t1.next;
            if (No(e1, r, n) >= 0) return !1;
            for(var i = t1.next.next; i !== t1.prev;){
                if (jo(e1.x, e1.y, r.x, r.y, n.x, n.y, i.x, i.y) && No(i.prev, i, i.next) >= 0) return !1;
                i = i.next;
            }
            return !0;
        }
        function To(t1, e1, r, n) {
            var i = t1.prev, a = t1, o = t1.next;
            if (No(i, a, o) >= 0) return !1;
            for(var s = i.x > a.x ? i.x > o.x ? i.x : o.x : a.x > o.x ? a.x : o.x, u = i.y > a.y ? i.y > o.y ? i.y : o.y : a.y > o.y ? a.y : o.y, l = Ro(i.x < a.x ? i.x < o.x ? i.x : o.x : a.x < o.x ? a.x : o.x, i.y < a.y ? i.y < o.y ? i.y : o.y : a.y < o.y ? a.y : o.y, e1, r, n), p = Ro(s, u, e1, r, n), c = t1.prevZ, h = t1.nextZ; c && c.z >= l && h && h.z <= p;){
                if (c !== t1.prev && c !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, c.x, c.y) && No(c.prev, c, c.next) >= 0) return !1;
                if (c = c.prevZ, h !== t1.prev && h !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, h.x, h.y) && No(h.prev, h, h.next) >= 0) return !1;
                h = h.nextZ;
            }
            for(; c && c.z >= l;){
                if (c !== t1.prev && c !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, c.x, c.y) && No(c.prev, c, c.next) >= 0) return !1;
                c = c.prevZ;
            }
            for(; h && h.z <= p;){
                if (h !== t1.prev && h !== t1.next && jo(i.x, i.y, a.x, a.y, o.x, o.y, h.x, h.y) && No(h.prev, h, h.next) >= 0) return !1;
                h = h.nextZ;
            }
            return !0;
        }
        function Vo(t1, e1, r) {
            var n = t1;
            do {
                var i = n.prev, a = n.next.next;
                !Ko(i, a) && Go(i, n, n.next, a) && Jo(i, a) && Jo(a, i) && (e1.push(i.i / r), e1.push(n.i / r), e1.push(a.i / r), $o(n), $o(n.next), n = t1 = a), n = n.next;
            }while (n !== t1);
            return Po(n);
        }
        function Fo(t1, e1, r, n, i, a) {
            var o = t1;
            do {
                for(var s = o.next.next; s !== o.prev;){
                    if (o.i !== s.i && qo(o, s)) {
                        var u = Ho(o, s);
                        return o = Po(o, o.next), u = Po(u, u.next), Mo(o, e1, r, n, i, a), void Mo(u, e1, r, n, i, a);
                    }
                    s = s.next;
                }
                o = o.next;
            }while (o !== t1);
        }
        function Do(t1, e1) {
            return t1.x - e1.x;
        }
        function Lo(t1, e1) {
            if (e1 = function(t1, e1) {
                var r, n = e1, i = t1.x, a = t1.y, o = -1 / 0;
                do {
                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                        var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (s <= i && s > o) {
                            if (o = s, s === i) {
                                if (a === n.y) return n;
                                if (a === n.next.y) return n.next;
                            }
                            r = n.x < n.next.x ? n : n.next;
                        }
                    }
                    n = n.next;
                }while (n !== e1);
                if (!r) return null;
                if (i === o) return r;
                var u, l = r, p = r.x, c = r.y, h = 1 / 0;
                n = r;
                do i >= n.x && n.x >= p && i !== n.x && jo(a < c ? i : o, a, p, c, a < c ? o : i, a, n.x, n.y) && (u = Math.abs(a - n.y) / (i - n.x), Jo(n, t1) && (u < h || u === h && (n.x > r.x || n.x === r.x && Oo(r, n))) && (r = n, h = u)), n = n.next;
                while (n !== l);
                return r;
            }(t1, e1)) {
                var r = Ho(e1, t1);
                Po(e1, e1.next), Po(r, r.next);
            }
        }
        function Oo(t1, e1) {
            return No(t1.prev, t1, e1.prev) < 0 && No(e1.next, t1, t1.next) < 0;
        }
        function Ro(t1, e1, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = 32767 * (t1 - r) * i) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = 32767 * (e1 - n) * i) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function Uo(t1) {
            var e1 = t1, r = t1;
            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
            while (e1 !== t1);
            return r;
        }
        function jo(t1, e1, r, n, i, a, o, s) {
            return (i - o) * (e1 - s) - (t1 - o) * (a - s) >= 0 && (t1 - o) * (n - s) - (r - o) * (e1 - s) >= 0 && (r - o) * (a - s) - (i - o) * (n - s) >= 0;
        }
        function qo(t1, e1) {
            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                var r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && Go(r, r.next, t1, e1)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e1) && (Jo(t1, e1) && Jo(e1, t1) && function(t1, e1) {
                var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e1) && (No(t1.prev, t1, e1.prev) || No(t1, e1.prev, e1)) || Ko(t1, e1) && No(t1.prev, t1, t1.next) > 0 && No(e1.prev, e1, e1.next) > 0);
        }
        function No(t1, e1, r) {
            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
        }
        function Ko(t1, e1) {
            return t1.x === e1.x && t1.y === e1.y;
        }
        function Go(t1, e1, r, n) {
            var i = Xo(No(t1, e1, r)), a = Xo(No(t1, e1, n)), o = Xo(No(r, n, t1)), s = Xo(No(r, n, e1));
            return i !== a && o !== s || !(0 !== i || !Zo(t1, r, e1)) || !(0 !== a || !Zo(t1, n, e1)) || !(0 !== o || !Zo(r, t1, n)) || !(0 !== s || !Zo(r, e1, n));
        }
        function Zo(t1, e1, r) {
            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
        }
        function Xo(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function Jo(t1, e1) {
            return No(t1.prev, t1, t1.next) < 0 ? No(t1, e1, t1.next) >= 0 && No(t1, t1.prev, e1) >= 0 : No(t1, e1, t1.prev) < 0 || No(t1, t1.next, e1) < 0;
        }
        function Ho(t1, e1) {
            var r = new Wo(t1.i, t1.x, t1.y), n = new Wo(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
        }
        function Yo(t1, e1, r, n) {
            var i = new Wo(t1, e1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function $o(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Wo(t1, e1, r) {
            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Qo(t1, e1, r, n) {
            for(var i = 0, a = e1, o = r - n; a < r; a += n)i += (t1[o] - t1[a]) * (t1[a + 1] + t1[o + 1]), o = a;
            return i;
        }
        function ts(t1, e1, r, n, i) {
            !function t1(e1, r, n, i, a) {
                for(; i > n;){
                    if (i - n > 600) {
                        var o = i - n + 1, s = r - n + 1, u = Math.log(o), l = .5 * Math.exp(2 * u / 3), p = .5 * Math.sqrt(u * l * (o - l) / o) * (s - o / 2 < 0 ? -1 : 1);
                        t1(e1, r, Math.max(n, Math.floor(r - s * l / o + p)), Math.min(i, Math.floor(r + (o - s) * l / o + p)), a);
                    }
                    var c = e1[r], h = n, f = i;
                    for(es(e1, n, r), a(e1[i], c) > 0 && es(e1, n, i); h < f;){
                        for(es(e1, h, f), h++, f--; a(e1[h], c) < 0;)h++;
                        for(; a(e1[f], c) > 0;)f--;
                    }
                    0 === a(e1[n], c) ? es(e1, n, f) : es(e1, ++f, i), f <= r && (n = f + 1), r <= f && (i = f - 1);
                }
            }(t1, e1, r || 0, n || t1.length - 1, i || rs);
        }
        function es(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        function rs(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function ns(t1, e1) {
            var r = t1.length;
            if (r <= 1) return [
                t1
            ];
            for(var n, i, a = [], o = 0; o < r; o++){
                var s = k(t1[o]);
                0 !== s && (t1[o].area = Math.abs(s), void 0 === i && (i = s < 0), i === s < 0 ? (n && a.push(n), n = [
                    t1[o]
                ]) : n.push(t1[o]));
            }
            if (n && a.push(n), e1 > 1) for(var u = 0; u < a.length; u++)a[u].length <= e1 || (ts(a[u], e1, 1, a[u].length - 1, is), a[u] = a[u].slice(0, e1));
            return a;
        }
        function is(t1, e1) {
            return e1.area - t1.area;
        }
        function as(t1, e1, r) {
            for(var n = r.patternDependencies, i = !1, a = 0, o = e1; a < o.length; a += 1){
                var s = o[a].paint.get(t1 + "-pattern");
                s.isConstant() || (i = !0);
                var u = s.constantOr(null);
                u && (i = !0, n[u.to] = !0, n[u.from] = !0);
            }
            return i;
        }
        function os(t1, e1, r, n, i) {
            for(var a = i.patternDependencies, o = 0, s = e1; o < s.length; o += 1){
                var u = s[o], l = u.paint.get(t1 + "-pattern").value;
                if ("constant" !== l.kind) {
                    var p = l.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), c = l.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), h = l.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    c = c && c.name ? c.name : c, h = h && h.name ? h.name : h, a[p = p && p.name ? p.name : p] = !0, a[c] = !0, a[h] = !0, r.patterns[u.id] = {
                        min: p,
                        mid: c,
                        max: h
                    };
                }
            }
            return r;
        }
        Co.deviation = function(t1, e1, r, n) {
            var i = e1 && e1.length, a = Math.abs(Qo(t1, 0, i ? e1[0] * r : t1.length, r));
            if (i) for(var o = 0, s = e1.length; o < s; o++)a -= Math.abs(Qo(t1, e1[o] * r, o < s - 1 ? e1[o + 1] * r : t1.length, r));
            var u = 0;
            for(o = 0; o < n.length; o += 3){
                var l = n[o] * r, p = n[o + 1] * r, c = n[o + 2] * r;
                u += Math.abs((t1[l] - t1[c]) * (t1[p + 1] - t1[l + 1]) - (t1[l] - t1[p]) * (t1[c + 1] - t1[l + 1]));
            }
            return 0 === a && 0 === u ? 0 : Math.abs((u - a) / a);
        }, Co.flatten = function(t1) {
            for(var e1 = t1[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e1
            }, n = 0, i = 0; i < t1.length; i++){
                for(var a = 0; a < t1[i].length; a++)for(var o = 0; o < e1; o++)r.vertices.push(t1[i][a][o]);
                i > 0 && r.holes.push(n += t1[i - 1].length);
            }
            return r;
        }, Io.default = zo;
        var ss = function(t1) {
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Ci, this.indexArray = new ji, this.indexArray2 = new Xi, this.programConfigurations = new Va(t1.layers, t1.zoom), this.segments = new sa, this.segments2 = new sa, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        ss.prototype.populate = function(t1, e1, r) {
            this.hasPattern = as("fill", this.layers, e1);
            for(var n = this.layers[0].layout.get("fill-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                var s = o[a], u = s.feature, l = s.id, p = s.index, c = s.sourceLayerIndex, h = this.layers[0]._featureFilter.needGeometry, f = Ua(u, h);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), f, r)) {
                    var y = n ? n.evaluate(f, {}, r, e1.availableImages) : void 0, d = {
                        id: l,
                        properties: u.properties,
                        type: u.type,
                        sourceLayerIndex: c,
                        index: p,
                        geometry: h ? f.geometry : Ra(u),
                        patterns: {},
                        sortKey: y
                    };
                    i.push(d);
                }
            }
            n && i.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var m = 0, v = i; m < v.length; m += 1){
                var g = v[m], x = g.geometry, b = g.index, w = g.sourceLayerIndex;
                if (this.hasPattern) {
                    var _ = os("fill", this.layers, g, this.zoom, e1);
                    this.patternFeatures.push(_);
                } else this.addFeature(g, x, b, r, {});
                e1.featureIndex.insert(t1[b].feature, x, b, w, this.index);
            }
        }, ss.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, ss.prototype.addFeatures = function(t1, e1, r) {
            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                var a = i[n];
                this.addFeature(a, a.geometry, a.index, e1, r);
            }
        }, ss.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, ss.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, ss.prototype.upload = function(t1) {
            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ko), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, ss.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
        }, ss.prototype.addFeature = function(t1, e1, r, n, i) {
            for(var a = 0, o = ns(e1, 500); a < o.length; a += 1){
                for(var s = o[a], u = 0, l = 0, p = s; l < p.length; l += 1)u += p[l].length;
                for(var c = this.segments.prepareSegment(u, this.layoutVertexArray, this.indexArray), h = c.vertexLength, f = [], y = [], d = 0, m = s; d < m.length; d += 1){
                    var v = m[d];
                    if (0 !== v.length) {
                        v !== s[0] && y.push(f.length / 2);
                        var g = this.segments2.prepareSegment(v.length, this.layoutVertexArray, this.indexArray2), x = g.vertexLength;
                        this.layoutVertexArray.emplaceBack(v[0].x, v[0].y), this.indexArray2.emplaceBack(x + v.length - 1, x), f.push(v[0].x), f.push(v[0].y);
                        for(var b = 1; b < v.length; b++)this.layoutVertexArray.emplaceBack(v[b].x, v[b].y), this.indexArray2.emplaceBack(x + b - 1, x + b), f.push(v[b].x), f.push(v[b].y);
                        g.vertexLength += v.length, g.primitiveLength += v.length;
                    }
                }
                for(var w = Io(f, y), _ = 0; _ < w.length; _ += 3)this.indexArray.emplaceBack(h + w[_], h + w[_ + 1], h + w[_ + 2]);
                c.vertexLength += u, c.primitiveLength += w.length / 3;
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
        }, On("FillBucket", ss, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var us = new wi({
            "fill-sort-key": new vi(Et.layout_fill["fill-sort-key"])
        }), ls = {
            paint: new wi({
                "fill-antialias": new mi(Et.paint_fill["fill-antialias"]),
                "fill-opacity": new vi(Et.paint_fill["fill-opacity"]),
                "fill-color": new vi(Et.paint_fill["fill-color"]),
                "fill-outline-color": new vi(Et.paint_fill["fill-outline-color"]),
                "fill-translate": new mi(Et.paint_fill["fill-translate"]),
                "fill-translate-anchor": new mi(Et.paint_fill["fill-translate-anchor"]),
                "fill-pattern": new gi(Et.paint_fill["fill-pattern"])
            }),
            layout: us
        }, ps = function(t1) {
            function e1(e1) {
                t1.call(this, e1, ls);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.recalculate = function(e1, r) {
                t1.prototype.recalculate.call(this, e1, r);
                var n = this.paint._values["fill-outline-color"];
                "constant" === n.value.kind && void 0 === n.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }, e1.prototype.createBucket = function(t1) {
                return new ss(t1);
            }, e1.prototype.queryRadius = function() {
                return eo(this.paint.get("fill-translate"));
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o) {
                return Ga(ro(t1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, o), n);
            }, e1.prototype.isTileClipped = function() {
                return !0;
            }, e1;
        }(_i), cs = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4).members, hs = fs;
        function fs(t1, e1, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(ys, this, e1);
        }
        function ys(t1, e1, r) {
            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                    e1.properties[n] = i;
                }
            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
        }
        function ds(t1) {
            for(var e1, r, n = 0, i = 0, a = t1.length, o = a - 1; i < a; o = i++)n += ((r = t1[o]).x - (e1 = t1[i]).x) * (e1.y + r.y);
            return n;
        }
        fs.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], fs.prototype.loadGeometry = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1, r = t1.readVarint() + t1.pos, n = 1, a = 0, o = 0, s = 0, u = []; t1.pos < r;){
                if (a <= 0) {
                    var l = t1.readVarint();
                    n = 7 & l, a = l >> 3;
                }
                if (a--, 1 === n || 2 === n) o += t1.readSVarint(), s += t1.readSVarint(), 1 === n && (e1 && u.push(e1), e1 = []), e1.push(new i(o, s));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e1 && e1.push(e1[0].clone());
                }
            }
            return e1 && u.push(e1), u;
        }, fs.prototype.bbox = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, o = 1 / 0, s = -1 / 0, u = 1 / 0, l = -1 / 0; t1.pos < e1;){
                if (n <= 0) {
                    var p = t1.readVarint();
                    r = 7 & p, n = p >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < o && (o = i), i > s && (s = i), (a += t1.readSVarint()) < u && (u = a), a > l && (l = a);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                o,
                u,
                s,
                l
            ];
        }, fs.prototype.toGeoJSON = function(t1, e1, r) {
            var n, i, a = this.extent * Math.pow(2, r), o = this.extent * t1, s = this.extent * e1, u = this.loadGeometry(), l = fs.types[this.type];
            function p(t1) {
                for(var e1 = 0; e1 < t1.length; e1++){
                    var r = t1[e1];
                    t1[e1] = [
                        360 * (r.x + o) / a - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + s) / a) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var c = [];
                    for(n = 0; n < u.length; n++)c[n] = u[n][0];
                    p(u = c);
                    break;
                case 2:
                    for(n = 0; n < u.length; n++)p(u[n]);
                    break;
                case 3:
                    for(u = function(t1) {
                        var e1 = t1.length;
                        if (e1 <= 1) return [
                            t1
                        ];
                        for(var r, n, i = [], a = 0; a < e1; a++){
                            var o = ds(t1[a]);
                            0 !== o && (void 0 === n && (n = o < 0), n === o < 0 ? (r && i.push(r), r = [
                                t1[a]
                            ]) : r.push(t1[a]));
                        }
                        return r && i.push(r), i;
                    }(u), n = 0; n < u.length; n++)for(i = 0; i < u[n].length; i++)p(u[n][i]);
            }
            1 === u.length ? u = u[0] : l = "Multi" + l;
            var h = {
                type: "Feature",
                geometry: {
                    type: l,
                    coordinates: u
                },
                properties: this.properties
            };
            return "id" in this && (h.id = this.id), h;
        };
        var ms = vs;
        function vs(t1, e1) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(gs, this, e1), this.length = this._features.length;
        }
        function gs(t1, e1, r) {
            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = t1.readVarint() >> 3;
                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                }
                return e1;
            }(r));
        }
        function xs(t1, e1, r) {
            if (3 === t1) {
                var n = new ms(r, r.readVarint() + r.pos);
                n.length && (e1[n.name] = n);
            }
        }
        vs.prototype.feature = function(t1) {
            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t1];
            var e1 = this._pbf.readVarint() + this._pbf.pos;
            return new hs(this._pbf, e1, this.extent, this._keys, this._values);
        };
        var bs = {
            VectorTile: function(t1, e1) {
                this.layers = t1.readFields(xs, {}, e1);
            },
            VectorTileFeature: hs,
            VectorTileLayer: ms
        }, ws = bs.VectorTileFeature.types, _s = Math.pow(2, 13);
        function As(t1, e1, r, n, i, a, o, s) {
            t1.emplaceBack(e1, r, 2 * Math.floor(n * _s) + o, i * _s * 2, a * _s * 2, Math.round(s));
        }
        var Ss = function(t1) {
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new Pi, this.indexArray = new ji, this.programConfigurations = new Va(t1.layers, t1.zoom), this.segments = new sa, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        function ks(t1, e1) {
            return t1.x === e1.x && (t1.x < 0 || t1.x > 8192) || t1.y === e1.y && (t1.y < 0 || t1.y > 8192);
        }
        Ss.prototype.populate = function(t1, e1, r) {
            this.features = [], this.hasPattern = as("fill-extrusion", this.layers, e1);
            for(var n = 0, i = t1; n < i.length; n += 1){
                var a = i[n], o = a.feature, s = a.id, u = a.index, l = a.sourceLayerIndex, p = this.layers[0]._featureFilter.needGeometry, c = Ua(o, p);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), c, r)) {
                    var h = {
                        id: s,
                        sourceLayerIndex: l,
                        index: u,
                        geometry: p ? c.geometry : Ra(o),
                        properties: o.properties,
                        type: o.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(os("fill-extrusion", this.layers, h, this.zoom, e1)) : this.addFeature(h, h.geometry, u, r, {}), e1.featureIndex.insert(o, h.geometry, u, l, this.index, !0);
                }
            }
        }, Ss.prototype.addFeatures = function(t1, e1, r) {
            for(var n = 0, i = this.features; n < i.length; n += 1){
                var a = i[n];
                this.addFeature(a, a.geometry, a.index, e1, r);
            }
        }, Ss.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, Ss.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, Ss.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, Ss.prototype.upload = function(t1) {
            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, cs), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, Ss.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }, Ss.prototype.addFeature = function(t1, e1, r, n, i) {
            for(var a = 0, o = ns(e1, 500); a < o.length; a += 1){
                for(var s = o[a], u = 0, l = 0, p = s; l < p.length; l += 1)u += p[l].length;
                for(var c = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray), h = 0, f = s; h < f.length; h += 1){
                    var y = f[h];
                    if (0 !== y.length && !((B = y).every(function(t1) {
                        return t1.x < 0;
                    }) || B.every(function(t1) {
                        return t1.x > 8192;
                    }) || B.every(function(t1) {
                        return t1.y < 0;
                    }) || B.every(function(t1) {
                        return t1.y > 8192;
                    }))) for(var d = 0, m = 0; m < y.length; m++){
                        var v = y[m];
                        if (m >= 1) {
                            var g = y[m - 1];
                            if (!ks(v, g)) {
                                c.vertexLength + 4 > sa.MAX_VERTEX_ARRAY_LENGTH && (c = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                var x = v.sub(g)._perp()._unit(), b = g.dist(v);
                                d + b > 32768 && (d = 0), As(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 0, d), As(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 1, d), As(this.layoutVertexArray, g.x, g.y, x.x, x.y, 0, 0, d += b), As(this.layoutVertexArray, g.x, g.y, x.x, x.y, 0, 1, d);
                                var w = c.vertexLength;
                                this.indexArray.emplaceBack(w, w + 2, w + 1), this.indexArray.emplaceBack(w + 1, w + 2, w + 3), c.vertexLength += 4, c.primitiveLength += 2;
                            }
                        }
                    }
                }
                if (c.vertexLength + u > sa.MAX_VERTEX_ARRAY_LENGTH && (c = this.segments.prepareSegment(u, this.layoutVertexArray, this.indexArray)), "Polygon" === ws[t1.type]) {
                    for(var _ = [], A = [], S = c.vertexLength, k = 0, I = s; k < I.length; k += 1){
                        var z = I[k];
                        if (0 !== z.length) {
                            z !== s[0] && A.push(_.length / 2);
                            for(var C = 0; C < z.length; C++){
                                var E = z[C];
                                As(this.layoutVertexArray, E.x, E.y, 0, 0, 1, 1, 0), _.push(E.x), _.push(E.y);
                            }
                        }
                    }
                    for(var P = Io(_, A), M = 0; M < P.length; M += 3)this.indexArray.emplaceBack(S + P[M], S + P[M + 2], S + P[M + 1]);
                    c.primitiveLength += P.length / 3, c.vertexLength += u;
                }
            }
            var B;
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
        }, On("FillExtrusionBucket", Ss, {
            omit: [
                "layers",
                "features"
            ]
        });
        var Is = {
            paint: new wi({
                "fill-extrusion-opacity": new mi(Et["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                "fill-extrusion-color": new vi(Et["paint_fill-extrusion"]["fill-extrusion-color"]),
                "fill-extrusion-translate": new mi(Et["paint_fill-extrusion"]["fill-extrusion-translate"]),
                "fill-extrusion-translate-anchor": new mi(Et["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                "fill-extrusion-pattern": new gi(Et["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                "fill-extrusion-height": new vi(Et["paint_fill-extrusion"]["fill-extrusion-height"]),
                "fill-extrusion-base": new vi(Et["paint_fill-extrusion"]["fill-extrusion-base"]),
                "fill-extrusion-vertical-gradient": new mi(Et["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
            })
        }, zs = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Is);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.createBucket = function(t1) {
                return new Ss(t1);
            }, e1.prototype.queryRadius = function() {
                return eo(this.paint.get("fill-extrusion-translate"));
            }, e1.prototype.is3D = function() {
                return !0;
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, a, o, s, u) {
                var l = ro(t1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, s), p = this.paint.get("fill-extrusion-height").evaluate(e1, r), c = this.paint.get("fill-extrusion-base").evaluate(e1, r), h = function(t1, e1, r, n) {
                    for(var a = [], o = 0, s = t1; o < s.length; o += 1){
                        var u = s[o], l = [
                            u.x,
                            u.y,
                            0,
                            1
                        ];
                        po(l, l, e1), a.push(new i(l[0] / l[3], l[1] / l[3]));
                    }
                    return a;
                }(l, u), f = function(t1, e1, r, n) {
                    for(var a = [], o = [], s = n[8] * e1, u = n[9] * e1, l = n[10] * e1, p = n[11] * e1, c = n[8] * r, h = n[9] * r, f = n[10] * r, y = n[11] * r, d = 0, m = t1; d < m.length; d += 1){
                        for(var v = [], g = [], x = 0, b = m[d]; x < b.length; x += 1){
                            var w = b[x], _ = w.x, A = w.y, S = n[0] * _ + n[4] * A + n[12], k = n[1] * _ + n[5] * A + n[13], I = n[2] * _ + n[6] * A + n[14], z = n[3] * _ + n[7] * A + n[15], C = I + l, E = z + p, P = S + c, M = k + h, B = I + f, T = z + y, V = new i((S + s) / E, (k + u) / E);
                            V.z = C / E, v.push(V);
                            var F = new i(P / T, M / T);
                            F.z = B / T, g.push(F);
                        }
                        a.push(v), o.push(g);
                    }
                    return [
                        a,
                        o
                    ];
                }(n, c, p, u);
                return function(t1, e1, r) {
                    var n = 1 / 0;
                    Ga(r, e1) && (n = Es(r, e1[0]));
                    for(var i = 0; i < e1.length; i++)for(var a = e1[i], o = t1[i], s = 0; s < a.length - 1; s++){
                        var u = a[s], l = [
                            u,
                            a[s + 1],
                            o[s + 1],
                            o[s],
                            u
                        ];
                        Na(r, l) && (n = Math.min(n, Es(r, l)));
                    }
                    return n !== 1 / 0 && n;
                }(f[0], f[1], h);
            }, e1;
        }(_i);
        function Cs(t1, e1) {
            return t1.x * e1.x + t1.y * e1.y;
        }
        function Es(t1, e1) {
            if (1 === t1.length) {
                for(var r, n = 0, i = e1[n++]; !r || i.equals(r);)if (!(r = e1[n++])) return 1 / 0;
                for(; n < e1.length; n++){
                    var a = e1[n], o = t1[0], s = r.sub(i), u = a.sub(i), l = o.sub(i), p = Cs(s, s), c = Cs(s, u), h = Cs(u, u), f = Cs(l, s), y = Cs(l, u), d = p * h - c * c, m = (h * f - c * y) / d, v = (p * y - c * f) / d, g = i.z * (1 - m - v) + r.z * m + a.z * v;
                    if (isFinite(g)) return g;
                }
                return 1 / 0;
            }
            for(var x = 1 / 0, b = 0, w = e1; b < w.length; b += 1)x = Math.min(x, w[b].z);
            return x;
        }
        var Ps = Ii([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4).members, Ms = Ii([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]).members, Bs = bs.VectorTileFeature.types, Ts = Math.cos(Math.PI / 180 * 37.5), Vs = Math.pow(2, 14) / .5, Fs = function(t1) {
            var e1 = this;
            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach(function(t1) {
                e1.gradients[t1.id] = {};
            }), this.layoutVertexArray = new Mi, this.layoutVertexArray2 = new Bi, this.indexArray = new ji, this.programConfigurations = new Va(t1.layers, t1.zoom), this.segments = new sa, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            });
        };
        Fs.prototype.populate = function(t1, e1, r) {
            this.hasPattern = as("line", this.layers, e1);
            for(var n = this.layers[0].layout.get("line-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                var s = o[a], u = s.feature, l = s.id, p = s.index, c = s.sourceLayerIndex, h = this.layers[0]._featureFilter.needGeometry, f = Ua(u, h);
                if (this.layers[0]._featureFilter.filter(new si(this.zoom), f, r)) {
                    var y = n ? n.evaluate(f, {}, r) : void 0, d = {
                        id: l,
                        properties: u.properties,
                        type: u.type,
                        sourceLayerIndex: c,
                        index: p,
                        geometry: h ? f.geometry : Ra(u),
                        patterns: {},
                        sortKey: y
                    };
                    i.push(d);
                }
            }
            n && i.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var m = 0, v = i; m < v.length; m += 1){
                var g = v[m], x = g.geometry, b = g.index, w = g.sourceLayerIndex;
                if (this.hasPattern) {
                    var _ = os("line", this.layers, g, this.zoom, e1);
                    this.patternFeatures.push(_);
                } else this.addFeature(g, x, b, r, {});
                e1.featureIndex.insert(t1[b].feature, x, b, w, this.index);
            }
        }, Fs.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
        }, Fs.prototype.addFeatures = function(t1, e1, r) {
            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                var a = i[n];
                this.addFeature(a, a.geometry, a.index, e1, r);
            }
        }, Fs.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length;
        }, Fs.prototype.uploadPending = function() {
            return !this.uploaded || this.programConfigurations.needsUpload;
        }, Fs.prototype.upload = function(t1) {
            this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, Ms)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Ps), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
        }, Fs.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }, Fs.prototype.lineFeatureClips = function(t1) {
            if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                start: +t1.properties.mapbox_clip_start,
                end: +t1.properties.mapbox_clip_end
            };
        }, Fs.prototype.addFeature = function(t1, e1, r, n, i) {
            var a = this.layers[0].layout, o = a.get("line-join").evaluate(t1, {}), s = a.get("line-cap"), u = a.get("line-miter-limit"), l = a.get("line-round-limit");
            this.lineClips = this.lineFeatureClips(t1);
            for(var p = 0, c = e1; p < c.length; p += 1)this.addLine(c[p], t1, o, s, u, l);
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
        }, Fs.prototype.addLine = function(t1, e1, r, n, i, a) {
            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                this.lineClipsArray.push(this.lineClips);
                for(var o = 0; o < t1.length - 1; o++)this.totalDistance += t1[o].dist(t1[o + 1]);
                this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
            }
            for(var s = "Polygon" === Bs[e1.type], u = t1.length; u >= 2 && t1[u - 1].equals(t1[u - 2]);)u--;
            for(var l = 0; l < u - 1 && t1[l].equals(t1[l + 1]);)l++;
            if (!(u < (s ? 3 : 2))) {
                "bevel" === r && (i = 1.05);
                var p, c = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, h = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray), f = void 0, y = void 0, d = void 0, m = void 0;
                this.e1 = this.e2 = -1, s && (m = t1[l].sub(p = t1[u - 2])._unit()._perp());
                for(var v = l; v < u; v++)if (!(y = v === u - 1 ? s ? t1[l + 1] : void 0 : t1[v + 1]) || !t1[v].equals(y)) {
                    m && (d = m), p && (f = p), p = t1[v], m = y ? y.sub(p)._unit()._perp() : d;
                    var g = (d = d || m).add(m);
                    0 === g.x && 0 === g.y || g._unit();
                    var x = d.x * m.x + d.y * m.y, b = g.x * m.x + g.y * m.y, w = 0 !== b ? 1 / b : 1 / 0, _ = 2 * Math.sqrt(2 - 2 * b), A = b < Ts && f && y, S = d.x * m.y - d.y * m.x > 0;
                    if (A && v > l) {
                        var k = p.dist(f);
                        if (k > 2 * c) {
                            var I = p.sub(p.sub(f)._mult(c / k)._round());
                            this.updateDistance(f, I), this.addCurrentVertex(I, d, 0, 0, h), f = I;
                        }
                    }
                    var z = f && y, C = z ? r : s ? "butt" : n;
                    if (z && "round" === C && (w < a ? C = "miter" : w <= 2 && (C = "fakeround")), "miter" === C && w > i && (C = "bevel"), "bevel" === C && (w > 2 && (C = "flipbevel"), w < i && (C = "miter")), f && this.updateDistance(f, p), "miter" === C) g._mult(w), this.addCurrentVertex(p, g, 0, 0, h);
                    else if ("flipbevel" === C) {
                        if (w > 100) g = m.mult(-1);
                        else {
                            var E = w * d.add(m).mag() / d.sub(m).mag();
                            g._perp()._mult(E * (S ? -1 : 1));
                        }
                        this.addCurrentVertex(p, g, 0, 0, h), this.addCurrentVertex(p, g.mult(-1), 0, 0, h);
                    } else if ("bevel" === C || "fakeround" === C) {
                        var P = -Math.sqrt(w * w - 1), M = S ? P : 0, B = S ? 0 : P;
                        if (f && this.addCurrentVertex(p, d, M, B, h), "fakeround" === C) for(var T = Math.round(180 * _ / Math.PI / 20), V = 1; V < T; V++){
                            var F = V / T;
                            if (.5 !== F) {
                                var D = F - .5;
                                F += F * D * (F - 1) * ((1.0904 + x * (x * (3.55645 - 1.43519 * x) - 3.2452)) * D * D + (.848013 + x * (.215638 * x - 1.06021)));
                            }
                            var L = m.sub(d)._mult(F)._add(d)._unit()._mult(S ? -1 : 1);
                            this.addHalfVertex(p, L.x, L.y, !1, S, 0, h);
                        }
                        y && this.addCurrentVertex(p, m, -M, -B, h);
                    } else if ("butt" === C) this.addCurrentVertex(p, g, 0, 0, h);
                    else if ("square" === C) {
                        var O = f ? 1 : -1;
                        this.addCurrentVertex(p, g, O, O, h);
                    } else "round" === C && (f && (this.addCurrentVertex(p, d, 0, 0, h), this.addCurrentVertex(p, d, 1, 1, h, !0)), y && (this.addCurrentVertex(p, m, -1, -1, h, !0), this.addCurrentVertex(p, m, 0, 0, h)));
                    if (A && v < u - 1) {
                        var R = p.dist(y);
                        if (R > 2 * c) {
                            var U = p.add(y.sub(p)._mult(c / R)._round());
                            this.updateDistance(p, U), this.addCurrentVertex(U, m, 0, 0, h), p = U;
                        }
                    }
                }
            }
        }, Fs.prototype.addCurrentVertex = function(t1, e1, r, n, i, a) {
            void 0 === a && (a = !1);
            var o = e1.y * n - e1.x, s = -e1.y - e1.x * n;
            this.addHalfVertex(t1, e1.x + e1.y * r, e1.y - e1.x * r, a, !1, r, i), this.addHalfVertex(t1, o, s, a, !0, -n, i), this.distance > Vs / 2 && 0 === this.totalDistance && (this.distance = 0, this.addCurrentVertex(t1, e1, r, n, i, a));
        }, Fs.prototype.addHalfVertex = function(t1, e1, r, n, i, a, o) {
            var s = .5 * (this.lineClips ? this.scaledDistance * (Vs - 1) : this.scaledDistance);
            this.layoutVertexArray.emplaceBack((t1.x << 1) + (n ? 1 : 0), (t1.y << 1) + (i ? 1 : 0), Math.round(63 * e1) + 128, Math.round(63 * r) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & s) << 2, s >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
            var u = o.vertexLength++;
            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), i ? this.e2 = u : this.e1 = u;
        }, Fs.prototype.updateScaledDistance = function() {
            this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
        }, Fs.prototype.updateDistance = function(t1, e1) {
            this.distance += t1.dist(e1), this.updateScaledDistance();
        }, On("LineBucket", Fs, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var Ds = new wi({
            "line-cap": new mi(Et.layout_line["line-cap"]),
            "line-join": new vi(Et.layout_line["line-join"]),
            "line-miter-limit": new mi(Et.layout_line["line-miter-limit"]),
            "line-round-limit": new mi(Et.layout_line["line-round-limit"]),
            "line-sort-key": new vi(Et.layout_line["line-sort-key"])
        }), Ls = {
            paint: new wi({
                "line-opacity": new vi(Et.paint_line["line-opacity"]),
                "line-color": new vi(Et.paint_line["line-color"]),
                "line-translate": new mi(Et.paint_line["line-translate"]),
                "line-translate-anchor": new mi(Et.paint_line["line-translate-anchor"]),
                "line-width": new vi(Et.paint_line["line-width"]),
                "line-gap-width": new vi(Et.paint_line["line-gap-width"]),
                "line-offset": new vi(Et.paint_line["line-offset"]),
                "line-blur": new vi(Et.paint_line["line-blur"]),
                "line-dasharray": new xi(Et.paint_line["line-dasharray"]),
                "line-pattern": new gi(Et.paint_line["line-pattern"]),
                "line-gradient": new bi(Et.paint_line["line-gradient"])
            }),
            layout: Ds
        }, Os = new (function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.possiblyEvaluate = function(e1, r) {
                return r = new si(Math.floor(r.zoom), {
                    now: r.now,
                    fadeDuration: r.fadeDuration,
                    zoomHistory: r.zoomHistory,
                    transition: r.transition
                }), t1.prototype.possiblyEvaluate.call(this, e1, r);
            }, e1.prototype.evaluate = function(e1, r, n, i) {
                return r = h({}, r, {
                    zoom: Math.floor(r.zoom)
                }), t1.prototype.evaluate.call(this, e1, r, n, i);
            }, e1;
        }(vi))(Ls.paint.properties["line-width"].specification);
        Os.useIntegerZoom = !0;
        var Rs = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Ls), this.gradientVersion = 0;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                "line-gradient" === t1 && (this.stepInterpolant = this._transitionablePaint._values["line-gradient"].value.expression._styleExpression.expression instanceof Ne, this.gradientVersion = (this.gradientVersion + 1) % s);
            }, e1.prototype.gradientExpression = function() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }, e1.prototype.recalculate = function(e1, r) {
                t1.prototype.recalculate.call(this, e1, r), this.paint._values["line-floorwidth"] = Os.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
            }, e1.prototype.createBucket = function(t1) {
                return new Fs(t1);
            }, e1.prototype.queryRadius = function(t1) {
                var e1 = t1, r = Us(to("line-width", this, e1), to("line-gap-width", this, e1)), n = to("line-offset", this, e1);
                return r / 2 + Math.abs(n) + eo(this.paint.get("line-translate"));
            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, a, o, s) {
                var u = ro(t1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, s), l = s / 2 * Us(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), p = this.paint.get("line-offset").evaluate(e1, r);
                return p && (n = function(t1, e1) {
                    for(var r = [], n = new i(0, 0), a = 0; a < t1.length; a++){
                        for(var o = t1[a], s = [], u = 0; u < o.length; u++){
                            var l = o[u], p = o[u + 1], c = 0 === u ? n : l.sub(o[u - 1])._unit()._perp(), h = u === o.length - 1 ? n : p.sub(l)._unit()._perp(), f = c._add(h)._unit();
                            f._mult(1 / (f.x * h.x + f.y * h.y)), s.push(f._mult(e1)._add(l));
                        }
                        r.push(s);
                    }
                    return r;
                }(n, p * s)), function(t1, e1, r) {
                    for(var n = 0; n < e1.length; n++){
                        var i = e1[n];
                        if (t1.length >= 3) {
                            for(var a = 0; a < i.length; a++)if (Wa(t1, i[a])) return !0;
                        }
                        if (Za(t1, i, r)) return !0;
                    }
                    return !1;
                }(u, n, l);
            }, e1.prototype.isTileClipped = function() {
                return !0;
            }, e1;
        }(_i);
        function Us(t1, e1) {
            return e1 > 0 ? e1 + 2 * t1 : t1;
        }
        var js = Ii([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), qs = Ii([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4), Ns = (Ii([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4), Ii([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ])), Ks = (Ii([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]), Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4)), Gs = Ii([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function Zs(t1, e1, r) {
            return t1.sections.forEach(function(t1) {
                t1.text = function(t1, e1, r) {
                    var n = e1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), oi.applyArabicShaping && (t1 = oi.applyArabicShaping(t1)), t1;
                }(t1.text, e1, r);
            }), t1;
        }
        Ii([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Ii([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), Ii([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            }
        ]), Ii([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Ii([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]);
        var Xs = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        }, Js = function(t1, e1, r, n, i) {
            var a, o, s = 8 * i - n - 1, u = (1 << s) - 1, l = u >> 1, p = -7, c = r ? i - 1 : 0, h = r ? -1 : 1, f = t1[e1 + c];
            for(c += h, a = f & (1 << -p) - 1, f >>= -p, p += s; p > 0; a = 256 * a + t1[e1 + c], c += h, p -= 8);
            for(o = a & (1 << -p) - 1, a >>= -p, p += n; p > 0; o = 256 * o + t1[e1 + c], c += h, p -= 8);
            if (0 === a) a = 1 - l;
            else {
                if (a === u) return o ? NaN : 1 / 0 * (f ? -1 : 1);
                o += Math.pow(2, n), a -= l;
            }
            return (f ? -1 : 1) * o * Math.pow(2, a - n);
        }, Hs = function(t1, e1, r, n, i, a) {
            var o, s, u, l = 8 * a - i - 1, p = (1 << l) - 1, c = p >> 1, h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : a - 1, y = n ? 1 : -1, d = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = p) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), (e1 += o + c >= 1 ? h / u : h * Math.pow(2, 1 - c)) * u >= 2 && (o++, u /= 2), o + c >= p ? (s = 0, o = p) : o + c >= 1 ? (s = (e1 * u - 1) * Math.pow(2, i), o += c) : (s = e1 * Math.pow(2, c - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + f] = 255 & s, f += y, s /= 256, i -= 8);
            for(o = o << i | s, l += i; l > 0; t1[r + f] = 255 & o, f += y, o /= 256, l -= 8);
            t1[r + f - y] |= 128 * d;
        }, Ys = $s;
        function $s(t1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        $s.Varint = 0, $s.Fixed64 = 1, $s.Bytes = 2, $s.Fixed32 = 5;
        var Ws = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function Qs(t1) {
            return t1.type === $s.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
        }
        function tu(t1, e1, r) {
            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
        }
        function eu(t1, e1, r) {
            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
        }
        function ru(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
        }
        function nu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
        }
        function iu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
        }
        function au(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
        }
        function ou(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
        }
        function su(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
        }
        function uu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
        }
        function lu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
        }
        function pu(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
        }
        function cu(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
        }
        function hu(t1, e1, r) {
            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
        }
        function fu(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
        }
        function yu(t1, e1, r) {
            1 === t1 && r.readMessage(du, e1);
        }
        function du(t1, e1, r) {
            if (3 === t1) {
                var n = r.readMessage(mu, {}), i = n.width, a = n.height, o = n.left, s = n.top, u = n.advance;
                e1.push({
                    id: n.id,
                    bitmap: new go({
                        width: i + 6,
                        height: a + 6
                    }, n.bitmap),
                    metrics: {
                        width: i,
                        height: a,
                        left: o,
                        top: s,
                        advance: u
                    }
                });
            }
        }
        function mu(t1, e1, r) {
            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
        }
        function vu(t1) {
            for(var e1 = 0, r = 0, n = 0, i = t1; n < i.length; n += 1){
                var a = i[n];
                e1 += a.w * a.h, r = Math.max(r, a.w);
            }
            t1.sort(function(t1, e1) {
                return e1.h - t1.h;
            });
            for(var o = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                    h: 1 / 0
                }
            ], s = 0, u = 0, l = 0, p = t1; l < p.length; l += 1)for(var c = p[l], h = o.length - 1; h >= 0; h--){
                var f = o[h];
                if (!(c.w > f.w || c.h > f.h)) {
                    if (c.x = f.x, c.y = f.y, u = Math.max(u, c.y + c.h), s = Math.max(s, c.x + c.w), c.w === f.w && c.h === f.h) {
                        var y = o.pop();
                        h < o.length && (o[h] = y);
                    } else c.h === f.h ? (f.x += c.w, f.w -= c.w) : c.w === f.w ? (f.y += c.h, f.h -= c.h) : (o.push({
                        x: f.x + c.w,
                        y: f.y,
                        w: f.w - c.w,
                        h: c.h
                    }), f.y += c.h, f.h -= c.h);
                    break;
                }
            }
            return {
                w: s,
                h: u,
                fill: e1 / (s * u) || 0
            };
        }
        $s.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t1, e1, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                    this.type = 7 & n, t1(i, e1, this), this.pos === a && this.skip(n);
                }
                return e1;
            },
            readMessage: function(t1, e1) {
                return this.readFields(t1, e1, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t1 = cu(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readSFixed32: function() {
                var t1 = fu(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readFixed64: function() {
                var t1 = cu(this.buf, this.pos) + 4294967296 * cu(this.buf, this.pos + 4);
                return this.pos += 8, t1;
            },
            readSFixed64: function() {
                var t1 = cu(this.buf, this.pos) + 4294967296 * fu(this.buf, this.pos + 4);
                return this.pos += 8, t1;
            },
            readFloat: function() {
                var t1 = Js(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t1;
            },
            readDouble: function() {
                var t1 = Js(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t1;
            },
            readVarint: function(t1) {
                var e1, r, n = this.buf;
                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                    var n, i, a = r.buf;
                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return tu(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return tu(t1, n, e1);
                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return tu(t1, n, e1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t1 = this.readVarint();
                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                return this.pos = t1, t1 - e1 >= 12 && Ws ? function(t1, e1, r) {
                    return Ws.decode(t1.subarray(e1, r));
                }(this.buf, e1, t1) : function(t1, e1, r) {
                    for(var n = "", i = e1; i < r;){
                        var a, o, s, u = t1[i], l = null, p = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
                        if (i + p > r) break;
                        1 === p ? u < 128 && (l = u) : 2 === p ? 128 == (192 & (a = t1[i + 1])) && (l = (31 & u) << 6 | 63 & a) <= 127 && (l = null) : 3 === p ? (o = t1[i + 2], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & o) && ((l = (15 & u) << 12 | (63 & a) << 6 | 63 & o) <= 2047 || l >= 55296 && l <= 57343) && (l = null)) : 4 === p && (o = t1[i + 2], s = t1[i + 3], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & o) && 128 == (192 & s) && ((l = (15 & u) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) <= 65535 || l >= 1114112) && (l = null)), null === l ? (l = 65533, p = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), i += p;
                    }
                    return n;
                }(this.buf, e1, t1);
            },
            readBytes: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                return this.pos = t1, e1;
            },
            readPackedVarint: function(t1, e1) {
                if (this.type !== $s.Bytes) return t1.push(this.readVarint(e1));
                var r = Qs(this);
                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                return t1;
            },
            readPackedSVarint: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readSVarint());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                return t1;
            },
            readPackedBoolean: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readBoolean());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                return t1;
            },
            readPackedFloat: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readFloat());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                return t1;
            },
            readPackedDouble: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readDouble());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                return t1;
            },
            readPackedFixed32: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readFixed32());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                return t1;
            },
            readPackedSFixed32: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readSFixed32());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                return t1;
            },
            readPackedFixed64: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readFixed64());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                return t1;
            },
            readPackedSFixed64: function(t1) {
                if (this.type !== $s.Bytes) return t1.push(this.readSFixed64());
                var e1 = Qs(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                return t1;
            },
            skip: function(t1) {
                var e1 = 7 & t1;
                if (e1 === $s.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e1 === $s.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e1 === $s.Fixed32) this.pos += 4;
                else {
                    if (e1 !== $s.Fixed64) throw new Error("Unimplemented type: " + e1);
                    this.pos += 8;
                }
            },
            writeTag: function(t1, e1) {
                this.writeVarint(t1 << 3 | e1);
            },
            realloc: function(t1) {
                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                if (e1 !== this.length) {
                    var r = new Uint8Array(e1);
                    r.set(this.buf), this.buf = r, this.length = e1;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t1) {
                this.realloc(4), hu(this.buf, t1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t1) {
                this.realloc(4), hu(this.buf, t1, this.pos), this.pos += 4;
            },
            writeFixed64: function(t1) {
                this.realloc(8), hu(this.buf, -1 & t1, this.pos), hu(this.buf, Math.floor(t1 * (1 / 4294967296)), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t1) {
                this.realloc(8), hu(this.buf, -1 & t1, this.pos), hu(this.buf, Math.floor(t1 * (1 / 4294967296)), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t1) {
                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                    var r, n;
                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e1.realloc(10), function(t1, e1, r) {
                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                    }(r, 0, e1), function(t1, e1) {
                        var r = (7 & t1) << 4;
                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                    }(n, e1);
                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
            },
            writeSVarint: function(t1) {
                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
            },
            writeBoolean: function(t1) {
                this.writeVarint(Boolean(t1));
            },
            writeString: function(t1) {
                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                var e1 = this.pos;
                this.pos = function(t1, e1, r) {
                    for(var n, i, a = 0; a < e1.length; a++){
                        if ((n = e1.charCodeAt(a)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || a + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t1, this.pos);
                var r = this.pos - e1;
                r >= 128 && eu(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t1) {
                this.realloc(4), Hs(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t1) {
                this.realloc(8), Hs(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t1) {
                var e1 = t1.length;
                this.writeVarint(e1), this.realloc(e1);
                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
            },
            writeRawMessage: function(t1, e1) {
                this.pos++;
                var r = this.pos;
                t1(e1, this);
                var n = this.pos - r;
                n >= 128 && eu(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t1, e1, r) {
                this.writeTag(t1, $s.Bytes), this.writeRawMessage(e1, r);
            },
            writePackedVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, ru, e1);
            },
            writePackedSVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, nu, e1);
            },
            writePackedBoolean: function(t1, e1) {
                e1.length && this.writeMessage(t1, ou, e1);
            },
            writePackedFloat: function(t1, e1) {
                e1.length && this.writeMessage(t1, iu, e1);
            },
            writePackedDouble: function(t1, e1) {
                e1.length && this.writeMessage(t1, au, e1);
            },
            writePackedFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, su, e1);
            },
            writePackedSFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, uu, e1);
            },
            writePackedFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, lu, e1);
            },
            writePackedSFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, pu, e1);
            },
            writeBytesField: function(t1, e1) {
                this.writeTag(t1, $s.Bytes), this.writeBytes(e1);
            },
            writeFixed32Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed32), this.writeFixed32(e1);
            },
            writeSFixed32Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed32), this.writeSFixed32(e1);
            },
            writeFixed64Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed64), this.writeFixed64(e1);
            },
            writeSFixed64Field: function(t1, e1) {
                this.writeTag(t1, $s.Fixed64), this.writeSFixed64(e1);
            },
            writeVarintField: function(t1, e1) {
                this.writeTag(t1, $s.Varint), this.writeVarint(e1);
            },
            writeSVarintField: function(t1, e1) {
                this.writeTag(t1, $s.Varint), this.writeSVarint(e1);
            },
            writeStringField: function(t1, e1) {
                this.writeTag(t1, $s.Bytes), this.writeString(e1);
            },
            writeFloatField: function(t1, e1) {
                this.writeTag(t1, $s.Fixed32), this.writeFloat(e1);
            },
            writeDoubleField: function(t1, e1) {
                this.writeTag(t1, $s.Fixed64), this.writeDouble(e1);
            },
            writeBooleanField: function(t1, e1) {
                this.writeVarintField(t1, Boolean(e1));
            }
        };
        var gu = function(t1, e1) {
            var r = e1.pixelRatio, n = e1.version, i = e1.stretchX, a = e1.stretchY, o = e1.content;
            this.paddedRect = t1, this.pixelRatio = r, this.stretchX = i, this.stretchY = a, this.content = o, this.version = n;
        }, xu = {
            tl: {
                configurable: !0
            },
            br: {
                configurable: !0
            },
            tlbr: {
                configurable: !0
            },
            displaySize: {
                configurable: !0
            }
        };
        xu.tl.get = function() {
            return [
                this.paddedRect.x + 1,
                this.paddedRect.y + 1
            ];
        }, xu.br.get = function() {
            return [
                this.paddedRect.x + this.paddedRect.w - 1,
                this.paddedRect.y + this.paddedRect.h - 1
            ];
        }, xu.tlbr.get = function() {
            return this.tl.concat(this.br);
        }, xu.displaySize.get = function() {
            return [
                (this.paddedRect.w - 2) / this.pixelRatio,
                (this.paddedRect.h - 2) / this.pixelRatio
            ];
        }, Object.defineProperties(gu.prototype, xu);
        var bu = function(t1, e1) {
            var r = {}, n = {};
            this.haveRenderCallbacks = [];
            var i = [];
            this.addImages(t1, r, i), this.addImages(e1, n, i);
            var a = vu(i), o = new xo({
                width: a.w || 1,
                height: a.h || 1
            });
            for(var s in t1){
                var u = t1[s], l = r[s].paddedRect;
                xo.copy(u.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: l.x + 1,
                    y: l.y + 1
                }, u.data);
            }
            for(var p in e1){
                var c = e1[p], h = n[p].paddedRect, f = h.x + 1, y = h.y + 1, d = c.data.width, m = c.data.height;
                xo.copy(c.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: f,
                    y: y
                }, c.data), xo.copy(c.data, o, {
                    x: 0,
                    y: m - 1
                }, {
                    x: f,
                    y: y - 1
                }, {
                    width: d,
                    height: 1
                }), xo.copy(c.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: f,
                    y: y + m
                }, {
                    width: d,
                    height: 1
                }), xo.copy(c.data, o, {
                    x: d - 1,
                    y: 0
                }, {
                    x: f - 1,
                    y: y
                }, {
                    width: 1,
                    height: m
                }), xo.copy(c.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: f + d,
                    y: y
                }, {
                    width: 1,
                    height: m
                });
            }
            this.image = o, this.iconPositions = r, this.patternPositions = n;
        };
        bu.prototype.addImages = function(t1, e1, r) {
            for(var n in t1){
                var i = t1[n], a = {
                    x: 0,
                    y: 0,
                    w: i.data.width + 2,
                    h: i.data.height + 2
                };
                r.push(a), e1[n] = new gu(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
            }
        }, bu.prototype.patchUpdatedImages = function(t1, e1) {
            for(var r in t1.dispatchRenderCallbacks(this.haveRenderCallbacks), t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
        }, bu.prototype.patchUpdatedImage = function(t1, e1, r) {
            if (t1 && e1 && t1.version !== e1.version) {
                t1.version = e1.version;
                var n = t1.tl;
                r.update(e1.data, void 0, {
                    x: n[0],
                    y: n[1]
                });
            }
        }, On("ImagePosition", gu), On("ImageAtlas", bu);
        var wu = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        }, _u = function() {
            this.scale = 1, this.fontStack = "", this.imageName = null;
        };
        _u.forText = function(t1, e1) {
            var r = new _u;
            return r.scale = t1 || 1, r.fontStack = e1, r;
        }, _u.forImage = function(t1) {
            var e1 = new _u;
            return e1.imageName = t1, e1;
        };
        var Au = function() {
            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
        };
        function Su(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d) {
            var m, v = Au.fromFeature(t1, i);
            c === wu.vertical && v.verticalizePunctuation();
            var g = oi.processBidirectionalText, x = oi.processStyledBidirectionalText;
            if (g && 1 === v.sections.length) {
                m = [];
                for(var b = 0, w = g(v.toString(), Mu(v, l, a, e1, n, f, y)); b < w.length; b += 1){
                    var _ = w[b], A = new Au;
                    A.text = _, A.sections = v.sections;
                    for(var S = 0; S < _.length; S++)A.sectionIndex.push(0);
                    m.push(A);
                }
            } else if (x) {
                m = [];
                for(var k = 0, I = x(v.text, v.sectionIndex, Mu(v, l, a, e1, n, f, y)); k < I.length; k += 1){
                    var z = I[k], C = new Au;
                    C.text = z[0], C.sectionIndex = z[1], C.sections = v.sections, m.push(C);
                }
            } else m = function(t1, e1) {
                for(var r = [], n = t1.text, i = 0, a = 0, o = e1; a < o.length; a += 1){
                    var s = o[a];
                    r.push(t1.substring(i, s)), i = s;
                }
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(v, Mu(v, l, a, e1, n, f, y));
            var E = [], P = {
                positionedLines: E,
                text: v.toString(),
                top: p[1],
                bottom: p[1],
                left: p[0],
                right: p[0],
                writingMode: c,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(t1, e1, r, n, i, a, o, s, u, l, p, c) {
                for(var h = 0, f = -17, y = 0, d = 0, m = "right" === s ? 1 : "left" === s ? 0 : .5, v = 0, g = 0, x = i; g < x.length; g += 1){
                    var b = x[g];
                    b.trim();
                    var w = b.getMaxScale(), _ = 24 * (w - 1), A = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[v] = A;
                    var S = A.positionedGlyphs, k = 0;
                    if (b.length()) {
                        for(var I = 0; I < b.length(); I++){
                            var z = b.getSection(I), C = b.getSectionIndex(I), E = b.getCharCode(I), P = 0, M = null, B = null, T = null, V = 24, F = !(u === wu.horizontal || !p && !Xn(E) || p && (ku[E] || (K = E, Gn.Arabic(K) || Gn["Arabic Supplement"](K) || Gn["Arabic Extended-A"](K) || Gn["Arabic Presentation Forms-A"](K) || Gn["Arabic Presentation Forms-B"](K))));
                            if (z.imageName) {
                                var D = n[z.imageName];
                                if (!D) continue;
                                T = z.imageName, t1.iconsInText = t1.iconsInText || !0, B = D.paddedRect;
                                var L = D.displaySize;
                                z.scale = 24 * z.scale / c, P = _ + (24 - L[1] * z.scale), V = (M = {
                                    width: L[0],
                                    height: L[1],
                                    left: 1,
                                    top: -3,
                                    advance: F ? L[1] : L[0]
                                }).advance;
                                var O = F ? L[0] * z.scale - 24 * w : L[1] * z.scale - 24 * w;
                                O > 0 && O > k && (k = O);
                            } else {
                                var R = r[z.fontStack], U = R && R[E];
                                if (U && U.rect) B = U.rect, M = U.metrics;
                                else {
                                    var j = e1[z.fontStack], q = j && j[E];
                                    if (!q) continue;
                                    M = q.metrics;
                                }
                                P = 24 * (w - z.scale);
                            }
                            F ? (t1.verticalizable = !0, S.push({
                                glyph: E,
                                imageName: T,
                                x: h,
                                y: f + P,
                                vertical: F,
                                scale: z.scale,
                                fontStack: z.fontStack,
                                sectionIndex: C,
                                metrics: M,
                                rect: B
                            }), h += V * z.scale + l) : (S.push({
                                glyph: E,
                                imageName: T,
                                x: h,
                                y: f + P,
                                vertical: F,
                                scale: z.scale,
                                fontStack: z.fontStack,
                                sectionIndex: C,
                                metrics: M,
                                rect: B
                            }), h += M.advance * z.scale + l);
                        }
                        0 !== S.length && (y = Math.max(h - l, y), Tu(S, 0, S.length - 1, m, k)), h = 0;
                        var N = a * w + k;
                        A.lineOffset = Math.max(k, _), f += N, d = Math.max(N, d), ++v;
                    } else f += a, ++v;
                }
                var K, G = f - -17, Z = Bu(o), X = Z.horizontalAlign, J = Z.verticalAlign;
                (function(t1, e1, r, n, i, a, o, s, u) {
                    var l, p = (e1 - r) * i;
                    l = a !== o ? -s * n - -17 : (-n * u + .5) * o;
                    for(var c = 0, h = t1; c < h.length; c += 1)for(var f = 0, y = h[c].positionedGlyphs; f < y.length; f += 1){
                        var d = y[f];
                        d.x += p, d.y += l;
                    }
                })(t1.positionedLines, m, X, J, y, d, a, G, i.length), t1.top += -J * G, t1.bottom = t1.top + G, t1.left += -X * y, t1.right = t1.left + y;
            }(P, e1, r, n, m, o, s, u, c, l, h, d), !function(t1) {
                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (0 !== r[e1].positionedGlyphs.length) return !1;
                return !0;
            }(E) && P;
        }
        Au.fromFeature = function(t1, e1) {
            for(var r = new Au, n = 0; n < t1.sections.length; n++){
                var i = t1.sections[n];
                i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
            }
            return r;
        }, Au.prototype.length = function() {
            return this.text.length;
        }, Au.prototype.getSection = function(t1) {
            return this.sections[this.sectionIndex[t1]];
        }, Au.prototype.getSectionIndex = function(t1) {
            return this.sectionIndex[t1];
        }, Au.prototype.getCharCode = function(t1) {
            return this.text.charCodeAt(t1);
        }, Au.prototype.verticalizePunctuation = function() {
            this.text = function(t1) {
                for(var e1 = "", r = 0; r < t1.length; r++){
                    var n = t1.charCodeAt(r + 1) || null, i = t1.charCodeAt(r - 1) || null;
                    e1 += n && Jn(n) && !Xs[t1[r + 1]] || i && Jn(i) && !Xs[t1[r - 1]] || !Xs[t1[r]] ? t1[r] : Xs[t1[r]];
                }
                return e1;
            }(this.text);
        }, Au.prototype.trim = function() {
            for(var t1 = 0, e1 = 0; e1 < this.text.length && ku[this.text.charCodeAt(e1)]; e1++)t1++;
            for(var r = this.text.length, n = this.text.length - 1; n >= 0 && n >= t1 && ku[this.text.charCodeAt(n)]; n--)r--;
            this.text = this.text.substring(t1, r), this.sectionIndex = this.sectionIndex.slice(t1, r);
        }, Au.prototype.substring = function(t1, e1) {
            var r = new Au;
            return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
        }, Au.prototype.toString = function() {
            return this.text;
        }, Au.prototype.getMaxScale = function() {
            var t1 = this;
            return this.sectionIndex.reduce(function(e1, r) {
                return Math.max(e1, t1.sections[r].scale);
            }, 0);
        }, Au.prototype.addTextSection = function(t1, e1) {
            this.text += t1.text, this.sections.push(_u.forText(t1.scale, t1.fontStack || e1));
            for(var r = this.sections.length - 1, n = 0; n < t1.text.length; ++n)this.sectionIndex.push(r);
        }, Au.prototype.addImageSection = function(t1) {
            var e1 = t1.image ? t1.image.name : "";
            if (0 !== e1.length) {
                var r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(_u.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : A("Reached maximum number of images 6401");
            } else A("Can't add FormattedSection with an empty image.");
        }, Au.prototype.getNextImageSectionCharCode = function() {
            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
        };
        var ku = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Iu = {};
        function zu(t1, e1, r, n, i, a) {
            if (e1.imageName) {
                var o = n[e1.imageName];
                return o ? o.displaySize[0] * e1.scale * 24 / a + i : 0;
            }
            var s = r[e1.fontStack], u = s && s[t1];
            return u ? u.metrics.advance * e1.scale + i : 0;
        }
        function Cu(t1, e1, r, n) {
            var i = Math.pow(t1 - e1, 2);
            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function Eu(t1, e1, r) {
            var n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
        }
        function Pu(t1, e1, r, n, i, a) {
            for(var o = null, s = Cu(e1, r, i, a), u = 0, l = n; u < l.length; u += 1){
                var p = l[u], c = Cu(e1 - p.x, r, i, a) + p.badness;
                c <= s && (o = p, s = c);
            }
            return {
                index: t1,
                x: e1,
                priorBreak: o,
                badness: s
            };
        }
        function Mu(t1, e1, r, n, i, a, o) {
            if ("point" !== a) return [];
            if (!t1) return [];
            for(var s, u = [], l = function(t1, e1, r, n, i, a) {
                for(var o = 0, s = 0; s < t1.length(); s++){
                    var u = t1.getSection(s);
                    o += zu(t1.getCharCode(s), u, n, i, e1, a);
                }
                return o / Math.max(1, Math.ceil(o / r));
            }(t1, e1, r, n, i, o), p = t1.text.indexOf("\u200B") >= 0, c = 0, h = 0; h < t1.length(); h++){
                var f = t1.getSection(h), y = t1.getCharCode(h);
                if (ku[y] || (c += zu(y, f, n, i, e1, o)), h < t1.length() - 1) {
                    var d = !((s = y) < 11904 || !(Gn["Bopomofo Extended"](s) || Gn.Bopomofo(s) || Gn["CJK Compatibility Forms"](s) || Gn["CJK Compatibility Ideographs"](s) || Gn["CJK Compatibility"](s) || Gn["CJK Radicals Supplement"](s) || Gn["CJK Strokes"](s) || Gn["CJK Symbols and Punctuation"](s) || Gn["CJK Unified Ideographs Extension A"](s) || Gn["CJK Unified Ideographs"](s) || Gn["Enclosed CJK Letters and Months"](s) || Gn["Halfwidth and Fullwidth Forms"](s) || Gn.Hiragana(s) || Gn["Ideographic Description Characters"](s) || Gn["Kangxi Radicals"](s) || Gn["Katakana Phonetic Extensions"](s) || Gn.Katakana(s) || Gn["Vertical Forms"](s) || Gn["Yi Radicals"](s) || Gn["Yi Syllables"](s)));
                    (Iu[y] || d || f.imageName) && u.push(Pu(h + 1, c, l, u, Eu(y, t1.getCharCode(h + 1), d && p), !1));
                }
            }
            return function t1(e1) {
                return e1 ? t1(e1.priorBreak).concat(e1.index) : [];
            }(Pu(t1.length(), c, l, u, 0, !0));
        }
        function Bu(t1) {
            var e1 = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e1 = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e1,
                verticalAlign: r
            };
        }
        function Tu(t1, e1, r, n, i) {
            if (n || i) for(var a = t1[r], o = (t1[r].x + a.metrics.advance * a.scale) * n, s = e1; s <= r; s++)t1[s].x -= o, t1[s].y += i;
        }
        function Vu(t1, e1, r, n, i, a) {
            var o, s = t1.image;
            if (s.content) {
                var u = s.content, l = s.pixelRatio || 1;
                o = [
                    u[0] / l,
                    u[1] / l,
                    s.displaySize[0] - u[2] / l,
                    s.displaySize[1] - u[3] / l
                ];
            }
            var p, c, h, f, y = e1.left * a, d = e1.right * a;
            "width" === r || "both" === r ? (f = i[0] + y - n[3], c = i[0] + d + n[1]) : c = (f = i[0] + (y + d - s.displaySize[0]) / 2) + s.displaySize[0];
            var m = e1.top * a, v = e1.bottom * a;
            return "height" === r || "both" === r ? (p = i[1] + m - n[0], h = i[1] + v + n[2]) : h = (p = i[1] + (m + v - s.displaySize[1]) / 2) + s.displaySize[1], {
                image: s,
                top: p,
                right: c,
                bottom: h,
                left: f,
                collisionPadding: o
            };
        }
        Iu[10] = !0, Iu[32] = !0, Iu[38] = !0, Iu[40] = !0, Iu[41] = !0, Iu[43] = !0, Iu[45] = !0, Iu[47] = !0, Iu[173] = !0, Iu[183] = !0, Iu[8203] = !0, Iu[8208] = !0, Iu[8211] = !0, Iu[8231] = !0;
        var Fu = function(t1) {
            function e1(e1, r, n, i) {
                t1.call(this, e1, r), this.angle = n, void 0 !== i && (this.segment = i);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.clone = function() {
                return new e1(this.x, this.y, this.angle, this.segment);
            }, e1;
        }(i);
        function Du(t1, e1) {
            var r = e1.expression;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new si(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            for(var n = r.zoomStops, i = r.interpolationType, a = 0; a < n.length && n[a] <= t1;)a++;
            for(var o = a = Math.max(0, a - 1); o < n.length && n[o] < t1 + 1;)o++;
            o = Math.min(n.length - 1, o);
            var s = n[a], u = n[o];
            return "composite" === r.kind ? {
                kind: "composite",
                minZoom: s,
                maxZoom: u,
                interpolationType: i
            } : {
                kind: "camera",
                minZoom: s,
                maxZoom: u,
                minSize: r.evaluate(new si(s)),
                maxSize: r.evaluate(new si(u)),
                interpolationType: i
            };
        }
        function Lu(t1, e1, r) {
            var n = e1.uSize, i = r.lowerSize;
            return "source" === t1.kind ? i / 128 : "composite" === t1.kind ? Ke(i / 128, r.upperSize / 128, e1.uSizeT) : n;
        }
        function Ou(t1, e1) {
            var r = 0, n = 0;
            if ("constant" === t1.kind) n = t1.layoutSize;
            else if ("source" !== t1.kind) {
                var i = t1.interpolationType, a = i ? p(ar.interpolationFactor(i, e1, t1.minZoom, t1.maxZoom), 0, 1) : 0;
                "camera" === t1.kind ? n = Ke(t1.minSize, t1.maxSize, a) : r = a;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }
        On("Anchor", Fu);
        var Ru = Object.freeze({
            __proto__: null,
            getSizeData: Du,
            evaluateSizeForFeature: Lu,
            evaluateSizeForZoom: Ou,
            SIZE_PACK_FACTOR: 128
        });
        function Uu(t1, e1, r, n, i) {
            if (void 0 === e1.segment) return !0;
            for(var a = e1, o = e1.segment + 1, s = 0; s > -r / 2;){
                if (--o < 0) return !1;
                s -= t1[o].dist(a), a = t1[o];
            }
            s += t1[o].dist(t1[o + 1]), o++;
            for(var u = [], l = 0; s < r / 2;){
                var p = t1[o], c = t1[o + 1];
                if (!c) return !1;
                var h = t1[o - 1].angleTo(p) - p.angleTo(c);
                for(h = Math.abs((h + 3 * Math.PI) % (2 * Math.PI) - Math.PI), u.push({
                    distance: s,
                    angleDelta: h
                }), l += h; s - u[0].distance > n;)l -= u.shift().angleDelta;
                if (l > i) return !1;
                o++, s += p.dist(c);
            }
            return !0;
        }
        function ju(t1) {
            for(var e1 = 0, r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
            return e1;
        }
        function qu(t1, e1, r) {
            return t1 ? .6 * e1 * r : 0;
        }
        function Nu(t1, e1) {
            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function Ku(t1, e1, r, n, i, a) {
            for(var o = qu(r, i, a), s = Nu(r, n) * a, u = 0, l = ju(t1) / 2, p = 0; p < t1.length - 1; p++){
                var c = t1[p], h = t1[p + 1], f = c.dist(h);
                if (u + f > l) {
                    var y = (l - u) / f, d = Ke(c.x, h.x, y), m = Ke(c.y, h.y, y), v = new Fu(d, m, h.angleTo(c), p);
                    return v._round(), !o || Uu(t1, v, s, o, e1) ? v : void 0;
                }
                u += f;
            }
        }
        function Gu(t1, e1, r, n, i, a, o, s, u) {
            var l = qu(n, a, o), p = Nu(n, i), c = p * o, h = 0 === t1[0].x || t1[0].x === u || 0 === t1[0].y || t1[0].y === u;
            return e1 - c < e1 / 4 && (e1 = c + e1 / 4), function t1(e1, r, n, i, a, o, s, u, l) {
                for(var p = o / 2, c = ju(e1), h = 0, f = r - n, y = [], d = 0; d < e1.length - 1; d++){
                    for(var m = e1[d], v = e1[d + 1], g = m.dist(v), x = v.angleTo(m); f + n < h + g;){
                        var b = ((f += n) - h) / g, w = Ke(m.x, v.x, b), _ = Ke(m.y, v.y, b);
                        if (w >= 0 && w < l && _ >= 0 && _ < l && f - p >= 0 && f + p <= c) {
                            var A = new Fu(w, _, x, d);
                            A._round(), i && !Uu(e1, A, o, i, a) || y.push(A);
                        }
                    }
                    h += g;
                }
                return u || y.length || s || (y = t1(e1, h / 2, n, i, a, o, s, !0, l)), y;
            }(t1, h ? e1 / 2 * s % e1 : (p / 2 + 2 * a) * o * s % e1, e1, l, r, c, h, !1, u);
        }
        function Zu(t1, e1, r, n, a) {
            for(var o = [], s = 0; s < t1.length; s++)for(var u = t1[s], l = void 0, p = 0; p < u.length - 1; p++){
                var c = u[p], h = u[p + 1];
                c.x < e1 && h.x < e1 || (c.x < e1 ? c = new i(e1, c.y + (e1 - c.x) / (h.x - c.x) * (h.y - c.y))._round() : h.x < e1 && (h = new i(e1, c.y + (e1 - c.x) / (h.x - c.x) * (h.y - c.y))._round()), c.y < r && h.y < r || (c.y < r ? c = new i(c.x + (r - c.y) / (h.y - c.y) * (h.x - c.x), r)._round() : h.y < r && (h = new i(c.x + (r - c.y) / (h.y - c.y) * (h.x - c.x), r)._round()), c.x >= n && h.x >= n || (c.x >= n ? c = new i(n, c.y + (n - c.x) / (h.x - c.x) * (h.y - c.y))._round() : h.x >= n && (h = new i(n, c.y + (n - c.x) / (h.x - c.x) * (h.y - c.y))._round()), c.y >= a && h.y >= a || (c.y >= a ? c = new i(c.x + (a - c.y) / (h.y - c.y) * (h.x - c.x), a)._round() : h.y >= a && (h = new i(c.x + (a - c.y) / (h.y - c.y) * (h.x - c.x), a)._round()), l && c.equals(l[l.length - 1]) || o.push(l = [
                    c
                ]), l.push(h)))));
            }
            return o;
        }
        function Xu(t1, e1, r, n) {
            var a = [], o = t1.image, s = o.pixelRatio, u = o.paddedRect.w - 2, l = o.paddedRect.h - 2, p = t1.right - t1.left, c = t1.bottom - t1.top, h = o.stretchX || [
                [
                    0,
                    u
                ]
            ], f = o.stretchY || [
                [
                    0,
                    l
                ]
            ], y = function(t1, e1) {
                return t1 + e1[1] - e1[0];
            }, d = h.reduce(y, 0), m = f.reduce(y, 0), v = u - d, g = l - m, x = 0, b = d, w = 0, _ = m, A = 0, S = v, k = 0, I = g;
            if (o.content && n) {
                var z = o.content;
                x = Ju(h, 0, z[0]), w = Ju(f, 0, z[1]), b = Ju(h, z[0], z[2]), _ = Ju(f, z[1], z[3]), A = z[0] - x, k = z[1] - w, S = z[2] - z[0] - b, I = z[3] - z[1] - _;
            }
            var C = function(n, a, u, l) {
                var h = Yu(n.stretch - x, b, p, t1.left), f = $u(n.fixed - A, S, n.stretch, d), y = Yu(a.stretch - w, _, c, t1.top), v = $u(a.fixed - k, I, a.stretch, m), g = Yu(u.stretch - x, b, p, t1.left), z = $u(u.fixed - A, S, u.stretch, d), C = Yu(l.stretch - w, _, c, t1.top), E = $u(l.fixed - k, I, l.stretch, m), P = new i(h, y), M = new i(g, y), B = new i(g, C), T = new i(h, C), V = new i(f / s, v / s), F = new i(z / s, E / s), D = e1 * Math.PI / 180;
                if (D) {
                    var L = Math.sin(D), O = Math.cos(D), R = [
                        O,
                        -L,
                        L,
                        O
                    ];
                    P._matMult(R), M._matMult(R), T._matMult(R), B._matMult(R);
                }
                var U = n.stretch + n.fixed, j = a.stretch + a.fixed;
                return {
                    tl: P,
                    tr: M,
                    bl: T,
                    br: B,
                    tex: {
                        x: o.paddedRect.x + 1 + U,
                        y: o.paddedRect.y + 1 + j,
                        w: u.stretch + u.fixed - U,
                        h: l.stretch + l.fixed - j
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: V,
                    pixelOffsetBR: F,
                    minFontScaleX: S / s / p,
                    minFontScaleY: I / s / c,
                    isSDF: r
                };
            };
            if (n && (o.stretchX || o.stretchY)) for(var E = Hu(h, v, d), P = Hu(f, g, m), M = 0; M < E.length - 1; M++)for(var B = E[M], T = E[M + 1], V = 0; V < P.length - 1; V++)a.push(C(B, P[V], T, P[V + 1]));
            else a.push(C({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: u + 1
            }, {
                fixed: 0,
                stretch: l + 1
            }));
            return a;
        }
        function Ju(t1, e1, r) {
            for(var n = 0, i = 0, a = t1; i < a.length; i += 1){
                var o = a[i];
                n += Math.max(e1, Math.min(r, o[1])) - Math.max(e1, Math.min(r, o[0]));
            }
            return n;
        }
        function Hu(t1, e1, r) {
            for(var n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ], i = 0, a = t1; i < a.length; i += 1){
                var o = a[i], s = o[0], u = o[1], l = n[n.length - 1];
                n.push({
                    fixed: s - l.stretch,
                    stretch: l.stretch
                }), n.push({
                    fixed: s - l.stretch,
                    stretch: l.stretch + (u - s)
                });
            }
            return n.push({
                fixed: e1 + 1,
                stretch: r
            }), n;
        }
        function Yu(t1, e1, r, n) {
            return t1 / e1 * r + n;
        }
        function $u(t1, e1, r, n) {
            return t1 - e1 * r / n;
        }
        var Wu = function(t1, e1, r, n, a, o, s, u, l, p) {
            if (this.boxStartIndex = t1.length, l) {
                var c = o.top, h = o.bottom, f = o.collisionPadding;
                f && (c -= f[1], h += f[3]);
                var y = h - c;
                y > 0 && (y = Math.max(10, y), this.circleDiameter = y);
            } else {
                var d = o.top * s - u, m = o.bottom * s + u, v = o.left * s - u, g = o.right * s + u, x = o.collisionPadding;
                if (x && (v -= x[0] * s, d -= x[1] * s, g += x[2] * s, m += x[3] * s), p) {
                    var b = new i(v, d), w = new i(g, d), _ = new i(v, m), A = new i(g, m), S = p * Math.PI / 180;
                    b._rotate(S), w._rotate(S), _._rotate(S), A._rotate(S), v = Math.min(b.x, w.x, _.x, A.x), g = Math.max(b.x, w.x, _.x, A.x), d = Math.min(b.y, w.y, _.y, A.y), m = Math.max(b.y, w.y, _.y, A.y);
                }
                t1.emplaceBack(e1.x, e1.y, v, d, g, m, r, n, a);
            }
            this.boxEndIndex = t1.length;
        }, Qu = function(t1, e1) {
            if (void 0 === t1 && (t1 = []), void 0 === e1 && (e1 = tl), this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
        };
        function tl(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function el(t1, e1, r) {
            void 0 === e1 && (e1 = 1), void 0 === r && (r = !1);
            for(var n = 1 / 0, a = 1 / 0, o = -1 / 0, s = -1 / 0, u = t1[0], l = 0; l < u.length; l++){
                var p = u[l];
                (!l || p.x < n) && (n = p.x), (!l || p.y < a) && (a = p.y), (!l || p.x > o) && (o = p.x), (!l || p.y > s) && (s = p.y);
            }
            var c = Math.min(o - n, s - a), h = c / 2, f = new Qu([], rl);
            if (0 === c) return new i(n, a);
            for(var y = n; y < o; y += c)for(var d = a; d < s; d += c)f.push(new nl(y + h, d + h, h, t1));
            for(var m = function(t1) {
                for(var e1 = 0, r = 0, n = 0, i = t1[0], a = 0, o = i.length, s = o - 1; a < o; s = a++){
                    var u = i[a], l = i[s], p = u.x * l.y - l.x * u.y;
                    r += (u.x + l.x) * p, n += (u.y + l.y) * p, e1 += 3 * p;
                }
                return new nl(r / e1, n / e1, 0, t1);
            }(t1), v = f.length; f.length;){
                var g = f.pop();
                (g.d > m.d || !m.d) && (m = g, r && console.log("found best %d after %d probes", Math.round(1e4 * g.d) / 1e4, v)), g.max - m.d <= e1 || (f.push(new nl(g.p.x - (h = g.h / 2), g.p.y - h, h, t1)), f.push(new nl(g.p.x + h, g.p.y - h, h, t1)), f.push(new nl(g.p.x - h, g.p.y + h, h, t1)), f.push(new nl(g.p.x + h, g.p.y + h, h, t1)), v += 4);
            }
            return r && (console.log("num probes: " + v), console.log("best distance: " + m.d)), m.p;
        }
        function rl(t1, e1) {
            return e1.max - t1.max;
        }
        function nl(t1, e1, r, n) {
            this.p = new i(t1, e1), this.h = r, this.d = function(t1, e1) {
                for(var r = !1, n = 1 / 0, i = 0; i < e1.length; i++)for(var a = e1[i], o = 0, s = a.length, u = s - 1; o < s; u = o++){
                    var l = a[o], p = a[u];
                    l.y > t1.y != p.y > t1.y && t1.x < (p.x - l.x) * (t1.y - l.y) / (p.y - l.y) + l.x && (r = !r), n = Math.min(n, Ya(t1, l, p));
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        Qu.prototype.push = function(t1) {
            this.data.push(t1), this.length++, this._up(this.length - 1);
        }, Qu.prototype.pop = function() {
            if (0 !== this.length) {
                var t1 = this.data[0], e1 = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
            }
        }, Qu.prototype.peek = function() {
            return this.data[0];
        }, Qu.prototype._up = function(t1) {
            for(var e1 = this.data, r = this.compare, n = e1[t1]; t1 > 0;){
                var i = t1 - 1 >> 1, a = e1[i];
                if (r(n, a) >= 0) break;
                e1[t1] = a, t1 = i;
            }
            e1[t1] = n;
        }, Qu.prototype._down = function(t1) {
            for(var e1 = this.data, r = this.compare, n = this.length >> 1, i = e1[t1]; t1 < n;){
                var a = 1 + (t1 << 1), o = e1[a], s = a + 1;
                if (s < this.length && r(e1[s], o) < 0 && (a = s, o = e1[s]), r(o, i) >= 0) break;
                e1[t1] = o, t1 = a;
            }
            e1[t1] = i;
        };
        var il = Number.POSITIVE_INFINITY;
        function al(t1, e1) {
            return e1[1] !== il ? function(t1, e1, r) {
                var n = 0, i = 0;
                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e1;
                }
                return [
                    n,
                    i
                ];
            }(t1, e1[0], e1[1]) : function(t1, e1) {
                var r = 0, n = 0;
                e1 < 0 && (e1 = 0);
                var i = e1 / Math.sqrt(2);
                switch(t1){
                    case "top-right":
                    case "top-left":
                        n = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = 7 - i;
                        break;
                    case "bottom":
                        n = 7 - e1;
                        break;
                    case "top":
                        n = e1 - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e1;
                        break;
                    case "right":
                        r = -e1;
                }
                return [
                    r,
                    n
                ];
            }(t1, e1[0]);
        }
        function ol(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function sl(t1, e1, r, n, a, o, s, u, l, p, c, h, f, y, d) {
            var m = function(t1, e1, r, n, a, o, s, u) {
                for(var l = n.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, p = [], c = 0, h = e1.positionedLines; c < h.length; c += 1)for(var f = h[c], y = 0, d = f.positionedGlyphs; y < d.length; y += 1){
                    var m = d[y];
                    if (m.rect) {
                        var v = m.rect || {}, g = 4, x = !0, b = 1, w = 0, _ = (a || u) && m.vertical, A = m.metrics.advance * m.scale / 2;
                        if (u && e1.verticalizable && (w = f.lineOffset / 2 - (m.imageName ? -(24 - m.metrics.width * m.scale) / 2 : 24 * (m.scale - 1))), m.imageName) {
                            var S = s[m.imageName];
                            x = S.sdf, g = 1 / (b = S.pixelRatio);
                        }
                        var k = a ? [
                            m.x + A,
                            m.y
                        ] : [
                            0,
                            0
                        ], I = a ? [
                            0,
                            0
                        ] : [
                            m.x + A + r[0],
                            m.y + r[1] - w
                        ], z = [
                            0,
                            0
                        ];
                        _ && (z = I, I = [
                            0,
                            0
                        ]);
                        var C = (m.metrics.left - g) * m.scale - A + I[0], E = (-m.metrics.top - g) * m.scale + I[1], P = C + v.w * m.scale / b, M = E + v.h * m.scale / b, B = new i(C, E), T = new i(P, E), V = new i(C, M), F = new i(P, M);
                        if (_) {
                            var D = new i(-A, A - -17), L = -Math.PI / 2, O = 12 - A, R = new i(22 - O, -(m.imageName ? O : 0)), U = new (Function.prototype.bind.apply(i, [
                                null
                            ].concat(z)));
                            B._rotateAround(L, D)._add(R)._add(U), T._rotateAround(L, D)._add(R)._add(U), V._rotateAround(L, D)._add(R)._add(U), F._rotateAround(L, D)._add(R)._add(U);
                        }
                        if (l) {
                            var j = Math.sin(l), q = Math.cos(l), N = [
                                q,
                                -j,
                                j,
                                q
                            ];
                            B._matMult(N), T._matMult(N), V._matMult(N), F._matMult(N);
                        }
                        var K = new i(0, 0), G = new i(0, 0);
                        p.push({
                            tl: B,
                            tr: T,
                            bl: V,
                            br: F,
                            tex: v,
                            writingMode: e1.writingMode,
                            glyphOffset: k,
                            sectionIndex: m.sectionIndex,
                            isSDF: x,
                            pixelOffsetTL: K,
                            pixelOffsetBR: G,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return p;
            }(0, r, u, a, o, s, n, t1.allowVerticalPlacement), v = t1.textSizeData, g = null;
            "source" === v.kind ? (g = [
                128 * a.layout.get("text-size").evaluate(s, {})
            ])[0] > 32640 && A(t1.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".') : "composite" === v.kind && ((g = [
                128 * y.compositeTextSizes[0].evaluate(s, {}, d),
                128 * y.compositeTextSizes[1].evaluate(s, {}, d)
            ])[0] > 32640 || g[1] > 32640) && A(t1.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".'), t1.addSymbols(t1.text, m, g, u, o, s, p, e1, l.lineStartIndex, l.lineLength, f, d);
            for(var x = 0, b = c; x < b.length; x += 1)h[b[x]] = t1.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function ul(t1) {
            for(var e1 in t1)return t1[e1];
            return null;
        }
        function ll(t1, e1, r, n) {
            var i = t1.compareText;
            if (e1 in i) {
                for(var a = i[e1], o = a.length - 1; o >= 0; o--)if (n.dist(a[o]) < r) return !0;
            } else i[e1] = [];
            return i[e1].push(n), !1;
        }
        var pl = bs.VectorTileFeature.types, cl = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function hl(t1, e1, r, n, i, a, o, s, u, l, p, c, h) {
            var f = s ? Math.min(32640, Math.round(s[0])) : 0, y = s ? Math.min(32640, Math.round(s[1])) : 0;
            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), a, o, (f << 1) + (u ? 1 : 0), y, 16 * l, 16 * p, 256 * c, 256 * h);
        }
        function fl(t1, e1, r) {
            t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r);
        }
        function yl(t1) {
            for(var e1 = 0, r = t1.sections; e1 < r.length; e1 += 1)if ($n(r[e1].text)) return !0;
            return !1;
        }
        var dl = function(t1) {
            this.layoutVertexArray = new Vi, this.indexArray = new ji, this.programConfigurations = t1, this.segments = new sa, this.dynamicLayoutVertexArray = new Fi, this.opacityVertexArray = new Di, this.placedSymbolArray = new Qi;
        };
        dl.prototype.isEmpty = function() {
            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
        }, dl.prototype.upload = function(t1, e1, r, n) {
            this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, js.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, qs.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, cl, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
        }, dl.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
        }, On("SymbolBuffers", dl);
        var ml = function(t1, e1, r) {
            this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new sa, this.collisionVertexArray = new Ui;
        };
        ml.prototype.upload = function(t1) {
            this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, Ns.members, !0);
        }, ml.prototype.destroy = function() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
        }, On("CollisionBuffers", ml);
        var vl = function(t1) {
            this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                return t1.id;
            }), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = oo([]), this.placementViewportMatrix = oo([]);
            var e1 = this.layers[0]._unevaluatedLayout._values;
            this.textSizeData = Du(this.zoom, e1["text-size"]), this.iconSizeData = Du(this.zoom, e1["icon-size"]);
            var r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
            this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, "point" === r.get("symbol-placement") && (this.writingModes = r.get("text-writing-mode").map(function(t1) {
                return wu[t1];
            })), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                return t1.isStateDependent();
            }).map(function(t1) {
                return t1.id;
            }), this.sourceID = t1.sourceID;
        };
        vl.prototype.createArrays = function() {
            this.text = new dl(new Va(this.layers, this.zoom, function(t1) {
                return /^text/.test(t1);
            })), this.icon = new dl(new Va(this.layers, this.zoom, function(t1) {
                return /^icon/.test(t1);
            })), this.glyphOffsetArray = new ra, this.lineVertexArray = new na, this.symbolInstances = new ea;
        }, vl.prototype.calculateGlyphDependencies = function(t1, e1, r, n, i) {
            for(var a = 0; a < t1.length; a++)if (e1[t1.charCodeAt(a)] = !0, (r || n) && i) {
                var o = Xs[t1.charAt(a)];
                o && (e1[o.charCodeAt(0)] = !0);
            }
        }, vl.prototype.populate = function(t1, e1, r) {
            var n = this.layers[0], i = n.layout, a = i.get("text-font"), o = i.get("text-field"), s = i.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof ne && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), l = "constant" !== s.value.kind || !!s.value.value || Object.keys(s.parameters).length > 0, p = i.get("symbol-sort-key");
            if (this.features = [], u || l) {
                for(var c = e1.iconDependencies, h = e1.glyphDependencies, f = e1.availableImages, y = new si(this.zoom), d = 0, m = t1; d < m.length; d += 1){
                    var v = m[d], g = v.feature, x = v.id, b = v.index, w = v.sourceLayerIndex, _ = n._featureFilter.needGeometry, A = Ua(g, _);
                    if (n._featureFilter.filter(y, A, r)) {
                        _ || (A.geometry = Ra(g));
                        var S = void 0;
                        if (u) {
                            var k = n.getValueAndResolveTokens("text-field", A, r, f), I = ne.factory(k);
                            yl(I) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ii() || this.hasRTLText && oi.isParsed()) && (S = Zs(I, n, A));
                        }
                        var z = void 0;
                        if (l) {
                            var C = n.getValueAndResolveTokens("icon-image", A, r, f);
                            z = C instanceof ie ? C : ie.fromString(C);
                        }
                        if (S || z) {
                            var E = this.sortFeaturesByKey ? p.evaluate(A, {}, r) : void 0;
                            if (this.features.push({
                                id: x,
                                text: S,
                                icon: z,
                                index: b,
                                sourceLayerIndex: w,
                                geometry: A.geometry,
                                properties: g.properties,
                                type: pl[g.type],
                                sortKey: E
                            }), z && (c[z.name] = !0), S) {
                                var P = a.evaluate(A, {}, r).join(","), M = "map" === i.get("text-rotation-alignment") && "point" !== i.get("symbol-placement");
                                this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(wu.vertical) >= 0;
                                for(var B = 0, T = S.sections; B < T.length; B += 1){
                                    var V = T[B];
                                    if (V.image) c[V.image.name] = !0;
                                    else {
                                        var F = Zn(S.toString()), D = V.fontStack || P, L = h[D] = h[D] || {};
                                        this.calculateGlyphDependencies(V.text, L, M, this.allowVerticalPlacement, F);
                                    }
                                }
                            }
                        }
                    }
                }
                "line" === i.get("symbol-placement") && (this.features = function(t1) {
                    var e1 = {}, r = {}, n = [], i = 0;
                    function a(e1) {
                        n.push(t1[e1]), i++;
                    }
                    function o(t1, e1, i) {
                        var a = r[t1];
                        return delete r[t1], r[e1] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                    }
                    function s(t1, r, i) {
                        var a = e1[r];
                        return delete e1[r], e1[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                    }
                    function u(t1, e1, r) {
                        var n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                        return t1 + ":" + n.x + ":" + n.y;
                    }
                    for(var l = 0; l < t1.length; l++){
                        var p = t1[l], c = p.geometry, h = p.text ? p.text.toString() : null;
                        if (h) {
                            var f = u(h, c), y = u(h, c, !0);
                            if (f in r && y in e1 && r[f] !== e1[y]) {
                                var d = s(f, y, c), m = o(f, y, n[d].geometry);
                                delete e1[f], delete r[y], r[u(h, n[m].geometry, !0)] = m, n[d].geometry = null;
                            } else f in r ? o(f, y, c) : y in e1 ? s(f, y, c) : (a(l), e1[f] = i - 1, r[y] = i - 1);
                        } else a(l);
                    }
                    return n.filter(function(t1) {
                        return t1.geometry;
                    });
                }(this.features)), this.sortFeaturesByKey && this.features.sort(function(t1, e1) {
                    return t1.sortKey - e1.sortKey;
                });
            }
        }, vl.prototype.update = function(t1, e1, r) {
            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r));
        }, vl.prototype.isEmpty = function() {
            return 0 === this.symbolInstances.length && !this.hasRTLText;
        }, vl.prototype.uploadPending = function() {
            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
        }, vl.prototype.upload = function(t1) {
            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
        }, vl.prototype.destroyDebugData = function() {
            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
        }, vl.prototype.destroy = function() {
            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
        }, vl.prototype.addToLineVertexArray = function(t1, e1) {
            var r = this.lineVertexArray.length;
            if (void 0 !== t1.segment) {
                for(var n = t1.dist(e1[t1.segment + 1]), i = t1.dist(e1[t1.segment]), a = {}, o = t1.segment + 1; o < e1.length; o++)a[o] = {
                    x: e1[o].x,
                    y: e1[o].y,
                    tileUnitDistanceFromAnchor: n
                }, o < e1.length - 1 && (n += e1[o + 1].dist(e1[o]));
                for(var s = t1.segment || 0; s >= 0; s--)a[s] = {
                    x: e1[s].x,
                    y: e1[s].y,
                    tileUnitDistanceFromAnchor: i
                }, s > 0 && (i += e1[s - 1].dist(e1[s]));
                for(var u = 0; u < e1.length; u++){
                    var l = a[u];
                    this.lineVertexArray.emplaceBack(l.x, l.y, l.tileUnitDistanceFromAnchor);
                }
            }
            return {
                lineStartIndex: r,
                lineLength: this.lineVertexArray.length - r
            };
        }, vl.prototype.addSymbols = function(t1, e1, r, n, i, a, o, s, u, l, p, c) {
            for(var h = t1.indexArray, f = t1.layoutVertexArray, y = t1.segments.prepareSegment(4 * e1.length, f, h, this.canOverlap ? a.sortKey : void 0), d = this.glyphOffsetArray.length, m = y.vertexLength, v = this.allowVerticalPlacement && o === wu.vertical ? Math.PI / 2 : 0, g = a.text && a.text.sections, x = 0; x < e1.length; x++){
                var b = e1[x], w = b.tl, _ = b.tr, A = b.bl, S = b.br, k = b.tex, I = b.pixelOffsetTL, z = b.pixelOffsetBR, C = b.minFontScaleX, E = b.minFontScaleY, P = b.glyphOffset, M = b.isSDF, B = b.sectionIndex, T = y.vertexLength, V = P[1];
                hl(f, s.x, s.y, w.x, V + w.y, k.x, k.y, r, M, I.x, I.y, C, E), hl(f, s.x, s.y, _.x, V + _.y, k.x + k.w, k.y, r, M, z.x, I.y, C, E), hl(f, s.x, s.y, A.x, V + A.y, k.x, k.y + k.h, r, M, I.x, z.y, C, E), hl(f, s.x, s.y, S.x, V + S.y, k.x + k.w, k.y + k.h, r, M, z.x, z.y, C, E), fl(t1.dynamicLayoutVertexArray, s, v), h.emplaceBack(T, T + 1, T + 2), h.emplaceBack(T + 1, T + 2, T + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(P[0]), x !== e1.length - 1 && B === e1[x + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(f.length, a, a.index, {}, c, g && g[B]);
            }
            t1.placedSymbolArray.emplaceBack(s.x, s.y, d, this.glyphOffsetArray.length - d, m, u, l, s.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], o, 0, !1, 0, p);
        }, vl.prototype._addCollisionDebugVertex = function(t1, e1, r, n, i, a) {
            return e1.emplaceBack(0, 0), t1.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
        }, vl.prototype.addCollisionDebugVertices = function(t1, e1, r, n, a, o, s) {
            var u = a.segments.prepareSegment(4, a.layoutVertexArray, a.indexArray), l = u.vertexLength, p = a.layoutVertexArray, c = a.collisionVertexArray, h = s.anchorX, f = s.anchorY;
            this._addCollisionDebugVertex(p, c, o, h, f, new i(t1, e1)), this._addCollisionDebugVertex(p, c, o, h, f, new i(r, e1)), this._addCollisionDebugVertex(p, c, o, h, f, new i(r, n)), this._addCollisionDebugVertex(p, c, o, h, f, new i(t1, n)), u.vertexLength += 4;
            var y = a.indexArray;
            y.emplaceBack(l, l + 1), y.emplaceBack(l + 1, l + 2), y.emplaceBack(l + 2, l + 3), y.emplaceBack(l + 3, l), u.primitiveLength += 4;
        }, vl.prototype.addDebugCollisionBoxes = function(t1, e1, r, n) {
            for(var i = t1; i < e1; i++){
                var a = this.collisionBoxArray.get(i);
                this.addCollisionDebugVertices(a.x1, a.y1, a.x2, a.y2, n ? this.textCollisionBox : this.iconCollisionBox, a.anchorPoint, r);
            }
        }, vl.prototype.generateCollisionDebugBuffers = function() {
            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new ml(Oi, Ks.members, Xi), this.iconCollisionBox = new ml(Oi, Ks.members, Xi);
            for(var t1 = 0; t1 < this.symbolInstances.length; t1++){
                var e1 = this.symbolInstances.get(t1);
                this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
            }
        }, vl.prototype._deserializeCollisionBoxesForSymbol = function(t1, e1, r, n, i, a, o, s, u) {
            for(var l = {}, p = e1; p < r; p++){
                var c = t1.get(p);
                l.textBox = {
                    x1: c.x1,
                    y1: c.y1,
                    x2: c.x2,
                    y2: c.y2,
                    anchorPointX: c.anchorPointX,
                    anchorPointY: c.anchorPointY
                }, l.textFeatureIndex = c.featureIndex;
                break;
            }
            for(var h = n; h < i; h++){
                var f = t1.get(h);
                l.verticalTextBox = {
                    x1: f.x1,
                    y1: f.y1,
                    x2: f.x2,
                    y2: f.y2,
                    anchorPointX: f.anchorPointX,
                    anchorPointY: f.anchorPointY
                }, l.verticalTextFeatureIndex = f.featureIndex;
                break;
            }
            for(var y = a; y < o; y++){
                var d = t1.get(y);
                l.iconBox = {
                    x1: d.x1,
                    y1: d.y1,
                    x2: d.x2,
                    y2: d.y2,
                    anchorPointX: d.anchorPointX,
                    anchorPointY: d.anchorPointY
                }, l.iconFeatureIndex = d.featureIndex;
                break;
            }
            for(var m = s; m < u; m++){
                var v = t1.get(m);
                l.verticalIconBox = {
                    x1: v.x1,
                    y1: v.y1,
                    x2: v.x2,
                    y2: v.y2,
                    anchorPointX: v.anchorPointX,
                    anchorPointY: v.anchorPointY
                }, l.verticalIconFeatureIndex = v.featureIndex;
                break;
            }
            return l;
        }, vl.prototype.deserializeCollisionBoxes = function(t1) {
            this.collisionArrays = [];
            for(var e1 = 0; e1 < this.symbolInstances.length; e1++){
                var r = this.symbolInstances.get(e1);
                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
            }
        }, vl.prototype.hasTextData = function() {
            return this.text.segments.get().length > 0;
        }, vl.prototype.hasIconData = function() {
            return this.icon.segments.get().length > 0;
        }, vl.prototype.hasDebugData = function() {
            return this.textCollisionBox && this.iconCollisionBox;
        }, vl.prototype.hasTextCollisionBoxData = function() {
            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
        }, vl.prototype.hasIconCollisionBoxData = function() {
            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
        }, vl.prototype.addIndicesForPlacedSymbol = function(t1, e1) {
            for(var r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs, i = r.vertexStartIndex; i < n; i += 4)t1.indexArray.emplaceBack(i, i + 1, i + 2), t1.indexArray.emplaceBack(i + 1, i + 2, i + 3);
        }, vl.prototype.getSortedSymbolIndexes = function(t1) {
            if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
            for(var e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [], o = 0; o < this.symbolInstances.length; ++o){
                a.push(o);
                var s = this.symbolInstances.get(o);
                n.push(0 | Math.round(e1 * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
            }
            return a.sort(function(t1, e1) {
                return n[t1] - n[e1] || i[e1] - i[t1];
            }), a;
        }, vl.prototype.addToSortKeyRanges = function(t1, e1) {
            var r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
            r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                sortKey: e1,
                symbolInstanceStart: t1,
                symbolInstanceEnd: t1 + 1
            });
        }, vl.prototype.sortFeatures = function(t1) {
            var e1 = this;
            if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                for(var r = 0, n = this.symbolInstanceIndexes; r < n.length; r += 1){
                    var i = this.symbolInstances.get(n[r]);
                    this.featureSortOrder.push(i.featureIndex), [
                        i.rightJustifiedTextSymbolIndex,
                        i.centerJustifiedTextSymbolIndex,
                        i.leftJustifiedTextSymbolIndex
                    ].forEach(function(t1, r, n) {
                        t1 >= 0 && n.indexOf(t1) === r && e1.addIndicesForPlacedSymbol(e1.text, t1);
                    }), i.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, i.verticalPlacedTextSymbolIndex), i.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, i.placedIconSymbolIndex), i.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, i.verticalPlacedIconSymbolIndex);
                }
                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
            }
        }, On("SymbolBucket", vl, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), vl.MAX_GLYPHS = 65535, vl.addDynamicAttributes = fl;
        var gl = new wi({
            "symbol-placement": new mi(Et.layout_symbol["symbol-placement"]),
            "symbol-spacing": new mi(Et.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new mi(Et.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new vi(Et.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new mi(Et.layout_symbol["symbol-z-order"]),
            "icon-allow-overlap": new mi(Et.layout_symbol["icon-allow-overlap"]),
            "icon-ignore-placement": new mi(Et.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new mi(Et.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new mi(Et.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new vi(Et.layout_symbol["icon-size"]),
            "icon-text-fit": new mi(Et.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new mi(Et.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new vi(Et.layout_symbol["icon-image"]),
            "icon-rotate": new vi(Et.layout_symbol["icon-rotate"]),
            "icon-padding": new mi(Et.layout_symbol["icon-padding"]),
            "icon-keep-upright": new mi(Et.layout_symbol["icon-keep-upright"]),
            "icon-offset": new vi(Et.layout_symbol["icon-offset"]),
            "icon-anchor": new vi(Et.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new mi(Et.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new mi(Et.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new mi(Et.layout_symbol["text-rotation-alignment"]),
            "text-field": new vi(Et.layout_symbol["text-field"]),
            "text-font": new vi(Et.layout_symbol["text-font"]),
            "text-size": new vi(Et.layout_symbol["text-size"]),
            "text-max-width": new vi(Et.layout_symbol["text-max-width"]),
            "text-line-height": new mi(Et.layout_symbol["text-line-height"]),
            "text-letter-spacing": new vi(Et.layout_symbol["text-letter-spacing"]),
            "text-justify": new vi(Et.layout_symbol["text-justify"]),
            "text-radial-offset": new vi(Et.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new mi(Et.layout_symbol["text-variable-anchor"]),
            "text-anchor": new vi(Et.layout_symbol["text-anchor"]),
            "text-max-angle": new mi(Et.layout_symbol["text-max-angle"]),
            "text-writing-mode": new mi(Et.layout_symbol["text-writing-mode"]),
            "text-rotate": new vi(Et.layout_symbol["text-rotate"]),
            "text-padding": new mi(Et.layout_symbol["text-padding"]),
            "text-keep-upright": new mi(Et.layout_symbol["text-keep-upright"]),
            "text-transform": new vi(Et.layout_symbol["text-transform"]),
            "text-offset": new vi(Et.layout_symbol["text-offset"]),
            "text-allow-overlap": new mi(Et.layout_symbol["text-allow-overlap"]),
            "text-ignore-placement": new mi(Et.layout_symbol["text-ignore-placement"]),
            "text-optional": new mi(Et.layout_symbol["text-optional"])
        }), xl = {
            paint: new wi({
                "icon-opacity": new vi(Et.paint_symbol["icon-opacity"]),
                "icon-color": new vi(Et.paint_symbol["icon-color"]),
                "icon-halo-color": new vi(Et.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new vi(Et.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new vi(Et.paint_symbol["icon-halo-blur"]),
                "icon-translate": new mi(Et.paint_symbol["icon-translate"]),
                "icon-translate-anchor": new mi(Et.paint_symbol["icon-translate-anchor"]),
                "text-opacity": new vi(Et.paint_symbol["text-opacity"]),
                "text-color": new vi(Et.paint_symbol["text-color"], {
                    runtimeType: jt,
                    getOverride: function(t1) {
                        return t1.textColor;
                    },
                    hasOverride: function(t1) {
                        return !!t1.textColor;
                    }
                }),
                "text-halo-color": new vi(Et.paint_symbol["text-halo-color"]),
                "text-halo-width": new vi(Et.paint_symbol["text-halo-width"]),
                "text-halo-blur": new vi(Et.paint_symbol["text-halo-blur"]),
                "text-translate": new mi(Et.paint_symbol["text-translate"]),
                "text-translate-anchor": new mi(Et.paint_symbol["text-translate-anchor"])
            }),
            layout: gl
        }, bl = function(t1) {
            this.type = t1.property.overrides ? t1.property.overrides.runtimeType : Lt, this.defaultValue = t1;
        };
        bl.prototype.evaluate = function(t1) {
            if (t1.formattedSection) {
                var e1 = this.defaultValue.property.overrides;
                if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
            }
            return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
        }, bl.prototype.eachChild = function(t1) {
            this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
        }, bl.prototype.outputDefined = function() {
            return !1;
        }, bl.prototype.serialize = function() {
            return null;
        }, On("FormatSectionOverride", bl, {
            omit: [
                "defaultValue"
            ]
        });
        var wl = function(t1) {
            function e1(e1) {
                t1.call(this, e1, xl);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.recalculate = function(e1, r) {
                if (t1.prototype.recalculate.call(this, e1, r), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    var n = this.layout.get("text-writing-mode");
                    if (n) {
                        for(var i = [], a = 0, o = n; a < o.length; a += 1){
                            var s = o[a];
                            i.indexOf(s) < 0 && i.push(s);
                        }
                        this.layout._values["text-writing-mode"] = i;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }, e1.prototype.getValueAndResolveTokens = function(t1, e1, r, n) {
                var i = this.layout.get(t1).evaluate(e1, {}, r, n), a = this._unevaluatedLayout._values[t1];
                return a.isDataDriven() || Gr(a.value) || !i ? i : function(t1, e1) {
                    return e1.replace(/{([^{}]+)}/g, function(e1, r) {
                        return r in t1 ? String(t1[r]) : "";
                    });
                }(e1.properties, i);
            }, e1.prototype.createBucket = function(t1) {
                return new vl(t1);
            }, e1.prototype.queryRadius = function() {
                return 0;
            }, e1.prototype.queryIntersectsFeature = function() {
                return !1;
            }, e1.prototype._setPaintOverrides = function() {
                for(var t1 = 0, r = xl.paint.overridableProperties; t1 < r.length; t1 += 1){
                    var n = r[t1];
                    if (e1.hasPaintOverride(this.layout, n)) {
                        var i, a = this.paint.get(n), o = new bl(a), s = new Kr(o, a.property.specification);
                        i = "constant" === a.value.kind || "source" === a.value.kind ? new Xr("source", s) : new Jr("composite", s, a.value.zoomStops, a.value._interpolationType), this.paint._values[n] = new yi(a.property, i, a.parameters);
                    }
                }
            }, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, r, n) {
                return !(!this.layout || r.isDataDriven() || n.isDataDriven()) && e1.hasPaintOverride(this.layout, t1);
            }, e1.hasPaintOverride = function(t1, e1) {
                var r = t1.get("text-field"), n = xl.paint.properties[e1], i = !1, a = function(t1) {
                    for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (n.overrides && n.overrides.hasOverride(r[e1])) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof ne) a(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    var o = function(t1) {
                        i || (t1 instanceof le && se(t1.value) === Gt ? a(t1.value.sections) : t1 instanceof fe ? a(t1.sections) : t1.eachChild(o));
                    }, s = r.value;
                    s._styleExpression && o(s._styleExpression.expression);
                }
                return i;
            }, e1;
        }(_i), _l = {
            paint: new wi({
                "background-color": new mi(Et.paint_background["background-color"]),
                "background-pattern": new xi(Et.paint_background["background-pattern"]),
                "background-opacity": new mi(Et.paint_background["background-opacity"])
            })
        }, Al = function(t1) {
            function e1(e1) {
                t1.call(this, e1, _l);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(_i), Sl = {
            paint: new wi({
                "raster-opacity": new mi(Et.paint_raster["raster-opacity"]),
                "raster-hue-rotate": new mi(Et.paint_raster["raster-hue-rotate"]),
                "raster-brightness-min": new mi(Et.paint_raster["raster-brightness-min"]),
                "raster-brightness-max": new mi(Et.paint_raster["raster-brightness-max"]),
                "raster-saturation": new mi(Et.paint_raster["raster-saturation"]),
                "raster-contrast": new mi(Et.paint_raster["raster-contrast"]),
                "raster-resampling": new mi(Et.paint_raster["raster-resampling"]),
                "raster-fade-duration": new mi(Et.paint_raster["raster-fade-duration"])
            })
        }, kl = function(t1) {
            function e1(e1) {
                t1.call(this, e1, Sl);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(_i), Il = function(t1) {
            function e1(e1) {
                t1.call(this, e1, {}), this.implementation = e1;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.is3D = function() {
                return "3d" === this.implementation.renderingMode;
            }, e1.prototype.hasOffscreenPass = function() {
                return void 0 !== this.implementation.prerender;
            }, e1.prototype.recalculate = function() {}, e1.prototype.updateTransitions = function() {}, e1.prototype.hasTransition = function() {}, e1.prototype.serialize = function() {}, e1.prototype.onAdd = function(t1) {
                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
            }, e1.prototype.onRemove = function(t1) {
                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
            }, e1;
        }(_i), zl = {
            circle: co,
            heatmap: _o,
            hillshade: So,
            fill: ps,
            "fill-extrusion": zs,
            line: Rs,
            symbol: wl,
            background: Al,
            raster: kl
        }, Cl = o.HTMLImageElement, El = o.HTMLCanvasElement, Pl = o.HTMLVideoElement, Ml = o.ImageData, Bl = o.ImageBitmap, Tl = function(t1, e1, r, n) {
            this.context = t1, this.format = r, this.texture = t1.gl.createTexture(), this.update(e1, n);
        };
        Tl.prototype.update = function(t1, e1, r) {
            var n = t1.width, i = t1.height, a = !(this.size && this.size[0] === n && this.size[1] === i || r), o = this.context, s = o.gl;
            if (this.useMipmap = Boolean(e1 && e1.useMipmap), s.bindTexture(s.TEXTURE_2D, this.texture), o.pixelStoreUnpackFlipY.set(!1), o.pixelStoreUnpack.set(1), o.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA && (!e1 || !1 !== e1.premultiply)), a) this.size = [
                n,
                i
            ], t1 instanceof Cl || t1 instanceof El || t1 instanceof Pl || t1 instanceof Ml || Bl && t1 instanceof Bl ? s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, s.UNSIGNED_BYTE, t1) : s.texImage2D(s.TEXTURE_2D, 0, this.format, n, i, 0, this.format, s.UNSIGNED_BYTE, t1.data);
            else {
                var u = r || {
                    x: 0,
                    y: 0
                }, l = u.x, p = u.y;
                t1 instanceof Cl || t1 instanceof El || t1 instanceof Pl || t1 instanceof Ml || Bl && t1 instanceof Bl ? s.texSubImage2D(s.TEXTURE_2D, 0, l, p, s.RGBA, s.UNSIGNED_BYTE, t1) : s.texSubImage2D(s.TEXTURE_2D, 0, l, p, n, i, s.RGBA, s.UNSIGNED_BYTE, t1.data);
            }
            this.useMipmap && this.isSizePowerOfTwo() && s.generateMipmap(s.TEXTURE_2D);
        }, Tl.prototype.bind = function(t1, e1, r) {
            var n = this.context.gl;
            n.bindTexture(n.TEXTURE_2D, this.texture), r !== n.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = n.LINEAR), t1 !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, r || t1), this.filter = t1), e1 !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e1), this.wrap = e1);
        }, Tl.prototype.isSizePowerOfTwo = function() {
            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
        }, Tl.prototype.destroy = function() {
            this.context.gl.deleteTexture(this.texture), this.texture = null;
        };
        var Vl = function(t1) {
            var e1 = this;
            this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = function() {
                e1._triggered = !1, e1._callback();
            });
        };
        Vl.prototype.trigger = function() {
            var t1 = this;
            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function() {
                t1._triggered = !1, t1._callback();
            }, 0));
        }, Vl.prototype.remove = function() {
            delete this._channel, this._callback = function() {};
        };
        var Fl = function(t1, e1, r) {
            this.target = t1, this.parent = e1, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, v([
                "receive",
                "process"
            ], this), this.invoker = new Vl(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = I() ? t1 : o;
        };
        function Dl(t1, e1, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t1 * n - 2 * Math.PI * 6378137 / 2,
                e1 * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        Fl.prototype.send = function(t1, e1, r, n, i) {
            var a = this;
            void 0 === i && (i = !1);
            var o = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
            r && (this.callbacks[o] = r);
            var s = E(this.globalScope) ? void 0 : [];
            return this.target.postMessage({
                id: o,
                type: t1,
                hasCallback: !!r,
                targetMapId: n,
                mustQueue: i,
                sourceMapId: this.mapId,
                data: qn(e1, s)
            }, s), {
                cancel: function() {
                    r && delete a.callbacks[o], a.target.postMessage({
                        id: o,
                        type: "<cancel>",
                        targetMapId: n,
                        sourceMapId: a.mapId
                    });
                }
            };
        }, Fl.prototype.receive = function(t1) {
            var e1 = t1.data, r = e1.id;
            if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                if ("<cancel>" === e1.type) {
                    delete this.tasks[r];
                    var n = this.cancelCallbacks[r];
                    delete this.cancelCallbacks[r], n && n();
                } else I() || e1.mustQueue ? (this.tasks[r] = e1, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e1);
            }
        }, Fl.prototype.process = function() {
            if (this.taskQueue.length) {
                var t1 = this.taskQueue.shift(), e1 = this.tasks[t1];
                delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), e1 && this.processTask(t1, e1);
            }
        }, Fl.prototype.processTask = function(t1, e1) {
            var r = this;
            if ("<response>" === e1.type) {
                var n = this.callbacks[t1];
                delete this.callbacks[t1], n && (e1.error ? n(Nn(e1.error)) : n(null, Nn(e1.data)));
            } else {
                var i = !1, a = E(this.globalScope) ? void 0 : [], o = e1.hasCallback ? function(e1, n) {
                    i = !0, delete r.cancelCallbacks[t1], r.target.postMessage({
                        id: t1,
                        type: "<response>",
                        sourceMapId: r.mapId,
                        error: e1 ? qn(e1) : null,
                        data: qn(n, a)
                    }, a);
                } : function(t1) {
                    i = !0;
                }, s = null, u = Nn(e1.data);
                if (this.parent[e1.type]) s = this.parent[e1.type](e1.sourceMapId, u, o);
                else if (this.parent.getWorkerSource) {
                    var l = e1.type.split(".");
                    s = this.parent.getWorkerSource(e1.sourceMapId, l[0], u.source)[l[1]](u, o);
                } else o(new Error("Could not find function " + e1.type));
                !i && s && s.cancel && (this.cancelCallbacks[t1] = s.cancel);
            }
        }, Fl.prototype.remove = function() {
            this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
        };
        var Ll = function(t1, e1) {
            t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : 4 === t1.length ? this.setSouthWest([
                t1[0],
                t1[1]
            ]).setNorthEast([
                t1[2],
                t1[3]
            ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1]));
        };
        Ll.prototype.setNorthEast = function(t1) {
            return this._ne = t1 instanceof Ol ? new Ol(t1.lng, t1.lat) : Ol.convert(t1), this;
        }, Ll.prototype.setSouthWest = function(t1) {
            return this._sw = t1 instanceof Ol ? new Ol(t1.lng, t1.lat) : Ol.convert(t1), this;
        }, Ll.prototype.extend = function(t1) {
            var e1, r, n = this._sw, i = this._ne;
            if (t1 instanceof Ol) e1 = t1, r = t1;
            else {
                if (!(t1 instanceof Ll)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(Ll.convert(t1)) : this.extend(Ol.convert(t1)) : this;
                if (r = t1._ne, !(e1 = t1._sw) || !r) return this;
            }
            return n || i ? (n.lng = Math.min(e1.lng, n.lng), n.lat = Math.min(e1.lat, n.lat), i.lng = Math.max(r.lng, i.lng), i.lat = Math.max(r.lat, i.lat)) : (this._sw = new Ol(e1.lng, e1.lat), this._ne = new Ol(r.lng, r.lat)), this;
        }, Ll.prototype.getCenter = function() {
            return new Ol((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
        }, Ll.prototype.getSouthWest = function() {
            return this._sw;
        }, Ll.prototype.getNorthEast = function() {
            return this._ne;
        }, Ll.prototype.getNorthWest = function() {
            return new Ol(this.getWest(), this.getNorth());
        }, Ll.prototype.getSouthEast = function() {
            return new Ol(this.getEast(), this.getSouth());
        }, Ll.prototype.getWest = function() {
            return this._sw.lng;
        }, Ll.prototype.getSouth = function() {
            return this._sw.lat;
        }, Ll.prototype.getEast = function() {
            return this._ne.lng;
        }, Ll.prototype.getNorth = function() {
            return this._ne.lat;
        }, Ll.prototype.toArray = function() {
            return [
                this._sw.toArray(),
                this._ne.toArray()
            ];
        }, Ll.prototype.toString = function() {
            return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")";
        }, Ll.prototype.isEmpty = function() {
            return !(this._sw && this._ne);
        }, Ll.prototype.contains = function(t1) {
            var e1 = Ol.convert(t1), r = e1.lng, n = e1.lat, i = this._sw.lng <= r && r <= this._ne.lng;
            return this._sw.lng > this._ne.lng && (i = this._sw.lng >= r && r >= this._ne.lng), this._sw.lat <= n && n <= this._ne.lat && i;
        }, Ll.convert = function(t1) {
            return !t1 || t1 instanceof Ll ? t1 : new Ll(t1);
        };
        var Ol = function(t1, e1) {
            if (isNaN(t1) || isNaN(e1)) throw new Error("Invalid LngLat object: (" + t1 + ", " + e1 + ")");
            if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
        };
        Ol.prototype.wrap = function() {
            return new Ol(c(this.lng, -180, 180), this.lat);
        }, Ol.prototype.toArray = function() {
            return [
                this.lng,
                this.lat
            ];
        }, Ol.prototype.toString = function() {
            return "LngLat(" + this.lng + ", " + this.lat + ")";
        }, Ol.prototype.distanceTo = function(t1) {
            var e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
            return 6371008.8 * Math.acos(Math.min(i, 1));
        }, Ol.prototype.toBounds = function(t1) {
            void 0 === t1 && (t1 = 0);
            var e1 = 360 * t1 / 40075017, r = e1 / Math.cos(Math.PI / 180 * this.lat);
            return new Ll(new Ol(this.lng - r, this.lat - e1), new Ol(this.lng + r, this.lat + e1));
        }, Ol.convert = function(t1) {
            if (t1 instanceof Ol) return t1;
            if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new Ol(Number(t1[0]), Number(t1[1]));
            if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new Ol(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
        };
        var Rl = 2 * Math.PI * 6371008.8;
        function Ul(t1) {
            return Rl * Math.cos(t1 * Math.PI / 180);
        }
        function jl(t1) {
            return (180 + t1) / 360;
        }
        function ql(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function Nl(t1, e1) {
            return t1 / Ul(e1);
        }
        function Kl(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        var Gl = function(t1, e1, r) {
            void 0 === r && (r = 0), this.x = +t1, this.y = +e1, this.z = +r;
        };
        Gl.fromLngLat = function(t1, e1) {
            void 0 === e1 && (e1 = 0);
            var r = Ol.convert(t1);
            return new Gl(jl(r.lng), ql(r.lat), Nl(e1, r.lat));
        }, Gl.prototype.toLngLat = function() {
            return new Ol(360 * this.x - 180, Kl(this.y));
        }, Gl.prototype.toAltitude = function() {
            return this.z * Ul(Kl(this.y));
        }, Gl.prototype.meterInMercatorCoordinateUnits = function() {
            var t1;
            return 1 / Rl * (t1 = Kl(this.y), 1 / Math.cos(t1 * Math.PI / 180));
        };
        var Zl = function(t1, e1, r) {
            this.z = t1, this.x = e1, this.y = r, this.key = Hl(0, t1, t1, e1, r);
        };
        Zl.prototype.equals = function(t1) {
            return this.z === t1.z && this.x === t1.x && this.y === t1.y;
        }, Zl.prototype.url = function(t1, e1) {
            var r, n, i, a, o, s = (n = this.y, i = this.z, a = Dl(256 * (r = this.x), 256 * (n = Math.pow(2, i) - n - 1), i), o = Dl(256 * (r + 1), 256 * (n + 1), i), a[0] + "," + a[1] + "," + o[0] + "," + o[1]), u = function(t1, e1, r) {
                for(var n, i = "", a = t1; a > 0; a--)i += (e1 & (n = 1 << a - 1) ? 1 : 0) + (r & n ? 2 : 0);
                return i;
            }(this.z, this.x, this.y);
            return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String("tms" === e1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", u).replace("{bbox-epsg-3857}", s);
        }, Zl.prototype.getTilePoint = function(t1) {
            var e1 = Math.pow(2, this.z);
            return new i(8192 * (t1.x * e1 - this.x), 8192 * (t1.y * e1 - this.y));
        }, Zl.prototype.toString = function() {
            return this.z + "/" + this.x + "/" + this.y;
        };
        var Xl = function(t1, e1) {
            this.wrap = t1, this.canonical = e1, this.key = Hl(t1, e1.z, e1.z, e1.x, e1.y);
        }, Jl = function(t1, e1, r, n, i) {
            this.overscaledZ = t1, this.wrap = e1, this.canonical = new Zl(r, +n, +i), this.key = Hl(e1, t1, r, n, i);
        };
        function Hl(t1, e1, r, n, i) {
            (t1 *= 2) < 0 && (t1 = -1 * t1 - 1);
            var a = 1 << r;
            return (a * a * t1 + a * i + n).toString(36) + r.toString(36) + e1.toString(36);
        }
        Jl.prototype.equals = function(t1) {
            return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
        }, Jl.prototype.scaledTo = function(t1) {
            var e1 = this.canonical.z - t1;
            return t1 > this.canonical.z ? new Jl(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Jl(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
        }, Jl.prototype.calculateScaledKey = function(t1, e1) {
            var r = this.canonical.z - t1;
            return t1 > this.canonical.z ? Hl(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y) : Hl(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
        }, Jl.prototype.isChildOf = function(t1) {
            if (t1.wrap !== this.wrap) return !1;
            var e1 = this.canonical.z - t1.canonical.z;
            return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
        }, Jl.prototype.children = function(t1) {
            if (this.overscaledZ >= t1) return [
                new Jl(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
            ];
            var e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
            return [
                new Jl(e1, this.wrap, e1, r, n),
                new Jl(e1, this.wrap, e1, r + 1, n),
                new Jl(e1, this.wrap, e1, r, n + 1),
                new Jl(e1, this.wrap, e1, r + 1, n + 1)
            ];
        }, Jl.prototype.isLessThan = function(t1) {
            return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
        }, Jl.prototype.wrapped = function() {
            return new Jl(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
        }, Jl.prototype.unwrapTo = function(t1) {
            return new Jl(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
        }, Jl.prototype.overscaleFactor = function() {
            return Math.pow(2, this.overscaledZ - this.canonical.z);
        }, Jl.prototype.toUnwrapped = function() {
            return new Xl(this.wrap, this.canonical);
        }, Jl.prototype.toString = function() {
            return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y;
        }, Jl.prototype.getTilePoint = function(t1) {
            return this.canonical.getTilePoint(new Gl(t1.x - this.wrap, t1.y));
        }, On("CanonicalTileID", Zl), On("OverscaledTileID", Jl, {
            omit: [
                "posMatrix"
            ]
        });
        var Yl = function(t1, e1, r) {
            if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
            if (r && "mapbox" !== r && "terrarium" !== r) return A('"' + r + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
            this.stride = e1.height;
            var n = this.dim = e1.height - 2;
            this.data = new Uint32Array(e1.data.buffer), this.encoding = r || "mapbox";
            for(var i = 0; i < n; i++)this.data[this._idx(-1, i)] = this.data[this._idx(0, i)], this.data[this._idx(n, i)] = this.data[this._idx(n - 1, i)], this.data[this._idx(i, -1)] = this.data[this._idx(i, 0)], this.data[this._idx(i, n)] = this.data[this._idx(i, n - 1)];
            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(n, -1)] = this.data[this._idx(n - 1, 0)], this.data[this._idx(-1, n)] = this.data[this._idx(0, n - 1)], this.data[this._idx(n, n)] = this.data[this._idx(n - 1, n - 1)];
        };
        Yl.prototype.get = function(t1, e1) {
            var r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t1, e1);
            return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(r[n], r[n + 1], r[n + 2]);
        }, Yl.prototype.getUnpackVector = function() {
            return "terrarium" === this.encoding ? [
                256,
                1,
                1 / 256,
                32768
            ] : [
                6553.6,
                25.6,
                .1,
                1e4
            ];
        }, Yl.prototype._idx = function(t1, e1) {
            if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
            return (e1 + 1) * this.stride + (t1 + 1);
        }, Yl.prototype._unpackMapbox = function(t1, e1, r) {
            return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
        }, Yl.prototype._unpackTerrarium = function(t1, e1, r) {
            return 256 * t1 + e1 + r / 256 - 32768;
        }, Yl.prototype.getPixels = function() {
            return new xo({
                width: this.stride,
                height: this.stride
            }, new Uint8Array(this.data.buffer));
        }, Yl.prototype.backfillBorder = function(t1, e1, r) {
            if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
            var n = e1 * this.dim, i = e1 * this.dim + this.dim, a = r * this.dim, o = r * this.dim + this.dim;
            switch(e1){
                case -1:
                    n = i - 1;
                    break;
                case 1:
                    i = n + 1;
            }
            switch(r){
                case -1:
                    a = o - 1;
                    break;
                case 1:
                    o = a + 1;
            }
            for(var s = -e1 * this.dim, u = -r * this.dim, l = a; l < o; l++)for(var p = n; p < i; p++)this.data[this._idx(p, l)] = t1.data[this._idx(p + s, l + u)];
        }, On("DEMData", Yl);
        var $l = function(t1) {
            this._stringToNumber = {}, this._numberToString = [];
            for(var e1 = 0; e1 < t1.length; e1++){
                var r = t1[e1];
                this._stringToNumber[r] = e1, this._numberToString[e1] = r;
            }
        };
        $l.prototype.encode = function(t1) {
            return this._stringToNumber[t1];
        }, $l.prototype.decode = function(t1) {
            return this._numberToString[t1];
        };
        var Wl = function(t1, e1, r, n, i) {
            this.type = "Feature", this._vectorTileFeature = t1, t1._z = e1, t1._x = r, t1._y = n, this.properties = t1.properties, this.id = i;
        }, Ql = {
            geometry: {
                configurable: !0
            }
        };
        Ql.geometry.get = function() {
            return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
        }, Ql.geometry.set = function(t1) {
            this._geometry = t1;
        }, Wl.prototype.toJSON = function() {
            var t1 = {
                geometry: this.geometry
            };
            for(var e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && (t1[e1] = this[e1]);
            return t1;
        }, Object.defineProperties(Wl.prototype, Ql);
        var tp = function() {
            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
        };
        tp.prototype.updateState = function(t1, e1, r) {
            var n = String(e1);
            if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][n] = this.stateChanges[t1][n] || {}, h(this.stateChanges[t1][n], r), null === this.deletedStates[t1]) for(var i in this.deletedStates[t1] = {}, this.state[t1])i !== n && (this.deletedStates[t1][i] = null);
            else if (this.deletedStates[t1] && null === this.deletedStates[t1][n]) for(var a in this.deletedStates[t1][n] = {}, this.state[t1][n])r[a] || (this.deletedStates[t1][n][a] = null);
            else for(var o in r)this.deletedStates[t1] && this.deletedStates[t1][n] && null === this.deletedStates[t1][n][o] && delete this.deletedStates[t1][n][o];
        }, tp.prototype.removeFeatureState = function(t1, e1, r) {
            if (null !== this.deletedStates[t1]) {
                var n = String(e1);
                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, r && void 0 !== e1) null !== this.deletedStates[t1][n] && (this.deletedStates[t1][n] = this.deletedStates[t1][n] || {}, this.deletedStates[t1][n][r] = null);
                else if (void 0 !== e1) {
                    if (this.stateChanges[t1] && this.stateChanges[t1][n]) for(r in this.deletedStates[t1][n] = {}, this.stateChanges[t1][n])this.deletedStates[t1][n][r] = null;
                    else this.deletedStates[t1][n] = null;
                } else this.deletedStates[t1] = null;
            }
        }, tp.prototype.getState = function(t1, e1) {
            var r = String(e1), n = h({}, (this.state[t1] || {})[r], (this.stateChanges[t1] || {})[r]);
            if (null === this.deletedStates[t1]) return {};
            if (this.deletedStates[t1]) {
                var i = this.deletedStates[t1][e1];
                if (null === i) return {};
                for(var a in i)delete n[a];
            }
            return n;
        }, tp.prototype.initializeTileState = function(t1, e1) {
            t1.setFeatureState(this.state, e1);
        }, tp.prototype.coalesceChanges = function(t1, e1) {
            var r = {};
            for(var n in this.stateChanges){
                this.state[n] = this.state[n] || {};
                var i = {};
                for(var a in this.stateChanges[n])this.state[n][a] || (this.state[n][a] = {}), h(this.state[n][a], this.stateChanges[n][a]), i[a] = this.state[n][a];
                r[n] = i;
            }
            for(var o in this.deletedStates){
                this.state[o] = this.state[o] || {};
                var s = {};
                if (null === this.deletedStates[o]) for(var u in this.state[o])s[u] = {}, this.state[o][u] = {};
                else for(var l in this.deletedStates[o]){
                    if (null === this.deletedStates[o][l]) this.state[o][l] = {};
                    else for(var p = 0, c = Object.keys(this.deletedStates[o][l]); p < c.length; p += 1)delete this.state[o][l][c[p]];
                    s[l] = this.state[o][l];
                }
                r[o] = r[o] || {}, h(r[o], s);
            }
            if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for(var f in t1)t1[f].setFeatureState(r, e1);
        };
        var ep = function(t1, e1) {
            this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new Tn(8192, 16, 0), this.grid3D = new Tn(8192, 16, 0), this.featureIndexArray = new aa, this.promoteId = e1;
        };
        function rp(t1, e1, r, n, i) {
            return x(t1, function(t1, a) {
                var o = e1 instanceof di ? e1.get(a) : null;
                return o && o.evaluate ? o.evaluate(r, n, i) : o;
            });
        }
        function np(t1) {
            for(var e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0, a = 0, o = t1; a < o.length; a += 1){
                var s = o[a];
                e1 = Math.min(e1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            }
            return {
                minX: e1,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function ip(t1, e1) {
            return e1 - t1;
        }
        ep.prototype.insert = function(t1, e1, r, n, i, a) {
            var o = this.featureIndexArray.length;
            this.featureIndexArray.emplaceBack(r, n, i);
            for(var s = a ? this.grid3D : this.grid, u = 0; u < e1.length; u++){
                for(var l = e1[u], p = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], c = 0; c < l.length; c++){
                    var h = l[c];
                    p[0] = Math.min(p[0], h.x), p[1] = Math.min(p[1], h.y), p[2] = Math.max(p[2], h.x), p[3] = Math.max(p[3], h.y);
                }
                p[0] < 8192 && p[1] < 8192 && p[2] >= 0 && p[3] >= 0 && s.insert(o, p[0], p[1], p[2], p[3]);
            }
        }, ep.prototype.loadVTLayers = function() {
            return this.vtLayers || (this.vtLayers = new bs.VectorTile(new Ys(this.rawTileData)).layers, this.sourceLayerCoder = new $l(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                "_geojsonTileLayer"
            ])), this.vtLayers;
        }, ep.prototype.query = function(t1, e1, r, n) {
            var a = this;
            this.loadVTLayers();
            for(var o = t1.params || {}, s = 8192 / t1.tileSize / t1.scale, u = on(o.filter), l = t1.queryGeometry, p = t1.queryPadding * s, c = np(l), h = this.grid.query(c.minX - p, c.minY - p, c.maxX + p, c.maxY + p), f = np(t1.cameraQueryGeometry), y = this.grid3D.query(f.minX - p, f.minY - p, f.maxX + p, f.maxY + p, function(e1, r, n, a) {
                return function(t1, e1, r, n, a) {
                    for(var o = 0, s = t1; o < s.length; o += 1){
                        var u = s[o];
                        if (e1 <= u.x && r <= u.y && n >= u.x && a >= u.y) return !0;
                    }
                    var l = [
                        new i(e1, r),
                        new i(e1, a),
                        new i(n, a),
                        new i(n, r)
                    ];
                    if (t1.length > 2) {
                        for(var p = 0, c = l; p < c.length; p += 1)if (Wa(t1, c[p])) return !0;
                    }
                    for(var h = 0; h < t1.length - 1; h++)if (Qa(t1[h], t1[h + 1], l)) return !0;
                    return !1;
                }(t1.cameraQueryGeometry, e1 - p, r - p, n + p, a + p);
            }), d = 0, m = y; d < m.length; d += 1)h.push(m[d]);
            h.sort(ip);
            for(var v, g = {}, x = function(i) {
                var p = h[i];
                if (p !== v) {
                    v = p;
                    var c = a.featureIndexArray.get(p), f = null;
                    a.loadMatchingFeature(g, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, u, o.layers, o.availableImages, e1, r, n, function(e1, r, n) {
                        return f || (f = Ra(e1)), r.queryIntersectsFeature(l, e1, n, f, a.z, t1.transform, s, t1.pixelPosMatrix);
                    });
                }
            }, b = 0; b < h.length; b++)x(b);
            return g;
        }, ep.prototype.loadMatchingFeature = function(t1, e1, r, n, i, a, o, s, u, l, p) {
            var c = this.bucketLayerIDs[e1];
            if (!a || function(t1, e1) {
                for(var r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                return !1;
            }(a, c)) {
                var f = this.sourceLayerCoder.decode(r), y = this.vtLayers[f].feature(n);
                if (i.needGeometry) {
                    var d = Ua(y, !0);
                    if (!i.filter(new si(this.tileID.overscaledZ), d, this.tileID.canonical)) return;
                } else if (!i.filter(new si(this.tileID.overscaledZ), y)) return;
                for(var m = this.getId(y, f), v = 0; v < c.length; v++){
                    var g = c[v];
                    if (!(a && a.indexOf(g) < 0)) {
                        var x = s[g];
                        if (x) {
                            var b = {};
                            void 0 !== m && l && (b = l.getState(x.sourceLayer || "_geojsonTileLayer", m));
                            var w = h({}, u[g]);
                            w.paint = rp(w.paint, x.paint, y, b, o), w.layout = rp(w.layout, x.layout, y, b, o);
                            var _ = !p || p(y, x, b);
                            if (_) {
                                var A = new Wl(y, this.z, this.x, this.y, m);
                                A.layer = w;
                                var S = t1[g];
                                void 0 === S && (S = t1[g] = []), S.push({
                                    featureIndex: n,
                                    feature: A,
                                    intersectionZ: _
                                });
                            }
                        }
                    }
                }
            }
        }, ep.prototype.lookupSymbolFeatures = function(t1, e1, r, n, i, a, o, s) {
            var u = {};
            this.loadVTLayers();
            for(var l = on(i), p = 0, c = t1; p < c.length; p += 1)this.loadMatchingFeature(u, r, n, c[p], l, a, o, s, e1);
            return u;
        }, ep.prototype.hasLayer = function(t1) {
            for(var e1 = 0, r = this.bucketLayerIDs; e1 < r.length; e1 += 1)for(var n = 0, i = r[e1]; n < i.length; n += 1)if (t1 === i[n]) return !0;
            return !1;
        }, ep.prototype.getId = function(t1, e1) {
            var r = t1.id;
            return this.promoteId && "boolean" == typeof (r = t1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1]]) && (r = Number(r)), r;
        }, On("FeatureIndex", ep, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        var ap = function(t1, e1) {
            this.tileID = t1, this.uid = y(), this.uses = 0, this.tileSize = e1, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.expiredRequestCount = 0, this.state = "loading";
        };
        ap.prototype.registerFadeDuration = function(t1) {
            var e1 = t1 + this.timeAdded;
            e1 < O.now() || this.fadeEndTime && e1 < this.fadeEndTime || (this.fadeEndTime = e1);
        }, ap.prototype.wasRequested = function() {
            return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
        }, ap.prototype.loadVectorData = function(t1, e1, r) {
            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", t1) {
                for(var n in t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(t1, e1) {
                    var r = {};
                    if (!e1) return r;
                    for(var n = function() {
                        var t1 = a[i], n = t1.layerIds.map(function(t1) {
                            return e1.getLayer(t1);
                        }).filter(Boolean);
                        if (0 !== n.length) {
                            t1.layers = n, t1.stateDependentLayerIds && (t1.stateDependentLayers = t1.stateDependentLayerIds.map(function(t1) {
                                return n.filter(function(e1) {
                                    return e1.id === t1;
                                })[0];
                            }));
                            for(var o = 0, s = n; o < s.length; o += 1)r[s[o].id] = t1;
                        }
                    }, i = 0, a = t1; i < a.length; i += 1)n();
                    return r;
                }(t1.buckets, e1.style), this.hasSymbolBuckets = !1, this.buckets){
                    var i = this.buckets[n];
                    if (i instanceof vl) {
                        if (this.hasSymbolBuckets = !0, !r) break;
                        i.justReloaded = !0;
                    }
                }
                if (this.hasRTLText = !1, this.hasSymbolBuckets) for(var a in this.buckets){
                    var o = this.buckets[a];
                    if (o instanceof vl && o.hasRTLText) {
                        this.hasRTLText = !0, oi.isLoading() || oi.isLoaded() || "deferred" !== ii() || ai();
                        break;
                    }
                }
                for(var s in this.queryPadding = 0, this.buckets){
                    var u = this.buckets[s];
                    this.queryPadding = Math.max(this.queryPadding, e1.style.getLayer(s).queryRadius(u));
                }
                t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage);
            } else this.collisionBoxArray = new $i;
        }, ap.prototype.unloadVectorData = function() {
            for(var t1 in this.buckets)this.buckets[t1].destroy();
            this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
        }, ap.prototype.getBucket = function(t1) {
            return this.buckets[t1.id];
        }, ap.prototype.upload = function(t1) {
            for(var e1 in this.buckets){
                var r = this.buckets[e1];
                r.uploadPending() && r.upload(t1);
            }
            var n = t1.gl;
            this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new Tl(t1, this.imageAtlas.image, n.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new Tl(t1, this.glyphAtlasImage, n.ALPHA), this.glyphAtlasImage = null);
        }, ap.prototype.prepare = function(t1) {
            this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
        }, ap.prototype.queryRenderedFeatures = function(t1, e1, r, n, i, a, o, s, u, l) {
            return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                queryGeometry: n,
                cameraQueryGeometry: i,
                scale: a,
                tileSize: this.tileSize,
                pixelPosMatrix: l,
                transform: s,
                params: o,
                queryPadding: this.queryPadding * u
            }, t1, e1, r) : {};
        }, ap.prototype.querySourceFeatures = function(t1, e1) {
            var r = this.latestFeatureIndex;
            if (r && r.rawTileData) {
                var n = r.loadVTLayers(), i = e1 ? e1.sourceLayer : "", a = n._geojsonTileLayer || n[i];
                if (a) for(var o = on(e1 && e1.filter), s = this.tileID.canonical, u = s.z, l = s.x, p = s.y, c = {
                    z: u,
                    x: l,
                    y: p
                }, h = 0; h < a.length; h++){
                    var f = a.feature(h);
                    if (o.needGeometry) {
                        var y = Ua(f, !0);
                        if (!o.filter(new si(this.tileID.overscaledZ), y, this.tileID.canonical)) continue;
                    } else if (!o.filter(new si(this.tileID.overscaledZ), f)) continue;
                    var d = r.getId(f, i), m = new Wl(f, u, l, p, d);
                    m.tile = c, t1.push(m);
                }
            }
        }, ap.prototype.hasData = function() {
            return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
        }, ap.prototype.patternsLoaded = function() {
            return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
        }, ap.prototype.setExpiryData = function(t1) {
            var e1 = this.expirationTime;
            if (t1.cacheControl) {
                var r = z(t1.cacheControl);
                r["max-age"] && (this.expirationTime = Date.now() + 1e3 * r["max-age"]);
            } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
            if (this.expirationTime) {
                var n = Date.now(), i = !1;
                if (this.expirationTime > n) i = !1;
                else if (e1) {
                    if (this.expirationTime < e1) i = !0;
                    else {
                        var a = this.expirationTime - e1;
                        a ? this.expirationTime = n + Math.max(a, 3e4) : i = !0;
                    }
                } else i = !0;
                i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
            }
        }, ap.prototype.getExpiryTimeout = function() {
            if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
        }, ap.prototype.setFeatureState = function(t1, e1) {
            if (this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(t1).length) {
                var r = this.latestFeatureIndex.loadVTLayers();
                for(var n in this.buckets)if (e1.style.hasLayer(n)) {
                    var i = this.buckets[n], a = i.layers[0].sourceLayer || "_geojsonTileLayer", o = r[a], s = t1[a];
                    if (o && s && 0 !== Object.keys(s).length) {
                        i.update(s, o, this.imageAtlas && this.imageAtlas.patternPositions || {});
                        var u = e1 && e1.style && e1.style.getLayer(n);
                        u && (this.queryPadding = Math.max(this.queryPadding, u.queryRadius(i)));
                    }
                }
            }
        }, ap.prototype.holdingForFade = function() {
            return void 0 !== this.symbolFadeHoldUntil;
        }, ap.prototype.symbolFadeFinished = function() {
            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < O.now();
        }, ap.prototype.clearFadeHold = function() {
            this.symbolFadeHoldUntil = void 0;
        }, ap.prototype.setHoldDuration = function(t1) {
            this.symbolFadeHoldUntil = O.now() + t1;
        }, ap.prototype.setDependencies = function(t1, e1) {
            for(var r = {}, n = 0, i = e1; n < i.length; n += 1)r[i[n]] = !0;
            this.dependencies[t1] = r;
        }, ap.prototype.hasDependency = function(t1, e1) {
            for(var r = 0, n = t1; r < n.length; r += 1){
                var i = this.dependencies[n[r]];
                if (i) {
                    for(var a = 0, o = e1; a < o.length; a += 1)if (i[o[a]]) return !0;
                }
            }
            return !1;
        };
        var op = o.performance, sp = function(t1) {
            this._marks = {
                start: [
                    t1.url,
                    "start"
                ].join("#"),
                end: [
                    t1.url,
                    "end"
                ].join("#"),
                measure: t1.url.toString()
            }, op.mark(this._marks.start);
        };
        sp.prototype.finish = function() {
            op.mark(this._marks.end);
            var t1 = op.getEntriesByName(this._marks.measure);
            return 0 === t1.length && (op.measure(this._marks.measure, this._marks.start, this._marks.end), t1 = op.getEntriesByName(this._marks.measure), op.clearMarks(this._marks.start), op.clearMarks(this._marks.end), op.clearMeasures(this._marks.measure)), t1;
        }, t1.Actor = Fl, t1.AlphaImage = go, t1.CanonicalTileID = Zl, t1.CollisionBoxArray = $i, t1.Color = te, t1.DEMData = Yl, t1.DataConstantProperty = mi, t1.DictionaryCoder = $l, t1.EXTENT = 8192, t1.ErrorEvent = zt, t1.EvaluationParameters = si, t1.Event = It, t1.Evented = Ct, t1.FeatureIndex = ep, t1.FillBucket = ss, t1.FillExtrusionBucket = Ss, t1.ImageAtlas = bu, t1.ImagePosition = gu, t1.LineBucket = Fs, t1.LngLat = Ol, t1.LngLatBounds = Ll, t1.MercatorCoordinate = Gl, t1.ONE_EM = 24, t1.OverscaledTileID = Jl, t1.Point = i, t1.Point$1 = i, t1.Properties = wi, t1.Protobuf = Ys, t1.RGBAImage = xo, t1.RequestManager = G, t1.RequestPerformance = sp, t1.ResourceType = yt, t1.SegmentVector = sa, t1.SourceFeatureState = tp, t1.StructArrayLayout1ui2 = Ji, t1.StructArrayLayout2f1f2i16 = Ri, t1.StructArrayLayout2i4 = Ci, t1.StructArrayLayout3ui6 = ji, t1.StructArrayLayout4i8 = Ei, t1.SymbolBucket = vl, t1.Texture = Tl, t1.Tile = ap, t1.Transitionable = pi, t1.Uniform1f = ba, t1.Uniform1i = xa, t1.Uniform2f = wa, t1.Uniform3f = _a, t1.Uniform4f = Aa, t1.UniformColor = Sa, t1.UniformMatrix4f = Ia, t1.UnwrappedTileID = Xl, t1.ValidationError = Pt, t1.WritingMode = wu, t1.ZoomHistory = Kn, t1.add = function(t1, e1, r) {
            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
        }, t1.addDynamicAttributes = fl, t1.asyncAll = function(t1, e1, r) {
            if (!t1.length) return r(null, []);
            var n = t1.length, i = new Array(t1.length), a = null;
            t1.forEach(function(t1, o) {
                e1(t1, function(t1, e1) {
                    t1 && (a = t1), i[o] = e1, 0 == --n && r(a, i);
                });
            });
        }, t1.bezier = u, t1.bindAll = v, t1.browser = O, t1.cacheEntryPossiblyAdded = function(t1) {
            ++ht > ut && (t1.getActor().send("enforceCacheSizeLimit", st), ht = 0);
        }, t1.clamp = p, t1.clearTileCache = function(t1) {
            var e1 = o.caches.delete("mapbox-tiles");
            t1 && e1.catch(t1).then(function() {
                return t1();
            });
        }, t1.clipLine = Zu, t1.clone = function(t1) {
            var e1 = new ao(16);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }, t1.clone$1 = w, t1.clone$2 = function(t1) {
            var e1 = new ao(3);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
        }, t1.collisionCircleLayout = Gs, t1.config = R, t1.create = function() {
            var t1 = new ao(16);
            return ao != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
        }, t1.create$1 = function() {
            var t1 = new ao(9);
            return ao != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
        }, t1.create$2 = function() {
            var t1 = new ao(4);
            return ao != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
        }, t1.createCommonjsModule = e1, t1.createExpression = Zr, t1.createLayout = Ii, t1.createStyleLayer = function(t1) {
            return "custom" === t1.type ? new Il(t1) : new zl[t1.type](t1);
        }, t1.cross = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], u = r[2];
            return t1[0] = i * u - a * s, t1[1] = a * o - n * u, t1[2] = n * s - i * o, t1;
        }, t1.deepEqual = function t1(e1, r) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(r) || e1.length !== r.length) return !1;
                for(var n = 0; n < e1.length; n++)if (!t1(e1[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(e1).length !== Object.keys(r).length) return !1;
                for(var i in e1)if (!t1(e1[i], r[i])) return !1;
                return !0;
            }
            return e1 === r;
        }, t1.dot = function(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
        }, t1.dot$1 = function(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
        }, t1.ease = l, t1.emitValidationErrors = Bn, t1.endsWith = g, t1.enforceCacheSizeLimit = function(t1) {
            lt(), tt && tt.then(function(e1) {
                e1.keys().then(function(r) {
                    for(var n = 0; n < r.length - t1; n++)e1.delete(r[n]);
                });
            });
        }, t1.evaluateSizeForFeature = Lu, t1.evaluateSizeForZoom = Ou, t1.evaluateVariableOffset = al, t1.evented = ni, t1.extend = h, t1.featureFilter = on, t1.filterObject = b, t1.fromRotation = function(t1, e1) {
            var r = Math.sin(e1), n = Math.cos(e1);
            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
        }, t1.getAnchorAlignment = Bu, t1.getAnchorJustification = ol, t1.getArrayBuffer = bt, t1.getImage = At, t1.getJSON = function(t1, e1) {
            return xt(h(t1, {
                type: "json"
            }), e1);
        }, t1.getRTLTextPluginStatus = ii, t1.getReferrer = mt, t1.getVideo = function(t1, e1) {
            var r, n, i = o.document.createElement("video");
            i.muted = !0, i.onloadstart = function() {
                e1(null, i);
            };
            for(var a = 0; a < t1.length; a++){
                var s = o.document.createElement("source");
                r = t1[a], n = void 0, (n = o.document.createElement("a")).href = r, (n.protocol !== o.document.location.protocol || n.host !== o.document.location.host) && (i.crossOrigin = "Anonymous"), s.src = t1[a], i.appendChild(s);
            }
            return {
                cancel: function() {}
            };
        }, t1.identity = oo, t1.invert = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], u = e1[6], l = e1[7], p = e1[8], c = e1[9], h = e1[10], f = e1[11], y = e1[12], d = e1[13], m = e1[14], v = e1[15], g = r * s - n * o, x = r * u - i * o, b = r * l - a * o, w = n * u - i * s, _ = n * l - a * s, A = i * l - a * u, S = p * d - c * y, k = p * m - h * y, I = p * v - f * y, z = c * m - h * d, C = c * v - f * d, E = h * v - f * m, P = g * E - x * C + b * z + w * I - _ * k + A * S;
            return P ? (t1[0] = (s * E - u * C + l * z) * (P = 1 / P), t1[1] = (i * C - n * E - a * z) * P, t1[2] = (d * A - m * _ + v * w) * P, t1[3] = (h * _ - c * A - f * w) * P, t1[4] = (u * I - o * E - l * k) * P, t1[5] = (r * E - i * I + a * k) * P, t1[6] = (m * b - y * A - v * x) * P, t1[7] = (p * A - h * b + f * x) * P, t1[8] = (o * C - s * I + l * S) * P, t1[9] = (n * I - r * C - a * S) * P, t1[10] = (y * _ - d * b + v * g) * P, t1[11] = (c * b - p * _ - f * g) * P, t1[12] = (s * k - o * z - u * S) * P, t1[13] = (r * z - n * k + i * S) * P, t1[14] = (d * x - y * w - m * g) * P, t1[15] = (p * w - c * x + h * g) * P, t1) : null;
        }, t1.isChar = Gn, t1.isMapboxURL = Z, t1.keysDifference = function(t1, e1) {
            var r = [];
            for(var n in t1)n in e1 || r.push(n);
            return r;
        }, t1.makeRequest = xt, t1.mapObject = x, t1.mercatorXfromLng = jl, t1.mercatorYfromLat = ql, t1.mercatorZfromAltitude = Nl, t1.mul = lo, t1.multiply = so, t1.mvt = bs, t1.nextPowerOfTwo = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }, t1.normalize = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
            return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a, t1;
        }, t1.number = Ke, t1.offscreenCanvasSupported = ft, t1.ortho = function(t1, e1, r, n, i, a, o) {
            var s = 1 / (e1 - r), u = 1 / (n - i), l = 1 / (a - o);
            return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * u, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * l, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * u, t1[14] = (o + a) * l, t1[15] = 1, t1;
        }, t1.parseGlyphPBF = function(t1) {
            return new Ys(t1).readFields(yu, []);
        }, t1.pbf = Ys, t1.performSymbolLayout = function(t1, e1, r, n, i, a, o) {
            t1.createArrays(), t1.tilePixelRatio = 8192 / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            var s = t1.layers[0].layout, u = t1.layers[0]._unevaluatedLayout._values, l = {};
            if ("composite" === t1.textSizeData.kind) {
                var p = t1.textSizeData, c = p.maxZoom;
                l.compositeTextSizes = [
                    u["text-size"].possiblyEvaluate(new si(p.minZoom), o),
                    u["text-size"].possiblyEvaluate(new si(c), o)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                var h = t1.iconSizeData, f = h.maxZoom;
                l.compositeIconSizes = [
                    u["icon-size"].possiblyEvaluate(new si(h.minZoom), o),
                    u["icon-size"].possiblyEvaluate(new si(f), o)
                ];
            }
            l.layoutTextSize = u["text-size"].possiblyEvaluate(new si(t1.zoom + 1), o), l.layoutIconSize = u["icon-size"].possiblyEvaluate(new si(t1.zoom + 1), o), l.textMaxSize = u["text-size"].possiblyEvaluate(new si(18));
            for(var y = 24 * s.get("text-line-height"), d = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement"), m = s.get("text-keep-upright"), v = s.get("text-size"), g = function() {
                var a = b[x], u = s.get("text-font").evaluate(a, {}, o).join(","), p = v.evaluate(a, {}, o), c = l.layoutTextSize.evaluate(a, {}, o), h = l.layoutIconSize.evaluate(a, {}, o), f = {
                    horizontal: {},
                    vertical: void 0
                }, g = a.text, w = [
                    0,
                    0
                ];
                if (g) {
                    var _ = g.toString(), S = 24 * s.get("text-letter-spacing").evaluate(a, {}, o), k = function(t1) {
                        for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (n = r[e1].charCodeAt(0), Gn.Arabic(n) || Gn["Arabic Supplement"](n) || Gn["Arabic Extended-A"](n) || Gn["Arabic Presentation Forms-A"](n) || Gn["Arabic Presentation Forms-B"](n)) return !1;
                        var n;
                        return !0;
                    }(_) ? S : 0, I = s.get("text-anchor").evaluate(a, {}, o), z = s.get("text-variable-anchor");
                    if (!z) {
                        var C = s.get("text-radial-offset").evaluate(a, {}, o);
                        w = C ? al(I, [
                            24 * C,
                            il
                        ]) : s.get("text-offset").evaluate(a, {}, o).map(function(t1) {
                            return 24 * t1;
                        });
                    }
                    var E = d ? "center" : s.get("text-justify").evaluate(a, {}, o), P = s.get("symbol-placement"), M = "point" === P ? 24 * s.get("text-max-width").evaluate(a, {}, o) : 0, B = function() {
                        t1.allowVerticalPlacement && Zn(_) && (f.vertical = Su(g, e1, r, i, u, M, y, I, "left", k, w, wu.vertical, !0, P, c, p));
                    };
                    if (!d && z) {
                        for(var T = "auto" === E ? z.map(function(t1) {
                            return ol(t1);
                        }) : [
                            E
                        ], V = !1, F = 0; F < T.length; F++){
                            var D = T[F];
                            if (!f.horizontal[D]) {
                                if (V) f.horizontal[D] = f.horizontal[0];
                                else {
                                    var L = Su(g, e1, r, i, u, M, y, "center", D, k, w, wu.horizontal, !1, P, c, p);
                                    L && (f.horizontal[D] = L, V = 1 === L.positionedLines.length);
                                }
                            }
                        }
                        B();
                    } else {
                        "auto" === E && (E = ol(I));
                        var O = Su(g, e1, r, i, u, M, y, I, E, k, w, wu.horizontal, !1, P, c, p);
                        O && (f.horizontal[E] = O), B(), Zn(_) && d && m && (f.vertical = Su(g, e1, r, i, u, M, y, I, E, k, w, wu.vertical, !1, P, c, p));
                    }
                }
                var R = void 0, U = !1;
                if (a.icon && a.icon.name) {
                    var j = n[a.icon.name];
                    j && (R = function(t1, e1, r) {
                        var n = Bu(r), i = e1[0] - t1.displaySize[0] * n.horizontalAlign, a = e1[1] - t1.displaySize[1] * n.verticalAlign;
                        return {
                            image: t1,
                            top: a,
                            bottom: a + t1.displaySize[1],
                            left: i,
                            right: i + t1.displaySize[0]
                        };
                    }(i[a.icon.name], s.get("icon-offset").evaluate(a, {}, o), s.get("icon-anchor").evaluate(a, {}, o)), U = j.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = j.sdf : t1.sdfIcons !== j.sdf && A("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (j.pixelRatio !== t1.pixelRatio || 0 !== s.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                }
                var q = ul(f.horizontal) || f.vertical;
                t1.iconsInText = !!q && q.iconsInText, (q || R) && function(t1, e1, r, n, i, a, o, s, u, l, p) {
                    var c = a.textMaxSize.evaluate(e1, {});
                    void 0 === c && (c = o);
                    var h, f = t1.layers[0].layout, y = f.get("icon-offset").evaluate(e1, {}, p), d = ul(r.horizontal), m = o / 24, v = t1.tilePixelRatio * m, g = t1.tilePixelRatio * c / 24, x = t1.tilePixelRatio * s, b = t1.tilePixelRatio * f.get("symbol-spacing"), w = f.get("text-padding") * t1.tilePixelRatio, _ = f.get("icon-padding") * t1.tilePixelRatio, S = f.get("text-max-angle") / 180 * Math.PI, k = "map" === f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), I = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement"), z = f.get("symbol-placement"), C = b / 2, E = f.get("icon-text-fit");
                    n && "none" !== E && (t1.allowVerticalPlacement && r.vertical && (h = Vu(n, r.vertical, E, f.get("icon-text-fit-padding"), y, m)), d && (n = Vu(n, d, E, f.get("icon-text-fit-padding"), y, m)));
                    var P = function(s, c) {
                        c.x < 0 || c.x >= 8192 || c.y < 0 || c.y >= 8192 || function(t1, e1, r, n, i, a, o, s, u, l, p, c, h, f, y, d, m, v, g, x, b, w, _, S, k) {
                            var I, z, C, E, P, M = t1.addToLineVertexArray(e1, r), B = 0, T = 0, V = 0, F = 0, D = -1, L = -1, O = {}, R = ha(""), U = 0, j = 0;
                            if (void 0 === s._unevaluatedLayout.getValue("text-radial-offset") ? (U = (I = s.layout.get("text-offset").evaluate(b, {}, S).map(function(t1) {
                                return 24 * t1;
                            }))[0], j = I[1]) : (U = 24 * s.layout.get("text-radial-offset").evaluate(b, {}, S), j = il), t1.allowVerticalPlacement && n.vertical) {
                                var q = s.layout.get("text-rotate").evaluate(b, {}, S) + 90;
                                E = new Wu(u, e1, l, p, c, n.vertical, h, f, y, q), o && (P = new Wu(u, e1, l, p, c, o, m, v, y, q));
                            }
                            if (i) {
                                var N = s.layout.get("icon-rotate").evaluate(b, {}), K = "none" !== s.layout.get("icon-text-fit"), G = Xu(i, N, _, K), Z = o ? Xu(o, N, _, K) : void 0;
                                C = new Wu(u, e1, l, p, c, i, m, v, !1, N), B = 4 * G.length;
                                var X = t1.iconSizeData, J = null;
                                "source" === X.kind ? (J = [
                                    128 * s.layout.get("icon-size").evaluate(b, {})
                                ])[0] > 32640 && A(t1.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".') : "composite" === X.kind && ((J = [
                                    128 * w.compositeIconSizes[0].evaluate(b, {}, S),
                                    128 * w.compositeIconSizes[1].evaluate(b, {}, S)
                                ])[0] > 32640 || J[1] > 32640) && A(t1.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".'), t1.addSymbols(t1.icon, G, J, x, g, b, !1, e1, M.lineStartIndex, M.lineLength, -1, S), D = t1.icon.placedSymbolArray.length - 1, Z && (T = 4 * Z.length, t1.addSymbols(t1.icon, Z, J, x, g, b, wu.vertical, e1, M.lineStartIndex, M.lineLength, -1, S), L = t1.icon.placedSymbolArray.length - 1);
                            }
                            for(var H in n.horizontal){
                                var Y = n.horizontal[H];
                                if (!z) {
                                    R = ha(Y.text);
                                    var $ = s.layout.get("text-rotate").evaluate(b, {}, S);
                                    z = new Wu(u, e1, l, p, c, Y, h, f, y, $);
                                }
                                var W = 1 === Y.positionedLines.length;
                                if (V += sl(t1, e1, Y, a, s, y, b, d, M, n.vertical ? wu.horizontal : wu.horizontalOnly, W ? Object.keys(n.horizontal) : [
                                    H
                                ], O, D, w, S), W) break;
                            }
                            n.vertical && (F += sl(t1, e1, n.vertical, a, s, y, b, d, M, wu.vertical, [
                                "vertical"
                            ], O, L, w, S));
                            var Q = z ? z.boxStartIndex : t1.collisionBoxArray.length, tt = z ? z.boxEndIndex : t1.collisionBoxArray.length, et = E ? E.boxStartIndex : t1.collisionBoxArray.length, rt = E ? E.boxEndIndex : t1.collisionBoxArray.length, nt = C ? C.boxStartIndex : t1.collisionBoxArray.length, it = C ? C.boxEndIndex : t1.collisionBoxArray.length, at = P ? P.boxStartIndex : t1.collisionBoxArray.length, ot = P ? P.boxEndIndex : t1.collisionBoxArray.length, st = -1, ut = function(t1, e1) {
                                return t1 && t1.circleDiameter ? Math.max(t1.circleDiameter, e1) : e1;
                            };
                            st = ut(z, st), st = ut(E, st), st = ut(C, st);
                            var lt = (st = ut(P, st)) > -1 ? 1 : 0;
                            lt && (st *= k / 24), t1.glyphOffsetArray.length >= vl.MAX_GLYPHS && A("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey), t1.symbolInstances.emplaceBack(e1.x, e1.y, O.right >= 0 ? O.right : -1, O.center >= 0 ? O.center : -1, O.left >= 0 ? O.left : -1, O.vertical || -1, D, L, R, Q, tt, et, rt, nt, it, at, ot, l, V, F, B, T, lt, 0, h, U, j, st);
                        }(t1, c, s, r, n, i, h, t1.layers[0], t1.collisionBoxArray, e1.index, e1.sourceLayerIndex, t1.index, v, w, k, u, x, _, I, y, e1, a, l, p, o);
                    };
                    if ("line" === z) for(var M = 0, B = Zu(e1.geometry, 0, 0, 8192, 8192); M < B.length; M += 1)for(var T = B[M], V = 0, F = Gu(T, b, S, r.vertical || d, n, 24, g, t1.overscaling, 8192); V < F.length; V += 1){
                        var D = F[V];
                        d && ll(t1, d.text, C, D) || P(T, D);
                    }
                    else if ("line-center" === z) for(var L = 0, O = e1.geometry; L < O.length; L += 1){
                        var R = O[L];
                        if (R.length > 1) {
                            var U = Ku(R, S, r.vertical || d, n, 24, g);
                            U && P(R, U);
                        }
                    }
                    else if ("Polygon" === e1.type) for(var j = 0, q = ns(e1.geometry, 0); j < q.length; j += 1){
                        var N = q[j], K = el(N, 16);
                        P(N[0], new Fu(K.x, K.y, 0));
                    }
                    else if ("LineString" === e1.type) for(var G = 0, Z = e1.geometry; G < Z.length; G += 1){
                        var X = Z[G];
                        P(X, new Fu(X[0].x, X[0].y, 0));
                    }
                    else if ("Point" === e1.type) for(var J = 0, H = e1.geometry; J < H.length; J += 1)for(var Y = 0, $ = H[J]; Y < $.length; Y += 1){
                        var W = $[Y];
                        P([
                            W
                        ], new Fu(W.x, W.y, 0));
                    }
                }(t1, a, f, R, n, l, c, h, w, U, o);
            }, x = 0, b = t1.features; x < b.length; x += 1)g();
            a && t1.generateCollisionDebugBuffers();
        }, t1.perspective = function(t1, e1, r, n, i) {
            var a, o = 1 / Math.tan(e1 / 2);
            return t1[0] = o / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = o, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (a = 1 / (n - i)), t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
        }, t1.pick = function(t1, e1) {
            for(var r = {}, n = 0; n < e1.length; n++){
                var i = e1[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.plugin = oi, t1.polygonIntersectsPolygon = Na, t1.postMapLoadEvent = ot, t1.postTurnstileEvent = it, t1.potpack = vu, t1.refProperties = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.register = On, t1.registerForPluginStateChange = function(t1) {
            return t1({
                pluginStatus: Qn,
                pluginURL: ti
            }), ni.on("pluginStateChange", t1), t1;
        }, t1.renderColorRamp = wo, t1.rotate = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = Math.sin(r), u = Math.cos(r);
            return t1[0] = n * u + a * s, t1[1] = i * u + o * s, t1[2] = n * -s + a * u, t1[3] = i * -s + o * u, t1;
        }, t1.rotateX = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], u = e1[7], l = e1[8], p = e1[9], c = e1[10], h = e1[11];
            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + l * n, t1[5] = o * i + p * n, t1[6] = s * i + c * n, t1[7] = u * i + h * n, t1[8] = l * i - a * n, t1[9] = p * i - o * n, t1[10] = c * i - s * n, t1[11] = h * i - u * n, t1;
        }, t1.rotateZ = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], u = e1[3], l = e1[4], p = e1[5], c = e1[6], h = e1[7];
            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + l * n, t1[1] = o * i + p * n, t1[2] = s * i + c * n, t1[3] = u * i + h * n, t1[4] = l * i - a * n, t1[5] = p * i - o * n, t1[6] = c * i - s * n, t1[7] = h * i - u * n, t1;
        }, t1.scale = function(t1, e1, r) {
            var n = r[0], i = r[1], a = r[2];
            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }, t1.scale$1 = function(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
        }, t1.scale$2 = function(t1, e1, r) {
            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
        }, t1.setCacheLimits = function(t1, e1) {
            st = t1, ut = e1;
        }, t1.setRTLTextPlugin = function(t1, e1, r) {
            if (void 0 === r && (r = !1), "deferred" === Qn || "loading" === Qn || "loaded" === Qn) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            ti = O.resolveURL(t1), Qn = "deferred", Wn = e1, ri(), r || ai();
        }, t1.sphericalToCartesian = function(t1) {
            var e1 = t1[0], r = t1[1], n = t1[2];
            return r += 90, r *= Math.PI / 180, n *= Math.PI / 180, {
                x: e1 * Math.cos(r) * Math.sin(n),
                y: e1 * Math.sin(r) * Math.sin(n),
                z: e1 * Math.cos(n)
            };
        }, t1.sqrLen = function(t1) {
            var e1 = t1[0], r = t1[1];
            return e1 * e1 + r * r;
        }, t1.styleSpec = Et, t1.sub = function(t1, e1, r) {
            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
        }, t1.symbolSize = Ru, t1.transformMat3 = function(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2];
            return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
        }, t1.transformMat4 = po, t1.translate = function(t1, e1, r) {
            var n, i, a, o, s, u, l, p, c, h, f, y, d = r[0], m = r[1], v = r[2];
            return e1 === t1 ? (t1[12] = e1[0] * d + e1[4] * m + e1[8] * v + e1[12], t1[13] = e1[1] * d + e1[5] * m + e1[9] * v + e1[13], t1[14] = e1[2] * d + e1[6] * m + e1[10] * v + e1[14], t1[15] = e1[3] * d + e1[7] * m + e1[11] * v + e1[15]) : (i = e1[1], a = e1[2], o = e1[3], s = e1[4], u = e1[5], l = e1[6], p = e1[7], c = e1[8], h = e1[9], f = e1[10], y = e1[11], t1[0] = n = e1[0], t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = u, t1[6] = l, t1[7] = p, t1[8] = c, t1[9] = h, t1[10] = f, t1[11] = y, t1[12] = n * d + s * m + c * v + e1[12], t1[13] = i * d + u * m + h * v + e1[13], t1[14] = a * d + l * m + f * v + e1[14], t1[15] = o * d + p * m + y * v + e1[15]), t1;
        }, t1.triggerPluginCompletionEvent = ei, t1.uniqueId = y, t1.validateCustomStyleLayer = function(t1) {
            var e1 = [], r = t1.id;
            return void 0 === r && e1.push({
                message: "layers." + r + ': missing required property "id"'
            }), void 0 === t1.render && e1.push({
                message: "layers." + r + ': missing required method "render"'
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                message: "layers." + r + ': property "renderingMode" must be either "2d" or "3d"'
            }), e1;
        }, t1.validateLight = En, t1.validateStyle = Cn, t1.values = function(t1) {
            var e1 = [];
            for(var r in t1)e1.push(t1[r]);
            return e1;
        }, t1.vectorTile = bs, t1.version = "1.13.3", t1.warnOnce = A, t1.webpSupported = U, t1.window = o, t1.wrap = c;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t1(e1) {
            var r = typeof e1;
            if ("number" === r || "boolean" === r || "string" === r || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                for(var i = "[", o = 0, n = e1; o < n.length; o += 1)i += t1(n[o]) + ",";
                return i + "]";
            }
            for(var a = Object.keys(e1).sort(), s = "{", l = 0; l < a.length; l++)s += JSON.stringify(a[l]) + ":" + t1(e1[a[l]]) + ",";
            return s + "}";
        }
        function r(r) {
            for(var i = "", o = 0, n = e1.refProperties; o < n.length; o += 1)i += "/" + t1(r[n[o]]);
            return i;
        }
        var i = function(e1) {
            this.keyCache = {}, e1 && this.replace(e1);
        };
        i.prototype.replace = function(e1) {
            this._layerConfigs = {}, this._layers = {}, this.update(e1, []);
        }, i.prototype.update = function(t1, i) {
            for(var o = this, n = 0, a = t1; n < a.length; n += 1){
                var s = a[n];
                this._layerConfigs[s.id] = s;
                var l = this._layers[s.id] = e1.createStyleLayer(s);
                l._featureFilter = e1.featureFilter(l.filter), this.keyCache[s.id] && delete this.keyCache[s.id];
            }
            for(var u = 0, h = i; u < h.length; u += 1){
                var c = h[u];
                delete this.keyCache[c], delete this._layerConfigs[c], delete this._layers[c];
            }
            this.familiesBySource = {};
            for(var p = 0, f = function(e1, t1) {
                for(var i = {}, o = 0; o < e1.length; o++){
                    var n = t1 && t1[e1[o].id] || r(e1[o]);
                    t1 && (t1[e1[o].id] = n);
                    var a = i[n];
                    a || (a = i[n] = []), a.push(e1[o]);
                }
                var s = [];
                for(var l in i)s.push(i[l]);
                return s;
            }(e1.values(this._layerConfigs), this.keyCache); p < f.length; p += 1){
                var d = f[p].map(function(e1) {
                    return o._layers[e1.id];
                }), g = d[0];
                if ("none" !== g.visibility) {
                    var v = g.source || "", m = this.familiesBySource[v];
                    m || (m = this.familiesBySource[v] = {});
                    var y = g.sourceLayer || "_geojsonTileLayer", x = m[y];
                    x || (x = m[y] = []), x.push(d);
                }
            }
        };
        var o = function(t1) {
            var r = {}, i = [];
            for(var o in t1){
                var n = t1[o], a = r[o] = {};
                for(var s in n){
                    var l = n[+s];
                    if (l && 0 !== l.bitmap.width && 0 !== l.bitmap.height) {
                        var u = {
                            x: 0,
                            y: 0,
                            w: l.bitmap.width + 2,
                            h: l.bitmap.height + 2
                        };
                        i.push(u), a[s] = {
                            rect: u,
                            metrics: l.metrics
                        };
                    }
                }
            }
            var h = e1.potpack(i), c = new e1.AlphaImage({
                width: h.w || 1,
                height: h.h || 1
            });
            for(var p in t1){
                var f = t1[p];
                for(var d in f){
                    var g = f[+d];
                    if (g && 0 !== g.bitmap.width && 0 !== g.bitmap.height) {
                        var v = r[p][d].rect;
                        e1.AlphaImage.copy(g.bitmap, c, {
                            x: 0,
                            y: 0
                        }, {
                            x: v.x + 1,
                            y: v.y + 1
                        }, g.bitmap);
                    }
                }
            }
            this.image = c, this.positions = r;
        };
        e1.register("GlyphAtlas", o);
        var n = function(t1) {
            this.tileID = new e1.OverscaledTileID(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.uid = t1.uid, this.zoom = t1.zoom, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.collectResourceTiming, this.returnDependencies = !!t1.returnDependencies, this.promoteId = t1.promoteId;
        };
        function a(t1, r, i) {
            for(var o = new e1.EvaluationParameters(r), n = 0, a = t1; n < a.length; n += 1)a[n].recalculate(o, i);
        }
        function s(t1, r) {
            var i = e1.getArrayBuffer(t1.request, function(t1, i, o, n) {
                t1 ? r(t1) : i && r(null, {
                    vectorTile: new e1.vectorTile.VectorTile(new e1.pbf(i)),
                    rawData: i,
                    cacheControl: o,
                    expires: n
                });
            });
            return function() {
                i.cancel(), r();
            };
        }
        n.prototype.parse = function(t1, r, i, n, s) {
            var l = this;
            this.status = "parsing", this.data = t1, this.collisionBoxArray = new e1.CollisionBoxArray;
            var u = new e1.DictionaryCoder(Object.keys(t1.layers).sort()), h = new e1.FeatureIndex(this.tileID, this.promoteId);
            h.bucketLayerIDs = [];
            var c, p, f, d, g = {}, v = {
                featureIndex: h,
                iconDependencies: {},
                patternDependencies: {},
                glyphDependencies: {},
                availableImages: i
            }, m = r.familiesBySource[this.source];
            for(var y in m){
                var x = t1.layers[y];
                if (x) {
                    1 === x.version && e1.warnOnce('Vector tile source "' + this.source + '" layer "' + y + '" does not use vector tile spec v2 and therefore may have some rendering errors.');
                    for(var w = u.encode(y), S = [], I = 0; I < x.length; I++){
                        var M = x.feature(I), b = h.getId(M, y);
                        S.push({
                            feature: M,
                            id: b,
                            index: I,
                            sourceLayerIndex: w
                        });
                    }
                    for(var _ = 0, k = m[y]; _ < k.length; _ += 1){
                        var P = k[_], T = P[0];
                        T.minzoom && this.zoom < Math.floor(T.minzoom) || T.maxzoom && this.zoom >= T.maxzoom || "none" !== T.visibility && (a(P, this.zoom, i), (g[T.id] = T.createBucket({
                            index: h.bucketLayerIDs.length,
                            layers: P,
                            zoom: this.zoom,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: w,
                            sourceID: this.source
                        })).populate(S, v, this.tileID.canonical), h.bucketLayerIDs.push(P.map(function(e1) {
                            return e1.id;
                        })));
                    }
                }
            }
            var C = e1.mapObject(v.glyphDependencies, function(e1) {
                return Object.keys(e1).map(Number);
            });
            Object.keys(C).length ? n.send("getGlyphs", {
                uid: this.uid,
                stacks: C
            }, function(e1, t1) {
                c || (c = e1, p = t1, z.call(l));
            }) : p = {};
            var D = Object.keys(v.iconDependencies);
            D.length ? n.send("getImages", {
                icons: D,
                source: this.source,
                tileID: this.tileID,
                type: "icons"
            }, function(e1, t1) {
                c || (c = e1, f = t1, z.call(l));
            }) : f = {};
            var L = Object.keys(v.patternDependencies);
            function z() {
                if (c) return s(c);
                if (p && f && d) {
                    var t1 = new o(p), r = new e1.ImageAtlas(f, d);
                    for(var n in g){
                        var l = g[n];
                        l instanceof e1.SymbolBucket ? (a(l.layers, this.zoom, i), e1.performSymbolLayout(l, p, t1.positions, f, r.iconPositions, this.showCollisionBoxes, this.tileID.canonical)) : l.hasPattern && (l instanceof e1.LineBucket || l instanceof e1.FillBucket || l instanceof e1.FillExtrusionBucket) && (a(l.layers, this.zoom, i), l.addFeatures(v, this.tileID.canonical, r.patternPositions));
                    }
                    this.status = "done", s(null, {
                        buckets: e1.values(g).filter(function(e1) {
                            return !e1.isEmpty();
                        }),
                        featureIndex: h,
                        collisionBoxArray: this.collisionBoxArray,
                        glyphAtlasImage: t1.image,
                        imageAtlas: r,
                        glyphMap: this.returnDependencies ? p : null,
                        iconMap: this.returnDependencies ? f : null,
                        glyphPositions: this.returnDependencies ? t1.positions : null
                    });
                }
            }
            L.length ? n.send("getImages", {
                icons: L,
                source: this.source,
                tileID: this.tileID,
                type: "patterns"
            }, function(e1, t1) {
                c || (c = e1, d = t1, z.call(l));
            }) : d = {}, z.call(this);
        };
        var l = function(e1, t1, r, i) {
            this.actor = e1, this.layerIndex = t1, this.availableImages = r, this.loadVectorData = i || s, this.loading = {}, this.loaded = {};
        };
        l.prototype.loadTile = function(t1, r) {
            var i = this, o = t1.uid;
            this.loading || (this.loading = {});
            var a = !!(t1 && t1.request && t1.request.collectResourceTiming) && new e1.RequestPerformance(t1.request), s = this.loading[o] = new n(t1);
            s.abort = this.loadVectorData(t1, function(t1, n) {
                if (delete i.loading[o], t1 || !n) return s.status = "done", i.loaded[o] = s, r(t1);
                var l = n.rawData, u = {};
                n.expires && (u.expires = n.expires), n.cacheControl && (u.cacheControl = n.cacheControl);
                var h = {};
                if (a) {
                    var c = a.finish();
                    c && (h.resourceTiming = JSON.parse(JSON.stringify(c)));
                }
                s.vectorTile = n.vectorTile, s.parse(n.vectorTile, i.layerIndex, i.availableImages, i.actor, function(t1, i) {
                    if (t1 || !i) return r(t1);
                    r(null, e1.extend({
                        rawTileData: l.slice(0)
                    }, i, u, h));
                }), i.loaded = i.loaded || {}, i.loaded[o] = s;
            });
        }, l.prototype.reloadTile = function(e1, t1) {
            var r = this, i = this.loaded, o = e1.uid, n = this;
            if (i && i[o]) {
                var a = i[o];
                a.showCollisionBoxes = e1.showCollisionBoxes;
                var s = function(e1, i) {
                    var o = a.reloadCallback;
                    o && (delete a.reloadCallback, a.parse(a.vectorTile, n.layerIndex, r.availableImages, n.actor, o)), t1(e1, i);
                };
                "parsing" === a.status ? a.reloadCallback = s : "done" === a.status && (a.vectorTile ? a.parse(a.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
            }
        }, l.prototype.abortTile = function(e1, t1) {
            var r = this.loading, i = e1.uid;
            r && r[i] && r[i].abort && (r[i].abort(), delete r[i]), t1();
        }, l.prototype.removeTile = function(e1, t1) {
            var r = this.loaded, i = e1.uid;
            r && r[i] && delete r[i], t1();
        };
        var u = e1.window.ImageBitmap, h = function() {
            this.loaded = {};
        };
        function c(e1, t1) {
            if (0 !== e1.length) {
                p(e1[0], t1);
                for(var r = 1; r < e1.length; r++)p(e1[r], !t1);
            }
        }
        function p(e1, t1) {
            for(var r = 0, i = 0, o = 0, n = e1.length, a = n - 1; o < n; a = o++){
                var s = (e1[o][0] - e1[a][0]) * (e1[a][1] + e1[o][1]), l = r + s;
                i += Math.abs(r) >= Math.abs(s) ? r - l + s : s - l + r, r = l;
            }
            r + i >= 0 != !!t1 && e1.reverse();
        }
        h.prototype.loadTile = function(t1, r) {
            var i = t1.uid, o = t1.encoding, n = t1.rawImageData, a = u && n instanceof u ? this.getImageData(n) : n, s = new e1.DEMData(i, a, o);
            this.loaded = this.loaded || {}, this.loaded[i] = s, r(null, s);
        }, h.prototype.getImageData = function(t1) {
            this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(t1.width, t1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = t1.width, this.offscreenCanvas.height = t1.height, this.offscreenCanvasContext.drawImage(t1, 0, 0, t1.width, t1.height);
            var r = this.offscreenCanvasContext.getImageData(-1, -1, t1.width + 2, t1.height + 2);
            return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new e1.RGBAImage({
                width: r.width,
                height: r.height
            }, r.data);
        }, h.prototype.removeTile = function(e1) {
            var t1 = this.loaded, r = e1.uid;
            t1 && t1[r] && delete t1[r];
        };
        var f = e1.vectorTile.VectorTileFeature.prototype.toGeoJSON, d = function(t1) {
            this._feature = t1, this.extent = e1.EXTENT, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
        };
        d.prototype.loadGeometry = function() {
            if (1 === this._feature.type) {
                for(var t1 = [], r = 0, i = this._feature.geometry; r < i.length; r += 1){
                    var o = i[r];
                    t1.push([
                        new e1.Point$1(o[0], o[1])
                    ]);
                }
                return t1;
            }
            for(var n = [], a = 0, s = this._feature.geometry; a < s.length; a += 1){
                for(var l = [], u = 0, h = s[a]; u < h.length; u += 1){
                    var c = h[u];
                    l.push(new e1.Point$1(c[0], c[1]));
                }
                n.push(l);
            }
            return n;
        }, d.prototype.toGeoJSON = function(e1, t1, r) {
            return f.call(this, e1, t1, r);
        };
        var g = function(t1) {
            this.layers = {
                _geojsonTileLayer: this
            }, this.name = "_geojsonTileLayer", this.extent = e1.EXTENT, this.length = t1.length, this._features = t1;
        };
        g.prototype.feature = function(e1) {
            return new d(this._features[e1]);
        };
        var v = e1.vectorTile.VectorTileFeature, m = y;
        function y(e1, t1) {
            this.options = t1 || {}, this.features = e1, this.length = e1.length;
        }
        function x(e1, t1) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t1 || 4096;
        }
        y.prototype.feature = function(e1) {
            return new x(this.features[e1], this.options.extent);
        }, x.prototype.loadGeometry = function() {
            var t1 = this.rawGeometry;
            this.geometry = [];
            for(var r = 0; r < t1.length; r++){
                for(var i = t1[r], o = [], n = 0; n < i.length; n++)o.push(new e1.Point$1(i[n][0], i[n][1]));
                this.geometry.push(o);
            }
            return this.geometry;
        }, x.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t1 = 1 / 0, r = -1 / 0, i = 1 / 0, o = -1 / 0, n = 0; n < e1.length; n++)for(var a = e1[n], s = 0; s < a.length; s++){
                var l = a[s];
                t1 = Math.min(t1, l.x), r = Math.max(r, l.x), i = Math.min(i, l.y), o = Math.max(o, l.y);
            }
            return [
                t1,
                i,
                r,
                o
            ];
        }, x.prototype.toGeoJSON = v.prototype.toGeoJSON;
        var w = I, S = m;
        function I(t1) {
            var r = new e1.pbf;
            return function(e1, t1) {
                for(var r in e1.layers)t1.writeMessage(3, M, e1.layers[r]);
            }(t1, r), r.finish();
        }
        function M(e1, t1) {
            var r;
            t1.writeVarintField(15, e1.version || 1), t1.writeStringField(1, e1.name || ""), t1.writeVarintField(5, e1.extent || 4096);
            var i = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(r = 0; r < e1.length; r++)i.feature = e1.feature(r), t1.writeMessage(2, b, i);
            var o = i.keys;
            for(r = 0; r < o.length; r++)t1.writeStringField(3, o[r]);
            var n = i.values;
            for(r = 0; r < n.length; r++)t1.writeMessage(4, C, n[r]);
        }
        function b(e1, t1) {
            var r = e1.feature;
            void 0 !== r.id && t1.writeVarintField(1, r.id), t1.writeMessage(2, _, e1), t1.writeVarintField(3, r.type), t1.writeMessage(4, T, r);
        }
        function _(e1, t1) {
            var r = e1.feature, i = e1.keys, o = e1.values, n = e1.keycache, a = e1.valuecache;
            for(var s in r.properties){
                var l = n[s];
                void 0 === l && (i.push(s), n[s] = l = i.length - 1), t1.writeVarint(l);
                var u = r.properties[s], h = typeof u;
                "string" !== h && "boolean" !== h && "number" !== h && (u = JSON.stringify(u));
                var c = h + ":" + u, p = a[c];
                void 0 === p && (o.push(u), a[c] = p = o.length - 1), t1.writeVarint(p);
            }
        }
        function k(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function P(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function T(e1, t1) {
            for(var r = e1.loadGeometry(), i = e1.type, o = 0, n = 0, a = r.length, s = 0; s < a; s++){
                var l = r[s], u = 1;
                1 === i && (u = l.length), t1.writeVarint(k(1, u));
                for(var h = 3 === i ? l.length - 1 : l.length, c = 0; c < h; c++){
                    1 === c && 1 !== i && t1.writeVarint(k(2, h - 1));
                    var p = l[c].x - o, f = l[c].y - n;
                    t1.writeVarint(P(p)), t1.writeVarint(P(f)), o += p, n += f;
                }
                3 === i && t1.writeVarint(k(7, 1));
            }
        }
        function C(e1, t1) {
            var r = typeof e1;
            "string" === r ? t1.writeStringField(1, e1) : "boolean" === r ? t1.writeBooleanField(7, e1) : "number" === r && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        function D(e1, t1, r, i) {
            L(e1, r, i), L(t1, 2 * r, 2 * i), L(t1, 2 * r + 1, 2 * i + 1);
        }
        function L(e1, t1, r) {
            var i = e1[t1];
            e1[t1] = e1[r], e1[r] = i;
        }
        function z(e1, t1, r, i) {
            var o = e1 - r, n = t1 - i;
            return o * o + n * n;
        }
        w.fromVectorTileJs = I, w.fromGeojsonVt = function(e1, t1) {
            t1 = t1 || {};
            var r = {};
            for(var i in e1)r[i] = new m(e1[i].features, t1), r[i].name = i, r[i].version = t1.version, r[i].extent = t1.extent;
            return I({
                layers: r
            });
        }, w.GeoJSONWrapper = S;
        var O = function(e1) {
            return e1[0];
        }, E = function(e1) {
            return e1[1];
        }, F = function(e1, t1, r, i, o) {
            void 0 === t1 && (t1 = O), void 0 === r && (r = E), void 0 === i && (i = 64), void 0 === o && (o = Float64Array), this.nodeSize = i, this.points = e1;
            for(var n = e1.length < 65536 ? Uint16Array : Uint32Array, a = this.ids = new n(e1.length), s = this.coords = new o(2 * e1.length), l = 0; l < e1.length; l++)a[l] = l, s[2 * l] = t1(e1[l]), s[2 * l + 1] = r(e1[l]);
            !function e1(t1, r, i, o, n, a) {
                if (!(n - o <= i)) {
                    var s = o + n >> 1;
                    !function e1(t1, r, i, o, n, a) {
                        for(; n > o;){
                            if (n - o > 600) {
                                var s = n - o + 1, l = i - o + 1, u = Math.log(s), h = .5 * Math.exp(2 * u / 3), c = .5 * Math.sqrt(u * h * (s - h) / s) * (l - s / 2 < 0 ? -1 : 1);
                                e1(t1, r, i, Math.max(o, Math.floor(i - l * h / s + c)), Math.min(n, Math.floor(i + (s - l) * h / s + c)), a);
                            }
                            var p = r[2 * i + a], f = o, d = n;
                            for(D(t1, r, o, i), r[2 * n + a] > p && D(t1, r, o, n); f < d;){
                                for(D(t1, r, f, d), f++, d--; r[2 * f + a] < p;)f++;
                                for(; r[2 * d + a] > p;)d--;
                            }
                            r[2 * o + a] === p ? D(t1, r, o, d) : D(t1, r, ++d, n), d <= i && (o = d + 1), i <= d && (n = d - 1);
                        }
                    }(t1, r, s, o, n, a % 2), e1(t1, r, i, o, s - 1, a + 1), e1(t1, r, i, s + 1, n, a + 1);
                }
            }(a, s, i, 0, a.length - 1, 0);
        };
        F.prototype.range = function(e1, t1, r, i) {
            return function(e1, t1, r, i, o, n, a) {
                for(var s, l, u = [
                    0,
                    e1.length - 1,
                    0
                ], h = []; u.length;){
                    var c = u.pop(), p = u.pop(), f = u.pop();
                    if (p - f <= a) for(var d = f; d <= p; d++)l = t1[2 * d + 1], (s = t1[2 * d]) >= r && s <= o && l >= i && l <= n && h.push(e1[d]);
                    else {
                        var g = Math.floor((f + p) / 2);
                        l = t1[2 * g + 1], (s = t1[2 * g]) >= r && s <= o && l >= i && l <= n && h.push(e1[g]);
                        var v = (c + 1) % 2;
                        (0 === c ? r <= s : i <= l) && (u.push(f), u.push(g - 1), u.push(v)), (0 === c ? o >= s : n >= l) && (u.push(g + 1), u.push(p), u.push(v));
                    }
                }
                return h;
            }(this.ids, this.coords, e1, t1, r, i, this.nodeSize);
        }, F.prototype.within = function(e1, t1, r) {
            return function(e1, t1, r, i, o, n) {
                for(var a = [
                    0,
                    e1.length - 1,
                    0
                ], s = [], l = o * o; a.length;){
                    var u = a.pop(), h = a.pop(), c = a.pop();
                    if (h - c <= n) for(var p = c; p <= h; p++)z(t1[2 * p], t1[2 * p + 1], r, i) <= l && s.push(e1[p]);
                    else {
                        var f = Math.floor((c + h) / 2), d = t1[2 * f], g = t1[2 * f + 1];
                        z(d, g, r, i) <= l && s.push(e1[f]);
                        var v = (u + 1) % 2;
                        (0 === u ? r - o <= d : i - o <= g) && (a.push(c), a.push(f - 1), a.push(v)), (0 === u ? r + o >= d : i + o >= g) && (a.push(f + 1), a.push(h), a.push(v));
                    }
                }
                return s;
            }(this.ids, this.coords, e1, t1, r, this.nodeSize);
        };
        var N = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: function(e1) {
                return e1;
            }
        }, J = function(e1) {
            this.options = V(Object.create(N), e1), this.trees = new Array(this.options.maxZoom + 1);
        };
        function Z(e1, t1, r, i, o) {
            return {
                x: e1,
                y: t1,
                zoom: 1 / 0,
                id: r,
                parentId: -1,
                numPoints: i,
                properties: o
            };
        }
        function A(e1, t1) {
            var r = e1.geometry.coordinates, i = r[1];
            return {
                x: Y(r[0]),
                y: j(i),
                zoom: 1 / 0,
                index: t1,
                parentId: -1
            };
        }
        function B(e1) {
            var t1, r, i;
            return {
                type: "Feature",
                id: e1.id,
                properties: G(e1),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e1.x, 360 * (i - .5)),
                        (t1 = e1.y, r = (180 - 360 * t1) * Math.PI / 180, 360 * Math.atan(Math.exp(r)) / Math.PI - 90)
                    ]
                }
            };
        }
        function G(e1) {
            var t1 = e1.numPoints, r = t1 >= 1e4 ? Math.round(t1 / 1e3) + "k" : t1 >= 1e3 ? Math.round(t1 / 100) / 10 + "k" : t1;
            return V(V({}, e1.properties), {
                cluster: !0,
                cluster_id: e1.id,
                point_count: t1,
                point_count_abbreviated: r
            });
        }
        function Y(e1) {
            return e1 / 360 + .5;
        }
        function j(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function V(e1, t1) {
            for(var r in t1)e1[r] = t1[r];
            return e1;
        }
        function X(e1) {
            return e1.x;
        }
        function W(e1) {
            return e1.y;
        }
        function R(e1, t1, r, i, o, n) {
            var a = o - r, s = n - i;
            if (0 !== a || 0 !== s) {
                var l = ((e1 - r) * a + (t1 - i) * s) / (a * a + s * s);
                l > 1 ? (r = o, i = n) : l > 0 && (r += a * l, i += s * l);
            }
            return (a = e1 - r) * a + (s = t1 - i) * s;
        }
        function q(e1, t1, r, i) {
            var o = {
                id: void 0 === e1 ? null : e1,
                type: t1,
                geometry: r,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e1) {
                var t1 = e1.geometry, r = e1.type;
                if ("Point" === r || "MultiPoint" === r || "LineString" === r) U(e1, t1);
                else if ("Polygon" === r || "MultiLineString" === r) for(var i = 0; i < t1.length; i++)U(e1, t1[i]);
                else if ("MultiPolygon" === r) for(i = 0; i < t1.length; i++)for(var o = 0; o < t1[i].length; o++)U(e1, t1[i][o]);
            }(o), o;
        }
        function U(e1, t1) {
            for(var r = 0; r < t1.length; r += 3)e1.minX = Math.min(e1.minX, t1[r]), e1.minY = Math.min(e1.minY, t1[r + 1]), e1.maxX = Math.max(e1.maxX, t1[r]), e1.maxY = Math.max(e1.maxY, t1[r + 1]);
        }
        function $(e1, t1, r, i) {
            if (t1.geometry) {
                var o = t1.geometry.coordinates, n = t1.geometry.type, a = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2), s = [], l = t1.id;
                if (r.promoteId ? l = t1.properties[r.promoteId] : r.generateId && (l = i || 0), "Point" === n) H(o, s);
                else if ("MultiPoint" === n) for(var u = 0; u < o.length; u++)H(o[u], s);
                else if ("LineString" === n) K(o, s, a, !1);
                else if ("MultiLineString" === n) {
                    if (r.lineMetrics) {
                        for(u = 0; u < o.length; u++)K(o[u], s = [], a, !1), e1.push(q(l, "LineString", s, t1.properties));
                        return;
                    }
                    Q(o, s, a, !1);
                } else if ("Polygon" === n) Q(o, s, a, !0);
                else {
                    if ("MultiPolygon" !== n) {
                        if ("GeometryCollection" === n) {
                            for(u = 0; u < t1.geometry.geometries.length; u++)$(e1, {
                                id: l,
                                geometry: t1.geometry.geometries[u],
                                properties: t1.properties
                            }, r, i);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(u = 0; u < o.length; u++){
                        var h = [];
                        Q(o[u], h, a, !0), s.push(h);
                    }
                }
                e1.push(q(l, n, s, t1.properties));
            }
        }
        function H(e1, t1) {
            t1.push(ee(e1[0])), t1.push(te(e1[1])), t1.push(0);
        }
        function K(e1, t1, r, i) {
            for(var o, n, a = 0, s = 0; s < e1.length; s++){
                var l = ee(e1[s][0]), u = te(e1[s][1]);
                t1.push(l), t1.push(u), t1.push(0), s > 0 && (a += i ? (o * u - l * n) / 2 : Math.sqrt(Math.pow(l - o, 2) + Math.pow(u - n, 2))), o = l, n = u;
            }
            var h = t1.length - 3;
            t1[2] = 1, function e1(t1, r, i, o) {
                for(var n, a = o, s = i - r >> 1, l = i - r, u = t1[r], h = t1[r + 1], c = t1[i], p = t1[i + 1], f = r + 3; f < i; f += 3){
                    var d = R(t1[f], t1[f + 1], u, h, c, p);
                    if (d > a) n = f, a = d;
                    else if (d === a) {
                        var g = Math.abs(f - s);
                        g < l && (n = f, l = g);
                    }
                }
                a > o && (n - r > 3 && e1(t1, r, n, o), t1[n + 2] = a, i - n > 3 && e1(t1, n, i, o));
            }(t1, 0, h, r), t1[h + 2] = 1, t1.size = Math.abs(a), t1.start = 0, t1.end = t1.size;
        }
        function Q(e1, t1, r, i) {
            for(var o = 0; o < e1.length; o++){
                var n = [];
                K(e1[o], n, r, i), t1.push(n);
            }
        }
        function ee(e1) {
            return e1 / 360 + .5;
        }
        function te(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function re(e1, t1, r, i, o, n, a, s) {
            if (i /= t1, n >= (r /= t1) && a < i) return e1;
            if (a < r || n >= i) return null;
            for(var l = [], u = 0; u < e1.length; u++){
                var h = e1[u], c = h.geometry, p = h.type, f = 0 === o ? h.minX : h.minY, d = 0 === o ? h.maxX : h.maxY;
                if (f >= r && d < i) l.push(h);
                else if (!(d < r || f >= i)) {
                    var g = [];
                    if ("Point" === p || "MultiPoint" === p) ie(c, g, r, i, o);
                    else if ("LineString" === p) oe(c, g, r, i, o, !1, s.lineMetrics);
                    else if ("MultiLineString" === p) ae(c, g, r, i, o, !1);
                    else if ("Polygon" === p) ae(c, g, r, i, o, !0);
                    else if ("MultiPolygon" === p) for(var v = 0; v < c.length; v++){
                        var m = [];
                        ae(c[v], m, r, i, o, !0), m.length && g.push(m);
                    }
                    if (g.length) {
                        if (s.lineMetrics && "LineString" === p) {
                            for(v = 0; v < g.length; v++)l.push(q(h.id, p, g[v], h.tags));
                            continue;
                        }
                        "LineString" !== p && "MultiLineString" !== p || (1 === g.length ? (p = "LineString", g = g[0]) : p = "MultiLineString"), "Point" !== p && "MultiPoint" !== p || (p = 3 === g.length ? "Point" : "MultiPoint"), l.push(q(h.id, p, g, h.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function ie(e1, t1, r, i, o) {
            for(var n = 0; n < e1.length; n += 3){
                var a = e1[n + o];
                a >= r && a <= i && (t1.push(e1[n]), t1.push(e1[n + 1]), t1.push(e1[n + 2]));
            }
        }
        function oe(e1, t1, r, i, o, n, a) {
            for(var s, l, u = ne(e1), h = 0 === o ? le : ue, c = e1.start, p = 0; p < e1.length - 3; p += 3){
                var f = e1[p], d = e1[p + 1], g = e1[p + 2], v = e1[p + 3], m = e1[p + 4], y = 0 === o ? f : d, x = 0 === o ? v : m, w = !1;
                a && (s = Math.sqrt(Math.pow(f - v, 2) + Math.pow(d - m, 2))), y < r ? x > r && (l = h(u, f, d, v, m, r), a && (u.start = c + s * l)) : y > i ? x < i && (l = h(u, f, d, v, m, i), a && (u.start = c + s * l)) : se(u, f, d, g), x < r && y >= r && (l = h(u, f, d, v, m, r), w = !0), x > i && y <= i && (l = h(u, f, d, v, m, i), w = !0), !n && w && (a && (u.end = c + s * l), t1.push(u), u = ne(e1)), a && (c += s);
            }
            var S = e1.length - 3;
            f = e1[S], d = e1[S + 1], g = e1[S + 2], (y = 0 === o ? f : d) >= r && y <= i && se(u, f, d, g), S = u.length - 3, n && S >= 3 && (u[S] !== u[0] || u[S + 1] !== u[1]) && se(u, u[0], u[1], u[2]), u.length && t1.push(u);
        }
        function ne(e1) {
            var t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function ae(e1, t1, r, i, o, n) {
            for(var a = 0; a < e1.length; a++)oe(e1[a], t1, r, i, o, n, !1);
        }
        function se(e1, t1, r, i) {
            e1.push(t1), e1.push(r), e1.push(i);
        }
        function le(e1, t1, r, i, o, n) {
            var a = (n - t1) / (i - t1);
            return e1.push(n), e1.push(r + (o - r) * a), e1.push(1), a;
        }
        function ue(e1, t1, r, i, o, n) {
            var a = (n - r) / (o - r);
            return e1.push(t1 + (i - t1) * a), e1.push(n), e1.push(1), a;
        }
        function he(e1, t1) {
            for(var r = [], i = 0; i < e1.length; i++){
                var o, n = e1[i], a = n.type;
                if ("Point" === a || "MultiPoint" === a || "LineString" === a) o = ce(n.geometry, t1);
                else if ("MultiLineString" === a || "Polygon" === a) {
                    o = [];
                    for(var s = 0; s < n.geometry.length; s++)o.push(ce(n.geometry[s], t1));
                } else if ("MultiPolygon" === a) for(o = [], s = 0; s < n.geometry.length; s++){
                    for(var l = [], u = 0; u < n.geometry[s].length; u++)l.push(ce(n.geometry[s][u], t1));
                    o.push(l);
                }
                r.push(q(n.id, a, o, n.tags));
            }
            return r;
        }
        function ce(e1, t1) {
            var r = [];
            r.size = e1.size, void 0 !== e1.start && (r.start = e1.start, r.end = e1.end);
            for(var i = 0; i < e1.length; i += 3)r.push(e1[i] + t1, e1[i + 1], e1[i + 2]);
            return r;
        }
        function pe(e1, t1) {
            if (e1.transformed) return e1;
            var r, i, o, n = 1 << e1.z, a = e1.x, s = e1.y;
            for(r = 0; r < e1.features.length; r++){
                var l = e1.features[r], u = l.geometry, h = l.type;
                if (l.geometry = [], 1 === h) for(i = 0; i < u.length; i += 2)l.geometry.push(fe(u[i], u[i + 1], t1, n, a, s));
                else for(i = 0; i < u.length; i++){
                    var c = [];
                    for(o = 0; o < u[i].length; o += 2)c.push(fe(u[i][o], u[i][o + 1], t1, n, a, s));
                    l.geometry.push(c);
                }
            }
            return e1.transformed = !0, e1;
        }
        function fe(e1, t1, r, i, o, n) {
            return [
                Math.round(r * (e1 * i - o)),
                Math.round(r * (t1 * i - n))
            ];
        }
        function de(e1, t1, r, i, o) {
            for(var n = t1 === o.maxZoom ? 0 : o.tolerance / ((1 << t1) * o.extent), a = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: r,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, s = 0; s < e1.length; s++){
                a.numFeatures++, ge(a, e1[s], n, o);
                var l = e1[s].minX, u = e1[s].minY, h = e1[s].maxX, c = e1[s].maxY;
                l < a.minX && (a.minX = l), u < a.minY && (a.minY = u), h > a.maxX && (a.maxX = h), c > a.maxY && (a.maxY = c);
            }
            return a;
        }
        function ge(e1, t1, r, i) {
            var o = t1.geometry, n = t1.type, a = [];
            if ("Point" === n || "MultiPoint" === n) for(var s = 0; s < o.length; s += 3)a.push(o[s]), a.push(o[s + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === n) ve(a, o, e1, r, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(s = 0; s < o.length; s++)ve(a, o[s], e1, r, "Polygon" === n, 0 === s);
            else if ("MultiPolygon" === n) for(var l = 0; l < o.length; l++){
                var u = o[l];
                for(s = 0; s < u.length; s++)ve(a, u[s], e1, r, !0, 0 === s);
            }
            if (a.length) {
                var h = t1.tags || null;
                if ("LineString" === n && i.lineMetrics) {
                    for(var c in h = {}, t1.tags)h[c] = t1.tags[c];
                    h.mapbox_clip_start = o.start / o.size, h.mapbox_clip_end = o.end / o.size;
                }
                var p = {
                    geometry: a,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: h
                };
                null !== t1.id && (p.id = t1.id), e1.features.push(p);
            }
        }
        function ve(e1, t1, r, i, o, n) {
            var a = i * i;
            if (i > 0 && t1.size < (o ? a : i)) r.numPoints += t1.length / 3;
            else {
                for(var s = [], l = 0; l < t1.length; l += 3)(0 === i || t1[l + 2] > a) && (r.numSimplified++, s.push(t1[l]), s.push(t1[l + 1])), r.numPoints++;
                o && function(e1, t1) {
                    for(var r = 0, i = 0, o = e1.length, n = o - 2; i < o; n = i, i += 2)r += (e1[i] - e1[n]) * (e1[i + 1] + e1[n + 1]);
                    if (r > 0 === t1) for(i = 0, o = e1.length; i < o / 2; i += 2){
                        var a = e1[i], s = e1[i + 1];
                        e1[i] = e1[o - 2 - i], e1[i + 1] = e1[o - 1 - i], e1[o - 2 - i] = a, e1[o - 1 - i] = s;
                    }
                }(s, n), e1.push(s);
            }
        }
        function me(e1, t1) {
            var r = (t1 = this.options = function(e1, t1) {
                for(var r in t1)e1[r] = t1[r];
                return e1;
            }(Object.create(this.options), t1)).debug;
            if (r && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var i = function(e1, t1) {
                var r = [];
                if ("FeatureCollection" === e1.type) for(var i = 0; i < e1.features.length; i++)$(r, e1.features[i], t1, i);
                else $(r, "Feature" === e1.type ? e1 : {
                    geometry: e1
                }, t1);
                return r;
            }(e1, t1);
            this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (i = function(e1, t1) {
                var r = t1.buffer / t1.extent, i = e1, o = re(e1, 1, -1 - r, r, 0, -1, 2, t1), n = re(e1, 1, 1 - r, 2 + r, 0, -1, 2, t1);
                return (o || n) && (i = re(e1, 1, -r, 1 + r, 0, -1, 2, t1) || [], o && (i = he(o, 1).concat(i)), n && (i = i.concat(he(n, -1)))), i;
            }(i, t1)).length && this.splitTile(i, 0, 0, 0), r && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function ye(e1, t1, r) {
            return 32 * ((1 << e1) * r + t1) + e1;
        }
        function xe(e1, t1) {
            var r = e1.tileID.canonical;
            if (!this._geoJSONIndex) return t1(null, null);
            var i = this._geoJSONIndex.getTile(r.z, r.x, r.y);
            if (!i) return t1(null, null);
            var o = new g(i.features), n = w(o);
            0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), t1(null, {
                vectorTile: o,
                rawData: n.buffer
            });
        }
        J.prototype.load = function(e1) {
            var t1 = this.options, r = t1.log, i = t1.minZoom, o = t1.maxZoom, n = t1.nodeSize;
            r && console.time("total time");
            var a = "prepare " + e1.length + " points";
            r && console.time(a), this.points = e1;
            for(var s = [], l = 0; l < e1.length; l++)e1[l].geometry && s.push(A(e1[l], l));
            this.trees[o + 1] = new F(s, X, W, n, Float32Array), r && console.timeEnd(a);
            for(var u = o; u >= i; u--){
                var h = +Date.now();
                s = this._cluster(s, u), this.trees[u] = new F(s, X, W, n, Float32Array), r && console.log("z%d: %d clusters in %dms", u, s.length, +Date.now() - h);
            }
            return r && console.timeEnd("total time"), this;
        }, J.prototype.getClusters = function(e1, t1) {
            var r = ((e1[0] + 180) % 360 + 360) % 360 - 180, i = Math.max(-90, Math.min(90, e1[1])), o = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180, n = Math.max(-90, Math.min(90, e1[3]));
            if (e1[2] - e1[0] >= 360) r = -180, o = 180;
            else if (r > o) {
                var a = this.getClusters([
                    r,
                    i,
                    180,
                    n
                ], t1), s = this.getClusters([
                    -180,
                    i,
                    o,
                    n
                ], t1);
                return a.concat(s);
            }
            for(var l = this.trees[this._limitZoom(t1)], u = [], h = 0, c = l.range(Y(r), j(n), Y(o), j(i)); h < c.length; h += 1){
                var p = l.points[c[h]];
                u.push(p.numPoints ? B(p) : this.points[p.index]);
            }
            return u;
        }, J.prototype.getChildren = function(e1) {
            var t1 = this._getOriginId(e1), r = this._getOriginZoom(e1), i = "No cluster with the specified id.", o = this.trees[r];
            if (!o) throw new Error(i);
            var n = o.points[t1];
            if (!n) throw new Error(i);
            for(var a = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), s = [], l = 0, u = o.within(n.x, n.y, a); l < u.length; l += 1){
                var h = o.points[u[l]];
                h.parentId === e1 && s.push(h.numPoints ? B(h) : this.points[h.index]);
            }
            if (0 === s.length) throw new Error(i);
            return s;
        }, J.prototype.getLeaves = function(e1, t1, r) {
            var i = [];
            return this._appendLeaves(i, e1, t1 = t1 || 10, r = r || 0, 0), i;
        }, J.prototype.getTile = function(e1, t1, r) {
            var i = this.trees[this._limitZoom(e1)], o = Math.pow(2, e1), n = this.options, a = n.radius / n.extent, s = (r - a) / o, l = (r + 1 + a) / o, u = {
                features: []
            };
            return this._addTileFeatures(i.range((t1 - a) / o, s, (t1 + 1 + a) / o, l), i.points, t1, r, o, u), 0 === t1 && this._addTileFeatures(i.range(1 - a / o, s, 1, l), i.points, o, r, o, u), t1 === o - 1 && this._addTileFeatures(i.range(0, s, a / o, l), i.points, -1, r, o, u), u.features.length ? u : null;
        }, J.prototype.getClusterExpansionZoom = function(e1) {
            for(var t1 = this._getOriginZoom(e1) - 1; t1 <= this.options.maxZoom;){
                var r = this.getChildren(e1);
                if (t1++, 1 !== r.length) break;
                e1 = r[0].properties.cluster_id;
            }
            return t1;
        }, J.prototype._appendLeaves = function(e1, t1, r, i, o) {
            for(var n = 0, a = this.getChildren(t1); n < a.length; n += 1){
                var s = a[n], l = s.properties;
                if (l && l.cluster ? o + l.point_count <= i ? o += l.point_count : o = this._appendLeaves(e1, l.cluster_id, r, i, o) : o < i ? o++ : e1.push(s), e1.length === r) break;
            }
            return o;
        }, J.prototype._addTileFeatures = function(e1, t1, r, i, o, n) {
            for(var a = 0, s = e1; a < s.length; a += 1){
                var l = t1[s[a]], u = l.numPoints, h = {
                    type: 1,
                    geometry: [
                        [
                            Math.round(this.options.extent * (l.x * o - r)),
                            Math.round(this.options.extent * (l.y * o - i))
                        ]
                    ],
                    tags: u ? G(l) : this.points[l.index].properties
                }, c = void 0;
                u ? c = l.id : this.options.generateId ? c = l.index : this.points[l.index].id && (c = this.points[l.index].id), void 0 !== c && (h.id = c), n.features.push(h);
            }
        }, J.prototype._limitZoom = function(e1) {
            return Math.max(this.options.minZoom, Math.min(+e1, this.options.maxZoom + 1));
        }, J.prototype._cluster = function(e1, t1) {
            for(var r = [], i = this.options, o = i.reduce, n = i.minPoints, a = i.radius / (i.extent * Math.pow(2, t1)), s = 0; s < e1.length; s++){
                var l = e1[s];
                if (!(l.zoom <= t1)) {
                    l.zoom = t1;
                    for(var u = this.trees[t1 + 1], h = u.within(l.x, l.y, a), c = l.numPoints || 1, p = c, f = 0, d = h; f < d.length; f += 1){
                        var g = u.points[d[f]];
                        g.zoom > t1 && (p += g.numPoints || 1);
                    }
                    if (p >= n) {
                        for(var v = l.x * c, m = l.y * c, y = o && c > 1 ? this._map(l, !0) : null, x = (s << 5) + (t1 + 1) + this.points.length, w = 0, S = h; w < S.length; w += 1){
                            var I = u.points[S[w]];
                            if (!(I.zoom <= t1)) {
                                I.zoom = t1;
                                var M = I.numPoints || 1;
                                v += I.x * M, m += I.y * M, I.parentId = x, o && (y || (y = this._map(l, !0)), o(y, this._map(I)));
                            }
                        }
                        l.parentId = x, r.push(Z(v / p, m / p, x, p, y));
                    } else if (r.push(l), p > 1) for(var b = 0, _ = h; b < _.length; b += 1){
                        var k = u.points[_[b]];
                        k.zoom <= t1 || (k.zoom = t1, r.push(k));
                    }
                }
            }
            return r;
        }, J.prototype._getOriginId = function(e1) {
            return e1 - this.points.length >> 5;
        }, J.prototype._getOriginZoom = function(e1) {
            return (e1 - this.points.length) % 32;
        }, J.prototype._map = function(e1, t1) {
            if (e1.numPoints) return t1 ? V({}, e1.properties) : e1.properties;
            var r = this.points[e1.index].properties, i = this.options.map(r);
            return t1 && i === r ? V({}, i) : i;
        }, me.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, me.prototype.splitTile = function(e1, t1, r, i, o, n, a) {
            for(var s = [
                e1,
                t1,
                r,
                i
            ], l = this.options, u = l.debug; s.length;){
                i = s.pop(), r = s.pop(), t1 = s.pop(), e1 = s.pop();
                var h = 1 << t1, c = ye(t1, r, i), p = this.tiles[c];
                if (!p && (u > 1 && console.time("creation"), p = this.tiles[c] = de(e1, t1, r, i, l), this.tileCoords.push({
                    z: t1,
                    x: r,
                    y: i
                }), u)) {
                    u > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, r, i, p.numFeatures, p.numPoints, p.numSimplified), console.timeEnd("creation"));
                    var f = "z" + t1;
                    this.stats[f] = (this.stats[f] || 0) + 1, this.total++;
                }
                if (p.source = e1, o) {
                    if (t1 === l.maxZoom || t1 === o) continue;
                    var d = 1 << o - t1;
                    if (r !== Math.floor(n / d) || i !== Math.floor(a / d)) continue;
                } else if (t1 === l.indexMaxZoom || p.numPoints <= l.indexMaxPoints) continue;
                if (p.source = null, 0 !== e1.length) {
                    u > 1 && console.time("clipping");
                    var g, v, m, y, x, w, S = .5 * l.buffer / l.extent, I = .5 - S, M = .5 + S, b = 1 + S;
                    g = v = m = y = null, x = re(e1, h, r - S, r + M, 0, p.minX, p.maxX, l), w = re(e1, h, r + I, r + b, 0, p.minX, p.maxX, l), e1 = null, x && (g = re(x, h, i - S, i + M, 1, p.minY, p.maxY, l), v = re(x, h, i + I, i + b, 1, p.minY, p.maxY, l), x = null), w && (m = re(w, h, i - S, i + M, 1, p.minY, p.maxY, l), y = re(w, h, i + I, i + b, 1, p.minY, p.maxY, l), w = null), u > 1 && console.timeEnd("clipping"), s.push(g || [], t1 + 1, 2 * r, 2 * i), s.push(v || [], t1 + 1, 2 * r, 2 * i + 1), s.push(m || [], t1 + 1, 2 * r + 1, 2 * i), s.push(y || [], t1 + 1, 2 * r + 1, 2 * i + 1);
                }
            }
        }, me.prototype.getTile = function(e1, t1, r) {
            var i = this.options, o = i.extent, n = i.debug;
            if (e1 < 0 || e1 > 24) return null;
            var a = 1 << e1, s = ye(e1, t1 = (t1 % a + a) % a, r);
            if (this.tiles[s]) return pe(this.tiles[s], o);
            n > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, r);
            for(var l, u = e1, h = t1, c = r; !l && u > 0;)u--, h = Math.floor(h / 2), c = Math.floor(c / 2), l = this.tiles[ye(u, h, c)];
            return l && l.source ? (n > 1 && console.log("found parent tile z%d-%d-%d", u, h, c), n > 1 && console.time("drilling down"), this.splitTile(l.source, u, h, c, e1, t1, r), n > 1 && console.timeEnd("drilling down"), this.tiles[s] ? pe(this.tiles[s], o) : null) : null;
        };
        var we = function(t1) {
            function r(e1, r, i, o) {
                t1.call(this, e1, r, i, xe), o && (this.loadGeoJSON = o);
            }
            return t1 && (r.__proto__ = t1), (r.prototype = Object.create(t1 && t1.prototype)).constructor = r, r.prototype.loadData = function(e1, t1) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), this._pendingCallback = t1, this._pendingLoadDataParams = e1, this._state && "Idle" !== this._state ? this._state = "NeedsLoadData" : (this._state = "Coalescing", this._loadData());
            }, r.prototype._loadData = function() {
                var t1 = this;
                if (this._pendingCallback && this._pendingLoadDataParams) {
                    var r = this._pendingCallback, i = this._pendingLoadDataParams;
                    delete this._pendingCallback, delete this._pendingLoadDataParams;
                    var o = !!(i && i.request && i.request.collectResourceTiming) && new e1.RequestPerformance(i.request);
                    this.loadGeoJSON(i, function(n, a) {
                        if (n || !a) return r(n);
                        if ("object" != typeof a) return r(new Error("Input data given to '" + i.source + "' is not a valid GeoJSON object."));
                        !function e1(t1, r) {
                            var i, o = t1 && t1.type;
                            if ("FeatureCollection" === o) for(i = 0; i < t1.features.length; i++)e1(t1.features[i], r);
                            else if ("GeometryCollection" === o) for(i = 0; i < t1.geometries.length; i++)e1(t1.geometries[i], r);
                            else if ("Feature" === o) e1(t1.geometry, r);
                            else if ("Polygon" === o) c(t1.coordinates, r);
                            else if ("MultiPolygon" === o) for(i = 0; i < t1.coordinates.length; i++)c(t1.coordinates[i], r);
                            return t1;
                        }(a, !0);
                        try {
                            if (i.filter) {
                                var s = e1.createExpression(i.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === s.result) throw new Error(s.value.map(function(e1) {
                                    return e1.key + ": " + e1.message;
                                }).join(", "));
                                var l = a.features.filter(function(e1) {
                                    return s.value.evaluate({
                                        zoom: 0
                                    }, e1);
                                });
                                a = {
                                    type: "FeatureCollection",
                                    features: l
                                };
                            }
                            t1._geoJSONIndex = i.cluster ? new J(function(t1) {
                                var r = t1.superclusterOptions, i = t1.clusterProperties;
                                if (!i || !r) return r;
                                for(var o = {}, n = {}, a = {
                                    accumulated: null,
                                    zoom: 0
                                }, s = {
                                    properties: null
                                }, l = Object.keys(i), u = 0, h = l; u < h.length; u += 1){
                                    var c = h[u], p = i[c], f = p[0], d = e1.createExpression(p[1]), g = e1.createExpression("string" == typeof f ? [
                                        f,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            c
                                        ]
                                    ] : f);
                                    o[c] = d.value, n[c] = g.value;
                                }
                                return r.map = function(e1) {
                                    s.properties = e1;
                                    for(var t1 = {}, r = 0, i = l; r < i.length; r += 1){
                                        var n = i[r];
                                        t1[n] = o[n].evaluate(a, s);
                                    }
                                    return t1;
                                }, r.reduce = function(e1, t1) {
                                    s.properties = t1;
                                    for(var r = 0, i = l; r < i.length; r += 1){
                                        var o = i[r];
                                        a.accumulated = e1[o], e1[o] = n[o].evaluate(a, s);
                                    }
                                }, r;
                            }(i)).load(a.features) : function(e1, t1) {
                                return new me(e1, t1);
                            }(a, i.geojsonVtOptions);
                        } catch (n) {
                            return r(n);
                        }
                        t1.loaded = {};
                        var u = {};
                        if (o) {
                            var h = o.finish();
                            h && (u.resourceTiming = {}, u.resourceTiming[i.source] = JSON.parse(JSON.stringify(h)));
                        }
                        r(null, u);
                    });
                }
            }, r.prototype.coalesce = function() {
                "Coalescing" === this._state ? this._state = "Idle" : "NeedsLoadData" === this._state && (this._state = "Coalescing", this._loadData());
            }, r.prototype.reloadTile = function(e1, r) {
                var i = this.loaded;
                return i && i[e1.uid] ? t1.prototype.reloadTile.call(this, e1, r) : this.loadTile(e1, r);
            }, r.prototype.loadGeoJSON = function(t1, r) {
                if (t1.request) e1.getJSON(t1.request, r);
                else {
                    if ("string" != typeof t1.data) return r(new Error("Input data given to '" + t1.source + "' is not a valid GeoJSON object."));
                    try {
                        return r(null, JSON.parse(t1.data));
                    } catch (e1) {
                        return r(new Error("Input data given to '" + t1.source + "' is not a valid GeoJSON object."));
                    }
                }
            }, r.prototype.removeSource = function(e1, t1) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), t1();
            }, r.prototype.getClusterExpansionZoom = function(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }, r.prototype.getClusterChildren = function(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }, r.prototype.getClusterLeaves = function(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t1(e1);
                }
            }, r;
        }(l), Se = function(t1) {
            var r = this;
            this.self = t1, this.actor = new e1.Actor(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                vector: l,
                geojson: we
            }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = function(e1, t1) {
                if (r.workerSourceTypes[e1]) throw new Error('Worker source with name "' + e1 + '" already registered.');
                r.workerSourceTypes[e1] = t1;
            }, this.self.registerRTLTextPlugin = function(t1) {
                if (e1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                e1.plugin.applyArabicShaping = t1.applyArabicShaping, e1.plugin.processBidirectionalText = t1.processBidirectionalText, e1.plugin.processStyledBidirectionalText = t1.processStyledBidirectionalText;
            };
        };
        return Se.prototype.setReferrer = function(e1, t1) {
            this.referrer = t1;
        }, Se.prototype.setImages = function(e1, t1, r) {
            for(var i in this.availableImages[e1] = t1, this.workerSources[e1]){
                var o = this.workerSources[e1][i];
                for(var n in o)o[n].availableImages = t1;
            }
            r();
        }, Se.prototype.setLayers = function(e1, t1, r) {
            this.getLayerIndex(e1).replace(t1), r();
        }, Se.prototype.updateLayers = function(e1, t1, r) {
            this.getLayerIndex(e1).update(t1.layers, t1.removedIds), r();
        }, Se.prototype.loadTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).loadTile(t1, r);
        }, Se.prototype.loadDEMTile = function(e1, t1, r) {
            this.getDEMWorkerSource(e1, t1.source).loadTile(t1, r);
        }, Se.prototype.reloadTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).reloadTile(t1, r);
        }, Se.prototype.abortTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).abortTile(t1, r);
        }, Se.prototype.removeTile = function(e1, t1, r) {
            this.getWorkerSource(e1, t1.type, t1.source).removeTile(t1, r);
        }, Se.prototype.removeDEMTile = function(e1, t1) {
            this.getDEMWorkerSource(e1, t1.source).removeTile(t1);
        }, Se.prototype.removeSource = function(e1, t1, r) {
            if (this.workerSources[e1] && this.workerSources[e1][t1.type] && this.workerSources[e1][t1.type][t1.source]) {
                var i = this.workerSources[e1][t1.type][t1.source];
                delete this.workerSources[e1][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, r) : r();
            }
        }, Se.prototype.loadWorkerSource = function(e1, t1, r) {
            try {
                this.self.importScripts(t1.url), r();
            } catch (e1) {
                r(e1.toString());
            }
        }, Se.prototype.syncRTLPluginState = function(t1, r, i) {
            try {
                e1.plugin.setState(r);
                var o = e1.plugin.getPluginURL();
                if (e1.plugin.isLoaded() && !e1.plugin.isParsed() && null != o) {
                    this.self.importScripts(o);
                    var n = e1.plugin.isParsed();
                    i(n ? void 0 : new Error("RTL Text Plugin failed to import scripts from " + o), n);
                }
            } catch (e1) {
                i(e1.toString());
            }
        }, Se.prototype.getAvailableImages = function(e1) {
            var t1 = this.availableImages[e1];
            return t1 || (t1 = []), t1;
        }, Se.prototype.getLayerIndex = function(e1) {
            var t1 = this.layerIndexes[e1];
            return t1 || (t1 = this.layerIndexes[e1] = new i), t1;
        }, Se.prototype.getWorkerSource = function(e1, t1, r) {
            var i = this;
            return this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t1] || (this.workerSources[e1][t1] = {}), this.workerSources[e1][t1][r] || (this.workerSources[e1][t1][r] = new this.workerSourceTypes[t1]({
                send: function(t1, r, o) {
                    i.actor.send(t1, r, o, e1);
                }
            }, this.getLayerIndex(e1), this.getAvailableImages(e1))), this.workerSources[e1][t1][r];
        }, Se.prototype.getDEMWorkerSource = function(e1, t1) {
            return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t1] || (this.demWorkerSources[e1][t1] = new h), this.demWorkerSources[e1][t1];
        }, Se.prototype.enforceCacheSizeLimit = function(t1, r) {
            e1.enforceCacheSizeLimit(r);
        }, "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new Se(self)), Se;
    });
    define([
        "./shared"
    ], function(t1) {
        "use strict";
        var e1 = t1.createCommonjsModule(function(t1) {
            function e1(t1) {
                return !i(t1);
            }
            function i(t1) {
                var i;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var t1, e1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        e1 = new Worker(o), t1 = !0;
                    } catch (e1) {
                        t1 = !1;
                    }
                    return e1 && e1.terminate(), URL.revokeObjectURL(o), t1;
                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                    var t1 = document.createElement("canvas");
                    t1.width = t1.height = 1;
                    var e1 = t1.getContext("2d");
                    if (!e1) return !1;
                    var i = e1.getImageData(0, 0, 1, 1);
                    return i && i.width === t1.width;
                }() ? (void 0 === o[i = t1 && t1.failIfMajorPerformanceCaveat] && (o[i] = function(t1) {
                    var i = function(t1) {
                        var i = document.createElement("canvas"), o = Object.create(e1.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, i.probablySupportsContext ? i.probablySupportsContext("webgl", o) || i.probablySupportsContext("experimental-webgl", o) : i.supportsContext ? i.supportsContext("webgl", o) || i.supportsContext("experimental-webgl", o) : i.getContext("webgl", o) || i.getContext("experimental-webgl", o);
                    }(t1);
                    if (!i) return !1;
                    var o = i.createShader(i.VERTEX_SHADER);
                    return !(!o || i.isContextLost()) && (i.shaderSource(o, "void main() {}"), i.compileShader(o), !0 === i.getShaderParameter(o, i.COMPILE_STATUS));
                }(i)), o[i] ? void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }
            t1.exports ? t1.exports = e1 : window && (window.mapboxgl = window.mapboxgl || {}, window.mapboxgl.supported = e1, window.mapboxgl.notSupportedReason = i);
            var o = {};
            e1.webGLContextAttributes = {
                antialias: !1,
                alpha: !0,
                stencil: !0,
                depth: !0
            };
        }), i = {
            create: function(e1, i, o) {
                var r = t1.window.document.createElement(e1);
                return void 0 !== i && (r.className = i), o && o.appendChild(r), r;
            },
            createNS: function(e1, i) {
                return t1.window.document.createElementNS(e1, i);
            }
        }, o = t1.window.document && t1.window.document.documentElement.style;
        function r(t1) {
            if (!o) return t1[0];
            for(var e1 = 0; e1 < t1.length; e1++)if (t1[e1] in o) return t1[e1];
            return t1[0];
        }
        var a, n = r([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]);
        i.disableDrag = function() {
            o && n && (a = o[n], o[n] = "none");
        }, i.enableDrag = function() {
            o && n && (o[n] = a);
        };
        var s = r([
            "transform",
            "WebkitTransform"
        ]);
        i.setTransform = function(t1, e1) {
            t1.style[s] = e1;
        };
        var l = !1;
        try {
            var c = Object.defineProperty({}, "passive", {
                get: function() {
                    l = !0;
                }
            });
            t1.window.addEventListener("test", c, c), t1.window.removeEventListener("test", c, c);
        } catch (t1) {
            l = !1;
        }
        i.addEventListener = function(t1, e1, i, o) {
            void 0 === o && (o = {}), t1.addEventListener(e1, i, "passive" in o && l ? o : o.capture);
        }, i.removeEventListener = function(t1, e1, i, o) {
            void 0 === o && (o = {}), t1.removeEventListener(e1, i, "passive" in o && l ? o : o.capture);
        };
        var u = function(e1) {
            e1.preventDefault(), e1.stopPropagation(), t1.window.removeEventListener("click", u, !0);
        };
        function h(t1) {
            var e1 = t1.userImage;
            return !!(e1 && e1.render && e1.render()) && (t1.data.replace(new Uint8Array(e1.data.buffer)), !0);
        }
        i.suppressClick = function() {
            t1.window.addEventListener("click", u, !0), t1.window.setTimeout(function() {
                t1.window.removeEventListener("click", u, !0);
            }, 0);
        }, i.mousePos = function(e1, i) {
            var o = e1.getBoundingClientRect();
            return new t1.Point(i.clientX - o.left - e1.clientLeft, i.clientY - o.top - e1.clientTop);
        }, i.touchPos = function(e1, i) {
            for(var o = e1.getBoundingClientRect(), r = [], a = 0; a < i.length; a++)r.push(new t1.Point(i[a].clientX - o.left - e1.clientLeft, i[a].clientY - o.top - e1.clientTop));
            return r;
        }, i.mouseButton = function(e1) {
            return void 0 !== t1.window.InstallTrigger && 2 === e1.button && e1.ctrlKey && t1.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e1.button;
        }, i.remove = function(t1) {
            t1.parentNode && t1.parentNode.removeChild(t1);
        };
        var p = function(e1) {
            function i() {
                e1.call(this), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t1.RGBAImage({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.isLoaded = function() {
                return this.loaded;
            }, i.prototype.setLoaded = function(t1) {
                if (this.loaded !== t1 && (this.loaded = t1, t1)) {
                    for(var e1 = 0, i = this.requestors; e1 < i.length; e1 += 1){
                        var o = i[e1];
                        this._notify(o.ids, o.callback);
                    }
                    this.requestors = [];
                }
            }, i.prototype.getImage = function(t1) {
                return this.images[t1];
            }, i.prototype.addImage = function(t1, e1) {
                this._validate(t1, e1) && (this.images[t1] = e1);
            }, i.prototype._validate = function(e1, i) {
                var o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchX" value'))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchY" value'))), o = !1), this._validateContent(i.content, i) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "content" value'))), o = !1), o;
            }, i.prototype._validateStretch = function(t1, e1) {
                if (!t1) return !0;
                for(var i = 0, o = 0, r = t1; o < r.length; o += 1){
                    var a = r[o];
                    if (a[0] < i || a[1] < a[0] || e1 < a[1]) return !1;
                    i = a[1];
                }
                return !0;
            }, i.prototype._validateContent = function(t1, e1) {
                return !(t1 && (4 !== t1.length || t1[0] < 0 || e1.data.width < t1[0] || t1[1] < 0 || e1.data.height < t1[1] || t1[2] < 0 || e1.data.width < t1[2] || t1[3] < 0 || e1.data.height < t1[3] || t1[2] < t1[0] || t1[3] < t1[1]));
            }, i.prototype.updateImage = function(t1, e1) {
                e1.version = this.images[t1].version + 1, this.images[t1] = e1, this.updatedImages[t1] = !0;
            }, i.prototype.removeImage = function(t1) {
                var e1 = this.images[t1];
                delete this.images[t1], delete this.patterns[t1], e1.userImage && e1.userImage.onRemove && e1.userImage.onRemove();
            }, i.prototype.listImages = function() {
                return Object.keys(this.images);
            }, i.prototype.getImages = function(t1, e1) {
                var i = !0;
                if (!this.isLoaded()) for(var o = 0, r = t1; o < r.length; o += 1)this.images[r[o]] || (i = !1);
                this.isLoaded() || i ? this._notify(t1, e1) : this.requestors.push({
                    ids: t1,
                    callback: e1
                });
            }, i.prototype._notify = function(e1, i) {
                for(var o = {}, r = 0, a = e1; r < a.length; r += 1){
                    var n = a[r];
                    this.images[n] || this.fire(new t1.Event("styleimagemissing", {
                        id: n
                    }));
                    var s = this.images[n];
                    s ? o[n] = {
                        data: s.data.clone(),
                        pixelRatio: s.pixelRatio,
                        sdf: s.sdf,
                        version: s.version,
                        stretchX: s.stretchX,
                        stretchY: s.stretchY,
                        content: s.content,
                        hasRenderCallback: Boolean(s.userImage && s.userImage.render)
                    } : t1.warnOnce('Image "' + n + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
                }
                i(null, o);
            }, i.prototype.getPixelSize = function() {
                var t1 = this.atlasImage;
                return {
                    width: t1.width,
                    height: t1.height
                };
            }, i.prototype.getPattern = function(e1) {
                var i = this.patterns[e1], o = this.getImage(e1);
                if (!o) return null;
                if (i && i.position.version === o.version) return i.position;
                if (i) i.position.version = o.version;
                else {
                    var r = {
                        w: o.data.width + 2,
                        h: o.data.height + 2,
                        x: 0,
                        y: 0
                    }, a = new t1.ImagePosition(r, o);
                    this.patterns[e1] = {
                        bin: r,
                        position: a
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e1].position;
            }, i.prototype.bind = function(e1) {
                var i = e1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t1.Texture(e1, this.atlasImage, i.RGBA), this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }, i.prototype._updatePatternAtlas = function() {
                var e1 = [];
                for(var i in this.patterns)e1.push(this.patterns[i].bin);
                var o = t1.potpack(e1), r = o.w, a = o.h, n = this.atlasImage;
                for(var s in n.resize({
                    width: r || 1,
                    height: a || 1
                }), this.patterns){
                    var l = this.patterns[s].bin, c = l.x + 1, u = l.y + 1, h = this.images[s].data, p = h.width, d = h.height;
                    t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: c,
                        y: u
                    }, {
                        width: p,
                        height: d
                    }), t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: d - 1
                    }, {
                        x: c,
                        y: u - 1
                    }, {
                        width: p,
                        height: 1
                    }), t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: c,
                        y: u + d
                    }, {
                        width: p,
                        height: 1
                    }), t1.RGBAImage.copy(h, n, {
                        x: p - 1,
                        y: 0
                    }, {
                        x: c - 1,
                        y: u
                    }, {
                        width: 1,
                        height: d
                    }), t1.RGBAImage.copy(h, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: c + p,
                        y: u
                    }, {
                        width: 1,
                        height: d
                    });
                }
                this.dirty = !0;
            }, i.prototype.beginFrame = function() {
                this.callbackDispatchedThisFrame = {};
            }, i.prototype.dispatchRenderCallbacks = function(t1) {
                for(var e1 = 0, i = t1; e1 < i.length; e1 += 1){
                    var o = i[e1];
                    if (!this.callbackDispatchedThisFrame[o]) {
                        this.callbackDispatchedThisFrame[o] = !0;
                        var r = this.images[o];
                        h(r) && this.updateImage(o, r);
                    }
                }
            }, i;
        }(t1.Evented), d = m, _ = m, f = 1e20;
        function m(t1, e1, i, o, r, a) {
            this.fontSize = t1 || 24, this.buffer = void 0 === e1 ? 3 : e1, this.cutoff = o || .25, this.fontFamily = r || "sans-serif", this.fontWeight = a || "normal", this.radius = i || 8;
            var n = this.size = this.fontSize + 2 * this.buffer;
            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = n, this.ctx = this.canvas.getContext("2d"), this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.d = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Int16Array(n), this.middle = Math.round(n / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
        }
        function g(t1, e1, i, o, r, a, n) {
            for(var s = 0; s < e1; s++){
                for(var l = 0; l < i; l++)o[l] = t1[l * e1 + s];
                for(v(o, r, a, n, i), l = 0; l < i; l++)t1[l * e1 + s] = r[l];
            }
            for(l = 0; l < i; l++){
                for(s = 0; s < e1; s++)o[s] = t1[l * e1 + s];
                for(v(o, r, a, n, e1), s = 0; s < e1; s++)t1[l * e1 + s] = Math.sqrt(r[s]);
            }
        }
        function v(t1, e1, i, o, r) {
            i[0] = 0, o[0] = -f, o[1] = +f;
            for(var a = 1, n = 0; a < r; a++){
                for(var s = (t1[a] + a * a - (t1[i[n]] + i[n] * i[n])) / (2 * a - 2 * i[n]); s <= o[n];)n--, s = (t1[a] + a * a - (t1[i[n]] + i[n] * i[n])) / (2 * a - 2 * i[n]);
                i[++n] = a, o[n] = s, o[n + 1] = +f;
            }
            for(a = 0, n = 0; a < r; a++){
                for(; o[n + 1] < a;)n++;
                e1[a] = (a - i[n]) * (a - i[n]) + t1[i[n]];
            }
        }
        m.prototype.draw = function(t1) {
            this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.fillText(t1, this.buffer, this.middle);
            for(var e1 = this.ctx.getImageData(0, 0, this.size, this.size), i = new Uint8ClampedArray(this.size * this.size), o = 0; o < this.size * this.size; o++){
                var r = e1.data[4 * o + 3] / 255;
                this.gridOuter[o] = 1 === r ? 0 : 0 === r ? f : Math.pow(Math.max(0, .5 - r), 2), this.gridInner[o] = 1 === r ? f : 0 === r ? 0 : Math.pow(Math.max(0, r - .5), 2);
            }
            for(g(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z), g(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z), o = 0; o < this.size * this.size; o++)i[o] = Math.max(0, Math.min(255, Math.round(255 - 255 * ((this.gridOuter[o] - this.gridInner[o]) / this.radius + this.cutoff))));
            return i;
        }, d.default = _;
        var y = function(t1, e1) {
            this.requestManager = t1, this.localIdeographFontFamily = e1, this.entries = {};
        };
        y.prototype.setURL = function(t1) {
            this.url = t1;
        }, y.prototype.getGlyphs = function(e1, i) {
            var o = this, r = [];
            for(var a in e1)for(var n = 0, s = e1[a]; n < s.length; n += 1)r.push({
                stack: a,
                id: s[n]
            });
            t1.asyncAll(r, function(t1, e1) {
                var i = t1.stack, r = t1.id, a = o.entries[i];
                a || (a = o.entries[i] = {
                    glyphs: {},
                    requests: {},
                    ranges: {}
                });
                var n = a.glyphs[r];
                if (void 0 === n) {
                    if (n = o._tinySDF(a, i, r)) return a.glyphs[r] = n, void e1(null, {
                        stack: i,
                        id: r,
                        glyph: n
                    });
                    var s = Math.floor(r / 256);
                    if (256 * s > 65535) e1(new Error("glyphs > 65535 not supported"));
                    else if (a.ranges[s]) e1(null, {
                        stack: i,
                        id: r,
                        glyph: n
                    });
                    else {
                        var l = a.requests[s];
                        l || (l = a.requests[s] = [], y.loadGlyphRange(i, s, o.url, o.requestManager, function(t1, e1) {
                            if (e1) {
                                for(var i in e1)o._doesCharSupportLocalGlyph(+i) || (a.glyphs[+i] = e1[+i]);
                                a.ranges[s] = !0;
                            }
                            for(var r = 0, n = l; r < n.length; r += 1)(0, n[r])(t1, e1);
                            delete a.requests[s];
                        })), l.push(function(t1, o) {
                            t1 ? e1(t1) : o && e1(null, {
                                stack: i,
                                id: r,
                                glyph: o[r] || null
                            });
                        });
                    }
                } else e1(null, {
                    stack: i,
                    id: r,
                    glyph: n
                });
            }, function(t1, e1) {
                if (t1) i(t1);
                else if (e1) {
                    for(var o = {}, r = 0, a = e1; r < a.length; r += 1){
                        var n = a[r], s = n.stack, l = n.id, c = n.glyph;
                        (o[s] || (o[s] = {}))[l] = c && {
                            id: c.id,
                            bitmap: c.bitmap.clone(),
                            metrics: c.metrics
                        };
                    }
                    i(null, o);
                }
            });
        }, y.prototype._doesCharSupportLocalGlyph = function(e1) {
            return !!this.localIdeographFontFamily && (t1.isChar["CJK Unified Ideographs"](e1) || t1.isChar["Hangul Syllables"](e1) || t1.isChar.Hiragana(e1) || t1.isChar.Katakana(e1));
        }, y.prototype._tinySDF = function(e1, i, o) {
            var r = this.localIdeographFontFamily;
            if (r && this._doesCharSupportLocalGlyph(o)) {
                var a = e1.tinySDF;
                if (!a) {
                    var n = "400";
                    /bold/i.test(i) ? n = "900" : /medium/i.test(i) ? n = "500" : /light/i.test(i) && (n = "200"), a = e1.tinySDF = new y.TinySDF(24, 3, 8, .25, r, n);
                }
                return {
                    id: o,
                    bitmap: new t1.AlphaImage({
                        width: 30,
                        height: 30
                    }, a.draw(String.fromCharCode(o))),
                    metrics: {
                        width: 24,
                        height: 24,
                        left: 0,
                        top: -8,
                        advance: 24
                    }
                };
            }
        }, y.loadGlyphRange = function(e1, i, o, r, a) {
            var n = 256 * i, s = n + 255, l = r.transformRequest(r.normalizeGlyphsURL(o).replace("{fontstack}", e1).replace("{range}", n + "-" + s), t1.ResourceType.Glyphs);
            t1.getArrayBuffer(l, function(e1, i) {
                if (e1) a(e1);
                else if (i) {
                    for(var o = {}, r = 0, n = t1.parseGlyphPBF(i); r < n.length; r += 1){
                        var s = n[r];
                        o[s.id] = s;
                    }
                    a(null, o);
                }
            });
        }, y.TinySDF = d;
        var x = function() {
            this.specification = t1.styleSpec.light.position;
        };
        x.prototype.possiblyEvaluate = function(e1, i) {
            return t1.sphericalToCartesian(e1.expression.evaluate(i));
        }, x.prototype.interpolate = function(e1, i, o) {
            return {
                x: t1.number(e1.x, i.x, o),
                y: t1.number(e1.y, i.y, o),
                z: t1.number(e1.z, i.z, o)
            };
        };
        var b = new t1.Properties({
            anchor: new t1.DataConstantProperty(t1.styleSpec.light.anchor),
            position: new x,
            color: new t1.DataConstantProperty(t1.styleSpec.light.color),
            intensity: new t1.DataConstantProperty(t1.styleSpec.light.intensity)
        }), w = function(e1) {
            function i(i) {
                e1.call(this), this._transitionable = new t1.Transitionable(b), this.setLight(i), this._transitioning = this._transitionable.untransitioned();
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getLight = function() {
                return this._transitionable.serialize();
            }, i.prototype.setLight = function(e1, i) {
                if (void 0 === i && (i = {}), !this._validate(t1.validateLight, e1, i)) for(var o in e1){
                    var r = e1[o];
                    t1.endsWith(o, "-transition") ? this._transitionable.setTransition(o.slice(0, -11), r) : this._transitionable.setValue(o, r);
                }
            }, i.prototype.updateTransitions = function(t1) {
                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
            }, i.prototype.hasTransition = function() {
                return this._transitioning.hasTransition();
            }, i.prototype.recalculate = function(t1) {
                this.properties = this._transitioning.possiblyEvaluate(t1);
            }, i.prototype._validate = function(e1, i, o) {
                return (!o || !1 !== o.validate) && t1.emitValidationErrors(this, e1.call(t1.validateStyle, t1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t1.styleSpec
                })));
            }, i;
        }(t1.Evented), T = function(t1, e1) {
            this.width = t1, this.height = e1, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
        };
        T.prototype.getDash = function(t1, e1) {
            var i = t1.join(",") + String(e1);
            return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(t1, e1)), this.dashEntry[i];
        }, T.prototype.getDashRanges = function(t1, e1, i) {
            var o = [], r = t1.length % 2 == 1 ? -t1[t1.length - 1] * i : 0, a = t1[0] * i, n = !0;
            o.push({
                left: r,
                right: a,
                isDash: n,
                zeroLength: 0 === t1[0]
            });
            for(var s = t1[0], l = 1; l < t1.length; l++){
                var c = t1[l];
                o.push({
                    left: r = s * i,
                    right: a = (s += c) * i,
                    isDash: n = !n,
                    zeroLength: 0 === c
                });
            }
            return o;
        }, T.prototype.addRoundDash = function(t1, e1, i) {
            for(var o = e1 / 2, r = -i; r <= i; r++)for(var a = this.width * (this.nextRow + i + r), n = 0, s = t1[n], l = 0; l < this.width; l++){
                l / s.right > 1 && (s = t1[++n]);
                var c = Math.abs(l - s.left), u = Math.abs(l - s.right), h = Math.min(c, u), p = void 0, d = r / i * (o + 1);
                if (s.isDash) {
                    var _ = o - Math.abs(d);
                    p = Math.sqrt(h * h + _ * _);
                } else p = o - Math.sqrt(h * h + d * d);
                this.data[a + l] = Math.max(0, Math.min(255, p + 128));
            }
        }, T.prototype.addRegularDash = function(t1) {
            for(var e1 = t1.length - 1; e1 >= 0; --e1){
                var i = t1[e1], o = t1[e1 + 1];
                i.zeroLength ? t1.splice(e1, 1) : o && o.isDash === i.isDash && (o.left = i.left, t1.splice(e1, 1));
            }
            var r = t1[0], a = t1[t1.length - 1];
            r.isDash === a.isDash && (r.left = a.left - this.width, a.right = r.right + this.width);
            for(var n = this.width * this.nextRow, s = 0, l = t1[s], c = 0; c < this.width; c++){
                c / l.right > 1 && (l = t1[++s]);
                var u = Math.abs(c - l.left), h = Math.abs(c - l.right), p = Math.min(u, h);
                this.data[n + c] = Math.max(0, Math.min(255, (l.isDash ? p : -p) + 128));
            }
        }, T.prototype.addDash = function(e1, i) {
            var o = i ? 7 : 0, r = 2 * o + 1;
            if (this.nextRow + r > this.height) return t1.warnOnce("LineAtlas out of space"), null;
            for(var a = 0, n = 0; n < e1.length; n++)a += e1[n];
            if (0 !== a) {
                var s = this.width / a, l = this.getDashRanges(e1, this.width, s);
                i ? this.addRoundDash(l, s, o) : this.addRegularDash(l);
            }
            var c = {
                y: (this.nextRow + o + .5) / this.height,
                height: 2 * o / this.height,
                width: a
            };
            return this.nextRow += r, this.dirty = !0, c;
        }, T.prototype.bind = function(t1) {
            var e1 = t1.gl;
            this.texture ? (e1.bindTexture(e1.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e1.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, this.width, this.height, e1.ALPHA, e1.UNSIGNED_BYTE, this.data))) : (this.texture = e1.createTexture(), e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, e1.LINEAR), e1.texImage2D(e1.TEXTURE_2D, 0, e1.ALPHA, this.width, this.height, 0, e1.ALPHA, e1.UNSIGNED_BYTE, this.data));
        };
        var E = function e1(i, o) {
            this.workerPool = i, this.actors = [], this.currentActor = 0, this.id = t1.uniqueId();
            for(var r = this.workerPool.acquire(this.id), a = 0; a < r.length; a++){
                var n = new e1.Actor(r[a], o, this.id);
                n.name = "Worker " + a, this.actors.push(n);
            }
        };
        function I(e1, i, o) {
            var r = function(r, a) {
                if (r) return o(r);
                if (a) {
                    var n = t1.pick(t1.extend(a, e1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    a.vector_layers && (n.vectorLayers = a.vector_layers, n.vectorLayerIds = n.vectorLayers.map(function(t1) {
                        return t1.id;
                    })), n.tiles = i.canonicalizeTileset(n, e1.url), o(null, n);
                }
            };
            return e1.url ? t1.getJSON(i.transformRequest(i.normalizeSourceURL(e1.url), t1.ResourceType.Source), r) : t1.browser.frame(function() {
                return r(null, e1);
            });
        }
        E.prototype.broadcast = function(e1, i, o) {
            t1.asyncAll(this.actors, function(t1, o) {
                t1.send(e1, i, o);
            }, o = o || function() {});
        }, E.prototype.getActor = function() {
            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
        }, E.prototype.remove = function() {
            this.actors.forEach(function(t1) {
                t1.remove();
            }), this.actors = [], this.workerPool.release(this.id);
        }, E.Actor = t1.Actor;
        var P = function(e1, i, o) {
            this.bounds = t1.LngLatBounds.convert(this.validateBounds(e1)), this.minzoom = i || 0, this.maxzoom = o || 24;
        };
        P.prototype.validateBounds = function(t1) {
            return Array.isArray(t1) && 4 === t1.length ? [
                Math.max(-180, t1[0]),
                Math.max(-90, t1[1]),
                Math.min(180, t1[2]),
                Math.min(90, t1[3])
            ] : [
                -180,
                -90,
                180,
                90
            ];
        }, P.prototype.contains = function(e1) {
            var i = Math.pow(2, e1.z), o = Math.floor(t1.mercatorXfromLng(this.bounds.getWest()) * i), r = Math.floor(t1.mercatorYfromLat(this.bounds.getNorth()) * i), a = Math.ceil(t1.mercatorXfromLng(this.bounds.getEast()) * i), n = Math.ceil(t1.mercatorYfromLat(this.bounds.getSouth()) * i);
            return e1.x >= o && e1.x < a && e1.y >= r && e1.y < n;
        };
        var S = function(e1) {
            function i(i, o, r, a) {
                if (e1.call(this), this.id = i, this.dispatcher = r, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t1.extend(this, t1.pick(o, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = t1.extend({
                    type: "vector"
                }, o), this._collectResourceTiming = o.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(a);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = I(this._options, this.map._requestManager, function(i, o) {
                    e1._tileJSONRequest = null, e1._loaded = !0, i ? e1.fire(new t1.ErrorEvent(i)) : o && (t1.extend(e1, o), o.bounds && (e1.tileBounds = new P(o.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(o.tiles, e1.map._requestManager._customAccessToken), t1.postMapLoadEvent(o.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken, e1.map._requestManager._customAccessToken), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.hasTile = function(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.setSourceProperty = function(t1) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t1(), this.map.style.sourceCaches[this.id].clearTiles(), this.load();
            }, i.prototype.setTiles = function(t1) {
                var e1 = this;
                return this.setSourceProperty(function() {
                    e1._options.tiles = t1;
                }), this;
            }, i.prototype.setUrl = function(t1) {
                var e1 = this;
                return this.setSourceProperty(function() {
                    e1.url = t1, e1._options.url = t1;
                }), this;
            }, i.prototype.onRemove = function() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }, i.prototype.serialize = function() {
                return t1.extend({}, this._options);
            }, i.prototype.loadTile = function(e1, i) {
                var o = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                    request: this.map._requestManager.transformRequest(o, t1.ResourceType.Tile),
                    uid: e1.uid,
                    tileID: e1.tileID,
                    zoom: e1.tileID.overscaledZ,
                    tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    pixelRatio: t1.browser.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                function a(o, r) {
                    return delete e1.request, e1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (r && r.resourceTiming && (e1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && e1.setExpiryData(r), e1.loadVectorData(r, this.map.painter), t1.cacheEntryPossiblyAdded(this.dispatcher), i(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null)));
                }
                r.request.collectResourceTiming = this._collectResourceTiming, e1.actor && "expired" !== e1.state ? "loading" === e1.state ? e1.reloadCallback = i : e1.request = e1.actor.send("reloadTile", r, a.bind(this)) : (e1.actor = this.dispatcher.getActor(), e1.request = e1.actor.send("loadTile", r, a.bind(this)));
            }, i.prototype.abortTile = function(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.actor && t1.actor.send("abortTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }, i.prototype.unloadTile = function(t1) {
                t1.unloadVectorData(), t1.actor && t1.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), C = function(e1) {
            function i(i, o, r, a) {
                e1.call(this), this.id = i, this.dispatcher = r, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t1.extend({
                    type: "raster"
                }, o), t1.extend(this, t1.pick(o, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = I(this._options, this.map._requestManager, function(i, o) {
                    e1._tileJSONRequest = null, e1._loaded = !0, i ? e1.fire(new t1.ErrorEvent(i)) : o && (t1.extend(e1, o), o.bounds && (e1.tileBounds = new P(o.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(o.tiles), t1.postMapLoadEvent(o.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), e1.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.onRemove = function() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }, i.prototype.serialize = function() {
                return t1.extend({}, this._options);
            }, i.prototype.hasTile = function(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }, i.prototype.loadTile = function(e1, i) {
                var o = this, r = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                e1.request = t1.getImage(this.map._requestManager.transformRequest(r, t1.ResourceType.Tile), function(r, a) {
                    if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                    else if (r) e1.state = "errored", i(r);
                    else if (a) {
                        o.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                        var n = o.map.painter.context, s = n.gl;
                        e1.texture = o.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                            useMipmap: !0
                        }) : (e1.texture = new t1.Texture(n, a, s.RGBA, {
                            useMipmap: !0
                        }), e1.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_NEAREST), n.extTextureFilterAnisotropic && s.texParameterf(s.TEXTURE_2D, n.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, n.extTextureFilterAnisotropicMax)), e1.state = "loaded", t1.cacheEntryPossiblyAdded(o.dispatcher), i(null);
                    }
                });
            }, i.prototype.abortTile = function(t1, e1) {
                t1.request && (t1.request.cancel(), delete t1.request), e1();
            }, i.prototype.unloadTile = function(t1, e1) {
                t1.texture && this.map.painter.saveTileTexture(t1.texture), e1();
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), z = function(e1) {
            function i(i, o, r, a) {
                e1.call(this, i, o, r, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t1.extend({
                    type: "raster-dem"
                }, o), this.encoding = o.encoding || "mapbox";
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.serialize = function() {
                return {
                    type: "raster-dem",
                    url: this.url,
                    tileSize: this.tileSize,
                    tiles: this.tiles,
                    bounds: this.bounds,
                    encoding: this.encoding
                };
            }, i.prototype.loadTile = function(e1, i) {
                var o = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                function r(t1, o) {
                    t1 && (e1.state = "errored", i(t1)), o && (e1.dem = o, e1.needsHillshadePrepare = !0, e1.state = "loaded", i(null));
                }
                e1.request = t1.getImage(this.map._requestManager.transformRequest(o, t1.ResourceType.Tile), (function(o, a) {
                    if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                    else if (o) e1.state = "errored", i(o);
                    else if (a) {
                        this.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                        var n = t1.window.ImageBitmap && a instanceof t1.window.ImageBitmap && t1.offscreenCanvasSupported() ? a : t1.browser.getImageData(a, 1), s = {
                            uid: e1.uid,
                            coord: e1.tileID,
                            source: this.id,
                            rawImageData: n,
                            encoding: this.encoding
                        };
                        e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", s, r.bind(this)));
                    }
                }).bind(this)), e1.neighboringTiles = this._getNeighboringTiles(e1.tileID);
            }, i.prototype._getNeighboringTiles = function(e1) {
                var i = e1.canonical, o = Math.pow(2, i.z), r = (i.x - 1 + o) % o, a = 0 === i.x ? e1.wrap - 1 : e1.wrap, n = (i.x + 1 + o) % o, s = i.x + 1 === o ? e1.wrap + 1 : e1.wrap, l = {};
                return l[new t1.OverscaledTileID(e1.overscaledZ, a, i.z, r, i.y).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, i.z, n, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t1.OverscaledTileID(e1.overscaledZ, a, i.z, r, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, i.z, n, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < o && (l[new t1.OverscaledTileID(e1.overscaledZ, a, i.z, r, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, i.z, n, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }, i.prototype.unloadTile = function(t1) {
                t1.demTexture && this.map.painter.saveTileTexture(t1.demTexture), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), t1.dem && delete t1.dem, delete t1.neighboringTiles, t1.state = "unloaded", t1.actor && t1.actor.send("removeDEMTile", {
                    uid: t1.uid,
                    source: this.id
                });
            }, i;
        }(C), D = function(e1) {
            function i(i, o, r, a) {
                e1.call(this), this.id = i, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._loaded = !1, this.actor = r.getActor(), this.setEventedParent(a), this._data = o.data, this._options = t1.extend({}, o), this._collectResourceTiming = o.collectResourceTiming, this._resourceTiming = [], void 0 !== o.maxzoom && (this.maxzoom = o.maxzoom), o.type && (this.type = o.type), o.attribution && (this.attribution = o.attribution), this.promoteId = o.promoteId;
                var n = t1.EXTENT / this.tileSize;
                this.workerOptions = t1.extend({
                    source: this.id,
                    cluster: o.cluster || !1,
                    geojsonVtOptions: {
                        buffer: (void 0 !== o.buffer ? o.buffer : 128) * n,
                        tolerance: (void 0 !== o.tolerance ? o.tolerance : .375) * n,
                        extent: t1.EXTENT,
                        maxZoom: this.maxzoom,
                        lineMetrics: o.lineMetrics || !1,
                        generateId: o.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== o.clusterMaxZoom ? Math.min(o.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                        minPoints: Math.max(2, o.clusterMinPoints || 2),
                        extent: t1.EXTENT,
                        radius: (o.clusterRadius || 50) * n,
                        log: !1,
                        generateId: o.generateId || !1
                    },
                    clusterProperties: o.clusterProperties,
                    filter: o.filter
                }, o.workerOptions);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._updateWorkerData(function(i) {
                    if (i) e1.fire(new t1.ErrorEvent(i));
                    else {
                        var o = {
                            dataType: "source",
                            sourceDataType: "metadata"
                        };
                        e1._collectResourceTiming && e1._resourceTiming && e1._resourceTiming.length > 0 && (o.resourceTiming = e1._resourceTiming, e1._resourceTiming = []), e1.fire(new t1.Event("data", o));
                    }
                });
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.setData = function(e1) {
                var i = this;
                return this._data = e1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._updateWorkerData(function(e1) {
                    if (e1) i.fire(new t1.ErrorEvent(e1));
                    else {
                        var o = {
                            dataType: "source",
                            sourceDataType: "content"
                        };
                        i._collectResourceTiming && i._resourceTiming && i._resourceTiming.length > 0 && (o.resourceTiming = i._resourceTiming, i._resourceTiming = []), i.fire(new t1.Event("data", o));
                    }
                }), this;
            }, i.prototype.getClusterExpansionZoom = function(t1, e1) {
                return this.actor.send("geojson.getClusterExpansionZoom", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }, i.prototype.getClusterChildren = function(t1, e1) {
                return this.actor.send("geojson.getClusterChildren", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }, i.prototype.getClusterLeaves = function(t1, e1, i, o) {
                return this.actor.send("geojson.getClusterLeaves", {
                    source: this.id,
                    clusterId: t1,
                    limit: e1,
                    offset: i
                }, o), this;
            }, i.prototype._updateWorkerData = function(e1) {
                var i = this;
                this._loaded = !1;
                var o = t1.extend({}, this.workerOptions), r = this._data;
                "string" == typeof r ? (o.request = this.map._requestManager.transformRequest(t1.browser.resolveURL(r), t1.ResourceType.Source), o.request.collectResourceTiming = this._collectResourceTiming) : o.data = JSON.stringify(r), this.actor.send(this.type + ".loadData", o, function(t1, r) {
                    i._removed || r && r.abandoned || (i._loaded = !0, r && r.resourceTiming && r.resourceTiming[i.id] && (i._resourceTiming = r.resourceTiming[i.id].slice(0)), i.actor.send(i.type + ".coalesce", {
                        source: o.source
                    }, null), e1(t1));
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.loadTile = function(e1, i) {
                var o = this, r = e1.actor ? "reloadTile" : "loadTile";
                e1.actor = this.actor, e1.request = this.actor.send(r, {
                    type: this.type,
                    uid: e1.uid,
                    tileID: e1.tileID,
                    zoom: e1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    tileSize: this.tileSize,
                    source: this.id,
                    pixelRatio: t1.browser.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                }, function(t1, a) {
                    return delete e1.request, e1.unloadVectorData(), e1.aborted ? i(null) : t1 ? i(t1) : (e1.loadVectorData(a, o.map.painter, "reloadTile" === r), i(null));
                });
            }, i.prototype.abortTile = function(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.aborted = !0;
            }, i.prototype.unloadTile = function(t1) {
                t1.unloadVectorData(), this.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                });
            }, i.prototype.onRemove = function() {
                this._removed = !0, this.actor.send("removeSource", {
                    type: this.type,
                    source: this.id
                });
            }, i.prototype.serialize = function() {
                return t1.extend({}, this._options, {
                    type: this.type,
                    data: this._data
                });
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), A = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]), M = function(e1) {
            function i(t1, i, o, r) {
                e1.call(this), this.id = t1, this.dispatcher = o, this.coordinates = i.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(r), this.options = i;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function(e1, i) {
                var o = this;
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, t1.getImage(this.map._requestManager.transformRequest(this.url, t1.ResourceType.Image), function(r, a) {
                    o._loaded = !0, r ? o.fire(new t1.ErrorEvent(r)) : a && (o.image = a, e1 && (o.coordinates = e1), i && i(), o._finishLoading());
                });
            }, i.prototype.loaded = function() {
                return this._loaded;
            }, i.prototype.updateImage = function(t1) {
                var e1 = this;
                return this.image && t1.url ? (this.options.url = t1.url, this.load(t1.coordinates, function() {
                    e1.texture = null;
                }), this) : this;
            }, i.prototype._finishLoading = function() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load();
            }, i.prototype.setCoordinates = function(e1) {
                var i = this;
                this.coordinates = e1;
                var o = e1.map(t1.MercatorCoordinate.fromLngLat);
                this.tileID = function(e1) {
                    for(var i = 1 / 0, o = 1 / 0, r = -1 / 0, a = -1 / 0, n = 0, s = e1; n < s.length; n += 1){
                        var l = s[n];
                        i = Math.min(i, l.x), o = Math.min(o, l.y), r = Math.max(r, l.x), a = Math.max(a, l.y);
                    }
                    var c = Math.max(r - i, a - o), u = Math.max(0, Math.floor(-Math.log(c) / Math.LN2)), h = Math.pow(2, u);
                    return new t1.CanonicalTileID(u, Math.floor((i + r) / 2 * h), Math.floor((o + a) / 2 * h));
                }(o), this.minzoom = this.maxzoom = this.tileID.z;
                var r = o.map(function(t1) {
                    return i.tileID.getTilePoint(t1)._round();
                });
                return this._boundsArray = new t1.StructArrayLayout4i8, this._boundsArray.emplaceBack(r[0].x, r[0].y, 0, 0), this._boundsArray.emplaceBack(r[1].x, r[1].y, t1.EXTENT, 0), this._boundsArray.emplaceBack(r[3].x, r[3].y, 0, t1.EXTENT), this._boundsArray.emplaceBack(r[2].x, r[2].y, t1.EXTENT, t1.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }, i.prototype.prepare = function() {
                if (0 !== Object.keys(this.tiles).length && this.image) {
                    var e1 = this.map.painter.context, i = e1.gl;
                    for(var o in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, A.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new t1.Texture(e1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this.tiles){
                        var r = this.tiles[o];
                        "loaded" !== r.state && (r.state = "loaded", r.texture = this.texture);
                    }
                }
            }, i.prototype.loadTile = function(t1, e1) {
                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e1(null)) : (t1.state = "errored", e1(null));
            }, i.prototype.serialize = function() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }, i.prototype.hasTransition = function() {
                return !1;
            }, i;
        }(t1.Evented), L = function(e1) {
            function i(t1, i, o, r) {
                e1.call(this, t1, i, o, r), this.roundZoom = !0, this.type = "video", this.options = i;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                var e1 = this;
                this._loaded = !1;
                var i = this.options;
                this.urls = [];
                for(var o = 0, r = i.urls; o < r.length; o += 1)this.urls.push(this.map._requestManager.transformRequest(r[o], t1.ResourceType.Source).url);
                t1.getVideo(this.urls, function(i, o) {
                    e1._loaded = !0, i ? e1.fire(new t1.ErrorEvent(i)) : o && (e1.video = o, e1.video.loop = !0, e1.video.setAttribute("playsinline", ""), e1.video.addEventListener("playing", function() {
                        e1.map.triggerRepaint();
                    }), e1.map && e1.video.play(), e1._finishLoading());
                });
            }, i.prototype.pause = function() {
                this.video && this.video.pause();
            }, i.prototype.play = function() {
                this.video && this.video.play();
            }, i.prototype.seek = function(e1) {
                if (this.video) {
                    var i = this.video.seekable;
                    e1 < i.start(0) || e1 > i.end(0) ? this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + this.id, null, "Playback for this video can be set only between the " + i.start(0) + " and " + i.end(0) + "-second mark."))) : this.video.currentTime = e1;
                }
            }, i.prototype.getVideo = function() {
                return this.video;
            }, i.prototype.onAdd = function(t1) {
                this.map || (this.map = t1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }, i.prototype.prepare = function() {
                if (!(0 === Object.keys(this.tiles).length || this.video.readyState < 2)) {
                    var e1 = this.map.painter.context, i = e1.gl;
                    for(var o in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, A.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new t1.Texture(e1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this.tiles){
                        var r = this.tiles[o];
                        "loaded" !== r.state && (r.state = "loaded", r.texture = this.texture);
                    }
                }
            }, i.prototype.serialize = function() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }, i.prototype.hasTransition = function() {
                return this.video && !this.video.paused;
            }, i;
        }(M), R = function(e1) {
            function i(i, o, r, a) {
                e1.call(this, i, o, r, a), o.coordinates ? Array.isArray(o.coordinates) && 4 === o.coordinates.length && !o.coordinates.some(function(t1) {
                    return !Array.isArray(t1) || 2 !== t1.length || t1.some(function(t1) {
                        return "number" != typeof t1;
                    });
                }) || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, 'missing required property "coordinates"'))), o.animate && "boolean" != typeof o.animate && this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, 'optional "animate" property must be a boolean value'))), o.canvas ? "string" == typeof o.canvas || o.canvas instanceof t1.window.HTMLCanvasElement || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + i, null, 'missing required property "canvas"'))), this.options = o, this.animate = void 0 === o.animate || o.animate;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.load = function() {
                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof t1.window.HTMLCanvasElement ? this.options.canvas : t1.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                    this._playing = !0, this.map.triggerRepaint();
                }, this.pause = function() {
                    this._playing && (this.prepare(), this._playing = !1);
                }, this._finishLoading());
            }, i.prototype.getCanvas = function() {
                return this.canvas;
            }, i.prototype.onAdd = function(t1) {
                this.map = t1, this.load(), this.canvas && this.animate && this.play();
            }, i.prototype.onRemove = function() {
                this.pause();
            }, i.prototype.prepare = function() {
                var e1 = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), !this._hasInvalidDimensions() && 0 !== Object.keys(this.tiles).length) {
                    var i = this.map.painter.context, o = i.gl;
                    for(var r in this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, A.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new t1.Texture(i, this.canvas, o.RGBA, {
                        premultiply: !0
                    }), this.tiles){
                        var a = this.tiles[r];
                        "loaded" !== a.state && (a.state = "loaded", a.texture = this.texture);
                    }
                }
            }, i.prototype.serialize = function() {
                return {
                    type: "canvas",
                    coordinates: this.coordinates
                };
            }, i.prototype.hasTransition = function() {
                return this._playing;
            }, i.prototype._hasInvalidDimensions = function() {
                for(var t1 = 0, e1 = [
                    this.canvas.width,
                    this.canvas.height
                ]; t1 < e1.length; t1 += 1){
                    var i = e1[t1];
                    if (isNaN(i) || i <= 0) return !0;
                }
                return !1;
            }, i;
        }(M), k = {
            vector: S,
            raster: C,
            "raster-dem": z,
            geojson: D,
            video: L,
            image: M,
            canvas: R
        };
        function B(e1, i) {
            var o = t1.identity([]);
            return t1.translate(o, o, [
                1,
                1,
                0
            ]), t1.scale(o, o, [
                .5 * e1.width,
                .5 * e1.height,
                1
            ]), t1.multiply(o, o, e1.calculatePosMatrix(i.toUnwrapped()));
        }
        function O(t1, e1, i, o, r, a) {
            var n = function(t1, e1, i) {
                if (t1) for(var o = 0, r = t1; o < r.length; o += 1){
                    var a = e1[r[o]];
                    if (a && a.source === i && "fill-extrusion" === a.type) return !0;
                }
                else for(var n in e1){
                    var s = e1[n];
                    if (s.source === i && "fill-extrusion" === s.type) return !0;
                }
                return !1;
            }(r && r.layers, e1, t1.id), s = a.maxPitchScaleFactor(), l = t1.tilesIn(o, s, n);
            l.sort(F);
            for(var c = [], u = 0, h = l; u < h.length; u += 1){
                var p = h[u];
                c.push({
                    wrappedTileID: p.tileID.wrapped().key,
                    queryResults: p.tile.queryRenderedFeatures(e1, i, t1._state, p.queryGeometry, p.cameraQueryGeometry, p.scale, r, a, s, B(t1.transform, p.tileID))
                });
            }
            var d = function(t1) {
                for(var e1 = {}, i = {}, o = 0, r = t1; o < r.length; o += 1){
                    var a = r[o], n = a.queryResults, s = a.wrappedTileID, l = i[s] = i[s] || {};
                    for(var c in n)for(var u = n[c], h = l[c] = l[c] || {}, p = e1[c] = e1[c] || [], d = 0, _ = u; d < _.length; d += 1){
                        var f = _[d];
                        h[f.featureIndex] || (h[f.featureIndex] = !0, p.push(f));
                    }
                }
                return e1;
            }(c);
            for(var _ in d)d[_].forEach(function(e1) {
                var i = e1.feature, o = t1.getFeatureState(i.layer["source-layer"], i.id);
                i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
            });
            return d;
        }
        function F(t1, e1) {
            var i = t1.tileID, o = e1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        var U = function(t1, e1) {
            this.max = t1, this.onRemove = e1, this.reset();
        };
        U.prototype.reset = function() {
            for(var t1 in this.data)for(var e1 = 0, i = this.data[t1]; e1 < i.length; e1 += 1){
                var o = i[e1];
                o.timeout && clearTimeout(o.timeout), this.onRemove(o.value);
            }
            return this.data = {}, this.order = [], this;
        }, U.prototype.add = function(t1, e1, i) {
            var o = this, r = t1.wrapped().key;
            void 0 === this.data[r] && (this.data[r] = []);
            var a = {
                value: e1,
                timeout: void 0
            };
            if (void 0 !== i && (a.timeout = setTimeout(function() {
                o.remove(t1, a);
            }, i)), this.data[r].push(a), this.order.push(r), this.order.length > this.max) {
                var n = this._getAndRemoveByKey(this.order[0]);
                n && this.onRemove(n);
            }
            return this;
        }, U.prototype.has = function(t1) {
            return t1.wrapped().key in this.data;
        }, U.prototype.getAndRemove = function(t1) {
            return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
        }, U.prototype._getAndRemoveByKey = function(t1) {
            var e1 = this.data[t1].shift();
            return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
        }, U.prototype.getByKey = function(t1) {
            var e1 = this.data[t1];
            return e1 ? e1[0].value : null;
        }, U.prototype.get = function(t1) {
            return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
        }, U.prototype.remove = function(t1, e1) {
            if (!this.has(t1)) return this;
            var i = t1.wrapped().key, o = void 0 === e1 ? 0 : this.data[i].indexOf(e1), r = this.data[i][o];
            return this.data[i].splice(o, 1), r.timeout && clearTimeout(r.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(r.value), this.order.splice(this.order.indexOf(i), 1), this;
        }, U.prototype.setMaxSize = function(t1) {
            for(this.max = t1; this.order.length > this.max;){
                var e1 = this._getAndRemoveByKey(this.order[0]);
                e1 && this.onRemove(e1);
            }
            return this;
        }, U.prototype.filter = function(t1) {
            var e1 = [];
            for(var i in this.data)for(var o = 0, r = this.data[i]; o < r.length; o += 1){
                var a = r[o];
                t1(a.value) || e1.push(a);
            }
            for(var n = 0, s = e1; n < s.length; n += 1){
                var l = s[n];
                this.remove(l.value.tileID, l);
            }
        };
        var N = function(t1, e1, i) {
            this.context = t1;
            var o = t1.gl;
            this.buffer = o.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), t1.bindElementBuffer.set(this.buffer), o.bufferData(o.ELEMENT_ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? o.DYNAMIC_DRAW : o.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
        };
        N.prototype.bind = function() {
            this.context.bindElementBuffer.set(this.buffer);
        }, N.prototype.updateData = function(t1) {
            var e1 = this.context.gl;
            this.context.unbindVAO(), this.bind(), e1.bufferSubData(e1.ELEMENT_ARRAY_BUFFER, 0, t1.arrayBuffer);
        }, N.prototype.destroy = function() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        };
        var Z = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        }, q = function(t1, e1, i, o) {
            this.length = e1.length, this.attributes = i, this.itemSize = e1.bytesPerElement, this.dynamicDraw = o, this.context = t1;
            var r = t1.gl;
            this.buffer = r.createBuffer(), t1.bindVertexBuffer.set(this.buffer), r.bufferData(r.ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
        };
        q.prototype.bind = function() {
            this.context.bindVertexBuffer.set(this.buffer);
        }, q.prototype.updateData = function(t1) {
            var e1 = this.context.gl;
            this.bind(), e1.bufferSubData(e1.ARRAY_BUFFER, 0, t1.arrayBuffer);
        }, q.prototype.enableAttributes = function(t1, e1) {
            for(var i = 0; i < this.attributes.length; i++){
                var o = e1.attributes[this.attributes[i].name];
                void 0 !== o && t1.enableVertexAttribArray(o);
            }
        }, q.prototype.setVertexAttribPointers = function(t1, e1, i) {
            for(var o = 0; o < this.attributes.length; o++){
                var r = this.attributes[o], a = e1.attributes[r.name];
                void 0 !== a && t1.vertexAttribPointer(a, r.components, t1[Z[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0));
            }
        }, q.prototype.destroy = function() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        };
        var j = function(t1) {
            this.gl = t1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
        };
        j.prototype.get = function() {
            return this.current;
        }, j.prototype.set = function(t1) {}, j.prototype.getDefault = function() {
            return this.default;
        }, j.prototype.setDefault = function() {
            this.set(this.default);
        };
        var V = function(e1) {
            function i() {
                e1.apply(this, arguments);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getDefault = function() {
                return t1.Color.transparent;
            }, i.prototype.set = function(t1) {
                var e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.clearColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }, i;
        }(j), G = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 1;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearDepth(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), W = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 0;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearStencil(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), X = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.colorMask(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), H = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !0;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthMask(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), K = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 255;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.stencilMask(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), Y = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1.func !== e1.func || t1.ref !== e1.ref || t1.mask !== e1.mask || this.dirty) && (this.gl.stencilFunc(t1.func, t1.ref, t1.mask), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), J = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                var t1 = this.gl;
                return [
                    t1.KEEP,
                    t1.KEEP,
                    t1.KEEP
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || this.dirty) && (this.gl.stencilOp(t1[0], t1[1], t1[2]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), Q = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.STENCIL_TEST) : e1.disable(e1.STENCIL_TEST), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), $ = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return [
                    0,
                    1
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.depthRange(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), tt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.DEPTH_TEST) : e1.disable(e1.DEPTH_TEST), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), et = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.LESS;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthFunc(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), it = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.BLEND) : e1.disable(e1.BLEND), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), ot = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                var t1 = this.gl;
                return [
                    t1.ONE,
                    t1.ZERO
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.blendFunc(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), rt = function(e1) {
            function i() {
                e1.apply(this, arguments);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getDefault = function() {
                return t1.Color.transparent;
            }, i.prototype.set = function(t1) {
                var e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.blendColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }, i;
        }(j), at = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.FUNC_ADD;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.blendEquation(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), nt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    t1 ? e1.enable(e1.CULL_FACE) : e1.disable(e1.CULL_FACE), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), st = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.BACK;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.cullFace(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), lt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.CCW;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.frontFace(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), ct = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.useProgram(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), ut = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return this.gl.TEXTURE0;
            }, e1.prototype.set = function(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.activeTexture(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), ht = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                var t1 = this.gl;
                return [
                    0,
                    0,
                    t1.drawingBufferWidth,
                    t1.drawingBufferHeight
                ];
            }, e1.prototype.set = function(t1) {
                var e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.viewport(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), pt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindFramebuffer(e1.FRAMEBUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), dt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindRenderbuffer(e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), _t = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindTexture(e1.TEXTURE_2D, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), ft = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.bindBuffer(e1.ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), mt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                var e1 = this.gl;
                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
            }, e1;
        }(j), gt = function(t1) {
            function e1(e1) {
                t1.call(this, e1), this.vao = e1.extVertexArrayObject;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1.prototype.set = function(t1) {
                this.vao && (t1 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(t1), this.current = t1, this.dirty = !1);
            }, e1;
        }(j), vt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return 4;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.pixelStorei(e1.UNPACK_ALIGNMENT, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), yt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), xt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return !1;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    var e1 = this.gl;
                    e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(j), bt = function(t1) {
            function e1(e1, i) {
                t1.call(this, e1), this.context = e1, this.parent = i;
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.getDefault = function() {
                return null;
            }, e1;
        }(j), wt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.setDirty = function() {
                this.dirty = !0;
            }, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    this.context.bindFramebuffer.set(this.parent);
                    var e1 = this.gl;
                    e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t1, 0), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(bt), Tt = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.set = function(t1) {
                if (t1 !== this.current || this.dirty) {
                    this.context.bindFramebuffer.set(this.parent);
                    var e1 = this.gl;
                    e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                }
            }, e1;
        }(bt), Et = function(t1, e1, i, o) {
            this.context = t1, this.width = e1, this.height = i;
            var r = this.framebuffer = t1.gl.createFramebuffer();
            this.colorAttachment = new wt(t1, r), o && (this.depthAttachment = new Tt(t1, r));
        };
        Et.prototype.destroy = function() {
            var t1 = this.context.gl, e1 = this.colorAttachment.get();
            if (e1 && t1.deleteTexture(e1), this.depthAttachment) {
                var i = this.depthAttachment.get();
                i && t1.deleteRenderbuffer(i);
            }
            t1.deleteFramebuffer(this.framebuffer);
        };
        var It = function(t1, e1, i) {
            this.func = t1, this.mask = e1, this.range = i;
        };
        It.ReadOnly = !1, It.ReadWrite = !0, It.disabled = new It(519, It.ReadOnly, [
            0,
            1
        ]);
        var Pt = function(t1, e1, i, o, r, a) {
            this.test = t1, this.ref = e1, this.mask = i, this.fail = o, this.depthFail = r, this.pass = a;
        };
        Pt.disabled = new Pt({
            func: 519,
            mask: 0
        }, 0, 0, 7680, 7680, 7680);
        var St = function(t1, e1, i) {
            this.blendFunction = t1, this.blendColor = e1, this.mask = i;
        };
        St.disabled = new St(St.Replace = [
            1,
            0
        ], t1.Color.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), St.unblended = new St(St.Replace, t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), St.alphaBlended = new St([
            1,
            771
        ], t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        var Ct = function(t1, e1, i) {
            this.enable = t1, this.mode = e1, this.frontFace = i;
        };
        Ct.disabled = new Ct(!1, 1029, 2305), Ct.backCCW = new Ct(!0, 1029, 2305);
        var zt = function(t1) {
            this.gl = t1, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new V(this), this.clearDepth = new G(this), this.clearStencil = new W(this), this.colorMask = new X(this), this.depthMask = new H(this), this.stencilMask = new K(this), this.stencilFunc = new Y(this), this.stencilOp = new J(this), this.stencilTest = new Q(this), this.depthRange = new $(this), this.depthTest = new tt(this), this.depthFunc = new et(this), this.blend = new it(this), this.blendFunc = new ot(this), this.blendColor = new rt(this), this.blendEquation = new at(this), this.cullFace = new nt(this), this.cullFaceSide = new st(this), this.frontFace = new lt(this), this.program = new ct(this), this.activeTexture = new ut(this), this.viewport = new ht(this), this.bindFramebuffer = new pt(this), this.bindRenderbuffer = new dt(this), this.bindTexture = new _t(this), this.bindVertexBuffer = new ft(this), this.bindElementBuffer = new mt(this), this.bindVertexArrayOES = this.extVertexArrayObject && new gt(this), this.pixelStoreUnpack = new vt(this), this.pixelStoreUnpackPremultiplyAlpha = new yt(this), this.pixelStoreUnpackFlipY = new xt(this), this.extTextureFilterAnisotropic = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureHalfFloat = t1.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (t1.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = t1.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = t1.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = t1.getParameter(t1.MAX_TEXTURE_SIZE);
        };
        zt.prototype.setDefault = function() {
            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
        }, zt.prototype.setDirty = function() {
            this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
        }, zt.prototype.createIndexBuffer = function(t1, e1) {
            return new N(this, t1, e1);
        }, zt.prototype.createVertexBuffer = function(t1, e1, i) {
            return new q(this, t1, e1, i);
        }, zt.prototype.createRenderbuffer = function(t1, e1, i) {
            var o = this.gl, r = o.createRenderbuffer();
            return this.bindRenderbuffer.set(r), o.renderbufferStorage(o.RENDERBUFFER, t1, e1, i), this.bindRenderbuffer.set(null), r;
        }, zt.prototype.createFramebuffer = function(t1, e1, i) {
            return new Et(this, t1, e1, i);
        }, zt.prototype.clear = function(t1) {
            var e1 = t1.color, i = t1.depth, o = this.gl, r = 0;
            e1 && (r |= o.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                !0,
                !0,
                !0,
                !0
            ])), void 0 !== i && (r |= o.DEPTH_BUFFER_BIT, this.depthRange.set([
                0,
                1
            ]), this.clearDepth.set(i), this.depthMask.set(!0)), o.clear(r);
        }, zt.prototype.setCullFace = function(t1) {
            !1 === t1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t1.mode), this.frontFace.set(t1.frontFace));
        }, zt.prototype.setDepthMode = function(t1) {
            t1.func !== this.gl.ALWAYS || t1.mask ? (this.depthTest.set(!0), this.depthFunc.set(t1.func), this.depthMask.set(t1.mask), this.depthRange.set(t1.range)) : this.depthTest.set(!1);
        }, zt.prototype.setStencilMode = function(t1) {
            t1.test.func !== this.gl.ALWAYS || t1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t1.mask), this.stencilOp.set([
                t1.fail,
                t1.depthFail,
                t1.pass
            ]), this.stencilFunc.set({
                func: t1.test.func,
                ref: t1.ref,
                mask: t1.test.mask
            })) : this.stencilTest.set(!1);
        }, zt.prototype.setColorMode = function(e1) {
            t1.deepEqual(e1.blendFunction, St.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
        }, zt.prototype.unbindVAO = function() {
            this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
        };
        var Dt = function(e1) {
            function i(i, o, r) {
                var a = this;
                e1.call(this), this.id = i, this.dispatcher = r, this.on("data", function(t1) {
                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (a._sourceLoaded = !0), a._sourceLoaded && !a._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (a.reload(), a.transform && a.update(a.transform));
                }), this.on("error", function() {
                    a._sourceErrored = !0;
                }), this._source = function(e1, i, o, r) {
                    var a = new k[i.type](e1, i, o, r);
                    if (a.id !== e1) throw new Error("Expected Source id to be " + e1 + " instead of " + a.id);
                    return t1.bindAll([
                        "load",
                        "abort",
                        "unload",
                        "serialize",
                        "prepare"
                    ], a), a;
                }(i, o, r, this), this._tiles = {}, this._cache = new U(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new t1.SourceFeatureState;
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.onAdd = function(t1) {
                this.map = t1, this._maxTileCacheSize = t1 ? t1._maxTileCacheSize : null, this._source && this._source.onAdd && this._source.onAdd(t1);
            }, i.prototype.onRemove = function(t1) {
                this._source && this._source.onRemove && this._source.onRemove(t1);
            }, i.prototype.loaded = function() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(var t1 in this._tiles){
                    var e1 = this._tiles[t1];
                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                }
                return !0;
            }, i.prototype.getSource = function() {
                return this._source;
            }, i.prototype.pause = function() {
                this._paused = !0;
            }, i.prototype.resume = function() {
                if (this._paused) {
                    var t1 = this._shouldReloadOnResume;
                    this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform);
                }
            }, i.prototype._loadTile = function(t1, e1) {
                return this._source.loadTile(t1, e1);
            }, i.prototype._unloadTile = function(t1) {
                if (this._source.unloadTile) return this._source.unloadTile(t1, function() {});
            }, i.prototype._abortTile = function(t1) {
                if (this._source.abortTile) return this._source.abortTile(t1, function() {});
            }, i.prototype.serialize = function() {
                return this._source.serialize();
            }, i.prototype.prepare = function(t1) {
                for(var e1 in this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null), this._tiles){
                    var i = this._tiles[e1];
                    i.upload(t1), i.prepare(this.map.style.imageManager);
                }
            }, i.prototype.getIds = function() {
                return t1.values(this._tiles).map(function(t1) {
                    return t1.tileID;
                }).sort(At).map(function(t1) {
                    return t1.key;
                });
            }, i.prototype.getRenderableIds = function(e1) {
                var i = this, o = [];
                for(var r in this._tiles)this._isIdRenderable(r, e1) && o.push(this._tiles[r]);
                return e1 ? o.sort(function(e1, o) {
                    var r = e1.tileID, a = o.tileID, n = new t1.Point(r.canonical.x, r.canonical.y)._rotate(i.transform.angle), s = new t1.Point(a.canonical.x, a.canonical.y)._rotate(i.transform.angle);
                    return r.overscaledZ - a.overscaledZ || s.y - n.y || s.x - n.x;
                }).map(function(t1) {
                    return t1.tileID.key;
                }) : o.map(function(t1) {
                    return t1.tileID;
                }).sort(At).map(function(t1) {
                    return t1.key;
                });
            }, i.prototype.hasRenderableParent = function(t1) {
                var e1 = this.findLoadedParent(t1, 0);
                return !!e1 && this._isIdRenderable(e1.tileID.key);
            }, i.prototype._isIdRenderable = function(t1, e1) {
                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
            }, i.prototype.reload = function() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else for(var t1 in this._cache.reset(), this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(t1, "reloading");
            }, i.prototype._reloadTile = function(t1, e1) {
                var i = this._tiles[t1];
                i && ("loading" !== i.state && (i.state = e1), this._loadTile(i, this._tileLoaded.bind(this, i, t1, e1)));
            }, i.prototype._tileLoaded = function(e1, i, o, r) {
                if (r) return e1.state = "errored", void (404 !== r.status ? this._source.fire(new t1.ErrorEvent(r, {
                    tile: e1
                })) : this.update(this.transform));
                e1.timeAdded = t1.browser.now(), "expired" === o && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e1), "raster-dem" === this.getSource().type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._source.fire(new t1.Event("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID
                }));
            }, i.prototype._backfillDEM = function(t1) {
                for(var e1 = this.getRenderableIds(), i = 0; i < e1.length; i++){
                    var o = e1[i];
                    if (t1.neighboringTiles && t1.neighboringTiles[o]) {
                        var r = this.getTileByID(o);
                        a(t1, r), a(r, t1);
                    }
                }
                function a(t1, e1) {
                    t1.needsHillshadePrepare = !0;
                    var i = e1.tileID.canonical.x - t1.tileID.canonical.x, o = e1.tileID.canonical.y - t1.tileID.canonical.y, r = Math.pow(2, t1.tileID.canonical.z), a = e1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, i, o), t1.neighboringTiles && t1.neighboringTiles[a] && (t1.neighboringTiles[a].backfilled = !0)));
                }
            }, i.prototype.getTile = function(t1) {
                return this.getTileByID(t1.key);
            }, i.prototype.getTileByID = function(t1) {
                return this._tiles[t1];
            }, i.prototype._retainLoadedChildren = function(t1, e1, i, o) {
                for(var r in this._tiles){
                    var a = this._tiles[r];
                    if (!(o[r] || !a.hasData() || a.tileID.overscaledZ <= e1 || a.tileID.overscaledZ > i)) {
                        for(var n = a.tileID; a && a.tileID.overscaledZ > e1 + 1;){
                            var s = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                            (a = this._tiles[s.key]) && a.hasData() && (n = s);
                        }
                        for(var l = n; l.overscaledZ > e1;)if (t1[(l = l.scaledTo(l.overscaledZ - 1)).key]) {
                            o[n.key] = n;
                            break;
                        }
                    }
                }
            }, i.prototype.findLoadedParent = function(t1, e1) {
                if (t1.key in this._loadedParentTiles) {
                    var i = this._loadedParentTiles[t1.key];
                    return i && i.tileID.overscaledZ >= e1 ? i : null;
                }
                for(var o = t1.overscaledZ - 1; o >= e1; o--){
                    var r = t1.scaledTo(o), a = this._getLoadedTile(r);
                    if (a) return a;
                }
            }, i.prototype._getLoadedTile = function(t1) {
                var e1 = this._tiles[t1.key];
                return e1 && e1.hasData() ? e1 : this._cache.getByKey(t1.wrapped().key);
            }, i.prototype.updateCacheSize = function(t1) {
                var e1 = Math.ceil(t1.width / this._source.tileSize) + 1, i = Math.ceil(t1.height / this._source.tileSize) + 1, o = Math.floor(e1 * i * 5), r = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(r);
            }, i.prototype.handleWrapJump = function(t1) {
                var e1 = Math.round((t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360);
                if (this._prevLng = t1, e1) {
                    var i = {};
                    for(var o in this._tiles){
                        var r = this._tiles[o];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + e1), i[r.tileID.key] = r;
                    }
                    for(var a in this._tiles = i, this._timers)clearTimeout(this._timers[a]), delete this._timers[a];
                    for(var n in this._tiles)this._setTileReloadTimer(n, this._tiles[n]);
                }
            }, i.prototype.update = function(e1) {
                var o = this;
                if (this.transform = e1, this._sourceLoaded && !this._paused) {
                    var r;
                    this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used ? this._source.tileID ? r = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e1) {
                        return new t1.OverscaledTileID(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y);
                    }) : (r = e1.coveringTiles({
                        tileSize: this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom,
                        reparseOverscaled: this._source.reparseOverscaled
                    }), this._source.hasTile && (r = r.filter(function(t1) {
                        return o._source.hasTile(t1);
                    }))) : r = [];
                    var a = e1.coveringZoomLevel(this._source), n = Math.max(a - i.maxOverzooming, this._source.minzoom), s = Math.max(a + i.maxUnderzooming, this._source.minzoom), l = this._updateRetainedTiles(r, a);
                    if (Mt(this._source.type)) {
                        for(var c = {}, u = {}, h = 0, p = Object.keys(l); h < p.length; h += 1){
                            var d = p[h], _ = l[d], f = this._tiles[d];
                            if (f && !(f.fadeEndTime && f.fadeEndTime <= t1.browser.now())) {
                                var m = this.findLoadedParent(_, n);
                                m && (this._addTile(m.tileID), c[m.tileID.key] = m.tileID), u[d] = _;
                            }
                        }
                        for(var g in this._retainLoadedChildren(u, a, s, l), c)l[g] || (this._coveredTiles[g] = !0, l[g] = c[g]);
                    }
                    for(var v in l)this._tiles[v].clearFadeHold();
                    for(var y = 0, x = t1.keysDifference(this._tiles, l); y < x.length; y += 1){
                        var b = x[y], w = this._tiles[b];
                        w.hasSymbolBuckets && !w.holdingForFade() ? w.setHoldDuration(this.map._fadeDuration) : w.hasSymbolBuckets && !w.symbolFadeFinished() || this._removeTile(b);
                    }
                    this._updateLoadedParentTileCache();
                }
            }, i.prototype.releaseSymbolFadeTiles = function() {
                for(var t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(t1);
            }, i.prototype._updateRetainedTiles = function(t1, e1) {
                for(var o = {}, r = {}, a = Math.max(e1 - i.maxOverzooming, this._source.minzoom), n = Math.max(e1 + i.maxUnderzooming, this._source.minzoom), s = {}, l = 0, c = t1; l < c.length; l += 1){
                    var u = c[l], h = this._addTile(u);
                    o[u.key] = u, h.hasData() || e1 < this._source.maxzoom && (s[u.key] = u);
                }
                this._retainLoadedChildren(s, e1, n, o);
                for(var p = 0, d = t1; p < d.length; p += 1){
                    var _ = d[p], f = this._tiles[_.key];
                    if (!f.hasData()) {
                        if (e1 + 1 > this._source.maxzoom) {
                            var m = _.children(this._source.maxzoom)[0], g = this.getTile(m);
                            if (g && g.hasData()) {
                                o[m.key] = m;
                                continue;
                            }
                        } else {
                            var v = _.children(this._source.maxzoom);
                            if (o[v[0].key] && o[v[1].key] && o[v[2].key] && o[v[3].key]) continue;
                        }
                        for(var y = f.wasRequested(), x = _.overscaledZ - 1; x >= a; --x){
                            var b = _.scaledTo(x);
                            if (r[b.key]) break;
                            if (r[b.key] = !0, !(f = this.getTile(b)) && y && (f = this._addTile(b)), f && (o[b.key] = b, y = f.wasRequested(), f.hasData())) break;
                        }
                    }
                }
                return o;
            }, i.prototype._updateLoadedParentTileCache = function() {
                for(var t1 in this._loadedParentTiles = {}, this._tiles){
                    for(var e1 = [], i = void 0, o = this._tiles[t1].tileID; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        e1.push(o.key);
                        var r = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(r)) break;
                        o = r;
                    }
                    for(var a = 0, n = e1; a < n.length; a += 1)this._loadedParentTiles[n[a]] = i;
                }
            }, i.prototype._addTile = function(e1) {
                var i = this._tiles[e1.key];
                if (i) return i;
                (i = this._cache.getAndRemove(e1)) && (this._setTileReloadTimer(e1.key, i), i.tileID = e1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, i)));
                var o = Boolean(i);
                return o || (i = new t1.Tile(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(i, this._tileLoaded.bind(this, i, e1.key, i.state))), i ? (i.uses++, this._tiles[e1.key] = i, o || this._source.fire(new t1.Event("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i) : null;
            }, i.prototype._setTileReloadTimer = function(t1, e1) {
                var i = this;
                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                var o = e1.getExpiryTimeout();
                o && (this._timers[t1] = setTimeout(function() {
                    i._reloadTile(t1, "expired"), delete i._timers[t1];
                }, o));
            }, i.prototype._removeTile = function(t1) {
                var e1 = this._tiles[t1];
                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
            }, i.prototype.clearTiles = function() {
                for(var t1 in this._shouldReloadOnResume = !1, this._paused = !1, this._tiles)this._removeTile(t1);
                this._cache.reset();
            }, i.prototype.tilesIn = function(e1, i, o) {
                var r = this, a = [], n = this.transform;
                if (!n) return a;
                for(var s = o ? n.getCameraQueryGeometry(e1) : e1, l = e1.map(function(t1) {
                    return n.pointCoordinate(t1);
                }), c = s.map(function(t1) {
                    return n.pointCoordinate(t1);
                }), u = this.getIds(), h = 1 / 0, p = 1 / 0, d = -1 / 0, _ = -1 / 0, f = 0, m = c; f < m.length; f += 1){
                    var g = m[f];
                    h = Math.min(h, g.x), p = Math.min(p, g.y), d = Math.max(d, g.x), _ = Math.max(_, g.y);
                }
                for(var v = function(e1) {
                    var o = r._tiles[u[e1]];
                    if (!o.holdingForFade()) {
                        var s = o.tileID, f = Math.pow(2, n.zoom - o.tileID.overscaledZ), m = i * o.queryPadding * t1.EXTENT / o.tileSize / f, g = [
                            s.getTilePoint(new t1.MercatorCoordinate(h, p)),
                            s.getTilePoint(new t1.MercatorCoordinate(d, _))
                        ];
                        if (g[0].x - m < t1.EXTENT && g[0].y - m < t1.EXTENT && g[1].x + m >= 0 && g[1].y + m >= 0) {
                            var v = l.map(function(t1) {
                                return s.getTilePoint(t1);
                            }), y = c.map(function(t1) {
                                return s.getTilePoint(t1);
                            });
                            a.push({
                                tile: o,
                                tileID: s,
                                queryGeometry: v,
                                cameraQueryGeometry: y,
                                scale: f
                            });
                        }
                    }
                }, y = 0; y < u.length; y++)v(y);
                return a;
            }, i.prototype.getVisibleCoordinates = function(t1) {
                for(var e1 = this, i = this.getRenderableIds(t1).map(function(t1) {
                    return e1._tiles[t1].tileID;
                }), o = 0, r = i; o < r.length; o += 1){
                    var a = r[o];
                    a.posMatrix = this.transform.calculatePosMatrix(a.toUnwrapped());
                }
                return i;
            }, i.prototype.hasTransition = function() {
                if (this._source.hasTransition()) return !0;
                if (Mt(this._source.type)) for(var e1 in this._tiles){
                    var i = this._tiles[e1];
                    if (void 0 !== i.fadeEndTime && i.fadeEndTime >= t1.browser.now()) return !0;
                }
                return !1;
            }, i.prototype.setFeatureState = function(t1, e1, i) {
                this._state.updateState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }, i.prototype.removeFeatureState = function(t1, e1, i) {
                this._state.removeFeatureState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }, i.prototype.getFeatureState = function(t1, e1) {
                return this._state.getState(t1 = t1 || "_geojsonTileLayer", e1);
            }, i.prototype.setDependencies = function(t1, e1, i) {
                var o = this._tiles[t1];
                o && o.setDependencies(e1, i);
            }, i.prototype.reloadTilesForDependencies = function(t1, e1) {
                for(var i in this._tiles)this._tiles[i].hasDependency(t1, e1) && this._reloadTile(i, "reloading");
                this._cache.filter(function(i) {
                    return !i.hasDependency(t1, e1);
                });
            }, i;
        }(t1.Evented);
        function At(t1, e1) {
            var i = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), o = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t1.overscaledZ - e1.overscaledZ || o - i || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
        }
        function Mt(t1) {
            return "raster" === t1 || "image" === t1 || "video" === t1;
        }
        function Lt() {
            return new t1.window.Worker(Kr.workerUrl);
        }
        Dt.maxOverzooming = 10, Dt.maxUnderzooming = 3;
        var Rt = "mapboxgl_preloaded_worker_pool", kt = function() {
            this.active = {};
        };
        kt.prototype.acquire = function(t1) {
            if (!this.workers) for(this.workers = []; this.workers.length < kt.workerCount;)this.workers.push(new Lt);
            return this.active[t1] = !0, this.workers.slice();
        }, kt.prototype.release = function(t1) {
            delete this.active[t1], 0 === this.numActive() && (this.workers.forEach(function(t1) {
                t1.terminate();
            }), this.workers = null);
        }, kt.prototype.isPreloaded = function() {
            return !!this.active[Rt];
        }, kt.prototype.numActive = function() {
            return Object.keys(this.active).length;
        };
        var Bt, Ot = Math.floor(t1.browser.hardwareConcurrency / 2);
        function Ft() {
            return Bt || (Bt = new kt), Bt;
        }
        function Ut(e1, i) {
            var o = {};
            for(var r in e1)"ref" !== r && (o[r] = e1[r]);
            return t1.refProperties.forEach(function(t1) {
                t1 in i && (o[t1] = i[t1]);
            }), o;
        }
        function Nt(t1) {
            t1 = t1.slice();
            for(var e1 = Object.create(null), i = 0; i < t1.length; i++)e1[t1[i].id] = t1[i];
            for(var o = 0; o < t1.length; o++)"ref" in t1[o] && (t1[o] = Ut(t1[o], e1[t1[o].ref]));
            return t1;
        }
        kt.workerCount = Math.max(Math.min(Ot, 6), 1);
        var Zt = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight"
        };
        function qt(t1, e1, i) {
            i.push({
                command: Zt.addSource,
                args: [
                    t1,
                    e1[t1]
                ]
            });
        }
        function jt(t1, e1, i) {
            e1.push({
                command: Zt.removeSource,
                args: [
                    t1
                ]
            }), i[t1] = !0;
        }
        function Vt(t1, e1, i, o) {
            jt(t1, i, o), qt(t1, e1, i);
        }
        function Gt(e1, i, o) {
            var r;
            for(r in e1[o])if (e1[o].hasOwnProperty(r) && "data" !== r && !t1.deepEqual(e1[o][r], i[o][r])) return !1;
            for(r in i[o])if (i[o].hasOwnProperty(r) && "data" !== r && !t1.deepEqual(e1[o][r], i[o][r])) return !1;
            return !0;
        }
        function Wt(e1, i, o, r, a, n) {
            var s;
            for(s in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], i[s]) || o.push({
                command: n,
                args: [
                    r,
                    s,
                    i[s],
                    a
                ]
            }));
            for(s in i)i.hasOwnProperty(s) && !e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], i[s]) || o.push({
                command: n,
                args: [
                    r,
                    s,
                    i[s],
                    a
                ]
            }));
        }
        function Xt(t1) {
            return t1.id;
        }
        function Ht(t1, e1) {
            return t1[e1.id] = e1, t1;
        }
        var Kt = function(t1, e1) {
            this.reset(t1, e1);
        };
        Kt.prototype.reset = function(t1, e1) {
            this.points = t1 || [], this._distances = [
                0
            ];
            for(var i = 1; i < this.points.length; i++)this._distances[i] = this._distances[i - 1] + this.points[i].dist(this.points[i - 1]);
            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
        }, Kt.prototype.lerp = function(e1) {
            if (1 === this.points.length) return this.points[0];
            e1 = t1.clamp(e1, 0, 1);
            for(var i = 1, o = this._distances[i], r = e1 * this.paddedLength + this.padding; o < r && i < this._distances.length;)o = this._distances[++i];
            var a = i - 1, n = this._distances[a], s = o - n, l = s > 0 ? (r - n) / s : 0;
            return this.points[a].mult(1 - l).add(this.points[i].mult(l));
        };
        var Yt = function(t1, e1, i) {
            var o = this.boxCells = [], r = this.circleCells = [];
            this.xCellCount = Math.ceil(t1 / i), this.yCellCount = Math.ceil(e1 / i);
            for(var a = 0; a < this.xCellCount * this.yCellCount; a++)o.push([]), r.push([]);
            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t1, this.height = e1, this.xScale = this.xCellCount / t1, this.yScale = this.yCellCount / e1, this.boxUid = 0, this.circleUid = 0;
        };
        function Jt(e1, i, o, r, a) {
            var n = t1.create();
            return i ? (t1.scale(n, n, [
                1 / a,
                1 / a,
                1
            ]), o || t1.rotateZ(n, n, r.angle)) : t1.multiply(n, r.labelPlaneMatrix, e1), n;
        }
        function Qt(e1, i, o, r, a) {
            if (i) {
                var n = t1.clone(e1);
                return t1.scale(n, n, [
                    a,
                    a,
                    1
                ]), o || t1.rotateZ(n, n, -r.angle), n;
            }
            return r.glCoordMatrix;
        }
        function $t(e1, i) {
            var o = [
                e1.x,
                e1.y,
                0,
                1
            ];
            ue(o, o, i);
            var r = o[3];
            return {
                point: new t1.Point(o[0] / r, o[1] / r),
                signedDistanceFromCamera: r
            };
        }
        function te(t1, e1) {
            return .5 + t1 / e1 * .5;
        }
        function ee(t1, e1) {
            var i = t1[0] / t1[3], o = t1[1] / t1[3];
            return i >= -e1[0] && i <= e1[0] && o >= -e1[1] && o <= e1[1];
        }
        function ie(e1, i, o, r, a, n, s, l) {
            var c = r ? e1.textSizeData : e1.iconSizeData, u = t1.evaluateSizeForZoom(c, o.transform.zoom), h = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], p = r ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            p.clear();
            for(var d = e1.lineVertexArray, _ = r ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, f = o.transform.width / o.transform.height, m = !1, g = 0; g < _.length; g++){
                var v = _.get(g);
                if (v.hidden || v.writingMode === t1.WritingMode.vertical && !m) ce(v.numGlyphs, p);
                else {
                    m = !1;
                    var y = [
                        v.anchorX,
                        v.anchorY,
                        0,
                        1
                    ];
                    if (t1.transformMat4(y, y, i), ee(y, h)) {
                        var x = te(o.transform.cameraToCenterDistance, y[3]), b = t1.evaluateSizeForFeature(c, u, v), w = s ? b / x : b * x, T = new t1.Point(v.anchorX, v.anchorY), E = $t(T, a).point, I = {}, P = ae(v, w, !1, l, i, a, n, e1.glyphOffsetArray, d, p, E, T, I, f);
                        m = P.useVertical, (P.notEnoughRoom || m || P.needsFlipping && ae(v, w, !0, l, i, a, n, e1.glyphOffsetArray, d, p, E, T, I, f).notEnoughRoom) && ce(v.numGlyphs, p);
                    } else ce(v.numGlyphs, p);
                }
            }
            r ? e1.text.dynamicLayoutVertexBuffer.updateData(p) : e1.icon.dynamicLayoutVertexBuffer.updateData(p);
        }
        function oe(t1, e1, i, o, r, a, n, s, l, c, u) {
            var h = s.glyphStartIndex + s.numGlyphs, p = s.lineStartIndex, d = s.lineStartIndex + s.lineLength, _ = e1.getoffsetX(s.glyphStartIndex), f = e1.getoffsetX(h - 1), m = se(t1 * _, i, o, r, a, n, s.segment, p, d, l, c, u);
            if (!m) return null;
            var g = se(t1 * f, i, o, r, a, n, s.segment, p, d, l, c, u);
            return g ? {
                first: m,
                last: g
            } : null;
        }
        function re(e1, i, o, r) {
            return e1 === t1.WritingMode.horizontal && Math.abs(o.y - i.y) > Math.abs(o.x - i.x) * r ? {
                useVertical: !0
            } : (e1 === t1.WritingMode.vertical ? i.y < o.y : i.x > o.x) ? {
                needsFlipping: !0
            } : null;
        }
        function ae(e1, i, o, r, a, n, s, l, c, u, h, p, d, _) {
            var f, m = i / 24, g = e1.lineOffsetX * m, v = e1.lineOffsetY * m;
            if (e1.numGlyphs > 1) {
                var y = e1.glyphStartIndex + e1.numGlyphs, x = e1.lineStartIndex, b = e1.lineStartIndex + e1.lineLength, w = oe(m, l, g, v, o, h, p, e1, c, n, d);
                if (!w) return {
                    notEnoughRoom: !0
                };
                var T = $t(w.first.point, s).point, E = $t(w.last.point, s).point;
                if (r && !o) {
                    var I = re(e1.writingMode, T, E, _);
                    if (I) return I;
                }
                f = [
                    w.first
                ];
                for(var P = e1.glyphStartIndex + 1; P < y - 1; P++)f.push(se(m * l.getoffsetX(P), g, v, o, h, p, e1.segment, x, b, c, n, d));
                f.push(w.last);
            } else {
                if (r && !o) {
                    var S = $t(p, a).point, C = e1.lineStartIndex + e1.segment + 1, z = new t1.Point(c.getx(C), c.gety(C)), D = $t(z, a), A = D.signedDistanceFromCamera > 0 ? D.point : ne(p, z, S, 1, a), M = re(e1.writingMode, S, A, _);
                    if (M) return M;
                }
                var L = se(m * l.getoffsetX(e1.glyphStartIndex), g, v, o, h, p, e1.segment, e1.lineStartIndex, e1.lineStartIndex + e1.lineLength, c, n, d);
                if (!L) return {
                    notEnoughRoom: !0
                };
                f = [
                    L
                ];
            }
            for(var R = 0, k = f; R < k.length; R += 1){
                var B = k[R];
                t1.addDynamicAttributes(u, B.point, B.angle);
            }
            return {};
        }
        function ne(t1, e1, i, o, r) {
            var a = $t(t1.add(t1.sub(e1)._unit()), r).point, n = i.sub(a);
            return i.add(n._mult(o / n.mag()));
        }
        function se(e1, i, o, r, a, n, s, l, c, u, h, p) {
            var d = r ? e1 - i : e1 + i, _ = d > 0 ? 1 : -1, f = 0;
            r && (_ *= -1, f = Math.PI), _ < 0 && (f += Math.PI);
            for(var m = _ > 0 ? l + s : l + s + 1, g = a, v = a, y = 0, x = 0, b = Math.abs(d), w = []; y + x <= b;){
                if ((m += _) < l || m >= c) return null;
                if (v = g, w.push(g), void 0 === (g = p[m])) {
                    var T = new t1.Point(u.getx(m), u.gety(m)), E = $t(T, h);
                    if (E.signedDistanceFromCamera > 0) g = p[m] = E.point;
                    else {
                        var I = m - _;
                        g = ne(0 === y ? n : new t1.Point(u.getx(I), u.gety(I)), T, v, b - y + 1, h);
                    }
                }
                y += x, x = v.dist(g);
            }
            var P = (b - y) / x, S = g.sub(v), C = S.mult(P)._add(v);
            C._add(S._unit()._perp()._mult(o * _));
            var z = f + Math.atan2(g.y - v.y, g.x - v.x);
            return w.push(C), {
                point: C,
                angle: z,
                path: w
            };
        }
        Yt.prototype.keysLength = function() {
            return this.boxKeys.length + this.circleKeys.length;
        }, Yt.prototype.insert = function(t1, e1, i, o, r) {
            this._forEachCell(e1, i, o, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t1), this.bboxes.push(e1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(r);
        }, Yt.prototype.insertCircle = function(t1, e1, i, o) {
            this._forEachCell(e1 - o, i - o, e1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t1), this.circles.push(e1), this.circles.push(i), this.circles.push(o);
        }, Yt.prototype._insertBoxCell = function(t1, e1, i, o, r, a) {
            this.boxCells[r].push(a);
        }, Yt.prototype._insertCircleCell = function(t1, e1, i, o, r, a) {
            this.circleCells[r].push(a);
        }, Yt.prototype._query = function(t1, e1, i, o, r, a) {
            if (i < 0 || t1 > this.width || o < 0 || e1 > this.height) return !r && [];
            var n = [];
            if (t1 <= 0 && e1 <= 0 && this.width <= i && this.height <= o) {
                if (r) return !0;
                for(var s = 0; s < this.boxKeys.length; s++)n.push({
                    key: this.boxKeys[s],
                    x1: this.bboxes[4 * s],
                    y1: this.bboxes[4 * s + 1],
                    x2: this.bboxes[4 * s + 2],
                    y2: this.bboxes[4 * s + 3]
                });
                for(var l = 0; l < this.circleKeys.length; l++){
                    var c = this.circles[3 * l], u = this.circles[3 * l + 1], h = this.circles[3 * l + 2];
                    n.push({
                        key: this.circleKeys[l],
                        x1: c - h,
                        y1: u - h,
                        x2: c + h,
                        y2: u + h
                    });
                }
                return a ? n.filter(a) : n;
            }
            return this._forEachCell(t1, e1, i, o, this._queryCell, n, {
                hitTest: r,
                seenUids: {
                    box: {},
                    circle: {}
                }
            }, a), r ? n.length > 0 : n;
        }, Yt.prototype._queryCircle = function(t1, e1, i, o, r) {
            var a = t1 - i, n = t1 + i, s = e1 - i, l = e1 + i;
            if (n < 0 || a > this.width || l < 0 || s > this.height) return !o && [];
            var c = [];
            return this._forEachCell(a, s, n, l, this._queryCellCircle, c, {
                hitTest: o,
                circle: {
                    x: t1,
                    y: e1,
                    radius: i
                },
                seenUids: {
                    box: {},
                    circle: {}
                }
            }, r), o ? c.length > 0 : c;
        }, Yt.prototype.query = function(t1, e1, i, o, r) {
            return this._query(t1, e1, i, o, !1, r);
        }, Yt.prototype.hitTest = function(t1, e1, i, o, r) {
            return this._query(t1, e1, i, o, !0, r);
        }, Yt.prototype.hitTestCircle = function(t1, e1, i, o) {
            return this._queryCircle(t1, e1, i, !0, o);
        }, Yt.prototype._queryCell = function(t1, e1, i, o, r, a, n, s) {
            var l = n.seenUids, c = this.boxCells[r];
            if (null !== c) for(var u = this.bboxes, h = 0, p = c; h < p.length; h += 1){
                var d = p[h];
                if (!l.box[d]) {
                    l.box[d] = !0;
                    var _ = 4 * d;
                    if (t1 <= u[_ + 2] && e1 <= u[_ + 3] && i >= u[_ + 0] && o >= u[_ + 1] && (!s || s(this.boxKeys[d]))) {
                        if (n.hitTest) return a.push(!0), !0;
                        a.push({
                            key: this.boxKeys[d],
                            x1: u[_],
                            y1: u[_ + 1],
                            x2: u[_ + 2],
                            y2: u[_ + 3]
                        });
                    }
                }
            }
            var f = this.circleCells[r];
            if (null !== f) for(var m = this.circles, g = 0, v = f; g < v.length; g += 1){
                var y = v[g];
                if (!l.circle[y]) {
                    l.circle[y] = !0;
                    var x = 3 * y;
                    if (this._circleAndRectCollide(m[x], m[x + 1], m[x + 2], t1, e1, i, o) && (!s || s(this.circleKeys[y]))) {
                        if (n.hitTest) return a.push(!0), !0;
                        var b = m[x], w = m[x + 1], T = m[x + 2];
                        a.push({
                            key: this.circleKeys[y],
                            x1: b - T,
                            y1: w - T,
                            x2: b + T,
                            y2: w + T
                        });
                    }
                }
            }
        }, Yt.prototype._queryCellCircle = function(t1, e1, i, o, r, a, n, s) {
            var l = n.circle, c = n.seenUids, u = this.boxCells[r];
            if (null !== u) for(var h = this.bboxes, p = 0, d = u; p < d.length; p += 1){
                var _ = d[p];
                if (!c.box[_]) {
                    c.box[_] = !0;
                    var f = 4 * _;
                    if (this._circleAndRectCollide(l.x, l.y, l.radius, h[f + 0], h[f + 1], h[f + 2], h[f + 3]) && (!s || s(this.boxKeys[_]))) return a.push(!0), !0;
                }
            }
            var m = this.circleCells[r];
            if (null !== m) for(var g = this.circles, v = 0, y = m; v < y.length; v += 1){
                var x = y[v];
                if (!c.circle[x]) {
                    c.circle[x] = !0;
                    var b = 3 * x;
                    if (this._circlesCollide(g[b], g[b + 1], g[b + 2], l.x, l.y, l.radius) && (!s || s(this.circleKeys[x]))) return a.push(!0), !0;
                }
            }
        }, Yt.prototype._forEachCell = function(t1, e1, i, o, r, a, n, s) {
            for(var l = this._convertToXCellCoord(t1), c = this._convertToYCellCoord(e1), u = this._convertToXCellCoord(i), h = this._convertToYCellCoord(o), p = l; p <= u; p++)for(var d = c; d <= h; d++)if (r.call(this, t1, e1, i, o, this.xCellCount * d + p, a, n, s)) return;
        }, Yt.prototype._convertToXCellCoord = function(t1) {
            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t1 * this.xScale)));
        }, Yt.prototype._convertToYCellCoord = function(t1) {
            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t1 * this.yScale)));
        }, Yt.prototype._circlesCollide = function(t1, e1, i, o, r, a) {
            var n = o - t1, s = r - e1, l = i + a;
            return l * l > n * n + s * s;
        }, Yt.prototype._circleAndRectCollide = function(t1, e1, i, o, r, a, n) {
            var s = (a - o) / 2, l = Math.abs(t1 - (o + s));
            if (l > s + i) return !1;
            var c = (n - r) / 2, u = Math.abs(e1 - (r + c));
            if (u > c + i) return !1;
            if (l <= s || u <= c) return !0;
            var h = l - s, p = u - c;
            return h * h + p * p <= i * i;
        };
        var le = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function ce(t1, e1) {
            for(var i = 0; i < t1; i++){
                var o = e1.length;
                e1.resize(o + 4), e1.float32.set(le, 3 * o);
            }
        }
        function ue(t1, e1, i) {
            var o = e1[0], r = e1[1];
            return t1[0] = i[0] * o + i[4] * r + i[12], t1[1] = i[1] * o + i[5] * r + i[13], t1[3] = i[3] * o + i[7] * r + i[15], t1;
        }
        var he = function(t1, e1, i) {
            void 0 === e1 && (e1 = new Yt(t1.width + 200, t1.height + 200, 25)), void 0 === i && (i = new Yt(t1.width + 200, t1.height + 200, 25)), this.transform = t1, this.grid = e1, this.ignoredGrid = i, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + 100, this.screenBottomBoundary = t1.height + 100, this.gridRightBoundary = t1.width + 200, this.gridBottomBoundary = t1.height + 200;
        };
        function pe(e1, i, o) {
            return i * (t1.EXTENT / (e1.tileSize * Math.pow(2, o - e1.tileID.overscaledZ)));
        }
        he.prototype.placeCollisionBox = function(t1, e1, i, o, r) {
            var a = this.projectAndGetPerspectiveRatio(o, t1.anchorPointX, t1.anchorPointY), n = i * a.perspectiveRatio, s = t1.x1 * n + a.point.x, l = t1.y1 * n + a.point.y, c = t1.x2 * n + a.point.x, u = t1.y2 * n + a.point.y;
            return !this.isInsideGrid(s, l, c, u) || !e1 && this.grid.hitTest(s, l, c, u, r) ? {
                box: [],
                offscreen: !1
            } : {
                box: [
                    s,
                    l,
                    c,
                    u
                ],
                offscreen: this.isOffscreen(s, l, c, u)
            };
        }, he.prototype.placeCollisionCircles = function(e1, i, o, r, a, n, s, l, c, u, h, p, d) {
            var _ = [], f = new t1.Point(i.anchorX, i.anchorY), m = $t(f, n), g = te(this.transform.cameraToCenterDistance, m.signedDistanceFromCamera), v = (u ? a / g : a * g) / t1.ONE_EM, y = $t(f, s).point, x = oe(v, r, i.lineOffsetX * v, i.lineOffsetY * v, !1, y, f, i, o, s, {}), b = !1, w = !1, T = !0;
            if (x) {
                for(var E = .5 * p * g + d, I = new t1.Point(-100, -100), P = new t1.Point(this.screenRightBoundary, this.screenBottomBoundary), S = new Kt, C = x.first, z = x.last, D = [], A = C.path.length - 1; A >= 1; A--)D.push(C.path[A]);
                for(var M = 1; M < z.path.length; M++)D.push(z.path[M]);
                var L = 2.5 * E;
                if (l) {
                    var R = D.map(function(t1) {
                        return $t(t1, l);
                    });
                    D = R.some(function(t1) {
                        return t1.signedDistanceFromCamera <= 0;
                    }) ? [] : R.map(function(t1) {
                        return t1.point;
                    });
                }
                var k = [];
                if (D.length > 0) {
                    for(var B = D[0].clone(), O = D[0].clone(), F = 1; F < D.length; F++)B.x = Math.min(B.x, D[F].x), B.y = Math.min(B.y, D[F].y), O.x = Math.max(O.x, D[F].x), O.y = Math.max(O.y, D[F].y);
                    k = B.x >= I.x && O.x <= P.x && B.y >= I.y && O.y <= P.y ? [
                        D
                    ] : O.x < I.x || B.x > P.x || O.y < I.y || B.y > P.y ? [] : t1.clipLine([
                        D
                    ], I.x, I.y, P.x, P.y);
                }
                for(var U = 0, N = k; U < N.length; U += 1){
                    var Z;
                    S.reset(N[U], .25 * E), Z = S.length <= .5 * E ? 1 : Math.ceil(S.paddedLength / L) + 1;
                    for(var q = 0; q < Z; q++){
                        var j = q / Math.max(Z - 1, 1), V = S.lerp(j), G = V.x + 100, W = V.y + 100;
                        _.push(G, W, E, 0);
                        var X = G - E, H = W - E, K = G + E, Y = W + E;
                        if (T = T && this.isOffscreen(X, H, K, Y), w = w || this.isInsideGrid(X, H, K, Y), !e1 && this.grid.hitTestCircle(G, W, E, h) && (b = !0, !c)) return {
                            circles: [],
                            offscreen: !1,
                            collisionDetected: b
                        };
                    }
                }
            }
            return {
                circles: !c && b || !w ? [] : _,
                offscreen: T,
                collisionDetected: b
            };
        }, he.prototype.queryRenderedSymbols = function(e1) {
            if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
            for(var i = [], o = 1 / 0, r = 1 / 0, a = -1 / 0, n = -1 / 0, s = 0, l = e1; s < l.length; s += 1){
                var c = l[s], u = new t1.Point(c.x + 100, c.y + 100);
                o = Math.min(o, u.x), r = Math.min(r, u.y), a = Math.max(a, u.x), n = Math.max(n, u.y), i.push(u);
            }
            for(var h = {}, p = {}, d = 0, _ = this.grid.query(o, r, a, n).concat(this.ignoredGrid.query(o, r, a, n)); d < _.length; d += 1){
                var f = _[d], m = f.key;
                if (void 0 === h[m.bucketInstanceId] && (h[m.bucketInstanceId] = {}), !h[m.bucketInstanceId][m.featureIndex]) {
                    var g = [
                        new t1.Point(f.x1, f.y1),
                        new t1.Point(f.x2, f.y1),
                        new t1.Point(f.x2, f.y2),
                        new t1.Point(f.x1, f.y2)
                    ];
                    t1.polygonIntersectsPolygon(i, g) && (h[m.bucketInstanceId][m.featureIndex] = !0, void 0 === p[m.bucketInstanceId] && (p[m.bucketInstanceId] = []), p[m.bucketInstanceId].push(m.featureIndex));
                }
            }
            return p;
        }, he.prototype.insertCollisionBox = function(t1, e1, i, o, r) {
            (e1 ? this.ignoredGrid : this.grid).insert({
                bucketInstanceId: i,
                featureIndex: o,
                collisionGroupID: r
            }, t1[0], t1[1], t1[2], t1[3]);
        }, he.prototype.insertCollisionCircles = function(t1, e1, i, o, r) {
            for(var a = e1 ? this.ignoredGrid : this.grid, n = {
                bucketInstanceId: i,
                featureIndex: o,
                collisionGroupID: r
            }, s = 0; s < t1.length; s += 4)a.insertCircle(n, t1[s], t1[s + 1], t1[s + 2]);
        }, he.prototype.projectAndGetPerspectiveRatio = function(e1, i, o) {
            var r = [
                i,
                o,
                0,
                1
            ];
            return ue(r, r, e1), {
                point: new t1.Point((r[0] / r[3] + 1) / 2 * this.transform.width + 100, (-r[1] / r[3] + 1) / 2 * this.transform.height + 100),
                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / r[3] * .5
            };
        }, he.prototype.isOffscreen = function(t1, e1, i, o) {
            return i < 100 || t1 >= this.screenRightBoundary || o < 100 || e1 > this.screenBottomBoundary;
        }, he.prototype.isInsideGrid = function(t1, e1, i, o) {
            return i >= 0 && t1 < this.gridRightBoundary && o >= 0 && e1 < this.gridBottomBoundary;
        }, he.prototype.getViewportMatrix = function() {
            var e1 = t1.identity([]);
            return t1.translate(e1, e1, [
                -100,
                -100,
                0
            ]), e1;
        };
        var de = function(t1, e1, i, o) {
            this.opacity = t1 ? Math.max(0, Math.min(1, t1.opacity + (t1.placed ? e1 : -e1))) : o && i ? 1 : 0, this.placed = i;
        };
        de.prototype.isHidden = function() {
            return 0 === this.opacity && !this.placed;
        };
        var _e = function(t1, e1, i, o, r) {
            this.text = new de(t1 ? t1.text : null, e1, i, r), this.icon = new de(t1 ? t1.icon : null, e1, o, r);
        };
        _e.prototype.isHidden = function() {
            return this.text.isHidden() && this.icon.isHidden();
        };
        var fe = function(t1, e1, i) {
            this.text = t1, this.icon = e1, this.skipFade = i;
        }, me = function() {
            this.invProjMatrix = t1.create(), this.viewportMatrix = t1.create(), this.circles = [];
        }, ge = function(t1, e1, i, o, r) {
            this.bucketInstanceId = t1, this.featureIndex = e1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = r;
        }, ve = function(t1) {
            this.crossSourceCollisions = t1, this.maxGroupID = 0, this.collisionGroups = {};
        };
        function ye(e1, i, o, r, a) {
            var n = t1.getAnchorAlignment(e1), s = -(n.horizontalAlign - .5) * i, l = -(n.verticalAlign - .5) * o, c = t1.evaluateVariableOffset(e1, r);
            return new t1.Point(s + c[0] * a, l + c[1] * a);
        }
        function xe(e1, i, o, r, a, n) {
            var s = e1.x1, l = e1.x2, c = e1.y1, u = e1.y2, h = e1.anchorPointX, p = e1.anchorPointY, d = new t1.Point(i, o);
            return r && d._rotate(a ? n : -n), {
                x1: s + d.x,
                y1: c + d.y,
                x2: l + d.x,
                y2: u + d.y,
                anchorPointX: h,
                anchorPointY: p
            };
        }
        ve.prototype.get = function(t1) {
            if (this.crossSourceCollisions) return {
                ID: 0,
                predicate: null
            };
            if (!this.collisionGroups[t1]) {
                var e1 = ++this.maxGroupID;
                this.collisionGroups[t1] = {
                    ID: e1,
                    predicate: function(t1) {
                        return t1.collisionGroupID === e1;
                    }
                };
            }
            return this.collisionGroups[t1];
        };
        var be = function(t1, e1, i, o) {
            this.transform = t1.clone(), this.collisionIndex = new he(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = e1, this.retainedQueryData = {}, this.collisionGroups = new ve(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
        };
        function we(t1, e1, i, o, r) {
            t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, o || 0, r || 0);
        }
        be.prototype.getBucketParts = function(e1, i, o, r) {
            var a = o.getBucket(i), n = o.latestFeatureIndex;
            if (a && n && i.id === a.layerIds[0]) {
                var s = o.collisionBoxArray, l = a.layers[0].layout, c = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), u = o.tileSize / t1.EXTENT, h = this.transform.calculatePosMatrix(o.tileID.toUnwrapped()), p = "map" === l.get("text-pitch-alignment"), d = "map" === l.get("text-rotation-alignment"), _ = pe(o, 1, this.transform.zoom), f = Jt(h, p, d, this.transform, _), m = null;
                if (p) {
                    var g = Qt(h, p, d, this.transform, _);
                    m = t1.multiply([], this.transform.labelPlaneMatrix, g);
                }
                this.retainedQueryData[a.bucketInstanceId] = new ge(a.bucketInstanceId, n, a.sourceLayerIndex, a.index, o.tileID);
                var v = {
                    bucket: a,
                    layout: l,
                    posMatrix: h,
                    textLabelPlaneMatrix: f,
                    labelToScreenMatrix: m,
                    scale: c,
                    textPixelRatio: u,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: s,
                    partiallyEvaluatedTextSize: t1.evaluateSizeForZoom(a.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(a.sourceID)
                };
                if (r) for(var y = 0, x = a.sortKeyRanges; y < x.length; y += 1){
                    var b = x[y];
                    e1.push({
                        sortKey: b.sortKey,
                        symbolInstanceStart: b.symbolInstanceStart,
                        symbolInstanceEnd: b.symbolInstanceEnd,
                        parameters: v
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: a.symbolInstances.length,
                    parameters: v
                });
            }
        }, be.prototype.attemptAnchorPlacement = function(t1, e1, i, o, r, a, n, s, l, c, u, h, p, d, _) {
            var f, m = [
                h.textOffset0,
                h.textOffset1
            ], g = ye(t1, i, o, m, r), v = this.collisionIndex.placeCollisionBox(xe(e1, g.x, g.y, a, n, this.transform.angle), u, s, l, c.predicate);
            if (!_ || 0 !== this.collisionIndex.placeCollisionBox(xe(_, g.x, g.y, a, n, this.transform.angle), u, s, l, c.predicate).box.length) return v.box.length > 0 ? (this.prevPlacement && this.prevPlacement.variableOffsets[h.crossTileID] && this.prevPlacement.placements[h.crossTileID] && this.prevPlacement.placements[h.crossTileID].text && (f = this.prevPlacement.variableOffsets[h.crossTileID].anchor), this.variableOffsets[h.crossTileID] = {
                textOffset: m,
                width: i,
                height: o,
                anchor: t1,
                textBoxScale: r,
                prevAnchor: f
            }, this.markUsedJustification(p, t1, h, d), p.allowVerticalPlacement && (this.markUsedOrientation(p, d, h), this.placedOrientations[h.crossTileID] = d), {
                shift: g,
                placedGlyphBoxes: v
            }) : void 0;
        }, be.prototype.placeLayerBucketPart = function(e1, i, o) {
            var r = this, a = e1.parameters, n = a.bucket, s = a.layout, l = a.posMatrix, c = a.textLabelPlaneMatrix, u = a.labelToScreenMatrix, h = a.textPixelRatio, p = a.holdingForFade, d = a.collisionBoxArray, _ = a.partiallyEvaluatedTextSize, f = a.collisionGroup, m = s.get("text-optional"), g = s.get("icon-optional"), v = s.get("text-allow-overlap"), y = s.get("icon-allow-overlap"), x = "map" === s.get("text-rotation-alignment"), b = "map" === s.get("text-pitch-alignment"), w = "none" !== s.get("icon-text-fit"), T = "viewport-y" === s.get("symbol-z-order"), E = v && (y || !n.hasIconData() || g), I = y && (v || !n.hasTextData() || m);
            !n.collisionArrays && d && n.deserializeCollisionBoxes(d);
            var P = function(e1, a) {
                if (!i[e1.crossTileID]) {
                    if (p) r.placements[e1.crossTileID] = new fe(!1, !1, !1);
                    else {
                        var d, T = !1, P = !1, S = !0, C = null, z = {
                            box: null,
                            offscreen: null
                        }, D = {
                            box: null,
                            offscreen: null
                        }, A = null, M = null, L = 0, R = 0, k = 0;
                        a.textFeatureIndex ? L = a.textFeatureIndex : e1.useRuntimeCollisionCircles && (L = e1.featureIndex), a.verticalTextFeatureIndex && (R = a.verticalTextFeatureIndex);
                        var B = a.textBox;
                        if (B) {
                            var O = function(i) {
                                var o = t1.WritingMode.horizontal;
                                if (n.allowVerticalPlacement && !i && r.prevPlacement) {
                                    var a = r.prevPlacement.placedOrientations[e1.crossTileID];
                                    a && (r.placedOrientations[e1.crossTileID] = a, r.markUsedOrientation(n, o = a, e1));
                                }
                                return o;
                            }, F = function(i, o) {
                                if (n.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && a.verticalTextBox) for(var r = 0, s = n.writingModes; r < s.length && (s[r] === t1.WritingMode.vertical ? (z = o(), D = z) : z = i(), !(z && z.box && z.box.length)); r += 1);
                                else z = i();
                            };
                            if (s.get("text-variable-anchor")) {
                                var U = s.get("text-variable-anchor");
                                if (r.prevPlacement && r.prevPlacement.variableOffsets[e1.crossTileID]) {
                                    var N = r.prevPlacement.variableOffsets[e1.crossTileID];
                                    U.indexOf(N.anchor) > 0 && (U = U.filter(function(t1) {
                                        return t1 !== N.anchor;
                                    })).unshift(N.anchor);
                                }
                                var Z = function(t1, i, o) {
                                    for(var a = t1.x2 - t1.x1, s = t1.y2 - t1.y1, c = e1.textBoxScale, u = w && !y ? i : null, p = {
                                        box: [],
                                        offscreen: !1
                                    }, d = v ? 2 * U.length : U.length, _ = 0; _ < d; ++_){
                                        var m = r.attemptAnchorPlacement(U[_ % U.length], t1, a, s, c, x, b, h, l, f, _ >= U.length, e1, n, o, u);
                                        if (m && (p = m.placedGlyphBoxes) && p.box && p.box.length) {
                                            T = !0, C = m.shift;
                                            break;
                                        }
                                    }
                                    return p;
                                };
                                F(function() {
                                    return Z(B, a.iconBox, t1.WritingMode.horizontal);
                                }, function() {
                                    var i = a.verticalTextBox;
                                    return n.allowVerticalPlacement && !(z && z.box && z.box.length) && e1.numVerticalGlyphVertices > 0 && i ? Z(i, a.verticalIconBox, t1.WritingMode.vertical) : {
                                        box: null,
                                        offscreen: null
                                    };
                                }), z && (T = z.box, S = z.offscreen);
                                var q = O(z && z.box);
                                if (!T && r.prevPlacement) {
                                    var j = r.prevPlacement.variableOffsets[e1.crossTileID];
                                    j && (r.variableOffsets[e1.crossTileID] = j, r.markUsedJustification(n, j.anchor, e1, q));
                                }
                            } else {
                                var V = function(t1, i) {
                                    var o = r.collisionIndex.placeCollisionBox(t1, v, h, l, f.predicate);
                                    return o && o.box && o.box.length && (r.markUsedOrientation(n, i, e1), r.placedOrientations[e1.crossTileID] = i), o;
                                };
                                F(function() {
                                    return V(B, t1.WritingMode.horizontal);
                                }, function() {
                                    var i = a.verticalTextBox;
                                    return n.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && i ? V(i, t1.WritingMode.vertical) : {
                                        box: null,
                                        offscreen: null
                                    };
                                }), O(z && z.box && z.box.length);
                            }
                        }
                        if (T = (d = z) && d.box && d.box.length > 0, S = d && d.offscreen, e1.useRuntimeCollisionCircles) {
                            var G = n.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), W = t1.evaluateSizeForFeature(n.textSizeData, _, G), X = s.get("text-padding");
                            A = r.collisionIndex.placeCollisionCircles(v, G, n.lineVertexArray, n.glyphOffsetArray, W, l, c, u, o, b, f.predicate, e1.collisionCircleDiameter, X), T = v || A.circles.length > 0 && !A.collisionDetected, S = S && A.offscreen;
                        }
                        if (a.iconFeatureIndex && (k = a.iconFeatureIndex), a.iconBox) {
                            var H = function(t1) {
                                var e1 = w && C ? xe(t1, C.x, C.y, x, b, r.transform.angle) : t1;
                                return r.collisionIndex.placeCollisionBox(e1, y, h, l, f.predicate);
                            };
                            P = D && D.box && D.box.length && a.verticalIconBox ? (M = H(a.verticalIconBox)).box.length > 0 : (M = H(a.iconBox)).box.length > 0, S = S && M.offscreen;
                        }
                        var K = m || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, Y = g || 0 === e1.numIconVertices;
                        if (K || Y ? Y ? K || (P = P && T) : T = P && T : P = T = P && T, T && d && d.box && r.collisionIndex.insertCollisionBox(d.box, s.get("text-ignore-placement"), n.bucketInstanceId, D && D.box && R ? R : L, f.ID), P && M && r.collisionIndex.insertCollisionBox(M.box, s.get("icon-ignore-placement"), n.bucketInstanceId, k, f.ID), A && (T && r.collisionIndex.insertCollisionCircles(A.circles, s.get("text-ignore-placement"), n.bucketInstanceId, L, f.ID), o)) {
                            var J = n.bucketInstanceId, Q = r.collisionCircleArrays[J];
                            void 0 === Q && (Q = r.collisionCircleArrays[J] = new me);
                            for(var $ = 0; $ < A.circles.length; $ += 4)Q.circles.push(A.circles[$ + 0]), Q.circles.push(A.circles[$ + 1]), Q.circles.push(A.circles[$ + 2]), Q.circles.push(A.collisionDetected ? 1 : 0);
                        }
                        r.placements[e1.crossTileID] = new fe(T || E, P || I, S || n.justReloaded), i[e1.crossTileID] = !0;
                    }
                }
            };
            if (T) for(var S = n.getSortedSymbolIndexes(this.transform.angle), C = S.length - 1; C >= 0; --C){
                var z = S[C];
                P(n.symbolInstances.get(z), n.collisionArrays[z]);
            }
            else for(var D = e1.symbolInstanceStart; D < e1.symbolInstanceEnd; D++)P(n.symbolInstances.get(D), n.collisionArrays[D]);
            if (o && n.bucketInstanceId in this.collisionCircleArrays) {
                var A = this.collisionCircleArrays[n.bucketInstanceId];
                t1.invert(A.invProjMatrix, l), A.viewportMatrix = this.collisionIndex.getViewportMatrix();
            }
            n.justReloaded = !1;
        }, be.prototype.markUsedJustification = function(e1, i, o, r) {
            var a;
            a = r === t1.WritingMode.vertical ? o.verticalPlacedTextSymbolIndex : ({
                left: o.leftJustifiedTextSymbolIndex,
                center: o.centerJustifiedTextSymbolIndex,
                right: o.rightJustifiedTextSymbolIndex
            })[t1.getAnchorJustification(i)];
            for(var n = 0, s = [
                o.leftJustifiedTextSymbolIndex,
                o.centerJustifiedTextSymbolIndex,
                o.rightJustifiedTextSymbolIndex,
                o.verticalPlacedTextSymbolIndex
            ]; n < s.length; n += 1){
                var l = s[n];
                l >= 0 && (e1.text.placedSymbolArray.get(l).crossTileID = a >= 0 && l !== a ? 0 : o.crossTileID);
            }
        }, be.prototype.markUsedOrientation = function(e1, i, o) {
            for(var r = i === t1.WritingMode.horizontal || i === t1.WritingMode.horizontalOnly ? i : 0, a = i === t1.WritingMode.vertical ? i : 0, n = 0, s = [
                o.leftJustifiedTextSymbolIndex,
                o.centerJustifiedTextSymbolIndex,
                o.rightJustifiedTextSymbolIndex
            ]; n < s.length; n += 1)e1.text.placedSymbolArray.get(s[n]).placedOrientation = r;
            o.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation = a);
        }, be.prototype.commit = function(t1) {
            this.commitTime = t1, this.zoomAtLastRecencyCheck = this.transform.zoom;
            var e1 = this.prevPlacement, i = !1;
            this.prevZoomAdjustment = e1 ? e1.zoomAdjustment(this.transform.zoom) : 0;
            var o = e1 ? e1.symbolFadeChange(t1) : 1, r = e1 ? e1.opacities : {}, a = e1 ? e1.variableOffsets : {}, n = e1 ? e1.placedOrientations : {};
            for(var s in this.placements){
                var l = this.placements[s], c = r[s];
                c ? (this.opacities[s] = new _e(c, o, l.text, l.icon), i = i || l.text !== c.text.placed || l.icon !== c.icon.placed) : (this.opacities[s] = new _e(null, o, l.text, l.icon, l.skipFade), i = i || l.text || l.icon);
            }
            for(var u in r){
                var h = r[u];
                if (!this.opacities[u]) {
                    var p = new _e(h, o, !1, !1);
                    p.isHidden() || (this.opacities[u] = p, i = i || h.text.placed || h.icon.placed);
                }
            }
            for(var d in a)this.variableOffsets[d] || !this.opacities[d] || this.opacities[d].isHidden() || (this.variableOffsets[d] = a[d]);
            for(var _ in n)this.placedOrientations[_] || !this.opacities[_] || this.opacities[_].isHidden() || (this.placedOrientations[_] = n[_]);
            i ? this.lastPlacementChangeTime = t1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e1 ? e1.lastPlacementChangeTime : t1);
        }, be.prototype.updateLayerOpacities = function(t1, e1) {
            for(var i = {}, o = 0, r = e1; o < r.length; o += 1){
                var a = r[o], n = a.getBucket(t1);
                n && a.latestFeatureIndex && t1.id === n.layerIds[0] && this.updateBucketOpacities(n, i, a.collisionBoxArray);
            }
        }, be.prototype.updateBucketOpacities = function(e1, i, o) {
            var r = this;
            e1.hasTextData() && e1.text.opacityVertexArray.clear(), e1.hasIconData() && e1.icon.opacityVertexArray.clear(), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
            var a = e1.layers[0].layout, n = new _e(null, 0, !1, !1, !0), s = a.get("text-allow-overlap"), l = a.get("icon-allow-overlap"), c = a.get("text-variable-anchor"), u = "map" === a.get("text-rotation-alignment"), h = "map" === a.get("text-pitch-alignment"), p = "none" !== a.get("icon-text-fit"), d = new _e(null, 0, s && (l || !e1.hasIconData() || a.get("icon-optional")), l && (s || !e1.hasTextData() || a.get("text-optional")), !0);
            !e1.collisionArrays && o && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(o);
            for(var _ = function(t1, e1, i) {
                for(var o = 0; o < e1 / 4; o++)t1.opacityVertexArray.emplaceBack(i);
            }, f = function(o) {
                var a = e1.symbolInstances.get(o), s = a.numHorizontalGlyphVertices, l = a.numVerticalGlyphVertices, f = a.crossTileID, m = r.opacities[f];
                i[f] ? m = n : m || (r.opacities[f] = m = d), i[f] = !0;
                var g = a.numIconVertices > 0, v = r.placedOrientations[a.crossTileID], y = v === t1.WritingMode.vertical, x = v === t1.WritingMode.horizontal || v === t1.WritingMode.horizontalOnly;
                if (s > 0 || l > 0) {
                    var b = De(m.text);
                    _(e1.text, s, y ? Ae : b), _(e1.text, l, x ? Ae : b);
                    var w = m.text.isHidden();
                    [
                        a.rightJustifiedTextSymbolIndex,
                        a.centerJustifiedTextSymbolIndex,
                        a.leftJustifiedTextSymbolIndex
                    ].forEach(function(t1) {
                        t1 >= 0 && (e1.text.placedSymbolArray.get(t1).hidden = w || y ? 1 : 0);
                    }), a.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = w || x ? 1 : 0);
                    var T = r.variableOffsets[a.crossTileID];
                    T && r.markUsedJustification(e1, T.anchor, a, v);
                    var E = r.placedOrientations[a.crossTileID];
                    E && (r.markUsedJustification(e1, "left", a, E), r.markUsedOrientation(e1, E, a));
                }
                if (g) {
                    var I = De(m.icon), P = !(p && a.verticalPlacedIconSymbolIndex && y);
                    a.placedIconSymbolIndex >= 0 && (_(e1.icon, a.numIconVertices, P ? I : Ae), e1.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = m.icon.isHidden()), a.verticalPlacedIconSymbolIndex >= 0 && (_(e1.icon, a.numVerticalIconVertices, P ? Ae : I), e1.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = m.icon.isHidden());
                }
                if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                    var S = e1.collisionArrays[o];
                    if (S) {
                        var C = new t1.Point(0, 0);
                        if (S.textBox || S.verticalTextBox) {
                            var z = !0;
                            if (c) {
                                var D = r.variableOffsets[f];
                                D ? (C = ye(D.anchor, D.width, D.height, D.textOffset, D.textBoxScale), u && C._rotate(h ? r.transform.angle : -r.transform.angle)) : z = !1;
                            }
                            S.textBox && we(e1.textCollisionBox.collisionVertexArray, m.text.placed, !z || y, C.x, C.y), S.verticalTextBox && we(e1.textCollisionBox.collisionVertexArray, m.text.placed, !z || x, C.x, C.y);
                        }
                        var A = Boolean(!x && S.verticalIconBox);
                        S.iconBox && we(e1.iconCollisionBox.collisionVertexArray, m.icon.placed, A, p ? C.x : 0, p ? C.y : 0), S.verticalIconBox && we(e1.iconCollisionBox.collisionVertexArray, m.icon.placed, !A, p ? C.x : 0, p ? C.y : 0);
                    }
                }
            }, m = 0; m < e1.symbolInstances.length; m++)f(m);
            if (e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.bucketInstanceId in this.collisionCircleArrays) {
                var g = this.collisionCircleArrays[e1.bucketInstanceId];
                e1.placementInvProjMatrix = g.invProjMatrix, e1.placementViewportMatrix = g.viewportMatrix, e1.collisionCircleArray = g.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
            }
        }, be.prototype.symbolFadeChange = function(t1) {
            return 0 === this.fadeDuration ? 1 : (t1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
        }, be.prototype.zoomAdjustment = function(t1) {
            return Math.max(0, (this.transform.zoom - t1) / 1.5);
        }, be.prototype.hasTransitions = function(t1) {
            return this.stale || t1 - this.lastPlacementChangeTime < this.fadeDuration;
        }, be.prototype.stillRecent = function(t1, e1) {
            var i = this.zoomAtLastRecencyCheck === e1 ? 1 - this.zoomAdjustment(e1) : 1;
            return this.zoomAtLastRecencyCheck = e1, this.commitTime + this.fadeDuration * i > t1;
        }, be.prototype.setStale = function() {
            this.stale = !0;
        };
        var Te = Math.pow(2, 25), Ee = Math.pow(2, 24), Ie = Math.pow(2, 17), Pe = Math.pow(2, 16), Se = Math.pow(2, 9), Ce = Math.pow(2, 8), ze = Math.pow(2, 1);
        function De(t1) {
            if (0 === t1.opacity && !t1.placed) return 0;
            if (1 === t1.opacity && t1.placed) return 4294967295;
            var e1 = t1.placed ? 1 : 0, i = Math.floor(127 * t1.opacity);
            return i * Te + e1 * Ee + i * Ie + e1 * Pe + i * Se + e1 * Ce + i * ze + e1;
        }
        var Ae = 0, Me = function(t1) {
            this._sortAcrossTiles = "viewport-y" !== t1.layout.get("symbol-z-order") && void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
        };
        Me.prototype.continuePlacement = function(t1, e1, i, o, r) {
            for(var a = this._bucketParts; this._currentTileIndex < t1.length;)if (e1.getBucketParts(a, o, t1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
            for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            })); this._currentPartIndex < a.length;)if (e1.placeLayerBucketPart(a[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, r()) return !0;
            return !1;
        };
        var Le = function(t1, e1, i, o, r, a, n) {
            this.placement = new be(t1, r, a, n), this._currentPlacementIndex = e1.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
        };
        Le.prototype.isDone = function() {
            return this._done;
        }, Le.prototype.continuePlacement = function(e1, i, o) {
            for(var r = this, a = t1.browser.now(), n = function() {
                var e1 = t1.browser.now() - a;
                return !r._forceFullPlacement && e1 > 2;
            }; this._currentPlacementIndex >= 0;){
                var s = i[e1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                if ("symbol" === s.type && (!s.minzoom || s.minzoom <= l) && (!s.maxzoom || s.maxzoom > l)) {
                    if (this._inProgressLayer || (this._inProgressLayer = new Me(s)), this._inProgressLayer.continuePlacement(o[s.source], this.placement, this._showCollisionBoxes, s, n)) return;
                    delete this._inProgressLayer;
                }
                this._currentPlacementIndex--;
            }
            this._done = !0;
        }, Le.prototype.commit = function(t1) {
            return this.placement.commit(t1), this.placement;
        };
        var Re = 512 / t1.EXTENT / 2, ke = function(t1, e1, i) {
            this.tileID = t1, this.indexedSymbolInstances = {}, this.bucketInstanceId = i;
            for(var o = 0; o < e1.length; o++){
                var r = e1.get(o), a = r.key;
                this.indexedSymbolInstances[a] || (this.indexedSymbolInstances[a] = []), this.indexedSymbolInstances[a].push({
                    crossTileID: r.crossTileID,
                    coord: this.getScaledCoordinates(r, t1)
                });
            }
        };
        ke.prototype.getScaledCoordinates = function(e1, i) {
            var o = Re / Math.pow(2, i.canonical.z - this.tileID.canonical.z);
            return {
                x: Math.floor((i.canonical.x * t1.EXTENT + e1.anchorX) * o),
                y: Math.floor((i.canonical.y * t1.EXTENT + e1.anchorY) * o)
            };
        }, ke.prototype.findMatches = function(t1, e1, i) {
            for(var o = this.tileID.canonical.z < e1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e1.canonical.z), r = 0; r < t1.length; r++){
                var a = t1.get(r);
                if (!a.crossTileID) {
                    var n = this.indexedSymbolInstances[a.key];
                    if (n) for(var s = this.getScaledCoordinates(a, e1), l = 0, c = n; l < c.length; l += 1){
                        var u = c[l];
                        if (Math.abs(u.coord.x - s.x) <= o && Math.abs(u.coord.y - s.y) <= o && !i[u.crossTileID]) {
                            i[u.crossTileID] = !0, a.crossTileID = u.crossTileID;
                            break;
                        }
                    }
                }
            }
        };
        var Be = function() {
            this.maxCrossTileID = 0;
        };
        Be.prototype.generate = function() {
            return ++this.maxCrossTileID;
        };
        var Oe = function() {
            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
        };
        Oe.prototype.handleWrapJump = function(t1) {
            var e1 = Math.round((t1 - this.lng) / 360);
            if (0 !== e1) for(var i in this.indexes){
                var o = this.indexes[i], r = {};
                for(var a in o){
                    var n = o[a];
                    n.tileID = n.tileID.unwrapTo(n.tileID.wrap + e1), r[n.tileID.key] = n;
                }
                this.indexes[i] = r;
            }
            this.lng = t1;
        }, Oe.prototype.addBucket = function(t1, e1, i) {
            if (this.indexes[t1.overscaledZ] && this.indexes[t1.overscaledZ][t1.key]) {
                if (this.indexes[t1.overscaledZ][t1.key].bucketInstanceId === e1.bucketInstanceId) return !1;
                this.removeBucketCrossTileIDs(t1.overscaledZ, this.indexes[t1.overscaledZ][t1.key]);
            }
            for(var o = 0; o < e1.symbolInstances.length; o++)e1.symbolInstances.get(o).crossTileID = 0;
            this.usedCrossTileIDs[t1.overscaledZ] || (this.usedCrossTileIDs[t1.overscaledZ] = {});
            var r = this.usedCrossTileIDs[t1.overscaledZ];
            for(var a in this.indexes){
                var n = this.indexes[a];
                if (Number(a) > t1.overscaledZ) for(var s in n){
                    var l = n[s];
                    l.tileID.isChildOf(t1) && l.findMatches(e1.symbolInstances, t1, r);
                }
                else {
                    var c = n[t1.scaledTo(Number(a)).key];
                    c && c.findMatches(e1.symbolInstances, t1, r);
                }
            }
            for(var u = 0; u < e1.symbolInstances.length; u++){
                var h = e1.symbolInstances.get(u);
                h.crossTileID || (h.crossTileID = i.generate(), r[h.crossTileID] = !0);
            }
            return void 0 === this.indexes[t1.overscaledZ] && (this.indexes[t1.overscaledZ] = {}), this.indexes[t1.overscaledZ][t1.key] = new ke(t1, e1.symbolInstances, e1.bucketInstanceId), !0;
        }, Oe.prototype.removeBucketCrossTileIDs = function(t1, e1) {
            for(var i in e1.indexedSymbolInstances)for(var o = 0, r = e1.indexedSymbolInstances[i]; o < r.length; o += 1)delete this.usedCrossTileIDs[t1][r[o].crossTileID];
        }, Oe.prototype.removeStaleBuckets = function(t1) {
            var e1 = !1;
            for(var i in this.indexes){
                var o = this.indexes[i];
                for(var r in o)t1[o[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[r]), delete o[r], e1 = !0);
            }
            return e1;
        };
        var Fe = function() {
            this.layerIndexes = {}, this.crossTileIDs = new Be, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
        };
        Fe.prototype.addLayer = function(t1, e1, i) {
            var o = this.layerIndexes[t1.id];
            void 0 === o && (o = this.layerIndexes[t1.id] = new Oe);
            var r = !1, a = {};
            o.handleWrapJump(i);
            for(var n = 0, s = e1; n < s.length; n += 1){
                var l = s[n], c = l.getBucket(t1);
                c && t1.id === c.layerIds[0] && (c.bucketInstanceId || (c.bucketInstanceId = ++this.maxBucketInstanceId), o.addBucket(l.tileID, c, this.crossTileIDs) && (r = !0), a[c.bucketInstanceId] = !0);
            }
            return o.removeStaleBuckets(a) && (r = !0), r;
        }, Fe.prototype.pruneUnusedLayers = function(t1) {
            var e1 = {};
            for(var i in t1.forEach(function(t1) {
                e1[t1] = !0;
            }), this.layerIndexes)e1[i] || delete this.layerIndexes[i];
        };
        var Ue = function(e1, i) {
            return t1.emitValidationErrors(e1, i && i.filter(function(t1) {
                return "source.canvas" !== t1.identifier;
            }));
        }, Ne = t1.pick(Zt, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData"
        ]), Ze = t1.pick(Zt, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), qe = function() {
            var e1 = {}, i = t1.styleSpec.$version;
            for(var o in t1.styleSpec.$root){
                var r, a = t1.styleSpec.$root[o];
                if (a.required) null != (r = "version" === o ? i : "array" === a.type ? [] : {}) && (e1[o] = r);
            }
            return e1;
        }(), je = function(e1) {
            function i(o, r) {
                var a = this;
                void 0 === r && (r = {}), e1.call(this), this.map = o, this.dispatcher = new E(Ft(), this), this.imageManager = new p, this.imageManager.setEventedParent(this), this.glyphManager = new y(o._requestManager, r.localIdeographFontFamily), this.lineAtlas = new T(256, 512), this.crossTileSymbolIndex = new Fe, this._layers = {}, this._serializedLayers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t1.ZoomHistory, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t1.getReferrer());
                var n = this;
                this._rtlTextPluginCallback = i.registerForPluginStateChange(function(e1) {
                    n.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e1.pluginStatus,
                        pluginURL: e1.pluginURL
                    }, function(e1, i) {
                        if (t1.triggerPluginCompletionEvent(e1), i && i.every(function(t1) {
                            return t1;
                        })) for(var o in n.sourceCaches)n.sourceCaches[o].reload();
                    });
                }), this.on("data", function(t1) {
                    if ("source" === t1.dataType && "metadata" === t1.sourceDataType) {
                        var e1 = a.sourceCaches[t1.sourceId];
                        if (e1) {
                            var i = e1.getSource();
                            if (i && i.vectorLayerIds) for(var o in a._layers){
                                var r = a._layers[o];
                                r.source === i.id && a._validateLayer(r);
                            }
                        }
                    }
                });
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.loadURL = function(e1, i) {
                var o = this;
                void 0 === i && (i = {}), this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                }));
                var r = "boolean" == typeof i.validate ? i.validate : !t1.isMapboxURL(e1);
                e1 = this.map._requestManager.normalizeStyleURL(e1, i.accessToken);
                var a = this.map._requestManager.transformRequest(e1, t1.ResourceType.Style);
                this._request = t1.getJSON(a, function(e1, i) {
                    o._request = null, e1 ? o.fire(new t1.ErrorEvent(e1)) : i && o._load(i, r);
                });
            }, i.prototype.loadJSON = function(e1, i) {
                var o = this;
                void 0 === i && (i = {}), this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._request = t1.browser.frame(function() {
                    o._request = null, o._load(e1, !1 !== i.validate);
                });
            }, i.prototype.loadEmpty = function() {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._load(qe, !1);
            }, i.prototype._load = function(e1, i) {
                if (!i || !Ue(this, t1.validateStyle(e1))) {
                    for(var o in this._loaded = !0, this.stylesheet = e1, e1.sources)this.addSource(o, e1.sources[o], {
                        validate: !1
                    });
                    e1.sprite ? this._loadSprite(e1.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(e1.glyphs);
                    var r = Nt(this.stylesheet.layers);
                    this._order = r.map(function(t1) {
                        return t1.id;
                    }), this._layers = {}, this._serializedLayers = {};
                    for(var a = 0, n = r; a < n.length; a += 1){
                        var s = n[a];
                        (s = t1.createStyleLayer(s)).setEventedParent(this, {
                            layer: {
                                id: s.id
                            }
                        }), this._layers[s.id] = s, this._serializedLayers[s.id] = s.serialize();
                    }
                    this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new w(this.stylesheet.light), this.fire(new t1.Event("data", {
                        dataType: "style"
                    })), this.fire(new t1.Event("style.load"));
                }
            }, i.prototype._loadSprite = function(e1) {
                var i = this;
                this._spriteRequest = function(e1, i, o) {
                    var r, a, n, s = t1.browser.devicePixelRatio > 1 ? "@2x" : "", l = t1.getJSON(i.transformRequest(i.normalizeSpriteURL(e1, s, ".json"), t1.ResourceType.SpriteJSON), function(t1, e1) {
                        l = null, n || (n = t1, r = e1, u());
                    }), c = t1.getImage(i.transformRequest(i.normalizeSpriteURL(e1, s, ".png"), t1.ResourceType.SpriteImage), function(t1, e1) {
                        c = null, n || (n = t1, a = e1, u());
                    });
                    function u() {
                        if (n) o(n);
                        else if (r && a) {
                            var e1 = t1.browser.getImageData(a), i = {};
                            for(var s in r){
                                var l = r[s], c = l.width, u = l.height, h = l.x, p = l.y, d = l.sdf, _ = l.pixelRatio, f = l.stretchX, m = l.stretchY, g = l.content, v = new t1.RGBAImage({
                                    width: c,
                                    height: u
                                });
                                t1.RGBAImage.copy(e1, v, {
                                    x: h,
                                    y: p
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: c,
                                    height: u
                                }), i[s] = {
                                    data: v,
                                    pixelRatio: _,
                                    sdf: d,
                                    stretchX: f,
                                    stretchY: m,
                                    content: g
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel: function() {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(e1, this.map._requestManager, function(e1, o) {
                    if (i._spriteRequest = null, e1) i.fire(new t1.ErrorEvent(e1));
                    else if (o) for(var r in o)i.imageManager.addImage(r, o[r]);
                    i.imageManager.setLoaded(!0), i._availableImages = i.imageManager.listImages(), i.dispatcher.broadcast("setImages", i._availableImages), i.fire(new t1.Event("data", {
                        dataType: "style"
                    }));
                });
            }, i.prototype._validateLayer = function(e1) {
                var i = this.sourceCaches[e1.source];
                if (i) {
                    var o = e1.sourceLayer;
                    if (o) {
                        var r = i.getSource();
                        ("geojson" === r.type || r.vectorLayerIds && -1 === r.vectorLayerIds.indexOf(o)) && this.fire(new t1.ErrorEvent(new Error('Source layer "' + o + '" does not exist on source "' + r.id + '" as specified by style layer "' + e1.id + '"')));
                    }
                }
            }, i.prototype.loaded = function() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(var t1 in this.sourceCaches)if (!this.sourceCaches[t1].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }, i.prototype._serializeLayers = function(t1) {
                for(var e1 = [], i = 0, o = t1; i < o.length; i += 1){
                    var r = this._layers[o[i]];
                    "custom" !== r.type && e1.push(r.serialize());
                }
                return e1;
            }, i.prototype.hasTransitions = function() {
                if (this.light && this.light.hasTransition()) return !0;
                for(var t1 in this.sourceCaches)if (this.sourceCaches[t1].hasTransition()) return !0;
                for(var e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }, i.prototype._checkLoaded = function() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }, i.prototype.update = function(e1) {
                if (this._loaded) {
                    var i = this._changed;
                    if (this._changed) {
                        var o = Object.keys(this._updatedLayers), r = Object.keys(this._removedLayers);
                        for(var a in (o.length || r.length) && this._updateWorkerLayers(o, r), this._updatedSources){
                            var n = this._updatedSources[a];
                            "reload" === n ? this._reloadSource(a) : "clear" === n && this._clearSource(a);
                        }
                        for(var s in this._updateTilesForChangedImages(), this._updatedPaintProps)this._layers[s].updateTransitions(e1);
                        this.light.updateTransitions(e1), this._resetUpdates();
                    }
                    var l = {};
                    for(var c in this.sourceCaches){
                        var u = this.sourceCaches[c];
                        l[c] = u.used, u.used = !1;
                    }
                    for(var h = 0, p = this._order; h < p.length; h += 1){
                        var d = this._layers[p[h]];
                        d.recalculate(e1, this._availableImages), !d.isHidden(e1.zoom) && d.source && (this.sourceCaches[d.source].used = !0);
                    }
                    for(var _ in l){
                        var f = this.sourceCaches[_];
                        l[_] !== f.used && f.fire(new t1.Event("data", {
                            sourceDataType: "visibility",
                            dataType: "source",
                            sourceId: _
                        }));
                    }
                    this.light.recalculate(e1), this.z = e1.zoom, i && this.fire(new t1.Event("data", {
                        dataType: "style"
                    }));
                }
            }, i.prototype._updateTilesForChangedImages = function() {
                var t1 = Object.keys(this._changedImages);
                if (t1.length) {
                    for(var e1 in this.sourceCaches)this.sourceCaches[e1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], t1);
                    this._changedImages = {};
                }
            }, i.prototype._updateWorkerLayers = function(t1, e1) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeLayers(t1),
                    removedIds: e1
                });
            }, i.prototype._resetUpdates = function() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
            }, i.prototype.setState = function(e1) {
                var i = this;
                if (this._checkLoaded(), Ue(this, t1.validateStyle(e1))) return !1;
                (e1 = t1.clone$1(e1)).layers = Nt(e1.layers);
                var o = (function(e1, i) {
                    if (!e1) return [
                        {
                            command: Zt.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    var o = [];
                    try {
                        if (!t1.deepEqual(e1.version, i.version)) return [
                            {
                                command: Zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        t1.deepEqual(e1.center, i.center) || o.push({
                            command: Zt.setCenter,
                            args: [
                                i.center
                            ]
                        }), t1.deepEqual(e1.zoom, i.zoom) || o.push({
                            command: Zt.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), t1.deepEqual(e1.bearing, i.bearing) || o.push({
                            command: Zt.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), t1.deepEqual(e1.pitch, i.pitch) || o.push({
                            command: Zt.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), t1.deepEqual(e1.sprite, i.sprite) || o.push({
                            command: Zt.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), t1.deepEqual(e1.glyphs, i.glyphs) || o.push({
                            command: Zt.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), t1.deepEqual(e1.transition, i.transition) || o.push({
                            command: Zt.setTransition,
                            args: [
                                i.transition
                            ]
                        }), t1.deepEqual(e1.light, i.light) || o.push({
                            command: Zt.setLight,
                            args: [
                                i.light
                            ]
                        });
                        var r = {}, a = [];
                        !function(e1, i, o, r) {
                            var a;
                            for(a in i = i || {}, e1 = e1 || {})e1.hasOwnProperty(a) && (i.hasOwnProperty(a) || jt(a, o, r));
                            for(a in i)i.hasOwnProperty(a) && (e1.hasOwnProperty(a) ? t1.deepEqual(e1[a], i[a]) || ("geojson" === e1[a].type && "geojson" === i[a].type && Gt(e1, i, a) ? o.push({
                                command: Zt.setGeoJSONSourceData,
                                args: [
                                    a,
                                    i[a].data
                                ]
                            }) : Vt(a, i, o, r)) : qt(a, i, o));
                        }(e1.sources, i.sources, a, r);
                        var n = [];
                        e1.layers && e1.layers.forEach(function(t1) {
                            r[t1.source] ? o.push({
                                command: Zt.removeLayer,
                                args: [
                                    t1.id
                                ]
                            }) : n.push(t1);
                        }), o = o.concat(a), function(e1, i, o) {
                            i = i || [];
                            var r, a, n, s, l, c, u, h = (e1 = e1 || []).map(Xt), p = i.map(Xt), d = e1.reduce(Ht, {}), _ = i.reduce(Ht, {}), f = h.slice(), m = Object.create(null);
                            for(r = 0, a = 0; r < h.length; r++)_.hasOwnProperty(n = h[r]) ? a++ : (o.push({
                                command: Zt.removeLayer,
                                args: [
                                    n
                                ]
                            }), f.splice(f.indexOf(n, a), 1));
                            for(r = 0, a = 0; r < p.length; r++)f[f.length - 1 - r] !== (n = p[p.length - 1 - r]) && (d.hasOwnProperty(n) ? (o.push({
                                command: Zt.removeLayer,
                                args: [
                                    n
                                ]
                            }), f.splice(f.lastIndexOf(n, f.length - a), 1)) : a++, o.push({
                                command: Zt.addLayer,
                                args: [
                                    _[n],
                                    c = f[f.length - r]
                                ]
                            }), f.splice(f.length - r, 0, n), m[n] = !0);
                            for(r = 0; r < p.length; r++)if (s = d[n = p[r]], l = _[n], !m[n] && !t1.deepEqual(s, l)) {
                                if (t1.deepEqual(s.source, l.source) && t1.deepEqual(s["source-layer"], l["source-layer"]) && t1.deepEqual(s.type, l.type)) {
                                    for(u in Wt(s.layout, l.layout, o, n, null, Zt.setLayoutProperty), Wt(s.paint, l.paint, o, n, null, Zt.setPaintProperty), t1.deepEqual(s.filter, l.filter) || o.push({
                                        command: Zt.setFilter,
                                        args: [
                                            n,
                                            l.filter
                                        ]
                                    }), t1.deepEqual(s.minzoom, l.minzoom) && t1.deepEqual(s.maxzoom, l.maxzoom) || o.push({
                                        command: Zt.setLayerZoomRange,
                                        args: [
                                            n,
                                            l.minzoom,
                                            l.maxzoom
                                        ]
                                    }), s)s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Wt(s[u], l[u], o, n, u.slice(6), Zt.setPaintProperty) : t1.deepEqual(s[u], l[u]) || o.push({
                                        command: Zt.setLayerProperty,
                                        args: [
                                            n,
                                            u,
                                            l[u]
                                        ]
                                    }));
                                    for(u in l)l.hasOwnProperty(u) && !s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Wt(s[u], l[u], o, n, u.slice(6), Zt.setPaintProperty) : t1.deepEqual(s[u], l[u]) || o.push({
                                        command: Zt.setLayerProperty,
                                        args: [
                                            n,
                                            u,
                                            l[u]
                                        ]
                                    }));
                                } else o.push({
                                    command: Zt.removeLayer,
                                    args: [
                                        n
                                    ]
                                }), c = f[f.lastIndexOf(n) + 1], o.push({
                                    command: Zt.addLayer,
                                    args: [
                                        l,
                                        c
                                    ]
                                });
                            }
                        }(n, i.layers, o);
                    } catch (t1) {
                        console.warn("Unable to compute style diff:", t1), o = [
                            {
                                command: Zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), e1).filter(function(t1) {
                    return !(t1.command in Ze);
                });
                if (0 === o.length) return !1;
                var r = o.filter(function(t1) {
                    return !(t1.command in Ne);
                });
                if (r.length > 0) throw new Error("Unimplemented: " + r.map(function(t1) {
                    return t1.command;
                }).join(", ") + ".");
                return o.forEach(function(t1) {
                    "setTransition" !== t1.command && i[t1.command].apply(i, t1.args);
                }), this.stylesheet = e1, !0;
            }, i.prototype.addImage = function(e1, i) {
                if (this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("An image with this name already exists.")));
                this.imageManager.addImage(e1, i), this._afterImageUpdated(e1);
            }, i.prototype.updateImage = function(t1, e1) {
                this.imageManager.updateImage(t1, e1);
            }, i.prototype.getImage = function(t1) {
                return this.imageManager.getImage(t1);
            }, i.prototype.removeImage = function(e1) {
                if (!this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("No image with this name exists.")));
                this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
            }, i.prototype._afterImageUpdated = function(e1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                    dataType: "style"
                }));
            }, i.prototype.listImages = function() {
                return this._checkLoaded(), this.imageManager.listImages();
            }, i.prototype.addSource = function(e1, i, o) {
                var r = this;
                if (void 0 === o && (o = {}), this._checkLoaded(), void 0 !== this.sourceCaches[e1]) throw new Error("There is already a source with this ID");
                if (!i.type) throw new Error("The type property must be defined, but only the following properties were given: " + Object.keys(i).join(", ") + ".");
                if (!([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t1.validateStyle.source, "sources." + e1, i, null, o))) {
                    this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                    var a = this.sourceCaches[e1] = new Dt(e1, i, this.dispatcher);
                    a.style = this, a.setEventedParent(this, function() {
                        return {
                            isSourceLoaded: r.loaded(),
                            source: a.serialize(),
                            sourceId: e1
                        };
                    }), a.onAdd(this.map), this._changed = !0;
                }
            }, i.prototype.removeSource = function(e1) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e1]) throw new Error("There is no source with this ID");
                for(var i in this._layers)if (this._layers[i].source === e1) return this.fire(new t1.ErrorEvent(new Error('Source "' + e1 + '" cannot be removed while layer "' + i + '" is using it.')));
                var o = this.sourceCaches[e1];
                delete this.sourceCaches[e1], delete this._updatedSources[e1], o.fire(new t1.Event("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e1
                })), o.setEventedParent(null), o.clearTiles(), o.onRemove && o.onRemove(this.map), this._changed = !0;
            }, i.prototype.setGeoJSONSourceData = function(t1, e1) {
                this._checkLoaded(), this.sourceCaches[t1].getSource().setData(e1), this._changed = !0;
            }, i.prototype.getSource = function(t1) {
                return this.sourceCaches[t1] && this.sourceCaches[t1].getSource();
            }, i.prototype.addLayer = function(e1, i, o) {
                void 0 === o && (o = {}), this._checkLoaded();
                var r = e1.id;
                if (this.getLayer(r)) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + r + '" already exists on this map')));
                else {
                    var a;
                    if ("custom" === e1.type) {
                        if (Ue(this, t1.validateCustomStyleLayer(e1))) return;
                        a = t1.createStyleLayer(e1);
                    } else {
                        if ("object" == typeof e1.source && (this.addSource(r, e1.source), e1 = t1.clone$1(e1), e1 = t1.extend(e1, {
                            source: r
                        })), this._validate(t1.validateStyle.layer, "layers." + r, e1, {
                            arrayIndex: -1
                        }, o)) return;
                        a = t1.createStyleLayer(e1), this._validateLayer(a), a.setEventedParent(this, {
                            layer: {
                                id: r
                            }
                        }), this._serializedLayers[a.id] = a.serialize();
                    }
                    var n = i ? this._order.indexOf(i) : this._order.length;
                    if (i && -1 === n) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + i + '" does not exist on this map.')));
                    else {
                        if (this._order.splice(n, 0, r), this._layerOrderChanged = !0, this._layers[r] = a, this._removedLayers[r] && a.source && "custom" !== a.type) {
                            var s = this._removedLayers[r];
                            delete this._removedLayers[r], s.type !== a.type ? this._updatedSources[a.source] = "clear" : (this._updatedSources[a.source] = "reload", this.sourceCaches[a.source].pause());
                        }
                        this._updateLayer(a), a.onAdd && a.onAdd(this.map);
                    }
                }
            }, i.prototype.moveLayer = function(e1, i) {
                if (this._checkLoaded(), this._changed = !0, this._layers[e1]) {
                    if (e1 !== i) {
                        var o = this._order.indexOf(e1);
                        this._order.splice(o, 1);
                        var r = i ? this._order.indexOf(i) : this._order.length;
                        i && -1 === r ? this.fire(new t1.ErrorEvent(new Error('Layer with id "' + i + '" does not exist on this map.'))) : (this._order.splice(r, 0, e1), this._layerOrderChanged = !0);
                    }
                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be moved.")));
            }, i.prototype.removeLayer = function(e1) {
                this._checkLoaded();
                var i = this._layers[e1];
                if (i) {
                    i.setEventedParent(null);
                    var o = this._order.indexOf(e1);
                    this._order.splice(o, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = i, delete this._layers[e1], delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], i.onRemove && i.onRemove(this.map);
                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be removed.")));
            }, i.prototype.getLayer = function(t1) {
                return this._layers[t1];
            }, i.prototype.hasLayer = function(t1) {
                return t1 in this._layers;
            }, i.prototype.setLayerZoomRange = function(e1, i, o) {
                this._checkLoaded();
                var r = this.getLayer(e1);
                r ? r.minzoom === i && r.maxzoom === o || (null != i && (r.minzoom = i), null != o && (r.maxzoom = o), this._updateLayer(r)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot have zoom extent.")));
            }, i.prototype.setFilter = function(e1, i, o) {
                void 0 === o && (o = {}), this._checkLoaded();
                var r = this.getLayer(e1);
                if (r) {
                    if (!t1.deepEqual(r.filter, i)) return null == i ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(t1.validateStyle.filter, "layers." + r.id + ".filter", i, null, o) || (r.filter = t1.clone$1(i), this._updateLayer(r)));
                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be filtered.")));
            }, i.prototype.getFilter = function(e1) {
                return t1.clone$1(this.getLayer(e1).filter);
            }, i.prototype.setLayoutProperty = function(e1, i, o, r) {
                void 0 === r && (r = {}), this._checkLoaded();
                var a = this.getLayer(e1);
                a ? t1.deepEqual(a.getLayoutProperty(i), o) || (a.setLayoutProperty(i, o, r), this._updateLayer(a)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
            }, i.prototype.getLayoutProperty = function(e1, i) {
                var o = this.getLayer(e1);
                if (o) return o.getLayoutProperty(i);
                this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style.")));
            }, i.prototype.setPaintProperty = function(e1, i, o, r) {
                void 0 === r && (r = {}), this._checkLoaded();
                var a = this.getLayer(e1);
                a ? t1.deepEqual(a.getPaintProperty(i), o) || (a.setPaintProperty(i, o, r) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[e1] = !0) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
            }, i.prototype.getPaintProperty = function(t1, e1) {
                return this.getLayer(t1).getPaintProperty(e1);
            }, i.prototype.setFeatureState = function(e1, i) {
                this._checkLoaded();
                var o = e1.source, r = e1.sourceLayer, a = this.sourceCaches[o];
                if (void 0 !== a) {
                    var n = a.getSource().type;
                    "geojson" === n && r ? this.fire(new t1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== n || r ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), a.setFeatureState(r, e1.id, i)) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new t1.ErrorEvent(new Error("The source '" + o + "' does not exist in the map's style.")));
            }, i.prototype.removeFeatureState = function(e1, i) {
                this._checkLoaded();
                var o = e1.source, r = this.sourceCaches[o];
                if (void 0 !== r) {
                    var a = r.getSource().type, n = "vector" === a ? e1.sourceLayer : void 0;
                    "vector" !== a || n ? i && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t1.ErrorEvent(new Error("A feature id is required to remove its specific state property."))) : r.removeFeatureState(n, e1.id, i) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new t1.ErrorEvent(new Error("The source '" + o + "' does not exist in the map's style.")));
            }, i.prototype.getFeatureState = function(e1) {
                this._checkLoaded();
                var i = e1.source, o = e1.sourceLayer, r = this.sourceCaches[i];
                if (void 0 !== r) {
                    if ("vector" !== r.getSource().type || o) return void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), r.getFeatureState(o, e1.id);
                    this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                } else this.fire(new t1.ErrorEvent(new Error("The source '" + i + "' does not exist in the map's style.")));
            }, i.prototype.getTransition = function() {
                return t1.extend({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }, i.prototype.serialize = function() {
                return t1.filterObject({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    light: this.stylesheet.light,
                    center: this.stylesheet.center,
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    sources: t1.mapObject(this.sourceCaches, function(t1) {
                        return t1.serialize();
                    }),
                    layers: this._serializeLayers(this._order)
                }, function(t1) {
                    return void 0 !== t1;
                });
            }, i.prototype._updateLayer = function(t1) {
                this._updatedLayers[t1.id] = !0, t1.source && !this._updatedSources[t1.source] && "raster" !== this.sourceCaches[t1.source].getSource().type && (this._updatedSources[t1.source] = "reload", this.sourceCaches[t1.source].pause()), this._changed = !0;
            }, i.prototype._flattenAndSortRenderedFeatures = function(t1) {
                for(var e1 = this, i = function(t1) {
                    return "fill-extrusion" === e1._layers[t1].type;
                }, o = {}, r = [], a = this._order.length - 1; a >= 0; a--){
                    var n = this._order[a];
                    if (i(n)) {
                        o[n] = a;
                        for(var s = 0, l = t1; s < l.length; s += 1){
                            var c = l[s][n];
                            if (c) for(var u = 0, h = c; u < h.length; u += 1)r.push(h[u]);
                        }
                    }
                }
                r.sort(function(t1, e1) {
                    return e1.intersectionZ - t1.intersectionZ;
                });
                for(var p = [], d = this._order.length - 1; d >= 0; d--){
                    var _ = this._order[d];
                    if (i(_)) for(var f = r.length - 1; f >= 0; f--){
                        var m = r[f].feature;
                        if (o[m.layer.id] < d) break;
                        p.push(m), r.pop();
                    }
                    else for(var g = 0, v = t1; g < v.length; g += 1){
                        var y = v[g][_];
                        if (y) for(var x = 0, b = y; x < b.length; x += 1)p.push(b[x].feature);
                    }
                }
                return p;
            }, i.prototype.queryRenderedFeatures = function(e1, i, o) {
                i && i.filter && this._validate(t1.validateStyle.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                var r = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new t1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                    for(var a = 0, n = i.layers; a < n.length; a += 1){
                        var s = n[a], l = this._layers[s];
                        if (!l) return this.fire(new t1.ErrorEvent(new Error("The layer '" + s + "' does not exist in the map's style and cannot be queried for features."))), [];
                        r[l.source] = !0;
                    }
                }
                var c = [];
                for(var u in i.availableImages = this._availableImages, this.sourceCaches)i.layers && !r[u] || c.push(O(this.sourceCaches[u], this._layers, this._serializedLayers, e1, i, o));
                return this.placement && c.push(function(t1, e1, i, o, r, a, n) {
                    for(var s = {}, l = a.queryRenderedSymbols(o), c = [], u = 0, h = Object.keys(l).map(Number); u < h.length; u += 1)c.push(n[h[u]]);
                    c.sort(F);
                    for(var p = function() {
                        var i = _[d], o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], e1, i.bucketIndex, i.sourceLayerIndex, r.filter, r.layers, r.availableImages, t1);
                        for(var a in o){
                            var n = s[a] = s[a] || [], c = o[a];
                            c.sort(function(t1, e1) {
                                var o = i.featureSortOrder;
                                if (o) {
                                    var r = o.indexOf(t1.featureIndex);
                                    return o.indexOf(e1.featureIndex) - r;
                                }
                                return e1.featureIndex - t1.featureIndex;
                            });
                            for(var u = 0, h = c; u < h.length; u += 1)n.push(h[u]);
                        }
                    }, d = 0, _ = c; d < _.length; d += 1)p();
                    var f = function(e1) {
                        s[e1].forEach(function(o) {
                            var r = o.feature, a = i[t1[e1].source].getFeatureState(r.layer["source-layer"], r.id);
                            r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = a;
                        });
                    };
                    for(var m in s)f(m);
                    return s;
                }(this._layers, this._serializedLayers, this.sourceCaches, e1, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(c);
            }, i.prototype.querySourceFeatures = function(e1, i) {
                i && i.filter && this._validate(t1.validateStyle.filter, "querySourceFeatures.filter", i.filter, null, i);
                var o = this.sourceCaches[e1];
                return o ? function(t1, e1) {
                    for(var i = t1.getRenderableIds().map(function(e1) {
                        return t1.getTileByID(e1);
                    }), o = [], r = {}, a = 0; a < i.length; a++){
                        var n = i[a], s = n.tileID.canonical.key;
                        r[s] || (r[s] = !0, n.querySourceFeatures(o, e1));
                    }
                    return o;
                }(o, i) : [];
            }, i.prototype.addSourceType = function(t1, e1, o) {
                return i.getSourceType(t1) ? o(new Error('A source type called "' + t1 + '" already exists.')) : (i.setSourceType(t1, e1), e1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: t1,
                    url: e1.workerSourceURL
                }, o) : o(null, null));
            }, i.prototype.getLight = function() {
                return this.light.getLight();
            }, i.prototype.setLight = function(e1, i) {
                void 0 === i && (i = {}), this._checkLoaded();
                var o = this.light.getLight(), r = !1;
                for(var a in e1)if (!t1.deepEqual(e1[a], o[a])) {
                    r = !0;
                    break;
                }
                if (r) {
                    var n = {
                        now: t1.browser.now(),
                        transition: t1.extend({
                            duration: 300,
                            delay: 0
                        }, this.stylesheet.transition)
                    };
                    this.light.setLight(e1, i), this.light.updateTransitions(n);
                }
            }, i.prototype._validate = function(e1, i, o, r, a) {
                return void 0 === a && (a = {}), (!a || !1 !== a.validate) && Ue(this, e1.call(t1.validateStyle, t1.extend({
                    key: i,
                    style: this.serialize(),
                    value: o,
                    styleSpec: t1.styleSpec
                }, r)));
            }, i.prototype._remove = function() {
                for(var e1 in this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t1.evented.off("pluginStateChange", this._rtlTextPluginCallback), this._layers)this._layers[e1].setEventedParent(null);
                for(var i in this.sourceCaches)this.sourceCaches[i].clearTiles(), this.sourceCaches[i].setEventedParent(null);
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
            }, i.prototype._clearSource = function(t1) {
                this.sourceCaches[t1].clearTiles();
            }, i.prototype._reloadSource = function(t1) {
                this.sourceCaches[t1].resume(), this.sourceCaches[t1].reload();
            }, i.prototype._updateSources = function(t1) {
                for(var e1 in this.sourceCaches)this.sourceCaches[e1].update(t1);
            }, i.prototype._generateCollisionBoxes = function() {
                for(var t1 in this.sourceCaches)this._reloadSource(t1);
            }, i.prototype._updatePlacement = function(e1, i, o, r, a) {
                void 0 === a && (a = !1);
                for(var n = !1, s = !1, l = {}, c = 0, u = this._order; c < u.length; c += 1){
                    var h = this._layers[u[c]];
                    if ("symbol" === h.type) {
                        if (!l[h.source]) {
                            var p = this.sourceCaches[h.source];
                            l[h.source] = p.getRenderableIds(!0).map(function(t1) {
                                return p.getTileByID(t1);
                            }).sort(function(t1, e1) {
                                return e1.tileID.overscaledZ - t1.tileID.overscaledZ || (t1.tileID.isLessThan(e1.tileID) ? -1 : 1);
                            });
                        }
                        var d = this.crossTileSymbolIndex.addLayer(h, l[h.source], e1.center.lng);
                        n = n || d;
                    }
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((a = a || this._layerOrderChanged || 0 === o) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t1.browser.now(), e1.zoom)) && (this.pauseablePlacement = new Le(e1, this._order, a, i, o, r, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t1.browser.now()), s = !0), n && this.pauseablePlacement.placement.setStale()), s || n) for(var _ = 0, f = this._order; _ < f.length; _ += 1){
                    var m = this._layers[f[_]];
                    "symbol" === m.type && this.placement.updateLayerOpacities(m, l[m.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t1.browser.now());
            }, i.prototype._releaseSymbolFadeTiles = function() {
                for(var t1 in this.sourceCaches)this.sourceCaches[t1].releaseSymbolFadeTiles();
            }, i.prototype.getImages = function(t1, e1, i) {
                this.imageManager.getImages(e1.icons, i), this._updateTilesForChangedImages();
                var o = this.sourceCaches[e1.source];
                o && o.setDependencies(e1.tileID.key, e1.type, e1.icons);
            }, i.prototype.getGlyphs = function(t1, e1, i) {
                this.glyphManager.getGlyphs(e1.stacks, i);
            }, i.prototype.getResource = function(e1, i, o) {
                return t1.makeRequest(i, o);
            }, i;
        }(t1.Evented);
        je.getSourceType = function(t1) {
            return k[t1];
        }, je.setSourceType = function(t1, e1) {
            k[t1] = e1;
        }, je.registerForPluginStateChange = t1.registerForPluginStateChange;
        var Ve = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]), Ge = gi("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"), We = gi("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), Xe = gi("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"), He = gi("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"), Ke = gi("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), Ye = gi("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"), Je = gi("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"), Qe = gi("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"), $e = gi("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), ti = gi("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}"), ei = gi("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"), ii = gi("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), oi = gi("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), ri = gi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"), ai = gi("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"), ni = gi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"), si = gi("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), li = gi("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"), ci = gi("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), ui = gi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), hi = gi("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"), pi = gi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"), di = gi("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"), _i = gi("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"), fi = gi("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"), mi = gi("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");
        function gi(t1, e1) {
            var i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, o = e1.match(/attribute ([\w]+) ([\w]+)/g), r = t1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), n = a ? a.concat(r) : r, s = {};
            return {
                fragmentSource: t1 = t1.replace(i, function(t1, e1, i, o, r) {
                    return s[r] = !0, "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + r + "\nvarying " + i + " " + o + " " + r + ";\n#else\nuniform " + i + " " + o + " u_" + r + ";\n#endif\n" : "\n#ifdef HAS_UNIFORM_u_" + r + "\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n";
                }),
                vertexSource: e1 = e1.replace(i, function(t1, e1, i, o, r) {
                    var a = "float" === o ? "vec2" : "vec4", n = r.match(/color/) ? "color" : a;
                    return s[r] ? "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + r + "\nuniform lowp float u_" + r + "_t;\nattribute " + i + " " + a + " a_" + r + ";\nvarying " + i + " " + o + " " + r + ";\n#else\nuniform " + i + " " + o + " u_" + r + ";\n#endif\n" : "vec4" === n ? "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + r + " = a_" + r + ";\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + r + " = unpack_mix_" + n + "(a_" + r + ", u_" + r + "_t);\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n" : "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + r + "\nuniform lowp float u_" + r + "_t;\nattribute " + i + " " + a + " a_" + r + ";\n#else\nuniform " + i + " " + o + " u_" + r + ";\n#endif\n" : "vec4" === n ? "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + i + " " + o + " " + r + " = a_" + r + ";\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + r + "\n    " + i + " " + o + " " + r + " = unpack_mix_" + n + "(a_" + r + ", u_" + r + "_t);\n#else\n    " + i + " " + o + " " + r + " = u_" + r + ";\n#endif\n";
                }),
                staticAttributes: o,
                staticUniforms: n
            };
        }
        var vi = Object.freeze({
            __proto__: null,
            prelude: Ge,
            background: We,
            backgroundPattern: Xe,
            circle: He,
            clippingMask: Ke,
            heatmap: Ye,
            heatmapTexture: Je,
            collisionBox: Qe,
            collisionCircle: $e,
            debug: ti,
            fill: ei,
            fillOutline: ii,
            fillOutlinePattern: oi,
            fillPattern: ri,
            fillExtrusion: ai,
            fillExtrusionPattern: ni,
            hillshadePrepare: si,
            hillshade: li,
            line: ci,
            lineGradient: ui,
            linePattern: hi,
            lineSDF: pi,
            raster: di,
            symbolIcon: _i,
            symbolSDF: fi,
            symbolTextAndIcon: mi
        }), yi = function() {
            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
        };
        function xi(t1) {
            for(var e1 = [], i = 0; i < t1.length; i++)if (null !== t1[i]) {
                var o = t1[i].split(" ");
                e1.push(o.pop());
            }
            return e1;
        }
        yi.prototype.bind = function(t1, e1, i, o, r, a, n, s) {
            this.context = t1;
            for(var l = this.boundPaintVertexBuffers.length !== o.length, c = 0; !l && c < o.length; c++)this.boundPaintVertexBuffers[c] !== o[c] && (l = !0);
            t1.extVertexArrayObject && this.vao && this.boundProgram === e1 && this.boundLayoutVertexBuffer === i && !l && this.boundIndexBuffer === r && this.boundVertexOffset === a && this.boundDynamicVertexBuffer === n && this.boundDynamicVertexBuffer2 === s ? (t1.bindVertexArrayOES.set(this.vao), n && n.bind(), r && r.dynamicDraw && r.bind(), s && s.bind()) : this.freshBind(e1, i, o, r, a, n, s);
        }, yi.prototype.freshBind = function(t1, e1, i, o, r, a, n) {
            var s, l = t1.numAttributes, c = this.context, u = c.gl;
            if (c.extVertexArrayObject) this.vao && this.destroy(), this.vao = c.extVertexArrayObject.createVertexArrayOES(), c.bindVertexArrayOES.set(this.vao), s = 0, this.boundProgram = t1, this.boundLayoutVertexBuffer = e1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = r, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = n;
            else {
                s = c.currentNumAttributes || 0;
                for(var h = l; h < s; h++)u.disableVertexAttribArray(h);
            }
            e1.enableAttributes(u, t1);
            for(var p = 0, d = i; p < d.length; p += 1)d[p].enableAttributes(u, t1);
            a && a.enableAttributes(u, t1), n && n.enableAttributes(u, t1), e1.bind(), e1.setVertexAttribPointers(u, t1, r);
            for(var _ = 0, f = i; _ < f.length; _ += 1){
                var m = f[_];
                m.bind(), m.setVertexAttribPointers(u, t1, r);
            }
            a && (a.bind(), a.setVertexAttribPointers(u, t1, r)), o && o.bind(), n && (n.bind(), n.setVertexAttribPointers(u, t1, r)), c.currentNumAttributes = l;
        }, yi.prototype.destroy = function() {
            this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
        };
        var bi = function(t1, e1, i, o, r, a) {
            var n = t1.gl;
            this.program = n.createProgram();
            for(var s = xi(i.staticAttributes), l = o ? o.getBinderAttributes() : [], c = s.concat(l), u = i.staticUniforms ? xi(i.staticUniforms) : [], h = o ? o.getBinderUniforms() : [], p = [], d = 0, _ = u.concat(h); d < _.length; d += 1){
                var f = _[d];
                p.indexOf(f) < 0 && p.push(f);
            }
            var m = o ? o.defines() : [];
            a && m.push("#define OVERDRAW_INSPECTOR;");
            var g = m.concat(Ge.fragmentSource, i.fragmentSource).join("\n"), v = m.concat(Ge.vertexSource, i.vertexSource).join("\n"), y = n.createShader(n.FRAGMENT_SHADER);
            if (n.isContextLost()) this.failedToCreate = !0;
            else {
                n.shaderSource(y, g), n.compileShader(y), n.attachShader(this.program, y);
                var x = n.createShader(n.VERTEX_SHADER);
                if (n.isContextLost()) this.failedToCreate = !0;
                else {
                    n.shaderSource(x, v), n.compileShader(x), n.attachShader(this.program, x), this.attributes = {};
                    var b = {};
                    this.numAttributes = c.length;
                    for(var w = 0; w < this.numAttributes; w++)c[w] && (n.bindAttribLocation(this.program, w, c[w]), this.attributes[c[w]] = w);
                    n.linkProgram(this.program), n.deleteShader(x), n.deleteShader(y);
                    for(var T = 0; T < p.length; T++){
                        var E = p[T];
                        if (E && !b[E]) {
                            var I = n.getUniformLocation(this.program, E);
                            I && (b[E] = I);
                        }
                    }
                    this.fixedUniforms = r(t1, b), this.binderUniforms = o ? o.getUniforms(t1, b) : [];
                }
            }
        };
        function wi(t1, e1, i) {
            var o = 1 / pe(i, 1, e1.transform.tileZoom), r = Math.pow(2, i.tileID.overscaledZ), a = i.tileSize * Math.pow(2, e1.transform.tileZoom) / r, n = a * (i.tileID.canonical.x + i.tileID.wrap * r), s = a * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    o,
                    t1.fromScale,
                    t1.toScale
                ],
                u_fade: t1.t,
                u_pixel_coord_upper: [
                    n >> 16,
                    s >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & s
                ]
            };
        }
        bi.prototype.draw = function(t1, e1, i, o, r, a, n, s, l, c, u, h, p, d, _, f) {
            var m, g = t1.gl;
            if (!this.failedToCreate) {
                for(var v in t1.program.set(this.program), t1.setDepthMode(i), t1.setStencilMode(o), t1.setColorMode(r), t1.setCullFace(a), this.fixedUniforms)this.fixedUniforms[v].set(n[v]);
                d && d.setUniforms(t1, this.binderUniforms, h, {
                    zoom: p
                });
                for(var y = (m = {}, m[g.LINES] = 2, m[g.TRIANGLES] = 3, m[g.LINE_STRIP] = 1, m)[e1], x = 0, b = u.get(); x < b.length; x += 1){
                    var w = b[x], T = w.vaos || (w.vaos = {});
                    (T[s] || (T[s] = new yi)).bind(t1, this, l, d ? d.getPaintVertexBuffers() : [], c, w.vertexOffset, _, f), g.drawElements(e1, w.primitiveLength * y, g.UNSIGNED_SHORT, w.primitiveOffset * y * 2);
                }
            }
        };
        var Ti = function(e1, i, o, r) {
            var a = i.style.light, n = a.properties.get("position"), s = [
                n.x,
                n.y,
                n.z
            ], l = t1.create$1();
            "viewport" === a.properties.get("anchor") && t1.fromRotation(l, -i.transform.angle), t1.transformMat3(s, s, l);
            var c = a.properties.get("color");
            return {
                u_matrix: e1,
                u_lightpos: s,
                u_lightintensity: a.properties.get("intensity"),
                u_lightcolor: [
                    c.r,
                    c.g,
                    c.b
                ],
                u_vertical_gradient: +o,
                u_opacity: r
            };
        }, Ei = function(e1, i, o, r, a, n, s) {
            return t1.extend(Ti(e1, i, o, r), wi(n, i, s), {
                u_height_factor: -Math.pow(2, a.overscaledZ) / s.tileSize / 8
            });
        }, Ii = function(t1) {
            return {
                u_matrix: t1
            };
        }, Pi = function(e1, i, o, r) {
            return t1.extend(Ii(e1), wi(o, i, r));
        }, Si = function(t1, e1) {
            return {
                u_matrix: t1,
                u_world: e1
            };
        }, Ci = function(e1, i, o, r, a) {
            return t1.extend(Pi(e1, i, o, r), {
                u_world: a
            });
        }, zi = function(e1, i, o, r) {
            var a, n, s = e1.transform;
            if ("map" === r.paint.get("circle-pitch-alignment")) {
                var l = pe(o, 1, s.zoom);
                a = !0, n = [
                    l,
                    l
                ];
            } else a = !1, n = s.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_scale_with_map: +("map" === r.paint.get("circle-pitch-scale")),
                u_matrix: e1.translatePosMatrix(i.posMatrix, o, r.paint.get("circle-translate"), r.paint.get("circle-translate-anchor")),
                u_pitch_with_map: +a,
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_extrude_scale: n
            };
        }, Di = function(t1, e1, i) {
            var o = pe(i, 1, e1.zoom), r = Math.pow(2, e1.zoom - i.tileID.overscaledZ), a = i.tileID.overscaleFactor();
            return {
                u_matrix: t1,
                u_camera_to_center_distance: e1.cameraToCenterDistance,
                u_pixels_to_tile_units: o,
                u_extrude_scale: [
                    e1.pixelsToGLUnits[0] / (o * r),
                    e1.pixelsToGLUnits[1] / (o * r)
                ],
                u_overscale_factor: a
            };
        }, Ai = function(t1, e1, i) {
            return {
                u_matrix: t1,
                u_inv_matrix: e1,
                u_camera_to_center_distance: i.cameraToCenterDistance,
                u_viewport_size: [
                    i.width,
                    i.height
                ]
            };
        }, Mi = function(t1, e1, i) {
            return void 0 === i && (i = 1), {
                u_matrix: t1,
                u_color: e1,
                u_overlay: 0,
                u_overlay_scale: i
            };
        }, Li = function(t1) {
            return {
                u_matrix: t1
            };
        }, Ri = function(t1, e1, i, o) {
            return {
                u_matrix: t1,
                u_extrude_scale: pe(e1, 1, i),
                u_intensity: o
            };
        }, ki = function(e1, i, o) {
            var r = e1.transform;
            return {
                u_matrix: Ni(e1, i, o),
                u_ratio: 1 / pe(i, 1, r.zoom),
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_units_to_pixels: [
                    1 / r.pixelsToGLUnits[0],
                    1 / r.pixelsToGLUnits[1]
                ]
            };
        }, Bi = function(e1, i, o, r) {
            return t1.extend(ki(e1, i, o), {
                u_image: 0,
                u_image_height: r
            });
        }, Oi = function(e1, i, o, r) {
            var a = e1.transform, n = Ui(i, a);
            return {
                u_matrix: Ni(e1, i, o),
                u_texsize: i.imageAtlasTexture.size,
                u_ratio: 1 / pe(i, 1, a.zoom),
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_image: 0,
                u_scale: [
                    n,
                    r.fromScale,
                    r.toScale
                ],
                u_fade: r.t,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ]
            };
        }, Fi = function(e1, i, o, r, a) {
            var n = e1.lineAtlas, s = Ui(i, e1.transform), l = "round" === o.layout.get("line-cap"), c = n.getDash(r.from, l), u = n.getDash(r.to, l), h = c.width * a.fromScale, p = u.width * a.toScale;
            return t1.extend(ki(e1, i, o), {
                u_patternscale_a: [
                    s / h,
                    -c.height / 2
                ],
                u_patternscale_b: [
                    s / p,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(h, p) * t1.browser.devicePixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: c.y,
                u_tex_y_b: u.y,
                u_mix: a.t
            });
        };
        function Ui(t1, e1) {
            return 1 / pe(t1, 1, e1.tileZoom);
        }
        function Ni(t1, e1, i) {
            return t1.translatePosMatrix(e1.tileID.posMatrix, e1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        var Zi = function(t1, e1, i, o, r) {
            var a, n;
            return {
                u_matrix: t1,
                u_tl_parent: e1,
                u_scale_parent: i,
                u_buffer_scale: 1,
                u_fade_t: o.mix,
                u_opacity: o.opacity * r.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: r.paint.get("raster-brightness-min"),
                u_brightness_high: r.paint.get("raster-brightness-max"),
                u_saturation_factor: (n = r.paint.get("raster-saturation"), n > 0 ? 1 - 1 / (1.001 - n) : -n),
                u_contrast_factor: (a = r.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
                u_spin_weights: qi(r.paint.get("raster-hue-rotate"))
            };
        };
        function qi(t1) {
            t1 *= Math.PI / 180;
            var e1 = Math.sin(t1), i = Math.cos(t1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * e1 - i + 1) / 3,
                (Math.sqrt(3) * e1 - i + 1) / 3
            ];
        }
        var ji, Vi = function(t1, e1, i, o, r, a, n, s, l, c) {
            var u = r.transform;
            return {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: e1 ? e1.uSizeT : 0,
                u_size: e1 ? e1.uSize : 0,
                u_camera_to_center_distance: u.cameraToCenterDistance,
                u_pitch: u.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: u.width / u.height,
                u_fade_change: r.options.fadeDuration ? r.symbolFadeChange : 1,
                u_matrix: a,
                u_label_plane_matrix: n,
                u_coord_matrix: s,
                u_is_text: +l,
                u_pitch_with_map: +o,
                u_texsize: c,
                u_texture: 0
            };
        }, Gi = function(e1, i, o, r, a, n, s, l, c, u, h) {
            var p = a.transform;
            return t1.extend(Vi(e1, i, o, r, a, n, s, l, c, u), {
                u_gamma_scale: r ? Math.cos(p._pitch) * p.cameraToCenterDistance : 1,
                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                u_is_halo: +h
            });
        }, Wi = function(e1, i, o, r, a, n, s, l, c, u) {
            return t1.extend(Gi(e1, i, o, r, a, n, s, l, !0, c, !0), {
                u_texsize_icon: u,
                u_texture_icon: 1
            });
        }, Xi = function(t1, e1, i) {
            return {
                u_matrix: t1,
                u_opacity: e1,
                u_color: i
            };
        }, Hi = function(e1, i, o, r, a, n) {
            return t1.extend(function(t1, e1, i, o) {
                var r = i.imageManager.getPattern(t1.from.toString()), a = i.imageManager.getPattern(t1.to.toString()), n = i.imageManager.getPixelSize(), s = n.width, l = n.height, c = Math.pow(2, o.tileID.overscaledZ), u = o.tileSize * Math.pow(2, i.transform.tileZoom) / c, h = u * (o.tileID.canonical.x + o.tileID.wrap * c), p = u * o.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: r.tl,
                    u_pattern_br_a: r.br,
                    u_pattern_tl_b: a.tl,
                    u_pattern_br_b: a.br,
                    u_texsize: [
                        s,
                        l
                    ],
                    u_mix: e1.t,
                    u_pattern_size_a: r.displaySize,
                    u_pattern_size_b: a.displaySize,
                    u_scale_a: e1.fromScale,
                    u_scale_b: e1.toScale,
                    u_tile_units_to_pixels: 1 / pe(o, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        h >> 16,
                        p >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & h,
                        65535 & p
                    ]
                };
            }(r, n, o, a), {
                u_matrix: e1,
                u_opacity: i
            });
        }, Ki = {
            fillExtrusion: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                };
            },
            fillExtrusionPattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_height_factor: new t1.Uniform1f(e1, i.u_height_factor),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                };
            },
            fill: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            fillPattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                };
            },
            fillOutline: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world)
                };
            },
            fillOutlinePattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                };
            },
            circle: function(e1, i) {
                return {
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_scale_with_map: new t1.Uniform1i(e1, i.u_scale_with_map),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            collisionBox: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pixels_to_tile_units: new t1.Uniform1f(e1, i.u_pixels_to_tile_units),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_overscale_factor: new t1.Uniform1f(e1, i.u_overscale_factor)
                };
            },
            collisionCircle: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_inv_matrix: new t1.UniformMatrix4f(e1, i.u_inv_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_viewport_size: new t1.Uniform2f(e1, i.u_viewport_size)
                };
            },
            debug: function(e1, i) {
                return {
                    u_color: new t1.UniformColor(e1, i.u_color),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_overlay: new t1.Uniform1i(e1, i.u_overlay),
                    u_overlay_scale: new t1.Uniform1f(e1, i.u_overlay_scale)
                };
            },
            clippingMask: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            heatmap: function(e1, i) {
                return {
                    u_extrude_scale: new t1.Uniform1f(e1, i.u_extrude_scale),
                    u_intensity: new t1.Uniform1f(e1, i.u_intensity),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                };
            },
            heatmapTexture: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_color_ramp: new t1.Uniform1i(e1, i.u_color_ramp),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                };
            },
            hillshade: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_latrange: new t1.Uniform2f(e1, i.u_latrange),
                    u_light: new t1.Uniform2f(e1, i.u_light),
                    u_shadow: new t1.UniformColor(e1, i.u_shadow),
                    u_highlight: new t1.UniformColor(e1, i.u_highlight),
                    u_accent: new t1.UniformColor(e1, i.u_accent)
                };
            },
            hillshadePrepare: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_dimension: new t1.Uniform2f(e1, i.u_dimension),
                    u_zoom: new t1.Uniform1f(e1, i.u_zoom),
                    u_unpack: new t1.Uniform4f(e1, i.u_unpack)
                };
            },
            line: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels)
                };
            },
            lineGradient: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_image_height: new t1.Uniform1f(e1, i.u_image_height)
                };
            },
            linePattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                };
            },
            lineSDF: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_patternscale_a: new t1.Uniform2f(e1, i.u_patternscale_a),
                    u_patternscale_b: new t1.Uniform2f(e1, i.u_patternscale_b),
                    u_sdfgamma: new t1.Uniform1f(e1, i.u_sdfgamma),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_tex_y_a: new t1.Uniform1f(e1, i.u_tex_y_a),
                    u_tex_y_b: new t1.Uniform1f(e1, i.u_tex_y_b),
                    u_mix: new t1.Uniform1f(e1, i.u_mix)
                };
            },
            raster: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_tl_parent: new t1.Uniform2f(e1, i.u_tl_parent),
                    u_scale_parent: new t1.Uniform1f(e1, i.u_scale_parent),
                    u_buffer_scale: new t1.Uniform1f(e1, i.u_buffer_scale),
                    u_fade_t: new t1.Uniform1f(e1, i.u_fade_t),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image0: new t1.Uniform1i(e1, i.u_image0),
                    u_image1: new t1.Uniform1i(e1, i.u_image1),
                    u_brightness_low: new t1.Uniform1f(e1, i.u_brightness_low),
                    u_brightness_high: new t1.Uniform1f(e1, i.u_brightness_high),
                    u_saturation_factor: new t1.Uniform1f(e1, i.u_saturation_factor),
                    u_contrast_factor: new t1.Uniform1f(e1, i.u_contrast_factor),
                    u_spin_weights: new t1.Uniform3f(e1, i.u_spin_weights)
                };
            },
            symbolIcon: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture)
                };
            },
            symbolSDF: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                };
            },
            symbolTextAndIcon: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texsize_icon: new t1.Uniform2f(e1, i.u_texsize_icon),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_texture_icon: new t1.Uniform1i(e1, i.u_texture_icon),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                };
            },
            background: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_color: new t1.UniformColor(e1, i.u_color)
                };
            },
            backgroundPattern: function(e1, i) {
                return {
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_pattern_tl_a: new t1.Uniform2f(e1, i.u_pattern_tl_a),
                    u_pattern_br_a: new t1.Uniform2f(e1, i.u_pattern_br_a),
                    u_pattern_tl_b: new t1.Uniform2f(e1, i.u_pattern_tl_b),
                    u_pattern_br_b: new t1.Uniform2f(e1, i.u_pattern_br_b),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_mix: new t1.Uniform1f(e1, i.u_mix),
                    u_pattern_size_a: new t1.Uniform2f(e1, i.u_pattern_size_a),
                    u_pattern_size_b: new t1.Uniform2f(e1, i.u_pattern_size_b),
                    u_scale_a: new t1.Uniform1f(e1, i.u_scale_a),
                    u_scale_b: new t1.Uniform1f(e1, i.u_scale_b),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t1.Uniform1f(e1, i.u_tile_units_to_pixels)
                };
            }
        };
        function Yi(e1, i, o, r, a, n, s) {
            for(var l = e1.context, c = l.gl, u = e1.useProgram("collisionBox"), h = [], p = 0, d = 0, _ = 0; _ < r.length; _++){
                var f = r[_], m = i.getTile(f), g = m.getBucket(o);
                if (g) {
                    var v = f.posMatrix;
                    0 === a[0] && 0 === a[1] || (v = e1.translatePosMatrix(f.posMatrix, m, a, n));
                    var y = s ? g.textCollisionBox : g.iconCollisionBox, x = g.collisionCircleArray;
                    if (x.length > 0) {
                        var b = t1.create(), w = v;
                        t1.mul(b, g.placementInvProjMatrix, e1.transform.glCoordMatrix), t1.mul(b, b, g.placementViewportMatrix), h.push({
                            circleArray: x,
                            circleOffset: d,
                            transform: w,
                            invTransform: b
                        }), d = p += x.length / 4;
                    }
                    y && u.draw(l, c.LINES, It.disabled, Pt.disabled, e1.colorModeForRenderPass(), Ct.disabled, Di(v, e1.transform, m), o.id, y.layoutVertexBuffer, y.indexBuffer, y.segments, null, e1.transform.zoom, null, null, y.collisionVertexBuffer);
                }
            }
            if (s && h.length) {
                var T = e1.useProgram("collisionCircle"), E = new t1.StructArrayLayout2f1f2i16;
                E.resize(4 * p), E._trim();
                for(var I = 0, P = 0, S = h; P < S.length; P += 1)for(var C = S[P], z = 0; z < C.circleArray.length / 4; z++){
                    var D = 4 * z, A = C.circleArray[D + 0], M = C.circleArray[D + 1], L = C.circleArray[D + 2], R = C.circleArray[D + 3];
                    E.emplace(I++, A, M, L, R, 0), E.emplace(I++, A, M, L, R, 1), E.emplace(I++, A, M, L, R, 2), E.emplace(I++, A, M, L, R, 3);
                }
                (!ji || ji.length < 2 * p) && (ji = function(e1) {
                    var i = 2 * e1, o = new t1.StructArrayLayout3ui6;
                    o.resize(i), o._trim();
                    for(var r = 0; r < i; r++){
                        var a = 6 * r;
                        o.uint16[a + 0] = 4 * r + 0, o.uint16[a + 1] = 4 * r + 1, o.uint16[a + 2] = 4 * r + 2, o.uint16[a + 3] = 4 * r + 2, o.uint16[a + 4] = 4 * r + 3, o.uint16[a + 5] = 4 * r + 0;
                    }
                    return o;
                }(p));
                for(var k = l.createIndexBuffer(ji, !0), B = l.createVertexBuffer(E, t1.collisionCircleLayout.members, !0), O = 0, F = h; O < F.length; O += 1){
                    var U = F[O], N = Ai(U.transform, U.invTransform, e1.transform);
                    T.draw(l, c.TRIANGLES, It.disabled, Pt.disabled, e1.colorModeForRenderPass(), Ct.disabled, N, o.id, B, k, t1.SegmentVector.simpleSegment(0, 2 * U.circleOffset, U.circleArray.length, U.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
                }
                B.destroy(), k.destroy();
            }
        }
        var Ji = t1.identity(new Float32Array(16));
        function Qi(e1, i, o, r, a, n) {
            var s = t1.getAnchorAlignment(e1), l = -(s.horizontalAlign - .5) * i, c = -(s.verticalAlign - .5) * o, u = t1.evaluateVariableOffset(e1, r);
            return new t1.Point((l / a + u[0]) * n, (c / a + u[1]) * n);
        }
        function $i(e1, i, o, r, a, n, s, l, c, u, h) {
            var p = e1.text.placedSymbolArray, d = e1.text.dynamicLayoutVertexArray, _ = e1.icon.dynamicLayoutVertexArray, f = {};
            d.clear();
            for(var m = 0; m < p.length; m++){
                var g = p.get(m), v = g.hidden || !g.crossTileID || e1.allowVerticalPlacement && !g.placedOrientation ? null : r[g.crossTileID];
                if (v) {
                    var y = new t1.Point(g.anchorX, g.anchorY), x = $t(y, o ? l : s), b = te(n.cameraToCenterDistance, x.signedDistanceFromCamera), w = a.evaluateSizeForFeature(e1.textSizeData, u, g) * b / t1.ONE_EM;
                    o && (w *= e1.tilePixelRatio / c);
                    for(var T = Qi(v.anchor, v.width, v.height, v.textOffset, v.textBoxScale, w), E = o ? $t(y.add(T), s).point : x.point.add(i ? T.rotate(-n.angle) : T), I = e1.allowVerticalPlacement && g.placedOrientation === t1.WritingMode.vertical ? Math.PI / 2 : 0, P = 0; P < g.numGlyphs; P++)t1.addDynamicAttributes(d, E, I);
                    h && g.associatedIconIndex >= 0 && (f[g.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: I
                    });
                } else ce(g.numGlyphs, d);
            }
            if (h) {
                _.clear();
                for(var S = e1.icon.placedSymbolArray, C = 0; C < S.length; C++){
                    var z = S.get(C);
                    if (z.hidden) ce(z.numGlyphs, _);
                    else {
                        var D = f[C];
                        if (D) for(var A = 0; A < z.numGlyphs; A++)t1.addDynamicAttributes(_, D.shiftedAnchor, D.angle);
                        else ce(z.numGlyphs, _);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(_);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(d);
        }
        function to(t1, e1, i) {
            return i.iconsInText && e1 ? "symbolTextAndIcon" : t1 ? "symbolSDF" : "symbolIcon";
        }
        function eo(e1, i, o, r, a, n, s, l, c, u, h, p) {
            for(var d = e1.context, _ = d.gl, f = e1.transform, m = "map" === l, g = "map" === c, v = m && "point" !== o.layout.get("symbol-placement"), y = m && !g && !v, x = void 0 !== o.layout.get("symbol-sort-key").constantOr(1), b = !1, w = e1.depthModeForSublayer(0, It.ReadOnly), T = o.layout.get("text-variable-anchor"), E = [], I = 0, P = r; I < P.length; I += 1){
                var S = P[I], C = i.getTile(S), z = C.getBucket(o);
                if (z) {
                    var D = a ? z.text : z.icon;
                    if (D && D.segments.get().length) {
                        var A = D.programConfigurations.get(o.id), M = a || z.sdfIcons, L = a ? z.textSizeData : z.iconSizeData, R = g || 0 !== f.pitch, k = e1.useProgram(to(M, a, z), A), B = t1.evaluateSizeForZoom(L, f.zoom), O = void 0, F = [
                            0,
                            0
                        ], U = void 0, N = void 0, Z = null, q = void 0;
                        if (a) U = C.glyphAtlasTexture, N = _.LINEAR, O = C.glyphAtlasTexture.size, z.iconsInText && (F = C.imageAtlasTexture.size, Z = C.imageAtlasTexture, q = R || e1.options.rotating || e1.options.zooming || "composite" === L.kind || "camera" === L.kind ? _.LINEAR : _.NEAREST);
                        else {
                            var j = 1 !== o.layout.get("icon-size").constantOr(0) || z.iconsNeedLinear;
                            U = C.imageAtlasTexture, N = M || e1.options.rotating || e1.options.zooming || j || R ? _.LINEAR : _.NEAREST, O = C.imageAtlasTexture.size;
                        }
                        var V = pe(C, 1, e1.transform.zoom), G = Jt(S.posMatrix, g, m, e1.transform, V), W = Qt(S.posMatrix, g, m, e1.transform, V), X = T && z.hasTextData(), H = "none" !== o.layout.get("icon-text-fit") && X && z.hasIconData();
                        v && ie(z, S.posMatrix, e1, a, G, W, g, u);
                        var K = e1.translatePosMatrix(S.posMatrix, C, n, s), Y = v || a && T || H ? Ji : G, J = e1.translatePosMatrix(W, C, n, s, !0), Q = M && 0 !== o.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1), $ = {
                            program: k,
                            buffers: D,
                            uniformValues: M ? z.iconsInText ? Wi(L.kind, B, y, g, e1, K, Y, J, O, F) : Gi(L.kind, B, y, g, e1, K, Y, J, a, O, !0) : Vi(L.kind, B, y, g, e1, K, Y, J, a, O),
                            atlasTexture: U,
                            atlasTextureIcon: Z,
                            atlasInterpolation: N,
                            atlasInterpolationIcon: q,
                            isSDF: M,
                            hasHalo: Q
                        };
                        if (x && z.canOverlap) {
                            b = !0;
                            for(var tt = 0, et = D.segments.get(); tt < et.length; tt += 1){
                                var it = et[tt];
                                E.push({
                                    segments: new t1.SegmentVector([
                                        it
                                    ]),
                                    sortKey: it.sortKey,
                                    state: $
                                });
                            }
                        } else E.push({
                            segments: D.segments,
                            sortKey: 0,
                            state: $
                        });
                    }
                }
            }
            b && E.sort(function(t1, e1) {
                return t1.sortKey - e1.sortKey;
            });
            for(var ot = 0, rt = E; ot < rt.length; ot += 1){
                var at = rt[ot], nt = at.state;
                if (d.activeTexture.set(_.TEXTURE0), nt.atlasTexture.bind(nt.atlasInterpolation, _.CLAMP_TO_EDGE), nt.atlasTextureIcon && (d.activeTexture.set(_.TEXTURE1), nt.atlasTextureIcon && nt.atlasTextureIcon.bind(nt.atlasInterpolationIcon, _.CLAMP_TO_EDGE)), nt.isSDF) {
                    var st = nt.uniformValues;
                    nt.hasHalo && (st.u_is_halo = 1, io(nt.buffers, at.segments, o, e1, nt.program, w, h, p, st)), st.u_is_halo = 0;
                }
                io(nt.buffers, at.segments, o, e1, nt.program, w, h, p, nt.uniformValues);
            }
        }
        function io(t1, e1, i, o, r, a, n, s, l) {
            var c = o.context;
            r.draw(c, c.gl.TRIANGLES, a, n, s, Ct.disabled, l, i.id, t1.layoutVertexBuffer, t1.indexBuffer, e1, i.paint, o.transform.zoom, t1.programConfigurations.get(i.id), t1.dynamicLayoutVertexBuffer, t1.opacityVertexBuffer);
        }
        function oo(t1, e1, i, o, r, a, n) {
            var s, l, c, u, h, p = t1.context.gl, d = i.paint.get("fill-pattern"), _ = d && d.constantOr(1), f = i.getCrossfadeParameters();
            n ? (l = _ && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", s = p.LINES) : (l = _ ? "fillPattern" : "fill", s = p.TRIANGLES);
            for(var m = 0, g = o; m < g.length; m += 1){
                var v = g[m], y = e1.getTile(v);
                if (!_ || y.patternsLoaded()) {
                    var x = y.getBucket(i);
                    if (x) {
                        var b = x.programConfigurations.get(i.id), w = t1.useProgram(l, b);
                        _ && (t1.context.activeTexture.set(p.TEXTURE0), y.imageAtlasTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE), b.updatePaintBuffers(f));
                        var T = d.constantOr(null);
                        if (T && y.imageAtlas) {
                            var E = y.imageAtlas, I = E.patternPositions[T.to.toString()], P = E.patternPositions[T.from.toString()];
                            I && P && b.setConstantPatternPositions(I, P);
                        }
                        var S = t1.translatePosMatrix(v.posMatrix, y, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                        if (n) {
                            u = x.indexBuffer2, h = x.segments2;
                            var C = [
                                p.drawingBufferWidth,
                                p.drawingBufferHeight
                            ];
                            c = "fillOutlinePattern" === l && _ ? Ci(S, t1, f, y, C) : Si(S, C);
                        } else u = x.indexBuffer, h = x.segments, c = _ ? Pi(S, t1, f, y) : Ii(S);
                        w.draw(t1.context, s, r, t1.stencilModeForClipping(v), a, Ct.disabled, c, i.id, x.layoutVertexBuffer, u, h, i.paint, t1.transform.zoom, b);
                    }
                }
            }
        }
        function ro(t1, e1, i, o, r, a, n) {
            for(var s = t1.context, l = s.gl, c = i.paint.get("fill-extrusion-pattern"), u = c.constantOr(1), h = i.getCrossfadeParameters(), p = i.paint.get("fill-extrusion-opacity"), d = 0, _ = o; d < _.length; d += 1){
                var f = _[d], m = e1.getTile(f), g = m.getBucket(i);
                if (g) {
                    var v = g.programConfigurations.get(i.id), y = t1.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", v);
                    u && (t1.context.activeTexture.set(l.TEXTURE0), m.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), v.updatePaintBuffers(h));
                    var x = c.constantOr(null);
                    if (x && m.imageAtlas) {
                        var b = m.imageAtlas, w = b.patternPositions[x.to.toString()], T = b.patternPositions[x.from.toString()];
                        w && T && v.setConstantPatternPositions(w, T);
                    }
                    var E = t1.translatePosMatrix(f.posMatrix, m, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), I = i.paint.get("fill-extrusion-vertical-gradient"), P = u ? Ei(E, t1, I, p, f, h, m) : Ti(E, t1, I, p);
                    y.draw(s, s.gl.TRIANGLES, r, a, n, Ct.backCCW, P, i.id, g.layoutVertexBuffer, g.indexBuffer, g.segments, i.paint, t1.transform.zoom, v);
                }
            }
        }
        function ao(e1, i, o, r, a, n) {
            var s = e1.context, l = s.gl, c = i.fbo;
            if (c) {
                var u = e1.useProgram("hillshade");
                s.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, c.colorAttachment.get());
                var h = function(e1, i, o) {
                    var r = o.paint.get("hillshade-shadow-color"), a = o.paint.get("hillshade-highlight-color"), n = o.paint.get("hillshade-accent-color"), s = o.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                    "viewport" === o.paint.get("hillshade-illumination-anchor") && (s -= e1.transform.angle);
                    var l, c, u, h = !e1.options.moving;
                    return {
                        u_matrix: e1.transform.calculatePosMatrix(i.tileID.toUnwrapped(), h),
                        u_image: 0,
                        u_latrange: (l = i.tileID, c = Math.pow(2, l.canonical.z), u = l.canonical.y, [
                            new t1.MercatorCoordinate(0, u / c).toLngLat().lat,
                            new t1.MercatorCoordinate(0, (u + 1) / c).toLngLat().lat
                        ]),
                        u_light: [
                            o.paint.get("hillshade-exaggeration"),
                            s
                        ],
                        u_shadow: r,
                        u_highlight: a,
                        u_accent: n
                    };
                }(e1, i, o);
                u.draw(s, l.TRIANGLES, r, a, n, Ct.disabled, h, o.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments);
            }
        }
        function no(e1, i, o, r, a, n) {
            var s = e1.context, l = s.gl, c = i.dem;
            if (c && c.data) {
                var u = c.dim, h = c.stride, p = c.getPixels();
                if (s.activeTexture.set(l.TEXTURE1), s.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || e1.getTileTexture(h), i.demTexture) {
                    var d = i.demTexture;
                    d.update(p, {
                        premultiply: !1
                    }), d.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                } else i.demTexture = new t1.Texture(s, p, l.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                s.activeTexture.set(l.TEXTURE0);
                var _ = i.fbo;
                if (!_) {
                    var f = new t1.Texture(s, {
                        width: u,
                        height: u,
                        data: null
                    }, l.RGBA);
                    f.bind(l.LINEAR, l.CLAMP_TO_EDGE), (_ = i.fbo = s.createFramebuffer(u, u, !0)).colorAttachment.set(f.texture);
                }
                s.bindFramebuffer.set(_.framebuffer), s.viewport.set([
                    0,
                    0,
                    u,
                    u
                ]), e1.useProgram("hillshadePrepare").draw(s, l.TRIANGLES, r, a, n, Ct.disabled, function(e1, i) {
                    var o = i.stride, r = t1.create();
                    return t1.ortho(r, 0, t1.EXTENT, -t1.EXTENT, 0, 0, 1), t1.translate(r, r, [
                        0,
                        -t1.EXTENT,
                        0
                    ]), {
                        u_matrix: r,
                        u_image: 1,
                        u_dimension: [
                            o,
                            o
                        ],
                        u_zoom: e1.overscaledZ,
                        u_unpack: i.getUnpackVector()
                    };
                }(i.tileID, c), o.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        }
        function so(e1, i, o, r, a) {
            var n = r.paint.get("raster-fade-duration");
            if (n > 0) {
                var s = t1.browser.now(), l = (s - e1.timeAdded) / n, c = i ? (s - i.timeAdded) / n : -1, u = o.getSource(), h = a.coveringZoomLevel({
                    tileSize: u.tileSize,
                    roundZoom: u.roundZoom
                }), p = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(e1.tileID.overscaledZ - h), d = p && e1.refreshedUponExpiration ? 1 : t1.clamp(p ? l : 1 - c, 0, 1);
                return e1.refreshedUponExpiration && l >= 1 && (e1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        var lo = new t1.Color(1, 0, 0, 1), co = new t1.Color(0, 1, 0, 1), uo = new t1.Color(0, 0, 1, 1), ho = new t1.Color(1, 0, 1, 1), po = new t1.Color(0, 1, 1, 1);
        function _o(t1, e1, i, o) {
            mo(t1, 0, e1 + i / 2, t1.transform.width, i, o);
        }
        function fo(t1, e1, i, o) {
            mo(t1, e1 - i / 2, 0, i, t1.transform.height, o);
        }
        function mo(e1, i, o, r, a, n) {
            var s = e1.context, l = s.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * t1.browser.devicePixelRatio, o * t1.browser.devicePixelRatio, r * t1.browser.devicePixelRatio, a * t1.browser.devicePixelRatio), s.clear({
                color: n
            }), l.disable(l.SCISSOR_TEST);
        }
        function go(e1, i, o) {
            var r = e1.context, a = r.gl, n = o.posMatrix, s = e1.useProgram("debug"), l = It.disabled, c = Pt.disabled, u = e1.colorModeForRenderPass();
            r.activeTexture.set(a.TEXTURE0), e1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.draw(r, a.LINE_STRIP, l, c, u, Ct.disabled, Mi(n, t1.Color.red), "$debug", e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
            var h = i.getTileByID(o.key).latestRawTileData, p = Math.floor((h && h.byteLength || 0) / 1024), d = i.getTile(o).tileSize, _ = 512 / Math.min(d, 512) * (o.overscaledZ / e1.transform.zoom) * .5, f = o.canonical.toString();
            o.overscaledZ !== o.canonical.z && (f += " => " + o.overscaledZ), function(t1, e1) {
                t1.initDebugOverlayCanvas();
                var i = t1.debugOverlayCanvas, o = t1.context.gl, r = t1.debugOverlayCanvas.getContext("2d");
                r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(e1, 5, 5), r.strokeText(e1, 5, 5), t1.debugOverlayTexture.update(i), t1.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }(e1, f + " " + p + "kb"), s.draw(r, a.TRIANGLES, l, c, St.alphaBlended, Ct.disabled, Mi(n, t1.Color.transparent, _), "$debug", e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments);
        }
        var vo = {
            symbol: function(e1, i, o, r, a) {
                if ("translucent" === e1.renderPass) {
                    var n = Pt.disabled, s = e1.colorModeForRenderPass();
                    o.layout.get("text-variable-anchor") && function(e1, i, o, r, a, n, s) {
                        for(var l = i.transform, c = "map" === a, u = "map" === n, h = 0, p = e1; h < p.length; h += 1){
                            var d = p[h], _ = r.getTile(d), f = _.getBucket(o);
                            if (f && f.text && f.text.segments.get().length) {
                                var m = t1.evaluateSizeForZoom(f.textSizeData, l.zoom), g = pe(_, 1, i.transform.zoom), v = Jt(d.posMatrix, u, c, i.transform, g), y = "none" !== o.layout.get("icon-text-fit") && f.hasIconData();
                                if (m) {
                                    var x = Math.pow(2, l.zoom - _.tileID.overscaledZ);
                                    $i(f, c, u, s, t1.symbolSize, l, v, d.posMatrix, x, m, y);
                                }
                            }
                        }
                    }(r, e1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), a), 0 !== o.paint.get("icon-opacity").constantOr(1) && eo(e1, i, o, r, !1, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), o.layout.get("icon-rotation-alignment"), o.layout.get("icon-pitch-alignment"), o.layout.get("icon-keep-upright"), n, s), 0 !== o.paint.get("text-opacity").constantOr(1) && eo(e1, i, o, r, !0, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), o.layout.get("text-keep-upright"), n, s), i.map.showCollisionBoxes && (Yi(e1, i, o, r, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), Yi(e1, i, o, r, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
                }
            },
            circle: function(e1, i, o, r) {
                if ("translucent" === e1.renderPass) {
                    var a = o.paint.get("circle-opacity"), n = o.paint.get("circle-stroke-width"), s = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1);
                    if (0 !== a.constantOr(1) || 0 !== n.constantOr(1) && 0 !== s.constantOr(1)) {
                        for(var c = e1.context, u = c.gl, h = e1.depthModeForSublayer(0, It.ReadOnly), p = Pt.disabled, d = e1.colorModeForRenderPass(), _ = [], f = 0; f < r.length; f++){
                            var m = r[f], g = i.getTile(m), v = g.getBucket(o);
                            if (v) {
                                var y = v.programConfigurations.get(o.id), x = {
                                    programConfiguration: y,
                                    program: e1.useProgram("circle", y),
                                    layoutVertexBuffer: v.layoutVertexBuffer,
                                    indexBuffer: v.indexBuffer,
                                    uniformValues: zi(e1, m, g, o)
                                };
                                if (l) for(var b = 0, w = v.segments.get(); b < w.length; b += 1){
                                    var T = w[b];
                                    _.push({
                                        segments: new t1.SegmentVector([
                                            T
                                        ]),
                                        sortKey: T.sortKey,
                                        state: x
                                    });
                                }
                                else _.push({
                                    segments: v.segments,
                                    sortKey: 0,
                                    state: x
                                });
                            }
                        }
                        l && _.sort(function(t1, e1) {
                            return t1.sortKey - e1.sortKey;
                        });
                        for(var E = 0, I = _; E < I.length; E += 1){
                            var P = I[E], S = P.state;
                            S.program.draw(c, u.TRIANGLES, h, p, d, Ct.disabled, S.uniformValues, o.id, S.layoutVertexBuffer, S.indexBuffer, P.segments, o.paint, e1.transform.zoom, S.programConfiguration);
                        }
                    }
                }
            },
            heatmap: function(e1, i, o, r) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === e1.renderPass) {
                        var a = e1.context, n = a.gl, s = Pt.disabled, l = new St([
                            n.ONE,
                            n.ONE
                        ], t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(t1, e1, i) {
                            var o = t1.gl;
                            t1.activeTexture.set(o.TEXTURE1), t1.viewport.set([
                                0,
                                0,
                                e1.width / 4,
                                e1.height / 4
                            ]);
                            var r = i.heatmapFbo;
                            if (r) o.bindTexture(o.TEXTURE_2D, r.colorAttachment.get()), t1.bindFramebuffer.set(r.framebuffer);
                            else {
                                var a = o.createTexture();
                                o.bindTexture(o.TEXTURE_2D, a), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR), r = i.heatmapFbo = t1.createFramebuffer(e1.width / 4, e1.height / 4, !1), function(t1, e1, i, o) {
                                    var r = t1.gl;
                                    r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, e1.width / 4, e1.height / 4, 0, r.RGBA, t1.extRenderToTextureHalfFloat ? t1.extTextureHalfFloat.HALF_FLOAT_OES : r.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(t1, e1, a, r);
                            }
                        }(a, e1, o), a.clear({
                            color: t1.Color.transparent
                        });
                        for(var c = 0; c < r.length; c++){
                            var u = r[c];
                            if (!i.hasRenderableParent(u)) {
                                var h = i.getTile(u), p = h.getBucket(o);
                                if (p) {
                                    var d = p.programConfigurations.get(o.id);
                                    e1.useProgram("heatmap", d).draw(a, n.TRIANGLES, It.disabled, s, l, Ct.disabled, Ri(u.posMatrix, h, e1.transform.zoom, o.paint.get("heatmap-intensity")), o.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, o.paint, e1.transform.zoom, d);
                                }
                            }
                        }
                        a.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, i) {
                        var o = e1.context, r = o.gl, a = i.heatmapFbo;
                        if (a) {
                            o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, a.colorAttachment.get()), o.activeTexture.set(r.TEXTURE1);
                            var n = i.colorRampTexture;
                            n || (n = i.colorRampTexture = new t1.Texture(o, i.colorRamp, r.RGBA)), n.bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(o, r.TRIANGLES, It.disabled, Pt.disabled, e1.colorModeForRenderPass(), Ct.disabled, function(e1, i, o, r) {
                                var a = t1.create();
                                t1.ortho(a, 0, e1.width, e1.height, 0, 0, 1);
                                var n = e1.context.gl;
                                return {
                                    u_matrix: a,
                                    u_world: [
                                        n.drawingBufferWidth,
                                        n.drawingBufferHeight
                                    ],
                                    u_image: 0,
                                    u_color_ramp: 1,
                                    u_opacity: i.paint.get("heatmap-opacity")
                                };
                            }(e1, i), i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom);
                        }
                    }(e1, o));
                }
            },
            line: function(e1, i, o, r) {
                if ("translucent" === e1.renderPass) {
                    var a = o.paint.get("line-opacity"), n = o.paint.get("line-width");
                    if (0 !== a.constantOr(1) && 0 !== n.constantOr(1)) for(var s = e1.depthModeForSublayer(0, It.ReadOnly), l = e1.colorModeForRenderPass(), c = o.paint.get("line-dasharray"), u = o.paint.get("line-pattern"), h = u.constantOr(1), p = o.paint.get("line-gradient"), d = o.getCrossfadeParameters(), _ = h ? "linePattern" : c ? "lineSDF" : p ? "lineGradient" : "line", f = e1.context, m = f.gl, g = !0, v = 0, y = r; v < y.length; v += 1){
                        var x = y[v], b = i.getTile(x);
                        if (!h || b.patternsLoaded()) {
                            var w = b.getBucket(o);
                            if (w) {
                                var T = w.programConfigurations.get(o.id), E = e1.context.program.get(), I = e1.useProgram(_, T), P = g || I.program !== E, S = u.constantOr(null);
                                if (S && b.imageAtlas) {
                                    var C = b.imageAtlas, z = C.patternPositions[S.to.toString()], D = C.patternPositions[S.from.toString()];
                                    z && D && T.setConstantPatternPositions(z, D);
                                }
                                var A = h ? Oi(e1, b, o, d) : c ? Fi(e1, b, o, c, d) : p ? Bi(e1, b, o, w.lineClipsArray.length) : ki(e1, b, o);
                                if (h) f.activeTexture.set(m.TEXTURE0), b.imageAtlasTexture.bind(m.LINEAR, m.CLAMP_TO_EDGE), T.updatePaintBuffers(d);
                                else if (c && (P || e1.lineAtlas.dirty)) f.activeTexture.set(m.TEXTURE0), e1.lineAtlas.bind(f);
                                else if (p) {
                                    var M = w.gradients[o.id], L = M.texture;
                                    if (o.gradientVersion !== M.version) {
                                        var R = 256;
                                        if (o.stepInterpolant) {
                                            var k = i.getSource().maxzoom, B = x.canonical.z === k ? Math.ceil(1 << e1.transform.maxZoom - x.canonical.z) : 1;
                                            R = t1.clamp(t1.nextPowerOfTwo(w.maxLineLength / t1.EXTENT * 1024 * B), 256, f.maxTextureSize);
                                        }
                                        M.gradient = t1.renderColorRamp({
                                            expression: o.gradientExpression(),
                                            evaluationKey: "lineProgress",
                                            resolution: R,
                                            image: M.gradient || void 0,
                                            clips: w.lineClipsArray
                                        }), M.texture ? M.texture.update(M.gradient) : M.texture = new t1.Texture(f, M.gradient, m.RGBA), M.version = o.gradientVersion, L = M.texture;
                                    }
                                    f.activeTexture.set(m.TEXTURE0), L.bind(o.stepInterpolant ? m.NEAREST : m.LINEAR, m.CLAMP_TO_EDGE);
                                }
                                I.draw(f, m.TRIANGLES, s, e1.stencilModeForClipping(x), l, Ct.disabled, A, o.id, w.layoutVertexBuffer, w.indexBuffer, w.segments, o.paint, e1.transform.zoom, T, w.layoutVertexBuffer2), g = !1;
                            }
                        }
                    }
                }
            },
            fill: function(e1, i, o, r) {
                var a = o.paint.get("fill-color"), n = o.paint.get("fill-opacity");
                if (0 !== n.constantOr(1)) {
                    var s = e1.colorModeForRenderPass(), l = o.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === a.constantOr(t1.Color.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                    if (e1.renderPass === c) {
                        var u = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? It.ReadWrite : It.ReadOnly);
                        oo(e1, i, o, r, u, s, !1);
                    }
                    if ("translucent" === e1.renderPass && o.paint.get("fill-antialias")) {
                        var h = e1.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, It.ReadOnly);
                        oo(e1, i, o, r, h, s, !0);
                    }
                }
            },
            "fill-extrusion": function(t1, e1, i, o) {
                var r = i.paint.get("fill-extrusion-opacity");
                if (0 !== r && "translucent" === t1.renderPass) {
                    var a = new It(t1.context.gl.LEQUAL, It.ReadWrite, t1.depthRangeFor3D);
                    if (1 !== r || i.paint.get("fill-extrusion-pattern").constantOr(1)) ro(t1, e1, i, o, a, Pt.disabled, St.disabled), ro(t1, e1, i, o, a, t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                    else {
                        var n = t1.colorModeForRenderPass();
                        ro(t1, e1, i, o, a, Pt.disabled, n);
                    }
                }
            },
            hillshade: function(t1, e1, i, o) {
                if ("offscreen" === t1.renderPass || "translucent" === t1.renderPass) {
                    for(var r = t1.context, a = t1.depthModeForSublayer(0, It.ReadOnly), n = t1.colorModeForRenderPass(), s = "translucent" === t1.renderPass ? t1.stencilConfigForOverlap(o) : [
                        {},
                        o
                    ], l = s[0], c = 0, u = s[1]; c < u.length; c += 1){
                        var h = u[c], p = e1.getTile(h);
                        p.needsHillshadePrepare && "offscreen" === t1.renderPass ? no(t1, p, i, a, Pt.disabled, n) : "translucent" === t1.renderPass && ao(t1, p, i, a, l[h.overscaledZ], n);
                    }
                    r.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }
            },
            raster: function(t1, e1, i, o) {
                if ("translucent" === t1.renderPass && 0 !== i.paint.get("raster-opacity") && o.length) for(var r = t1.context, a = r.gl, n = e1.getSource(), s = t1.useProgram("raster"), l = t1.colorModeForRenderPass(), c = n instanceof M ? [
                    {},
                    o
                ] : t1.stencilConfigForOverlap(o), u = c[0], h = c[1], p = h[h.length - 1].overscaledZ, d = !t1.options.moving, _ = 0, f = h; _ < f.length; _ += 1){
                    var m = f[_], g = t1.depthModeForSublayer(m.overscaledZ - p, 1 === i.paint.get("raster-opacity") ? It.ReadWrite : It.ReadOnly, a.LESS), v = e1.getTile(m), y = t1.transform.calculatePosMatrix(m.toUnwrapped(), d);
                    v.registerFadeDuration(i.paint.get("raster-fade-duration"));
                    var x = e1.findLoadedParent(m, 0), b = so(v, x, e1, i, t1.transform), w = void 0, T = void 0, E = "nearest" === i.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;
                    r.activeTexture.set(a.TEXTURE0), v.texture.bind(E, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), r.activeTexture.set(a.TEXTURE1), x ? (x.texture.bind(E, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), w = Math.pow(2, x.tileID.overscaledZ - v.tileID.overscaledZ), T = [
                        v.tileID.canonical.x * w % 1,
                        v.tileID.canonical.y * w % 1
                    ]) : v.texture.bind(E, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST);
                    var I = Zi(y, T || [
                        0,
                        0
                    ], w || 1, b, i);
                    n instanceof M ? s.draw(r, a.TRIANGLES, g, Pt.disabled, l, Ct.disabled, I, i.id, n.boundsBuffer, t1.quadTriangleIndexBuffer, n.boundsSegments) : s.draw(r, a.TRIANGLES, g, u[m.overscaledZ], l, Ct.disabled, I, i.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                }
            },
            background: function(t1, e1, i) {
                var o = i.paint.get("background-color"), r = i.paint.get("background-opacity");
                if (0 !== r) {
                    var a = t1.context, n = a.gl, s = t1.transform, l = s.tileSize, c = i.paint.get("background-pattern");
                    if (!t1.isPatternMissing(c)) {
                        var u = !c && 1 === o.a && 1 === r && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                        if (t1.renderPass === u) {
                            var h = Pt.disabled, p = t1.depthModeForSublayer(0, "opaque" === u ? It.ReadWrite : It.ReadOnly), d = t1.colorModeForRenderPass(), _ = t1.useProgram(c ? "backgroundPattern" : "background"), f = s.coveringTiles({
                                tileSize: l
                            });
                            c && (a.activeTexture.set(n.TEXTURE0), t1.imageManager.bind(t1.context));
                            for(var m = i.getCrossfadeParameters(), g = 0, v = f; g < v.length; g += 1){
                                var y = v[g], x = t1.transform.calculatePosMatrix(y.toUnwrapped()), b = c ? Hi(x, r, t1, c, {
                                    tileID: y,
                                    tileSize: l
                                }, m) : Xi(x, r, o);
                                _.draw(a, n.TRIANGLES, p, h, d, Ct.disabled, b, i.id, t1.tileExtentBuffer, t1.quadTriangleIndexBuffer, t1.tileExtentSegments);
                            }
                        }
                    }
                }
            },
            debug: function(t1, e1, i) {
                for(var o = 0; o < i.length; o++)go(t1, e1, i[o]);
            },
            custom: function(t1, e1, i) {
                var o = t1.context, r = i.implementation;
                if ("offscreen" === t1.renderPass) {
                    var a = r.prerender;
                    a && (t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), a.call(r, o.gl, t1.transform.customLayerMatrix()), o.setDirty(), t1.setBaseState());
                } else if ("translucent" === t1.renderPass) {
                    t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), o.setStencilMode(Pt.disabled);
                    var n = "3d" === r.renderingMode ? new It(t1.context.gl.LEQUAL, It.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, It.ReadOnly);
                    o.setDepthMode(n), r.render(o.gl, t1.transform.customLayerMatrix()), o.setDirty(), t1.setBaseState(), o.bindFramebuffer.set(null);
                }
            }
        }, yo = function(t1, e1) {
            this.context = new zt(t1), this.transform = e1, this._tileTextures = {}, this.setup(), this.numSublayers = Dt.maxUnderzooming + Dt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Fe, this.gpuTimers = {};
        };
        yo.prototype.resize = function(e1, i) {
            if (this.width = e1 * t1.browser.devicePixelRatio, this.height = i * t1.browser.devicePixelRatio, this.context.viewport.set([
                0,
                0,
                this.width,
                this.height
            ]), this.style) for(var o = 0, r = this.style._order; o < r.length; o += 1)this.style._layers[r[o]].resize();
        }, yo.prototype.setup = function() {
            var e1 = this.context, i = new t1.StructArrayLayout2i4;
            i.emplaceBack(0, 0), i.emplaceBack(t1.EXTENT, 0), i.emplaceBack(0, t1.EXTENT), i.emplaceBack(t1.EXTENT, t1.EXTENT), this.tileExtentBuffer = e1.createVertexBuffer(i, Ve.members), this.tileExtentSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
            var o = new t1.StructArrayLayout2i4;
            o.emplaceBack(0, 0), o.emplaceBack(t1.EXTENT, 0), o.emplaceBack(0, t1.EXTENT), o.emplaceBack(t1.EXTENT, t1.EXTENT), this.debugBuffer = e1.createVertexBuffer(o, Ve.members), this.debugSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 5);
            var r = new t1.StructArrayLayout4i8;
            r.emplaceBack(0, 0, 0, 0), r.emplaceBack(t1.EXTENT, 0, t1.EXTENT, 0), r.emplaceBack(0, t1.EXTENT, 0, t1.EXTENT), r.emplaceBack(t1.EXTENT, t1.EXTENT, t1.EXTENT, t1.EXTENT), this.rasterBoundsBuffer = e1.createVertexBuffer(r, A.members), this.rasterBoundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
            var a = new t1.StructArrayLayout2i4;
            a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(a, Ve.members), this.viewportSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
            var n = new t1.StructArrayLayout1ui2;
            n.emplaceBack(0), n.emplaceBack(1), n.emplaceBack(3), n.emplaceBack(2), n.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(n);
            var s = new t1.StructArrayLayout3ui6;
            s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s), this.emptyTexture = new t1.Texture(e1, {
                width: 1,
                height: 1,
                data: new Uint8Array([
                    0,
                    0,
                    0,
                    0
                ])
            }, e1.gl.RGBA);
            var l = this.context.gl;
            this.stencilClearMode = new Pt({
                func: l.ALWAYS,
                mask: 0
            }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
        }, yo.prototype.clearStencil = function() {
            var e1 = this.context, i = e1.gl;
            this.nextStencilID = 1, this.currentStencilSource = void 0;
            var o = t1.create();
            t1.ortho(o, 0, this.width, this.height, 0, 0, 1), t1.scale(o, o, [
                i.drawingBufferWidth,
                i.drawingBufferHeight,
                0
            ]), this.useProgram("clippingMask").draw(e1, i.TRIANGLES, It.disabled, this.stencilClearMode, St.disabled, Ct.disabled, Li(o), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
        }, yo.prototype._renderTileClippingMasks = function(t1, e1) {
            if (this.currentStencilSource !== t1.source && t1.isTileClipped() && e1 && e1.length) {
                this.currentStencilSource = t1.source;
                var i = this.context, o = i.gl;
                this.nextStencilID + e1.length > 256 && this.clearStencil(), i.setColorMode(St.disabled), i.setDepthMode(It.disabled);
                var r = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for(var a = 0, n = e1; a < n.length; a += 1){
                    var s = n[a], l = this._tileClippingMaskIDs[s.key] = this.nextStencilID++;
                    r.draw(i, o.TRIANGLES, It.disabled, new Pt({
                        func: o.ALWAYS,
                        mask: 0
                    }, l, 255, o.KEEP, o.KEEP, o.REPLACE), St.disabled, Ct.disabled, Li(s.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                }
            }
        }, yo.prototype.stencilModeFor3D = function() {
            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
            var t1 = this.nextStencilID++, e1 = this.context.gl;
            return new Pt({
                func: e1.NOTEQUAL,
                mask: 255
            }, t1, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
        }, yo.prototype.stencilModeForClipping = function(t1) {
            var e1 = this.context.gl;
            return new Pt({
                func: e1.EQUAL,
                mask: 255
            }, this._tileClippingMaskIDs[t1.key], 0, e1.KEEP, e1.KEEP, e1.REPLACE);
        }, yo.prototype.stencilConfigForOverlap = function(t1) {
            var e1, i = this.context.gl, o = t1.sort(function(t1, e1) {
                return e1.overscaledZ - t1.overscaledZ;
            }), r = o[o.length - 1].overscaledZ, a = o[0].overscaledZ - r + 1;
            if (a > 1) {
                this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                for(var n = {}, s = 0; s < a; s++)n[s + r] = new Pt({
                    func: i.GEQUAL,
                    mask: 255
                }, s + this.nextStencilID, 255, i.KEEP, i.KEEP, i.REPLACE);
                return this.nextStencilID += a, [
                    n,
                    o
                ];
            }
            return [
                (e1 = {}, e1[r] = Pt.disabled, e1),
                o
            ];
        }, yo.prototype.colorModeForRenderPass = function() {
            var e1 = this.context.gl;
            return this._showOverdrawInspector ? new St([
                e1.CONSTANT_COLOR,
                e1.ONE
            ], new t1.Color(1 / 8, 1 / 8, 1 / 8, 0), [
                !0,
                !0,
                !0,
                !0
            ]) : "opaque" === this.renderPass ? St.unblended : St.alphaBlended;
        }, yo.prototype.depthModeForSublayer = function(t1, e1, i) {
            if (!this.opaquePassEnabledForLayer()) return It.disabled;
            var o = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
            return new It(i || this.context.gl.LEQUAL, e1, [
                o,
                o
            ]);
        }, yo.prototype.opaquePassEnabledForLayer = function() {
            return this.currentLayer < this.opaquePassCutoff;
        }, yo.prototype.render = function(e1, i) {
            var o = this;
            this.style = e1, this.options = i, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(t1.browser.now()), this.imageManager.beginFrame();
            var r = this.style._order, a = this.style.sourceCaches;
            for(var n in a){
                var s = a[n];
                s.used && s.prepare(this.context);
            }
            var l, c, u = {}, h = {}, p = {};
            for(var d in a){
                var _ = a[d];
                u[d] = _.getVisibleCoordinates(), h[d] = u[d].slice().reverse(), p[d] = _.getVisibleCoordinates(!0).reverse();
            }
            this.opaquePassCutoff = 1 / 0;
            for(var f = 0; f < r.length; f++)if (this.style._layers[r[f]].is3D()) {
                this.opaquePassCutoff = f;
                break;
            }
            this.renderPass = "offscreen";
            for(var m = 0, g = r; m < g.length; m += 1){
                var v = this.style._layers[g[m]];
                if (v.hasOffscreenPass() && !v.isHidden(this.transform.zoom)) {
                    var y = h[v.source];
                    ("custom" === v.type || y.length) && this.renderLayer(this, a[v.source], v, y);
                }
            }
            for(this.context.bindFramebuffer.set(null), this.context.clear({
                color: i.showOverdrawInspector ? t1.Color.black : t1.Color.transparent,
                depth: 1
            }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                0,
                1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
            ], this.renderPass = "opaque", this.currentLayer = r.length - 1; this.currentLayer >= 0; this.currentLayer--){
                var x = this.style._layers[r[this.currentLayer]], b = a[x.source], w = u[x.source];
                this._renderTileClippingMasks(x, w), this.renderLayer(this, b, x, w);
            }
            for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < r.length; this.currentLayer++){
                var T = this.style._layers[r[this.currentLayer]], E = a[T.source], I = ("symbol" === T.type ? p : h)[T.source];
                this._renderTileClippingMasks(T, u[T.source]), this.renderLayer(this, E, T, I);
            }
            this.options.showTileBoundaries && (t1.values(this.style._layers).forEach(function(t1) {
                t1.source && !t1.isHidden(o.transform.zoom) && (t1.source !== (c && c.id) && (c = o.style.sourceCaches[t1.source]), (!l || l.getSource().maxzoom < c.getSource().maxzoom) && (l = c));
            }), l && vo.debug(this, l, l.getVisibleCoordinates())), this.options.showPadding && function(t1) {
                var e1 = t1.transform.padding;
                _o(t1, t1.transform.height - (e1.top || 0), 3, lo), _o(t1, e1.bottom || 0, 3, co), fo(t1, e1.left || 0, 3, uo), fo(t1, t1.transform.width - (e1.right || 0), 3, ho);
                var i = t1.transform.centerPoint;
                !function(t1, e1, i, o) {
                    mo(t1, e1 - 1, i - 10, 2, 20, o), mo(t1, e1 - 10, i - 1, 20, 2, o);
                }(t1, i.x, t1.transform.height - i.y, po);
            }(this), this.context.setDefault();
        }, yo.prototype.renderLayer = function(t1, e1, i, o) {
            i.isHidden(this.transform.zoom) || ("background" === i.type || "custom" === i.type || o.length) && (this.id = i.id, this.gpuTimingStart(i), vo[i.type](t1, e1, i, o, this.style.placement.variableOffsets), this.gpuTimingEnd());
        }, yo.prototype.gpuTimingStart = function(t1) {
            if (this.options.gpuTiming) {
                var e1 = this.context.extTimerQuery, i = this.gpuTimers[t1.id];
                i || (i = this.gpuTimers[t1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: e1.createQueryEXT()
                }), i.calls++, e1.beginQueryEXT(e1.TIME_ELAPSED_EXT, i.query);
            }
        }, yo.prototype.gpuTimingEnd = function() {
            if (this.options.gpuTiming) {
                var t1 = this.context.extTimerQuery;
                t1.endQueryEXT(t1.TIME_ELAPSED_EXT);
            }
        }, yo.prototype.collectGpuTimers = function() {
            var t1 = this.gpuTimers;
            return this.gpuTimers = {}, t1;
        }, yo.prototype.queryGpuTimers = function(t1) {
            var e1 = {};
            for(var i in t1){
                var o = t1[i], r = this.context.extTimerQuery, a = r.getQueryObjectEXT(o.query, r.QUERY_RESULT_EXT) / 1e6;
                r.deleteQueryEXT(o.query), e1[i] = a;
            }
            return e1;
        }, yo.prototype.translatePosMatrix = function(e1, i, o, r, a) {
            if (!o[0] && !o[1]) return e1;
            var n = a ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
            if (n) {
                var s = Math.sin(n), l = Math.cos(n);
                o = [
                    o[0] * l - o[1] * s,
                    o[0] * s + o[1] * l
                ];
            }
            var c = [
                a ? o[0] : pe(i, o[0], this.transform.zoom),
                a ? o[1] : pe(i, o[1], this.transform.zoom),
                0
            ], u = new Float32Array(16);
            return t1.translate(u, e1, c), u;
        }, yo.prototype.saveTileTexture = function(t1) {
            var e1 = this._tileTextures[t1.size[0]];
            e1 ? e1.push(t1) : this._tileTextures[t1.size[0]] = [
                t1
            ];
        }, yo.prototype.getTileTexture = function(t1) {
            var e1 = this._tileTextures[t1];
            return e1 && e1.length > 0 ? e1.pop() : null;
        }, yo.prototype.isPatternMissing = function(t1) {
            if (!t1) return !1;
            if (!t1.from || !t1.to) return !0;
            var e1 = this.imageManager.getPattern(t1.from.toString()), i = this.imageManager.getPattern(t1.to.toString());
            return !e1 || !i;
        }, yo.prototype.useProgram = function(t1, e1) {
            this.cache = this.cache || {};
            var i = "" + t1 + (e1 ? e1.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "");
            return this.cache[i] || (this.cache[i] = new bi(this.context, t1, vi[t1], e1, Ki[t1], this._showOverdrawInspector)), this.cache[i];
        }, yo.prototype.setCustomLayerDefaults = function() {
            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
        }, yo.prototype.setBaseState = function() {
            var t1 = this.context.gl;
            this.context.cullFace.set(!1), this.context.viewport.set([
                0,
                0,
                this.width,
                this.height
            ]), this.context.blendEquation.set(t1.FUNC_ADD);
        }, yo.prototype.initDebugOverlayCanvas = function() {
            null == this.debugOverlayCanvas && (this.debugOverlayCanvas = t1.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new t1.Texture(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
        }, yo.prototype.destroy = function() {
            this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
        };
        var xo = function(t1, e1) {
            this.points = t1, this.planes = e1;
        };
        xo.fromInvProjectionMatrix = function(e1, i, o) {
            var r = Math.pow(2, o), a = [
                [
                    -1,
                    1,
                    -1,
                    1
                ],
                [
                    1,
                    1,
                    -1,
                    1
                ],
                [
                    1,
                    -1,
                    -1,
                    1
                ],
                [
                    -1,
                    -1,
                    -1,
                    1
                ],
                [
                    -1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    -1,
                    1,
                    1
                ],
                [
                    -1,
                    -1,
                    1,
                    1
                ]
            ].map(function(i) {
                return t1.transformMat4([], i, e1);
            }).map(function(e1) {
                return t1.scale$1([], e1, 1 / e1[3] / i * r);
            }), n = [
                [
                    0,
                    1,
                    2
                ],
                [
                    6,
                    5,
                    4
                ],
                [
                    0,
                    3,
                    7
                ],
                [
                    2,
                    1,
                    5
                ],
                [
                    3,
                    2,
                    6
                ],
                [
                    0,
                    4,
                    5
                ]
            ].map(function(e1) {
                var i = t1.sub([], a[e1[0]], a[e1[1]]), o = t1.sub([], a[e1[2]], a[e1[1]]), r = t1.normalize([], t1.cross([], i, o)), n = -t1.dot(r, a[e1[1]]);
                return r.concat(n);
            });
            return new xo(a, n);
        };
        var bo = function(e1, i) {
            this.min = e1, this.max = i, this.center = t1.scale$2([], t1.add([], this.min, this.max), .5);
        };
        bo.prototype.quadrant = function(e1) {
            for(var i = [
                e1 % 2 == 0,
                e1 < 2
            ], o = t1.clone$2(this.min), r = t1.clone$2(this.max), a = 0; a < i.length; a++)o[a] = i[a] ? this.min[a] : this.center[a], r[a] = i[a] ? this.center[a] : this.max[a];
            return r[2] = this.max[2], new bo(o, r);
        }, bo.prototype.distanceX = function(t1) {
            return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
        }, bo.prototype.distanceY = function(t1) {
            return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
        }, bo.prototype.intersects = function(e1) {
            for(var i = [
                [
                    this.min[0],
                    this.min[1],
                    0,
                    1
                ],
                [
                    this.max[0],
                    this.min[1],
                    0,
                    1
                ],
                [
                    this.max[0],
                    this.max[1],
                    0,
                    1
                ],
                [
                    this.min[0],
                    this.max[1],
                    0,
                    1
                ]
            ], o = !0, r = 0; r < e1.planes.length; r++){
                for(var a = e1.planes[r], n = 0, s = 0; s < i.length; s++)n += t1.dot$1(a, i[s]) >= 0;
                if (0 === n) return 0;
                n !== i.length && (o = !1);
            }
            if (o) return 2;
            for(var l = 0; l < 3; l++){
                for(var c = Number.MAX_VALUE, u = -Number.MAX_VALUE, h = 0; h < e1.points.length; h++){
                    var p = e1.points[h][l] - this.min[l];
                    c = Math.min(c, p), u = Math.max(u, p);
                }
                if (u < 0 || c > this.max[l] - this.min[l]) return 0;
            }
            return 1;
        };
        var wo = function(t1, e1, i, o) {
            if (void 0 === t1 && (t1 = 0), void 0 === e1 && (e1 = 0), void 0 === i && (i = 0), void 0 === o && (o = 0), isNaN(t1) || t1 < 0 || isNaN(e1) || e1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
            this.top = t1, this.bottom = e1, this.left = i, this.right = o;
        };
        wo.prototype.interpolate = function(e1, i, o) {
            return null != i.top && null != e1.top && (this.top = t1.number(e1.top, i.top, o)), null != i.bottom && null != e1.bottom && (this.bottom = t1.number(e1.bottom, i.bottom, o)), null != i.left && null != e1.left && (this.left = t1.number(e1.left, i.left, o)), null != i.right && null != e1.right && (this.right = t1.number(e1.right, i.right, o)), this;
        }, wo.prototype.getCenter = function(e1, i) {
            var o = t1.clamp((this.left + e1 - this.right) / 2, 0, e1), r = t1.clamp((this.top + i - this.bottom) / 2, 0, i);
            return new t1.Point(o, r);
        }, wo.prototype.equals = function(t1) {
            return this.top === t1.top && this.bottom === t1.bottom && this.left === t1.left && this.right === t1.right;
        }, wo.prototype.clone = function() {
            return new wo(this.top, this.bottom, this.left, this.right);
        }, wo.prototype.toJSON = function() {
            return {
                top: this.top,
                bottom: this.bottom,
                left: this.left,
                right: this.right
            };
        };
        var To = function(e1, i, o, r, a) {
            this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = void 0 === a || a, this._minZoom = e1 || 0, this._maxZoom = i || 22, this._minPitch = null == o ? 0 : o, this._maxPitch = null == r ? 60 : r, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t1.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new wo, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
        }, Eo = {
            minZoom: {
                configurable: !0
            },
            maxZoom: {
                configurable: !0
            },
            minPitch: {
                configurable: !0
            },
            maxPitch: {
                configurable: !0
            },
            renderWorldCopies: {
                configurable: !0
            },
            worldSize: {
                configurable: !0
            },
            centerOffset: {
                configurable: !0
            },
            size: {
                configurable: !0
            },
            bearing: {
                configurable: !0
            },
            pitch: {
                configurable: !0
            },
            fov: {
                configurable: !0
            },
            zoom: {
                configurable: !0
            },
            center: {
                configurable: !0
            },
            padding: {
                configurable: !0
            },
            centerPoint: {
                configurable: !0
            },
            unmodified: {
                configurable: !0
            },
            point: {
                configurable: !0
            }
        };
        To.prototype.clone = function() {
            var t1 = new To(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
            return t1.tileSize = this.tileSize, t1.latRange = this.latRange, t1.width = this.width, t1.height = this.height, t1._center = this._center, t1.zoom = this.zoom, t1.angle = this.angle, t1._fov = this._fov, t1._pitch = this._pitch, t1._unmodified = this._unmodified, t1._edgeInsets = this._edgeInsets.clone(), t1._calcMatrices(), t1;
        }, Eo.minZoom.get = function() {
            return this._minZoom;
        }, Eo.minZoom.set = function(t1) {
            this._minZoom !== t1 && (this._minZoom = t1, this.zoom = Math.max(this.zoom, t1));
        }, Eo.maxZoom.get = function() {
            return this._maxZoom;
        }, Eo.maxZoom.set = function(t1) {
            this._maxZoom !== t1 && (this._maxZoom = t1, this.zoom = Math.min(this.zoom, t1));
        }, Eo.minPitch.get = function() {
            return this._minPitch;
        }, Eo.minPitch.set = function(t1) {
            this._minPitch !== t1 && (this._minPitch = t1, this.pitch = Math.max(this.pitch, t1));
        }, Eo.maxPitch.get = function() {
            return this._maxPitch;
        }, Eo.maxPitch.set = function(t1) {
            this._maxPitch !== t1 && (this._maxPitch = t1, this.pitch = Math.min(this.pitch, t1));
        }, Eo.renderWorldCopies.get = function() {
            return this._renderWorldCopies;
        }, Eo.renderWorldCopies.set = function(t1) {
            void 0 === t1 ? t1 = !0 : null === t1 && (t1 = !1), this._renderWorldCopies = t1;
        }, Eo.worldSize.get = function() {
            return this.tileSize * this.scale;
        }, Eo.centerOffset.get = function() {
            return this.centerPoint._sub(this.size._div(2));
        }, Eo.size.get = function() {
            return new t1.Point(this.width, this.height);
        }, Eo.bearing.get = function() {
            return -this.angle / Math.PI * 180;
        }, Eo.bearing.set = function(e1) {
            var i = -t1.wrap(e1, -180, 180) * Math.PI / 180;
            this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = t1.create$2(), t1.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
        }, Eo.pitch.get = function() {
            return this._pitch / Math.PI * 180;
        }, Eo.pitch.set = function(e1) {
            var i = t1.clamp(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
            this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
        }, Eo.fov.get = function() {
            return this._fov / Math.PI * 180;
        }, Eo.fov.set = function(t1) {
            t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = t1 / 180 * Math.PI, this._calcMatrices());
        }, Eo.zoom.get = function() {
            return this._zoom;
        }, Eo.zoom.set = function(t1) {
            var e1 = Math.min(Math.max(t1, this.minZoom), this.maxZoom);
            this._zoom !== e1 && (this._unmodified = !1, this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom, this._constrain(), this._calcMatrices());
        }, Eo.center.get = function() {
            return this._center;
        }, Eo.center.set = function(t1) {
            t1.lat === this._center.lat && t1.lng === this._center.lng || (this._unmodified = !1, this._center = t1, this._constrain(), this._calcMatrices());
        }, Eo.padding.get = function() {
            return this._edgeInsets.toJSON();
        }, Eo.padding.set = function(t1) {
            this._edgeInsets.equals(t1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t1, 1), this._calcMatrices());
        }, Eo.centerPoint.get = function() {
            return this._edgeInsets.getCenter(this.width, this.height);
        }, To.prototype.isPaddingEqual = function(t1) {
            return this._edgeInsets.equals(t1);
        }, To.prototype.interpolatePadding = function(t1, e1, i) {
            this._unmodified = !1, this._edgeInsets.interpolate(t1, e1, i), this._constrain(), this._calcMatrices();
        }, To.prototype.coveringZoomLevel = function(t1) {
            var e1 = (t1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t1.tileSize));
            return Math.max(0, e1);
        }, To.prototype.getVisibleUnwrappedCoordinates = function(e1) {
            var i = [
                new t1.UnwrappedTileID(0, e1)
            ];
            if (this._renderWorldCopies) for(var o = this.pointCoordinate(new t1.Point(0, 0)), r = this.pointCoordinate(new t1.Point(this.width, 0)), a = this.pointCoordinate(new t1.Point(this.width, this.height)), n = this.pointCoordinate(new t1.Point(0, this.height)), s = Math.floor(Math.min(o.x, r.x, a.x, n.x)), l = Math.floor(Math.max(o.x, r.x, a.x, n.x)), c = s - 1; c <= l + 1; c++)0 !== c && i.push(new t1.UnwrappedTileID(c, e1));
            return i;
        }, To.prototype.coveringTiles = function(e1) {
            var i = this.coveringZoomLevel(e1), o = i;
            if (void 0 !== e1.minzoom && i < e1.minzoom) return [];
            void 0 !== e1.maxzoom && i > e1.maxzoom && (i = e1.maxzoom);
            var r = t1.MercatorCoordinate.fromLngLat(this.center), a = Math.pow(2, i), n = [
                a * r.x,
                a * r.y,
                0
            ], s = xo.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i), l = e1.minzoom || 0;
            this.pitch <= 60 && this._edgeInsets.top < .1 && (l = i);
            var c = function(t1) {
                return {
                    aabb: new bo([
                        t1 * a,
                        0,
                        0
                    ], [
                        (t1 + 1) * a,
                        a,
                        0
                    ]),
                    zoom: 0,
                    x: 0,
                    y: 0,
                    wrap: t1,
                    fullyVisible: !1
                };
            }, u = [], h = [], p = i, d = e1.reparseOverscaled ? o : i;
            if (this._renderWorldCopies) for(var _ = 1; _ <= 3; _++)u.push(c(-_)), u.push(c(_));
            for(u.push(c(0)); u.length > 0;){
                var f = u.pop(), m = f.x, g = f.y, v = f.fullyVisible;
                if (!v) {
                    var y = f.aabb.intersects(s);
                    if (0 === y) continue;
                    v = 2 === y;
                }
                var x = f.aabb.distanceX(n), b = f.aabb.distanceY(n), w = Math.max(Math.abs(x), Math.abs(b));
                if (f.zoom === p || w > 3 + (1 << p - f.zoom) - 2 && f.zoom >= l) h.push({
                    tileID: new t1.OverscaledTileID(f.zoom === p ? d : f.zoom, f.wrap, f.zoom, m, g),
                    distanceSq: t1.sqrLen([
                        n[0] - .5 - m,
                        n[1] - .5 - g
                    ])
                });
                else for(var T = 0; T < 4; T++){
                    var E = (m << 1) + T % 2, I = (g << 1) + (T >> 1);
                    u.push({
                        aabb: f.aabb.quadrant(T),
                        zoom: f.zoom + 1,
                        x: E,
                        y: I,
                        wrap: f.wrap,
                        fullyVisible: v
                    });
                }
            }
            return h.sort(function(t1, e1) {
                return t1.distanceSq - e1.distanceSq;
            }).map(function(t1) {
                return t1.tileID;
            });
        }, To.prototype.resize = function(t1, e1) {
            this.width = t1, this.height = e1, this.pixelsToGLUnits = [
                2 / t1,
                -2 / e1
            ], this._constrain(), this._calcMatrices();
        }, Eo.unmodified.get = function() {
            return this._unmodified;
        }, To.prototype.zoomScale = function(t1) {
            return Math.pow(2, t1);
        }, To.prototype.scaleZoom = function(t1) {
            return Math.log(t1) / Math.LN2;
        }, To.prototype.project = function(e1) {
            var i = t1.clamp(e1.lat, -this.maxValidLatitude, this.maxValidLatitude);
            return new t1.Point(t1.mercatorXfromLng(e1.lng) * this.worldSize, t1.mercatorYfromLat(i) * this.worldSize);
        }, To.prototype.unproject = function(e1) {
            return new t1.MercatorCoordinate(e1.x / this.worldSize, e1.y / this.worldSize).toLngLat();
        }, Eo.point.get = function() {
            return this.project(this.center);
        }, To.prototype.setLocationAtPoint = function(e1, i) {
            var o = this.pointCoordinate(i), r = this.pointCoordinate(this.centerPoint), a = this.locationCoordinate(e1), n = new t1.MercatorCoordinate(a.x - (o.x - r.x), a.y - (o.y - r.y));
            this.center = this.coordinateLocation(n), this._renderWorldCopies && (this.center = this.center.wrap());
        }, To.prototype.locationPoint = function(t1) {
            return this.coordinatePoint(this.locationCoordinate(t1));
        }, To.prototype.pointLocation = function(t1) {
            return this.coordinateLocation(this.pointCoordinate(t1));
        }, To.prototype.locationCoordinate = function(e1) {
            return t1.MercatorCoordinate.fromLngLat(e1);
        }, To.prototype.coordinateLocation = function(t1) {
            return t1.toLngLat();
        }, To.prototype.pointCoordinate = function(e1) {
            var i = [
                e1.x,
                e1.y,
                0,
                1
            ], o = [
                e1.x,
                e1.y,
                1,
                1
            ];
            t1.transformMat4(i, i, this.pixelMatrixInverse), t1.transformMat4(o, o, this.pixelMatrixInverse);
            var r = i[3], a = o[3], n = i[1] / r, s = o[1] / a, l = i[2] / r, c = o[2] / a, u = l === c ? 0 : (0 - l) / (c - l);
            return new t1.MercatorCoordinate(t1.number(i[0] / r, o[0] / a, u) / this.worldSize, t1.number(n, s, u) / this.worldSize);
        }, To.prototype.coordinatePoint = function(e1) {
            var i = [
                e1.x * this.worldSize,
                e1.y * this.worldSize,
                0,
                1
            ];
            return t1.transformMat4(i, i, this.pixelMatrix), new t1.Point(i[0] / i[3], i[1] / i[3]);
        }, To.prototype.getBounds = function() {
            return (new t1.LngLatBounds).extend(this.pointLocation(new t1.Point(0, 0))).extend(this.pointLocation(new t1.Point(this.width, 0))).extend(this.pointLocation(new t1.Point(this.width, this.height))).extend(this.pointLocation(new t1.Point(0, this.height)));
        }, To.prototype.getMaxBounds = function() {
            return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new t1.LngLatBounds([
                this.lngRange[0],
                this.latRange[0]
            ], [
                this.lngRange[1],
                this.latRange[1]
            ]) : null;
        }, To.prototype.setMaxBounds = function(t1) {
            t1 ? (this.lngRange = [
                t1.getWest(),
                t1.getEast()
            ], this.latRange = [
                t1.getSouth(),
                t1.getNorth()
            ], this._constrain()) : (this.lngRange = null, this.latRange = [
                -this.maxValidLatitude,
                this.maxValidLatitude
            ]);
        }, To.prototype.calculatePosMatrix = function(e1, i) {
            void 0 === i && (i = !1);
            var o = e1.key, r = i ? this._alignedPosMatrixCache : this._posMatrixCache;
            if (r[o]) return r[o];
            var a = e1.canonical, n = this.worldSize / this.zoomScale(a.z), s = a.x + Math.pow(2, a.z) * e1.wrap, l = t1.identity(new Float64Array(16));
            return t1.translate(l, l, [
                s * n,
                a.y * n,
                0
            ]), t1.scale(l, l, [
                n / t1.EXTENT,
                n / t1.EXTENT,
                1
            ]), t1.multiply(l, i ? this.alignedProjMatrix : this.projMatrix, l), r[o] = new Float32Array(l), r[o];
        }, To.prototype.customLayerMatrix = function() {
            return this.mercatorMatrix.slice();
        }, To.prototype._constrain = function() {
            if (this.center && this.width && this.height && !this._constraining) {
                this._constraining = !0;
                var e1, i, o, r, a = -90, n = 90, s = -180, l = 180, c = this.size, u = this._unmodified;
                if (this.latRange) {
                    var h = this.latRange;
                    a = t1.mercatorYfromLat(h[1]) * this.worldSize, e1 = (n = t1.mercatorYfromLat(h[0]) * this.worldSize) - a < c.y ? c.y / (n - a) : 0;
                }
                if (this.lngRange) {
                    var p = this.lngRange;
                    s = t1.mercatorXfromLng(p[0]) * this.worldSize, i = (l = t1.mercatorXfromLng(p[1]) * this.worldSize) - s < c.x ? c.x / (l - s) : 0;
                }
                var d = this.point, _ = Math.max(i || 0, e1 || 0);
                if (_) return this.center = this.unproject(new t1.Point(i ? (l + s) / 2 : d.x, e1 ? (n + a) / 2 : d.y)), this.zoom += this.scaleZoom(_), this._unmodified = u, void (this._constraining = !1);
                if (this.latRange) {
                    var f = d.y, m = c.y / 2;
                    f - m < a && (r = a + m), f + m > n && (r = n - m);
                }
                if (this.lngRange) {
                    var g = d.x, v = c.x / 2;
                    g - v < s && (o = s + v), g + v > l && (o = l - v);
                }
                void 0 === o && void 0 === r || (this.center = this.unproject(new t1.Point(void 0 !== o ? o : d.x, void 0 !== r ? r : d.y))), this._unmodified = u, this._constraining = !1;
            }
        }, To.prototype._calcMatrices = function() {
            if (this.height) {
                var e1 = this.centerOffset;
                this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height;
                var i = Math.PI / 2 + this._pitch, o = this._fov * (.5 + e1.y / this.height), r = Math.sin(o) * this.cameraToCenterDistance / Math.sin(t1.clamp(Math.PI - i - o, .01, Math.PI - .01)), a = this.point, n = a.x, s = a.y, l = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * r + this.cameraToCenterDistance), c = this.height / 50, u = new Float64Array(16);
                t1.perspective(u, this._fov, this.width / this.height, c, l), u[8] = 2 * -e1.x / this.width, u[9] = 2 * e1.y / this.height, t1.scale(u, u, [
                    1,
                    -1,
                    1
                ]), t1.translate(u, u, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t1.rotateX(u, u, this._pitch), t1.rotateZ(u, u, this.angle), t1.translate(u, u, [
                    -n,
                    -s,
                    0
                ]), this.mercatorMatrix = t1.scale([], u, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t1.scale(u, u, [
                    1,
                    1,
                    t1.mercatorZfromAltitude(1, this.center.lat) * this.worldSize,
                    1
                ]), this.projMatrix = u, this.invProjMatrix = t1.invert([], this.projMatrix);
                var h = this.width % 2 / 2, p = this.height % 2 / 2, d = Math.cos(this.angle), _ = Math.sin(this.angle), f = n - Math.round(n) + d * h + _ * p, m = s - Math.round(s) + d * p + _ * h, g = new Float64Array(u);
                if (t1.translate(g, g, [
                    f > .5 ? f - 1 : f,
                    m > .5 ? m - 1 : m,
                    0
                ]), this.alignedProjMatrix = g, u = t1.create(), t1.scale(u, u, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), t1.translate(u, u, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = u, u = t1.create(), t1.scale(u, u, [
                    1,
                    -1,
                    1
                ]), t1.translate(u, u, [
                    -1,
                    -1,
                    0
                ]), t1.scale(u, u, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = u, this.pixelMatrix = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), !(u = t1.invert(new Float64Array(16), this.pixelMatrix))) throw new Error("failed to invert matrix");
                this.pixelMatrixInverse = u, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
        }, To.prototype.maxPitchScaleFactor = function() {
            if (!this.pixelMatrixInverse) return 1;
            var e1 = this.pointCoordinate(new t1.Point(0, 0)), i = [
                e1.x * this.worldSize,
                e1.y * this.worldSize,
                0,
                1
            ];
            return t1.transformMat4(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance;
        }, To.prototype.getCameraPoint = function() {
            var e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
            return this.centerPoint.add(new t1.Point(0, e1));
        }, To.prototype.getCameraQueryGeometry = function(e1) {
            var i = this.getCameraPoint();
            if (1 === e1.length) return [
                e1[0],
                i
            ];
            for(var o = i.x, r = i.y, a = i.x, n = i.y, s = 0, l = e1; s < l.length; s += 1){
                var c = l[s];
                o = Math.min(o, c.x), r = Math.min(r, c.y), a = Math.max(a, c.x), n = Math.max(n, c.y);
            }
            return [
                new t1.Point(o, r),
                new t1.Point(a, r),
                new t1.Point(a, n),
                new t1.Point(o, n),
                new t1.Point(o, r)
            ];
        }, Object.defineProperties(To.prototype, Eo);
        var Io = function(e1) {
            var i, o, r, a;
            this._hashName = e1 && encodeURIComponent(e1), t1.bindAll([
                "_getCurrentHash",
                "_onHashChange",
                "_updateHash"
            ], this), this._updateHash = (i = this._updateHashUnthrottled.bind(this), o = !1, r = null, a = function() {
                r = null, o && (i(), r = setTimeout(a, 300), o = !1);
            }, function() {
                return o = !0, r || a(), r;
            });
        };
        Io.prototype.addTo = function(e1) {
            return this._map = e1, t1.window.addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
        }, Io.prototype.remove = function() {
            return t1.window.removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
        }, Io.prototype.getHashString = function(e1) {
            var i = this._map.getCenter(), o = Math.round(100 * this._map.getZoom()) / 100, r = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, r), n = Math.round(i.lng * a) / a, s = Math.round(i.lat * a) / a, l = this._map.getBearing(), c = this._map.getPitch(), u = "";
            if (u += e1 ? "/" + n + "/" + s + "/" + o : o + "/" + s + "/" + n, (l || c) && (u += "/" + Math.round(10 * l) / 10), c && (u += "/" + Math.round(c)), this._hashName) {
                var h = this._hashName, p = !1, d = t1.window.location.hash.slice(1).split("&").map(function(t1) {
                    var e1 = t1.split("=")[0];
                    return e1 === h ? (p = !0, e1 + "=" + u) : t1;
                }).filter(function(t1) {
                    return t1;
                });
                return p || d.push(h + "=" + u), "#" + d.join("&");
            }
            return "#" + u;
        }, Io.prototype._getCurrentHash = function() {
            var e1, i = this, o = t1.window.location.hash.replace("#", "");
            return this._hashName ? (o.split("&").map(function(t1) {
                return t1.split("=");
            }).forEach(function(t1) {
                t1[0] === i._hashName && (e1 = t1);
            }), (e1 && e1[1] || "").split("/")) : o.split("/");
        }, Io.prototype._onHashChange = function() {
            var t1 = this._getCurrentHash();
            if (t1.length >= 3 && !t1.some(function(t1) {
                return isNaN(t1);
            })) {
                var e1 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : this._map.getBearing();
                return this._map.jumpTo({
                    center: [
                        +t1[2],
                        +t1[1]
                    ],
                    zoom: +t1[0],
                    bearing: e1,
                    pitch: +(t1[4] || 0)
                }), !0;
            }
            return !1;
        }, Io.prototype._updateHashUnthrottled = function() {
            var e1 = t1.window.location.href.replace(/(#.+)?$/, this.getHashString());
            try {
                t1.window.history.replaceState(t1.window.history.state, null, e1);
            } catch (t1) {}
        };
        var Po = {
            linearity: .3,
            easing: t1.bezier(0, 0, .3, 1)
        }, So = t1.extend({
            deceleration: 2500,
            maxSpeed: 1400
        }, Po), Co = t1.extend({
            deceleration: 20,
            maxSpeed: 1400
        }, Po), zo = t1.extend({
            deceleration: 1e3,
            maxSpeed: 360
        }, Po), Do = t1.extend({
            deceleration: 1e3,
            maxSpeed: 90
        }, Po), Ao = function(t1) {
            this._map = t1, this.clear();
        };
        function Mo(t1, e1) {
            (!t1.duration || t1.duration < e1.duration) && (t1.duration = e1.duration, t1.easing = e1.easing);
        }
        function Lo(e1, i, o) {
            var r = o.maxSpeed, a = o.linearity, n = o.deceleration, s = t1.clamp(e1 * a / (i / 1e3), -r, r), l = Math.abs(s) / (n * a);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: s * (l / 2)
            };
        }
        Ao.prototype.clear = function() {
            this._inertiaBuffer = [];
        }, Ao.prototype.record = function(e1) {
            this._drainInertiaBuffer(), this._inertiaBuffer.push({
                time: t1.browser.now(),
                settings: e1
            });
        }, Ao.prototype._drainInertiaBuffer = function() {
            for(var e1 = this._inertiaBuffer, i = t1.browser.now(); e1.length > 0 && i - e1[0].time > 160;)e1.shift();
        }, Ao.prototype._onMoveEnd = function(e1) {
            if (this._drainInertiaBuffer(), !(this._inertiaBuffer.length < 2)) {
                for(var i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new t1.Point(0, 0),
                    pinchAround: void 0,
                    around: void 0
                }, o = 0, r = this._inertiaBuffer; o < r.length; o += 1){
                    var a = r[o].settings;
                    i.zoom += a.zoomDelta || 0, i.bearing += a.bearingDelta || 0, i.pitch += a.pitchDelta || 0, a.panDelta && i.pan._add(a.panDelta), a.around && (i.around = a.around), a.pinchAround && (i.pinchAround = a.pinchAround);
                }
                var n = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                if (i.pan.mag()) {
                    var l = Lo(i.pan.mag(), n, t1.extend({}, So, e1 || {}));
                    s.offset = i.pan.mult(l.amount / i.pan.mag()), s.center = this._map.transform.center, Mo(s, l);
                }
                if (i.zoom) {
                    var c = Lo(i.zoom, n, Co);
                    s.zoom = this._map.transform.zoom + c.amount, Mo(s, c);
                }
                if (i.bearing) {
                    var u = Lo(i.bearing, n, zo);
                    s.bearing = this._map.transform.bearing + t1.clamp(u.amount, -179, 179), Mo(s, u);
                }
                if (i.pitch) {
                    var h = Lo(i.pitch, n, Do);
                    s.pitch = this._map.transform.pitch + h.amount, Mo(s, h);
                }
                if (s.zoom || s.bearing) {
                    var p = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    s.around = p ? this._map.unproject(p) : this._map.getCenter();
                }
                return this.clear(), t1.extend(s, {
                    noMoveStart: !0
                });
            }
        };
        var Ro = function(e1) {
            function o(o, r, a, n) {
                void 0 === n && (n = {});
                var s = i.mousePos(r.getCanvasContainer(), a), l = r.unproject(s);
                e1.call(this, o, t1.extend({
                    point: s,
                    lngLat: l,
                    originalEvent: a
                }, n)), this._defaultPrevented = !1, this.target = r;
            }
            e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o;
            var r = {
                defaultPrevented: {
                    configurable: !0
                }
            };
            return o.prototype.preventDefault = function() {
                this._defaultPrevented = !0;
            }, r.defaultPrevented.get = function() {
                return this._defaultPrevented;
            }, Object.defineProperties(o.prototype, r), o;
        }(t1.Event), ko = function(e1) {
            function o(o, r, a) {
                var n = "touchend" === o ? a.changedTouches : a.touches, s = i.touchPos(r.getCanvasContainer(), n), l = s.map(function(t1) {
                    return r.unproject(t1);
                }), c = s.reduce(function(t1, e1, i, o) {
                    return t1.add(e1.div(o.length));
                }, new t1.Point(0, 0)), u = r.unproject(c);
                e1.call(this, o, {
                    points: s,
                    point: c,
                    lngLats: l,
                    lngLat: u,
                    originalEvent: a
                }), this._defaultPrevented = !1;
            }
            e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o;
            var r = {
                defaultPrevented: {
                    configurable: !0
                }
            };
            return o.prototype.preventDefault = function() {
                this._defaultPrevented = !0;
            }, r.defaultPrevented.get = function() {
                return this._defaultPrevented;
            }, Object.defineProperties(o.prototype, r), o;
        }(t1.Event), Bo = function(t1) {
            function e1(e1, i, o) {
                t1.call(this, e1, {
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
            t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1;
            var i = {
                defaultPrevented: {
                    configurable: !0
                }
            };
            return e1.prototype.preventDefault = function() {
                this._defaultPrevented = !0;
            }, i.defaultPrevented.get = function() {
                return this._defaultPrevented;
            }, Object.defineProperties(e1.prototype, i), e1;
        }(t1.Event), Oo = function(t1, e1) {
            this._map = t1, this._clickTolerance = e1.clickTolerance;
        };
        Oo.prototype.reset = function() {
            delete this._mousedownPos;
        }, Oo.prototype.wheel = function(t1) {
            return this._firePreventable(new Bo(t1.type, this._map, t1));
        }, Oo.prototype.mousedown = function(t1, e1) {
            return this._mousedownPos = e1, this._firePreventable(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.mouseup = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.click = function(t1, e1) {
            this._mousedownPos && this._mousedownPos.dist(e1) >= this._clickTolerance || this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.dblclick = function(t1) {
            return this._firePreventable(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.mouseover = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.mouseout = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Oo.prototype.touchstart = function(t1) {
            return this._firePreventable(new ko(t1.type, this._map, t1));
        }, Oo.prototype.touchmove = function(t1) {
            this._map.fire(new ko(t1.type, this._map, t1));
        }, Oo.prototype.touchend = function(t1) {
            this._map.fire(new ko(t1.type, this._map, t1));
        }, Oo.prototype.touchcancel = function(t1) {
            this._map.fire(new ko(t1.type, this._map, t1));
        }, Oo.prototype._firePreventable = function(t1) {
            if (this._map.fire(t1), t1.defaultPrevented) return {};
        }, Oo.prototype.isEnabled = function() {
            return !0;
        }, Oo.prototype.isActive = function() {
            return !1;
        }, Oo.prototype.enable = function() {}, Oo.prototype.disable = function() {};
        var Fo = function(t1) {
            this._map = t1;
        };
        Fo.prototype.reset = function() {
            this._delayContextMenu = !1, delete this._contextMenuEvent;
        }, Fo.prototype.mousemove = function(t1) {
            this._map.fire(new Ro(t1.type, this._map, t1));
        }, Fo.prototype.mousedown = function() {
            this._delayContextMenu = !0;
        }, Fo.prototype.mouseup = function() {
            this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Ro("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
        }, Fo.prototype.contextmenu = function(t1) {
            this._delayContextMenu ? this._contextMenuEvent = t1 : this._map.fire(new Ro(t1.type, this._map, t1)), this._map.listens("contextmenu") && t1.preventDefault();
        }, Fo.prototype.isEnabled = function() {
            return !0;
        }, Fo.prototype.isActive = function() {
            return !1;
        }, Fo.prototype.enable = function() {}, Fo.prototype.disable = function() {};
        var Uo = function(t1, e1) {
            this._map = t1, this._el = t1.getCanvasContainer(), this._container = t1.getContainer(), this._clickTolerance = e1.clickTolerance || 1;
        };
        function No(t1, e1) {
            for(var i = {}, o = 0; o < t1.length; o++)i[t1[o].identifier] = e1[o];
            return i;
        }
        Uo.prototype.isEnabled = function() {
            return !!this._enabled;
        }, Uo.prototype.isActive = function() {
            return !!this._active;
        }, Uo.prototype.enable = function() {
            this.isEnabled() || (this._enabled = !0);
        }, Uo.prototype.disable = function() {
            this.isEnabled() && (this._enabled = !1);
        }, Uo.prototype.mousedown = function(t1, e1) {
            this.isEnabled() && t1.shiftKey && 0 === t1.button && (i.disableDrag(), this._startPos = this._lastPos = e1, this._active = !0);
        }, Uo.prototype.mousemoveWindow = function(t1, e1) {
            if (this._active) {
                var o = e1;
                if (!(this._lastPos.equals(o) || !this._box && o.dist(this._startPos) < this._clickTolerance)) {
                    var r = this._startPos;
                    this._lastPos = o, this._box || (this._box = i.create("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", t1));
                    var a = Math.min(r.x, o.x), n = Math.max(r.x, o.x), s = Math.min(r.y, o.y), l = Math.max(r.y, o.y);
                    i.setTransform(this._box, "translate(" + a + "px," + s + "px)"), this._box.style.width = n - a + "px", this._box.style.height = l - s + "px";
                }
            }
        }, Uo.prototype.mouseupWindow = function(e1, o) {
            var r = this;
            if (this._active && 0 === e1.button) {
                var a = this._startPos, n = o;
                if (this.reset(), i.suppressClick(), a.x !== n.x || a.y !== n.y) return this._map.fire(new t1.Event("boxzoomend", {
                    originalEvent: e1
                })), {
                    cameraAnimation: function(t1) {
                        return t1.fitScreenCoordinates(a, n, r._map.getBearing(), {
                            linear: !0
                        });
                    }
                };
                this._fireEvent("boxzoomcancel", e1);
            }
        }, Uo.prototype.keydown = function(t1) {
            this._active && 27 === t1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t1));
        }, Uo.prototype.blur = function() {
            this.reset();
        }, Uo.prototype.reset = function() {
            this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (i.remove(this._box), this._box = null), i.enableDrag(), delete this._startPos, delete this._lastPos;
        }, Uo.prototype._fireEvent = function(e1, i) {
            return this._map.fire(new t1.Event(e1, {
                originalEvent: i
            }));
        };
        var Zo = function(t1) {
            this.reset(), this.numTouches = t1.numTouches;
        };
        Zo.prototype.reset = function() {
            delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
        }, Zo.prototype.touchstart = function(e1, i, o) {
            (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), o.length === this.numTouches && (this.centroid = function(e1) {
                for(var i = new t1.Point(0, 0), o = 0, r = e1; o < r.length; o += 1)i._add(r[o]);
                return i.div(e1.length);
            }(i), this.touches = No(o, i)));
        }, Zo.prototype.touchmove = function(t1, e1, i) {
            if (!this.aborted && this.centroid) {
                var o = No(i, e1);
                for(var r in this.touches){
                    var a = o[r];
                    (!a || a.dist(this.touches[r]) > 30) && (this.aborted = !0);
                }
            }
        }, Zo.prototype.touchend = function(t1, e1, i) {
            if ((!this.centroid || t1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                var o = !this.aborted && this.centroid;
                if (this.reset(), o) return o;
            }
        };
        var qo = function(t1) {
            this.singleTap = new Zo(t1), this.numTaps = t1.numTaps, this.reset();
        };
        qo.prototype.reset = function() {
            this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
        }, qo.prototype.touchstart = function(t1, e1, i) {
            this.singleTap.touchstart(t1, e1, i);
        }, qo.prototype.touchmove = function(t1, e1, i) {
            this.singleTap.touchmove(t1, e1, i);
        }, qo.prototype.touchend = function(t1, e1, i) {
            var o = this.singleTap.touchend(t1, e1, i);
            if (o) {
                var r = t1.timeStamp - this.lastTime < 500, a = !this.lastTap || this.lastTap.dist(o) < 30;
                if (r && a || this.reset(), this.count++, this.lastTime = t1.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
            }
        };
        var jo = function() {
            this._zoomIn = new qo({
                numTouches: 1,
                numTaps: 2
            }), this._zoomOut = new qo({
                numTouches: 2,
                numTaps: 1
            }), this.reset();
        };
        jo.prototype.reset = function() {
            this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
        }, jo.prototype.touchstart = function(t1, e1, i) {
            this._zoomIn.touchstart(t1, e1, i), this._zoomOut.touchstart(t1, e1, i);
        }, jo.prototype.touchmove = function(t1, e1, i) {
            this._zoomIn.touchmove(t1, e1, i), this._zoomOut.touchmove(t1, e1, i);
        }, jo.prototype.touchend = function(t1, e1, i) {
            var o = this, r = this._zoomIn.touchend(t1, e1, i), a = this._zoomOut.touchend(t1, e1, i);
            return r ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                return o.reset();
            }, 0), {
                cameraAnimation: function(e1) {
                    return e1.easeTo({
                        duration: 300,
                        zoom: e1.getZoom() + 1,
                        around: e1.unproject(r)
                    }, {
                        originalEvent: t1
                    });
                }
            }) : a ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                return o.reset();
            }, 0), {
                cameraAnimation: function(e1) {
                    return e1.easeTo({
                        duration: 300,
                        zoom: e1.getZoom() - 1,
                        around: e1.unproject(a)
                    }, {
                        originalEvent: t1
                    });
                }
            }) : void 0;
        }, jo.prototype.touchcancel = function() {
            this.reset();
        }, jo.prototype.enable = function() {
            this._enabled = !0;
        }, jo.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, jo.prototype.isEnabled = function() {
            return this._enabled;
        }, jo.prototype.isActive = function() {
            return this._active;
        };
        var Vo = {
            0: 1,
            2: 2
        }, Go = function(t1) {
            this.reset(), this._clickTolerance = t1.clickTolerance || 1;
        };
        Go.prototype.blur = function() {
            this.reset();
        }, Go.prototype.reset = function() {
            this._active = !1, this._moved = !1, delete this._lastPoint, delete this._eventButton;
        }, Go.prototype._correctButton = function(t1, e1) {
            return !1;
        }, Go.prototype._move = function(t1, e1) {
            return {};
        }, Go.prototype.mousedown = function(t1, e1) {
            if (!this._lastPoint) {
                var o = i.mouseButton(t1);
                this._correctButton(t1, o) && (this._lastPoint = e1, this._eventButton = o);
            }
        }, Go.prototype.mousemoveWindow = function(t1, e1) {
            var i = this._lastPoint;
            if (i) {
                if (t1.preventDefault(), function(t1, e1) {
                    var i = Vo[e1];
                    return void 0 === t1.buttons || (t1.buttons & i) !== i;
                }(t1, this._eventButton)) this.reset();
                else if (this._moved || !(e1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = e1, this._move(i, e1);
            }
        }, Go.prototype.mouseupWindow = function(t1) {
            this._lastPoint && i.mouseButton(t1) === this._eventButton && (this._moved && i.suppressClick(), this.reset());
        }, Go.prototype.enable = function() {
            this._enabled = !0;
        }, Go.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, Go.prototype.isEnabled = function() {
            return this._enabled;
        }, Go.prototype.isActive = function() {
            return this._active;
        };
        var Wo = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.mousedown = function(e1, i) {
                t1.prototype.mousedown.call(this, e1, i), this._lastPoint && (this._active = !0);
            }, e1.prototype._correctButton = function(t1, e1) {
                return 0 === e1 && !t1.ctrlKey;
            }, e1.prototype._move = function(t1, e1) {
                return {
                    around: e1,
                    panDelta: e1.sub(t1)
                };
            }, e1;
        }(Go), Xo = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                return 0 === e1 && t1.ctrlKey || 2 === e1;
            }, e1.prototype._move = function(t1, e1) {
                var i = .8 * (e1.x - t1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }, e1.prototype.contextmenu = function(t1) {
                t1.preventDefault();
            }, e1;
        }(Go), Ho = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                return 0 === e1 && t1.ctrlKey || 2 === e1;
            }, e1.prototype._move = function(t1, e1) {
                var i = -0.5 * (e1.y - t1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }, e1.prototype.contextmenu = function(t1) {
                t1.preventDefault();
            }, e1;
        }(Go), Ko = function(t1) {
            this._minTouches = 1, this._clickTolerance = t1.clickTolerance || 1, this.reset();
        };
        Ko.prototype.reset = function() {
            this._active = !1, this._touches = {}, this._sum = new t1.Point(0, 0);
        }, Ko.prototype.touchstart = function(t1, e1, i) {
            return this._calculateTransform(t1, e1, i);
        }, Ko.prototype.touchmove = function(t1, e1, i) {
            if (this._active && !(i.length < this._minTouches)) return t1.preventDefault(), this._calculateTransform(t1, e1, i);
        }, Ko.prototype.touchend = function(t1, e1, i) {
            this._calculateTransform(t1, e1, i), this._active && i.length < this._minTouches && this.reset();
        }, Ko.prototype.touchcancel = function() {
            this.reset();
        }, Ko.prototype._calculateTransform = function(e1, i, o) {
            o.length > 0 && (this._active = !0);
            var r = No(o, i), a = new t1.Point(0, 0), n = new t1.Point(0, 0), s = 0;
            for(var l in r){
                var c = r[l], u = this._touches[l];
                u && (a._add(c), n._add(c.sub(u)), s++, r[l] = c);
            }
            if (this._touches = r, !(s < this._minTouches) && n.mag()) {
                var h = n.div(s);
                if (this._sum._add(h), !(this._sum.mag() < this._clickTolerance)) return {
                    around: a.div(s),
                    panDelta: h
                };
            }
        }, Ko.prototype.enable = function() {
            this._enabled = !0;
        }, Ko.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, Ko.prototype.isEnabled = function() {
            return this._enabled;
        }, Ko.prototype.isActive = function() {
            return this._active;
        };
        var Yo = function() {
            this.reset();
        };
        function Jo(t1, e1, i) {
            for(var o = 0; o < t1.length; o++)if (t1[o].identifier === i) return e1[o];
        }
        function Qo(t1, e1) {
            return Math.log(t1 / e1) / Math.LN2;
        }
        Yo.prototype.reset = function() {
            this._active = !1, delete this._firstTwoTouches;
        }, Yo.prototype._start = function(t1) {}, Yo.prototype._move = function(t1, e1, i) {
            return {};
        }, Yo.prototype.touchstart = function(t1, e1, i) {
            this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                i[0].identifier,
                i[1].identifier
            ], this._start([
                e1[0],
                e1[1]
            ]));
        }, Yo.prototype.touchmove = function(t1, e1, i) {
            if (this._firstTwoTouches) {
                t1.preventDefault();
                var o = this._firstTwoTouches, r = o[1], a = Jo(i, e1, o[0]), n = Jo(i, e1, r);
                if (a && n) {
                    var s = this._aroundCenter ? null : a.add(n).div(2);
                    return this._move([
                        a,
                        n
                    ], s, t1);
                }
            }
        }, Yo.prototype.touchend = function(t1, e1, o) {
            if (this._firstTwoTouches) {
                var r = this._firstTwoTouches, a = r[1], n = Jo(o, e1, r[0]), s = Jo(o, e1, a);
                n && s || (this._active && i.suppressClick(), this.reset());
            }
        }, Yo.prototype.touchcancel = function() {
            this.reset();
        }, Yo.prototype.enable = function(t1) {
            this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around;
        }, Yo.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, Yo.prototype.isEnabled = function() {
            return this._enabled;
        }, Yo.prototype.isActive = function() {
            return this._active;
        };
        var $o = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.reset = function() {
                t1.prototype.reset.call(this), delete this._distance, delete this._startDistance;
            }, e1.prototype._start = function(t1) {
                this._startDistance = this._distance = t1[0].dist(t1[1]);
            }, e1.prototype._move = function(t1, e1) {
                var i = this._distance;
                if (this._distance = t1[0].dist(t1[1]), this._active || !(Math.abs(Qo(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Qo(this._distance, i),
                    pinchAround: e1
                };
            }, e1;
        }(Yo);
        function tr(t1, e1) {
            return 180 * t1.angleWith(e1) / Math.PI;
        }
        var er = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.reset = function() {
                t1.prototype.reset.call(this), delete this._minDiameter, delete this._startVector, delete this._vector;
            }, e1.prototype._start = function(t1) {
                this._startVector = this._vector = t1[0].sub(t1[1]), this._minDiameter = t1[0].dist(t1[1]);
            }, e1.prototype._move = function(t1, e1) {
                var i = this._vector;
                if (this._vector = t1[0].sub(t1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: tr(this._vector, i),
                    pinchAround: e1
                };
            }, e1.prototype._isBelowThreshold = function(t1) {
                this._minDiameter = Math.min(this._minDiameter, t1.mag());
                var e1 = 25 / (Math.PI * this._minDiameter) * 360, i = tr(t1, this._startVector);
                return Math.abs(i) < e1;
            }, e1;
        }(Yo);
        function ir(t1) {
            return Math.abs(t1.y) > Math.abs(t1.x);
        }
        var or = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1.prototype.reset = function() {
                t1.prototype.reset.call(this), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }, e1.prototype._start = function(t1) {
                this._lastPoints = t1, ir(t1[0].sub(t1[1])) && (this._valid = !1);
            }, e1.prototype._move = function(t1, e1, i) {
                var o = t1[0].sub(this._lastPoints[0]), r = t1[1].sub(this._lastPoints[1]);
                if (this._valid = this.gestureBeginsVertically(o, r, i.timeStamp), this._valid) return this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (o.y + r.y) / 2 * -0.5
                };
            }, e1.prototype.gestureBeginsVertically = function(t1, e1, i) {
                if (void 0 !== this._valid) return this._valid;
                var o = t1.mag() >= 2, r = e1.mag() >= 2;
                if (o || r) {
                    if (!o || !r) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                    var a = t1.y > 0 == e1.y > 0;
                    return ir(t1) && ir(e1) && a;
                }
            }, e1;
        }(Yo), rr = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        }, ar = function() {
            var t1 = rr;
            this._panStep = t1.panStep, this._bearingStep = t1.bearingStep, this._pitchStep = t1.pitchStep, this._rotationDisabled = !1;
        };
        function nr(t1) {
            return t1 * (2 - t1);
        }
        ar.prototype.blur = function() {
            this.reset();
        }, ar.prototype.reset = function() {
            this._active = !1;
        }, ar.prototype.keydown = function(t1) {
            var e1 = this;
            if (!(t1.altKey || t1.ctrlKey || t1.metaKey)) {
                var i = 0, o = 0, r = 0, a = 0, n = 0;
                switch(t1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        i = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        i = -1;
                        break;
                    case 37:
                        t1.shiftKey ? o = -1 : (t1.preventDefault(), a = -1);
                        break;
                    case 39:
                        t1.shiftKey ? o = 1 : (t1.preventDefault(), a = 1);
                        break;
                    case 38:
                        t1.shiftKey ? r = 1 : (t1.preventDefault(), n = -1);
                        break;
                    case 40:
                        t1.shiftKey ? r = -1 : (t1.preventDefault(), n = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (o = 0, r = 0), {
                    cameraAnimation: function(s) {
                        var l = s.getZoom();
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: nr,
                            zoom: i ? Math.round(l) + i * (t1.shiftKey ? 2 : 1) : l,
                            bearing: s.getBearing() + o * e1._bearingStep,
                            pitch: s.getPitch() + r * e1._pitchStep,
                            offset: [
                                -a * e1._panStep,
                                -n * e1._panStep
                            ],
                            center: s.getCenter()
                        }, {
                            originalEvent: t1
                        });
                    }
                };
            }
        }, ar.prototype.enable = function() {
            this._enabled = !0;
        }, ar.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, ar.prototype.isEnabled = function() {
            return this._enabled;
        }, ar.prototype.isActive = function() {
            return this._active;
        }, ar.prototype.disableRotation = function() {
            this._rotationDisabled = !0;
        }, ar.prototype.enableRotation = function() {
            this._rotationDisabled = !1;
        };
        var sr = function(e1, i) {
            this._map = e1, this._el = e1.getCanvasContainer(), this._handler = i, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = 1 / 450, t1.bindAll([
                "_onTimeout"
            ], this);
        };
        sr.prototype.setZoomRate = function(t1) {
            this._defaultZoomRate = t1;
        }, sr.prototype.setWheelZoomRate = function(t1) {
            this._wheelZoomRate = t1;
        }, sr.prototype.isEnabled = function() {
            return !!this._enabled;
        }, sr.prototype.isActive = function() {
            return !!this._active || void 0 !== this._finishTimeout;
        }, sr.prototype.isZooming = function() {
            return !!this._zooming;
        }, sr.prototype.enable = function(t1) {
            this.isEnabled() || (this._enabled = !0, this._aroundCenter = t1 && "center" === t1.around);
        }, sr.prototype.disable = function() {
            this.isEnabled() && (this._enabled = !1);
        }, sr.prototype.wheel = function(e1) {
            if (this.isEnabled()) {
                var i = e1.deltaMode === t1.window.WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY, o = t1.browser.now(), r = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % 4.000244140625 == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= i, this._active || this._start(e1)), e1.preventDefault();
            }
        }, sr.prototype._onTimeout = function(t1) {
            this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t1);
        }, sr.prototype._start = function(e1) {
            if (this._delta) {
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                var o = i.mousePos(this._el, e1);
                this._around = t1.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(o)), this._aroundPoint = this._map.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
        }, sr.prototype.renderFrame = function() {
            var e1 = this;
            if (this._frameId && (this._frameId = null, this.isActive())) {
                var i = this._map.transform;
                if (0 !== this._delta) {
                    var o = "wheel" === this._type && Math.abs(this._delta) > 4.000244140625 ? this._wheelZoomRate : this._defaultZoomRate, r = 2 / (1 + Math.exp(-Math.abs(this._delta * o)));
                    this._delta < 0 && 0 !== r && (r = 1 / r);
                    var a = "number" == typeof this._targetZoom ? i.zoomScale(this._targetZoom) : i.scale;
                    this._targetZoom = Math.min(i.maxZoom, Math.max(i.minZoom, i.scaleZoom(a * r))), "wheel" === this._type && (this._startZoom = i.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                var n, s = "number" == typeof this._targetZoom ? this._targetZoom : i.zoom, l = this._startZoom, c = this._easing, u = !1;
                if ("wheel" === this._type && l && c) {
                    var h = Math.min((t1.browser.now() - this._lastWheelEventTime) / 200, 1), p = c(h);
                    n = t1.number(l, s, p), h < 1 ? this._frameId || (this._frameId = !0) : u = !0;
                } else n = s, u = !0;
                return this._active = !0, u && (this._active = !1, this._finishTimeout = setTimeout(function() {
                    e1._zooming = !1, e1._handler._triggerRenderFrame(), delete e1._targetZoom, delete e1._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !u,
                    zoomDelta: n - i.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
        }, sr.prototype._smoothOutEasing = function(e1) {
            var i = t1.ease;
            if (this._prevEase) {
                var o = this._prevEase, r = (t1.browser.now() - o.start) / o.duration, a = o.easing(r + .01) - o.easing(r), n = .27 / Math.sqrt(a * a + 1e-4) * .01, s = Math.sqrt(.0729 - n * n);
                i = t1.bezier(n, s, .25, 1);
            }
            return this._prevEase = {
                start: t1.browser.now(),
                duration: e1,
                easing: i
            }, i;
        }, sr.prototype.blur = function() {
            this.reset();
        }, sr.prototype.reset = function() {
            this._active = !1;
        };
        var lr = function(t1, e1) {
            this._clickZoom = t1, this._tapZoom = e1;
        };
        lr.prototype.enable = function() {
            this._clickZoom.enable(), this._tapZoom.enable();
        }, lr.prototype.disable = function() {
            this._clickZoom.disable(), this._tapZoom.disable();
        }, lr.prototype.isEnabled = function() {
            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
        }, lr.prototype.isActive = function() {
            return this._clickZoom.isActive() || this._tapZoom.isActive();
        };
        var cr = function() {
            this.reset();
        };
        cr.prototype.reset = function() {
            this._active = !1;
        }, cr.prototype.blur = function() {
            this.reset();
        }, cr.prototype.dblclick = function(t1, e1) {
            return t1.preventDefault(), {
                cameraAnimation: function(i) {
                    i.easeTo({
                        duration: 300,
                        zoom: i.getZoom() + (t1.shiftKey ? -1 : 1),
                        around: i.unproject(e1)
                    }, {
                        originalEvent: t1
                    });
                }
            };
        }, cr.prototype.enable = function() {
            this._enabled = !0;
        }, cr.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, cr.prototype.isEnabled = function() {
            return this._enabled;
        }, cr.prototype.isActive = function() {
            return this._active;
        };
        var ur = function() {
            this._tap = new qo({
                numTouches: 1,
                numTaps: 1
            }), this.reset();
        };
        ur.prototype.reset = function() {
            this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
        }, ur.prototype.touchstart = function(t1, e1, i) {
            this._swipePoint || (this._tapTime && t1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = e1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(t1, e1, i));
        }, ur.prototype.touchmove = function(t1, e1, i) {
            if (this._tapTime) {
                if (this._swipePoint) {
                    if (i[0].identifier !== this._swipeTouch) return;
                    var o = e1[0], r = o.y - this._swipePoint.y;
                    return this._swipePoint = o, t1.preventDefault(), this._active = !0, {
                        zoomDelta: r / 128
                    };
                }
            } else this._tap.touchmove(t1, e1, i);
        }, ur.prototype.touchend = function(t1, e1, i) {
            this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(t1, e1, i) && (this._tapTime = t1.timeStamp);
        }, ur.prototype.touchcancel = function() {
            this.reset();
        }, ur.prototype.enable = function() {
            this._enabled = !0;
        }, ur.prototype.disable = function() {
            this._enabled = !1, this.reset();
        }, ur.prototype.isEnabled = function() {
            return this._enabled;
        }, ur.prototype.isActive = function() {
            return this._active;
        };
        var hr = function(t1, e1, i) {
            this._el = t1, this._mousePan = e1, this._touchPan = i;
        };
        hr.prototype.enable = function(t1) {
            this._inertiaOptions = t1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
        }, hr.prototype.disable = function() {
            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
        }, hr.prototype.isEnabled = function() {
            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
        }, hr.prototype.isActive = function() {
            return this._mousePan.isActive() || this._touchPan.isActive();
        };
        var pr = function(t1, e1, i) {
            this._pitchWithRotate = t1.pitchWithRotate, this._mouseRotate = e1, this._mousePitch = i;
        };
        pr.prototype.enable = function() {
            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
        }, pr.prototype.disable = function() {
            this._mouseRotate.disable(), this._mousePitch.disable();
        }, pr.prototype.isEnabled = function() {
            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
        }, pr.prototype.isActive = function() {
            return this._mouseRotate.isActive() || this._mousePitch.isActive();
        };
        var dr = function(t1, e1, i, o) {
            this._el = t1, this._touchZoom = e1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
        };
        dr.prototype.enable = function(t1) {
            this._touchZoom.enable(t1), this._rotationDisabled || this._touchRotate.enable(t1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
        }, dr.prototype.disable = function() {
            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
        }, dr.prototype.isEnabled = function() {
            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
        }, dr.prototype.isActive = function() {
            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
        }, dr.prototype.disableRotation = function() {
            this._rotationDisabled = !0, this._touchRotate.disable();
        }, dr.prototype.enableRotation = function() {
            this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
        };
        var _r = function(t1) {
            return t1.zoom || t1.drag || t1.pitch || t1.rotate;
        }, fr = function(t1) {
            function e1() {
                t1.apply(this, arguments);
            }
            return t1 && (e1.__proto__ = t1), (e1.prototype = Object.create(t1 && t1.prototype)).constructor = e1, e1;
        }(t1.Event);
        function mr(t1) {
            return t1.panDelta && t1.panDelta.mag() || t1.zoomDelta || t1.bearingDelta || t1.pitchDelta;
        }
        var gr = function(e1, o) {
            this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Ao(e1), this._bearingSnap = o.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(o), t1.bindAll([
                "handleEvent",
                "handleWindowEvent"
            ], this);
            var r = this._el;
            this._listeners = [
                [
                    r,
                    "touchstart",
                    {
                        passive: !0
                    }
                ],
                [
                    r,
                    "touchmove",
                    {
                        passive: !1
                    }
                ],
                [
                    r,
                    "touchend",
                    void 0
                ],
                [
                    r,
                    "touchcancel",
                    void 0
                ],
                [
                    r,
                    "mousedown",
                    void 0
                ],
                [
                    r,
                    "mousemove",
                    void 0
                ],
                [
                    r,
                    "mouseup",
                    void 0
                ],
                [
                    t1.window.document,
                    "mousemove",
                    {
                        capture: !0
                    }
                ],
                [
                    t1.window.document,
                    "mouseup",
                    void 0
                ],
                [
                    r,
                    "mouseover",
                    void 0
                ],
                [
                    r,
                    "mouseout",
                    void 0
                ],
                [
                    r,
                    "dblclick",
                    void 0
                ],
                [
                    r,
                    "click",
                    void 0
                ],
                [
                    r,
                    "keydown",
                    {
                        capture: !1
                    }
                ],
                [
                    r,
                    "keyup",
                    void 0
                ],
                [
                    r,
                    "wheel",
                    {
                        passive: !1
                    }
                ],
                [
                    r,
                    "contextmenu",
                    void 0
                ],
                [
                    t1.window,
                    "blur",
                    void 0
                ]
            ];
            for(var a = 0, n = this._listeners; a < n.length; a += 1){
                var s = n[a], l = s[0];
                i.addEventListener(l, s[1], l === t1.window.document ? this.handleWindowEvent : this.handleEvent, s[2]);
            }
        };
        gr.prototype.destroy = function() {
            for(var e1 = 0, o = this._listeners; e1 < o.length; e1 += 1){
                var r = o[e1], a = r[0];
                i.removeEventListener(a, r[1], a === t1.window.document ? this.handleWindowEvent : this.handleEvent, r[2]);
            }
        }, gr.prototype._addDefaultHandlers = function(t1) {
            var e1 = this._map, i = e1.getCanvasContainer();
            this._add("mapEvent", new Oo(e1, t1));
            var o = e1.boxZoom = new Uo(e1, t1);
            this._add("boxZoom", o);
            var r = new jo, a = new cr;
            e1.doubleClickZoom = new lr(a, r), this._add("tapZoom", r), this._add("clickZoom", a);
            var n = new ur;
            this._add("tapDragZoom", n);
            var s = e1.touchPitch = new or;
            this._add("touchPitch", s);
            var l = new Xo(t1), c = new Ho(t1);
            e1.dragRotate = new pr(t1, l, c), this._add("mouseRotate", l, [
                "mousePitch"
            ]), this._add("mousePitch", c, [
                "mouseRotate"
            ]);
            var u = new Wo(t1), h = new Ko(t1);
            e1.dragPan = new hr(i, u, h), this._add("mousePan", u), this._add("touchPan", h, [
                "touchZoom",
                "touchRotate"
            ]);
            var p = new er, d = new $o;
            e1.touchZoomRotate = new dr(i, d, p, n), this._add("touchRotate", p, [
                "touchPan",
                "touchZoom"
            ]), this._add("touchZoom", d, [
                "touchPan",
                "touchRotate"
            ]);
            var _ = e1.scrollZoom = new sr(e1, this);
            this._add("scrollZoom", _, [
                "mousePan"
            ]);
            var f = e1.keyboard = new ar;
            this._add("keyboard", f), this._add("blockableMapEvent", new Fo(e1));
            for(var m = 0, g = [
                "boxZoom",
                "doubleClickZoom",
                "tapDragZoom",
                "touchPitch",
                "dragRotate",
                "dragPan",
                "touchZoomRotate",
                "scrollZoom",
                "keyboard"
            ]; m < g.length; m += 1){
                var v = g[m];
                t1.interactive && t1[v] && e1[v].enable(t1[v]);
            }
        }, gr.prototype._add = function(t1, e1, i) {
            this._handlers.push({
                handlerName: t1,
                handler: e1,
                allowed: i
            }), this._handlersById[t1] = e1;
        }, gr.prototype.stop = function(t1) {
            if (!this._updatingCamera) {
                for(var e1 = 0, i = this._handlers; e1 < i.length; e1 += 1)i[e1].handler.reset();
                this._inertia.clear(), this._fireEvents({}, {}, t1), this._changes = [];
            }
        }, gr.prototype.isActive = function() {
            for(var t1 = 0, e1 = this._handlers; t1 < e1.length; t1 += 1)if (e1[t1].handler.isActive()) return !0;
            return !1;
        }, gr.prototype.isZooming = function() {
            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
        }, gr.prototype.isRotating = function() {
            return !!this._eventsInProgress.rotate;
        }, gr.prototype.isMoving = function() {
            return Boolean(_r(this._eventsInProgress)) || this.isZooming();
        }, gr.prototype._blockedByActive = function(t1, e1, i) {
            for(var o in t1)if (o !== i && (!e1 || e1.indexOf(o) < 0)) return !0;
            return !1;
        }, gr.prototype.handleWindowEvent = function(t1) {
            this.handleEvent(t1, t1.type + "Window");
        }, gr.prototype._getMapTouches = function(t1) {
            for(var e1 = [], i = 0, o = t1; i < o.length; i += 1){
                var r = o[i];
                this._el.contains(r.target) && e1.push(r);
            }
            return e1;
        }, gr.prototype.handleEvent = function(t1, e1) {
            this._updatingCamera = !0;
            for(var o = "renderFrame" === t1.type ? void 0 : t1, r = {
                needsRenderFrame: !1
            }, a = {}, n = {}, s = t1.touches ? this._getMapTouches(t1.touches) : void 0, l = s ? i.touchPos(this._el, s) : i.mousePos(this._el, t1), c = 0, u = this._handlers; c < u.length; c += 1){
                var h = u[c], p = h.handlerName, d = h.handler, _ = h.allowed;
                if (d.isEnabled()) {
                    var f = void 0;
                    this._blockedByActive(n, _, p) ? d.reset() : d[e1 || t1.type] && (f = d[e1 || t1.type](t1, l, s), this.mergeHandlerResult(r, a, f, p, o), f && f.needsRenderFrame && this._triggerRenderFrame()), (f || d.isActive()) && (n[p] = d);
                }
            }
            var m = {};
            for(var g in this._previousActiveHandlers)n[g] || (m[g] = o);
            this._previousActiveHandlers = n, (Object.keys(m).length || mr(r)) && (this._changes.push([
                r,
                a,
                m
            ]), this._triggerRenderFrame()), (Object.keys(n).length || mr(r)) && this._map._stop(!0), this._updatingCamera = !1;
            var v = r.cameraAnimation;
            v && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], v(this._map));
        }, gr.prototype.mergeHandlerResult = function(e1, i, o, r, a) {
            if (o) {
                t1.extend(e1, o);
                var n = {
                    handlerName: r,
                    originalEvent: o.originalEvent || a
                };
                void 0 !== o.zoomDelta && (i.zoom = n), void 0 !== o.panDelta && (i.drag = n), void 0 !== o.pitchDelta && (i.pitch = n), void 0 !== o.bearingDelta && (i.rotate = n);
            }
        }, gr.prototype._applyChanges = function() {
            for(var e1 = {}, i = {}, o = {}, r = 0, a = this._changes; r < a.length; r += 1){
                var n = a[r], s = n[0], l = n[1], c = n[2];
                s.panDelta && (e1.panDelta = (e1.panDelta || new t1.Point(0, 0))._add(s.panDelta)), s.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (e1.around = s.around), void 0 !== s.pinchAround && (e1.pinchAround = s.pinchAround), s.noInertia && (e1.noInertia = s.noInertia), t1.extend(i, l), t1.extend(o, c);
            }
            this._updateMapTransform(e1, i, o), this._changes = [];
        }, gr.prototype._updateMapTransform = function(t1, e1, i) {
            var o = this._map, r = o.transform;
            if (!mr(t1)) return this._fireEvents(e1, i, !0);
            var a = t1.panDelta, n = t1.zoomDelta, s = t1.bearingDelta, l = t1.pitchDelta, c = t1.around, u = t1.pinchAround;
            void 0 !== u && (c = u), o._stop(!0), c = c || o.transform.centerPoint;
            var h = r.pointLocation(a ? c.sub(a) : c);
            s && (r.bearing += s), l && (r.pitch += l), n && (r.zoom += n), r.setLocationAtPoint(h, c), this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(e1, i, !0);
        }, gr.prototype._fireEvents = function(e1, i, o) {
            var r = this, a = _r(this._eventsInProgress), n = _r(e1), s = {};
            for(var l in e1)this._eventsInProgress[l] || (s[l + "start"] = e1[l].originalEvent), this._eventsInProgress[l] = e1[l];
            for(var c in !a && n && this._fireEvent("movestart", n.originalEvent), s)this._fireEvent(c, s[c]);
            for(var u in n && this._fireEvent("move", n.originalEvent), e1)this._fireEvent(u, e1[u].originalEvent);
            var h, p = {};
            for(var d in this._eventsInProgress){
                var _ = this._eventsInProgress[d], f = _.handlerName, m = _.originalEvent;
                this._handlersById[f].isActive() || (delete this._eventsInProgress[d], p[d + "end"] = h = i[f] || m);
            }
            for(var g in p)this._fireEvent(g, p[g]);
            var v = _r(this._eventsInProgress);
            if (o && (a || n) && !v) {
                this._updatingCamera = !0;
                var y = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), x = function(t1) {
                    return 0 !== t1 && -r._bearingSnap < t1 && t1 < r._bearingSnap;
                };
                y ? (x(y.bearing || this._map.getBearing()) && (y.bearing = 0), this._map.easeTo(y, {
                    originalEvent: h
                })) : (this._map.fire(new t1.Event("moveend", {
                    originalEvent: h
                })), x(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
            }
        }, gr.prototype._fireEvent = function(e1, i) {
            this._map.fire(new t1.Event(e1, i ? {
                originalEvent: i
            } : {}));
        }, gr.prototype._requestFrame = function() {
            var t1 = this;
            return this._map.triggerRepaint(), this._map._renderTaskQueue.add(function(e1) {
                delete t1._frameId, t1.handleEvent(new fr("renderFrame", {
                    timeStamp: e1
                })), t1._applyChanges();
            });
        }, gr.prototype._triggerRenderFrame = function() {
            void 0 === this._frameId && (this._frameId = this._requestFrame());
        };
        var vr = function(e1) {
            function i(i, o) {
                e1.call(this), this._moving = !1, this._zooming = !1, this.transform = i, this._bearingSnap = o.bearingSnap, t1.bindAll([
                    "_renderFrameCallback"
                ], this);
            }
            return e1 && (i.__proto__ = e1), (i.prototype = Object.create(e1 && e1.prototype)).constructor = i, i.prototype.getCenter = function() {
                return new t1.LngLat(this.transform.center.lng, this.transform.center.lat);
            }, i.prototype.setCenter = function(t1, e1) {
                return this.jumpTo({
                    center: t1
                }, e1);
            }, i.prototype.panBy = function(e1, i, o) {
                return e1 = t1.Point.convert(e1).mult(-1), this.panTo(this.transform.center, t1.extend({
                    offset: e1
                }, i), o);
            }, i.prototype.panTo = function(e1, i, o) {
                return this.easeTo(t1.extend({
                    center: e1
                }, i), o);
            }, i.prototype.getZoom = function() {
                return this.transform.zoom;
            }, i.prototype.setZoom = function(t1, e1) {
                return this.jumpTo({
                    zoom: t1
                }, e1), this;
            }, i.prototype.zoomTo = function(e1, i, o) {
                return this.easeTo(t1.extend({
                    zoom: e1
                }, i), o);
            }, i.prototype.zoomIn = function(t1, e1) {
                return this.zoomTo(this.getZoom() + 1, t1, e1), this;
            }, i.prototype.zoomOut = function(t1, e1) {
                return this.zoomTo(this.getZoom() - 1, t1, e1), this;
            }, i.prototype.getBearing = function() {
                return this.transform.bearing;
            }, i.prototype.setBearing = function(t1, e1) {
                return this.jumpTo({
                    bearing: t1
                }, e1), this;
            }, i.prototype.getPadding = function() {
                return this.transform.padding;
            }, i.prototype.setPadding = function(t1, e1) {
                return this.jumpTo({
                    padding: t1
                }, e1), this;
            }, i.prototype.rotateTo = function(e1, i, o) {
                return this.easeTo(t1.extend({
                    bearing: e1
                }, i), o);
            }, i.prototype.resetNorth = function(e1, i) {
                return this.rotateTo(0, t1.extend({
                    duration: 1e3
                }, e1), i), this;
            }, i.prototype.resetNorthPitch = function(e1, i) {
                return this.easeTo(t1.extend({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e1), i), this;
            }, i.prototype.snapToNorth = function(t1, e1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t1, e1) : this;
            }, i.prototype.getPitch = function() {
                return this.transform.pitch;
            }, i.prototype.setPitch = function(t1, e1) {
                return this.jumpTo({
                    pitch: t1
                }, e1), this;
            }, i.prototype.cameraForBounds = function(e1, i) {
                e1 = t1.LngLatBounds.convert(e1);
                var o = i && i.bearing || 0;
                return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), o, i);
            }, i.prototype._cameraForBoxAndBearing = function(e1, i, o, r) {
                var a = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (r = t1.extend({
                    padding: a,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, r)).padding) {
                    var n = r.padding;
                    r.padding = {
                        top: n,
                        bottom: n,
                        right: n,
                        left: n
                    };
                }
                r.padding = t1.extend(a, r.padding);
                var s = this.transform, l = s.padding, c = s.project(t1.LngLat.convert(e1)), u = s.project(t1.LngLat.convert(i)), h = c.rotate(-o * Math.PI / 180), p = u.rotate(-o * Math.PI / 180), d = new t1.Point(Math.max(h.x, p.x), Math.max(h.y, p.y)), _ = new t1.Point(Math.min(h.x, p.x), Math.min(h.y, p.y)), f = d.sub(_), m = (s.width - (l.left + l.right + r.padding.left + r.padding.right)) / f.x, g = (s.height - (l.top + l.bottom + r.padding.top + r.padding.bottom)) / f.y;
                if (!(g < 0 || m < 0)) {
                    var v = Math.min(s.scaleZoom(s.scale * Math.min(m, g)), r.maxZoom), y = "number" == typeof r.offset.x ? new t1.Point(r.offset.x, r.offset.y) : t1.Point.convert(r.offset), x = new t1.Point((r.padding.left - r.padding.right) / 2, (r.padding.top - r.padding.bottom) / 2).rotate(o * Math.PI / 180), b = y.add(x).mult(s.scale / s.zoomScale(v));
                    return {
                        center: s.unproject(c.add(u).div(2).sub(b)),
                        zoom: v,
                        bearing: o
                    };
                }
                t1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
            }, i.prototype.fitBounds = function(t1, e1, i) {
                return this._fitInternal(this.cameraForBounds(t1, e1), e1, i);
            }, i.prototype.fitScreenCoordinates = function(e1, i, o, r, a) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t1.Point.convert(e1)), this.transform.pointLocation(t1.Point.convert(i)), o, r), r, a);
            }, i.prototype._fitInternal = function(e1, i, o) {
                return e1 ? (delete (i = t1.extend(e1, i)).padding, i.linear ? this.easeTo(i, o) : this.flyTo(i, o)) : this;
            }, i.prototype.jumpTo = function(e1, i) {
                this.stop();
                var o = this.transform, r = !1, a = !1, n = !1;
                return "zoom" in e1 && o.zoom !== +e1.zoom && (r = !0, o.zoom = +e1.zoom), void 0 !== e1.center && (o.center = t1.LngLat.convert(e1.center)), "bearing" in e1 && o.bearing !== +e1.bearing && (a = !0, o.bearing = +e1.bearing), "pitch" in e1 && o.pitch !== +e1.pitch && (n = !0, o.pitch = +e1.pitch), null == e1.padding || o.isPaddingEqual(e1.padding) || (o.padding = e1.padding), this.fire(new t1.Event("movestart", i)).fire(new t1.Event("move", i)), r && this.fire(new t1.Event("zoomstart", i)).fire(new t1.Event("zoom", i)).fire(new t1.Event("zoomend", i)), a && this.fire(new t1.Event("rotatestart", i)).fire(new t1.Event("rotate", i)).fire(new t1.Event("rotateend", i)), n && this.fire(new t1.Event("pitchstart", i)).fire(new t1.Event("pitch", i)).fire(new t1.Event("pitchend", i)), this.fire(new t1.Event("moveend", i));
            }, i.prototype.easeTo = function(e1, i) {
                var o = this;
                this._stop(!1, e1.easeId), (!1 === (e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t1.ease
                }, e1)).animate || !e1.essential && t1.browser.prefersReducedMotion) && (e1.duration = 0);
                var r = this.transform, a = this.getZoom(), n = this.getBearing(), s = this.getPitch(), l = this.getPadding(), c = "zoom" in e1 ? +e1.zoom : a, u = "bearing" in e1 ? this._normalizeBearing(e1.bearing, n) : n, h = "pitch" in e1 ? +e1.pitch : s, p = "padding" in e1 ? e1.padding : r.padding, d = t1.Point.convert(e1.offset), _ = r.centerPoint.add(d), f = r.pointLocation(_), m = t1.LngLat.convert(e1.center || f);
                this._normalizeCenter(m);
                var g, v, y = r.project(f), x = r.project(m).sub(y), b = r.zoomScale(c - a);
                e1.around && (g = t1.LngLat.convert(e1.around), v = r.locationPoint(g));
                var w = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = this._zooming || c !== a, this._rotating = this._rotating || n !== u, this._pitching = this._pitching || h !== s, this._padding = !r.isPaddingEqual(p), this._easeId = e1.easeId, this._prepareEase(i, e1.noMoveStart, w), this._ease(function(e1) {
                    if (o._zooming && (r.zoom = t1.number(a, c, e1)), o._rotating && (r.bearing = t1.number(n, u, e1)), o._pitching && (r.pitch = t1.number(s, h, e1)), o._padding && (r.interpolatePadding(l, p, e1), _ = r.centerPoint.add(d)), g) r.setLocationAtPoint(g, v);
                    else {
                        var f = r.zoomScale(r.zoom - a), m = c > a ? Math.min(2, b) : Math.max(.5, b), w = Math.pow(m, 1 - e1), T = r.unproject(y.add(x.mult(e1 * w)).mult(f));
                        r.setLocationAtPoint(r.renderWorldCopies ? T.wrap() : T, _);
                    }
                    o._fireMoveEvents(i);
                }, function(t1) {
                    o._afterEase(i, t1);
                }, e1), this;
            }, i.prototype._prepareEase = function(e1, i, o) {
                void 0 === o && (o = {}), this._moving = !0, i || o.moving || this.fire(new t1.Event("movestart", e1)), this._zooming && !o.zooming && this.fire(new t1.Event("zoomstart", e1)), this._rotating && !o.rotating && this.fire(new t1.Event("rotatestart", e1)), this._pitching && !o.pitching && this.fire(new t1.Event("pitchstart", e1));
            }, i.prototype._fireMoveEvents = function(e1) {
                this.fire(new t1.Event("move", e1)), this._zooming && this.fire(new t1.Event("zoom", e1)), this._rotating && this.fire(new t1.Event("rotate", e1)), this._pitching && this.fire(new t1.Event("pitch", e1));
            }, i.prototype._afterEase = function(e1, i) {
                if (!this._easeId || !i || this._easeId !== i) {
                    delete this._easeId;
                    var o = this._zooming, r = this._rotating, a = this._pitching;
                    this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new t1.Event("zoomend", e1)), r && this.fire(new t1.Event("rotateend", e1)), a && this.fire(new t1.Event("pitchend", e1)), this.fire(new t1.Event("moveend", e1));
                }
            }, i.prototype.flyTo = function(e1, i) {
                var o = this;
                if (!e1.essential && t1.browser.prefersReducedMotion) {
                    var r = t1.pick(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(r, i);
                }
                this.stop(), e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t1.ease
                }, e1);
                var a = this.transform, n = this.getZoom(), s = this.getBearing(), l = this.getPitch(), c = this.getPadding(), u = "zoom" in e1 ? t1.clamp(+e1.zoom, a.minZoom, a.maxZoom) : n, h = "bearing" in e1 ? this._normalizeBearing(e1.bearing, s) : s, p = "pitch" in e1 ? +e1.pitch : l, d = "padding" in e1 ? e1.padding : a.padding, _ = a.zoomScale(u - n), f = t1.Point.convert(e1.offset), m = a.centerPoint.add(f), g = a.pointLocation(m), v = t1.LngLat.convert(e1.center || g);
                this._normalizeCenter(v);
                var y = a.project(g), x = a.project(v).sub(y), b = e1.curve, w = Math.max(a.width, a.height), T = w / _, E = x.mag();
                if ("minZoom" in e1) {
                    var I = t1.clamp(Math.min(e1.minZoom, n, u), a.minZoom, a.maxZoom), P = w / a.zoomScale(I - n);
                    b = Math.sqrt(P / E * 2);
                }
                var S = b * b;
                function C(t1) {
                    var e1 = (T * T - w * w + (t1 ? -1 : 1) * S * S * E * E) / (2 * (t1 ? T : w) * S * E);
                    return Math.log(Math.sqrt(e1 * e1 + 1) - e1);
                }
                function z(t1) {
                    return (Math.exp(t1) - Math.exp(-t1)) / 2;
                }
                function D(t1) {
                    return (Math.exp(t1) + Math.exp(-t1)) / 2;
                }
                var A = C(0), M = function(t1) {
                    return D(A) / D(A + b * t1);
                }, L = function(t1) {
                    var e1;
                    return w * ((D(A) * (z(e1 = A + b * t1) / D(e1)) - z(A)) / S) / E;
                }, R = (C(1) - A) / b;
                if (Math.abs(E) < 1e-6 || !isFinite(R)) {
                    if (Math.abs(w - T) < 1e-6) return this.easeTo(e1, i);
                    var k = T < w ? -1 : 1;
                    R = Math.abs(Math.log(T / w)) / b, L = function() {
                        return 0;
                    }, M = function(t1) {
                        return Math.exp(k * b * t1);
                    };
                }
                return e1.duration = "duration" in e1 ? +e1.duration : 1e3 * R / ("screenSpeed" in e1 ? +e1.screenSpeed / b : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = s !== h, this._pitching = p !== l, this._padding = !a.isPaddingEqual(d), this._prepareEase(i, !1), this._ease(function(e1) {
                    var r = e1 * R, _ = 1 / M(r);
                    a.zoom = 1 === e1 ? u : n + a.scaleZoom(_), o._rotating && (a.bearing = t1.number(s, h, e1)), o._pitching && (a.pitch = t1.number(l, p, e1)), o._padding && (a.interpolatePadding(c, d, e1), m = a.centerPoint.add(f));
                    var g = 1 === e1 ? v : a.unproject(y.add(x.mult(L(r))).mult(_));
                    a.setLocationAtPoint(a.renderWorldCopies ? g.wrap() : g, m), o._fireMoveEvents(i);
                }, function() {
                    return o._afterEase(i);
                }, e1), this;
            }, i.prototype.isEasing = function() {
                return !!this._easeFrameId;
            }, i.prototype.stop = function() {
                return this._stop();
            }, i.prototype._stop = function(t1, e1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    var i = this._onEaseEnd;
                    delete this._onEaseEnd, i.call(this, e1);
                }
                if (!t1) {
                    var o = this.handlers;
                    o && o.stop(!1);
                }
                return this;
            }, i.prototype._ease = function(e1, i, o) {
                !1 === o.animate || 0 === o.duration ? (e1(1), i()) : (this._easeStart = t1.browser.now(), this._easeOptions = o, this._onEaseFrame = e1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }, i.prototype._renderFrameCallback = function() {
                var e1 = Math.min((t1.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
                this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }, i.prototype._normalizeBearing = function(e1, i) {
                e1 = t1.wrap(e1, -180, 180);
                var o = Math.abs(e1 - i);
                return Math.abs(e1 - 360 - i) < o && (e1 -= 360), Math.abs(e1 + 360 - i) < o && (e1 += 360), e1;
            }, i.prototype._normalizeCenter = function(t1) {
                var e1 = this.transform;
                if (e1.renderWorldCopies && !e1.lngRange) {
                    var i = t1.lng - e1.center.lng;
                    t1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
                }
            }, i;
        }(t1.Evented), yr = function(e1) {
            void 0 === e1 && (e1 = {}), this.options = e1, t1.bindAll([
                "_toggleAttribution",
                "_updateEditLink",
                "_updateData",
                "_updateCompact"
            ], this);
        };
        yr.prototype.getDefaultPosition = function() {
            return "bottom-right";
        }, yr.prototype.onAdd = function(t1) {
            var e1 = this.options && this.options.compact;
            return this._map = t1, this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = i.create("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = i.create("div", "mapboxgl-ctrl-attrib-inner", this._container), this._innerContainer.setAttribute("role", "list"), e1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === e1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
        }, yr.prototype.onRemove = function() {
            i.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
        }, yr.prototype._setElementTitle = function(t1, e1) {
            var i = this._map._getUIString("AttributionControl." + e1);
            t1.title = i, t1.setAttribute("aria-label", i);
        }, yr.prototype._toggleAttribution = function() {
            this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "true"));
        }, yr.prototype._updateEditLink = function() {
            var e1 = this._editLink;
            e1 || (e1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
            var i = [
                {
                    key: "owner",
                    value: this.styleOwner
                },
                {
                    key: "id",
                    value: this.styleId
                },
                {
                    key: "access_token",
                    value: this._map._requestManager._customAccessToken || t1.config.ACCESS_TOKEN
                }
            ];
            if (e1) {
                var o = i.reduce(function(t1, e1, o) {
                    return e1.value && (t1 += e1.key + "=" + e1.value + (o < i.length - 1 ? "&" : "")), t1;
                }, "?");
                e1.href = t1.config.FEEDBACK_URL + "/" + o + (this._map._hash ? this._map._hash.getHashString(!0) : ""), e1.rel = "noopener nofollow", this._setElementTitle(e1, "MapFeedback");
            }
        }, yr.prototype._updateData = function(t1) {
            !t1 || "metadata" !== t1.sourceDataType && "visibility" !== t1.sourceDataType && "style" !== t1.dataType || (this._updateAttributions(), this._updateEditLink());
        }, yr.prototype._updateAttributions = function() {
            if (this._map.style) {
                var t1 = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t1 = t1.concat(this.options.customAttribution.map(function(t1) {
                    return "string" != typeof t1 ? "" : t1;
                })) : "string" == typeof this.options.customAttribution && t1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    var e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                var i = this._map.style.sourceCaches;
                for(var o in i){
                    var r = i[o];
                    if (r.used) {
                        var a = r.getSource();
                        a.attribution && t1.indexOf(a.attribution) < 0 && t1.push(a.attribution);
                    }
                }
                t1.sort(function(t1, e1) {
                    return t1.length - e1.length;
                });
                var n = (t1 = t1.filter(function(e1, i) {
                    for(var o = i + 1; o < t1.length; o++)if (t1[o].indexOf(e1) >= 0) return !1;
                    return !0;
                })).join(" | ");
                n !== this._attribHTML && (this._attribHTML = n, t1.length ? (this._innerContainer.innerHTML = n, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
        }, yr.prototype._updateCompact = function() {
            this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
        };
        var xr = function() {
            t1.bindAll([
                "_updateLogo"
            ], this), t1.bindAll([
                "_updateCompact"
            ], this);
        };
        xr.prototype.onAdd = function(t1) {
            this._map = t1, this._container = i.create("div", "mapboxgl-ctrl");
            var e1 = i.create("a", "mapboxgl-ctrl-logo");
            return e1.target = "_blank", e1.rel = "noopener nofollow", e1.href = "https://www.mapbox.com/", e1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
        }, xr.prototype.onRemove = function() {
            i.remove(this._container), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
        }, xr.prototype.getDefaultPosition = function() {
            return "bottom-left";
        }, xr.prototype._updateLogo = function(t1) {
            t1 && "metadata" !== t1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
        }, xr.prototype._logoRequired = function() {
            if (this._map.style) {
                var t1 = this._map.style.sourceCaches;
                for(var e1 in t1)if (t1[e1].getSource().mapbox_logo) return !0;
                return !1;
            }
        }, xr.prototype._updateCompact = function() {
            var t1 = this._container.children;
            if (t1.length) {
                var e1 = t1[0];
                this._map.getCanvasContainer().offsetWidth < 250 ? e1.classList.add("mapboxgl-compact") : e1.classList.remove("mapboxgl-compact");
            }
        };
        var br = function() {
            this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
        };
        br.prototype.add = function(t1) {
            var e1 = ++this._id;
            return this._queue.push({
                callback: t1,
                id: e1,
                cancelled: !1
            }), e1;
        }, br.prototype.remove = function(t1) {
            for(var e1 = this._currentlyRunning, i = 0, o = e1 ? this._queue.concat(e1) : this._queue; i < o.length; i += 1){
                var r = o[i];
                if (r.id === t1) return void (r.cancelled = !0);
            }
        }, br.prototype.run = function(t1) {
            void 0 === t1 && (t1 = 0);
            var e1 = this._currentlyRunning = this._queue;
            this._queue = [];
            for(var i = 0, o = e1; i < o.length; i += 1){
                var r = o[i];
                if (!r.cancelled && (r.callback(t1), this._cleared)) break;
            }
            this._cleared = !1, this._currentlyRunning = !1;
        }, br.prototype.clear = function() {
            this._currentlyRunning && (this._cleared = !0), this._queue = [];
        };
        var wr = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm"
        }, Tr = t1.window.HTMLImageElement, Er = t1.window.HTMLElement, Ir = t1.window.ImageBitmap, Pr = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            crossSourceCollisions: !0
        }, Sr = function(o) {
            function r(e1) {
                var i = this;
                if (null != (e1 = t1.extend({}, Pr, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != e1.maxPitch && e1.maxPitch > 60) throw new Error("maxPitch must be less than or equal to 60");
                var r = new To(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies);
                if (o.call(this, r, e1), this._interactive = e1.interactive, this._maxTileCacheSize = e1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._crossSourceCollisions = e1.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e1.collectResourceTiming, this._renderTaskQueue = new br, this._controls = [], this._mapId = t1.uniqueId(), this._locale = t1.extend({}, wr, e1.locale), this._clickTolerance = e1.clickTolerance, this._requestManager = new t1.RequestManager(e1.transformRequest, e1.accessToken), "string" == typeof e1.container) {
                    if (this._container = t1.window.document.getElementById(e1.container), !this._container) throw new Error("Container '" + e1.container + "' not found.");
                } else {
                    if (!(e1.container instanceof Er)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    this._container = e1.container;
                }
                if (e1.maxBounds && this.setMaxBounds(e1.maxBounds), t1.bindAll([
                    "_onWindowOnline",
                    "_onWindowResize",
                    "_onMapScroll",
                    "_contextLost",
                    "_contextRestored"
                ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                this.on("move", function() {
                    return i._update(!1);
                }), this.on("moveend", function() {
                    return i._update(!1);
                }), this.on("zoom", function() {
                    return i._update(!0);
                }), void 0 !== t1.window && (t1.window.addEventListener("online", this._onWindowOnline, !1), t1.window.addEventListener("resize", this._onWindowResize, !1), t1.window.addEventListener("orientationchange", this._onWindowResize, !1)), this.handlers = new gr(this, e1), this._hash = e1.hash && new Io("string" == typeof e1.hash && e1.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                    center: e1.center,
                    zoom: e1.zoom,
                    bearing: e1.bearing,
                    pitch: e1.pitch
                }), e1.bounds && (this.resize(), this.fitBounds(e1.bounds, t1.extend({}, e1.fitBoundsOptions, {
                    duration: 0
                })))), this.resize(), this._localIdeographFontFamily = e1.localIdeographFontFamily, e1.style && this.setStyle(e1.style, {
                    localIdeographFontFamily: e1.localIdeographFontFamily
                }), e1.attributionControl && this.addControl(new yr({
                    customAttribution: e1.customAttribution
                })), this.addControl(new xr, e1.logoPosition), this.on("style.load", function() {
                    i.transform.unmodified && i.jumpTo(i.style.stylesheet);
                }), this.on("data", function(e1) {
                    i._update("style" === e1.dataType), i.fire(new t1.Event(e1.dataType + "data", e1));
                }), this.on("dataloading", function(e1) {
                    i.fire(new t1.Event(e1.dataType + "dataloading", e1));
                });
            }
            o && (r.__proto__ = o), (r.prototype = Object.create(o && o.prototype)).constructor = r;
            var a = {
                showTileBoundaries: {
                    configurable: !0
                },
                showPadding: {
                    configurable: !0
                },
                showCollisionBoxes: {
                    configurable: !0
                },
                showOverdrawInspector: {
                    configurable: !0
                },
                repaint: {
                    configurable: !0
                },
                vertices: {
                    configurable: !0
                },
                version: {
                    configurable: !0
                }
            };
            return r.prototype._getMapId = function() {
                return this._mapId;
            }, r.prototype.addControl = function(e1, i) {
                if (void 0 === i && (i = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                var o = e1.onAdd(this);
                this._controls.push(e1);
                var r = this._controlPositions[i];
                return -1 !== i.indexOf("bottom") ? r.insertBefore(o, r.firstChild) : r.appendChild(o), this;
            }, r.prototype.removeControl = function(e1) {
                if (!e1 || !e1.onRemove) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                var i = this._controls.indexOf(e1);
                return i > -1 && this._controls.splice(i, 1), e1.onRemove(this), this;
            }, r.prototype.hasControl = function(t1) {
                return this._controls.indexOf(t1) > -1;
            }, r.prototype.resize = function(e1) {
                var i = this._containerDimensions(), o = i[0], r = i[1];
                if (o === this.transform.width && r === this.transform.height) return this;
                this._resizeCanvas(o, r), this.transform.resize(o, r), this.painter.resize(o, r);
                var a = !this._moving;
                return a && this.fire(new t1.Event("movestart", e1)).fire(new t1.Event("move", e1)), this.fire(new t1.Event("resize", e1)), a && this.fire(new t1.Event("moveend", e1)), this;
            }, r.prototype.getBounds = function() {
                return this.transform.getBounds();
            }, r.prototype.getMaxBounds = function() {
                return this.transform.getMaxBounds();
            }, r.prototype.setMaxBounds = function(e1) {
                return this.transform.setMaxBounds(t1.LngLatBounds.convert(e1)), this._update();
            }, r.prototype.setMinZoom = function(t1) {
                if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 && this.setZoom(t1), this;
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }, r.prototype.getMinZoom = function() {
                return this.transform.minZoom;
            }, r.prototype.setMaxZoom = function(t1) {
                if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 && this.setZoom(t1), this;
                throw new Error("maxZoom must be greater than the current minZoom");
            }, r.prototype.getMaxZoom = function() {
                return this.transform.maxZoom;
            }, r.prototype.setMinPitch = function(t1) {
                if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 && this.setPitch(t1), this;
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }, r.prototype.getMinPitch = function() {
                return this.transform.minPitch;
            }, r.prototype.setMaxPitch = function(t1) {
                if ((t1 = null == t1 ? 60 : t1) > 60) throw new Error("maxPitch must be less than or equal to 60");
                if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 && this.setPitch(t1), this;
                throw new Error("maxPitch must be greater than the current minPitch");
            }, r.prototype.getMaxPitch = function() {
                return this.transform.maxPitch;
            }, r.prototype.getRenderWorldCopies = function() {
                return this.transform.renderWorldCopies;
            }, r.prototype.setRenderWorldCopies = function(t1) {
                return this.transform.renderWorldCopies = t1, this._update();
            }, r.prototype.project = function(e1) {
                return this.transform.locationPoint(t1.LngLat.convert(e1));
            }, r.prototype.unproject = function(e1) {
                return this.transform.pointLocation(t1.Point.convert(e1));
            }, r.prototype.isMoving = function() {
                return this._moving || this.handlers.isMoving();
            }, r.prototype.isZooming = function() {
                return this._zooming || this.handlers.isZooming();
            }, r.prototype.isRotating = function() {
                return this._rotating || this.handlers.isRotating();
            }, r.prototype._createDelegatedListener = function(t1, e1, i) {
                var o, r = this;
                if ("mouseenter" === t1 || "mouseover" === t1) {
                    var a = !1;
                    return {
                        layer: e1,
                        listener: i,
                        delegates: {
                            mousemove: function(o) {
                                var n = r.getLayer(e1) ? r.queryRenderedFeatures(o.point, {
                                    layers: [
                                        e1
                                    ]
                                }) : [];
                                n.length ? a || (a = !0, i.call(r, new Ro(t1, r, o.originalEvent, {
                                    features: n
                                }))) : a = !1;
                            },
                            mouseout: function() {
                                a = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === t1 || "mouseout" === t1) {
                    var n = !1;
                    return {
                        layer: e1,
                        listener: i,
                        delegates: {
                            mousemove: function(o) {
                                (r.getLayer(e1) ? r.queryRenderedFeatures(o.point, {
                                    layers: [
                                        e1
                                    ]
                                }) : []).length ? n = !0 : n && (n = !1, i.call(r, new Ro(t1, r, o.originalEvent)));
                            },
                            mouseout: function(e1) {
                                n && (n = !1, i.call(r, new Ro(t1, r, e1.originalEvent)));
                            }
                        }
                    };
                }
                return {
                    layer: e1,
                    listener: i,
                    delegates: (o = {}, o[t1] = function(t1) {
                        var o = r.getLayer(e1) ? r.queryRenderedFeatures(t1.point, {
                            layers: [
                                e1
                            ]
                        }) : [];
                        o.length && (t1.features = o, i.call(r, t1), delete t1.features);
                    }, o)
                };
            }, r.prototype.on = function(t1, e1, i) {
                if (void 0 === i) return o.prototype.on.call(this, t1, e1);
                var r = this._createDelegatedListener(t1, e1, i);
                for(var a in this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t1] = this._delegatedListeners[t1] || [], this._delegatedListeners[t1].push(r), r.delegates)this.on(a, r.delegates[a]);
                return this;
            }, r.prototype.once = function(t1, e1, i) {
                if (void 0 === i) return o.prototype.once.call(this, t1, e1);
                var r = this._createDelegatedListener(t1, e1, i);
                for(var a in r.delegates)this.once(a, r.delegates[a]);
                return this;
            }, r.prototype.off = function(t1, e1, i) {
                var r = this;
                return void 0 === i ? o.prototype.off.call(this, t1, e1) : (this._delegatedListeners && this._delegatedListeners[t1] && function(o) {
                    for(var a = o[t1], n = 0; n < a.length; n++){
                        var s = a[n];
                        if (s.layer === e1 && s.listener === i) {
                            for(var l in s.delegates)r.off(l, s.delegates[l]);
                            return a.splice(n, 1), r;
                        }
                    }
                }(this._delegatedListeners), this);
            }, r.prototype.queryRenderedFeatures = function(e1, i) {
                if (!this.style) return [];
                var o;
                if (void 0 !== i || void 0 === e1 || e1 instanceof t1.Point || Array.isArray(e1) || (i = e1, e1 = void 0), i = i || {}, (e1 = e1 || [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ]) instanceof t1.Point || "number" == typeof e1[0]) o = [
                    t1.Point.convert(e1)
                ];
                else {
                    var r = t1.Point.convert(e1[0]), a = t1.Point.convert(e1[1]);
                    o = [
                        r,
                        new t1.Point(a.x, r.y),
                        a,
                        new t1.Point(r.x, a.y),
                        r
                    ];
                }
                return this.style.queryRenderedFeatures(o, i, this.transform);
            }, r.prototype.querySourceFeatures = function(t1, e1) {
                return this.style.querySourceFeatures(t1, e1);
            }, r.prototype.setStyle = function(e1, i) {
                return !1 !== (i = t1.extend({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e1, i));
            }, r.prototype._getUIString = function(t1) {
                var e1 = this._locale[t1];
                if (null == e1) throw new Error("Missing UI string '" + t1 + "'");
                return e1;
            }, r.prototype._updateStyle = function(t1, e1) {
                return this.style && (this.style.setEventedParent(null), this.style._remove()), t1 ? (this.style = new je(this, e1 || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof t1 ? this.style.loadURL(t1) : this.style.loadJSON(t1), this) : (delete this.style, this);
            }, r.prototype._lazyInitEmptyStyle = function() {
                this.style || (this.style = new je(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }, r.prototype._diffStyle = function(e1, i) {
                var o = this;
                if ("string" == typeof e1) {
                    var r = this._requestManager.normalizeStyleURL(e1), a = this._requestManager.transformRequest(r, t1.ResourceType.Style);
                    t1.getJSON(a, function(e1, r) {
                        e1 ? o.fire(new t1.ErrorEvent(e1)) : r && o._updateDiff(r, i);
                    });
                } else "object" == typeof e1 && this._updateDiff(e1, i);
            }, r.prototype._updateDiff = function(e1, i) {
                try {
                    this.style.setState(e1) && this._update(!0);
                } catch (o) {
                    t1.warnOnce("Unable to perform style diff: " + (o.message || o.error || o) + ".  Rebuilding the style from scratch."), this._updateStyle(e1, i);
                }
            }, r.prototype.getStyle = function() {
                if (this.style) return this.style.serialize();
            }, r.prototype.isStyleLoaded = function() {
                return this.style ? this.style.loaded() : t1.warnOnce("There is no style added to the map.");
            }, r.prototype.addSource = function(t1, e1) {
                return this._lazyInitEmptyStyle(), this.style.addSource(t1, e1), this._update(!0);
            }, r.prototype.isSourceLoaded = function(e1) {
                var i = this.style && this.style.sourceCaches[e1];
                if (void 0 !== i) return i.loaded();
                this.fire(new t1.ErrorEvent(new Error("There is no source with ID '" + e1 + "'")));
            }, r.prototype.areTilesLoaded = function() {
                var t1 = this.style && this.style.sourceCaches;
                for(var e1 in t1){
                    var i = t1[e1]._tiles;
                    for(var o in i){
                        var r = i[o];
                        if ("loaded" !== r.state && "errored" !== r.state) return !1;
                    }
                }
                return !0;
            }, r.prototype.addSourceType = function(t1, e1, i) {
                return this._lazyInitEmptyStyle(), this.style.addSourceType(t1, e1, i);
            }, r.prototype.removeSource = function(t1) {
                return this.style.removeSource(t1), this._update(!0);
            }, r.prototype.getSource = function(t1) {
                return this.style.getSource(t1);
            }, r.prototype.addImage = function(e1, i, o) {
                void 0 === o && (o = {});
                var r = o.pixelRatio;
                void 0 === r && (r = 1);
                var a = o.sdf;
                void 0 === a && (a = !1);
                var n = o.stretchX, s = o.stretchY, l = o.content;
                if (this._lazyInitEmptyStyle(), i instanceof Tr || Ir && i instanceof Ir) {
                    var c = t1.browser.getImageData(i);
                    this.style.addImage(e1, {
                        data: new t1.RGBAImage({
                            width: c.width,
                            height: c.height
                        }, c.data),
                        pixelRatio: r,
                        stretchX: n,
                        stretchY: s,
                        content: l,
                        sdf: a,
                        version: 0
                    });
                } else {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    var u = i;
                    this.style.addImage(e1, {
                        data: new t1.RGBAImage({
                            width: i.width,
                            height: i.height
                        }, new Uint8Array(i.data)),
                        pixelRatio: r,
                        stretchX: n,
                        stretchY: s,
                        content: l,
                        sdf: a,
                        version: 0,
                        userImage: u
                    }), u.onAdd && u.onAdd(this, e1);
                }
            }, r.prototype.updateImage = function(e1, i) {
                var o = this.style.getImage(e1);
                if (!o) return this.fire(new t1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                var r = i instanceof Tr || Ir && i instanceof Ir ? t1.browser.getImageData(i) : i, a = r.width, n = r.height, s = r.data;
                return void 0 === a || void 0 === n ? this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))) : a !== o.data.width || n !== o.data.height ? this.fire(new t1.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image"))) : (o.data.replace(s, !(i instanceof Tr || Ir && i instanceof Ir)), void this.style.updateImage(e1, o));
            }, r.prototype.hasImage = function(e1) {
                return e1 ? !!this.style.getImage(e1) : (this.fire(new t1.ErrorEvent(new Error("Missing required image id"))), !1);
            }, r.prototype.removeImage = function(t1) {
                this.style.removeImage(t1);
            }, r.prototype.loadImage = function(e1, i) {
                t1.getImage(this._requestManager.transformRequest(e1, t1.ResourceType.Image), i);
            }, r.prototype.listImages = function() {
                return this.style.listImages();
            }, r.prototype.addLayer = function(t1, e1) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(t1, e1), this._update(!0);
            }, r.prototype.moveLayer = function(t1, e1) {
                return this.style.moveLayer(t1, e1), this._update(!0);
            }, r.prototype.removeLayer = function(t1) {
                return this.style.removeLayer(t1), this._update(!0);
            }, r.prototype.getLayer = function(t1) {
                return this.style.getLayer(t1);
            }, r.prototype.setLayerZoomRange = function(t1, e1, i) {
                return this.style.setLayerZoomRange(t1, e1, i), this._update(!0);
            }, r.prototype.setFilter = function(t1, e1, i) {
                return void 0 === i && (i = {}), this.style.setFilter(t1, e1, i), this._update(!0);
            }, r.prototype.getFilter = function(t1) {
                return this.style.getFilter(t1);
            }, r.prototype.setPaintProperty = function(t1, e1, i, o) {
                return void 0 === o && (o = {}), this.style.setPaintProperty(t1, e1, i, o), this._update(!0);
            }, r.prototype.getPaintProperty = function(t1, e1) {
                return this.style.getPaintProperty(t1, e1);
            }, r.prototype.setLayoutProperty = function(t1, e1, i, o) {
                return void 0 === o && (o = {}), this.style.setLayoutProperty(t1, e1, i, o), this._update(!0);
            }, r.prototype.getLayoutProperty = function(t1, e1) {
                return this.style.getLayoutProperty(t1, e1);
            }, r.prototype.setLight = function(t1, e1) {
                return void 0 === e1 && (e1 = {}), this._lazyInitEmptyStyle(), this.style.setLight(t1, e1), this._update(!0);
            }, r.prototype.getLight = function() {
                return this.style.getLight();
            }, r.prototype.setFeatureState = function(t1, e1) {
                return this.style.setFeatureState(t1, e1), this._update();
            }, r.prototype.removeFeatureState = function(t1, e1) {
                return this.style.removeFeatureState(t1, e1), this._update();
            }, r.prototype.getFeatureState = function(t1) {
                return this.style.getFeatureState(t1);
            }, r.prototype.getContainer = function() {
                return this._container;
            }, r.prototype.getCanvasContainer = function() {
                return this._canvasContainer;
            }, r.prototype.getCanvas = function() {
                return this._canvas;
            }, r.prototype._containerDimensions = function() {
                var t1 = 0, e1 = 0;
                return this._container && (t1 = this._container.clientWidth || 400, e1 = this._container.clientHeight || 300), [
                    t1,
                    e1
                ];
            }, r.prototype._detectMissingCSS = function() {
                "rgb(250, 128, 114)" !== t1.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && t1.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
            }, r.prototype._setupContainer = function() {
                var t1 = this._container;
                t1.classList.add("mapboxgl-map"), (this._missingCSSCanary = i.create("div", "mapboxgl-canary", t1)).style.visibility = "hidden", this._detectMissingCSS();
                var e1 = this._canvasContainer = i.create("div", "mapboxgl-canvas-container", t1);
                this._interactive && e1.classList.add("mapboxgl-interactive"), this._canvas = i.create("canvas", "mapboxgl-canvas", e1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                var o = this._containerDimensions();
                this._resizeCanvas(o[0], o[1]);
                var r = this._controlContainer = i.create("div", "mapboxgl-control-container", t1), a = this._controlPositions = {};
                [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ].forEach(function(t1) {
                    a[t1] = i.create("div", "mapboxgl-ctrl-" + t1, r);
                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }, r.prototype._resizeCanvas = function(e1, i) {
                var o = t1.browser.devicePixelRatio || 1;
                this._canvas.width = o * e1, this._canvas.height = o * i, this._canvas.style.width = e1 + "px", this._canvas.style.height = i + "px";
            }, r.prototype._setupPainter = function() {
                var i = t1.extend({}, e1.webGLContextAttributes, {
                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                    antialias: this._antialias || !1
                }), o = this._canvas.getContext("webgl", i) || this._canvas.getContext("experimental-webgl", i);
                o ? (this.painter = new yo(o, this.transform), t1.webpSupported.testSupport(o)) : this.fire(new t1.ErrorEvent(new Error("Failed to initialize WebGL")));
            }, r.prototype._contextLost = function(e1) {
                e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t1.Event("webglcontextlost", {
                    originalEvent: e1
                }));
            }, r.prototype._contextRestored = function(e1) {
                this._setupPainter(), this.resize(), this._update(), this.fire(new t1.Event("webglcontextrestored", {
                    originalEvent: e1
                }));
            }, r.prototype._onMapScroll = function(t1) {
                if (t1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
            }, r.prototype.loaded = function() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }, r.prototype._update = function(t1) {
                return this.style ? (this._styleDirty = this._styleDirty || t1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }, r.prototype._requestRenderFrame = function(t1) {
                return this._update(), this._renderTaskQueue.add(t1);
            }, r.prototype._cancelRenderFrame = function(t1) {
                this._renderTaskQueue.remove(t1);
            }, r.prototype._render = function(e1) {
                var i, o = this, r = 0, a = this.painter.context.extTimerQuery;
                if (this.listens("gpu-timing-frame") && (i = a.createQueryEXT(), a.beginQueryEXT(a.TIME_ELAPSED_EXT, i), r = t1.browser.now()), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), !this._removed) {
                    var n = !1;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        var s = this.transform.zoom, l = t1.browser.now();
                        this.style.zoomHistory.update(s, l);
                        var c = new t1.EvaluationParameters(s, {
                            now: l,
                            fadeDuration: this._fadeDuration,
                            zoomHistory: this.style.zoomHistory,
                            transition: this.style.getTransition()
                        }), u = c.crossFadingFactor();
                        1 === u && u === this._crossFadingFactor || (n = !0, this._crossFadingFactor = u), this.style.update(c);
                    }
                    if (this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions), this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showOverdrawInspector: this._showOverdrawInspector,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: this._fadeDuration,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer")
                    }), this.fire(new t1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new t1.Event("load"))), this.style && (this.style.hasTransitions() || n) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
                        var h = t1.browser.now() - r;
                        a.endQueryEXT(a.TIME_ELAPSED_EXT, i), setTimeout(function() {
                            var e1 = a.getQueryObjectEXT(i, a.QUERY_RESULT_EXT) / 1e6;
                            a.deleteQueryEXT(i), o.fire(new t1.Event("gpu-timing-frame", {
                                cpuTime: h,
                                gpuTime: e1
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        var p = this.painter.collectGpuTimers();
                        setTimeout(function() {
                            var e1 = o.painter.queryGpuTimers(p);
                            o.fire(new t1.Event("gpu-timing-layer", {
                                layerTimes: e1
                            }));
                        }, 50);
                    }
                    var d = this._sourcesDirty || this._styleDirty || this._placementDirty;
                    return d || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t1.Event("idle")), !this._loaded || this._fullyLoaded || d || (this._fullyLoaded = !0), this;
                }
            }, r.prototype.remove = function() {
                this._hash && this._hash.remove();
                for(var e1 = 0, i = this._controls; e1 < i.length; e1 += 1)i[e1].onRemove(this);
                this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), void 0 !== t1.window && (t1.window.removeEventListener("resize", this._onWindowResize, !1), t1.window.removeEventListener("orientationchange", this._onWindowResize, !1), t1.window.removeEventListener("online", this._onWindowOnline, !1));
                var o = this.painter.context.gl.getExtension("WEBGL_lose_context");
                o && o.loseContext(), Cr(this._canvasContainer), Cr(this._controlContainer), Cr(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), this._removed = !0, this.fire(new t1.Event("remove"));
            }, r.prototype.triggerRepaint = function() {
                var e1 = this;
                this.style && !this._frame && (this._frame = t1.browser.frame(function(t1) {
                    e1._frame = null, e1._render(t1);
                }));
            }, r.prototype._onWindowOnline = function() {
                this._update();
            }, r.prototype._onWindowResize = function(t1) {
                this._trackResize && this.resize({
                    originalEvent: t1
                })._update();
            }, a.showTileBoundaries.get = function() {
                return !!this._showTileBoundaries;
            }, a.showTileBoundaries.set = function(t1) {
                this._showTileBoundaries !== t1 && (this._showTileBoundaries = t1, this._update());
            }, a.showPadding.get = function() {
                return !!this._showPadding;
            }, a.showPadding.set = function(t1) {
                this._showPadding !== t1 && (this._showPadding = t1, this._update());
            }, a.showCollisionBoxes.get = function() {
                return !!this._showCollisionBoxes;
            }, a.showCollisionBoxes.set = function(t1) {
                this._showCollisionBoxes !== t1 && (this._showCollisionBoxes = t1, t1 ? this.style._generateCollisionBoxes() : this._update());
            }, a.showOverdrawInspector.get = function() {
                return !!this._showOverdrawInspector;
            }, a.showOverdrawInspector.set = function(t1) {
                this._showOverdrawInspector !== t1 && (this._showOverdrawInspector = t1, this._update());
            }, a.repaint.get = function() {
                return !!this._repaint;
            }, a.repaint.set = function(t1) {
                this._repaint !== t1 && (this._repaint = t1, this.triggerRepaint());
            }, a.vertices.get = function() {
                return !!this._vertices;
            }, a.vertices.set = function(t1) {
                this._vertices = t1, this._update();
            }, r.prototype._setCacheLimits = function(e1, i) {
                t1.setCacheLimits(e1, i);
            }, a.version.get = function() {
                return t1.version;
            }, Object.defineProperties(r.prototype, a), r;
        }(vr);
        function Cr(t1) {
            t1.parentNode && t1.parentNode.removeChild(t1);
        }
        var zr = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        }, Dr = function(e1) {
            var o = this;
            this.options = t1.extend({}, zr, e1), this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", function(t1) {
                return t1.preventDefault();
            }), this.options.showZoom && (t1.bindAll([
                "_setButtonTitle",
                "_updateZoomButtons"
            ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function(t1) {
                return o._map.zoomIn({}, {
                    originalEvent: t1
                });
            }), i.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", !0), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function(t1) {
                return o._map.zoomOut({}, {
                    originalEvent: t1
                });
            }), i.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", !0)), this.options.showCompass && (t1.bindAll([
                "_rotateCompassArrow"
            ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", function(t1) {
                o.options.visualizePitch ? o._map.resetNorthPitch({}, {
                    originalEvent: t1
                }) : o._map.resetNorth({}, {
                    originalEvent: t1
                });
            }), this._compassIcon = i.create("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", !0));
        };
        Dr.prototype._updateZoomButtons = function() {
            var t1 = this._map.getZoom(), e1 = t1 === this._map.getMaxZoom(), i = t1 === this._map.getMinZoom();
            this._zoomInButton.disabled = e1, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", e1.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
        }, Dr.prototype._rotateCompassArrow = function() {
            var t1 = this.options.visualizePitch ? "scale(" + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5) + ") rotateX(" + this._map.transform.pitch + "deg) rotateZ(" + this._map.transform.angle * (180 / Math.PI) + "deg)" : "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
            this._compassIcon.style.transform = t1;
        }, Dr.prototype.onAdd = function(t1) {
            return this._map = t1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Ar(this._map, this._compass, this.options.visualizePitch)), this._container;
        }, Dr.prototype.onRemove = function() {
            i.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
        }, Dr.prototype._createButton = function(t1, e1) {
            var o = i.create("button", t1, this._container);
            return o.type = "button", o.addEventListener("click", e1), o;
        }, Dr.prototype._setButtonTitle = function(t1, e1) {
            var i = this._map._getUIString("NavigationControl." + e1);
            t1.title = i, t1.setAttribute("aria-label", i);
        };
        var Ar = function(e1, o, r) {
            void 0 === r && (r = !1), this._clickTolerance = 10, this.element = o, this.mouseRotate = new Xo({
                clickTolerance: e1.dragRotate._mouseRotate._clickTolerance
            }), this.map = e1, r && (this.mousePitch = new Ho({
                clickTolerance: e1.dragRotate._mousePitch._clickTolerance
            })), t1.bindAll([
                "mousedown",
                "mousemove",
                "mouseup",
                "touchstart",
                "touchmove",
                "touchend",
                "reset"
            ], this), i.addEventListener(o, "mousedown", this.mousedown), i.addEventListener(o, "touchstart", this.touchstart, {
                passive: !1
            }), i.addEventListener(o, "touchmove", this.touchmove), i.addEventListener(o, "touchend", this.touchend), i.addEventListener(o, "touchcancel", this.reset);
        };
        function Mr(e1, i, o) {
            if (e1 = new t1.LngLat(e1.lng, e1.lat), i) {
                var r = new t1.LngLat(e1.lng - 360, e1.lat), a = new t1.LngLat(e1.lng + 360, e1.lat), n = o.locationPoint(e1).distSqr(i);
                o.locationPoint(r).distSqr(i) < n ? e1 = r : o.locationPoint(a).distSqr(i) < n && (e1 = a);
            }
            for(; Math.abs(e1.lng - o.center.lng) > 180;){
                var s = o.locationPoint(e1);
                if (s.x >= 0 && s.y >= 0 && s.x <= o.width && s.y <= o.height) break;
                e1.lng > o.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1;
        }
        Ar.prototype.down = function(t1, e1) {
            this.mouseRotate.mousedown(t1, e1), this.mousePitch && this.mousePitch.mousedown(t1, e1), i.disableDrag();
        }, Ar.prototype.move = function(t1, e1) {
            var i = this.map, o = this.mouseRotate.mousemoveWindow(t1, e1);
            if (o && o.bearingDelta && i.setBearing(i.getBearing() + o.bearingDelta), this.mousePitch) {
                var r = this.mousePitch.mousemoveWindow(t1, e1);
                r && r.pitchDelta && i.setPitch(i.getPitch() + r.pitchDelta);
            }
        }, Ar.prototype.off = function() {
            var t1 = this.element;
            i.removeEventListener(t1, "mousedown", this.mousedown), i.removeEventListener(t1, "touchstart", this.touchstart, {
                passive: !1
            }), i.removeEventListener(t1, "touchmove", this.touchmove), i.removeEventListener(t1, "touchend", this.touchend), i.removeEventListener(t1, "touchcancel", this.reset), this.offTemp();
        }, Ar.prototype.offTemp = function() {
            i.enableDrag(), i.removeEventListener(t1.window, "mousemove", this.mousemove), i.removeEventListener(t1.window, "mouseup", this.mouseup);
        }, Ar.prototype.mousedown = function(e1) {
            this.down(t1.extend({}, e1, {
                ctrlKey: !0,
                preventDefault: function() {
                    return e1.preventDefault();
                }
            }), i.mousePos(this.element, e1)), i.addEventListener(t1.window, "mousemove", this.mousemove), i.addEventListener(t1.window, "mouseup", this.mouseup);
        }, Ar.prototype.mousemove = function(t1) {
            this.move(t1, i.mousePos(this.element, t1));
        }, Ar.prototype.mouseup = function(t1) {
            this.mouseRotate.mouseupWindow(t1), this.mousePitch && this.mousePitch.mouseupWindow(t1), this.offTemp();
        }, Ar.prototype.touchstart = function(t1) {
            1 !== t1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = i.touchPos(this.element, t1.targetTouches)[0], this.down({
                type: "mousedown",
                button: 0,
                ctrlKey: !0,
                preventDefault: function() {
                    return t1.preventDefault();
                }
            }, this._startPos));
        }, Ar.prototype.touchmove = function(t1) {
            1 !== t1.targetTouches.length ? this.reset() : (this._lastPos = i.touchPos(this.element, t1.targetTouches)[0], this.move({
                preventDefault: function() {
                    return t1.preventDefault();
                }
            }, this._lastPos));
        }, Ar.prototype.touchend = function(t1) {
            0 === t1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
        }, Ar.prototype.reset = function() {
            this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        };
        var Lr = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function Rr(t1, e1, i) {
            var o = t1.classList;
            for(var r in Lr)o.remove("mapboxgl-" + i + "-anchor-" + r);
            o.add("mapboxgl-" + i + "-anchor-" + e1);
        }
        var kr, Br = function(e1) {
            function o(o, r) {
                if (e1.call(this), (o instanceof t1.window.HTMLElement || r) && (o = t1.extend({
                    element: o
                }, r)), t1.bindAll([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress"
                ], this), this._anchor = o && o.anchor || "center", this._color = o && o.color || "#3FB1CE", this._scale = o && o.scale || 1, this._draggable = o && o.draggable || !1, this._clickTolerance = o && o.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = o && o.rotation || 0, this._rotationAlignment = o && o.rotationAlignment || "auto", this._pitchAlignment = o && o.pitchAlignment && "auto" !== o.pitchAlignment ? o.pitchAlignment : this._rotationAlignment, o && o.element) this._element = o.element, this._offset = t1.Point.convert(o && o.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = i.create("div"), this._element.setAttribute("aria-label", "Map marker");
                    var a = i.createNS("http://www.w3.org/2000/svg", "svg");
                    a.setAttributeNS(null, "display", "block"), a.setAttributeNS(null, "height", "41px"), a.setAttributeNS(null, "width", "27px"), a.setAttributeNS(null, "viewBox", "0 0 27 41");
                    var n = i.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "stroke", "none"), n.setAttributeNS(null, "stroke-width", "1"), n.setAttributeNS(null, "fill", "none"), n.setAttributeNS(null, "fill-rule", "evenodd");
                    var s = i.createNS("http://www.w3.org/2000/svg", "g");
                    s.setAttributeNS(null, "fill-rule", "nonzero");
                    var l = i.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    for(var c = 0, u = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ]; c < u.length; c += 1){
                        var h = u[c], p = i.createNS("http://www.w3.org/2000/svg", "ellipse");
                        p.setAttributeNS(null, "opacity", "0.04"), p.setAttributeNS(null, "cx", "10.5"), p.setAttributeNS(null, "cy", "5.80029008"), p.setAttributeNS(null, "rx", h.rx), p.setAttributeNS(null, "ry", h.ry), l.appendChild(p);
                    }
                    var d = i.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "fill", this._color);
                    var _ = i.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), d.appendChild(_);
                    var f = i.createNS("http://www.w3.org/2000/svg", "g");
                    f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "fill", "#000000");
                    var m = i.createNS("http://www.w3.org/2000/svg", "path");
                    m.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), f.appendChild(m);
                    var g = i.createNS("http://www.w3.org/2000/svg", "g");
                    g.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), g.setAttributeNS(null, "fill", "#FFFFFF");
                    var v = i.createNS("http://www.w3.org/2000/svg", "g");
                    v.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    var y = i.createNS("http://www.w3.org/2000/svg", "circle");
                    y.setAttributeNS(null, "fill", "#000000"), y.setAttributeNS(null, "opacity", "0.25"), y.setAttributeNS(null, "cx", "5.5"), y.setAttributeNS(null, "cy", "5.5"), y.setAttributeNS(null, "r", "5.4999962");
                    var x = i.createNS("http://www.w3.org/2000/svg", "circle");
                    x.setAttributeNS(null, "fill", "#FFFFFF"), x.setAttributeNS(null, "cx", "5.5"), x.setAttributeNS(null, "cy", "5.5"), x.setAttributeNS(null, "r", "5.4999962"), v.appendChild(y), v.appendChild(x), s.appendChild(l), s.appendChild(d), s.appendChild(f), s.appendChild(g), s.appendChild(v), a.appendChild(s), a.setAttributeNS(null, "height", 41 * this._scale + "px"), a.setAttributeNS(null, "width", 27 * this._scale + "px"), this._element.appendChild(a), this._offset = t1.Point.convert(o && o.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", function(t1) {
                    t1.preventDefault();
                }), this._element.addEventListener("mousedown", function(t1) {
                    t1.preventDefault();
                }), Rr(this._element, this._anchor, "marker"), this._popup = null;
            }
            return e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o, o.prototype.addTo = function(t1) {
                return this.remove(), this._map = t1, t1.getCanvasContainer().appendChild(this._element), t1.on("move", this._update), t1.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }, o.prototype.remove = function() {
                return this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), i.remove(this._element), this._popup && this._popup.remove(), this;
            }, o.prototype.getLngLat = function() {
                return this._lngLat;
            }, o.prototype.setLngLat = function(e1) {
                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }, o.prototype.getElement = function() {
                return this._element;
            }, o.prototype.setPopup = function(t1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t1) {
                    if (!("offset" in t1.options)) {
                        var e1 = Math.sqrt(Math.pow(13.5, 2) / 2);
                        t1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -38.1
                            ],
                            "bottom-left": [
                                e1,
                                -1 * (24.6 + e1)
                            ],
                            "bottom-right": [
                                -e1,
                                -1 * (24.6 + e1)
                            ],
                            left: [
                                13.5,
                                -24.6
                            ],
                            right: [
                                -13.5,
                                -24.6
                            ]
                        } : this._offset;
                    }
                    this._popup = t1, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }, o.prototype._onKeyPress = function(t1) {
                var e1 = t1.code, i = t1.charCode || t1.keyCode;
                "Space" !== e1 && "Enter" !== e1 && 32 !== i && 13 !== i || this.togglePopup();
            }, o.prototype._onMapClick = function(t1) {
                var e1 = t1.originalEvent.target, i = this._element;
                this._popup && (e1 === i || i.contains(e1)) && this.togglePopup();
            }, o.prototype.getPopup = function() {
                return this._popup;
            }, o.prototype.togglePopup = function() {
                var t1 = this._popup;
                return t1 ? (t1.isOpen() ? t1.remove() : t1.addTo(this._map), this) : this;
            }, o.prototype._update = function(t1) {
                if (this._map) {
                    this._map.transform.renderWorldCopies && (this._lngLat = Mr(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                    var e1 = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? e1 = "rotateZ(" + this._rotation + "deg)" : "map" === this._rotationAlignment && (e1 = "rotateZ(" + (this._rotation - this._map.getBearing()) + "deg)");
                    var o = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? o = "rotateX(0deg)" : "map" === this._pitchAlignment && (o = "rotateX(" + this._map.getPitch() + "deg)"), t1 && "moveend" !== t1.type || (this._pos = this._pos.round()), i.setTransform(this._element, Lr[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px) " + o + " " + e1);
                }
            }, o.prototype.getOffset = function() {
                return this._offset;
            }, o.prototype.setOffset = function(e1) {
                return this._offset = t1.Point.convert(e1), this._update(), this;
            }, o.prototype._onMove = function(e1) {
                if (!this._isDragging) {
                    var i = this._clickTolerance || this._map._clickTolerance;
                    this._isDragging = e1.point.dist(this._pointerdownPos) >= i;
                }
                this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t1.Event("dragstart"))), this.fire(new t1.Event("drag")));
            }, o.prototype._onUp = function() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t1.Event("dragend")), this._state = "inactive";
            }, o.prototype._addDragHandler = function(t1) {
                this._element.contains(t1.originalEvent.target) && (t1.preventDefault(), this._positionDelta = t1.point.sub(this._pos).add(this._offset), this._pointerdownPos = t1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
            }, o.prototype.setDraggable = function(t1) {
                return this._draggable = !!t1, this._map && (t1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }, o.prototype.isDraggable = function() {
                return this._draggable;
            }, o.prototype.setRotation = function(t1) {
                return this._rotation = t1 || 0, this._update(), this;
            }, o.prototype.getRotation = function() {
                return this._rotation;
            }, o.prototype.setRotationAlignment = function(t1) {
                return this._rotationAlignment = t1 || "auto", this._update(), this;
            }, o.prototype.getRotationAlignment = function() {
                return this._rotationAlignment;
            }, o.prototype.setPitchAlignment = function(t1) {
                return this._pitchAlignment = t1 && "auto" !== t1 ? t1 : this._rotationAlignment, this._update(), this;
            }, o.prototype.getPitchAlignment = function() {
                return this._pitchAlignment;
            }, o;
        }(t1.Evented), Or = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        }, Fr = 0, Ur = !1, Nr = function(e1) {
            function o(i) {
                e1.call(this), this.options = t1.extend({}, Or, i), t1.bindAll([
                    "_onSuccess",
                    "_onError",
                    "_onZoom",
                    "_finish",
                    "_setupUI",
                    "_updateCamera",
                    "_updateMarker"
                ], this);
            }
            return e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o, o.prototype.onAdd = function(e1) {
                var o;
                return this._map = e1, this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), o = this._setupUI, void 0 !== kr ? o(kr) : void 0 !== t1.window.navigator.permissions ? t1.window.navigator.permissions.query({
                    name: "geolocation"
                }).then(function(t1) {
                    o(kr = "denied" !== t1.state);
                }) : o(kr = !!t1.window.navigator.geolocation), this._container;
            }, o.prototype.onRemove = function() {
                void 0 !== this._geolocationWatchID && (t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), i.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Fr = 0, Ur = !1;
            }, o.prototype._isOutOfMapMaxBounds = function(t1) {
                var e1 = this._map.getMaxBounds(), i = t1.coords;
                return e1 && (i.longitude < e1.getWest() || i.longitude > e1.getEast() || i.latitude < e1.getSouth() || i.latitude > e1.getNorth());
            }, o.prototype._setErrorState = function() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                }
            }, o.prototype._onSuccess = function(e1) {
                if (this._map) {
                    if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t1.Event("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                    if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                            break;
                        case "BACKGROUND":
                        case "BACKGROUND_ERROR":
                            this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                    }
                    this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("geolocate", e1)), this._finish();
                }
            }, o.prototype._updateCamera = function(e1) {
                var i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude), o = e1.coords.accuracy, r = this._map.getBearing(), a = t1.extend({
                    bearing: r
                }, this.options.fitBoundsOptions);
                this._map.fitBounds(i.toBounds(o), a, {
                    geolocateSource: !0
                });
            }, o.prototype._updateMarker = function(e1) {
                if (e1) {
                    var i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude);
                    this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
            }, o.prototype._updateCircleRadius = function() {
                var t1 = this._map._container.clientHeight / 2, e1 = this._map.unproject([
                    0,
                    t1
                ]), i = this._map.unproject([
                    1,
                    t1
                ]), o = e1.distanceTo(i), r = Math.ceil(2 * this._accuracy / o);
                this._circleElement.style.width = r + "px", this._circleElement.style.height = r + "px";
            }, o.prototype._onZoom = function() {
                this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
            }, o.prototype._onError = function(e1) {
                if (this._map) {
                    if (this.options.trackUserLocation) {
                        if (1 === e1.code) {
                            this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                            var i = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.title = i, this._geolocateButton.setAttribute("aria-label", i), void 0 !== this._geolocationWatchID && this._clearWatch();
                        } else {
                            if (3 === e1.code && Ur) return;
                            this._setErrorState();
                        }
                    }
                    "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("error", e1)), this._finish();
                }
            }, o.prototype._finish = function() {
                this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
            }, o.prototype._setupUI = function(e1) {
                var o = this;
                if (this._container.addEventListener("contextmenu", function(t1) {
                    return t1.preventDefault();
                }), this._geolocateButton = i.create("button", "mapboxgl-ctrl-geolocate", this._container), i.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", !0), this._geolocateButton.type = "button", !1 === e1) {
                    t1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                    var r = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                    this._geolocateButton.disabled = !0, this._geolocateButton.title = r, this._geolocateButton.setAttribute("aria-label", r);
                } else {
                    var a = this._map._getUIString("GeolocateControl.FindMyLocation");
                    this._geolocateButton.title = a, this._geolocateButton.setAttribute("aria-label", a);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = i.create("div", "mapboxgl-user-location-dot"), this._userLocationDotMarker = new Br(this._dotElement), this._circleElement = i.create("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Br({
                    element: this._circleElement,
                    pitchAlignment: "map"
                }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", function(e1) {
                    e1.geolocateSource || "ACTIVE_LOCK" !== o._watchState || e1.originalEvent && "resize" === e1.originalEvent.type || (o._watchState = "BACKGROUND", o._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), o._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), o.fire(new t1.Event("trackuserlocationend")));
                });
            }, o.prototype.trigger = function() {
                if (!this._setup) return t1.warnOnce("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new t1.Event("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            Fr--, Ur = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new t1.Event("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t1.Event("trackuserlocationstart"));
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_ERROR":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "BACKGROUND":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                            break;
                        case "BACKGROUND_ERROR":
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        var e1;
                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), ++Fr > 1 ? (e1 = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, Ur = !0) : (e1 = this.options.positionOptions, Ur = !1), this._geolocationWatchID = t1.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
                    }
                } else t1.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }, o.prototype._clearWatch = function() {
                t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }, o;
        }(t1.Evented), Zr = {
            maxWidth: 100,
            unit: "metric"
        }, qr = function(e1) {
            this.options = t1.extend({}, Zr, e1), t1.bindAll([
                "_onMove",
                "setUnit"
            ], this);
        };
        function jr(t1, e1, i) {
            var o = i && i.maxWidth || 100, r = t1._container.clientHeight / 2, a = t1.unproject([
                0,
                r
            ]), n = t1.unproject([
                o,
                r
            ]), s = a.distanceTo(n);
            if (i && "imperial" === i.unit) {
                var l = 3.2808 * s;
                l > 5280 ? Vr(e1, o, l / 5280, t1._getUIString("ScaleControl.Miles")) : Vr(e1, o, l, t1._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? Vr(e1, o, s / 1852, t1._getUIString("ScaleControl.NauticalMiles")) : s >= 1e3 ? Vr(e1, o, s / 1e3, t1._getUIString("ScaleControl.Kilometers")) : Vr(e1, o, s, t1._getUIString("ScaleControl.Meters"));
        }
        function Vr(t1, e1, i, o) {
            var r, a, n, s = (r = i, (a = Math.pow(10, ("" + Math.floor(r)).length - 1)) * (n = (n = r / a) >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : n >= 1 ? 1 : function(t1) {
                var e1 = Math.pow(10, Math.ceil(-Math.log(t1) / Math.LN10));
                return Math.round(t1 * e1) / e1;
            }(n)));
            t1.style.width = e1 * (s / i) + "px", t1.innerHTML = s + "&nbsp;" + o;
        }
        qr.prototype.getDefaultPosition = function() {
            return "bottom-left";
        }, qr.prototype._onMove = function() {
            jr(this._map, this._container, this.options);
        }, qr.prototype.onAdd = function(t1) {
            return this._map = t1, this._container = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", t1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
        }, qr.prototype.onRemove = function() {
            i.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
        }, qr.prototype.setUnit = function(t1) {
            this.options.unit = t1, jr(this._map, this._container, this.options);
        };
        var Gr = function(e1) {
            this._fullscreen = !1, e1 && e1.container && (e1.container instanceof t1.window.HTMLElement ? this._container = e1.container : t1.warnOnce("Full screen control 'container' must be a DOM element.")), t1.bindAll([
                "_onClickFullscreen",
                "_changeIcon"
            ], this), "onfullscreenchange" in t1.window.document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in t1.window.document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in t1.window.document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in t1.window.document && (this._fullscreenchange = "MSFullscreenChange");
        };
        Gr.prototype.onAdd = function(e1) {
            return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = i.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", t1.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
        }, Gr.prototype.onRemove = function() {
            i.remove(this._controlContainer), this._map = null, t1.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
        }, Gr.prototype._checkFullscreenSupport = function() {
            return !!(t1.window.document.fullscreenEnabled || t1.window.document.mozFullScreenEnabled || t1.window.document.msFullscreenEnabled || t1.window.document.webkitFullscreenEnabled);
        }, Gr.prototype._setupUI = function() {
            var e1 = this._fullscreenButton = i.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
            i.create("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", !0), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), t1.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
        }, Gr.prototype._updateTitle = function() {
            var t1 = this._getTitle();
            this._fullscreenButton.setAttribute("aria-label", t1), this._fullscreenButton.title = t1;
        }, Gr.prototype._getTitle = function() {
            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
        }, Gr.prototype._isFullscreen = function() {
            return this._fullscreen;
        }, Gr.prototype._changeIcon = function() {
            (t1.window.document.fullscreenElement || t1.window.document.mozFullScreenElement || t1.window.document.webkitFullscreenElement || t1.window.document.msFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
        }, Gr.prototype._onClickFullscreen = function() {
            this._isFullscreen() ? t1.window.document.exitFullscreen ? t1.window.document.exitFullscreen() : t1.window.document.mozCancelFullScreen ? t1.window.document.mozCancelFullScreen() : t1.window.document.msExitFullscreen ? t1.window.document.msExitFullscreen() : t1.window.document.webkitCancelFullScreen && t1.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
        };
        var Wr = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, Xr = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", "), Hr = function(e1) {
            function o(i) {
                e1.call(this), this.options = t1.extend(Object.create(Wr), i), t1.bindAll([
                    "_update",
                    "_onClose",
                    "remove",
                    "_onMouseMove",
                    "_onMouseUp",
                    "_onDrag"
                ], this);
            }
            return e1 && (o.__proto__ = e1), (o.prototype = Object.create(e1 && e1.prototype)).constructor = o, o.prototype.addTo = function(e1) {
                return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new t1.Event("open")), this;
            }, o.prototype.isOpen = function() {
                return !!this._map;
            }, o.prototype.remove = function() {
                return this._content && i.remove(this._content), this._container && (i.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t1.Event("close")), this;
            }, o.prototype.getLngLat = function() {
                return this._lngLat;
            }, o.prototype.setLngLat = function(e1) {
                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
            }, o.prototype.trackPointer = function() {
                return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
            }, o.prototype.getElement = function() {
                return this._container;
            }, o.prototype.setText = function(e1) {
                return this.setDOMContent(t1.window.document.createTextNode(e1));
            }, o.prototype.setHTML = function(e1) {
                var i, o = t1.window.document.createDocumentFragment(), r = t1.window.document.createElement("body");
                for(r.innerHTML = e1; i = r.firstChild;)o.appendChild(i);
                return this.setDOMContent(o);
            }, o.prototype.getMaxWidth = function() {
                return this._container && this._container.style.maxWidth;
            }, o.prototype.setMaxWidth = function(t1) {
                return this.options.maxWidth = t1, this._update(), this;
            }, o.prototype.setDOMContent = function(t1) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = i.create("div", "mapboxgl-popup-content", this._container);
                return this._content.appendChild(t1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }, o.prototype.addClassName = function(t1) {
                this._container && this._container.classList.add(t1);
            }, o.prototype.removeClassName = function(t1) {
                this._container && this._container.classList.remove(t1);
            }, o.prototype.setOffset = function(t1) {
                return this.options.offset = t1, this._update(), this;
            }, o.prototype.toggleClassName = function(t1) {
                if (this._container) return this._container.classList.toggle(t1);
            }, o.prototype._createCloseButton = function() {
                this.options.closeButton && (this._closeButton = i.create("button", "mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }, o.prototype._onMouseUp = function(t1) {
                this._update(t1.point);
            }, o.prototype._onMouseMove = function(t1) {
                this._update(t1.point);
            }, o.prototype._onDrag = function(t1) {
                this._update(t1.point);
            }, o.prototype._update = function(e1) {
                var o = this;
                if (this._map && (this._lngLat || this._trackPointer) && this._content && (this._container || (this._container = i.create("div", "mapboxgl-popup", this._map.getContainer()), this._tip = i.create("div", "mapboxgl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach(function(t1) {
                    return o._container.classList.add(t1);
                }), this._trackPointer && this._container.classList.add("mapboxgl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Mr(this._lngLat, this._pos, this._map.transform)), !this._trackPointer || e1)) {
                    var r = this._pos = this._trackPointer && e1 ? e1 : this._map.project(this._lngLat), a = this.options.anchor, n = function e1(i) {
                        if (i) {
                            if ("number" == typeof i) {
                                var o = Math.round(Math.sqrt(.5 * Math.pow(i, 2)));
                                return {
                                    center: new t1.Point(0, 0),
                                    top: new t1.Point(0, i),
                                    "top-left": new t1.Point(o, o),
                                    "top-right": new t1.Point(-o, o),
                                    bottom: new t1.Point(0, -i),
                                    "bottom-left": new t1.Point(o, -o),
                                    "bottom-right": new t1.Point(-o, -o),
                                    left: new t1.Point(i, 0),
                                    right: new t1.Point(-i, 0)
                                };
                            }
                            if (i instanceof t1.Point || Array.isArray(i)) {
                                var r = t1.Point.convert(i);
                                return {
                                    center: r,
                                    top: r,
                                    "top-left": r,
                                    "top-right": r,
                                    bottom: r,
                                    "bottom-left": r,
                                    "bottom-right": r,
                                    left: r,
                                    right: r
                                };
                            }
                            return {
                                center: t1.Point.convert(i.center || [
                                    0,
                                    0
                                ]),
                                top: t1.Point.convert(i.top || [
                                    0,
                                    0
                                ]),
                                "top-left": t1.Point.convert(i["top-left"] || [
                                    0,
                                    0
                                ]),
                                "top-right": t1.Point.convert(i["top-right"] || [
                                    0,
                                    0
                                ]),
                                bottom: t1.Point.convert(i.bottom || [
                                    0,
                                    0
                                ]),
                                "bottom-left": t1.Point.convert(i["bottom-left"] || [
                                    0,
                                    0
                                ]),
                                "bottom-right": t1.Point.convert(i["bottom-right"] || [
                                    0,
                                    0
                                ]),
                                left: t1.Point.convert(i.left || [
                                    0,
                                    0
                                ]),
                                right: t1.Point.convert(i.right || [
                                    0,
                                    0
                                ])
                            };
                        }
                        return e1(new t1.Point(0, 0));
                    }(this.options.offset);
                    if (!a) {
                        var s, l = this._container.offsetWidth, c = this._container.offsetHeight;
                        s = r.y + n.bottom.y < c ? [
                            "top"
                        ] : r.y > this._map.transform.height - c ? [
                            "bottom"
                        ] : [], r.x < l / 2 ? s.push("left") : r.x > this._map.transform.width - l / 2 && s.push("right"), a = 0 === s.length ? "bottom" : s.join("-");
                    }
                    var u = r.add(n[a]).round();
                    i.setTransform(this._container, Lr[a] + " translate(" + u.x + "px," + u.y + "px)"), Rr(this._container, a, "popup");
                }
            }, o.prototype._focusFirstElement = function() {
                if (this.options.focusAfterOpen && this._container) {
                    var t1 = this._container.querySelector(Xr);
                    t1 && t1.focus();
                }
            }, o.prototype._onClose = function() {
                this.remove();
            }, o;
        }(t1.Evented), Kr = {
            version: t1.version,
            supported: e1,
            setRTLTextPlugin: t1.setRTLTextPlugin,
            getRTLTextPluginStatus: t1.getRTLTextPluginStatus,
            Map: Sr,
            NavigationControl: Dr,
            GeolocateControl: Nr,
            AttributionControl: yr,
            ScaleControl: qr,
            FullscreenControl: Gr,
            Popup: Hr,
            Marker: Br,
            Style: je,
            LngLat: t1.LngLat,
            LngLatBounds: t1.LngLatBounds,
            Point: t1.Point,
            MercatorCoordinate: t1.MercatorCoordinate,
            Evented: t1.Evented,
            config: t1.config,
            prewarm: function() {
                Ft().acquire(Rt);
            },
            clearPrewarmedResources: function() {
                var t1 = Bt;
                t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(Rt), Bt = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return t1.config.ACCESS_TOKEN;
            },
            set accessToken (e){
                t1.config.ACCESS_TOKEN = e;
            },
            get baseApiUrl () {
                return t1.config.API_URL;
            },
            set baseApiUrl (e){
                t1.config.API_URL = e;
            },
            get workerCount () {
                return kt.workerCount;
            },
            set workerCount (t){
                kt.workerCount = t;
            },
            get maxParallelImageRequests () {
                return t1.config.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (e){
                t1.config.MAX_PARALLEL_IMAGE_REQUESTS = e;
            },
            clearStorage: function(e1) {
                t1.clearTileCache(e1);
            },
            workerUrl: ""
        };
        return Kr;
    });
    //
    return mapboxgl;
});

});

parcelRegister("25g61", function(module, exports) {

$parcel$export(module.exports, "$", () => $);
$parcel$export(module.exports, "addClass", () => addClass);
$parcel$export(module.exports, "removeClass", () => removeClass);
$parcel$export(module.exports, "toggleClass", () => toggleClass);
$parcel$export(module.exports, "hasClass", () => hasClass);
$parcel$export(module.exports, "attr", () => attr);
$parcel$export(module.exports, "removeAttr", () => removeAttr);
$parcel$export(module.exports, "transform", () => transform);
$parcel$export(module.exports, "transition", () => transition);
$parcel$export(module.exports, "on", () => on);
$parcel$export(module.exports, "off", () => off);
$parcel$export(module.exports, "trigger", () => trigger);
$parcel$export(module.exports, "transitionEnd", () => transitionEnd);
$parcel$export(module.exports, "outerWidth", () => outerWidth);
$parcel$export(module.exports, "outerHeight", () => outerHeight);
$parcel$export(module.exports, "offset", () => offset);
$parcel$export(module.exports, "styles", () => styles);
$parcel$export(module.exports, "css", () => css);
$parcel$export(module.exports, "each", () => each);
$parcel$export(module.exports, "filter", () => filter);
$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "index", () => index);
$parcel$export(module.exports, "eq", () => eq);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "prepend", () => prepend);
$parcel$export(module.exports, "next", () => next);
$parcel$export(module.exports, "nextAll", () => nextAll);
$parcel$export(module.exports, "prev", () => prev);
$parcel$export(module.exports, "prevAll", () => prevAll);
$parcel$export(module.exports, "parent", () => parent);
$parcel$export(module.exports, "parents", () => parents);
$parcel$export(module.exports, "closest", () => closest);
$parcel$export(module.exports, "find", () => find);
$parcel$export(module.exports, "children", () => children);
$parcel$export(module.exports, "remove", () => remove);
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $6fzuY = parcelRequire("6fzuY");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $6fzuY.getWindow)();
    const document = (0, $6fzuY.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $6fzuY.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, $6fzuY.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $6fzuY.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $6fzuY.getWindow)();
        const document = (0, $6fzuY.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, $6fzuY.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, $6fzuY.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $6fzuY.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $6fzuY.getWindow)();
    const document = (0, $6fzuY.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $6fzuY.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $6fzuY.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $6fzuY.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $6fzuY.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
var $184888bd8accd961$export$2e2bcd8739ae039 = $;

});
parcelRegister("6fzuY", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $48cfae140074808a$export$f65ca476c09acec0);
$parcel$export(module.exports, "getWindow", () => $48cfae140074808a$export$38b2d434cce3ea22);
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $48cfae140074808a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $48cfae140074808a$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($48cfae140074808a$var$isObject(src[key]) && $48cfae140074808a$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $48cfae140074808a$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $48cfae140074808a$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $48cfae140074808a$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $48cfae140074808a$export$8b58be045bf06082(doc, $48cfae140074808a$export$3fdcb9b4d81368d8);
    return doc;
}
const $48cfae140074808a$export$8582633f185c62bb = {
    document: $48cfae140074808a$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $48cfae140074808a$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $48cfae140074808a$export$8b58be045bf06082(win, $48cfae140074808a$export$8582633f185c62bb);
    return win;
}

});



document.addEventListener('keyup', function(e) {
    const key = e.key;
    if (key === 'Tab' || key === 'ArrowUp' || key === 'ArrowDown') {
        var elem = document.body;
        elem.classList.add('keyboard-navigation');
    }
});
document.addEventListener('mousedown', function() {
    var elem = document.body;
    elem.classList.remove('keyboard-navigation');
});



var $bvJM2 = parcelRequire("bvJM2");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $bvJM2 = parcelRequire("bvJM2");
var $7d9b5a7dd4dbaff5$var$_win, $7d9b5a7dd4dbaff5$var$_doc, $7d9b5a7dd4dbaff5$var$_docElement, $7d9b5a7dd4dbaff5$var$_pluginInitted, $7d9b5a7dd4dbaff5$var$_tempDiv, $7d9b5a7dd4dbaff5$var$_tempDivStyler, $7d9b5a7dd4dbaff5$var$_recentSetterPlugin, $7d9b5a7dd4dbaff5$var$_reverting, $7d9b5a7dd4dbaff5$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $7d9b5a7dd4dbaff5$var$_transformProps = {}, $7d9b5a7dd4dbaff5$var$_RAD2DEG = 180 / Math.PI, $7d9b5a7dd4dbaff5$var$_DEG2RAD = Math.PI / 180, $7d9b5a7dd4dbaff5$var$_atan2 = Math.atan2, $7d9b5a7dd4dbaff5$var$_bigNum = 1e8, $7d9b5a7dd4dbaff5$var$_capsExp = /([A-Z])/g, $7d9b5a7dd4dbaff5$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $7d9b5a7dd4dbaff5$var$_complexExp = /[\s,\(]\S/, $7d9b5a7dd4dbaff5$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $7d9b5a7dd4dbaff5$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $7d9b5a7dd4dbaff5$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $7d9b5a7dd4dbaff5$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $7d9b5a7dd4dbaff5$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_transformProp = "transform", $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin", $7d9b5a7dd4dbaff5$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $7d9b5a7dd4dbaff5$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $7d9b5a7dd4dbaff5$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $7d9b5a7dd4dbaff5$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $7d9b5a7dd4dbaff5$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $7d9b5a7dd4dbaff5$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($7d9b5a7dd4dbaff5$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, isNotCSS, "");
        }
        property = $7d9b5a7dd4dbaff5$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $7d9b5a7dd4dbaff5$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $7d9b5a7dd4dbaff5$var$_reverting();
        if ((!i || !i.isStart) && !style[$7d9b5a7dd4dbaff5$var$_transformProp]) {
            $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]) {
                style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $7d9b5a7dd4dbaff5$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $7d9b5a7dd4dbaff5$var$_revertStyle,
        save: $7d9b5a7dd4dbaff5$var$_saveStyle
    };
    target._gsap || (0, $bvJM2.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $7d9b5a7dd4dbaff5$var$_supports3D, $7d9b5a7dd4dbaff5$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $7d9b5a7dd4dbaff5$var$_doc.createElementNS ? $7d9b5a7dd4dbaff5$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $7d9b5a7dd4dbaff5$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $7d9b5a7dd4dbaff5$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $7d9b5a7dd4dbaff5$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($7d9b5a7dd4dbaff5$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $7d9b5a7dd4dbaff5$var$_prefixes[i] : "") + property;
}, $7d9b5a7dd4dbaff5$var$_initCore = function _initCore() {
    if ($7d9b5a7dd4dbaff5$var$_windowExists() && window.document) {
        $7d9b5a7dd4dbaff5$var$_win = window;
        $7d9b5a7dd4dbaff5$var$_doc = $7d9b5a7dd4dbaff5$var$_win.document;
        $7d9b5a7dd4dbaff5$var$_docElement = $7d9b5a7dd4dbaff5$var$_doc.documentElement;
        $7d9b5a7dd4dbaff5$var$_tempDiv = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $7d9b5a7dd4dbaff5$var$_tempDivStyler = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div");
        $7d9b5a7dd4dbaff5$var$_transformProp = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b($7d9b5a7dd4dbaff5$var$_transformProp);
        $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin";
        $7d9b5a7dd4dbaff5$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $7d9b5a7dd4dbaff5$var$_supports3D = !!$7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b("perspective");
        $7d9b5a7dd4dbaff5$var$_reverting = (0, $bvJM2.gsap).core.reverting;
        $7d9b5a7dd4dbaff5$var$_pluginInitted = 1;
    }
}, $7d9b5a7dd4dbaff5$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $7d9b5a7dd4dbaff5$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $7d9b5a7dd4dbaff5$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $7d9b5a7dd4dbaff5$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $7d9b5a7dd4dbaff5$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $7d9b5a7dd4dbaff5$var$_getBBoxHack || (bounds = $7d9b5a7dd4dbaff5$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $7d9b5a7dd4dbaff5$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$7d9b5a7dd4dbaff5$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp) property = $7d9b5a7dd4dbaff5$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $7d9b5a7dd4dbaff5$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $7d9b5a7dd4dbaff5$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$7d9b5a7dd4dbaff5$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $7d9b5a7dd4dbaff5$var$_tempDiv.style, horizontal = $7d9b5a7dd4dbaff5$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[unit] || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($7d9b5a7dd4dbaff5$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bvJM2._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $7d9b5a7dd4dbaff5$var$_doc || !parent.appendChild) parent = $7d9b5a7dd4dbaff5$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bvJM2._ticker).time && !cache.uncache) return (0, $bvJM2._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $7d9b5a7dd4dbaff5$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$7d9b5a7dd4dbaff5$var$_nonStandardLayouts[$7d9b5a7dd4dbaff5$var$_getComputedProperty(parent, "display")] && (style.position = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            px = $7d9b5a7dd4dbaff5$var$_tempDiv[measureProperty];
            parent.removeChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bvJM2._getCache)(parent);
            cache.time = (0, $bvJM2._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bvJM2._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $7d9b5a7dd4dbaff5$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore();
    if (property in $7d9b5a7dd4dbaff5$var$_propertyAliases && property !== "transform") {
        property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($7d9b5a7dd4dbaff5$var$_transformProps[property] && property !== "transform") {
        value = $7d9b5a7dd4dbaff5$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $7d9b5a7dd4dbaff5$var$_firstTwoOnly($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $7d9b5a7dd4dbaff5$var$_specialProps[property] && $7d9b5a7dd4dbaff5$var$_specialProps[property](target, property, unit) || $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, property) || (0, $bvJM2._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bvJM2.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bvJM2._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bvJM2._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bvJM2._numWithUnitExp)) || [];
    endValues = end.match((0, $bvJM2._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bvJM2._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bvJM2._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bvJM2._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bvJM2._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue;
    (0, $bvJM2._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $7d9b5a7dd4dbaff5$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[x] || x;
    split[1] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $7d9b5a7dd4dbaff5$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($7d9b5a7dd4dbaff5$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $7d9b5a7dd4dbaff5$var$_transformOriginProp : $7d9b5a7dd4dbaff5$var$_transformProp;
                }
                $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$7d9b5a7dd4dbaff5$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 0, $7d9b5a7dd4dbaff5$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $7d9b5a7dd4dbaff5$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $7d9b5a7dd4dbaff5$var$_rotationalProperties = {}, $7d9b5a7dd4dbaff5$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
    return $7d9b5a7dd4dbaff5$var$_isNullTransform(matrixString) ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrixString.substr(7).match((0, $bvJM2._numExp)).map((0, $bvJM2._round));
}, $7d9b5a7dd4dbaff5$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bvJM2._getCache)(target), style = target.style, matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrix;
    } else if (matrix === $7d9b5a7dd4dbaff5$var$_identity2DMatrix && !target.offsetParent && target !== $7d9b5a7dd4dbaff5$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $7d9b5a7dd4dbaff5$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $7d9b5a7dd4dbaff5$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $7d9b5a7dd4dbaff5$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $7d9b5a7dd4dbaff5$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $7d9b5a7dd4dbaff5$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bvJM2.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$7d9b5a7dd4dbaff5$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$7d9b5a7dd4dbaff5$var$_transformProp] !== "none" ? cs[$7d9b5a7dd4dbaff5$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $7d9b5a7dd4dbaff5$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $7d9b5a7dd4dbaff5$var$_atan2(b, a) * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $7d9b5a7dd4dbaff5$var$_atan2(c, d) * $7d9b5a7dd4dbaff5$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $7d9b5a7dd4dbaff5$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a32, a33);
            rotationX = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $7d9b5a7dd4dbaff5$var$_atan2(-c, a33);
            rotationY = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $7d9b5a7dd4dbaff5$var$_atan2(b, a);
            rotation = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bvJM2._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bvJM2._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$7d9b5a7dd4dbaff5$var$_isNullTransform($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bvJM2._round)(scaleX);
    cache.scaleY = (0, $bvJM2._round)(scaleY);
    cache.rotation = (0, $bvJM2._round)(rotation) + deg;
    cache.rotationX = (0, $bvJM2._round)(rotationX) + deg;
    cache.rotationY = (0, $bvJM2._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = $7d9b5a7dd4dbaff5$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bvJM2._config).force3D;
    cache.renderTransform = cache.svg ? $7d9b5a7dd4dbaff5$var$_renderSVGTransforms : $7d9b5a7dd4dbaff5$var$_supports3D ? $7d9b5a7dd4dbaff5$var$_renderCSSTransforms : $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $7d9b5a7dd4dbaff5$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$7d9b5a7dd4dbaff5$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bvJM2.getUnit)(start);
    return (0, $bvJM2._round)(parseFloat(start) + parseFloat($7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $7d9b5a7dd4dbaff5$var$_renderCSSTransforms(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_zeroDeg = "0deg", $7d9b5a7dd4dbaff5$var$_zeroPx = "0px", $7d9b5a7dd4dbaff5$var$_endParenthesis = ") ", $7d9b5a7dd4dbaff5$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $7d9b5a7dd4dbaff5$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += "perspective(" + transformPerspective + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $7d9b5a7dd4dbaff5$var$_zeroPx || y !== $7d9b5a7dd4dbaff5$var$_zeroPx || z !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += z !== $7d9b5a7dd4dbaff5$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotation !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotate(" + rotation + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateY(" + rotationY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateX(" + rotationX + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (skewX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || skewY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms || "translate(0, 0)";
}, $7d9b5a7dd4dbaff5$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        skewX *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bvJM2._round)(a11);
        a21 = (0, $bvJM2._round)(a21);
        a12 = (0, $bvJM2._round)(a12);
        a22 = (0, $bvJM2._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", x, "px");
        ty = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bvJM2._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bvJM2._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bvJM2._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bvJM2._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $7d9b5a7dd4dbaff5$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bvJM2._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $7d9b5a7dd4dbaff5$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, startNum, change, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $7d9b5a7dd4dbaff5$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $7d9b5a7dd4dbaff5$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$7d9b5a7dd4dbaff5$var$_transformProp];
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = startValue;
    }
    for(p in $7d9b5a7dd4dbaff5$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bvJM2.getUnit)(startValue);
            endUnit = (0, $bvJM2.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $7d9b5a7dd4dbaff5$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bvJM2._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $7d9b5a7dd4dbaff5$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $7d9b5a7dd4dbaff5$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $7d9b5a7dd4dbaff5$export$855822f522f18eef = {
    name: "css",
    register: $7d9b5a7dd4dbaff5$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $7d9b5a7dd4dbaff5$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bvJM2._plugins)[p] && (0, $bvJM2._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $7d9b5a7dd4dbaff5$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bvJM2._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bvJM2._colorExp).lastIndex = 0;
                if (!(0, $bvJM2._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bvJM2.getUnit)(startValue);
                    endUnit = (0, $bvJM2.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bvJM2._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bvJM2._replaceRandom)(startValue));
                    (0, $bvJM2.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bvJM2._config).units[p] || (0, $bvJM2.getUnit)($7d9b5a7dd4dbaff5$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $7d9b5a7dd4dbaff5$var$_get(target, p)); // can't work with relative values
                } else startValue = $7d9b5a7dd4dbaff5$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $7d9b5a7dd4dbaff5$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $7d9b5a7dd4dbaff5$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $7d9b5a7dd4dbaff5$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $7d9b5a7dd4dbaff5$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $7d9b5a7dd4dbaff5$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bvJM2.PropTween)(this._pt, style, $7d9b5a7dd4dbaff5$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bvJM2.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bvJM2._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, 0, style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]);
                        endValue = $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, p, $7d9b5a7dd4dbaff5$var$_firstTwoOnly(startValue), $7d9b5a7dd4dbaff5$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $7d9b5a7dd4dbaff5$var$_rotationalProperties) {
                        $7d9b5a7dd4dbaff5$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bvJM2._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $7d9b5a7dd4dbaff5$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$7d9b5a7dd4dbaff5$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bvJM2.getUnit)(endValue) || (p in (0, $bvJM2._config).units ? (0, $bvJM2._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bvJM2.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bvJM2._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp : $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bvJM2._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bvJM2._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$7d9b5a7dd4dbaff5$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $7d9b5a7dd4dbaff5$var$_get,
    aliases: $7d9b5a7dd4dbaff5$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp && (target._gsap.x || $7d9b5a7dd4dbaff5$var$_get(target, "x")) ? plugin && $7d9b5a7dd4dbaff5$var$_recentSetterPlugin === plugin ? property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScale : $7d9b5a7dd4dbaff5$var$_setterTransform : ($7d9b5a7dd4dbaff5$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScaleWithRender : $7d9b5a7dd4dbaff5$var$_setterTransformWithRender) : target.style && !(0, $bvJM2._isUndefined)(target.style[property]) ? $7d9b5a7dd4dbaff5$var$_setterCSSStyle : ~property.indexOf("-") ? $7d9b5a7dd4dbaff5$var$_setterCSSProp : (0, $bvJM2._getSetter)(target, property);
    },
    core: {
        _removeProperty: $7d9b5a7dd4dbaff5$var$_removeProperty,
        _getMatrix: $7d9b5a7dd4dbaff5$var$_getMatrix
    }
};
(0, $bvJM2.gsap).utils.checkPrefix = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b;
(0, $bvJM2.gsap).core.getStyleSaver = $7d9b5a7dd4dbaff5$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bvJM2._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $7d9b5a7dd4dbaff5$var$_transformProps[name] = 1;
    });
    (0, $bvJM2._forEachName)(rotation, function(name) {
        (0, $bvJM2._config).units[name] = "deg";
        $7d9b5a7dd4dbaff5$var$_rotationalProperties[name] = 1;
    });
    $7d9b5a7dd4dbaff5$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bvJM2._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $7d9b5a7dd4dbaff5$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bvJM2._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bvJM2._config).units[name] = "px";
});
(0, $bvJM2.gsap).registerPlugin($7d9b5a7dd4dbaff5$export$855822f522f18eef);


var $1974f63041948ee8$export$99ee26438460406a = (0, $bvJM2.gsap).registerPlugin((0, $7d9b5a7dd4dbaff5$export$855822f522f18eef)) || (0, $bvJM2.gsap), // to protect from tree shaking
$1974f63041948ee8$export$7b23975ad686bf91 = $1974f63041948ee8$export$99ee26438460406a.core.Tween;



/*
IE11 support
 */ var $7675ab03fcd9732b$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $7675ab03fcd9732b$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $7675ab03fcd9732b$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};


/**
 * defines a focus group
 */ var $dd2aed5bcdbb58ae$export$4f9a06cb7441a087 = 'data-focus-lock';
var $dd2aed5bcdbb58ae$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $dd2aed5bcdbb58ae$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $dd2aed5bcdbb58ae$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $dd2aed5bcdbb58ae$export$134ebef29fd94853 = 'data-no-autofocus';


var $8c0e782f6b12a8a6$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $8c0e782f6b12a8a6$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $8c0e782f6b12a8a6$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $8c0e782f6b12a8a6$var$isVisibleUncached = function(node, checkParent) {
    return !node || $8c0e782f6b12a8a6$var$isTopNode(node) || !$8c0e782f6b12a8a6$var$isElementHidden(node) && checkParent($8c0e782f6b12a8a6$var$getParentNode(node));
};
var $8c0e782f6b12a8a6$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $8c0e782f6b12a8a6$var$isVisibleUncached(node, $8c0e782f6b12a8a6$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $8c0e782f6b12a8a6$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$8c0e782f6b12a8a6$var$isTopNode(node) ? $8c0e782f6b12a8a6$export$b8550e27de209d85(node) ? checkParent($8c0e782f6b12a8a6$var$getParentNode(node)) : false : true;
};
var $8c0e782f6b12a8a6$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $8c0e782f6b12a8a6$var$isAutoFocusAllowedUncached(node, $8c0e782f6b12a8a6$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $8c0e782f6b12a8a6$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $8c0e782f6b12a8a6$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $8c0e782f6b12a8a6$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $8c0e782f6b12a8a6$export$9d74f6fbc6f469d0 = function(node) {
    return $8c0e782f6b12a8a6$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $8c0e782f6b12a8a6$export$8197b0ea56b3b055 = function(node) {
    return !(($8c0e782f6b12a8a6$export$88a6ceeed5737ba3(node) || $8c0e782f6b12a8a6$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $8c0e782f6b12a8a6$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $dd2aed5bcdbb58ae$export$134ebef29fd94853));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $8c0e782f6b12a8a6$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $8c0e782f6b12a8a6$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $8c0e782f6b12a8a6$export$602e5a0d338d7750 = function(node) {
    return !$8c0e782f6b12a8a6$export$d94b8b58ec2f30eb(node);
};
var $8c0e782f6b12a8a6$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $f6ed31bac90361d2$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $f6ed31bac90361d2$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $7675ab03fcd9732b$export$45b10814cc054894)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($f6ed31bac90361d2$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $3b893dc54a289fdc$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];


var $52e0019fb939d5cb$var$queryTabbables = (0, $3b893dc54a289fdc$export$8555f4622e95784).join(',');
var $52e0019fb939d5cb$var$queryGuardTabbables = "".concat($52e0019fb939d5cb$var$queryTabbables, ", [data-focus-guard]");
var $52e0019fb939d5cb$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $7675ab03fcd9732b$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $52e0019fb939d5cb$var$queryGuardTabbables : $52e0019fb939d5cb$var$queryTabbables) ? [
            child
        ] : [], $52e0019fb939d5cb$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $52e0019fb939d5cb$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $52e0019fb939d5cb$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $52e0019fb939d5cb$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $52e0019fb939d5cb$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $52e0019fb939d5cb$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $7675ab03fcd9732b$export$45b10814cc054894)(parent.parentNode.querySelectorAll($52e0019fb939d5cb$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $52e0019fb939d5cb$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $dd2aed5bcdbb58ae$export$70e9b4a1820af101), "]"));
    return (0, $7675ab03fcd9732b$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $52e0019fb939d5cb$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $e0b683520340e319$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $7675ab03fcd9732b$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $8c0e782f6b12a8a6$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $8c0e782f6b12a8a6$export$8197b0ea56b3b055)(node);
    });
};
var $e0b683520340e319$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $7675ab03fcd9732b$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $8c0e782f6b12a8a6$export$bcaa50628f6a736e)(cache, node);
    });
};
var $e0b683520340e319$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $f6ed31bac90361d2$export$cb40ee071f0d5226)($e0b683520340e319$export$6266a5cd5915dc33((0, $52e0019fb939d5cb$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $e0b683520340e319$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $f6ed31bac90361d2$export$cb40ee071f0d5226)($e0b683520340e319$export$6266a5cd5915dc33((0, $52e0019fb939d5cb$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $e0b683520340e319$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $e0b683520340e319$export$6266a5cd5915dc33((0, $52e0019fb939d5cb$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $e0b683520340e319$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $e0b683520340e319$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $7675ab03fcd9732b$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $e0b683520340e319$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $e0b683520340e319$export$2344b14b097df817(child, element);
        });
    }
};




/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $2ad735c56e123276$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $2ad735c56e123276$var$getTopParent = function(node) {
    return node.parentNode ? $2ad735c56e123276$var$getTopParent(node.parentNode) : node;
};
var $2ad735c56e123276$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $7675ab03fcd9732b$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $dd2aed5bcdbb58ae$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $2ad735c56e123276$var$filterNested((0, $7675ab03fcd9732b$export$45b10814cc054894)($2ad735c56e123276$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $dd2aed5bcdbb58ae$export$4f9a06cb7441a087), "=\"").concat(group, "\"]:not([").concat((0, $dd2aed5bcdbb58ae$export$aeda8252e54b50f7), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};



/**
 * returns active element from document or from nested shadowdoms
 */ var $a2eb708fe6502b5b$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $750286770c1b5c3d$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $750286770c1b5c3d$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $a2eb708fe6502b5b$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $750286770c1b5c3d$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $b2cb78917dfe27ae$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $b2cb78917dfe27ae$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $7675ab03fcd9732b$export$45b10814cc054894)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $b2cb78917dfe27ae$var$focusInFrame(node, activeElement);
    }));
};
var $b2cb78917dfe27ae$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $750286770c1b5c3d$export$cd4e5573fbe2b576)((0, $7675ab03fcd9732b$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $2ad735c56e123276$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $e0b683520340e319$export$2344b14b097df817)(node, activeElement) || $b2cb78917dfe27ae$var$focusInsideIframe(node, activeElement);
    });
};






var $7a6a7d14ebae13bd$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $750286770c1b5c3d$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $7675ab03fcd9732b$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $dd2aed5bcdbb58ae$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $e0b683520340e319$export$2344b14b097df817)(node, activeElement);
    });
};





var $984701be6af3c57c$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $8c0e782f6b12a8a6$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $984701be6af3c57c$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $8c0e782f6b12a8a6$export$9d74f6fbc6f469d0)(node) && node.name) return $984701be6af3c57c$var$findSelectedRadio(node, nodes);
    return node;
};
var $984701be6af3c57c$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($984701be6af3c57c$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $818864db6a7ccfff$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $984701be6af3c57c$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $818864db6a7ccfff$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $984701be6af3c57c$export$5261662167ad7ced)(nodes[index], nodes));
    return index;
};



var $871d28551aba0544$export$85710b12cf912438 = 'NEW_FOCUS';
var $871d28551aba0544$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $8c0e782f6b12a8a6$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $984701be6af3c57c$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $818864db6a7ccfff$export$e06728ee87c96122)(innerNodes, 0);
    var returnLastNode = (0, $818864db6a7ccfff$export$e06728ee87c96122)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $871d28551aba0544$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $b9897d8e56ce6ab5$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $8c0e782f6b12a8a6$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $b9897d8e56ce6ab5$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $e0b683520340e319$export$2f70373d403a5d2b)(nodes.filter($b9897d8e56ce6ab5$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $818864db6a7ccfff$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $818864db6a7ccfff$export$f4e86cfa0679b9cc)((0, $e0b683520340e319$export$2f70373d403a5d2b)(orderedNodes));
};






var $d61952bc10e440a1$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $d61952bc10e440a1$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $d61952bc10e440a1$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $d61952bc10e440a1$var$getParents(nodeA);
    var parentsB = $d61952bc10e440a1$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $d61952bc10e440a1$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $7675ab03fcd9732b$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $7675ab03fcd9732b$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $d61952bc10e440a1$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $d61952bc10e440a1$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $e0b683520340e319$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $d61952bc10e440a1$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $d61952bc10e440a1$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $e0b683520340e319$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};


var $a49375673bde1165$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $8c0e782f6b12a8a6$export$4e62c701997796c1));
};
var $a49375673bde1165$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = (0, $750286770c1b5c3d$export$cd4e5573fbe2b576)((0, $7675ab03fcd9732b$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $7675ab03fcd9732b$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $2ad735c56e123276$export$7e87c4720b9b279b)(topNode).filter((0, $8c0e782f6b12a8a6$export$602e5a0d338d7750));
    var commonParent = (0, $d61952bc10e440a1$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $e0b683520340e319$export$23c79be8286a3b0c)(entries, visibilityCache);
    var innerElements = (0, $e0b683520340e319$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $8c0e782f6b12a8a6$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $e0b683520340e319$export$23c79be8286a3b0c)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $a49375673bde1165$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $871d28551aba0544$export$65842178e9bb4205)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $871d28551aba0544$export$85710b12cf912438)) {
        var focusNode = (0, $b9897d8e56ce6ab5$export$cfb742983e257555)(anyFocusable, innerNodes, (0, $d61952bc10e440a1$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $77aa1cf495771a82$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};
var $77aa1cf495771a82$var$guardCount = 0;
var $77aa1cf495771a82$var$lockDisabled = false;
var $77aa1cf495771a82$export$f06c444b0336b5d5 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $a49375673bde1165$export$82d3f62e3f171d1d)(topNode, lastNode);
    if ($77aa1cf495771a82$var$lockDisabled) return;
    if (focusable) {
        if ($77aa1cf495771a82$var$guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $77aa1cf495771a82$var$lockDisabled = true;
            setTimeout(function() {
                $77aa1cf495771a82$var$lockDisabled = false;
            }, 1);
            return;
        }
        $77aa1cf495771a82$var$guardCount++;
        $77aa1cf495771a82$export$c12b3da842c43a8(focusable.node, options.focusOptions);
        $77aa1cf495771a82$var$guardCount--;
    }
};






var $fcc22e9ccbd3d0f7$export$2e2bcd8739ae039 //
 = (0, $77aa1cf495771a82$export$f06c444b0336b5d5);


var $34c45d765d8475a5$var$lastActiveTrap = 0;
var $34c45d765d8475a5$var$lastActiveFocus = null;
var $34c45d765d8475a5$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $34c45d765d8475a5$var$isFreeFocus = function isFreeFocus() {
    return $34c45d765d8475a5$var$focusOnBody() || (0, $7a6a7d14ebae13bd$export$be6b21806d3fd485)();
};
var $34c45d765d8475a5$var$activateTrap = function activateTrap() {
    var result = false;
    if ($34c45d765d8475a5$var$lastActiveTrap) {
        var observed = $34c45d765d8475a5$var$lastActiveTrap;
        if (!$34c45d765d8475a5$var$isFreeFocus()) {
            if (observed && !(0, $b2cb78917dfe27ae$export$20115f8da7baa6fa)(observed)) result = (0, $fcc22e9ccbd3d0f7$export$2e2bcd8739ae039)(observed, $34c45d765d8475a5$var$lastActiveFocus);
            $34c45d765d8475a5$var$lastActiveFocus = document.activeElement;
        }
    }
    return result;
};
var $34c45d765d8475a5$var$reducePropsToState = function reducePropsToState(propsList) {
    return propsList.filter(function(node) {
        return node;
    }).slice(-1)[0];
};
var $34c45d765d8475a5$var$handleStateChangeOnClient = function handleStateChangeOnClient(trap) {
    $34c45d765d8475a5$var$lastActiveTrap = trap;
    if (trap) $34c45d765d8475a5$var$activateTrap();
};
var $34c45d765d8475a5$var$instances = [];
var $34c45d765d8475a5$var$emitChange = function emitChange(event) {
    if ($34c45d765d8475a5$var$handleStateChangeOnClient($34c45d765d8475a5$var$reducePropsToState($34c45d765d8475a5$var$instances))) {
        event && event.preventDefault();
        return true;
    }
    return false;
};
var $34c45d765d8475a5$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $34c45d765d8475a5$var$emitChange);
};
var $34c45d765d8475a5$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $34c45d765d8475a5$var$emitChange);
};
var $34c45d765d8475a5$var$focusLock = {
    on: function on(domNode) {
        if ($34c45d765d8475a5$var$instances.length === 0) $34c45d765d8475a5$var$attachHandler();
        if ($34c45d765d8475a5$var$instances.indexOf(domNode) < 0) {
            $34c45d765d8475a5$var$instances.push(domNode);
            $34c45d765d8475a5$var$emitChange();
        }
    },
    off: function off(domNode) {
        $34c45d765d8475a5$var$instances = $34c45d765d8475a5$var$instances.filter(function(node) {
            return node !== domNode;
        });
        $34c45d765d8475a5$var$emitChange();
        if ($34c45d765d8475a5$var$instances.length === 0) $34c45d765d8475a5$var$detachHandler();
    }
};
var $34c45d765d8475a5$export$2e2bcd8739ae039 = $34c45d765d8475a5$var$focusLock;


function $ebfaf8c458485bce$export$ace028f8da1a6300() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
}






const $54946b2b86474aa3$var$ulToExpandId = "ulMobile";
const $54946b2b86474aa3$var$ulChildToExpandId = "ulChildMobile";
const $54946b2b86474aa3$var$topMenuButtonMobileId = "topMenuButtonMobile";
const $54946b2b86474aa3$var$spanMobileId = "spanMobileId";
const $54946b2b86474aa3$var$navigationIconMobileParentId = "navigationIconMobileParent";
const $54946b2b86474aa3$var$body = document.body;
const $54946b2b86474aa3$var$menu = document.getElementById('menu');
const $54946b2b86474aa3$var$menuButton = document.getElementById('menu-button');
const $54946b2b86474aa3$var$closeButton = document.getElementById('header-menu-close');
const $54946b2b86474aa3$var$primaryNavigation = $54946b2b86474aa3$var$menu.querySelectorAll('.primary-navigation li');
const $54946b2b86474aa3$var$header = document.getElementById('header');
const $54946b2b86474aa3$var$allUlsToExpand = document.querySelectorAll(`[id^=${$54946b2b86474aa3$var$ulToExpandId}]`);
const $54946b2b86474aa3$var$allChildUlsToExpand = document.querySelectorAll(`[id^=${$54946b2b86474aa3$var$ulChildToExpandId}]`);
const $54946b2b86474aa3$var$allMobileButtons = document.querySelectorAll(`[id^=${$54946b2b86474aa3$var$topMenuButtonMobileId}]`);
const $54946b2b86474aa3$var$allMobileSpans = document.querySelectorAll(`[id^=${$54946b2b86474aa3$var$spanMobileId}]`);
const $54946b2b86474aa3$var$allNavigationIconsMobileParents = document.querySelectorAll(`[id^=${$54946b2b86474aa3$var$navigationIconMobileParentId}]`);
const $54946b2b86474aa3$var$alltopMenuIconUpMobileParent = document.querySelectorAll(`[id^=topMenuIconUpMobileParent`);
const $54946b2b86474aa3$var$backToFirstPage = document.getElementById('backFirstPageButton');
const $54946b2b86474aa3$var$backPage = document.getElementById('backPageButton');
const $54946b2b86474aa3$var$language = document.getElementById("language");
const $54946b2b86474aa3$var$selectedLanguage = document.getElementById("selectedLanguage");
function $54946b2b86474aa3$var$hideSpans(item) {
    if (item.classList.contains('buttonSpanMarkedTopLevel')) item.classList.remove('buttonSpanMarkedTopLevel');
}
function $54946b2b86474aa3$var$hideUls(item) {
    if (item.classList.contains('ulMarked')) item.classList.remove('ulMarked');
    item.style.display = 'none';
}
function $54946b2b86474aa3$var$hideExitIcon() {
    const menuIcon = document.getElementById('MenuIcon');
    const exitIcon = document.getElementById('ExitIcon');
    if (menuIcon && exitIcon) {
        menuIcon.classList.remove('hide');
        exitIcon.classList.add('hide');
    }
}
function $54946b2b86474aa3$var$showAllButtons(item) {
    item.style.display = 'inline-flex';
}
const $54946b2b86474aa3$var$escapeEvent = (event)=>{
    if (event.defaultPrevented) return;
    const key = event.key || event.keyCode;
    if (key === 'Escape' || key === 'Esc' || key === 27) $54946b2b86474aa3$export$79e28f18a1d07049();
};
const $54946b2b86474aa3$export$79e28f18a1d07049 = function() {
    $54946b2b86474aa3$var$allUlsToExpand.forEach($54946b2b86474aa3$var$hideUls);
    $54946b2b86474aa3$var$allChildUlsToExpand.forEach($54946b2b86474aa3$var$hideUls);
    $54946b2b86474aa3$var$allMobileSpans.forEach($54946b2b86474aa3$var$hideSpans);
    $54946b2b86474aa3$var$allMobileButtons.forEach($54946b2b86474aa3$var$showAllButtons);
    $54946b2b86474aa3$var$allMobileButtons.forEach((button)=>{
        button.disabled = false;
    });
    if ($54946b2b86474aa3$var$language !== null) $54946b2b86474aa3$var$language.style.display = "none";
    if ($54946b2b86474aa3$var$selectedLanguage !== null) $54946b2b86474aa3$var$selectedLanguage.style.display = "flex";
    $54946b2b86474aa3$var$allNavigationIconsMobileParents.forEach((item)=>{
        item.style.display = 'block';
    });
    $54946b2b86474aa3$var$alltopMenuIconUpMobileParent.forEach((item)=>{
        item.style.display = 'none';
    });
    if ($54946b2b86474aa3$var$backToFirstPage !== null) $54946b2b86474aa3$var$backToFirstPage.classList.remove('hide');
    if ($54946b2b86474aa3$var$backPage !== null) $54946b2b86474aa3$var$backPage.classList.add('hide');
    $54946b2b86474aa3$var$hideExitIcon();
    (0, $1974f63041948ee8$export$99ee26438460406a).to($54946b2b86474aa3$var$primaryNavigation, {
        y: -20,
        opacity: 0,
        duration: 0.05,
        stagger: -0.025
    });
    (0, $1974f63041948ee8$export$99ee26438460406a).to($54946b2b86474aa3$var$menu, {
        duration: 0,
        delay: 0,
        y: '-100%',
        transformOrigin: 'top',
        ease: 'expo.inOut',
        onComplete: ()=>{
            $54946b2b86474aa3$var$header.classList.remove('elevate');
            $54946b2b86474aa3$var$menu.classList.remove('header__main-menu--open');
            $54946b2b86474aa3$var$menuButton.setAttribute('aria-expanded', 'false');
            $54946b2b86474aa3$var$menuButton.classList.remove('menu-toggle--open');
            $54946b2b86474aa3$var$menu.removeEventListener('keyup', $54946b2b86474aa3$var$escapeEvent);
            $54946b2b86474aa3$var$body.classList.remove('no-scroll');
            (0, $34c45d765d8475a5$export$2e2bcd8739ae039).off($54946b2b86474aa3$var$menu);
            $54946b2b86474aa3$var$menuButton.focus();
        }
    });
};
(function() {
    if ('undefined' === typeof $54946b2b86474aa3$var$menuButton || !$54946b2b86474aa3$var$menu) return;
    $54946b2b86474aa3$var$closeButton.onclick = function() {
        $54946b2b86474aa3$export$79e28f18a1d07049();
    };
    if ($54946b2b86474aa3$var$backToFirstPage !== null) $54946b2b86474aa3$var$backToFirstPage.onclick = function() {
        $54946b2b86474aa3$export$79e28f18a1d07049();
    };
    if ($54946b2b86474aa3$var$backPage !== null) $54946b2b86474aa3$var$backPage.onclick = function() {
        $54946b2b86474aa3$var$allUlsToExpand.forEach($54946b2b86474aa3$var$hideUls);
        $54946b2b86474aa3$var$allChildUlsToExpand.forEach($54946b2b86474aa3$var$hideUls);
        $54946b2b86474aa3$var$allMobileSpans.forEach($54946b2b86474aa3$var$hideSpans);
        $54946b2b86474aa3$var$allMobileButtons.forEach($54946b2b86474aa3$var$showAllButtons);
        $54946b2b86474aa3$var$allNavigationIconsMobileParents.forEach((item)=>{
            item.style.display = 'block';
        });
        $54946b2b86474aa3$var$backToFirstPage.classList.remove('hide');
        $54946b2b86474aa3$var$backPage.classList.add('hide');
        if ($54946b2b86474aa3$var$language !== null) $54946b2b86474aa3$var$language.style.display = "none";
        if ($54946b2b86474aa3$var$selectedLanguage !== null) $54946b2b86474aa3$var$selectedLanguage.style.display = "flex";
        $54946b2b86474aa3$var$allMobileButtons.forEach((button)=>{
            button.disabled = false;
        });
    };
    function showExitIcon() {
        const menuIcon = document.getElementById('MenuIcon');
        const exitIcon = document.getElementById('ExitIcon');
        if (menuIcon && exitIcon) {
            menuIcon.classList.add('hide');
            exitIcon.classList.remove('hide');
        }
    }
    $54946b2b86474aa3$var$menuButton.onclick = function() {
        if ($54946b2b86474aa3$var$menu.classList.contains('header__main-menu--open')) $54946b2b86474aa3$export$79e28f18a1d07049();
        else {
            (0, $35f54ccfc73e3dc1$export$77e2362d3cc00e23)();
            showExitIcon();
            const scrollbarWidth = (0, $ebfaf8c458485bce$export$ace028f8da1a6300)();
            document.body.style.setProperty('--scrollbar-width', scrollbarWidth.toString() + 'px');
            $54946b2b86474aa3$var$body.classList.add('no-scroll');
            $54946b2b86474aa3$var$menu.classList.add('header__main-menu--open');
            $54946b2b86474aa3$var$menuButton.setAttribute('aria-expanded', 'true');
            $54946b2b86474aa3$var$header.classList.add('elevate');
            (0, $1974f63041948ee8$export$99ee26438460406a).set($54946b2b86474aa3$var$primaryNavigation, {
                y: -20,
                opacity: 0
            });
            $54946b2b86474aa3$var$menu.classList.add('header__main-menu--open');
            $54946b2b86474aa3$var$menuButton.setAttribute('aria-expanded', 'true');
            (0, $1974f63041948ee8$export$99ee26438460406a).to($54946b2b86474aa3$var$menu, {
                duration: 0,
                y: 0,
                transformOrigin: 'top',
                ease: 'expo.inOut',
                onComplete: ()=>{
                    (0, $1974f63041948ee8$export$99ee26438460406a).to($54946b2b86474aa3$var$primaryNavigation, {
                        y: 0,
                        opacity: 1,
                        duration: 0,
                        stagger: 0,
                        onComplete: ()=>{
                            $54946b2b86474aa3$var$menu.focus();
                            (0, $34c45d765d8475a5$export$2e2bcd8739ae039).on($54946b2b86474aa3$var$menu);
                        }
                    });
                }
            });
            $54946b2b86474aa3$var$menu.addEventListener('keyup', $54946b2b86474aa3$var$escapeEvent);
        }
    };
})();


const $35f54ccfc73e3dc1$var$search = document.getElementById('header-search');
const $35f54ccfc73e3dc1$var$searchButton = document.getElementById('header-search-button');
const $35f54ccfc73e3dc1$var$header = document.getElementById('header');
const $35f54ccfc73e3dc1$var$openSearch = document.getElementById('openSearch');
const $35f54ccfc73e3dc1$var$exitSearch = document.getElementById('exitSearch');
const $35f54ccfc73e3dc1$export$77e2362d3cc00e23 = function() {
    $35f54ccfc73e3dc1$var$searchButton.classList.remove('close-button-underline');
    $35f54ccfc73e3dc1$var$searchButton.classList.add('open-button-underline');
    $35f54ccfc73e3dc1$var$exitSearch.style.display = 'none';
    $35f54ccfc73e3dc1$var$openSearch.style.display = 'block';
    (0, $1974f63041948ee8$export$99ee26438460406a).to($35f54ccfc73e3dc1$var$search, {
        duration: 0,
        y: '-100px',
        transformOrigin: 'top',
        ease: 'expo.inOut',
        onComplete: ()=>{
            $35f54ccfc73e3dc1$var$search.classList.remove('search--open');
            $35f54ccfc73e3dc1$var$searchButton.setAttribute('aria-expanded', 'false');
            $35f54ccfc73e3dc1$var$header.classList.remove('elevate');
            (0, $34c45d765d8475a5$export$2e2bcd8739ae039).off($35f54ccfc73e3dc1$var$search);
            $35f54ccfc73e3dc1$var$search.removeEventListener('keyup', $35f54ccfc73e3dc1$var$escapeEvent);
            document.body.classList.remove('no-scroll');
            $35f54ccfc73e3dc1$var$searchButton.focus();
        }
    });
};
const $35f54ccfc73e3dc1$var$escapeEvent = (event)=>{
    if (event.defaultPrevented) return;
    const key = event.key || event.keyCode;
    if (key === 'Escape' || key === 'Esc' || key === 27) $35f54ccfc73e3dc1$export$77e2362d3cc00e23();
};
(function() {
    const body = document.body;
    if ('undefined' === typeof $35f54ccfc73e3dc1$var$searchButton || !$35f54ccfc73e3dc1$var$search) return;
    $35f54ccfc73e3dc1$var$searchButton.onclick = function() {
        if ($35f54ccfc73e3dc1$var$search.classList.contains('search--open')) $35f54ccfc73e3dc1$export$77e2362d3cc00e23();
        else {
            (0, $54946b2b86474aa3$export$79e28f18a1d07049)();
            $35f54ccfc73e3dc1$var$searchButton.classList.remove('open-button-underline');
            $35f54ccfc73e3dc1$var$searchButton.classList.add('close-button-underline');
            $35f54ccfc73e3dc1$var$exitSearch.style.display = 'block';
            $35f54ccfc73e3dc1$var$openSearch.style.display = 'none';
            const scrollbarWidth = (0, $ebfaf8c458485bce$export$ace028f8da1a6300)();
            document.body.style.setProperty('--scrollbar-width', scrollbarWidth.toString() + 'px');
            $35f54ccfc73e3dc1$var$search.classList.add('search--open');
            $35f54ccfc73e3dc1$var$searchButton.setAttribute('aria-expanded', 'true');
            $35f54ccfc73e3dc1$var$header.classList.add('elevate');
            body.classList.add('no-scroll');
            (0, $1974f63041948ee8$export$99ee26438460406a).to($35f54ccfc73e3dc1$var$search, {
                duration: 0,
                y: 0,
                transformOrigin: 'top',
                ease: 'expo.inOut',
                onComplete: ()=>{
                    (0, $34c45d765d8475a5$export$2e2bcd8739ae039).on($35f54ccfc73e3dc1$var$search);
                }
            });
            $35f54ccfc73e3dc1$var$search.addEventListener('keyup', $35f54ccfc73e3dc1$var$escapeEvent);
        }
    };
})();


const $07955025b74861a7$var$body = document.body;
const $07955025b74861a7$var$scrollUp = 'scroll-up';
const $07955025b74861a7$var$scrollDown = 'scroll-down';
const $07955025b74861a7$var$pageIntro = document.getElementById('page-intro');
let $07955025b74861a7$var$lastScroll = 0;
let $07955025b74861a7$var$lockMenu = false;
const $07955025b74861a7$var$isCampaignPage = !!document.querySelector('.sticky-page-intro--white');
if ($07955025b74861a7$var$isCampaignPage) {
    const header = document.querySelector('#header');
    header?.classList.add('bg-white');
}
(function() {
    const topMenuButtonId = "topMenuButton";
    const spanTextId = "spanid";
    const divToExpandId = "underheaderSpace";
    const flipThisIconId = "flipThisIcon";
    var allButtons = document.querySelectorAll(`[id^=${topMenuButtonId}]`);
    var allSpans = document.querySelectorAll(`[id^=${spanTextId}]`);
    var allIcons = document.querySelectorAll(`[id^=${flipThisIconId}]`);
    var allDivsToExpand = document.querySelectorAll(`[id^=${divToExpandId}]`);
    var allCloseButtons = document.querySelectorAll(`[id^=${"closeAllButton"}]`);
    allCloseButtons.forEach(itemOnClick);
    allButtons.forEach(itemOnClick);
    const topMenuButtonMobileId = "topMenuButtonMobile";
    const spanMobileId = "spanMobileId";
    const ulToExpandId = "ulMobile";
    const ulChildToExpandId = "ulChildMobile";
    const childLinkMobileId = "childLinkMobileId";
    const allMobileButtons = document.querySelectorAll(`[id^=${topMenuButtonMobileId}]`);
    const allUlsToExpand = document.querySelectorAll(`[id^=${ulToExpandId}]`);
    const allChildUlsToExpand = document.querySelectorAll(`[id^=${ulChildToExpandId}]`);
    const allChildLinkMobile = document.querySelectorAll(`[id^=${childLinkMobileId}]`);
    const allNavigationIconMobileChild = document.querySelectorAll(`[id^=navigationIconMobileChild`);
    const allTopMenuIconUpMobileChild = document.querySelectorAll(`[id^=topMenuIconUpMobileChild`);
    const language = document.getElementById("language");
    const selectedLanguage = document.getElementById("selectedLanguage");
    const backFirstPageButton = document.getElementById('backFirstPageButton');
    const backButton = document.getElementById('backPageButton');
    allUlsToExpand.forEach(hideUls);
    allChildUlsToExpand.forEach(hideUls);
    allButtons.forEach(itemOnClick);
    allMobileButtons.forEach(mobileItemOnClick);
    allChildLinkMobile.forEach(mobileChildLinkOnClick);
    function hideUls(item) {
        if (item.classList.contains('ulMarked')) item.classList.remove('ulMarked');
        item.style.display = 'none';
    }
    function itemOnClick(item) {
        item.onclick = function(e) {
            const index = e.currentTarget.getAttribute('index');
            const topMenuSpan = document.getElementById(spanTextId + index);
            const flipIcon = document.getElementById(flipThisIconId + index);
            const divToExpand = document.getElementById(divToExpandId + index);
            allSpans.forEach(unmarkSpans);
            allIcons.forEach(flipIcons);
            allDivsToExpand.forEach(hideDivs);
            function unmarkSpans(item) {
                if (item.id.indexOf(index) === -1) item.classList.remove('buttonSpanMarked');
            }
            function flipIcons(item) {
                if (item.id.indexOf(index) === -1) item.style.transform = '';
            }
            function hideDivs(item) {
                if (item.id.indexOf(index) === -1) item.style.display = 'none';
            }
            if (topMenuSpan.classList.contains('buttonSpanMarked')) {
                topMenuSpan.classList.remove('buttonSpanMarked');
                removeOverlay();
                flipIcon.style.transform = '';
                divToExpand.style.display = 'none';
            } else {
                removeOverlay();
                (0, $35f54ccfc73e3dc1$export$77e2362d3cc00e23)();
                addOverlayForHeader();
                topMenuSpan.classList.add('buttonSpanMarked');
                flipIcon.style.transform = 'rotate(180deg)';
                divToExpand.style.display = 'block';
            }
        };
    }
    function addOverlayForHeader() {
        $07955025b74861a7$var$lockMenu = true;
        const header = document.getElementById('header');
        const childElement = document.getElementById('underheaderSpace0'); // Change 'childElement' to the actual id of your child element
        const overlay = document.createElement('div');
        overlay.classList.add('overlay');
        const headerHeight = header ? header.clientHeight : 0;
        const childElementHeight = childElement ? childElement.clientHeight : 0;
        const overlayTop = headerHeight - childElementHeight; // Adjust the height accordingly
        overlay.style.top = `${overlayTop}px`;
        overlay.style.zIndex = "1"; // Ensure the overlay is behind the child element
        document.body.appendChild(overlay);
    }
    function removeOverlay() {
        $07955025b74861a7$var$lockMenu = false;
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.remove();
    }
    function handleResize() {
        const screenWidth = window.innerWidth;
        if (screenWidth < 1280) removeOverlay();
    }
    function showAllButtons(item) {
        item.style.display = 'inline-flex';
    }
    function removeStuffTopLevel(lightMenu) {
        allButtons.forEach((button)=>{
            button.classList.add('topLevelTitle');
        });
        if (backFirstPageButton !== null && lightMenu === "False") backFirstPageButton.classList.add('hide');
        if (backButton !== null) backButton.classList.remove('hide');
    }
    function showStuffTopLevel() {
        allButtons.forEach((button)=>{
            button.classList.remove('topLevelTitle');
        });
        if (backFirstPageButton !== null) backFirstPageButton.classList.remove('hide');
        if (backButton !== null) backButton.classList.add('hide');
    }
    window.addEventListener('resize', handleResize);
    function mobileItemOnClick(item) {
        item.onclick = function(e) {
            const index = e.currentTarget.getAttribute('index');
            const lightMenu = e.currentTarget.getAttribute('lightMenu');
            const topMenuSpan = document.getElementById(spanMobileId + index);
            const ulToExpand = document.getElementById(ulToExpandId + index);
            const navigationIconMobileParent = document.getElementById("navigationIconMobileParent" + index);
            const navigationIconMobileParentGlobe = document.getElementById("navigationIconMobileParentGlobe" + index);
            const topMenuIconUpMobileParent = document.getElementById("topMenuIconUpMobileParent" + index);
            let languageIndex = null;
            if (language !== null) languageIndex = language.getAttribute('index');
            allTopMenuIconUpMobileChild.forEach((item)=>{
                item.style.display = 'none';
            });
            allNavigationIconMobileChild.forEach((item)=>{
                item.style.display = 'block';
            });
            if (topMenuSpan.classList.contains('buttonSpanMarkedTopLevel')) {
                topMenuSpan.classList.remove('buttonSpanMarkedTopLevel');
                ulToExpand.style.display = 'none';
                showStuffTopLevel();
                if (navigationIconMobileParent !== null) navigationIconMobileParent.style.display = "block";
                if (navigationIconMobileParentGlobe !== null) navigationIconMobileParentGlobe.style.display = "block";
                if (topMenuIconUpMobileParent != null) topMenuIconUpMobileParent.style.display = "none";
                if (languageIndex !== null && languageIndex == index) {
                    language.style.display = "none";
                    selectedLanguage.style.display = "flex";
                }
                allMobileButtons.forEach(showAllButtons);
            } else {
                allChildUlsToExpand.forEach(hideUls);
                topMenuSpan.classList.add('buttonSpanMarkedTopLevel');
                ulToExpand.style.display = 'block';
                removeStuffTopLevel(lightMenu);
                if (navigationIconMobileParent !== null) navigationIconMobileParent.style.display = "none";
                if (navigationIconMobileParentGlobe !== null) navigationIconMobileParentGlobe.style.display = "none";
                if (topMenuIconUpMobileParent != null) topMenuIconUpMobileParent.style.display = "block";
                if (lightMenu !== null && lightMenu == "False") {
                    allMobileButtons.forEach(hideOtherButtons);
                    item.disabled = true;
                }
                if (languageIndex !== null && languageIndex == index) {
                    language.style.display = "flex";
                    selectedLanguage.style.display = "none";
                }
                function hideOtherButtons(item) {
                    if (item.id.indexOf(index) === -1) item.style.display = 'none';
                }
            }
        };
    }
    function mobileChildLinkOnClick(item) {
        item.onclick = function(e) {
            const index = e.currentTarget.getAttribute('index');
            const ulChildToExpand = document.getElementById(ulChildToExpandId + index);
            const navigationIconMobileChild = document.getElementById("navigationIconMobileChild" + index);
            const topMenuIconUpMobileChild = document.getElementById("topMenuIconUpMobileChild" + index);
            if (ulChildToExpand.classList.contains('ulMarked')) {
                ulChildToExpand.classList.remove('ulMarked');
                ulChildToExpand.style.display = 'none';
                navigationIconMobileChild.style.display = "block";
                if (topMenuIconUpMobileChild != null) topMenuIconUpMobileChild.style.display = "none";
            } else {
                ulChildToExpand.classList.add('ulMarked');
                ulChildToExpand.style.display = 'block';
                navigationIconMobileChild.style.display = "none";
                if (topMenuIconUpMobileChild != null) topMenuIconUpMobileChild.style.display = "block";
            }
        };
    }
})();
window.addEventListener('scroll', ()=>{
    if (window.isScrollLocked) {
        // When in locked-mode in scrollytell, set the state to scroll-down and exit (no navigationmenu)
        $07955025b74861a7$var$body.classList.remove($07955025b74861a7$var$scrollUp);
        $07955025b74861a7$var$body.classList.add($07955025b74861a7$var$scrollDown);
        return;
    }
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
        $07955025b74861a7$var$body.classList.remove($07955025b74861a7$var$scrollUp);
        return;
    }
    if ($07955025b74861a7$var$pageIntro) {
        if (currentScroll > $07955025b74861a7$var$pageIntro.clientHeight - 92 && $07955025b74861a7$var$body.classList.contains('StartPage')) $07955025b74861a7$var$body.classList.add('scroll-below-page-intro');
        else $07955025b74861a7$var$body.classList.remove('scroll-below-page-intro');
    }
    if (currentScroll > $07955025b74861a7$var$lastScroll && !$07955025b74861a7$var$body.classList.contains($07955025b74861a7$var$scrollDown) && currentScroll > 200 && !$07955025b74861a7$var$lockMenu) {
        // down
        $07955025b74861a7$var$body.classList.remove($07955025b74861a7$var$scrollUp);
        $07955025b74861a7$var$body.classList.add($07955025b74861a7$var$scrollDown);
    } else if (currentScroll < $07955025b74861a7$var$lastScroll && $07955025b74861a7$var$body.classList.contains($07955025b74861a7$var$scrollDown)) {
        // up
        $07955025b74861a7$var$body.classList.remove($07955025b74861a7$var$scrollDown);
        $07955025b74861a7$var$body.classList.add($07955025b74861a7$var$scrollUp);
    }
    $07955025b74861a7$var$lastScroll = currentScroll;
});


var $ccf03f3c62b4f2fe$exports = {};
var $7ea6468ad1446672$exports = {};
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://iframe-resizer.com
 * Author: David J. Bradshaw - info@iframe-resizer.com
 */ console.info(`
IFRAME-RESIZER

Iframe-Resizer 5 is now available via the following two packages:

 * @iframe-resizer/parent
 * @iframe-resizer/child

Additionally their are also new versions of iframe-resizer for React, Vue, and jQuery.

Version 5 of iframe-resizer has been extensively rewritten to use modern browser APIs, which has enabled significantly better performance and greater accuracy in the detection of content resizing events.

Please see https://iframe-resizer.com/upgrade for more details.
`);
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    // var VERSION = '4.3.11'
    var count = 0, destroyObserver, logEnabled = false, hiddenCheckEnabled = false, msgHeader = 'message', msgHeaderLen = msgHeader.length, msgId = '[iFrameSizer]', msgIdLen = msgId.length, pagePosition = null, requestAnimationFrame = window.requestAnimationFrame, resetRequiredMethods = Object.freeze({
        max: 1,
        scroll: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }), settings = {}, timer = null, defaults = Object.freeze({
        autoResize: true,
        bodyBackground: null,
        bodyMargin: null,
        bodyMarginV1: 8,
        bodyPadding: null,
        checkOrigin: true,
        inPageLinks: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'bodyOffset',
        id: 'iFrameResizer',
        interval: 32,
        license: '1jqr0si6pnt',
        log: false,
        maxHeight: Infinity,
        maxWidth: Infinity,
        minHeight: 0,
        minWidth: 0,
        mouseEvents: true,
        resizeFrom: 'parent',
        scrolling: false,
        sizeHeight: true,
        sizeWidth: false,
        warningTimeout: 5000,
        tolerance: 0,
        widthCalculationMethod: 'scroll',
        onClose: function() {
            return true;
        },
        onClosed: function() {},
        onInit: function() {},
        onMessage: function() {
            warn('onMessage function not defined');
        },
        onMouseEnter: function() {},
        onMouseLeave: function() {},
        onResized: function() {},
        onScroll: function() {
            return true;
        }
    });
    function getMutationObserver() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function addEventListener(el, evt, func) {
        el.addEventListener(evt, func, false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function setupRequestAnimationFrame() {
        var vendors = [
            'moz',
            'webkit',
            'o',
            'ms'
        ];
        var x;
        // Remove vendor prefixing if prefixed and break early if not
        for(x = 0; x < vendors.length && !requestAnimationFrame; x += 1)requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        if (requestAnimationFrame) // Firefox extension content-scripts have a globalThis object that is not the same as window.
        // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
        // being thrown when run in that context, and should be a no-op in every other context.
        requestAnimationFrame = requestAnimationFrame.bind(window);
        else log('setup', 'RequestAnimationFrame not supported');
    }
    function getMyID(iframeId) {
        var retStr = 'Host page: ' + iframeId;
        if (window.top !== window.self) retStr = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ': ' + iframeId : 'Nested host page: ' + iframeId;
        return retStr;
    }
    function formatLogHeader(iframeId) {
        return msgId + '[' + getMyID(iframeId) + ']';
    }
    function isLogEnabled(iframeId) {
        return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }
    function log(iframeId, msg) {
        output('log', iframeId, msg, isLogEnabled(iframeId));
    }
    function info(iframeId, msg) {
        output('info', iframeId, msg, isLogEnabled(iframeId));
    }
    function warn(iframeId, msg) {
        output('warn', iframeId, msg, true);
    }
    function output(type, iframeId, msg, enabled) {
        if (true === enabled && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console[type](formatLogHeader(iframeId), msg);
    }
    function iFrameListener(event) {
        function resizeIFrame() {
            function resize() {
                setSize(messageData);
                setPagePosition(iframeId);
                on('onResized', messageData);
            }
            ensureInRange('Height');
            ensureInRange('Width');
            syncResize(resize, messageData, 'init');
        }
        function processMsg() {
            var data = msg.slice(msgIdLen).split(':');
            var height = data[1] ? parseInt(data[1], 10) : 0;
            var iframe = settings[data[0]] && settings[data[0]].iframe;
            var compStyle = getComputedStyle(iframe);
            return {
                iframe: iframe,
                id: data[0],
                height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
                width: data[2],
                type: data[3]
            };
        }
        function getPaddingEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0;
            var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0;
            return top + bot;
        }
        function getBorderEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0;
            var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0;
            return top + bot;
        }
        function ensureInRange(Dimension) {
            var max = Number(settings[iframeId]['max' + Dimension]), min = Number(settings[iframeId]['min' + Dimension]), dimension = Dimension.toLowerCase(), size = Number(messageData[dimension]);
            log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max);
            if (size < min) {
                size = min;
                log(iframeId, 'Set ' + dimension + ' to min value');
            }
            if (size > max) {
                size = max;
                log(iframeId, 'Set ' + dimension + ' to max value');
            }
            messageData[dimension] = '' + size;
        }
        function isMessageFromIFrame() {
            function checkAllowedOrigin() {
                function checkList() {
                    var i = 0, retCode = false;
                    log(iframeId, 'Checking connection is from allowed list of origins: ' + checkOrigin);
                    for(; i < checkOrigin.length; i++)if (checkOrigin[i] === origin) {
                        retCode = true;
                        break;
                    }
                    return retCode;
                }
                function checkSingle() {
                    var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
                    log(iframeId, 'Checking connection is from: ' + remoteHost);
                    return origin === remoteHost;
                }
                return checkOrigin.constructor === Array ? checkList() : checkSingle();
            }
            var origin = event.origin, checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
            if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) throw new Error('Unexpected message received from: ' + origin + ' for ' + messageData.iframe.id + '. Message was: ' + event.data + '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.');
            return true;
        }
        function isMessageForUs() {
            return msgId === ('' + msg).slice(0, msgIdLen) && msg.slice(msgIdLen).split(':')[0] in settings // ''+Protects against non-string msg
            ;
        }
        function isMessageFromMetaParent() {
            // Test if this message is from a parent above us. This is an ugly test, however, updating
            // the message format would break backwards compatibility.
            var retCode = messageData.type in {
                true: 1,
                false: 1,
                undefined: 1
            };
            if (retCode) log(iframeId, 'Ignoring init message from meta parent page');
            return retCode;
        }
        function getMsgBody(offset) {
            return msg.slice(msg.indexOf(':') + msgHeaderLen + offset);
        }
        function forwardMsgFromIFrame(msgBody) {
            log(iframeId, 'onMessage passed: {iframe: ' + messageData.iframe.id + ', message: ' + msgBody + '}');
            on('onMessage', {
                iframe: messageData.iframe,
                message: JSON.parse(msgBody)
            });
            log(iframeId, '--');
        }
        function getPageInfo() {
            var bodyPosition = document.body.getBoundingClientRect(), iFramePosition = messageData.iframe.getBoundingClientRect();
            return JSON.stringify({
                iframeHeight: iFramePosition.height,
                iframeWidth: iFramePosition.width,
                clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
                offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
                scrollTop: window.pageYOffset,
                scrollLeft: window.pageXOffset,
                documentHeight: document.documentElement.clientHeight,
                documentWidth: document.documentElement.clientWidth,
                windowHeight: window.innerHeight,
                windowWidth: window.innerWidth
            });
        }
        function sendPageInfoToIframe(iframe, iframeId) {
            function debouncedTrigger() {
                trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId);
            }
            debounceFrameEvents(debouncedTrigger, 32, iframeId);
        }
        function startPageInfoMonitor() {
            function setListener(type, func) {
                function sendPageInfo() {
                    if (settings[id]) sendPageInfoToIframe(settings[id].iframe, id);
                    else stop();
                }
                [
                    'scroll',
                    'resize'
                ].forEach(function(evt) {
                    log(id, type + evt + ' listener for sendPageInfo');
                    func(window, evt, sendPageInfo);
                });
            }
            function stop() {
                setListener('Remove ', removeEventListener);
            }
            function start() {
                setListener('Add ', addEventListener);
            }
            var id = iframeId // Create locally scoped copy of iFrame ID
            ;
            start();
            if (settings[id]) settings[id].stopPageInfo = stop;
        }
        function stopPageInfoMonitor() {
            if (settings[iframeId] && settings[iframeId].stopPageInfo) {
                settings[iframeId].stopPageInfo();
                delete settings[iframeId].stopPageInfo;
            }
        }
        function checkIFrameExists() {
            var retBool = true;
            if (null === messageData.iframe) {
                warn(iframeId, 'IFrame (' + messageData.id + ') not found');
                retBool = false;
            }
            return retBool;
        }
        function getElementPosition(target) {
            var iFramePosition = target.getBoundingClientRect();
            getPagePosition(iframeId);
            return {
                x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
                y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
            };
        }
        function scrollRequestFromChild(addOffset) {
            /* istanbul ignore next */ // Not testable in Karma
            function reposition() {
                pagePosition = newPosition;
                scrollTo();
                log(iframeId, '--');
            }
            function calcOffset() {
                return {
                    x: Number(messageData.width) + offset.x,
                    y: Number(messageData.height) + offset.y
                };
            }
            function scrollParent() {
                if (window.parentIFrame) window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](newPosition.x, newPosition.y);
                else warn(iframeId, 'Unable to scroll to requested position, window.parentIFrame not found');
            }
            var offset = addOffset ? getElementPosition(messageData.iframe) : {
                x: 0,
                y: 0
            }, newPosition = calcOffset();
            log(iframeId, 'Reposition requested from iFrame (offset x:' + offset.x + ' y:' + offset.y + ')');
            if (window.top === window.self) reposition();
            else scrollParent();
        }
        function scrollTo() {
            if (false === on('onScroll', pagePosition)) unsetPagePosition();
            else setPagePosition(iframeId);
        }
        function findTarget(location) {
            function jumpToTarget() {
                var jumpPosition = getElementPosition(target);
                log(iframeId, 'Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                pagePosition = {
                    x: jumpPosition.x,
                    y: jumpPosition.y
                };
                scrollTo();
                log(iframeId, '--');
            }
            function jumpToParent() {
                if (window.parentIFrame) window.parentIFrame.moveToAnchor(hash);
                else log(iframeId, 'In page link #' + hash + ' not found and window.parentIFrame not found');
            }
            var hash = location.split('#')[1] || '', hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (target) jumpToTarget();
            else if (window.top === window.self) log(iframeId, 'In page link #' + hash + ' not found');
            else jumpToParent();
        }
        function onMouse(event) {
            var mousePos = {};
            if (Number(messageData.width) === 0 && Number(messageData.height) === 0) {
                var data = getMsgBody(9).split(':');
                mousePos = {
                    x: data[1],
                    y: data[0]
                };
            } else mousePos = {
                x: messageData.width,
                y: messageData.height
            };
            on(event, {
                iframe: messageData.iframe,
                screenX: Number(mousePos.x),
                screenY: Number(mousePos.y),
                type: messageData.type
            });
        }
        function on(funcName, val) {
            return chkEvent(iframeId, funcName, val);
        }
        function actionMsg() {
            if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
            switch(messageData.type){
                case 'close':
                    closeIFrame(messageData.iframe);
                    break;
                case 'message':
                    forwardMsgFromIFrame(getMsgBody(6));
                    break;
                case 'mouseenter':
                    onMouse('onMouseEnter');
                    break;
                case 'mouseleave':
                    onMouse('onMouseLeave');
                    break;
                case 'autoResize':
                    settings[iframeId].autoResize = JSON.parse(getMsgBody(9));
                    break;
                case 'scrollTo':
                    scrollRequestFromChild(false);
                    break;
                case 'scrollToOffset':
                    scrollRequestFromChild(true);
                    break;
                case 'pageInfo':
                    sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe, iframeId);
                    startPageInfoMonitor();
                    break;
                case 'pageInfoStop':
                    stopPageInfoMonitor();
                    break;
                case 'inPageLink':
                    findTarget(getMsgBody(9));
                    break;
                case 'reset':
                    resetIFrame(messageData);
                    break;
                case 'init':
                    resizeIFrame();
                    on('onInit', messageData.iframe);
                    break;
                default:
                    if (Number(messageData.width) === 0 && Number(messageData.height) === 0) warn('Unsupported message received (' + messageData.type + '), this is likely due to the iframe containing a later ' + 'version of iframe-resizer than the parent page');
                    else resizeIFrame();
            }
        }
        function hasSettings(iframeId) {
            var retBool = true;
            if (!settings[iframeId]) {
                retBool = false;
                warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
            }
            return retBool;
        }
        function iFrameReadyMsgReceived() {
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for(var iframeId in settings)trigger('iFrame requested init', createOutgoingMsg(iframeId), settings[iframeId].iframe, iframeId);
        }
        function firstRun() {
            if (settings[iframeId]) settings[iframeId].firstRun = false;
        }
        var msg = event.data, messageData = {}, iframeId = null;
        if ('[iFrameResizerChild]Ready' === msg) iFrameReadyMsgReceived();
        else if (isMessageForUs()) {
            messageData = processMsg();
            iframeId = messageData.id;
            if (settings[iframeId]) settings[iframeId].loaded = true;
            if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
                log(iframeId, 'Received: ' + msg);
                if (checkIFrameExists() && isMessageFromIFrame()) actionMsg();
            }
        } else info(iframeId, 'Ignored: ' + msg);
    }
    function chkEvent(iframeId, funcName, val) {
        var func = null, retVal = null;
        if (settings[iframeId]) {
            func = settings[iframeId][funcName];
            if ('function' === typeof func) retVal = func(val);
            else throw new TypeError(funcName + ' on iFrame[' + iframeId + '] is not a function');
        }
        return retVal;
    }
    function removeIframeListeners(iframe) {
        var iframeId = iframe.id;
        delete settings[iframeId];
    }
    function closeIFrame(iframe) {
        var iframeId = iframe.id;
        if (chkEvent(iframeId, 'onClose', iframeId) === false) {
            log(iframeId, 'Close iframe cancelled by onClose event');
            return;
        }
        log(iframeId, 'Removing iFrame: ' + iframeId);
        try {
            // Catch race condition error with React
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        } catch (error) {
            warn(error);
        }
        chkEvent(iframeId, 'onClosed', iframeId);
        log(iframeId, '--');
        removeIframeListeners(iframe);
        if (destroyObserver) {
            destroyObserver.disconnect();
            destroyObserver = null;
        }
    }
    function getPagePosition(iframeId) {
        if (null === pagePosition) {
            pagePosition = {
                x: window.pageXOffset === undefined ? document.documentElement.scrollLeft : window.pageXOffset,
                y: window.pageYOffset === undefined ? document.documentElement.scrollTop : window.pageYOffset
            };
            log(iframeId, 'Get page position: ' + pagePosition.x + ',' + pagePosition.y);
        }
    }
    function setPagePosition(iframeId) {
        if (null !== pagePosition) {
            window.scrollTo(pagePosition.x, pagePosition.y);
            log(iframeId, 'Set page position: ' + pagePosition.x + ',' + pagePosition.y);
            unsetPagePosition();
        }
    }
    function unsetPagePosition() {
        pagePosition = null;
    }
    function resetIFrame(messageData) {
        function reset() {
            setSize(messageData);
            trigger('reset', 'reset', messageData.iframe, messageData.id);
        }
        log(messageData.id, 'Size reset requested by ' + ('init' === messageData.type ? 'host page' : 'iFrame'));
        getPagePosition(messageData.id);
        syncResize(reset, messageData, 'reset');
    }
    function setSize(messageData) {
        function setDimension(dimension) {
            if (!messageData.id) {
                log('undefined', 'messageData id not set');
                return;
            }
            messageData.iframe.style[dimension] = messageData[dimension] + 'px';
            log(messageData.id, 'IFrame (' + iframeId + ') ' + dimension + ' set to ' + messageData[dimension] + 'px');
        }
        function chkZero(dimension) {
            // FireFox sets dimension of hidden iFrames to zero.
            // So if we detect that set up an event to check for
            // when iFrame becomes visible.
            /* istanbul ignore next */ // Not testable in PhantomJS
            if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
                hiddenCheckEnabled = true;
                log(iframeId, 'Hidden iFrame detected, creating visibility listener');
                fixHiddenIFrames();
            }
        }
        function processDimension(dimension) {
            setDimension(dimension);
            chkZero(dimension);
        }
        var iframeId = messageData.iframe.id;
        if (settings[iframeId]) {
            if (settings[iframeId].sizeHeight) processDimension('height');
            if (settings[iframeId].sizeWidth) processDimension('width');
        }
    }
    function syncResize(func, messageData, doNotSync) {
        /* istanbul ignore if */ // Not testable in PhantomJS
        if (doNotSync !== messageData.type && requestAnimationFrame && // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
        !window.jasmine) {
            log(messageData.id, 'Requesting animation frame');
            requestAnimationFrame(func);
        } else func();
    }
    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
        function postMessageToIFrame() {
            var target = settings[id] && settings[id].targetOrigin;
            log(id, '[' + calleeMsg + '] Sending msg to iframe[' + id + '] (' + msg + ') targetOrigin: ' + target);
            iframe.contentWindow.postMessage(msgId + msg, target);
        }
        function iFrameNotFound() {
            warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
        }
        function chkAndSend() {
            if (iframe && 'contentWindow' in iframe && null !== iframe.contentWindow) // Null test for PhantomJS
            postMessageToIFrame();
            else iFrameNotFound();
        }
        function warnOnNoResponse() {
            function warning() {
                if (settings[id] && !settings[id].loaded && !errorShown) {
                    errorShown = true;
                    warn(id, 'IFrame has not responded within ' + settings[id].warningTimeout / 1000 + ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
                }
            }
            if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
        }
        var errorShown = false;
        id = id || iframe.id;
        if (settings[id]) {
            chkAndSend();
            warnOnNoResponse();
        }
    }
    function createOutgoingMsg(iframeId) {
        return iframeId + ':' + settings[iframeId].bodyMarginV1 + ':' + settings[iframeId].sizeWidth + ':' + settings[iframeId].log + ':' + settings[iframeId].interval + ':' + settings[iframeId].enablePublicMethods + ':' + settings[iframeId].autoResize + ':' + settings[iframeId].bodyMargin + ':' + settings[iframeId].heightCalculationMethod + ':' + settings[iframeId].bodyBackground + ':' + settings[iframeId].bodyPadding + ':' + settings[iframeId].tolerance + ':' + settings[iframeId].inPageLinks + ':' + settings[iframeId].resizeFrom + ':' + settings[iframeId].widthCalculationMethod + ':' + settings[iframeId].mouseEvents;
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    function setupIFrame(iframe, options) {
        function setLimits() {
            function addStyle(style) {
                var styleValue = settings[iframeId][style];
                if (Infinity !== styleValue && 0 !== styleValue) {
                    iframe.style[style] = isNumber(styleValue) ? styleValue + 'px' : styleValue;
                    log(iframeId, 'Set ' + style + ' = ' + iframe.style[style]);
                }
            }
            function chkMinMax(dimension) {
                if (settings[iframeId]['min' + dimension] > settings[iframeId]['max' + dimension]) throw new Error('Value for min' + dimension + ' can not be greater than max' + dimension);
            }
            chkMinMax('Height');
            chkMinMax('Width');
            addStyle('maxHeight');
            addStyle('minHeight');
            addStyle('maxWidth');
            addStyle('minWidth');
        }
        function newId() {
            var id = options && options.id || defaults.id + count++;
            if (null !== document.getElementById(id)) id += count++;
            return id;
        }
        function ensureHasId(iframeId) {
            if (typeof iframeId !== 'string') throw new TypeError('Invaild id for iFrame. Expected String');
            if ('' === iframeId) {
                // eslint-disable-next-line no-multi-assign
                iframe.id = iframeId = newId();
                logEnabled = (options || {}).log;
                log(iframeId, 'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')');
            }
            return iframeId;
        }
        function setScrolling() {
            log(iframeId, 'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
            iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
            switch(settings[iframeId] && settings[iframeId].scrolling){
                case 'omit':
                    break;
                case true:
                    iframe.scrolling = 'yes';
                    break;
                case false:
                    iframe.scrolling = 'no';
                    break;
                default:
                    iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
            }
        }
        // The V1 iFrame script expects an int, where as in V2 expects a CSS
        // string value such as '1px 3em', so if we have an int for V2, set V1=V2
        // and then convert V2 to a string PX value.
        function setupBodyMarginValues() {
            if ('number' === typeof (settings[iframeId] && settings[iframeId].bodyMargin) || '0' === (settings[iframeId] && settings[iframeId].bodyMargin)) {
                settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
                settings[iframeId].bodyMargin = '' + settings[iframeId].bodyMargin + 'px';
            }
        }
        function checkReset() {
            // Reduce scope of firstRun to function, because IE8's JS execution
            // context stack is borked and this value gets externally
            // changed midway through running this function!!!
            var firstRun = settings[iframeId] && settings[iframeId].firstRun, resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;
            if (!firstRun && resetRequertMethod) resetIFrame({
                iframe: iframe,
                height: 0,
                width: 0,
                type: 'init'
            });
        }
        function setupIFrameObject() {
            if (settings[iframeId]) settings[iframeId].iframe.iFrameResizer = {
                close: closeIFrame.bind(null, settings[iframeId].iframe),
                removeListeners: removeIframeListeners.bind(null, settings[iframeId].iframe),
                resize: trigger.bind(null, 'Window resize', 'resize', settings[iframeId].iframe),
                moveToAnchor: function(anchor) {
                    trigger('Move to anchor', 'moveToAnchor:' + anchor, settings[iframeId].iframe, iframeId);
                },
                sendMessage: function(message) {
                    message = JSON.stringify(message);
                    trigger('Send Message', 'message:' + message, settings[iframeId].iframe, iframeId);
                }
            };
        }
        // We have to call trigger twice, as we can not be sure if all
        // iframes have completed loading when this code runs. The
        // event listener also catches the page changing in the iFrame.
        function init(msg) {
            function iFrameLoaded() {
                trigger('iFrame.onload', msg, iframe, undefined, true);
                checkReset();
            }
            function createDestroyObserver(MutationObserver) {
                if (!iframe.parentNode) return null;
                var destroyObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
                        ;
                        removedNodes.forEach(function(removedNode) {
                            if (removedNode === iframe) closeIFrame(iframe);
                        });
                    });
                });
                destroyObserver.observe(iframe.parentNode, {
                    childList: true
                });
                return destroyObserver;
            }
            var MutationObserver = getMutationObserver();
            if (MutationObserver) destroyObserver = createDestroyObserver(MutationObserver);
            addEventListener(iframe, 'load', iFrameLoaded);
            trigger('init', msg, iframe, undefined, true);
        }
        function checkOptions(options) {
            if ('object' !== typeof options) throw new TypeError('Options is not an object');
        }
        function copyOptions(options) {
            // eslint-disable-next-line no-restricted-syntax
            for(var option in defaults)if (Object.prototype.hasOwnProperty.call(defaults, option)) settings[iframeId][option] = Object.prototype.hasOwnProperty.call(options, option) ? options[option] : defaults[option];
        }
        function getTargetOrigin(remoteHost) {
            return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost;
        }
        function depricate(key) {
            var splitName = key.split('Callback');
            if (splitName.length === 2) {
                var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
                this[name] = this[key];
                delete this[key];
                warn(iframeId, "Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
            }
        }
        function processOptions(options) {
            options = options || {};
            settings[iframeId] = Object.create(null) // Protect against prototype attacks
            ;
            settings[iframeId].iframe = iframe;
            settings[iframeId].firstRun = true;
            settings[iframeId].remoteHost = iframe.src && iframe.src.split('/').slice(0, 3).join('/');
            checkOptions(options);
            Object.keys(options).forEach(depricate, options);
            copyOptions(options);
            if (settings[iframeId]) settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
        }
        function beenHere() {
            return iframeId in settings && 'iFrameResizer' in iframe;
        }
        var iframeId = ensureHasId(iframe.id);
        if (beenHere()) warn(iframeId, 'Ignored iFrame, already setup.');
        else {
            processOptions(options);
            setScrolling();
            setLimits();
            setupBodyMarginValues();
            init(createOutgoingMsg(iframeId));
            setupIFrameObject();
        }
    }
    function debouce(fn, time) {
        if (null === timer) timer = setTimeout(function() {
            timer = null;
            fn();
        }, time);
    }
    var frameTimer = {};
    function debounceFrameEvents(fn, time, frameId) {
        if (!frameTimer[frameId]) frameTimer[frameId] = setTimeout(function() {
            frameTimer[frameId] = null;
            fn();
        }, time);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function fixHiddenIFrames() {
        function checkIFrames() {
            function checkIFrame(settingId) {
                function chkDimension(dimension) {
                    return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
                }
                function isVisible(el) {
                    return null !== el.offsetParent;
                }
                if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
            }
            Object.keys(settings).forEach(function(key) {
                checkIFrame(key);
            });
        }
        function mutationObserved(mutations) {
            log('window', 'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
            debouce(checkIFrames, 16);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            }, observer = new MutationObserver(mutationObserved);
            observer.observe(target, config);
        }
        var MutationObserver = getMutationObserver();
        if (MutationObserver) createMutationObserver();
    }
    function resizeIFrames(event) {
        function resize() {
            sendTriggerMsg('Window ' + event, 'resize');
        }
        log('window', 'Trigger event: ' + event);
        debouce(resize, 16);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function tabVisible() {
        function resize() {
            sendTriggerMsg('Tab Visible', 'resize');
        }
        if ('hidden' !== document.visibilityState) {
            log('document', 'Trigger event: Visibility change');
            debouce(resize, 16);
        }
    }
    function sendTriggerMsg(eventName, event) {
        function isIFrameResizeEnabled(iframeId) {
            return settings[iframeId] && 'parent' === settings[iframeId].resizeFrom && settings[iframeId].autoResize && !settings[iframeId].firstRun;
        }
        Object.keys(settings).forEach(function(iframeId) {
            if (isIFrameResizeEnabled(iframeId)) trigger(eventName, event, settings[iframeId].iframe, iframeId);
        });
    }
    function setupEventListeners() {
        addEventListener(window, 'message', iFrameListener);
        addEventListener(window, 'resize', function() {
            resizeIFrames('resize');
        });
        addEventListener(document, 'visibilitychange', tabVisible);
        addEventListener(document, '-webkit-visibilitychange', tabVisible);
    }
    function factory() {
        function init(options, element) {
            function chkType() {
                if (!element.tagName) throw new TypeError('Object is not a valid DOM element');
                else if ('IFRAME' !== element.tagName.toUpperCase()) throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>');
            }
            if (element) {
                chkType();
                setupIFrame(element, options);
                iFrames.push(element);
            }
        }
        function warnDeprecatedOptions(options) {
            if (options && options.enablePublicMethods) warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
        }
        var iFrames;
        setupRequestAnimationFrame();
        setupEventListeners();
        return function iFrameResizeF(options, target) {
            iFrames = [] // Only return iFrames past in on this call
            ;
            warnDeprecatedOptions(options);
            switch(typeof target){
                case 'undefined':
                case 'string':
                    Array.prototype.forEach.call(document.querySelectorAll(target || 'iframe'), init.bind(undefined, options));
                    break;
                case 'object':
                    init(options, target);
                    break;
                default:
                    throw new TypeError('Unexpected data type (' + typeof target + ')');
            }
            return iFrames;
        };
    }
    function createJQueryPublicMethod($) {
        if (!$.fn) info('', 'Unable to bind to jQuery, it is not fully loaded.');
        else if (!$.fn.iFrameResize) $.fn.iFrameResize = function $iFrameResizeF(options) {
            function init(index, element) {
                setupIFrame(element, options);
            }
            return this.filter('iframe').each(init).end();
        };
    }
    if (window.jQuery !== undefined) createJQueryPublicMethod(window.jQuery);
    if (typeof define === 'function' && define.amd) define([], factory);
    else if (typeof $7ea6468ad1446672$exports === 'object') // Node for browserfy
    $7ea6468ad1446672$exports = factory();
    window.iFrameResize = window.iFrameResize || factory();
})();



$ccf03f3c62b4f2fe$exports = {
    iframeResize: $7ea6468ad1446672$exports,
    iframeResizer: $7ea6468ad1446672$exports,
    contentWindow: (parcelRequire("8UnLC"))
};


iFrameResize({
    log: false
}, '#webcastIframe');



(function() {
    const accordionItems = document.querySelectorAll('[data-accordion-item]');
    /**
     * Stop all iframes or HTML5 <video>'s from playing
     */ const stopVideos = function(item) {
        const videos = item.querySelectorAll('iframe, video');
        if (!videos.length) return;
        Array.prototype.forEach.call(videos, function(video) {
            if (video.tagName.toLowerCase() === 'video') video.pause();
            else {
                var src = video.src;
                video.src = src;
            }
        });
    };
    if (!accordionItems.length) return;
    accordionItems.forEach((accordionItem)=>{
        const details = accordionItem;
        const clickTarget = accordionItem.querySelector('summary');
        const collapsibleElement = accordionItem.querySelector('.accordion-item__content');
        clickTarget.onclick = function(e) {
            e.preventDefault();
            if (details.open) {
                stopVideos(accordionItem);
                (0, $1974f63041948ee8$export$99ee26438460406a).to(collapsibleElement, {
                    duration: 0.3,
                    height: 0,
                    ease: 'expo.inOut',
                    onComplete: ()=>{
                        details.open = false;
                    }
                });
            } else {
                details.open = true;
                (0, $1974f63041948ee8$export$99ee26438460406a).set(collapsibleElement, {
                    height: 'auto'
                });
                (0, $1974f63041948ee8$export$99ee26438460406a).from(collapsibleElement, {
                    duration: 0.3,
                    height: 0,
                    ease: 'expo.inOut',
                    onComplete: ()=>collapsibleElement.style.height = 'auto'
                });
            }
        };
    });
})();





(function() {
    const langSelector = document.getElementById('lang-selector');
    const list = document.getElementById('lang-selector-list');
    const toggle = document.getElementById('lang-selector-toggle');
    const staggerItems = document.getElementsByClassName('language-selector__list-item');
    const closeNavigation = function() {
        (0, $1974f63041948ee8$export$99ee26438460406a).to(staggerItems, {
            duration: 0.15,
            delay: 0,
            opacity: 0,
            scaleY: 0,
            transformOrigin: 'top',
            stagger: -0.1,
            ease: 'expo.in',
            onComplete: ()=>{
                if (list) list.classList.remove('language-selector__list--open');
                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                    toggle.classList.remove('language-selector__toggle--open');
                }
                if (langSelector) langSelector.removeEventListener('keyup', escapeEvent);
            }
        });
    };
    const escapeEvent = (event)=>{
        if (event.defaultPrevented) return;
        const key = event.key || event.keyCode;
        if (key === 'Escape' || key === 'Esc' || key === 27) closeNavigation();
    };
    if (toggle) toggle.onclick = function() {
        closeNavigation();
    };
    if (toggle && list && langSelector) toggle.onclick = function() {
        if (list.classList.contains('language-selector__list--open')) closeNavigation();
        else {
            list.classList.add('language-selector__list--open');
            const listWidth = list.clientWidth;
            const toggleWidth = toggle.clientWidth;
            toggle.setAttribute('aria-expanded', 'true');
            toggle.classList.add('language-selector__toggle--open');
            langSelector.addEventListener('keyup', escapeEvent);
            (0, $1974f63041948ee8$export$99ee26438460406a).set(staggerItems, {
                opacity: 0,
                scaleY: 0,
                transformOrigin: 'top'
            });
            (0, $1974f63041948ee8$export$99ee26438460406a).to(staggerItems, {
                duration: 0.25,
                delay: 0,
                opacity: 1,
                scaleY: 1,
                stagger: 0.1,
                ease: 'back.out'
            });
        }
    };
    if (langSelector) window.addEventListener('click', function(event) {
        const target = event.target;
        if (target && !langSelector.contains(target)) closeNavigation();
    });
})();


function $143acc617b86de23$export$61fc7d43ac8f84b0(func, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}


function $25096305884d9bbc$var$autocomplete(searchForm) {
    let currentFocus;
    if (!searchForm) return;
    const searchInput = searchForm.getElementsByTagName('input')[0];
    const searchButton = searchForm.getElementsByTagName('button')[0];
    const getDataFromApi = async (prefix)=>{
        if (prefix != '') {
            const searchActionUrl = searchForm.querySelector('form').getAttribute('action');
            await fetch(`${searchActionUrl}/Suggest?prefix=${prefix}`).then((response)=>response.json()).then((json)=>{
                const suggestions = json.hits.map((hit)=>hit.query);
                if (suggestions.length > 0) createList(suggestions, prefix);
            }).catch((error)=>{
                console.log('error', error);
            });
        }
    };
    // <li aria-selected="false" class="autocomplete__option autocomplete__option--odd" id="autocomplete-default__option--1" role="option" tabindex="-1" aria-posinset="2" aria-setsize="3">Central African Republic</li>
    const createList = (items, fieldVal)=>{
        let divCreate, ulCreate, listElement, i, listButton;
        currentFocus = -1;
        divCreate = document.createElement('div');
        ulCreate = document.createElement('ul');
        divCreate.appendChild(ulCreate);
        ulCreate.setAttribute('id', searchInput.id + 'autocomplete-list');
        ulCreate.setAttribute('role', 'listbox');
        divCreate.setAttribute('class', 'search-form__dropdown');
        searchInput.parentNode.parentNode.appendChild(divCreate);
        searchForm.classList.add('search-form--has-dropdown');
        for(i = 0; i < items.length; i++)if (items[i].substr(0, fieldVal.length).toUpperCase() == fieldVal.toUpperCase()) {
            listElement = document.createElement('li');
            listButton = document.createElement('button');
            listButton.setAttribute('type', 'button');
            listElement.setAttribute('role', 'option');
            listElement.classList.add('search-form__dropdown__item');
            listElement.setAttribute('id', 'search-form__dropdown__item_' + i);
            listElement.innerHTML = '<span>' + items[i].substr(0, fieldVal.length) + '</span>';
            listElement.innerHTML += items[i].substr(fieldVal.length);
            listElement.setAttribute('data-value', items[i]);
            listElement.setAttribute('aria-setsize', items.length);
            listElement.setAttribute('aria-posinset', i + 1);
            listElement.setAttribute('tabindex', "-1");
            // b.innerHTML += "<input type='hidden' value='" + items[i] + "'>";
            listElement.addEventListener('click', function(e) {
                console.log('click', e.target);
                searchInput.value = e.target.dataset.value;
                searchButton.click();
            // closeAllLists(e.target);
            });
            searchInput.setAttribute('aria-expanded', 'true');
            ulCreate.appendChild(listElement);
        }
    };
    const checkInput = (e)=>{
        let fieldVal = e.target.value;
        closeAllLists();
        if (!fieldVal) return false;
        getDataFromApi(fieldVal);
    };
    searchInput.addEventListener('input', (0, $143acc617b86de23$export$61fc7d43ac8f84b0)((e)=>checkInput(e)));
    searchInput.addEventListener('keydown', function(e) {
        let autocompleteList = document.getElementById(this.id + 'autocomplete-list');
        if (autocompleteList) autocompleteList = autocompleteList.getElementsByTagName('li');
        const key = e.key || e.keyCode;
        if (key == 40 || key == 'ArrowDown') {
            //down
            currentFocus++;
            addActive(autocompleteList);
        } else if (key == 38 || key == 'ArrowUp') {
            //up
            currentFocus--;
            addActive(autocompleteList);
        } else if (key == 13 || key == 'Enter') //enter key
        {
            if (currentFocus > -1) {
                e.preventDefault();
                if (autocompleteList) autocompleteList[currentFocus].click();
            }
        } else if (key === 'Escape' || key === 'Esc' || key === 27) closeAllLists(e.target);
        console.log(currentFocus);
    });
    function addActive(autocompleteList) {
        if (!autocompleteList) return false;
        removeActive(autocompleteList);
        if (currentFocus >= autocompleteList.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = autocompleteList.length - 1;
        searchInput.setAttribute("aria-activedescendant", 'search-form__dropdown__item_' + currentFocus);
        console.log(autocompleteList[currentFocus]);
        autocompleteList[currentFocus].classList.add('autocomplete-active');
        autocompleteList[currentFocus].setAttribute('aria-selected', true);
    // autocompleteList[currentFocus].focus();
    }
    function removeActive(autocompleteList) {
        for(var i = 0; i < autocompleteList.length; i++){
            autocompleteList[i].classList.remove('autocomplete-active');
            autocompleteList[i].removeAttribute('aria-selected', true);
        }
    }
    function closeAllLists(elmnt) {
        searchForm.classList.remove('search-form--has-dropdown');
        var autocompleteList = document.getElementsByClassName('search-form__dropdown');
        for(var i = 0; i < autocompleteList.length; i++)if (elmnt != autocompleteList[i] && elmnt != searchInput) autocompleteList[i].parentNode.removeChild(autocompleteList[i]);
        searchInput.setAttribute('aria-expanded', 'false');
    }
    document.addEventListener('click', function(e) {
        closeAllLists(e.target);
    });
}
$25096305884d9bbc$var$autocomplete(document.getElementById('searchPageSearch'));
$25096305884d9bbc$var$autocomplete(document.getElementById('headerSearchForm'));


//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
class $5611204dba55fa8c$export$c9ce65124d222c64 {
}
class $5611204dba55fa8c$export$712b737e999aeef9 {
}
class $5611204dba55fa8c$export$22651c2840fe9a6f {
}
class $5611204dba55fa8c$export$b0a8614754aa4cb8 {
}
class $5611204dba55fa8c$export$6ad8415c10837c2f extends $5611204dba55fa8c$export$b0a8614754aa4cb8 {
}
class $5611204dba55fa8c$export$6f4fd64aef9a61f0 {
}
class $5611204dba55fa8c$export$691daf630d2bd942 {
}
class $5611204dba55fa8c$export$c394c2f9dbf7ee26 {
}
class $5611204dba55fa8c$export$38325152e97f36be {
}
class $5611204dba55fa8c$export$da923a61327a587e {
}
class $5611204dba55fa8c$export$de4217e1b46d9894 extends $5611204dba55fa8c$export$b0a8614754aa4cb8 {
}
class $5611204dba55fa8c$export$f700c79c077df835 {
}
class $5611204dba55fa8c$export$215358e5b5dfc1f9 {
}
class $5611204dba55fa8c$export$73974d1f547d9d48 {
}
var $5611204dba55fa8c$export$3ea65033b6956d45 = /*#__PURE__*/ function(MapEndpointType) {
    MapEndpointType[MapEndpointType["ProjectPageContactCardMap"] = 0] = "ProjectPageContactCardMap";
    MapEndpointType[MapEndpointType["ProjectListPageMap"] = 1] = "ProjectListPageMap";
    MapEndpointType[MapEndpointType["FeaturedProjectMap"] = 2] = "FeaturedProjectMap";
    MapEndpointType[MapEndpointType["ContactCardMap"] = 3] = "ContactCardMap";
    return MapEndpointType;
}({});
class $5611204dba55fa8c$export$891d2a736b3510c1 {
}



var $kMGLj = parcelRequire("kMGLj");
var $be4debe075ad0ecc$exports = {};

(function(root, factory) {
    $be4debe075ad0ecc$exports = factory((parcelRequire("kMGLj")));
})($be4debe075ad0ecc$exports, function(mapboxgl) {
    function MapboxglSpiderifier(map, userOptions) {
        var util = {
            each: eachFn,
            map: mapFn,
            mapTimes: mapTimesFn,
            eachTimes: eachTimesFn
        }, NULL_FUNCTION = function() {}, options = {
            animate: false,
            animationSpeed: 0,
            customPin: false,
            initializeLeg: NULL_FUNCTION,
            onClick: NULL_FUNCTION,
            // --- <SPIDER TUNING Params>
            // circleSpiralSwitchover: show spiral instead of circle from this marker count upwards
            //                        0 -> always spiral; Infinity -> always circle
            circleSpiralSwitchover: 9,
            circleFootSeparation: 25,
            spiralFootSeparation: 28,
            spiralLengthStart: 15,
            spiralLengthFactor: 4
        }, twoPi = Math.PI * 2, previousSpiderLegs = [];
        for(var attrname in userOptions)options[attrname] = userOptions[attrname];
        // Public:
        this.spiderfy = spiderfy;
        this.unspiderfy = unspiderfy;
        this.each = function(callback) {
            util.each(previousSpiderLegs, callback);
        };
        // Private:
        function spiderfy(latLng, features) {
            var spiderLegParams = generateSpiderLegParams(features.length);
            var spiderLegs;
            unspiderfy();
            spiderLegs = util.map(features, function(feature, index) {
                var spiderLegParam = spiderLegParams[index];
                var elements = createMarkerElements(spiderLegParam, feature);
                var mapboxMarker;
                var spiderLeg;
                mapboxMarker = new mapboxgl.Marker(elements.container).setLngLat(latLng);
                spiderLeg = {
                    feature: feature,
                    elements: elements,
                    mapboxMarker: mapboxMarker,
                    param: spiderLegParam
                };
                options.initializeLeg(spiderLeg);
                elements.container.onclick = function(e) {
                    options.onClick(e, spiderLeg);
                };
                return spiderLeg;
            });
            util.each(spiderLegs.reverse(), function(spiderLeg) {
                spiderLeg.mapboxMarker.addTo(map);
            });
            if (options.animate) setTimeout(function() {
                util.each(spiderLegs.reverse(), function(spiderLeg, index) {
                    spiderLeg.elements.container.className = (spiderLeg.elements.container.className || '').replace('initial', '');
                    spiderLeg.elements.container.style['transitionDelay'] = options.animationSpeed / 1000 / spiderLegs.length * index + 's';
                });
            });
            previousSpiderLegs = spiderLegs;
        }
        function unspiderfy() {
            util.each(previousSpiderLegs.reverse(), function(spiderLeg, index) {
                if (options.animate) {
                    spiderLeg.elements.container.style['transitionDelay'] = options.animationSpeed / 1000 / previousSpiderLegs.length * index + 's';
                    spiderLeg.elements.container.className += ' exit';
                    setTimeout(function() {
                        spiderLeg.mapboxMarker.remove();
                    }, options.animationSpeed + 100); //Wait for 100ms more before clearing the DOM
                } else spiderLeg.mapboxMarker.remove();
            });
            previousSpiderLegs = [];
        }
        function generateSpiderLegParams(count) {
            if (count >= options.circleSpiralSwitchover) return generateSpiralParams(count);
            else return generateCircleParams(count);
        }
        function generateSpiralParams(count) {
            var legLength = options.spiralLengthStart, angle = 0;
            return util.mapTimes(count, function(index) {
                var pt;
                angle = angle + (options.spiralFootSeparation / legLength + index * 0.0005);
                pt = {
                    x: legLength * Math.cos(angle),
                    y: legLength * Math.sin(angle),
                    angle: angle,
                    legLength: legLength,
                    index: index
                };
                legLength = legLength + twoPi * options.spiralLengthFactor / angle;
                return pt;
            });
        }
        function generateCircleParams(count) {
            var circumference = options.circleFootSeparation * (2 + count), legLength = circumference / twoPi, angleStep = twoPi / count;
            return util.mapTimes(count, function(index) {
                var angle = index * angleStep;
                return {
                    x: legLength * Math.cos(angle),
                    y: legLength * Math.sin(angle),
                    angle: angle,
                    legLength: legLength,
                    index: index
                };
            });
        }
        function createMarkerElements(spiderLegParam) {
            var containerElem = document.createElement('div'), pinElem = document.createElement('div'), lineElem = document.createElement('div');
            containerElem.className = 'spider-leg-container' + (options.animate ? ' animate initial ' : ' ');
            lineElem.className = 'spider-leg-line';
            pinElem.className = 'spider-leg-pin' + (options.customPin ? '' : ' default-spider-pin');
            containerElem.appendChild(lineElem);
            containerElem.appendChild(pinElem);
            containerElem.style['margin-left'] = spiderLegParam.x + 'px';
            containerElem.style['margin-top'] = spiderLegParam.y + 'px';
            lineElem.style.height = spiderLegParam.legLength + 'px';
            // lineElem.style.transform = 'rotate(' + (2*Math.PI - spiderLegParam.angle) +'rad)';
            lineElem.style.transform = 'rotate(' + (spiderLegParam.angle - Math.PI / 2) + 'rad)';
            return {
                container: containerElem,
                line: lineElem,
                pin: pinElem
            };
        }
        // Utility
        function eachFn(array, iterator) {
            var i = 0;
            if (!array || !array.length) return [];
            for(i = 0; i < array.length; i++)iterator(array[i], i);
        }
        function eachTimesFn(count, iterator) {
            if (!count) return [];
            for(var i = 0; i < count; i++)iterator(i);
        }
        function mapFn(array, iterator) {
            var result = [];
            eachFn(array, function(item, i) {
                result.push(iterator(item, i));
            });
            return result;
        }
        function mapTimesFn(count, iterator) {
            var result = [];
            eachTimesFn(count, function(i) {
                result.push(iterator(i));
            });
            return result;
        }
    }
    // Returns Offset option for mapbox poup, so that the popup for pins in the spider
    // appears next to the pin, rather than at the center of the spider.
    // offset: <number> Offset of the popup from the pin.
    MapboxglSpiderifier.popupOffsetForSpiderLeg = function popupOffsetForSpiderLeg(spiderLeg, offset) {
        var pinOffsetX = spiderLeg.param.x;
        var pinOffsetY = spiderLeg.param.y;
        offset = offset || 0;
        return {
            'top': offsetVariant([
                0,
                offset
            ], pinOffsetX, pinOffsetY),
            'top-left': offsetVariant([
                offset,
                offset
            ], pinOffsetX, pinOffsetY),
            'top-right': offsetVariant([
                -offset,
                offset
            ], pinOffsetX, pinOffsetY),
            'bottom': offsetVariant([
                0,
                -offset
            ], pinOffsetX, pinOffsetY),
            'bottom-left': offsetVariant([
                offset,
                -offset
            ], pinOffsetX, pinOffsetY),
            'bottom-right': offsetVariant([
                -offset,
                -offset
            ], pinOffsetX, pinOffsetY),
            'left': offsetVariant([
                offset,
                -offset
            ], pinOffsetX, pinOffsetY),
            'right': offsetVariant([
                -offset,
                -offset
            ], pinOffsetX, pinOffsetY)
        };
    };
    function offsetVariant(offset, variantX, variantY) {
        return [
            offset[0] + (variantX || 0),
            offset[1] + (variantY || 0)
        ];
    }
    return MapboxglSpiderifier;
});




var $kMGLj = parcelRequire("kMGLj");
function $a302fbcb41b6324b$var$paginate({ totalItems: totalItems, currentPage: currentPage = 1, pageSize: pageSize = 10, maxPages: maxPages = 10 }) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);
    // ensure current page isn't out of range
    if (currentPage < 1) currentPage = 1;
    else if (currentPage > totalPages) currentPage = totalPages;
    let startPage, endPage;
    if (totalPages <= maxPages) {
        // total pages less than max so show all pages
        startPage = 1;
        endPage = totalPages;
    } else {
        // total pages more than max so calculate start and end pages
        let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
        let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
        if (currentPage <= maxPagesBeforeCurrentPage) {
            // current page near the start
            startPage = 1;
            endPage = maxPages;
        } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
            // current page near the end
            startPage = totalPages - maxPages + 1;
            endPage = totalPages;
        } else {
            // current page somewhere in the middle
            startPage = currentPage - maxPagesBeforeCurrentPage;
            endPage = currentPage + maxPagesAfterCurrentPage;
        }
    }
    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i)=>startPage + i);
    // return object with all pager properties required by the view
    return {
        totalItems: totalItems,
        currentPage: currentPage,
        pageSize: pageSize,
        totalPages: totalPages,
        startPage: startPage,
        endPage: endPage,
        startIndex: startIndex,
        endIndex: endIndex,
        pages: pages
    };
}
var $a302fbcb41b6324b$export$2e2bcd8739ae039 = $a302fbcb41b6324b$var$paginate;


const $93fd8d0d9f93e298$var$cardsPagination = (searchData, onPageChange)=>{
    const { paginationTranslation: paginationTranslation, pageSearchHitsCount: pageSearchHitsCount } = searchData;
    const { forNext: forNext, forOf: forOf, forPrevious: forPrevious } = paginationTranslation;
    const paginationEl = document.querySelector('.pagination-dynamic');
    const { numberOfItemsInList: numberOfItemsInList } = paginationEl.dataset;
    const pageSize = Number(numberOfItemsInList);
    let pagination = (0, $a302fbcb41b6324b$export$2e2bcd8739ae039)({
        totalItems: pageSearchHitsCount,
        pageSize: pageSize
    });
    const { pages: pages, currentPage: currentPage, totalPages: totalPages } = pagination;
    const createPagination = ()=>{
        const paginationEl = document.querySelector('.pagination-dynamic');
        const paginationWrapperEl = paginationEl.querySelector('.pagination__wrapper');
        if (pageSearchHitsCount === 0 || !pages.length) {
            paginationWrapperEl.innerHTML = '';
            return;
        }
        if (pages.length === 1) {
            onPageChange(pagination);
            return;
        }
        const paginationMobileEl = document.createElement('p');
        paginationMobileEl.classList.add('pagination__mobile');
        paginationMobileEl.innerHTML = `
            <span class="pagination__mobile__current">${currentPage}</span>
            ${forOf}
            <span class="pagination__mobile__total">${totalPages}</span>
        `;
        const paginationListEl = document.createElement('ul');
        paginationListEl.classList.add('pagination__list');
        const paginationItems = [];
        pages.forEach((num)=>{
            const isActive = num === currentPage;
            const item = createPaginationItem(num, isActive);
            paginationItems.push(item);
        });
        paginationWrapperEl.append(paginationMobileEl, paginationListEl);
        const previousButton = `
            <li class="pagination__item pagination__item--previous">
                <button class="pagination__previous" rel="prev">
                    <span class="pagination__previous__icon">
                        <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                            aria-hidden="true" focusable="false" fill="currentColor">
                            <polygon
                                points="29.83 5.73 27 8.55 40.01 21.56 40.01 22 4.02 22 4.02 26 40.01 26 40.01 26.44 26.98 39.45 29.81 42.28 44.01 28.1 44.01 19.91 29.83 5.73">
                            </polygon>
                        </svg>
                    </span>
                    <span class="pagination__previous__text">${forPrevious}</span>
                </button>
            </li>
        `;
        const nextButton = `
            <li class="pagination__item pagination__item--next">
                <button class="pagination__next" rel="next">
                    <span class="pagination__next__text">${forNext}</span>
                    <span class="pagination__next__icon">
                        <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                            fill="currentColor" aria-hidden="true" focusable="false">
                            <polygon
                                points="29.83 5.73 27 8.55 40.01 21.56 40.01 22 4.02 22 4.02 26 40.01 26 40.01 26.44 26.98 39.45 29.81 42.28 44.01 28.1 44.01 19.91 29.83 5.73">
                            </polygon>
                        </svg>
                    </span>
                </button>
            </li>
        `;
        paginationListEl.insertAdjacentHTML('afterbegin', previousButton);
        paginationItems.forEach((item)=>paginationListEl.append(item));
        paginationListEl.insertAdjacentHTML('beforeend', nextButton);
        const buttonPreviousEl = document.querySelector('button.pagination__previous');
        const buttonNextEl = document.querySelector('button.pagination__next');
        buttonPreviousEl.addEventListener('click', function() {
            const { currentPage: currentPage } = pagination;
            setCurrentPage(currentPage - 1);
        });
        buttonNextEl.addEventListener('click', function() {
            const { currentPage: currentPage } = pagination;
            setCurrentPage(currentPage + 1);
        });
        onPageChange(pagination);
    };
    const setCurrentPage = (num)=>{
        const { currentPage: currentPage, pages: pages } = pagination;
        if (currentPage === num || num < 1) return;
        if (num === pages[pages.length - 1] + 1) return;
        const items = document.querySelectorAll('.pagination__item');
        items.forEach((el)=>el.classList.remove('pagination__item--current'));
        const pageNumberEl = document.querySelectorAll(`.pagination__item[data-page-number="${num.toString()}"]`)[0];
        pageNumberEl.classList.add('pagination__item--current');
        const pageNumberMobileCurrent = document.querySelector('.pagination__mobile__current');
        pageNumberMobileCurrent.textContent = num.toString();
        pagination = (0, $a302fbcb41b6324b$export$2e2bcd8739ae039)({
            totalItems: pageSearchHitsCount,
            pageSize: pageSize,
            currentPage: num
        });
        onPageChange(pagination);
    };
    const createPaginationItem = (num, isActive)=>{
        const item = document.createElement('li');
        item.classList.add('pagination__item');
        item.setAttribute('data-page-number', num.toString());
        item.addEventListener('click', function(e) {
            setCurrentPage(num);
        });
        if (isActive) {
            const link = document.createElement('span');
            link.classList.add('pagination__link');
            link.textContent = num.toString();
            item.append(link);
            item.classList.add('pagination__item--current');
            return item;
        } else {
            const link = document.createElement('span');
            link.classList.add('pagination__link');
            link.textContent = num.toString();
            item.append(link);
            return item;
        }
    };
    createPagination();
};
var $93fd8d0d9f93e298$export$2e2bcd8739ae039 = $93fd8d0d9f93e298$var$cardsPagination;


const $5d0fafb2bd24c3c5$var$getData = async (url)=>{
    const res = await fetch(url).then((response)=>response.json());
    return res;
};
const $5d0fafb2bd24c3c5$var$createListItem = (properties)=>{
    const { imageSrcUrl: imageSrcUrl, dateAndPlace: dateAndPlace, title: title, description: description, contentUrl: contentUrl } = properties;
    const listItemEl = document.createElement('li');
    listItemEl.classList.add('entryblock');
    const content = `
        <a class="entryblock__link" href="${contentUrl}">
            <div class="entryblock__image ratio ratio--1-1">
                <img class="ratio__item ratio__item--cover" alt="" src="${imageSrcUrl}" />
            </div>

            <div class="entryblock__content">
                <p class="entryblock__date">${dateAndPlace}</p>
                <h3 class="entryblock__title">${title}</h3>
                <p class="entryblock__text">${description}</p>
                <svg class="vd-icon vd-icon-arrow-right" width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" fill="currentColor">
                <polygon points="29.83 5.73 27 8.55 40.01 21.56 40.01 22 4.02 22 4.02 26 40.01 26 40.01 26.44 26.98 39.45 29.81 42.28 44.01 28.1 44.01 19.91 29.83 5.73"></polygon>
                </svg>
            </div>
        </a>
  `;
    listItemEl.innerHTML = content;
    return listItemEl;
};
const $5d0fafb2bd24c3c5$var$createList = (elements)=>{
    const productCardsEl = document.querySelector('.project-cards');
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');
    productsCardsListEl.innerHTML = '';
    elements.forEach((element)=>{
        const listItem = $5d0fafb2bd24c3c5$var$createListItem(element);
        productsCardsListEl.append(listItem);
    });
};
const $5d0fafb2bd24c3c5$export$68477b6f04b7bf2 = (list, searchData)=>{
    const { pageSearchHits: pageSearchHits } = searchData;
    const resultIds = pageSearchHits.map((item)=>item.contentLinkId);
    const newList = list.filter((item)=>resultIds.includes(item.contentLinkId));
    return newList;
};
const $5d0fafb2bd24c3c5$export$57a5f2d0e67d7713 = ()=>{
    const catIds = [];
    let searchTerm = '';
    const url = new URL(window.location.href);
    for (const [key, value] of url.searchParams.entries()){
        if (key === 'catids') {
            if (value != null) {
                const commaSeparatedValuesOrNot = value.split(",");
                for (const val of commaSeparatedValuesOrNot)catIds.push(Number(val));
            }
        } else if (key === 'q') searchTerm = value;
    }
    return {
        catIds: catIds,
        searchTerm: searchTerm
    };
};
const $5d0fafb2bd24c3c5$export$cfcc0908d6dfb8a6 = async ({ guuid: guuid, langId: langId, catIds: catIds, searchTerm: searchTerm })=>{
    const mainUrl = window.location.origin;
    const apiUrl = `${mainUrl}/api/map/ProjectListPageSearchResults/${guuid}/${langId}?catIds=${catIds.toString()}&q=${searchTerm}`;
    const data = await $5d0fafb2bd24c3c5$var$getData(apiUrl);
    return data;
};
const $5d0fafb2bd24c3c5$export$ee52b86b54557588 = async ({ guuid: guuid, langId: langId, catIds: catIds, searchTerm: searchTerm })=>{
    const searchData = await $5d0fafb2bd24c3c5$export$cfcc0908d6dfb8a6({
        guuid: guuid,
        langId: langId,
        catIds: catIds,
        searchTerm: searchTerm
    });
    searchData.pageSearchHits = searchData.pageSearchHits.filter((hit)=>hit.pageIsDisabled === false);
    searchData.pageSearchHitsCount = searchData.pageSearchHits.length;
    return searchData;
};
const $5d0fafb2bd24c3c5$var$updateList = async ({ searchTerm: searchTerm, guuid: guuid, langId: langId, initialList: initialList })=>{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    searchParams.delete('q');
    searchParams.append('q', searchTerm);
    url.search = searchParams.toString();
    history.pushState({}, null, url.toString());
    const productCardsEl = document.querySelector('.project-cards');
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');
    const { catIds: catIds } = $5d0fafb2bd24c3c5$export$57a5f2d0e67d7713();
    const searchDataWithoutDisabledProjects = await $5d0fafb2bd24c3c5$export$ee52b86b54557588({
        guuid: guuid,
        langId: langId,
        catIds: catIds,
        searchTerm: searchTerm
    });
    const filteredList = $5d0fafb2bd24c3c5$export$68477b6f04b7bf2(initialList, searchDataWithoutDisabledProjects);
    productsCardsListEl.innerHTML = '';
    const paginationEl = document.querySelector('.pagination-dynamic');
    const paginationWrapperEl = paginationEl.querySelector('.pagination__wrapper');
    paginationWrapperEl.innerHTML = '';
    (0, $93fd8d0d9f93e298$export$2e2bcd8739ae039)(searchDataWithoutDisabledProjects, (pagination)=>$5d0fafb2bd24c3c5$var$handlePageChange(pagination, filteredList));
    $5d0fafb2bd24c3c5$var$handleNoResultsMessage(searchDataWithoutDisabledProjects.pageSearchHitsCount < 1);
};
const $5d0fafb2bd24c3c5$var$clearList = ()=>{
    const productCardsEl = document.querySelector('.project-cards');
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');
    productsCardsListEl.innerHTML = '';
};
const $5d0fafb2bd24c3c5$var$handlePageChange = (paginationData, filteredList)=>{
    const { startIndex: startIndex, endIndex: endIndex } = paginationData;
    const slicedList = filteredList.slice(startIndex, endIndex + 1);
    $5d0fafb2bd24c3c5$var$clearList();
    $5d0fafb2bd24c3c5$var$createList(slicedList);
};
const $5d0fafb2bd24c3c5$var$handleNoResultsMessage = (isVisible)=>{
    let noResultsDiv = document.getElementById("no-results-placeholder");
    if (noResultsDiv) {
        if (!isVisible) noResultsDiv.style.display = "none";
        else noResultsDiv.style.display = "block";
    }
};
const $5d0fafb2bd24c3c5$var$projectCards = async ()=>{
    const productCardsEl = document.querySelector('.project-cards');
    if (!productCardsEl) return;
    const productsCardsListEl = productCardsEl.querySelector('.project-cards__list');
    const inputWrapperEl = document.querySelector('.input-search-wrapper');
    const inputEl = inputWrapperEl.querySelector('.input-cards-filter');
    const iconEl = inputWrapperEl.querySelector('.search-icon');
    const filterBoxEl = document.querySelector('.filter-box');
    const { lang: lang, guuid: guuid } = productsCardsListEl.dataset;
    const langId = Number(lang);
    const mainUrl = window.location.origin;
    const projectListApiUrl = `${mainUrl}/api/map/ProjectListPageMap/${guuid}/${lang}`;
    const { catIds: catIds, searchTerm: searchTerm } = $5d0fafb2bd24c3c5$export$57a5f2d0e67d7713();
    const allProjectsData = await $5d0fafb2bd24c3c5$var$getData(projectListApiUrl);
    const searchDataWithoutDisabledProjects = await $5d0fafb2bd24c3c5$export$ee52b86b54557588({
        guuid: guuid,
        langId: langId,
        catIds: catIds,
        searchTerm: searchTerm
    });
    $5d0fafb2bd24c3c5$var$handleNoResultsMessage(searchDataWithoutDisabledProjects.pageSearchHitsCount < 1);
    const filteredList = $5d0fafb2bd24c3c5$export$68477b6f04b7bf2(allProjectsData.mapItems, searchDataWithoutDisabledProjects);
    inputEl.value = searchTerm;
    inputEl.onkeyup = function(e) {
        const event = e;
        if (event.key === 'Enter') {
            const searchTerm = event.target['value'];
            $5d0fafb2bd24c3c5$var$updateList({
                searchTerm: searchTerm,
                guuid: guuid,
                langId: langId,
                initialList: allProjectsData.mapItems
            });
        }
    };
    iconEl.addEventListener('click', function() {
        $5d0fafb2bd24c3c5$var$updateList({
            searchTerm: inputEl.value,
            guuid: guuid,
            langId: langId,
            initialList: allProjectsData.mapItems
        });
    });
    if (filterBoxEl) {
        const filterSubmitButtonEl = filterBoxEl.querySelector('.filter-button--submit');
        const filterAbortButtonEl = filterBoxEl.querySelector('.filter-button--abort');
        filterSubmitButtonEl.addEventListener('click', function() {
            $5d0fafb2bd24c3c5$var$updateList({
                searchTerm: searchTerm,
                guuid: guuid,
                langId: langId,
                initialList: allProjectsData.mapItems
            });
        });
        filterAbortButtonEl.addEventListener('click', function() {
            $5d0fafb2bd24c3c5$var$updateList({
                searchTerm: searchTerm,
                guuid: guuid,
                langId: langId,
                initialList: allProjectsData.mapItems
            });
        });
    }
    (0, $93fd8d0d9f93e298$export$2e2bcd8739ae039)(searchDataWithoutDisabledProjects, (pagination)=>$5d0fafb2bd24c3c5$var$handlePageChange(pagination, filteredList));
};
$5d0fafb2bd24c3c5$var$projectCards();


const $0e9407883341aa7e$var$popupSettings = {
    classNames: {
        office: 'map-popup map-popup__office',
        'contact-card': 'map-popup map-popup__contact-card',
        project: 'map-popup map-popup__project'
    },
    maxWidths: {
        office: '100%',
        'contact-card': '100%',
        project: '560px'
    },
    offsets: {
        top: [
            0,
            30
        ],
        'top-left': [
            0,
            30
        ],
        'top-right': [
            0,
            30
        ],
        bottom: [
            0,
            -30
        ],
        'bottom-left': [
            0,
            -30
        ],
        'bottom-right': [
            0,
            -30
        ],
        left: [
            30,
            0
        ],
        right: [
            -30,
            0
        ]
    }
};
const $0e9407883341aa7e$export$dff72a5fd5ad3e0c = (map)=>{
    map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).FullscreenControl(), 'bottom-right');
    map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).NavigationControl({
        showCompass: false
    }), 'bottom-right');
};
const $0e9407883341aa7e$export$8250d5b41185d62d = (map, images)=>{
    images.forEach((imageData)=>{
        const { src: src, name: name } = imageData;
        map.loadImage(src, function(error, image) {
            if (error) throw error;
            map.addImage(name, image);
        });
    });
};
const $0e9407883341aa7e$export$bb39f6f3ba85bd94 = (map, layerName)=>{
    map.setLayoutProperty(layerName, 'icon-image', 'unactive-marker');
};
const $0e9407883341aa7e$export$179985d5b2b4978c = (removeAll = false)=>{
    const popup = document.getElementsByClassName('mapboxgl-popup');
    if (!removeAll && popup.length === 1) return;
    else for(let i = 0; i < popup.length; i++)popup[i].remove();
};
const $0e9407883341aa7e$export$c1e84714c800b36a = (features)=>{
    let bounds = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).LngLatBounds();
    features.forEach(function(feature) {
        const coords = feature.geometry.coordinates;
        bounds.extend(coords);
    });
    return bounds;
};
const $0e9407883341aa7e$export$d6ad891437e8c72c = ({ value: value, places: places, map: map, layerName: layerName })=>{
    let newGeoData = {
        ...places
    };
    const filteredFeatures = newGeoData.features.filter((feature)=>feature.properties.title.includes(value));
    newGeoData = {
        ...newGeoData,
        features: filteredFeatures
    };
    map.getSource(layerName).setData(newGeoData);
    $0e9407883341aa7e$export$179985d5b2b4978c();
    $0e9407883341aa7e$export$bb39f6f3ba85bd94(map, layerName);
};
const $0e9407883341aa7e$export$2add49245bf1e169 = (features, placeId)=>features.find((feature)=>feature.id === placeId);
const $0e9407883341aa7e$var$createPopupHtml = (properties)=>{
    const { type: type } = properties;
    if (type === 'project') {
        const { imageSrcUrl: imageSrcUrl, dateAndPlace: dateAndPlace, title: title, description: description, contentUrl: contentUrl, pageIsDisabled: pageIsDisabled } = properties;
        return `
            <div class="project-popup__image-wrapper">
                <img src="${imageSrcUrl}?width=150&amp;height=150&amp;quality=85" alt=""/>
            </div>
            <a class="project-popup${!pageIsDisabled ? "" : " without-link-effect"}" href="${!pageIsDisabled ? contentUrl : "#"}">
                <h3 class="project-popup__title">${title}</h3>
                <p class="project-popup__date-and-place">${dateAndPlace}</p>
                <p class="project-popup__description">${description}</p>
                <span class="project-popup__link"${pageIsDisabled ? " style=\"visibility: hidden\"" : ""}></span>   
            </a>
        `;
    } else if (type === 'contact-card' || type === 'office') {
        const { address: address, emailAnchor: emailAnchor, googleMapsLink: googleMapsLink, googleMapsLinkText: googleMapsLinkText, homePageAnchor: homePageAnchor, name: name, phoneNumbersAnchors: phoneNumbersAnchors, visitingAddressText: visitingAddressText, postalAddressText: postalAddressText, visitingAddress: visitingAddress, postalAddress: postalAddress, postalAddressAsSameAsVisitingAddress: postalAddressAsSameAsVisitingAddress } = properties;
        const showPostalAddress = !postalAddressAsSameAsVisitingAddress && postalAddress.line1 && postalAddress.line2;
        return `
            <div class="contact-popup">
                <div class="container">
                    <div class="contact-popup__content-left">
                    ${homePageAnchor ? `<a class="contact-popup__link" href="${homePageAnchor} "target="_blank">
                            <h3 class="contact-popup__heading">${name}</h3>
                            ${$0e9407883341aa7e$var$renderGoToLinkIcon()}
                        </a>` : `<h3 class="contact-popup__heading">${name}</h3>`}
                    </div>
                    <div class="contact-popup__content-middle">
                        <div class="company__address visiting__address">
                        ${address ? ` <p>${address}</p>` : ''}
                        ${showPostalAddress && visitingAddress.line1 && visitingAddress.line2 ? `<p><b>${visitingAddressText}</b></p>` : ''}
                        ${visitingAddress.line1 && visitingAddress.line2 ? `<p>${visitingAddress.line1}</p>
                        <p>${visitingAddress.line2}</p>` : ''}
                    </div>
                    ${showPostalAddress ? `<div class="company__address postal__address">
                            <p><b>${postalAddressText}</b></p>
                            <p>${postalAddress.line1}</p>
                            <p>${postalAddress.line2}</p>
                        </div>` : ''}      
                    </div>
                    <div class="contact-popup__content-right">
                        <div>
                            <p class="contact-popup__phone-numbers">${phoneNumbersAnchors}</p>
                            <p class="contact-popup__mail-wrapper">${emailAnchor}</p>
                        </div>
                        <a class="contact-popup__maps-link" href="${googleMapsLink}" target="_blank" rel="noopener noreferrer">
                            ${googleMapsLinkText}
                            ${$0e9407883341aa7e$var$renderGoToLinkIcon()}
                        </a>
                    </div>
                <div>
            <div>
        `;
    }
};
const $0e9407883341aa7e$var$renderGoToLinkIcon = ()=>`
    <svg class="vd-icon vd-icon-arrow-up-right" width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" fill="currentColor">
        <polygon points="38.22 4.04 18.17 4.03 18.17 8.03 36.56 8.04 36.87 8.35 11.43 33.79 14.25 36.62 39.7 11.17 40.01 11.48 40 29.89 44 29.89 44.01 9.83 38.22 4.04"></polygon>
    </svg>
`;
const $0e9407883341aa7e$export$9093c36bb72cf0de = ({ map: map, feature: feature, layerName: layerName, changeIcons: changeIcons = true })=>{
    const { geometry: geometry, properties: properties, id: id } = feature;
    const coordinates = geometry.coordinates.slice();
    const { classNames: classNames, maxWidths: maxWidths, offsets: offsets } = $0e9407883341aa7e$var$popupSettings;
    const popupHtml = $0e9407883341aa7e$var$createPopupHtml(properties);
    $0e9407883341aa7e$export$179985d5b2b4978c(true);
    const popup = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Popup({
        closeButton: false,
        closeOnClick: false,
        className: classNames[properties.type],
        maxWidth: maxWidths[properties.type],
        offset: offsets,
        focusAfterOpen: false
    }).setLngLat(coordinates).setHTML(popupHtml).addTo(map);
    changeIcons && map.setLayoutProperty(layerName, 'icon-image', [
        'match',
        [
            'id'
        ],
        id,
        'active-marker',
        'unactive-marker'
    ]);
    return {
        popup: popup
    };
};
const $0e9407883341aa7e$export$cf609c82ce40d570 = ()=>{
    const attributionHtml = `
        <button class="mapboxgl-ctrl-attrib-button" title="Toggle attribution" aria-label="Toggle attribution"></button>
        <div class="mapboxgl-ctrl-attrib-inner" role="list">
            <a href="https://www.mapbox.com/about/maps/" target="_blank" title="Mapbox" aria-label="Mapbox" role="listitem">
                \xa9 Mapbox
            </a>
            <a href="https://www.openstreetmap.org/about/" target="_blank" title="OpenStreetMap" aria-label="OpenStreetMap" role="listitem">
                \xa9 OpenStreetMap
            </a>
            <a
                href="https://apps.mapbox.com/feedback/?owner=wojtek-noa&amp;id=ckzfqrjwa006p15lposgug5tz&amp;access_token=pk.eyJ1Ijoid29qdGVrLW5vYSIsImEiOiJja3o2dHIxaWwwc3ZjMnhwa3lzZHF6ZDNjIn0.IGZ8B2VPTB1vnL66p6RqPA"
                target="_blank"
                title="Map feedback"
                aria-label="Map feedback"
                role="listitem"
                rel="noopener nofollow"
            >
                Improve this map
            </a>
        </div>
    `;
    const attributionEl = document.createElement('div');
    attributionEl.classList.add('mapboxgl-ctrl');
    attributionEl.classList.add('mapboxgl-ctrl-attrib');
    attributionEl.innerHTML = attributionHtml;
    const mapWrapperElements = document.querySelectorAll('.map-wrapper');
    if (mapWrapperElements.length) mapWrapperElements.forEach((element)=>{
        element.appendChild(attributionEl);
    });
};
const $0e9407883341aa7e$var$updateMapWithSearchResults = async ({ map: map, layerName: layerName, places: places, guuid: guuid, langId: langId, catIds: catIds, searchTerm: searchTerm })=>{
    const results = await (0, $5d0fafb2bd24c3c5$export$cfcc0908d6dfb8a6)({
        guuid: guuid,
        langId: langId,
        catIds: catIds,
        searchTerm: searchTerm
    });
    const resultIds = results.pageSearchHits.map((item)=>item.contentLinkId);
    const mapSource = map.getSource(layerName);
    let newGeoData = {
        ...places
    };
    const filteredFeatures = newGeoData.features.filter((feature)=>resultIds.includes(Number(feature.id)));
    newGeoData = newGeoData = {
        ...newGeoData,
        features: filteredFeatures
    };
    mapSource.setData(newGeoData);
    $0e9407883341aa7e$export$179985d5b2b4978c();
    $0e9407883341aa7e$export$bb39f6f3ba85bd94(map, layerName);
};
const $0e9407883341aa7e$export$ae939118842f3d6d = async ({ map: map, layerName: layerName, places: places, spiderifier: spiderifier })=>{
    const filterBoxEl = document.querySelector('.filter-box');
    if (!filterBoxEl) return;
    const { lang: lang, guuid: guuid } = filterBoxEl.dataset;
    const langId = Number(lang);
    const filterSubmitButtonEl = filterBoxEl.querySelector('.filter-button--submit');
    const filterAbortButtonEl = filterBoxEl.querySelector('.filter-button--abort');
    filterSubmitButtonEl.addEventListener('click', function() {
        const { catIds: catIds, searchTerm: searchTerm } = (0, $5d0fafb2bd24c3c5$export$57a5f2d0e67d7713)();
        spiderifier.unspiderfy();
        $0e9407883341aa7e$var$updateMapWithSearchResults({
            map: map,
            layerName: layerName,
            places: places,
            guuid: guuid,
            langId: langId,
            catIds: catIds,
            searchTerm: searchTerm
        });
    });
    filterAbortButtonEl.addEventListener('click', function() {
        const { catIds: catIds, searchTerm: searchTerm } = (0, $5d0fafb2bd24c3c5$export$57a5f2d0e67d7713)();
        spiderifier.unspiderfy();
        $0e9407883341aa7e$var$updateMapWithSearchResults({
            map: map,
            layerName: layerName,
            places: places,
            guuid: guuid,
            langId: langId,
            catIds: catIds,
            searchTerm: searchTerm
        });
    });
};
const $0e9407883341aa7e$export$e57937c15eadcf91 = async ({ map: map, layerName: layerName, places: places, spiderifier: spiderifier })=>{
    const inputWrapperEl = document.querySelector('.input-search-wrapper');
    const inputEl = inputWrapperEl.querySelector('.input-cards-filter');
    const iconEl = inputWrapperEl.querySelector('.search-icon');
    const { lang: lang, guuid: guuid } = inputWrapperEl.dataset;
    const { catIds: catIds, searchTerm: searchTerm } = (0, $5d0fafb2bd24c3c5$export$57a5f2d0e67d7713)();
    const langId = Number(lang);
    $0e9407883341aa7e$var$updateMapWithSearchResults({
        map: map,
        layerName: layerName,
        places: places,
        guuid: guuid,
        langId: langId,
        catIds: catIds,
        searchTerm: searchTerm
    });
    inputEl.addEventListener('keyup', async function(e) {
        const event = e;
        if (event.key === 'Enter') {
            spiderifier.unspiderfy();
            $0e9407883341aa7e$var$updateMapWithSearchResults({
                map: map,
                layerName: layerName,
                places: places,
                guuid: guuid,
                langId: langId,
                catIds: catIds,
                searchTerm: e.target['value']
            });
        }
    });
    iconEl.addEventListener('click', function() {
        spiderifier.unspiderfy();
        $0e9407883341aa7e$var$updateMapWithSearchResults({
            map: map,
            layerName: layerName,
            places: places,
            guuid: guuid,
            langId: langId,
            catIds: catIds,
            searchTerm: inputEl.value
        });
    });
};


// custom style "mapbox://styles/username/ckzcr7hd0003b14qrsjvmzx4m" =>
// https://api.mapbox.com/styles/v1/username/ckzfpdd9t00ay15pclynqtwgn?access_token=pk.access.token
// pre style from mapbox =>
// https://api.mapbox.com/v4/mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2.json?secure=&access_token=pk.access.token
(0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).accessToken = "pk.eyJ1Ijoid29qdGVrLW5vYSIsImEiOiJja3o2dHIxaWwwc3ZjMnhwa3lzZHF6ZDNjIn0.IGZ8B2VPTB1vnL66p6RqPA";
const $f9ae6eb85c78f8d0$var$tilesApi = "mapbox://styles/wojtek-noa/ckzfqrjwa006p15lposgug5tz";
const $f9ae6eb85c78f8d0$var$activeMarker = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAApCAYAAABQgPsBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAImSURBVHgB7ZhPbtpAFMa/55REaVKJ7CLBwr0ByK3URaUmN+i6mzYnqHqCkhukJyirbpMbsOmiiybyDepFibrDVQnEGHv6HhUpmIDHA7FZ8FuBPYafvvnjN0PQ4Kb6rEFKfYQBEdHpk5/fG2ntKK1Bt+qcWQrvsQQ6MgtFuhWnaQFvsQIU0NxrX54gi4iyj8r94Z/P/PRrrBKFi6AXnRz4ro80kZFE2G3xpxoeAqXcoBcfJ2WmRPr2C1uFw/MHk/iPR6XS8a73zZsR+ScRchKwkQ9TMlSQxIwMde3nNSuMzwuQmJKhm6rTIYUyCoSntm8VLSHw+ChbWBMewZDdr1/uvd5/+QYmrE0iG5EkG5Ek1Ks4CmvApmuSrI+IIvgoGAXlW4NhVOfyzUNR8H8Porg+Kow6hzV7x7JaILKRJywRxFy//nK9u1Ixd5kJCfl6N1jlgtzIpZukkp+QEGa2Ex27Vt4JORlQrtuJmel74Ll+UOJkCBdYuYNq3ich5LflZIm966u5W86FC9p++/IdnwI0sCyxOlskIaSeBgj9itPiN+MRDEhLYozWEn8bRak/NI9BHJ/qtNMSGS04Bl0kaUxO0aVFhNvt+FOm95Is3ZppZBKRaW3xoNNtLwczumkIWoN1jCx228OtH6m7Q07j8fXVU2QgUz0iqXC/f0hrR0QNZCRTImMWTmeDNASzCo1PCeffyp7G6DkYEh7WXyWvBVvq937bdWHAX0bBE1Pb8UFTAAAAAElFTkSuQmCC';
const $f9ae6eb85c78f8d0$var$unactiveMarker = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAApCAYAAABQgPsBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMHSURBVHgB7ZhNctowFMefTCFTks7ALhNYKDcwcTPTXckN2hOUnKDpCUJukJ4g3IDcgCy7KBnfAC9Kpjvo1ECMP1TJhVSWvyQbdv1vAMmWfvwtvfdkBBJatN/2ESHXUEA+Qjdvfnzv512H8i6w28atRuAzlJAMTCaI3TIGGsAn2IEIwOBwOr4EFRCCu42V9/uO3v0BdikC987Sv2zOzTnkgYQQrj2i3/RoB7GcILho/jQtkNDsWMcHmjYChLAwjuks6TgCTARkhd9h4nrDshC5MAAWqlYvXlvfrBjIXwiXOgF4FxCqMCgHItFGZRisNw5cCgNIT4NBNj7XNTcYxiAAHpyF/7EsRATGqyRtgBAGLdrGDBFo8D2EkMHh02PqVkt1MOHZi0oKCXRrzzURAgJyWxCCKexj16TdfzQd92iU7vNtdH000LJlEL6xPh2jghC8cp0R59VAQZIQTFtgab0CNWH+h+ie8C8xKEjJkX3qP4gotTVCwz0fqsWVH7tWQUqOsJwjNcEmP4GClEBY4suFKZgklddIJkyJTB2LrLLFbhkl1cEaQRDJrhVarS9axh3sSWHSEyAIkLm29vyOaDMNl73liTGcNfQG7EhhCdoyRrFinM699oNOGKJV68tCEDl18EuuUKkvVSRbgr7smozdkFtjFIAwxd0Vqz1k6ksoC5HwuGNxpGmZc6dKnUFwL3SFA9utcx0KQrASNG3NFTlyPtA6JDN809g0SYLIKkEzI2tSfUnVpdsw9Txst856IkReHcyU+zaAie1/Gn67XJNFjxqdJItFN/Kc2Eoq1zz7vjgQrtW12KuKJDfWQXADEpICCQOO+IgQuuIjL1ugGqDIyxzmhmwClM6+z7XgK5+X2FmEd8X33Cvg3WChW9KNzXjyWp2cXROE+pEBqtXTcF7XnfDt1I0+XRv7AWHBruZVJsLp0Np8Yo7Cqj89noKC1Co0GuzoP/0iNGMQFigSXJORkiNbJWznfyrgBlOx4wSt4tK71N0I74OCco8778U2p0J+HU1NEwroD9n9LDzMJ2quAAAAAElFTkSuQmCC';
const $f9ae6eb85c78f8d0$var$hoverMarker = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAApCAYAAABQgPsBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKxSURBVHgB7VjBcdswELyjbI/zUwlyB04FsTqQrWQmv1AVxKnAcgdOBeYzjzhRB3IHdgdmB1FemZFMIDhETHggSOJAacaP7EcjEDguF3e8BRECkL4t5qDhCmKAcJ19Hcy7p3WRmBY35ucj9EEAGewgkZmfD7AbZNndYAYSIulED2GgbwH0BHYKXECBs2yBq9oV8JFI9BJQn7ILGnJQ63G2eJVDANL3egQbEwfML4uDj6Bw7JJJaot3QIKQfcEcDnFsnpWvodiJekgnv0ZsuPsJ5CSqCI2L7ZP9MorJBGw3pu/Wp6AOvtdIgL6HYnDelwQj4yuALRk0JfrD/B0661pLrc82NrwSVkmNhIabKBIEBJPsR0s3EaswsVNzj7kzPCRFtDMRo0hUEaYMu28CEoSQIGyVAQEOQAROwlWPPSWREUCmyB7xn4gLYY5Q3/iXJ27mM1DlCCBTxNfEmkiY8gUBREQaO6qHhLRJinOklUyPTl17s4aa3T7w+WBShHdX49bNxFvYE7ZNzzXjK2zuH83+MorAHxtAduOMXShtgJ30AoyRTVapvxSRoIcc6IcuH/y3aprJdHuMVhKNSvPqepnHCYKdoKwyC3ahVIY8biwJE74p5yKOnHif3SXj9nXqyUeizYK2vln9/lKfzabPjefh9OI59ZjqVh9M6PwaYINP1ZLVv82X5LVP4poa2ijxrZ0EIazXHCIPZPNF1T5VeNVQ62sIQBARW9ruFiFc2gorSVCCYsI/5pAagVUW3n1V8hl4XxoyVTbq0tmSPFQNQlCOlEgviiuzYs4Gi/UJHB8TkSc2bhQ0ubEnIrZx2RsOKzfMt5FG1TFD4gQEkDk0qhKtP7FBIuCcYRD1HIQQKVKiVs5VRKhBiDtOYNG49zFq2HUQidm5fuOOab35mS2OHiECvwEpR9tUzOOH+QAAAABJRU5ErkJggg==';
const $f9ae6eb85c78f8d0$var$images = [
    {
        src: $f9ae6eb85c78f8d0$var$activeMarker,
        name: 'active-marker'
    },
    {
        src: $f9ae6eb85c78f8d0$var$unactiveMarker,
        name: 'unactive-marker'
    },
    {
        src: $f9ae6eb85c78f8d0$var$hoverMarker,
        name: 'hover-marker'
    }
];
const $f9ae6eb85c78f8d0$var$MAX_ZOOM = 17; // Setting this above 17 will break cluster behavior
const $f9ae6eb85c78f8d0$var$MAX_CLUSTER_ZOOM = 14;
const $f9ae6eb85c78f8d0$var$MIN_SPIRAL_VALUE = 4;
const $f9ae6eb85c78f8d0$var$createMap = ({ mapId: mapId, places: places, activePlaceId: activePlaceId, layerName: layerName, center: center = [
    10.7316,
    59.9371
], initialZoom: initialZoom = 12, fitToMarkers: fitToMarkers = true, useSearch: useSearch = false })=>{
    var map = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Map({
        container: mapId,
        style: $f9ae6eb85c78f8d0$var$tilesApi,
        center: center,
        zoom: initialZoom,
        maxZoom: $f9ae6eb85c78f8d0$var$MAX_ZOOM,
        attributionControl: false
    });
    const spiderifier = new (0, (/*@__PURE__*/$parcel$interopDefault($be4debe075ad0ecc$exports)))(map, {
        onClick: (e)=>e.preventDefault(),
        initializeLeg: initializeLeg,
        animate: true,
        animationSpeed: 200,
        circleSpiralSwitchover: $f9ae6eb85c78f8d0$var$MIN_SPIRAL_VALUE
    });
    function initializeLeg(spiderLeg) {
        const pinElem = spiderLeg.elements.pin;
        const feature = spiderLeg.feature;
        let popup;
        pinElem.addEventListener('click', function(e) {
            e.stopPropagation();
            popup = (0, $0e9407883341aa7e$export$9093c36bb72cf0de)({
                map: map,
                feature: feature,
                layerName: layerName,
                changeIcons: false
            }).popup;
            spiderLeg.mapboxMarker.setPopup(popup);
        });
    }
    map.on('load', ()=>{
        (0, $0e9407883341aa7e$export$dff72a5fd5ad3e0c)(map);
        (0, $0e9407883341aa7e$export$8250d5b41185d62d)(map, $f9ae6eb85c78f8d0$var$images);
        (0, $0e9407883341aa7e$export$cf609c82ce40d570)();
        (0, $0e9407883341aa7e$export$ae939118842f3d6d)({
            map: map,
            layerName: layerName,
            places: places,
            spiderifier: spiderifier
        });
        if (useSearch) (0, $0e9407883341aa7e$export$e57937c15eadcf91)({
            map: map,
            layerName: layerName,
            places: places,
            spiderifier: spiderifier
        });
        map.scrollZoom.disable();
        map.addSource(layerName, {
            type: 'geojson',
            data: places,
            cluster: true,
            clusterMaxZoom: $f9ae6eb85c78f8d0$var$MAX_ZOOM,
            clusterRadius: 30
        });
        map.addLayer({
            id: layerName,
            type: 'symbol',
            source: layerName,
            layout: {
                'icon-image': 'unactive-marker',
                'icon-size': 0.75,
                'icon-allow-overlap': true
            }
        });
        // Set map center based on projects bounds or center on single project
        if (activePlaceId) {
            const activeProject = (0, $0e9407883341aa7e$export$2add49245bf1e169)(places.features, activePlaceId);
            map.jumpTo({
                center: activeProject.geometry.coordinates,
                zoom: initialZoom
            });
            (0, $0e9407883341aa7e$export$9093c36bb72cf0de)({
                map: map,
                layerName: layerName,
                feature: activeProject
            });
        } else if (fitToMarkers) {
            const bounds = (0, $0e9407883341aa7e$export$c1e84714c800b36a)(places.features);
            map.fitBounds(bounds, {
                padding: 100,
                duration: 0
            });
        }
        map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: layerName,
            filter: [
                'has',
                'point_count'
            ],
            paint: {
                'circle-color': '#603345',
                'circle-radius': 20
            }
        });
        map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: layerName,
            filter: [
                'has',
                'point_count'
            ],
            layout: {
                'text-field': '{point_count_abbreviated}',
                'text-size': 14
            },
            paint: {
                'text-color': '#FFFFFF'
            }
        });
        let hoveredPlaceId = null;
        map.on('mouseenter', layerName, (e)=>{
            map.getCanvas().style.cursor = 'pointer';
            const isCluster = e.features[0].properties.cluster;
            if (isCluster) return;
            const id = e.features[0].id;
            const isActive = e.features[0].layer.layout['icon-image'].name === 'active-marker';
            if (!isActive) {
                map.setLayoutProperty(layerName, 'icon-image', [
                    'match',
                    [
                        'id'
                    ],
                    id,
                    'hover-marker',
                    'unactive-marker'
                ]);
                hoveredPlaceId = id;
            }
        });
        map.on('mouseleave', layerName, ()=>{
            map.getCanvas().style.cursor = '';
            if (hoveredPlaceId) map.setLayoutProperty(layerName, 'icon-image', [
                'match',
                [
                    'id'
                ],
                hoveredPlaceId,
                'unactive-marker',
                'unactive-marker'
            ]);
            hoveredPlaceId = null;
        });
        map.on('click', (e)=>{
            if (e.defaultPrevented === false) (0, $0e9407883341aa7e$export$bb39f6f3ba85bd94)(map, layerName);
        });
        map.getSource(layerName);
        // Cluster click
        map.on('click', 'clusters', (e)=>{
            const features = map.queryRenderedFeatures(e.point, {
                layers: [
                    'clusters'
                ]
            });
            const feature = features[0];
            const clusterId = feature.properties.cluster_id;
            if (map.getZoom() < $f9ae6eb85c78f8d0$var$MAX_CLUSTER_ZOOM) map.getSource(layerName).getClusterExpansionZoom(clusterId, (err, zoom)=>{
                if (err) return console.error('Error while getting cluster expansion zoom', err);
                const zoomLvl = zoom > $f9ae6eb85c78f8d0$var$MAX_CLUSTER_ZOOM ? $f9ae6eb85c78f8d0$var$MAX_CLUSTER_ZOOM : zoom;
                map.easeTo({
                    center: feature.geometry.coordinates,
                    zoom: zoomLvl
                });
            });
            else map.getSource(layerName).getClusterLeaves(feature.properties.cluster_id, 100, 0, (err, leafFeatures)=>{
                if (err) return console.error('error while getting leaves of a cluster', err);
                spiderifier.spiderfy(feature.geometry.coordinates, leafFeatures);
            });
        });
        // Place click
        map.on('click', layerName, (e)=>{
            e.preventDefault();
            const point = e.features[0];
            const isCluster = point.properties.cluster;
            if (isCluster) return;
            hoveredPlaceId = null;
            const feature = (0, $0e9407883341aa7e$export$2add49245bf1e169)(places.features, point.id);
            (0, $0e9407883341aa7e$export$9093c36bb72cf0de)({
                map: map,
                feature: feature,
                layerName: layerName
            });
        });
    });
    return map;
};
var $f9ae6eb85c78f8d0$export$2e2bcd8739ae039 = $f9ae6eb85c78f8d0$var$createMap;


const $49e9315d19a36e72$var$debug = new URL(window.location.href).searchParams.get("debug") === "true";
const $49e9315d19a36e72$var$getDataFromApi = async (url)=>{
    if ($49e9315d19a36e72$var$debug) console.log(`Fetching from ${url}...`);
    await fetch(url).then((response)=>response.json()).then((json)=>{
        if ($49e9315d19a36e72$var$debug) console.log(`JSON from ${url}`, json, JSON.stringify(json));
    }).catch((error)=>{
        if ($49e9315d19a36e72$var$debug) console.log(`ERROR from ${url}`, error);
    });
};
const $49e9315d19a36e72$var$getFeaturedProjectMapMap = ()=>$49e9315d19a36e72$var$getDataFromApi(mapRequestModel.mapEndpoint);
const $49e9315d19a36e72$var$getProjectListPageMap = ()=>$49e9315d19a36e72$var$getDataFromApi(mapRequestModel.mapEndpoint);
const $49e9315d19a36e72$var$getProjectListPageSearchResults = ()=>$49e9315d19a36e72$var$getDataFromApi(`${mapRequestModel.searchEndpointBase}${$49e9315d19a36e72$var$getSearchParams()}`);
const $49e9315d19a36e72$var$getSearchParams = ()=>{
    // Get me from filters/searchText instead
    return ''; // '?q=navnet på prosjektet&catIDs=7,9';
};
const $49e9315d19a36e72$var$createFeaturesList = (mapItems, type)=>{
    const features = mapItems.map((item)=>{
        const { position: position, contentLinkId: contentLinkId, ...properties } = item;
        const geometry = {
            type: 'Point',
            coordinates: [
                position.longitude,
                position.latitude
            ]
        };
        const feature = {
            type: 'Feature',
            id: contentLinkId,
            properties: {
                ...properties,
                type: type
            },
            geometry: geometry
        };
        return feature;
    });
    const featureCollection = {
        type: 'FeatureCollection',
        features: features
    };
    return featureCollection;
};
const $49e9315d19a36e72$var$createProjectListPageMap = async ()=>{
    const divId = 'project-list-map';
    const containerEl = document.querySelector(`#${divId}`);
    if (!containerEl) return;
    const { initialZoom: initialZoom } = containerEl.dataset;
    const { mapItems: mapItems } = projectListPageMap;
    const features = $49e9315d19a36e72$var$createFeaturesList(mapItems, 'project');
    (0, $f9ae6eb85c78f8d0$export$2e2bcd8739ae039)({
        mapId: divId,
        layerName: 'projects',
        places: features,
        useSearch: true,
        initialZoom: initialZoom && Number(initialZoom)
    });
};
const $49e9315d19a36e72$var$createProjectPageContactCardMap = async ()=>{
    // getContactCardMap();
    const divId = 'project-map';
    const containerEl = document.querySelector(`#${divId}`);
    if (!containerEl) return;
    const { initialZoom: initialZoom } = containerEl.dataset;
    const { mapItems: mapItems } = contactCardMap;
    const { contactCard: contactCard, googleMapsLink: googleMapsLink, googleMapsLinkText: googleMapsLinkText, position: position, contentLinkId: contentLinkId, friendlyPosition: friendlyPosition } = mapItems[0];
    const mapItem = {
        ...contactCard,
        googleMapsLink: googleMapsLink,
        googleMapsLinkText: googleMapsLinkText,
        position: position,
        contentLinkId: contentLinkId,
        friendlyPosition: friendlyPosition
    };
    const features = $49e9315d19a36e72$var$createFeaturesList([
        mapItem
    ], 'contact-card');
    (0, $f9ae6eb85c78f8d0$export$2e2bcd8739ae039)({
        mapId: divId,
        layerName: 'projects',
        places: features,
        center: [
            position.latitude,
            position.longitude
        ],
        activePlaceId: contentLinkId,
        initialZoom: initialZoom && Number(initialZoom)
    });
};
const $49e9315d19a36e72$var$createContactCardMap = async ()=>{
    const divId = 'contact-card-map';
    const containerEl = document.querySelector(`#${divId}`);
    if (!containerEl) return;
    const { initialZoom: initialZoom } = containerEl.dataset;
    const { mapItems: mapItems } = contactCardMap;
    const items = mapItems.map(({ contactCard: contactCard, ...rest })=>({
            ...contactCard,
            ...rest
        }));
    const features = $49e9315d19a36e72$var$createFeaturesList(items, 'contact-card');
    const { position: position, contentLinkId: contentLinkId } = mapItems.find((item)=>item.contentLinkId === contactCardMap.selectedContentLinkId);
    (0, $f9ae6eb85c78f8d0$export$2e2bcd8739ae039)({
        mapId: divId,
        layerName: 'projects',
        places: features,
        center: [
            position.latitude,
            position.longitude
        ],
        activePlaceId: contentLinkId,
        initialZoom: initialZoom && Number(initialZoom)
    });
};
const $49e9315d19a36e72$var$createFeaturedProjectMapMap = async ()=>{
    // getFeaturedProjectMapMap();
    const divId = 'featured-map';
    const containerEl = document.querySelector(`#${divId}`);
    if (!containerEl) return;
    const { initialZoom: initialZoom } = containerEl.dataset;
    const { mapItems: mapItems, featuredProjectPageId: featuredProjectPageId } = featuredProjectMap;
    const projectDetails = mapItems.find((project)=>project.contentLinkId === featuredProjectPageId);
    const { position: position } = projectDetails;
    const features = $49e9315d19a36e72$var$createFeaturesList(mapItems, 'project');
    (0, $f9ae6eb85c78f8d0$export$2e2bcd8739ae039)({
        mapId: divId,
        layerName: 'places',
        places: features,
        center: [
            position.latitude,
            position.longitude
        ],
        activePlaceId: featuredProjectPageId,
        initialZoom: initialZoom && Number(initialZoom)
    });
};
const $49e9315d19a36e72$var$veidekkeMap = ()=>{
    if (typeof mapRequestModel !== 'undefined') switch(mapRequestModel?.endpointType){
        case (0, $5611204dba55fa8c$export$3ea65033b6956d45).ProjectPageContactCardMap:
            $49e9315d19a36e72$var$createProjectPageContactCardMap();
            break;
        case (0, $5611204dba55fa8c$export$3ea65033b6956d45).ProjectListPageMap:
            $49e9315d19a36e72$var$createProjectListPageMap();
            break;
        case (0, $5611204dba55fa8c$export$3ea65033b6956d45).FeaturedProjectMap:
            $49e9315d19a36e72$var$createFeaturedProjectMapMap();
            break;
        case (0, $5611204dba55fa8c$export$3ea65033b6956d45).ContactCardMap:
            $49e9315d19a36e72$var$createContactCardMap();
            break;
        default:
            break;
    }
};
$49e9315d19a36e72$var$veidekkeMap();



const $6c079a9b5b2f89c4$var$options = {
    threshold: 0.6,
    rootMargin: '0px 0px 0px 0px'
};
const $6c079a9b5b2f89c4$var$callback = function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.timeline.play();
    });
};
const $6c079a9b5b2f89c4$var$observer = new IntersectionObserver($6c079a9b5b2f89c4$var$callback, $6c079a9b5b2f89c4$var$options);
const $6c079a9b5b2f89c4$var$targets = document.querySelectorAll('.stock__number');
// create the individual target timelines
$6c079a9b5b2f89c4$var$targets.forEach((target)=>{
    // use document lang to show dot or ,
    const lang = document.documentElement.lang || 'no';
    const fromValue = {
        value: 0
    };
    const toValue = target.dataset.value.replace(',', '.') || 0;
    const showPercentage = target.dataset.showpercentage || false;
    const visibleCounter = target.getElementsByClassName('stock__number__counter')[0];
    const action = (0, $1974f63041948ee8$export$99ee26438460406a).timeline({
        paused: true
    }).to(fromValue, {
        value: toValue,
        duration: 3,
        ease: 'Power4.easeInOut',
        onUpdate: function() {
            lang === 'no' || lang === 'sv' ? visibleCounter.innerHTML = `${fromValue.value.toFixed(1).replace('.', ',')}${showPercentage ? '%' : ''}` : visibleCounter.innerHTML = `${fromValue.value.toFixed(1)}${showPercentage ? '%' : ''}`;
        }
    });
    target.timeline = action;
});
Array.prototype.forEach.call($6c079a9b5b2f89c4$var$targets, (el)=>{
    $6c079a9b5b2f89c4$var$observer.observe(el);
});


const $e809b06bdc6e6c59$export$882663d80edab31 = (entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) // define the event/property you want to use
        //do something with the element, in our case, add a class
        entry.target.classList.add('inview--visible');
    });
};


// Define the elements you want to intiate an action on
const $ee2fc2b35e0d6c53$var$page = document.querySelector('.FeatureArticlePage');
const $ee2fc2b35e0d6c53$var$observedElements = $ee2fc2b35e0d6c53$var$page ? $ee2fc2b35e0d6c53$var$page.querySelectorAll('.inview-wrapper img, .feature-page-intro__title, .feature-page-intro__byline, .feature-page-intro__introduction, .feature-page-intro__cta, .video-block') : [];
$ee2fc2b35e0d6c53$var$observedElements.forEach((element)=>{
    element.classList.add('inview');
});
const $ee2fc2b35e0d6c53$var$options = {
    //define your options
    threshold: 0.25
};
// create a new instance using our callback which contains our elements and actions, using the options we defined
const $ee2fc2b35e0d6c53$var$observer = new IntersectionObserver((0, $e809b06bdc6e6c59$export$882663d80edab31), $ee2fc2b35e0d6c53$var$options);
$ee2fc2b35e0d6c53$var$observedElements.forEach((element)=>{
    $ee2fc2b35e0d6c53$var$observer.observe(element); // run the observer
});


/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ /* eslint no-param-reassign: "off" */ 
var $6fzuY = parcelRequire("6fzuY");

var $25g61 = parcelRequire("25g61");
const $0428edcc4d18d14e$var$Methods = {
    addClass: $25g61.addClass,
    removeClass: $25g61.removeClass,
    hasClass: $25g61.hasClass,
    toggleClass: $25g61.toggleClass,
    attr: $25g61.attr,
    removeAttr: $25g61.removeAttr,
    transform: $25g61.transform,
    transition: $25g61.transition,
    on: $25g61.on,
    off: $25g61.off,
    trigger: $25g61.trigger,
    transitionEnd: $25g61.transitionEnd,
    outerWidth: $25g61.outerWidth,
    outerHeight: $25g61.outerHeight,
    styles: $25g61.styles,
    offset: $25g61.offset,
    css: $25g61.css,
    each: $25g61.each,
    html: $25g61.html,
    text: $25g61.text,
    is: $25g61.is,
    index: $25g61.index,
    eq: $25g61.eq,
    append: $25g61.append,
    prepend: $25g61.prepend,
    next: $25g61.next,
    nextAll: $25g61.nextAll,
    prev: $25g61.prev,
    prevAll: $25g61.prevAll,
    parent: $25g61.parent,
    parents: $25g61.parents,
    closest: $25g61.closest,
    find: $25g61.find,
    children: $25g61.children,
    filter: $25g61.filter,
    remove: $25g61.remove
};
Object.keys($0428edcc4d18d14e$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $25g61.$).fn, methodName, {
        value: $0428edcc4d18d14e$var$Methods[methodName],
        writable: true
    });
});
var $0428edcc4d18d14e$export$2e2bcd8739ae039 = (0, $25g61.$);



var $6fzuY = parcelRequire("6fzuY");
function $04b7fd865a707bca$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $04b7fd865a707bca$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $04b7fd865a707bca$export$461939dd4422153() {
    return Date.now();
}
function $04b7fd865a707bca$export$3735103072e4a80(el) {
    const window1 = (0, $6fzuY.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $04b7fd865a707bca$export$5ec402b7fcf74398(el, axis = 'x') {
    const window1 = (0, $6fzuY.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $04b7fd865a707bca$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $04b7fd865a707bca$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $04b7fd865a707bca$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $04b7fd865a707bca$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$04b7fd865a707bca$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($04b7fd865a707bca$export$a6cdc56e425d0d0a(to[nextKey]) && $04b7fd865a707bca$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $04b7fd865a707bca$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$04b7fd865a707bca$export$a6cdc56e425d0d0a(to[nextKey]) && $04b7fd865a707bca$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $04b7fd865a707bca$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $04b7fd865a707bca$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $04b7fd865a707bca$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $6fzuY.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $6fzuY = parcelRequire("6fzuY");
let $79ec0132ebd4cd3c$var$support;
function $79ec0132ebd4cd3c$var$calcSupport() {
    const window = (0, $6fzuY.getWindow)();
    const document = (0, $6fzuY.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $79ec0132ebd4cd3c$export$d61c7b85ff180578() {
    if (!$79ec0132ebd4cd3c$var$support) $79ec0132ebd4cd3c$var$support = $79ec0132ebd4cd3c$var$calcSupport();
    return $79ec0132ebd4cd3c$var$support;
}



var $6fzuY = parcelRequire("6fzuY");

let $3adb35beed00c3f1$var$deviceCached;
function $3adb35beed00c3f1$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $79ec0132ebd4cd3c$export$d61c7b85ff180578)();
    const window = (0, $6fzuY.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $3adb35beed00c3f1$export$30c823bc834d6ab4(overrides = {}) {
    if (!$3adb35beed00c3f1$var$deviceCached) $3adb35beed00c3f1$var$deviceCached = $3adb35beed00c3f1$var$calcDevice(overrides);
    return $3adb35beed00c3f1$var$deviceCached;
}



var $6fzuY = parcelRequire("6fzuY");
let $39f91bf3f483f11b$var$browser;
function $39f91bf3f483f11b$var$calcBrowser() {
    const window = (0, $6fzuY.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $39f91bf3f483f11b$export$89e15fc796a4a429() {
    if (!$39f91bf3f483f11b$var$browser) $39f91bf3f483f11b$var$browser = $39f91bf3f483f11b$var$calcBrowser();
    return $39f91bf3f483f11b$var$browser;
}



var $6fzuY = parcelRequire("6fzuY");
function $df45be0401cceedb$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $6fzuY.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}



var $6fzuY = parcelRequire("6fzuY");
function $c8b015111a66762c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $6fzuY.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}


/* eslint-disable no-underscore-dangle */ var $4e06334f990a9aa9$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $df8c43018371cd2e$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $cb8a8f42f4c64a2e$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $04b7fd865a707bca$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $04b7fd865a707bca$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $04b7fd865a707bca$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $04b7fd865a707bca$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}



function $0b22425024333a6c$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}


function $65ceec6138141d70$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $2985e25b8de17325$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $6faa37fa97640b4d$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $2e44e9e98960cd16$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $22b4bc1cbda55e8c$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $51a869fa9f50b466$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $bd4842633fe52783$export$2e2bcd8739ae039 = {
    updateSize: $df8c43018371cd2e$export$2e2bcd8739ae039,
    updateSlides: $cb8a8f42f4c64a2e$export$2e2bcd8739ae039,
    updateAutoHeight: $0b22425024333a6c$export$2e2bcd8739ae039,
    updateSlidesOffset: $65ceec6138141d70$export$2e2bcd8739ae039,
    updateSlidesProgress: $2985e25b8de17325$export$2e2bcd8739ae039,
    updateProgress: $6faa37fa97640b4d$export$2e2bcd8739ae039,
    updateSlidesClasses: $2e44e9e98960cd16$export$2e2bcd8739ae039,
    updateActiveIndex: $22b4bc1cbda55e8c$export$2e2bcd8739ae039,
    updateClickedSlide: $51a869fa9f50b466$export$2e2bcd8739ae039
};



function $cd6631e2ba9a3c07$export$2e2bcd8739ae039(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $04b7fd865a707bca$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $987a7cd76bbc585b$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $ca9ff026419f39f8$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $3f68fcdea6e2f7cc$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $b2d947326c428114$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $04b7fd865a707bca$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $37b4f9912c94901b$export$2e2bcd8739ae039 = {
    getTranslate: $cd6631e2ba9a3c07$export$2e2bcd8739ae039,
    setTranslate: $987a7cd76bbc585b$export$2e2bcd8739ae039,
    minTranslate: $ca9ff026419f39f8$export$2e2bcd8739ae039,
    maxTranslate: $3f68fcdea6e2f7cc$export$2e2bcd8739ae039,
    translateTo: $b2d947326c428114$export$2e2bcd8739ae039
};


function $791847eff2841518$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $573108e1d2fcee55$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $bab1b581bba6895a$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $573108e1d2fcee55$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}



function $482e357b736f7743$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $573108e1d2fcee55$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}


var $6bb1e758dbb602c2$export$2e2bcd8739ae039 = {
    setTransition: $791847eff2841518$export$2e2bcd8739ae039,
    transitionStart: $bab1b581bba6895a$export$2e2bcd8739ae039,
    transitionEnd: $482e357b736f7743$export$2e2bcd8739ae039
};



function $613325203449069d$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $04b7fd865a707bca$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $3dce91f88642a8f9$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $d3916cfec4f9f42f$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $dcbf9f111eea71c9$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $b60e1a1896e270a6$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $8b023a8c22f6a7b1$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $37e3c10f64d32f66$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $131644fb6da27948$export$2e2bcd8739ae039 = {
    slideTo: $613325203449069d$export$2e2bcd8739ae039,
    slideToLoop: $3dce91f88642a8f9$export$2e2bcd8739ae039,
    slideNext: $d3916cfec4f9f42f$export$2e2bcd8739ae039,
    slidePrev: $dcbf9f111eea71c9$export$2e2bcd8739ae039,
    slideReset: $b60e1a1896e270a6$export$2e2bcd8739ae039,
    slideToClosest: $8b023a8c22f6a7b1$export$2e2bcd8739ae039,
    slideToClickedSlide: $37e3c10f64d32f66$export$2e2bcd8739ae039
};



var $6fzuY = parcelRequire("6fzuY");

function $70bf547d0935e629$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $6fzuY.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $f3a46ec84f16e352$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $ddb89460e9084cb2$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $701031afeb98a6b4$export$2e2bcd8739ae039 = {
    loopCreate: $70bf547d0935e629$export$2e2bcd8739ae039,
    loopFix: $f3a46ec84f16e352$export$2e2bcd8739ae039,
    loopDestroy: $ddb89460e9084cb2$export$2e2bcd8739ae039
};


function $fd360ee3a2ed66ec$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $acec44e07f2839ab$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


var $de085cb59a7b22cb$export$2e2bcd8739ae039 = {
    setGrabCursor: $fd360ee3a2ed66ec$export$2e2bcd8739ae039,
    unsetGrabCursor: $acec44e07f2839ab$export$2e2bcd8739ae039
};



var $6fzuY = parcelRequire("6fzuY");

var $6fzuY = parcelRequire("6fzuY");


function $1f9cd4d61bb0431b$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $6fzuY.getDocument)() || el === (0, $6fzuY.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $1f9cd4d61bb0431b$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $6fzuY.getDocument)();
    const window = (0, $6fzuY.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $1f9cd4d61bb0431b$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $04b7fd865a707bca$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === 'SELECT') data.isTouched = false;
        }
        if (document.activeElement && (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}



var $6fzuY = parcelRequire("6fzuY");


function $4da35a4899cb783d$export$2e2bcd8739ae039(event) {
    const document = (0, $6fzuY.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $04b7fd865a707bca$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $746001e6b07b2034$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $04b7fd865a707bca$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $04b7fd865a707bca$export$461939dd4422153)();
    (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $4bb5d4ac8c156664$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $ee70b9e2a42f1029$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $8b92ea4f5b37f82e$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


let $037929b540e63932$var$dummyEventAttached = false;
function $037929b540e63932$var$dummyEventListener() {}
const $037929b540e63932$var$events = (swiper, method)=>{
    const document = (0, $6fzuY.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $4bb5d4ac8c156664$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]('observerUpdate', (0, $4bb5d4ac8c156664$export$2e2bcd8739ae039), true);
};
function $037929b540e63932$var$attachEvents() {
    const swiper = this;
    const document = (0, $6fzuY.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $1f9cd4d61bb0431b$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $4da35a4899cb783d$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $746001e6b07b2034$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $8b92ea4f5b37f82e$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $ee70b9e2a42f1029$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$037929b540e63932$var$dummyEventAttached) {
        document.addEventListener('touchstart', $037929b540e63932$var$dummyEventListener);
        $037929b540e63932$var$dummyEventAttached = true;
    }
    $037929b540e63932$var$events(swiper, 'on');
}
function $037929b540e63932$var$detachEvents() {
    const swiper = this;
    $037929b540e63932$var$events(swiper, 'off');
}
var $037929b540e63932$export$2e2bcd8739ae039 = {
    attachEvents: $037929b540e63932$var$attachEvents,
    detachEvents: $037929b540e63932$var$detachEvents
};



const $0c1f98f1742116b5$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $0c1f98f1742116b5$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $0c1f98f1742116b5$var$isGridEnabled(swiper, params);
    const isMultiRow = $0c1f98f1742116b5$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $04b7fd865a707bca$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $6fzuY = parcelRequire("6fzuY");
function $93ee0d33a3b5e8d2$export$2e2bcd8739ae039(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $6fzuY.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $20a6615ac1eae2d6$export$2e2bcd8739ae039 = {
    setBreakpoint: $0c1f98f1742116b5$export$2e2bcd8739ae039,
    getBreakpoint: $93ee0d33a3b5e8d2$export$2e2bcd8739ae039
};


function $ba08d2c0520b81a4$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $ba08d2c0520b81a4$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $ba08d2c0520b81a4$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}


function $8a6bacf5131c19fd$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $bc9284d067152bdc$export$2e2bcd8739ae039 = {
    addClasses: $ba08d2c0520b81a4$export$2e2bcd8739ae039,
    removeClasses: $8a6bacf5131c19fd$export$2e2bcd8739ae039
};



var $6fzuY = parcelRequire("6fzuY");

function $d556c256d5e2c0a9$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $6fzuY.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $57a07edec373887e$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $ef82bd580e29444e$export$2e2bcd8739ae039 = {
    loadImage: $d556c256d5e2c0a9$export$2e2bcd8739ae039,
    preloadImages: $57a07edec373887e$export$2e2bcd8739ae039
};


function $fcf09839e5a2ea8e$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $fcf09839e5a2ea8e$export$2e2bcd8739ae039 = {
    checkOverflow: $fcf09839e5a2ea8e$var$checkOverflow
};


var $9a0f8047d07c4881$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $c9efebc9216c9083$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $04b7fd865a707bca$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $04b7fd865a707bca$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $04b7fd865a707bca$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $d3a4dc7626ac6536$var$prototypes = {
    eventsEmitter: $4e06334f990a9aa9$export$2e2bcd8739ae039,
    update: $bd4842633fe52783$export$2e2bcd8739ae039,
    translate: $37b4f9912c94901b$export$2e2bcd8739ae039,
    transition: $6bb1e758dbb602c2$export$2e2bcd8739ae039,
    slide: $131644fb6da27948$export$2e2bcd8739ae039,
    loop: $701031afeb98a6b4$export$2e2bcd8739ae039,
    grabCursor: $de085cb59a7b22cb$export$2e2bcd8739ae039,
    events: $037929b540e63932$export$2e2bcd8739ae039,
    breakpoints: $20a6615ac1eae2d6$export$2e2bcd8739ae039,
    checkOverflow: $fcf09839e5a2ea8e$export$2e2bcd8739ae039,
    classes: $bc9284d067152bdc$export$2e2bcd8739ae039,
    images: $ef82bd580e29444e$export$2e2bcd8739ae039
};
const $d3a4dc7626ac6536$var$extendedDefaults = {};
class $d3a4dc7626ac6536$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $04b7fd865a707bca$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $04b7fd865a707bca$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $d3a4dc7626ac6536$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $79ec0132ebd4cd3c$export$d61c7b85ff180578)();
        swiper.device = (0, $3adb35beed00c3f1$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $39f91bf3f483f11b$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $c9efebc9216c9083$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $04b7fd865a707bca$export$8b58be045bf06082)({}, (0, $9a0f8047d07c4881$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $04b7fd865a707bca$export$8b58be045bf06082)({}, swiperParams, $d3a4dc7626ac6536$var$extendedDefaults, params);
        swiper.originalParams = (0, $04b7fd865a707bca$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $04b7fd865a707bca$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $04b7fd865a707bca$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $6fzuY.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $04b7fd865a707bca$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $04b7fd865a707bca$export$8b58be045bf06082)($d3a4dc7626ac6536$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $d3a4dc7626ac6536$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $9a0f8047d07c4881$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$d3a4dc7626ac6536$var$Swiper.prototype.__modules__) $d3a4dc7626ac6536$var$Swiper.prototype.__modules__ = [];
        const modules = $d3a4dc7626ac6536$var$Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$d3a4dc7626ac6536$var$Swiper.installModule(m));
            return $d3a4dc7626ac6536$var$Swiper;
        }
        $d3a4dc7626ac6536$var$Swiper.installModule(module);
        return $d3a4dc7626ac6536$var$Swiper;
    }
}
Object.keys($d3a4dc7626ac6536$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($d3a4dc7626ac6536$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $d3a4dc7626ac6536$var$Swiper.prototype[protoMethod] = $d3a4dc7626ac6536$var$prototypes[prototypeGroup][protoMethod];
    });
});
$d3a4dc7626ac6536$var$Swiper.use([
    (0, $df45be0401cceedb$export$2e2bcd8739ae039),
    (0, $c8b015111a66762c$export$2e2bcd8739ae039)
]);
var $d3a4dc7626ac6536$export$2e2bcd8739ae039 = $d3a4dc7626ac6536$var$Swiper;




function $1ea63ff20215c62b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $04b7fd865a707bca$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $6fzuY = parcelRequire("6fzuY");

function $e2f0aa3f098ad558$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6fzuY.getDocument)();
    const window = (0, $6fzuY.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $6fzuY = parcelRequire("6fzuY");


function $df7a3290c59430b2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6fzuY.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $04b7fd865a707bca$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $04b7fd865a707bca$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $04b7fd865a707bca$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $04b7fd865a707bca$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $04b7fd865a707bca$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $6fzuY = parcelRequire("6fzuY");
function $f05de503a5bc13af$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $6fzuY.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $b5a240318530864d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $f05de503a5bc13af$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $dbd3cdc557284ec2$export$2e2bcd8739ae039(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}



function $3ee8e27104abd775$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $f05de503a5bc13af$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $6fzuY = parcelRequire("6fzuY");



function $42f3aa20c49b56d2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6fzuY.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $f05de503a5bc13af$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $b3a3b0861e2e6871$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $6fzuY = parcelRequire("6fzuY");


function $e64ba30c3653f76a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6fzuY.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $04b7fd865a707bca$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $04b7fd865a707bca$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $6fzuY = parcelRequire("6fzuY");

function $0924bd774f0096f9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index');
            return (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index') : (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $6fzuY.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on('destroy', ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $342bbb647a6b0636$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $d3112a02654c1059$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on('focus', handleFocus, true);
        swiper.$el.on('pointerdown', handlePointerDown, true);
        swiper.$el.on('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $dbd3cdc557284ec2$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off('focus', handleFocus, true);
        swiper.$el.off('pointerdown', handlePointerDown, true);
        swiper.$el.off('pointerup', handlePointerUp, true);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $6fzuY = parcelRequire("6fzuY");
function $4840fa7a3579b95d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $6fzuY.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $6fzuY.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $6fzuY.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $6fzuY.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $6fzuY = parcelRequire("6fzuY");

function $a00d504a853fe3d1$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $6fzuY.getDocument)();
    const window = (0, $6fzuY.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $6fzuY = parcelRequire("6fzuY");

function $874ef61e28becefa$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $04b7fd865a707bca$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $6fzuY.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit('autoplayPause');
            pause();
        }
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $6fzuY.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $6fzuY.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $21874c507ef8d4c8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $04b7fd865a707bca$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $7f02f1943687ea8a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $04b7fd865a707bca$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $04b7fd865a707bca$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $04b7fd865a707bca$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $55e2df8de2047687$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $ad9de047fcc5ad0b$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $d2cfec18445c0fea$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $dbd25a00e3a1d482$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $f4c5e6dba7cec446$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $808f6247b07f957a$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $f03549ee7c5ccf7e$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $ad9de047fcc5ad0b$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $d2cfec18445c0fea$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $dbd25a00e3a1d482$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $f4c5e6dba7cec446$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $808f6247b07f957a$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $28c6ff965a3d6c35$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}


function $cb834727fa1e4eac$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}


function $a316893e68077ae3$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $b3259a8107f7c3ea$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $cb834727fa1e4eac$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $a316893e68077ae3$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $28c6ff965a3d6c35$export$2e2bcd8739ae039)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $3b55e7ca18654081$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $28c6ff965a3d6c35$export$2e2bcd8739ae039)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}




function $8af1b6a6474a1923$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $371180e4909a9831$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) shadowBefore = (0, $8af1b6a6474a1923$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (shadowAfter.length === 0) shadowAfter = (0, $8af1b6a6474a1923$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $0428edcc4d18d14e$export$2e2bcd8739ae039)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $cb834727fa1e4eac$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $a316893e68077ae3$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $28c6ff965a3d6c35$export$2e2bcd8739ae039)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $422bc6973e5424a0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $cb834727fa1e4eac$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $8af1b6a6474a1923$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $8af1b6a6474a1923$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $28c6ff965a3d6c35$export$2e2bcd8739ae039)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $e207ae6eea99b6f8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $8af1b6a6474a1923$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $cb834727fa1e4eac$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $a316893e68077ae3$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $28c6ff965a3d6c35$export$2e2bcd8739ae039)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $fa0436c0406dc1f7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $8af1b6a6474a1923$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $cb834727fa1e4eac$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $a316893e68077ae3$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $28c6ff965a3d6c35$export$2e2bcd8739ae039)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




window.isScrollLocked = false;
let $ac1a598cbf49b91d$var$swiperInstance;
let $ac1a598cbf49b91d$var$insideScrolly = false;
let $ac1a598cbf49b91d$var$readyToSwipe = true;
function $ac1a598cbf49b91d$var$setVariableToFalseForOneSecond() {
    $ac1a598cbf49b91d$var$readyToSwipe = false;
    setTimeout(()=>{
        $ac1a598cbf49b91d$var$readyToSwipe = true;
    }, 500);
}
$ac1a598cbf49b91d$var$swiperInstance = new (0, $d3a4dc7626ac6536$export$2e2bcd8739ae039)(".scrollytell", {
    speed: 600,
    touchReleaseOnEdges: true,
    modules: [
        (0, $df7a3290c59430b2$export$2e2bcd8739ae039),
        (0, $7f02f1943687ea8a$export$2e2bcd8739ae039),
        (0, $e2f0aa3f098ad558$export$2e2bcd8739ae039)
    ],
    direction: "vertical",
    on: {
        slideChange: function(e) {
            const backgroundImages = document.querySelectorAll(".scrollytell__bg");
            backgroundImages.forEach((bgImg, index)=>{
                const from = parseInt(bgImg.dataset.from ?? "");
                const to = parseInt(bgImg.dataset.to ?? "");
                if (e.activeIndex >= from && e.activeIndex <= to) bgImg.classList.add("scrollytell__bg--active");
                else bgImg.classList.remove("scrollytell__bg--active");
                const isLastElement = index === backgroundImages.length;
                if (!isLastElement) $ac1a598cbf49b91d$var$playActiveVideo();
                 //Enables videos and images to be in the same scrollytellcontainer by playing video on slide change
            });
        },
        reachEnd: function() {
            $ac1a598cbf49b91d$var$showFooter();
            $ac1a598cbf49b91d$var$scrolldown();
        },
        reachBeginning: function() {
            $ac1a598cbf49b91d$var$showHeader();
            $ac1a598cbf49b91d$var$scrollUp();
            $ac1a598cbf49b91d$var$scrollBackToElement('scrollytell-container');
            $ac1a598cbf49b91d$var$hideFooter();
        }
    }
});
function $ac1a598cbf49b91d$var$playActiveVideo() {
    const activeElements = document.querySelectorAll('.custom-video');
    activeElements.forEach((element)=>{
        if (element instanceof HTMLVideoElement) {
            if (element.paused || element.ended) {
                element.muted = true;
                element.play();
            }
        }
    });
}
function $ac1a598cbf49b91d$var$scrollBackToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        const yOffset = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: yOffset - 200
        });
    }
}
function $ac1a598cbf49b91d$var$scrollUp() {
    var firstElement = document.getElementById("feature-page-intro-container");
    if (firstElement) {
        var height = firstElement.offsetHeight;
        var scrollHeight = height - 51;
        window.scrollBy(0, +scrollHeight);
    }
}
function $ac1a598cbf49b91d$var$scrolldown() {
    window.scrollBy(0, 51); //sends the user out of locked state at the end of scrollytell
}
function $ac1a598cbf49b91d$var$disableSwiper() {
    $ac1a598cbf49b91d$var$stopVideo();
    const bodyElement = document.body;
    if (bodyElement) bodyElement.style.overflow = 'visible';
    $ac1a598cbf49b91d$var$insideScrolly = false;
    window.isScrollLocked = false;
    $ac1a598cbf49b91d$var$swiperInstance.enabled = false;
    const element = document.getElementById("header");
    if (element) element.style.display = "block";
}
function $ac1a598cbf49b91d$var$resumeSwiper() {
    const video = document.getElementById("bgImageScrolly");
    if (video instanceof HTMLVideoElement) $ac1a598cbf49b91d$var$playVideo();
    const bodyElement = document.body;
    if (bodyElement) bodyElement.style.overflow = 'hidden';
    $ac1a598cbf49b91d$var$insideScrolly = true;
    $ac1a598cbf49b91d$var$swiperInstance.enabled = true;
    const element = document.getElementById("header");
    if (element) element.style.display = "none";
    $ac1a598cbf49b91d$var$hideHeader();
}
function $ac1a598cbf49b91d$var$checkIfImageCentered() {
    function getCenterYCoordinate() {
        const image = document.getElementById('bgImageScrolly');
        if (!image) return null;
        const rect = image.getBoundingClientRect();
        const centerY = rect.top + rect.height / 2;
        return centerY;
    }
    const imageCenterY = getCenterYCoordinate();
    if (!imageCenterY) return;
    const viewportHeight = window.innerHeight;
    const viewportCenterY = viewportHeight / 2;
    const difference = imageCenterY - viewportCenterY;
    const tolerance = 50;
    if (Math.abs(difference) <= tolerance) {
        $ac1a598cbf49b91d$var$resumeSwiper();
        window.scrollBy(0, difference);
    } else $ac1a598cbf49b91d$var$disableSwiper();
}
function $ac1a598cbf49b91d$var$hideFooter() {
    const scrollytell = document.getElementById('scrollytell-container');
    if (scrollytell) {
        let nextElement = scrollytell.nextElementSibling;
        scrollytell.style.marginBottom = "0px";
        while(nextElement){
            nextElement.style.display = 'none';
            nextElement = nextElement.nextElementSibling;
        }
    }
    const footer = document.getElementById('footer');
    if (footer) footer.style.display = 'none';
}
function $ac1a598cbf49b91d$var$showFooter() {
    const scrollytell = document.getElementById('scrollytell-container');
    if (scrollytell) {
        scrollytell.style.marginBottom = "96px";
        let nextElement = scrollytell.nextElementSibling;
        while(nextElement){
            nextElement.style.display = 'block';
            nextElement = nextElement.nextElementSibling;
        }
    }
    const footer = document.getElementById('footer');
    if (footer) footer.style.display = 'block';
}
function $ac1a598cbf49b91d$var$hideHeader() {
    const header = document.getElementById('feature-page-intro-container');
    if (header) header.style.display = 'none';
    const scrollytell = document.getElementById('scrollytell-container');
    if (scrollytell) {
        let prevElement = scrollytell.previousElementSibling;
        scrollytell.style.marginTop = "0px";
        while(prevElement){
            prevElement.style.display = 'none';
            prevElement = prevElement.previousElementSibling;
        }
    }
}
function $ac1a598cbf49b91d$var$showHeader() {
    const header = document.getElementById('feature-page-intro-container');
    if (header) header.style.display = 'block';
    const scrollytell = document.getElementById('scrollytell-container');
    if (scrollytell) {
        scrollytell.style.marginTop = "0px"; // Adjust the margin as needed
        let prevElement = scrollytell.previousElementSibling;
        while(prevElement){
            prevElement.style.display = 'block';
            prevElement = prevElement.previousElementSibling;
        }
    }
}
function $ac1a598cbf49b91d$var$playVideo() {
    const video = document.getElementById("bgImageScrolly");
    if (video) {
        video.muted = true;
        video.play();
    }
}
function $ac1a598cbf49b91d$var$stopVideo() {
    const videos = document.querySelectorAll(".custom-video");
    if (videos.length > 0) videos.forEach((video)=>{
        if (video) video.pause();
    });
}
function $ac1a598cbf49b91d$var$removeTextWithoutTouchingChildren(element) {
    let child = element.firstChild;
    while(child){
        // Store reference to next sibling since we may remove the current child
        let nextChild = child.nextSibling;
        // If the child node is a text node (nodeType === 3), remove it
        if (child.nodeType === 3) element.removeChild(child);
        // Move to the next child
        child = nextChild;
    }
}
window.onload = function() {
    const scrollytellElement = document.querySelector(".scrollytell");
    if (scrollytellElement) {
        $ac1a598cbf49b91d$var$disableSwiper();
        $ac1a598cbf49b91d$var$hideFooter();
        const bodyElement = document.querySelector('.FeatureArticlePage');
        if (bodyElement) $ac1a598cbf49b91d$var$removeTextWithoutTouchingChildren(bodyElement); //Removing free text "header" to make sure that bg image covers 100% of the screen
    }
};
function $ac1a598cbf49b91d$var$changePage(direction) {
    if (!$ac1a598cbf49b91d$var$readyToSwipe) return;
    $ac1a598cbf49b91d$var$setVariableToFalseForOneSecond();
    if ($ac1a598cbf49b91d$var$insideScrolly) {
        if (direction == "down") $ac1a598cbf49b91d$var$swiperInstance.slideNext();
        else if (direction === "up") $ac1a598cbf49b91d$var$swiperInstance.slidePrev();
    }
}
window.addEventListener('scroll', (event)=>{
    const scrollytellElement = document.querySelector(".scrollytell");
    if (!scrollytellElement) return;
    $ac1a598cbf49b91d$var$checkIfImageCentered();
});
window.addEventListener('wheel', (event)=>{
    const scrollytellElement = document.querySelector(".scrollytell");
    if (!scrollytellElement) return;
    const swipeStrengthThreshold = 50;
    if (Math.abs(event.deltaY) > swipeStrengthThreshold) {
        const direction = event.deltaY > 0 ? 'down' : 'up';
        $ac1a598cbf49b91d$var$changePage(direction);
    }
});
window.addEventListener('keyup', (event)=>{
    const scrollytellElement = document.querySelector(".scrollytell");
    if (!scrollytellElement) return;
    if (!$ac1a598cbf49b91d$var$insideScrolly) return;
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.shiftKey && event.key === 'Tab') $ac1a598cbf49b91d$var$swiperInstance.slidePrev();
    else if (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === 'Tab') $ac1a598cbf49b91d$var$swiperInstance.slideNext();
});
window.addEventListener('keydown', (event)=>{
    const scrollytellElement = document.querySelector(".scrollytell");
    if (!scrollytellElement) return;
    if (event.key === 'Tab') event.preventDefault(); // Prevent the default tab behavior
});


window.addEventListener("DOMContentLoaded", ()=>{
    const input = document.getElementById("jobSearchInput");
    const dropdownToggle = document.getElementById("departmentDropdownToggle");
    const dropdownMenu = document.getElementById("departmentDropdownMenu");
    const checkboxes = document.querySelectorAll(".department-checkbox");
    const rows = document.querySelectorAll(".job-row");
    if (!input || !dropdownToggle || !dropdownMenu) return;
    // Toggle dropdown visibility & chevron state
    dropdownToggle.addEventListener("click", (e)=>{
        e.stopPropagation(); // so our outside click handler doesn’t immediately close it
        const isHidden = dropdownMenu.classList.toggle("hidden");
        // if hidden=true, menu is now hidden, so remove .open; else add .open
        dropdownToggle.classList.toggle("open", !isHidden);
    });
    // Close dropdown when clicking outside
    document.addEventListener("click", (event)=>{
        if (!dropdownToggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
            // hide menu and reset chevron
            dropdownMenu.classList.add("hidden");
            dropdownToggle.classList.remove("open");
        }
    });
    const filterJobs = (clearSearch = false)=>{
        if (clearSearch) input.value = "";
        const filter = input.value.toLowerCase();
        const selectedDepts = Array.from(checkboxes).filter((cb)=>cb.checked).map((cb)=>cb.value.toLowerCase());
        rows.forEach((row)=>{
            const title = row.dataset.title?.toLowerCase() || "";
            const city = row.dataset.city?.toLowerCase() || "";
            const department = row.dataset.department?.toLowerCase() || "";
            const matchesText = title.includes(filter) || city.includes(filter);
            const matchesDept = selectedDepts.length === 0 || selectedDepts.includes(department);
            row.style.display = matchesText && matchesDept ? "" : "none";
        });
    };
    input.addEventListener("input", ()=>filterJobs(false));
    checkboxes.forEach((checkbox)=>{
        checkbox.addEventListener("change", ()=>filterJobs(false));
    });
});



/*!
 * ScrollToPlugin 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $4bab6a91d9236b66$var$gsap, $4bab6a91d9236b66$var$_coreInitted, $4bab6a91d9236b66$var$_window, $4bab6a91d9236b66$var$_docEl, $4bab6a91d9236b66$var$_body, $4bab6a91d9236b66$var$_toArray, $4bab6a91d9236b66$var$_config, $4bab6a91d9236b66$var$ScrollTrigger, $4bab6a91d9236b66$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $4bab6a91d9236b66$var$_getGSAP = function _getGSAP() {
    return $4bab6a91d9236b66$var$gsap || $4bab6a91d9236b66$var$_windowExists() && ($4bab6a91d9236b66$var$gsap = window.gsap) && $4bab6a91d9236b66$var$gsap.registerPlugin && $4bab6a91d9236b66$var$gsap;
}, $4bab6a91d9236b66$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $4bab6a91d9236b66$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $4bab6a91d9236b66$var$_max = function _max(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return element === $4bab6a91d9236b66$var$_window || element === $4bab6a91d9236b66$var$_docEl || element === $4bab6a91d9236b66$var$_body ? Math.max($4bab6a91d9236b66$var$_docEl[scroll], $4bab6a91d9236b66$var$_body[scroll]) - ($4bab6a91d9236b66$var$_window["inner" + dim] || $4bab6a91d9236b66$var$_docEl[client] || $4bab6a91d9236b66$var$_body[client]) : element[scroll] - element["offset" + dim];
}, $4bab6a91d9236b66$var$_buildGetter = function _buildGetter(e, axis) {
    //pass in an element and an axis ("x" or "y") and it'll return a getter function for the scroll position of that element (like scrollTop or scrollLeft, although if the element is the window, it'll use the pageXOffset/pageYOffset or the documentElement's scrollTop/scrollLeft or document.body's. Basically this streamlines things and makes a very fast getter across browsers.
    var p = "scroll" + (axis === "x" ? "Left" : "Top");
    if (e === $4bab6a91d9236b66$var$_window) {
        if (e.pageXOffset != null) p = "page" + axis.toUpperCase() + "Offset";
        else e = $4bab6a91d9236b66$var$_docEl[p] != null ? $4bab6a91d9236b66$var$_docEl : $4bab6a91d9236b66$var$_body;
    }
    return function() {
        return e[p];
    };
}, $4bab6a91d9236b66$var$_clean = function _clean(value, index, target, targets) {
    $4bab6a91d9236b66$var$_isFunction(value) && (value = value(index, target, targets));
    if (typeof value !== "object") return $4bab6a91d9236b66$var$_isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
        x: value,
        y: value
    } : {
        y: value
    }; //if we don't receive an object as the parameter, assume the user intends "y".
    else if (value.nodeType) return {
        y: value,
        x: value
    };
    else {
        var result = {}, p;
        for(p in value)result[p] = p !== "onAutoKill" && $4bab6a91d9236b66$var$_isFunction(value[p]) ? value[p](index, target, targets) : value[p];
        return result;
    }
}, $4bab6a91d9236b66$var$_getOffset = function _getOffset(element, container) {
    element = $4bab6a91d9236b66$var$_toArray(element)[0];
    if (!element || !element.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || {
        x: 0,
        y: 0
    };
    var rect = element.getBoundingClientRect(), isRoot = !container || container === $4bab6a91d9236b66$var$_window || container === $4bab6a91d9236b66$var$_body, cRect = isRoot ? {
        top: $4bab6a91d9236b66$var$_docEl.clientTop - ($4bab6a91d9236b66$var$_window.pageYOffset || $4bab6a91d9236b66$var$_docEl.scrollTop || $4bab6a91d9236b66$var$_body.scrollTop || 0),
        left: $4bab6a91d9236b66$var$_docEl.clientLeft - ($4bab6a91d9236b66$var$_window.pageXOffset || $4bab6a91d9236b66$var$_docEl.scrollLeft || $4bab6a91d9236b66$var$_body.scrollLeft || 0)
    } : container.getBoundingClientRect(), offsets = {
        x: rect.left - cRect.left,
        y: rect.top - cRect.top
    };
    if (!isRoot && container) {
        //only add the current scroll position if it's not the window/body.
        offsets.x += $4bab6a91d9236b66$var$_buildGetter(container, "x")();
        offsets.y += $4bab6a91d9236b66$var$_buildGetter(container, "y")();
    }
    return offsets;
}, $4bab6a91d9236b66$var$_parseVal = function _parseVal(value, target, axis, currentVal, offset) {
    return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : $4bab6a91d9236b66$var$_isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? $4bab6a91d9236b66$var$_max(target, axis) - offset : Math.min($4bab6a91d9236b66$var$_max(target, axis), $4bab6a91d9236b66$var$_getOffset(value, target)[axis] - offset);
}, $4bab6a91d9236b66$var$_initCore = function _initCore() {
    $4bab6a91d9236b66$var$gsap = $4bab6a91d9236b66$var$_getGSAP();
    if ($4bab6a91d9236b66$var$_windowExists() && $4bab6a91d9236b66$var$gsap && typeof document !== "undefined" && document.body) {
        $4bab6a91d9236b66$var$_window = window;
        $4bab6a91d9236b66$var$_body = document.body;
        $4bab6a91d9236b66$var$_docEl = document.documentElement;
        $4bab6a91d9236b66$var$_toArray = $4bab6a91d9236b66$var$gsap.utils.toArray;
        $4bab6a91d9236b66$var$gsap.config({
            autoKillThreshold: 7
        });
        $4bab6a91d9236b66$var$_config = $4bab6a91d9236b66$var$gsap.config();
        $4bab6a91d9236b66$var$_coreInitted = 1;
    }
};
var $4bab6a91d9236b66$export$6953cc323644330b = {
    version: "3.12.5",
    name: "scrollTo",
    rawVars: 1,
    register: function register(core) {
        $4bab6a91d9236b66$var$gsap = core;
        $4bab6a91d9236b66$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        $4bab6a91d9236b66$var$_coreInitted || $4bab6a91d9236b66$var$_initCore();
        var data = this, snapType = $4bab6a91d9236b66$var$gsap.getProperty(target, "scrollSnapType");
        data.isWin = target === $4bab6a91d9236b66$var$_window;
        data.target = target;
        data.tween = tween;
        value = $4bab6a91d9236b66$var$_clean(value, index, target, targets);
        data.vars = value;
        data.autoKill = !!value.autoKill;
        data.getX = $4bab6a91d9236b66$var$_buildGetter(target, "x");
        data.getY = $4bab6a91d9236b66$var$_buildGetter(target, "y");
        data.x = data.xPrev = data.getX();
        data.y = data.yPrev = data.getY();
        $4bab6a91d9236b66$var$ScrollTrigger || ($4bab6a91d9236b66$var$ScrollTrigger = $4bab6a91d9236b66$var$gsap.core.globals().ScrollTrigger);
        $4bab6a91d9236b66$var$gsap.getProperty(target, "scrollBehavior") === "smooth" && $4bab6a91d9236b66$var$gsap.set(target, {
            scrollBehavior: "auto"
        });
        if (snapType && snapType !== "none") {
            // disable scroll snapping to avoid strange behavior
            data.snap = 1;
            data.snapInline = target.style.scrollSnapType;
            target.style.scrollSnapType = "none";
        }
        if (value.x != null) {
            data.add(data, "x", data.x, $4bab6a91d9236b66$var$_parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);
            data._props.push("scrollTo_x");
        } else data.skipX = 1;
        if (value.y != null) {
            data.add(data, "y", data.y, $4bab6a91d9236b66$var$_parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);
            data._props.push("scrollTo_y");
        } else data.skipY = 1;
    },
    render: function render(ratio, data) {
        var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, snap = data.snap, snapInline = data.snapInline, x, y, yDif, xDif, threshold;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        x = isWin || !data.skipX ? data.getX() : xPrev;
        y = isWin || !data.skipY ? data.getY() : yPrev;
        yDif = y - yPrev;
        xDif = x - xPrev;
        threshold = $4bab6a91d9236b66$var$_config.autoKillThreshold;
        if (data.x < 0) //can't scroll to a position less than 0! Might happen if someone uses a Back.easeOut or Elastic.easeOut when scrolling back to the top of the page (for example)
        data.x = 0;
        if (data.y < 0) data.y = 0;
        if (autoKill) {
            //note: iOS has a bug that throws off the scroll by several pixels, so we need to check if it's within 7 pixels of the previous one that we set instead of just looking for an exact match.
            if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < $4bab6a91d9236b66$var$_max(target, "x")) data.skipX = 1; //if the user scrolls separately, we should stop tweening!
            if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < $4bab6a91d9236b66$var$_max(target, "y")) data.skipY = 1; //if the user scrolls separately, we should stop tweening!
            if (data.skipX && data.skipY) {
                tween.kill();
                data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
            }
        }
        if (isWin) $4bab6a91d9236b66$var$_window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
        else {
            data.skipY || (target.scrollTop = data.y);
            data.skipX || (target.scrollLeft = data.x);
        }
        if (snap && (ratio === 1 || ratio === 0)) {
            y = target.scrollTop;
            x = target.scrollLeft;
            snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
            target.scrollTop = y + 1; // bug in Safari causes the element to totally reset its scroll position when scroll-snap-type changes, so we need to set it to a slightly different value and then back again to work around this bug.
            target.scrollLeft = x + 1;
            target.scrollTop = y;
            target.scrollLeft = x;
        }
        data.xPrev = data.x;
        data.yPrev = data.y;
        $4bab6a91d9236b66$var$ScrollTrigger && $4bab6a91d9236b66$var$ScrollTrigger.update();
    },
    kill: function kill(property) {
        var both = property === "scrollTo", i = this._props.indexOf(property);
        if (both || property === "scrollTo_x") this.skipX = 1;
        if (both || property === "scrollTo_y") this.skipY = 1;
        i > -1 && this._props.splice(i, 1);
        return !this._props.length;
    }
};
$4bab6a91d9236b66$export$6953cc323644330b.max = $4bab6a91d9236b66$var$_max;
$4bab6a91d9236b66$export$6953cc323644330b.getOffset = $4bab6a91d9236b66$var$_getOffset;
$4bab6a91d9236b66$export$6953cc323644330b.buildGetter = $4bab6a91d9236b66$var$_buildGetter;
$4bab6a91d9236b66$var$_getGSAP() && $4bab6a91d9236b66$var$gsap.registerPlugin($4bab6a91d9236b66$export$6953cc323644330b);


(0, $1974f63041948ee8$export$99ee26438460406a).registerPlugin((0, $4bab6a91d9236b66$export$6953cc323644330b));
(function() {
    const viewMoreLists = document.querySelectorAll('[data-view-more-list]');
    if (!viewMoreLists.length) return;
    viewMoreLists.forEach((viewMoreList)=>{
        let clickTarget = viewMoreList.getElementsByTagName('button')[0];
        let staggerItems = viewMoreList.querySelectorAll('[data-report-list-hidden]');
        const textContent = clickTarget.querySelectorAll('.view-more-button__text')[0];
        const closeText = clickTarget.getAttribute('data-close-text');
        const moreText = clickTarget.getAttribute('data-more-text');
        clickTarget.setAttribute('aria-expanded', 'false');
        const tl = (0, $1974f63041948ee8$export$99ee26438460406a).timeline({
            paused: true,
            onComplete: ()=>{
                clickTarget.classList.add('view-more-button--open');
                clickTarget.setAttribute('aria-expanded', 'true');
                textContent.innerText = closeText;
            },
            onReverseComplete: ()=>{
                clickTarget.classList.remove('view-more-button--open');
                clickTarget.setAttribute('aria-expanded', 'false');
                (0, $1974f63041948ee8$export$99ee26438460406a).to(window, {
                    duration: 0,
                    scrollTo: {
                        y: clickTarget,
                        offsetY: 200
                    }
                });
                textContent.innerText = moreText;
            }
        });
        tl.fromTo(staggerItems, {
            yPercent: -25,
            opacity: 0,
            display: 'none'
        }, {
            duration: 0.5,
            stagger: 0.025,
            display: 'grid',
            yPercent: 0,
            opacity: 1,
            ease: 'expo.inOut'
        });
        clickTarget.onclick = function() {
            if (clickTarget.classList.contains('view-more-button--open')) tl.timeScale(1.25).reverse();
            else {
                clickTarget.classList.add('view-more-button--open');
                tl.timeScale(1).play(0);
            }
        };
    });
})();



const $00846cbaa37a2d05$var$filterSideNav = ()=>{
    const filterComponentEl = document.querySelector('.filter-component');
    if (!filterComponentEl) return;
    const isExpanded = (element)=>{
        return element.classList.contains('expanded');
    };
    const sideNavElement = filterComponentEl.querySelector('.filter-side-nav');
    const desktopButton = sideNavElement.querySelector('.filter-side-nav__button-desktop');
    const mobileButton = sideNavElement.querySelector('.filter-side-nav__button-mobile');
    const activeButton = filterComponentEl.querySelector('.filter-active-button');
    const filterDefaultText = 'Filter';
    const { closeText: closeText } = activeButton.dataset;
    activeButton.addEventListener('click', function() {
        if (isExpanded(sideNavElement)) {
            sideNavElement.classList.remove('expanded');
            activeButton.textContent = filterDefaultText;
            activeButton.classList.remove('button--primary__active');
            desktopButton.classList.remove('button--primary__active');
        } else {
            sideNavElement.classList.add('expanded');
            activeButton.textContent = closeText;
            activeButton.classList.add('button--primary__active');
            desktopButton.classList.add('button--outline__active');
        }
    });
    mobileButton.addEventListener('click', function() {
        activeButton.textContent = filterDefaultText;
        sideNavElement.classList.remove('expanded');
        activeButton.classList.remove('button--primary__active');
        desktopButton.classList.remove('button--outline__active');
    });
    desktopButton.addEventListener('click', function() {
        if (isExpanded(sideNavElement)) {
            sideNavElement.classList.remove('expanded');
            activeButton.textContent = filterDefaultText;
            desktopButton.setAttribute('aria-label', 'Filter');
            activeButton.classList.remove('button--primary__active');
            desktopButton.classList.remove('button--outline__active');
        } else {
            sideNavElement.classList.remove('hovered');
            sideNavElement.classList.add('expanded');
            activeButton.textContent = closeText;
            desktopButton.setAttribute('aria-label', desktopButton.getAttribute('data-db-close-text'));
            activeButton.classList.add('button--primary__active');
            desktopButton.classList.add('button--outline__active');
        }
    });
    desktopButton.addEventListener('mouseover', function() {
        if (!isExpanded(sideNavElement)) sideNavElement.classList.add('hovered');
    });
    desktopButton.addEventListener('mouseleave', function() {
        if (!isExpanded(sideNavElement)) sideNavElement.classList.remove('hovered');
    });
};
const $00846cbaa37a2d05$var$createFilter = (props)=>{
    const { mainElement: mainElement, initialActiveCategoriesIds: initialActiveCategoriesIds, onSubmit: onSubmit, submitText: submitText, abortText: abortText, filterChooseText: filterChooseText, filterCategories: filterCategories, filterTitle: filterTitle, isAsync: isAsync, language: language } = props;
    let activeCategoryIds = initialActiveCategoriesIds || [];
    const createMainCategory = (category)=>{
        const wrapper = createSubcategory(category);
        const labelEl = document.createElement('h4');
        labelEl.classList.add('filter-item__label');
        labelEl.textContent = category.name;
        wrapper.prepend(labelEl);
        return wrapper;
    };
    const createSingleItem = (category)=>{
        const catIdNum = Number(category.id);
        const item = document.createElement('li');
        item.classList.add('filter-item');
        item.classList.add('filter-item__selectable');
        item.setAttribute('data-id', category.id.toString());
        const itemContentEl = document.createElement('label');
        itemContentEl.textContent = category.name;
        itemContentEl.setAttribute('for', 'cat' + category.id);
        const checkboxEl = document.createElement('input');
        checkboxEl.setAttribute('type', 'checkbox');
        checkboxEl.classList.add('filter-item__checkbox');
        checkboxEl.setAttribute('value', itemContentEl.textContent);
        checkboxEl.setAttribute('name', itemContentEl.textContent);
        checkboxEl.setAttribute('id', 'cat' + category.id);
        item.append(checkboxEl);
        item.append(itemContentEl);
        if (activeCategoryIds.indexOf(catIdNum) > -1) {
            item.classList.add('active');
            checkboxEl.checked = true;
            createFilterListItem(catIdNum, category.name);
        }
        checkboxEl.addEventListener('click', function() {
            const isActive = !checkboxEl.checked;
            if (isActive) removeFilter(catIdNum);
            else addFilter(catIdNum, category.name);
        });
        return item;
    };
    const createSubcategory = (category)=>{
        const { name: name, categories: categories, id: id } = category;
        const isMainCategory = category.isTopCategoryInFilter;
        const wrapper = isMainCategory ? document.createElement('div') : document.createElement('li');
        wrapper.classList.add('filter-item');
        const panel = document.createElement('ul');
        panel.setAttribute('id', "parentname-" + name);
        if (!isMainCategory) {
            const item = document.createElement('li');
            item.classList.add('filter-item');
            item.classList.add('filter-item__selectable');
            item.setAttribute('data-id', "data" + id.toString());
            const itemContentEl = document.createElement('label');
            if (language === "20") itemContentEl.textContent = "Velg Alle";
            else if (language === "29") itemContentEl.textContent = "V\xe4lj Alla";
            else itemContentEl.textContent = "Select All";
            itemContentEl.setAttribute('for', 'SelectAll' + name);
            itemContentEl.setAttribute('id', 'SelectAll' + id);
            itemContentEl.classList.add('highligtedFont');
            const checkboxEl = document.createElement('input');
            checkboxEl.setAttribute('type', 'checkbox');
            checkboxEl.classList.add('filter-item__checkbox');
            checkboxEl.setAttribute('value', "select all" + name);
            checkboxEl.setAttribute('name', "select all" + name);
            checkboxEl.setAttribute('id', 'SelectAll' + name);
            item.append(checkboxEl);
            item.append(itemContentEl);
            panel.append(item);
            checkboxEl.addEventListener('click', function() {
                const isActive = !checkboxEl.checked;
                var childs = document.getElementById("parentname-" + name).childNodes;
                childs.forEach((child)=>{
                    var tmp = child.childNodes;
                    const inputLabel = tmp[1];
                    const inputChecker = tmp[0];
                    const isChildActive = !inputChecker.checked;
                    if (inputLabel != null) {
                        if (isActive) {
                            if (inputLabel.id != 'SelectAll' + id) {
                                if (!isChildActive) inputLabel.click();
                            }
                        } else if (!isActive) {
                            if (inputLabel.id != 'SelectAll' + id) {
                                if (isChildActive) inputLabel.click();
                            }
                        }
                    }
                });
            });
        }
        panel.classList.add('filter-item__panel');
        panel.classList.add('filter-item__panel--first-level');
        panel.classList.add('hide');
        // const panelList = document.createElement('ul');
        // panelList.classList.add('filter-item__panel-list');
        // panel.append(panelList);
        const btn = document.createElement('button');
        btn.classList.add('filter-item__accordion');
        btn.classList.add('filter-item__accordion--first');
        if (isMainCategory) {
            btn.textContent = filterChooseText;
            btn.setAttribute('id', id.toString());
            wrapper.classList.add('filter-item__main');
        } else {
            btn.textContent = name;
            btn.setAttribute('ids', id.toString());
        }
        btn.addEventListener('click', function() {
            this.classList.toggle('active');
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                panel.classList.add('hide');
                btn.setAttribute('aria-expanded', 'false');
            } else {
                panel.style.maxHeight = '1600px';
                btn.setAttribute('aria-expanded', 'true');
                panel.classList.remove('hide');
            }
        });
        if (categories != null) categories.forEach((subcategory)=>{
            const isSingleItem = subcategory.categories === null;
            const isSubcategory = !isSingleItem;
            const isAllWithin = subcategory.isAllWithin;
            if (isSingleItem) {
                const item = createSingleItem(subcategory);
                panel.append(item);
            } else if (isSubcategory) {
                const items = createSubcategory(subcategory);
                panel.append(items);
            } else if (isAllWithin) {
                const item = createSingleItem(subcategory);
                panel.append(item);
            }
        });
        wrapper.append(btn);
        wrapper.append(panel);
        return wrapper;
    };
    const removeFilter = (id)=>{
        const filterItem = document.querySelectorAll(`.filter-item__selectable[data-id="${id.toString()}"]`)[0];
        const filterCheckbox = filterItem.querySelector('.filter-item__checkbox');
        filterCheckbox.checked = false;
        activeCategoryIds = activeCategoryIds.filter((num)=>num !== id);
        filterItem.classList.remove('active');
        removeFilterListItem(id);
    };
    const addFilter = (id, name)=>{
        const filterItem = document.querySelectorAll(`.filter-item__selectable[data-id="${id.toString()}"]`)[0];
        const filterCheckbox = filterItem.querySelector('.filter-item__checkbox');
        createFilterListItem(id, name);
        filterCheckbox.checked = true;
        filterItem.classList.add('active');
        activeCategoryIds.push(id);
    };
    const removeAllFilters = ()=>{
        activeCategoryIds.forEach((catId)=>{
            removeFilter(catId);
        });
    };
    const resetCategories = (isAsync)=>{
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete('catids');
        searchParams.delete('page');
        url.search = searchParams.toString();
        const desktopButton = document.querySelector('.filter-side-nav__button-desktop');
        desktopButton.click();
        if (isAsync) {
            removeAllFilters();
            history.pushState({}, null, url.toString());
        } else window.open(url.href, '_self');
    };
    const createFilterListItem = (id, name)=>{
        const activeFiltersList = document.querySelector('.filter-active-list');
        const filterListEl = document.createElement('li');
        const filterListBtn = document.createElement('button');
        filterListBtn.setAttribute('type', 'button');
        filterListBtn.classList.add('filter-active-list__button');
        filterListBtn.textContent = name;
        filterListBtn.setAttribute('data-id', id.toString());
        filterListEl.classList.add('filter-active-list__item');
        filterListEl.setAttribute('data-id', id.toString());
        filterListBtn.addEventListener('click', function() {
            removeFilter(id);
        });
        filterListBtn.innerHTML = `${filterListBtn.innerHTML} <sup>&#10005;</sup>`;
        filterListEl.append(filterListBtn);
        activeFiltersList.prepend(filterListEl);
    };
    const removeFilterListItem = (id)=>{
        const filterListItem = document.querySelectorAll(`.filter-active-list__item[data-id="${id.toString()}"]`)[0];
        filterListItem.remove();
    };
    const createFiltersList = (categories, submitText, abortText, filterChooseText, filterTitle)=>{
        const filterWrapperEl = mainElement;
        const filters = [];
        const filterListEl = document.createElement('div');
        filterListEl.classList.add('filter-list');
        const buttonsWrapperEl = document.createElement('div');
        buttonsWrapperEl.classList.add('filter-buttons');
        const submitButton = document.createElement('button');
        submitButton.classList.add('filter-button');
        submitButton.classList.add('button');
        submitButton.classList.add('filter-button--submit');
        submitButton.classList.add('button--negative');
        submitButton.textContent = submitText;
        submitButton.addEventListener('click', ()=>onSubmit(activeCategoryIds));
        const abortButton = document.createElement('button');
        abortButton.classList.add('filter-button');
        abortButton.classList.add('button');
        abortButton.classList.add('button--outline-negative');
        abortButton.classList.add('filter-button--abort');
        abortButton.textContent = abortText;
        abortButton.addEventListener('click', ()=>resetCategories(isAsync));
        buttonsWrapperEl.append(submitButton, abortButton);
        categories.map((category)=>{
            const firstItemEl = createMainCategory(category);
            filterListEl.append(firstItemEl);
            filters.push(filterListEl);
        });
        filters.forEach((filter)=>{
            filterWrapperEl.prepend(filter);
        });
        filterWrapperEl.append(buttonsWrapperEl);
        const filterTitleEl = document.createElement('h2');
        filterTitleEl.textContent = filterTitle;
        filterTitleEl.classList.add("filter-title");
        filterWrapperEl.prepend(filterTitleEl);
    };
    createFiltersList(filterCategories.categories, submitText, abortText, filterChooseText, filterTitle);
};
const $00846cbaa37a2d05$var$getCategories = async (url)=>{
    const res = await fetch(url).then((response)=>response.json());
    return res;
};
const $00846cbaa37a2d05$var$updateCategories = (categories, isAsync)=>{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    searchParams.delete('catids');
    searchParams.delete('page');
    categories.forEach((category)=>searchParams.append('catids', category.toString()));
    url.search = searchParams.toString();
    const desktopButton = document.querySelector('.filter-side-nav__button-desktop');
    desktopButton.click();
    if (isAsync) history.pushState({}, null, url.toString());
    else window.open(url.href, '_self');
};
const $00846cbaa37a2d05$var$initializeFilters = ()=>{
    const filterBoxsEl = document.querySelector('.filter-box');
    if (!filterBoxsEl) return;
    const data = filterBoxsEl.dataset;
    const { guuid: guuid, lang: lang, abortText: abortText, submitText: submitText, filterChooseText: filterChooseText, filterTitle: filterTitle, isAsync: isAsync } = data;
    const isFilterAsync = isAsync ? isAsync.toLowerCase() === 'true' : false;
    const { catIds: catIds } = (0, $5d0fafb2bd24c3c5$export$57a5f2d0e67d7713)();
    const mainUrl = window.location.origin;
    const apiUrl = `${mainUrl}/api/filter/categories/${guuid}/${lang}`;
    $00846cbaa37a2d05$var$getCategories(apiUrl).then((filterCategories)=>{
        $00846cbaa37a2d05$var$createFilter({
            mainElement: filterBoxsEl,
            onSubmit: (categories)=>$00846cbaa37a2d05$var$updateCategories(categories, isFilterAsync),
            filterCategories: filterCategories,
            initialActiveCategoriesIds: catIds,
            submitText: submitText,
            abortText: abortText,
            filterChooseText: filterChooseText,
            filterTitle: filterTitle,
            isAsync: isFilterAsync,
            language: lang
        });
    });
};
$00846cbaa37a2d05$var$filterSideNav();
$00846cbaa37a2d05$var$initializeFilters();
var $00846cbaa37a2d05$export$2e2bcd8739ae039 = $00846cbaa37a2d05$var$createFilter;



function $717bb75f1b3c723c$export$8fb536984ec8b4d7(str) {
    let encoded = btoa(unescape(encodeURIComponent(str)));
    // Remove any '=' padding characters from the end
    return encoded.replace(/=*$/, '');
}
function $717bb75f1b3c723c$export$94fdf11bafc8de6b(str) {
    // Add back any missing padding for correct Base64 decoding
    let padding = str.length % 4 === 2 ? '==' : str.length % 4 === 3 ? '=' : '';
    return decodeURIComponent(escape(atob(str + padding)));
}


document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('priceCalculatorForm');
    const resultOutput = document.getElementById('resultOutput');
    const attachmentErrorOutput = document.getElementById('attachmentErrorOutput');
    const quoteRequestErrorOutput = document.getElementById('quoteRequestErrorOutput');
    const quoteInvalidSessionError = document.getElementById('quoteInvalidSessionError');
    const priceCalcluatorparent = document.getElementById('calculatorParent');
    const loader = document.getElementById('loader');
    const priceResult = document.getElementById('priceResult');
    const neutralResult = document.getElementById('neutralResult');
    const negativeResult = document.getElementById('negativeResult');
    const negativeResultText = document.getElementById('negativeResultText');
    const nextButton = document.getElementById('nextButton');
    const nextContainer = document.getElementById('nextContainer');
    const calculatorContent = document.querySelector('.calculatorContent');
    const furtherInputFields = document.getElementById('furtherInputFields');
    const submitButton = document.getElementById('submitFormButton');
    const submitAttachment = document.getElementById('submitAttachment');
    const description = document.getElementById('description');
    const receipt = document.getElementById('receiptParent');
    const consentCheckbox = document.getElementById('consentCheckbox');
    const m2 = document.getElementById("m2");
    const gate = document.getElementById("gate");
    const gateNummer = document.getElementById("gateNummer");
    const postnr = document.getElementById("postnr");
    const poststed = document.getElementById("poststed");
    const recalculateLink = document.getElementById("recalculateLink");
    const addressList = document.getElementById("addressList");
    const streetNumberList = document.getElementById("streetNumberList");
    const resultWho = document.getElementById('resultWho');
    const resultM2 = document.getElementById('resultM2');
    const summaryValue = document.getElementById('summaryValue');
    const resultGate = document.getElementById('resultGate');
    const resultPostnr = document.getElementById('resultPostnr');
    const resultPoststed = document.getElementById('resultPoststed');
    const firstName = document.getElementById('firstName');
    const firstNameError = document.getElementById('errorName');
    const email = document.getElementById('email');
    const emailError = document.getElementById('errorEmail');
    const errorOrgName = document.getElementById('errorOrgName');
    const errorOrgNumber = document.getElementById('errorOrgNumber');
    const phoneNumber = document.getElementById('phonenumber');
    const phoneNumberError = document.getElementById('errorPhonenumber');
    const orgNumberContainer = document.getElementById("orgNumberContainer");
    const orgNumber = document.getElementById("orgNumber");
    const orgNameContainer = document.getElementById("orgNameContainer");
    const orgName = document.getElementById("orgName");
    const inkNokElement = document.getElementById("inkNok");
    const addressLookupUrl = document.getElementById('addressLookupUrl');
    const priceCalculatorUrl = document.getElementById('priceCalculatorUrl');
    const quoteRequestUrl = document.getElementById('quoteRequestUrl');
    const uploadAttachmentUrl = document.getElementById('uploadAttachmentUrl');
    const veidekkeSessionUrl = document.getElementById('veidekkeSessionUrl');
    const firstPartResult = document.getElementById('firstPartResult');
    const inkNok = document.getElementById('inkNok');
    const asphaltCalculator = document.getElementById('asphaltCalculator');
    const fullNameLabelText = document.getElementById('fullNameLabelText');
    const signicatErrorContainer = document.getElementById('signicatErrorContainer');
    const signicatErrorResponse = document.getElementById('signicatErrorResponse');
    const attachmentList = document.getElementById("attachmentList");
    const companyString = "Company";
    const unableString = "Unable";
    const headerBring = "bring";
    const headerSignicat = "signicat";
    var signicatCallbackUrl = window.location.href + "?m2";
    var decodedParams = new URLSearchParams();
    var estimatedPrice = unableString;
    var signicatAuthUrl;
    var fileReferences = [];
    var filteredAddresses = Array();
    var validNumbers = Array();
    var fileUploadFailed = false;
    var gateClicked = false;
    var gateNummerClicked = false;
    var streetId;
    var gateAdresse;
    var uploadedFiles = [];
    var priceCalculatorQueryString;
    var addressLookupQueryString;
    if (!form || !receipt || !resultOutput || !submitButton || !nextContainer || !priceCalcluatorparent || !priceResult || !negativeResult || !neutralResult || !nextButton || !calculatorContent || !furtherInputFields || !consentCheckbox) return;
    toggleButton();
    function debounce(func, timeout = 300) {
        let timer;
        return (...args)=>{
            clearTimeout(timer);
            timer = setTimeout(()=>{
                func.apply(this, args);
            }, timeout);
        };
    }
    async function getToken(service) {
        try {
            const response = await fetch(`/api/token/getToken/${service}`);
            if (!response.ok) throw new Error('Network response was not ok');
            return await response.text();
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching token:', error);
            return null;
        }
    }
    async function getHeaders(tokenType, method) {
        const token = await getToken(tokenType);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        return {
            method: method,
            headers: myHeaders
        };
    }
    async function fetchAddresses() {
        const requestOptions = await getHeaders(headerBring, "GET");
        const url = `${addressLookupUrl.value + 'suggestions/?q=' + gate.value}`;
        if (addressLookupQueryString != url) try {
            gateClicked = false;
            const response = await fetch(url, requestOptions);
            addressLookupQueryString = url;
            const data = await response.json();
            const validAddresses = data.streets_and_places.map((street)=>street);
            resetAddresses();
            gateNummer.value = "";
            gateNummer.disabled = true;
            poststed.value = "";
            postnr.value = "";
            var nextPage = data.navigation.next;
            while(nextPage){
                const response = await fetch(`${addressLookupUrl.value + nextPage.split('/no/')[1]}`, requestOptions);
                const data = await response.json();
                const nextAddresses = data.streets_and_places.map((street)=>street);
                validAddresses.push(...nextAddresses);
                nextPage = data.navigation.next;
            }
            filteredAddresses = validAddresses.filter((address, index, self)=>index === self.findIndex((t)=>t.id === address.id));
            filteredAddresses.forEach((street)=>{
                const listItem = document.createElement("li");
                listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
                listItem.innerHTML = '<b>' + street.name + " " + '</b>' + "     " + " " + street.city.toUpperCase();
                listItem.onmousedown = function() {
                    streetId = street.id;
                    gateNummer.disabled = false;
                    gateClicked = true;
                    fetchStreetNumbers();
                    gate.value = street.name;
                    resetAddresses();
                };
                addressList.appendChild(listItem);
            });
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    }
    const focusGate = async ()=>{
        if (gate !== undefined && gate.value !== "") {
            await fetchAddresses();
            await updateResult();
        }
    };
    const selectAddress = async ()=>{
        if (filteredAddresses !== undefined && filteredAddresses.length > 0 && gate.value !== "" && !gateClicked) {
            const street = filteredAddresses[0];
            const listItem = document.createElement("li");
            listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
            listItem.innerHTML = '<b>' + street.name + " " + '</b>' + "     " + " " + street.city.toUpperCase();
            streetId = street.id;
            gateNummer.disabled = false;
            fetchStreetNumbers();
            gate.value = street.name;
            addressList.appendChild(listItem);
            resetAddresses();
        }
    };
    async function fetchStreetNumbers() {
        const requestOptions = await getHeaders(headerBring, "GET");
        try {
            gateNummerClicked = false;
            const response = await fetch(`${addressLookupUrl.value + 'streets/' + streetId + '/numbers'}`, requestOptions);
            const data = await response.json();
            validNumbers = data.street_numbers.map((number)=>number);
            var nextPage = data.navigation.next;
            while(nextPage){
                const response = await fetch(`${addressLookupUrl.value + nextPage.split('/no/')[1]}`, requestOptions);
                const data = await response.json();
                const nextNumbers = data.street_numbers.map((number)=>number);
                validNumbers.push(...nextNumbers);
                nextPage = data.navigation.next;
            }
            if (gateNummer.value) validNumbers = validNumbers.filter((number)=>number.formatted_number.startsWith(gateNummer.value));
            streetNumberList.innerHTML = "";
            validNumbers.forEach((number)=>{
                const listItem = document.createElement("li");
                listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
                listItem.innerHTML = '<b>' + number.formatted_number + '</b>';
                listItem.onmousedown = function() {
                    gateNummerClicked = true;
                    gateNummer.value = number.formatted_number;
                    gateAdresse = gate.value + " " + number.formatted_number;
                    streetNumberList.innerHTML = "";
                    updatePostnr(number.address_id);
                };
                streetNumberList.appendChild(listItem);
            });
            gateNummer.focus();
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    }
    const selectGatenummer = async ()=>{
        if (validNumbers !== undefined && validNumbers.length > 0 && !gateNummerClicked) {
            const number = validNumbers[0];
            const listItem = document.createElement("li");
            listItem.setAttribute("style", "list-style-type:none;padding:15px;border-bottom:1px solid #eeeeee;cursor:pointer");
            listItem.innerHTML = '<b>' + number.formatted_number + '</b>';
            gateNummer.value = number.formatted_number;
            gateAdresse = gate.value + " " + number.formatted_number;
            updatePostnr(number.address_id);
            streetNumberList.appendChild(listItem);
            resetStreetnumbers();
        }
    };
    async function updatePostnr(addressId) {
        const requestOptions = await getHeaders(headerBring, "GET");
        try {
            const response = await fetch(`${addressLookupUrl.value + 'addresses/' + addressId}`, requestOptions);
            const data = await response.json();
            postnr.value = data.postal_code;
            poststed.value = data.city;
            updateResult();
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    }
    const resetAddresses = ()=>{
        addressList.innerHTML = "";
    };
    const resetStreetnumbers = ()=>{
        streetNumberList.innerHTML = "";
    };
    const getSignicatAuthUrl = async ()=>{
        const token = await getToken("signicat");
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");
        let privateOrCompany = form.querySelector('input[name="options"]:checked').value;
        if (!privateOrCompany) privateOrCompany = "Private";
        let successCallback = `${signicatCallbackUrl + "=" + m2.value}&who=${privateOrCompany}&gate=${gateAdresse}&postnr=${postnr.value}&poststed=${poststed.value}&estimat=${estimatedPrice}`;
        const baseUrl = successCallback.split('?')[0];
        const queryString = successCallback.split('?')[1];
        const abortCallback = baseUrl + "?" + (0, $717bb75f1b3c723c$export$8fb536984ec8b4d7)("abort");
        const errorCallback = baseUrl + "?" + (0, $717bb75f1b3c723c$export$8fb536984ec8b4d7)("error");
        successCallback = baseUrl + "?" + (0, $717bb75f1b3c723c$export$8fb536984ec8b4d7)(queryString);
        const data = {
            allowedProviders: [
                "sms-otp"
            ],
            "language": "no",
            flow: "redirect",
            requestedAttributes: [
                "idpId",
                "name"
            ],
            callbackUrls: {
                success: successCallback,
                abort: abortCallback,
                error: errorCallback
            }
        };
        const jsonData = JSON.stringify(data);
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: jsonData
        };
        try {
            const response = await fetch(veidekkeSessionUrl.value, requestOptions);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            signicatAuthUrl = data.authenticationUrl;
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    };
    function decodeParams() {
        const queryString = window.location.href.split('?')[1];
        const relQueryString = queryString.split('&sessionId')[0];
        const decodedQueryString = (0, $717bb75f1b3c723c$export$94fdf11bafc8de6b)(relQueryString);
        decodedParams = new URLSearchParams(decodedQueryString);
    }
    const updateSummary = ()=>{
        if (decodedParams.get('who') === companyString) {
            resultWho.textContent = "Bedrift";
            orgNameContainer.style.display = 'flex';
            orgNumberContainer.style.display = "flex";
            fullNameLabelText.innerHTML = "Kontaktperson \u2013 Fullt navn\u200B";
        } else {
            resultWho.textContent = "Privat";
            orgNameContainer.style.display = 'none';
            orgNumberContainer.style.display = "none";
            fullNameLabelText.innerHTML = "Fullt navn\u200B";
        }
        resultM2.textContent = decodedParams.get('m2');
        const estimate = decodedParams.get('estimat');
        if (estimate === unableString) inkNokElement.textContent = "Automatisk pris ikke gitt";
        else {
            if (estimate) summaryValue.textContent = formatNumberWithSpaces(estimate) + " NOK";
            decodedParams.get('who') === companyString ? inkNok.textContent = "Ekskl Mva" : inkNok.textContent = "Inkl Mva";
        }
        resultGate.textContent = decodedParams.get('gate');
        resultPostnr.textContent = decodedParams.get('postnr');
        resultPoststed.textContent = decodedParams.get('poststed');
    };
    const getSession = async ()=>{
        const params = new URLSearchParams(window.location.search);
        const sessionId = params.get('sessionId');
        if (!sessionId) return false;
        try {
            const requestOptions = await getHeaders(headerSignicat, "GET");
            const response = await fetch(`${veidekkeSessionUrl.value}${sessionId}`, requestOptions);
            return response;
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error fetching data:', error);
        }
    };
    const checkSession = async ()=>{
        const session = await getSession();
        if (session) {
            decodeParams();
            if (decodedParams.has('abort')) {
                var newURL = window.location.href.split('?')[0];
                signicatCallbackUrl = newURL + "?m2";
                window.history.pushState({}, null, newURL);
            } else if (decodedParams.has('error')) {
                var data = await session.json();
                signicatErrorContainer.style.display = "block";
                signicatErrorResponse.innerHTML = data.status + " " + data.title;
            } else {
                furtherInputFields.style.display = 'block';
                priceCalcluatorparent.style.display = 'none';
                updateSummary();
            }
        }
        asphaltCalculator.scrollIntoView({
            behavior: 'auto'
        });
    };
    checkSession();
    m2.addEventListener('keydown', (event)=>{
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') event.preventDefault();
    });
    m2.addEventListener('wheel', (event)=>{
        event.preventDefault();
    });
    phoneNumber.addEventListener('keydown', (event)=>{
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') event.preventDefault();
    });
    phoneNumber.addEventListener('wheel', (event)=>{
        event.preventDefault();
    });
    function formatNumberWithSpaces(input) {
        const numStr = input.toString();
        const formattedNumber = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return formattedNumber;
    }
    const updateResult = async ()=>{
        let allFieldsFilled = m2.value && gate.value && gateNummer.value && postnr.value && poststed.value;
        if (allFieldsFilled && postnr.value.length === 4 && /^\d{4}$/.test(postnr.value)) {
            const url = `${priceCalculatorUrl.value}?m2=${m2.value}&street=${gateAdresse}&postalcode=${postnr.value}`;
            if (priceCalculatorQueryString != url) {
                try {
                    loader.style.display = "block";
                    const requestOptions = await getHeaders("dynamics", "GET");
                    const response = await fetch(url, requestOptions);
                    if (response.ok) {
                        priceCalculatorQueryString = url;
                        const data = await response.json();
                        if (data.message === "ok") {
                            let privateOrCompany = form.querySelector('input[name="options"]:checked').value;
                            if (privateOrCompany && privateOrCompany === companyString) {
                                const priceWithoutDecimals = Math.floor(data.price);
                                estimatedPrice = priceWithoutDecimals.toString();
                                const priceWithNok = formatNumberWithSpaces(priceWithoutDecimals) + " NOK";
                                firstPartResult.textContent = "Prisestimat Ekskl mva";
                                resultOutput.textContent = priceWithNok;
                            } else {
                                const withMva = data.price * 1.25;
                                const priceWithoutDecimals = Math.floor(withMva);
                                estimatedPrice = priceWithoutDecimals.toString();
                                const priceWithNok = formatNumberWithSpaces(priceWithoutDecimals) + " NOK";
                                firstPartResult.textContent = "Prisestimat Inkl mva";
                                resultOutput.textContent = priceWithNok;
                            }
                            negativeResult.style.display = "none";
                            priceResult.style.display = 'block';
                            nextContainer.style.display = 'block';
                            nextButton.focus({
                                preventScroll: true
                            });
                            neutralResult.style.display = 'none';
                        } else if (data.message === "Ta kontakt for pris" || data.message === "error") {
                            resultOutput.textContent = '';
                            priceResult.style.display = 'none';
                            neutralResult.style.display = 'block';
                            nextContainer.style.display = 'block';
                            nextButton.focus({
                                preventScroll: true
                            });
                            negativeResult.style.display = "none";
                            estimatedPrice = unableString;
                        } else if (data.message === "Vi leverer ikke i ditt omr\xe5de") {
                            negativeResult.style.display = "block";
                            nextContainer.style.display = 'none';
                            priceResult.style.display = 'none';
                            neutralResult.style.display = 'none';
                            estimatedPrice = unableString;
                        } else {
                            estimatedPrice = unableString;
                            // ToDo: do something with the error
                            console.log("error");
                        }
                    } else throw new Error(await response.statusText);
                } catch (error) {
                    // ToDo: do something with the error
                    console.error('Error fetching price:', error);
                    priceResult.style.display = 'none';
                    negativeResult.style.display = 'block';
                    negativeResultText.innerHTML = error;
                    estimatedPrice = unableString;
                }
                getSignicatAuthUrl();
            }
        } else {
            resultOutput.textContent = '';
            priceResult.style.display = 'none';
            neutralResult.style.display = 'none';
            nextContainer.style.display = 'none';
            negativeResult.style.display = "none";
        }
        loader.style.display = "none";
    };
    function toggleButton() {
        submitButton.disabled = !consentCheckbox.checked;
        submitButton.disabled ? submitButton.classList.add('disabled') : submitButton.classList.remove('disabled');
    }
    consentCheckbox.addEventListener('change', toggleButton);
    function isEmailOk(emailValue) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(emailValue.trim());
    }
    function isPhonenumberOk(number) {
        // Remove any non-digit characters
        const cleanedNumber = number.replace(/\D/g, '');
        return cleanedNumber.length === 8;
    }
    const validateForm = async ()=>{
        const fullName = firstName.value.trim().split(" ");
        const hasFirstName = fullName[0] && fullName[0].length > 0;
        const hasLastName = fullName[1] && fullName[1].length > 0;
        const isEmailValid = isEmailOk(email.value.toString());
        const isPhoneNumberValid = isPhonenumberOk(phoneNumber.value);
        const isConsentChecked = consentCheckbox.checked;
        let requiredFieldsFilled = hasFirstName && hasLastName && isEmailValid && isPhoneNumberValid && isConsentChecked;
        const sessionResponse = await getSession();
        if (sessionResponse && !sessionResponse.ok && sessionResponse.status !== 200) {
            quoteInvalidSessionError.style.display = "block";
            requiredFieldsFilled = false;
        }
        if (!hasFirstName || !hasLastName) firstNameError.style.display = "block";
        if (!isEmailValid) emailError.style.display = "block";
        if (decodedParams.get('who') === companyString) {
            if (orgName.value === "") {
                errorOrgName.style.display = "block";
                requiredFieldsFilled = false;
            }
            if (orgNumber.value === "") {
                errorOrgNumber.style.display = "block";
                requiredFieldsFilled = false;
            }
        }
        if (!isPhoneNumberValid) phoneNumberError.style.display = "block";
        return requiredFieldsFilled;
    };
    gate.addEventListener("input", debounce(()=>fetchAddresses()));
    gate.addEventListener("focus", focusGate);
    gate.addEventListener("focusout", resetAddresses);
    gate.addEventListener("blur", selectAddress);
    gate.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') selectAddress();
    });
    gateNummer.addEventListener("input", debounce(()=>fetchStreetNumbers()));
    gateNummer.addEventListener("focus", debounce(()=>fetchStreetNumbers()));
    gateNummer.addEventListener("blur", selectGatenummer);
    gateNummer.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') selectGatenummer();
    });
    m2.addEventListener('input', debounce(()=>updateResult()));
    m2.addEventListener('change', debounce(()=>updateResult()));
    orgNumber.addEventListener('input', debounce(()=>updateResult()));
    orgNumber.addEventListener('change', debounce(()=>updateResult()));
    form.querySelectorAll('input[name="options"]').forEach((radio)=>{
        radio.addEventListener('change', (event)=>{
            debounce(()=>updateResult())();
        });
    });
    nextButton.addEventListener('click', ()=>{
        window.location.href = signicatAuthUrl;
    });
    recalculateLink.addEventListener('click', ()=>{
        var newURL = window.location.href.split('?')[0];
        window.history.pushState({}, null, newURL);
        resetFields();
        hideOrgSetUnableString();
        signicatCallbackUrl = window.location.href + "?m2";
    });
    submitAttachment.addEventListener('change', ()=>{
        attachmentErrorOutput.style.display = 'none';
        //uploadedFiles
        submitAttachment.files.length > 0 ? attachmentList.style.display = 'block' : attachmentList.style.display = 'none';
        if (submitAttachment.files) {
            const files = Array.from(submitAttachment.files); // Convert FileList to array
            uploadedFiles = uploadedFiles.concat(files);
        }
        updateAttachmentList();
    });
    function removeFileElement(index) {
        if (index >= 0 && index < uploadedFiles.length) {
            // Remove the file from the uploadedFiles array
            uploadedFiles.splice(index, 1);
            // Update the attachment list display
            updateAttachmentList();
        }
    }
    function updateAttachmentList() {
        if (!attachmentList || !uploadedFiles) return;
        attachmentList.innerHTML = "";
        Array.from(uploadedFiles).forEach((file, index)=>{
            const listItem = document.createElement('li'); // Create a new list item
            const textElement = document.createElement('span'); // Create a new span element
            textElement.textContent = file.name; // Set the text content to the file name
            textElement.className = 'attachmentName';
            listItem.className = 'listIcon';
            const anchorElement = document.createElement('a');
            anchorElement.href = '#';
            anchorElement.className = 'attachmentLink';
            anchorElement.textContent = 'Fjern';
            anchorElement.addEventListener('click', (event)=>{
                event.preventDefault();
                removeFileElement(index); // Call removeMe with the index
            });
            listItem.appendChild(textElement);
            listItem.appendChild(anchorElement);
            attachmentList.appendChild(listItem);
        });
        updateAttachmentListDisplay();
    }
    function updateAttachmentListDisplay() {
        if (attachmentList && attachmentList.children.length === 0) attachmentList.style.display = 'none';
    }
    submitButton.addEventListener('click', async ()=>{
        if (!await validateForm()) return;
        submitData();
    });
    function resetFields() {
        m2.value = "";
        gate.value = "";
        gateNummer.value = "";
        postnr.value = "";
        poststed.value = "";
    }
    function hideOrgSetUnableString() {
        furtherInputFields.style.display = 'none';
        priceCalcluatorparent.style.display = 'block';
        estimatedPrice = unableString;
        orgNumber.value = "";
        orgName.value = "";
    }
    async function submitData() {
        if (submitAttachment !== undefined && uploadedFiles.length > 0) {
            const token = await getToken("dynamics");
            for(var i = 0; i < uploadedFiles.length; i++)await uploadFile(uploadedFiles[i], token);
        }
        if (!fileUploadFailed) await quoteRequest();
    }
    async function uploadFile(file, token) {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", 'application/json');
            const requestOptions = {
                method: 'PUT',
                headers: myHeaders,
                body: file
            };
            const url = `${uploadAttachmentUrl.value}/${file.name}`;
            const response = await fetch(url, requestOptions);
            if (!response.ok) {
                fileUploadFailed = true;
                throw new Error(response.statusText);
            }
            let fileRef = {};
            fileRef.FileName = file.name;
            fileRef.FileType = file.type;
            fileRef.FileRef = response.headers.get('fileref');
            fileReferences.push(fileRef);
            fileUploadFailed = false;
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error uploading file:', error);
            attachmentErrorOutput.innerHTML = error.message;
            attachmentErrorOutput.style.display = 'block';
            return;
        }
    }
    async function quoteRequest() {
        try {
            const [firstname, lastname] = firstName.value.split(" ");
            decodeParams();
            const submissionData = {
                "Type": decodedParams.get('who'),
                "Firstname": firstname || '',
                "Lastname": lastname || '',
                "Street": decodedParams.get('gate'),
                "PostalCode": decodedParams.get('postnr'),
                "Email": email.value,
                "Phone": phoneNumber.value,
                "M2": parseFloat(decodedParams.get('m2') || '0')
            };
            if (description.value !== "") submissionData.Comments = description.value;
            decodedParams.get('estimat') === unableString ? submissionData.PriceEstimate = null : submissionData.PriceEstimate = decodedParams.get('estimat');
            if (fileReferences.length > 0) submissionData.FileRefrences = fileReferences;
            if (orgNumber.value !== "" && orgName.value !== "") {
                submissionData.OrganizationNumber = orgNumber.value;
                submissionData.CompanyName = orgName.value;
            }
            const token = await getToken("dynamics");
            const myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", 'application/json');
            const jsonData = JSON.stringify(submissionData);
            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: jsonData
            };
            const response = await fetch(quoteRequestUrl.value, requestOptions);
            if (!response.ok) {
                const message = await response.text();
                throw new Error(message);
            }
        } catch (error) {
            // ToDo: do something with the error
            console.error('Error submitting quote:', error);
            quoteRequestErrorOutput.innerHTML = error.message;
            quoteRequestErrorOutput.style.display = 'block';
            return;
        }
        furtherInputFields.style.display = 'none';
        receipt.style.display = 'block';
        var newURL = window.location.href.split('?')[0];
        window.history.pushState({}, null, newURL);
        let dims = asphaltCalculator.getBoundingClientRect();
        window.scrollTo(window.scrollX, dims.top - 95 + window.scrollY);
    }
});



})();
//# sourceMappingURL=main.js.map
